import gql from 'graphql-tag';
import * as Urql from '@urql/vue';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A floating point number that requires more precision than IEEE 754 binary 64 */
  BigFloat: any;
  /**
   * A signed eight-byte integer. The upper big integer values are greater than the
   * max value for a JavaScript number. Therefore all big integers will be output as
   * strings and not numbers.
   */
  BigInt: any;
  /** A location in a connection that can be used for resuming pagination. */
  Cursor: any;
  /** The day, does not include a time. */
  Date: any;
  /**
   * A point in time as described by the [ISO
   * 8601](https://en.wikipedia.org/wiki/ISO_8601) standard. May or may not include a timezone.
   */
  Datetime: string;
  /** An IPv4 or IPv6 host address, and optionally its subnet. */
  InternetAddress: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  MimeType: any;
  /** A builtin object identifier type for a relation name */
  RegClass: any;
  /** The exact time of day, does not include the date. May or may not have a timezone offset. */
  Time: any;
  /** A universally unique identifier as defined by [RFC 4122](https://tools.ietf.org/html/rfc4122). */
  UUID: string;
};

/** All input for the `acceptMembershipInvitation` mutation. */
export type AcceptMembershipInvitationInput = {
  byId?: InputMaybe<Scalars['UUID']>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `acceptMembershipInvitation` mutation. */
export type AcceptMembershipInvitationPayload = {
  __typename?: 'AcceptMembershipInvitationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  result?: Maybe<AcceptMembershipInvitationRecord>;
};

/** The return type of our `acceptMembershipInvitation` mutation. */
export type AcceptMembershipInvitationRecord = {
  __typename?: 'AcceptMembershipInvitationRecord';
  invitation?: Maybe<MembershipInvitation>;
  membership?: Maybe<Membership>;
};

export type AuthToken = {
  __typename?: 'AuthToken';
  azp?: Maybe<Scalars['String']>;
  exp?: Maybe<Scalars['BigInt']>;
  iat?: Maybe<Scalars['BigInt']>;
  iss?: Maybe<Scalars['String']>;
  sub?: Maybe<Scalars['String']>;
};

export type AvatarIcon =
  | 'BIRD'
  | 'BLUE'
  | 'DOG'
  | 'ELEFANT'
  | 'PURPLE'
  | 'SPACE'
  | 'TREE'
  | 'WAVES'
  | 'YELLOW';

/** A filter to be used against AvatarIcon fields. All fields are combined with a logical ‘and.’ */
export type AvatarIconFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<AvatarIcon>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<AvatarIcon>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<AvatarIcon>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<AvatarIcon>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<AvatarIcon>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<AvatarIcon>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<AvatarIcon>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<AvatarIcon>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<AvatarIcon>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<AvatarIcon>>;
};

/** A filter to be used against BigFloat fields. All fields are combined with a logical ‘and.’ */
export type BigFloatFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigFloat']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigFloat']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigFloat']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigFloat']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigFloat']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigFloat']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigFloat']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigFloat']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigFloat']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigFloat']>>;
};

/** A filter to be used against BigInt fields. All fields are combined with a logical ‘and.’ */
export type BigIntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['BigInt']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['BigInt']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['BigInt']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['BigInt']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['BigInt']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['BigInt']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['BigInt']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['BigInt']>>;
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type Commentable = Node & {
  __typename?: 'Commentable';
  /** Reads and enables pagination through a set of `Conversation`. */
  conversationsByAboutCommentableId: ConversationsConnection;
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  numberOfPostings?: Maybe<Scalars['BigInt']>;
  numberOfUnreadPostings?: Maybe<Scalars['BigInt']>;
  origin: Scalars['RegClass'];
  /** Reads and enables pagination through a set of `Posting`. */
  postingsByAboutCommentableId: PostingsConnection;
  registeredAt: Scalars['Datetime'];
  /** Reads a single `Trial` that is related to this `Commentable`. */
  trialById?: Maybe<Trial>;
  /**
   * Reads and enables pagination through a set of `Trial`.
   * @deprecated Please use trialById instead
   */
  trialsById: TrialsConnection;
};


export type CommentableConversationsByAboutCommentableIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ConversationCondition>;
  filter?: InputMaybe<ConversationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
};


export type CommentablePostingsByAboutCommentableIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PostingCondition>;
  filter?: InputMaybe<PostingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PostingsOrderBy>>;
};


export type CommentableTrialsByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TrialCondition>;
  filter?: InputMaybe<TrialFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TrialsOrderBy>>;
};

export type CommentableAggregates = {
  __typename?: 'CommentableAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<CommentableAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<CommentableDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<CommentableMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<CommentableMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<CommentableStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<CommentableStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<CommentableSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<CommentableVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<CommentableVarianceSampleAggregates>;
};

export type CommentableAverageAggregates = {
  __typename?: 'CommentableAverageAggregates';
  /** Mean average of this field across the matching connection. */
  numberOfPostings?: Maybe<Scalars['BigFloat']>;
  /** Mean average of this field across the matching connection. */
  numberOfUnreadPostings?: Maybe<Scalars['BigFloat']>;
  /** Mean average of origin across the matching connection */
  origin?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `Commentable` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type CommentableCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `numberOfPostings` field. */
  numberOfPostings?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `numberOfUnreadPostings` field. */
  numberOfUnreadPostings?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `origin` field. */
  origin?: InputMaybe<Scalars['RegClass']>;
  /** Checks for equality with the object’s `registeredAt` field. */
  registeredAt?: InputMaybe<Scalars['Datetime']>;
};

export type CommentableDistinctCountAggregates = {
  __typename?: 'CommentableDistinctCountAggregates';
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']>;
  /** Distinct count of this field across the matching connection. */
  numberOfPostings?: Maybe<Scalars['BigInt']>;
  /** Distinct count of this field across the matching connection. */
  numberOfUnreadPostings?: Maybe<Scalars['BigInt']>;
  /** Distinct count of origin across the matching connection */
  origin?: Maybe<Scalars['BigInt']>;
  /** Distinct count of registeredAt across the matching connection */
  registeredAt?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `Commentable` object types. All fields are combined with a logical ‘and.’ */
export type CommentableFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<CommentableFilter>>;
  /** Filter by the object’s `conversationsByAboutCommentableId` relation. */
  conversationsByAboutCommentableId?: InputMaybe<CommentableToManyConversationFilter>;
  /** Some related `conversationsByAboutCommentableId` exist. */
  conversationsByAboutCommentableIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<CommentableFilter>;
  /** Filter by the object’s `numberOfPostings` field. */
  numberOfPostings?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `numberOfUnreadPostings` field. */
  numberOfUnreadPostings?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<CommentableFilter>>;
  /** Filter by the object’s `postingsByAboutCommentableId` relation. */
  postingsByAboutCommentableId?: InputMaybe<CommentableToManyPostingFilter>;
  /** Some related `postingsByAboutCommentableId` exist. */
  postingsByAboutCommentableIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `registeredAt` field. */
  registeredAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `trialById` relation. */
  trialById?: InputMaybe<TrialFilter>;
  /** A related `trialById` exists. */
  trialByIdExists?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `Commentable` */
export type CommentableInput = {
  id: Scalars['UUID'];
  origin: Scalars['RegClass'];
  registeredAt?: InputMaybe<Scalars['Datetime']>;
};

export type CommentableMaxAggregates = {
  __typename?: 'CommentableMaxAggregates';
  /** Maximum of this field across the matching connection. */
  numberOfPostings?: Maybe<Scalars['BigInt']>;
  /** Maximum of this field across the matching connection. */
  numberOfUnreadPostings?: Maybe<Scalars['BigInt']>;
  /** Maximum of origin across the matching connection */
  origin?: Maybe<Scalars['RegClass']>;
};

export type CommentableMinAggregates = {
  __typename?: 'CommentableMinAggregates';
  /** Minimum of this field across the matching connection. */
  numberOfPostings?: Maybe<Scalars['BigInt']>;
  /** Minimum of this field across the matching connection. */
  numberOfUnreadPostings?: Maybe<Scalars['BigInt']>;
  /** Minimum of origin across the matching connection */
  origin?: Maybe<Scalars['RegClass']>;
};

/** Represents an update to a `Commentable`. Fields that are set will be updated. */
export type CommentablePatch = {
  id?: InputMaybe<Scalars['UUID']>;
  origin?: InputMaybe<Scalars['RegClass']>;
  registeredAt?: InputMaybe<Scalars['Datetime']>;
};

export type CommentableStddevPopulationAggregates = {
  __typename?: 'CommentableStddevPopulationAggregates';
  /** Population standard deviation of this field across the matching connection. */
  numberOfPostings?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of this field across the matching connection. */
  numberOfUnreadPostings?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of origin across the matching connection */
  origin?: Maybe<Scalars['BigFloat']>;
};

export type CommentableStddevSampleAggregates = {
  __typename?: 'CommentableStddevSampleAggregates';
  /** Sample standard deviation of this field across the matching connection. */
  numberOfPostings?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of this field across the matching connection. */
  numberOfUnreadPostings?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of origin across the matching connection */
  origin?: Maybe<Scalars['BigFloat']>;
};

export type CommentableSumAggregates = {
  __typename?: 'CommentableSumAggregates';
  /** Sum of this field across the matching connection. */
  numberOfPostings?: Maybe<Scalars['BigFloat']>;
  /** Sum of this field across the matching connection. */
  numberOfUnreadPostings?: Maybe<Scalars['BigFloat']>;
  /** Sum of origin across the matching connection */
  origin: Scalars['BigFloat'];
};

/** A filter to be used against many `Conversation` object types. All fields are combined with a logical ‘and.’ */
export type CommentableToManyConversationFilter = {
  /** Aggregates across related `Conversation` match the filter criteria. */
  aggregates?: InputMaybe<ConversationAggregatesFilter>;
  /** Every related `Conversation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ConversationFilter>;
  /** No related `Conversation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ConversationFilter>;
  /** Some related `Conversation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ConversationFilter>;
};

/** A filter to be used against many `Posting` object types. All fields are combined with a logical ‘and.’ */
export type CommentableToManyPostingFilter = {
  /** Aggregates across related `Posting` match the filter criteria. */
  aggregates?: InputMaybe<PostingAggregatesFilter>;
  /** Every related `Posting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PostingFilter>;
  /** No related `Posting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PostingFilter>;
  /** Some related `Posting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PostingFilter>;
};

export type CommentableVariancePopulationAggregates = {
  __typename?: 'CommentableVariancePopulationAggregates';
  /** Population variance of this field across the matching connection. */
  numberOfPostings?: Maybe<Scalars['BigFloat']>;
  /** Population variance of this field across the matching connection. */
  numberOfUnreadPostings?: Maybe<Scalars['BigFloat']>;
  /** Population variance of origin across the matching connection */
  origin?: Maybe<Scalars['BigFloat']>;
};

export type CommentableVarianceSampleAggregates = {
  __typename?: 'CommentableVarianceSampleAggregates';
  /** Sample variance of this field across the matching connection. */
  numberOfPostings?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of this field across the matching connection. */
  numberOfUnreadPostings?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of origin across the matching connection */
  origin?: Maybe<Scalars['BigFloat']>;
};

/** A connection to a list of `Commentable` values. */
export type CommentablesConnection = {
  __typename?: 'CommentablesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<CommentableAggregates>;
  /** A list of edges which contains the `Commentable` and cursor to aid in pagination. */
  edges: Array<CommentablesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<CommentableAggregates>>;
  /** A list of `Commentable` objects. */
  nodes: Array<Commentable>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Commentable` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `Commentable` values. */
export type CommentablesConnectionGroupedAggregatesArgs = {
  groupBy: Array<CommentablesGroupBy>;
  having?: InputMaybe<CommentablesHavingInput>;
};

/** A `Commentable` edge in the connection. */
export type CommentablesEdge = {
  __typename?: 'CommentablesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Commentable` at the end of the edge. */
  node: Commentable;
};

/** Grouping methods for `Commentable` for usage during aggregation. */
export type CommentablesGroupBy =
  | 'ORIGIN'
  | 'REGISTERED_AT'
  | 'REGISTERED_AT_TRUNCATED_TO_DAY'
  | 'REGISTERED_AT_TRUNCATED_TO_HOUR';

export type CommentablesHavingAverageCommentablesNumberOfPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type CommentablesHavingAverageCommentablesNumberOfUnreadPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type CommentablesHavingAverageInput = {
  numberOfPostings?: InputMaybe<CommentablesHavingAverageCommentablesNumberOfPostingsInput>;
  numberOfUnreadPostings?: InputMaybe<CommentablesHavingAverageCommentablesNumberOfUnreadPostingsInput>;
  registeredAt?: InputMaybe<HavingDatetimeFilter>;
};

export type CommentablesHavingDistinctCountCommentablesNumberOfPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type CommentablesHavingDistinctCountCommentablesNumberOfUnreadPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type CommentablesHavingDistinctCountInput = {
  numberOfPostings?: InputMaybe<CommentablesHavingDistinctCountCommentablesNumberOfPostingsInput>;
  numberOfUnreadPostings?: InputMaybe<CommentablesHavingDistinctCountCommentablesNumberOfUnreadPostingsInput>;
  registeredAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `Commentable` aggregates. */
export type CommentablesHavingInput = {
  AND?: InputMaybe<Array<CommentablesHavingInput>>;
  OR?: InputMaybe<Array<CommentablesHavingInput>>;
  average?: InputMaybe<CommentablesHavingAverageInput>;
  distinctCount?: InputMaybe<CommentablesHavingDistinctCountInput>;
  max?: InputMaybe<CommentablesHavingMaxInput>;
  min?: InputMaybe<CommentablesHavingMinInput>;
  stddevPopulation?: InputMaybe<CommentablesHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<CommentablesHavingStddevSampleInput>;
  sum?: InputMaybe<CommentablesHavingSumInput>;
  variancePopulation?: InputMaybe<CommentablesHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<CommentablesHavingVarianceSampleInput>;
};

export type CommentablesHavingMaxCommentablesNumberOfPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type CommentablesHavingMaxCommentablesNumberOfUnreadPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type CommentablesHavingMaxInput = {
  numberOfPostings?: InputMaybe<CommentablesHavingMaxCommentablesNumberOfPostingsInput>;
  numberOfUnreadPostings?: InputMaybe<CommentablesHavingMaxCommentablesNumberOfUnreadPostingsInput>;
  registeredAt?: InputMaybe<HavingDatetimeFilter>;
};

export type CommentablesHavingMinCommentablesNumberOfPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type CommentablesHavingMinCommentablesNumberOfUnreadPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type CommentablesHavingMinInput = {
  numberOfPostings?: InputMaybe<CommentablesHavingMinCommentablesNumberOfPostingsInput>;
  numberOfUnreadPostings?: InputMaybe<CommentablesHavingMinCommentablesNumberOfUnreadPostingsInput>;
  registeredAt?: InputMaybe<HavingDatetimeFilter>;
};

export type CommentablesHavingStddevPopulationCommentablesNumberOfPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type CommentablesHavingStddevPopulationCommentablesNumberOfUnreadPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type CommentablesHavingStddevPopulationInput = {
  numberOfPostings?: InputMaybe<CommentablesHavingStddevPopulationCommentablesNumberOfPostingsInput>;
  numberOfUnreadPostings?: InputMaybe<CommentablesHavingStddevPopulationCommentablesNumberOfUnreadPostingsInput>;
  registeredAt?: InputMaybe<HavingDatetimeFilter>;
};

export type CommentablesHavingStddevSampleCommentablesNumberOfPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type CommentablesHavingStddevSampleCommentablesNumberOfUnreadPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type CommentablesHavingStddevSampleInput = {
  numberOfPostings?: InputMaybe<CommentablesHavingStddevSampleCommentablesNumberOfPostingsInput>;
  numberOfUnreadPostings?: InputMaybe<CommentablesHavingStddevSampleCommentablesNumberOfUnreadPostingsInput>;
  registeredAt?: InputMaybe<HavingDatetimeFilter>;
};

export type CommentablesHavingSumCommentablesNumberOfPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type CommentablesHavingSumCommentablesNumberOfUnreadPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type CommentablesHavingSumInput = {
  numberOfPostings?: InputMaybe<CommentablesHavingSumCommentablesNumberOfPostingsInput>;
  numberOfUnreadPostings?: InputMaybe<CommentablesHavingSumCommentablesNumberOfUnreadPostingsInput>;
  registeredAt?: InputMaybe<HavingDatetimeFilter>;
};

export type CommentablesHavingVariancePopulationCommentablesNumberOfPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type CommentablesHavingVariancePopulationCommentablesNumberOfUnreadPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type CommentablesHavingVariancePopulationInput = {
  numberOfPostings?: InputMaybe<CommentablesHavingVariancePopulationCommentablesNumberOfPostingsInput>;
  numberOfUnreadPostings?: InputMaybe<CommentablesHavingVariancePopulationCommentablesNumberOfUnreadPostingsInput>;
  registeredAt?: InputMaybe<HavingDatetimeFilter>;
};

export type CommentablesHavingVarianceSampleCommentablesNumberOfPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type CommentablesHavingVarianceSampleCommentablesNumberOfUnreadPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type CommentablesHavingVarianceSampleInput = {
  numberOfPostings?: InputMaybe<CommentablesHavingVarianceSampleCommentablesNumberOfPostingsInput>;
  numberOfUnreadPostings?: InputMaybe<CommentablesHavingVarianceSampleCommentablesNumberOfUnreadPostingsInput>;
  registeredAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `Commentable`. */
export type CommentablesOrderBy =
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_ABSTRACT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_ABSTRACT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_CREATED_AT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_CREATED_AT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_CREATOR_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_CREATOR_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_LANGUAGE_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_LANGUAGE_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_TENANT_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_TENANT_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_TITLE_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_TITLE_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_UPDATED_AT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_UPDATED_AT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_COUNT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_COUNT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_ABSTRACT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_ABSTRACT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_CREATOR_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_CREATOR_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_LANGUAGE_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_LANGUAGE_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_TENANT_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_TENANT_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_TITLE_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_TITLE_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MAX_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MAX_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MAX_ABSTRACT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MAX_ABSTRACT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MAX_CREATED_AT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MAX_CREATED_AT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MAX_CREATOR_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MAX_CREATOR_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MAX_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MAX_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MAX_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MAX_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MAX_LANGUAGE_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MAX_LANGUAGE_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MAX_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MAX_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MAX_TENANT_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MAX_TENANT_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MAX_TITLE_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MAX_TITLE_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MAX_UPDATED_AT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MAX_UPDATED_AT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MIN_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MIN_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MIN_ABSTRACT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MIN_ABSTRACT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MIN_CREATED_AT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MIN_CREATED_AT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MIN_CREATOR_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MIN_CREATOR_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MIN_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MIN_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MIN_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MIN_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MIN_LANGUAGE_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MIN_LANGUAGE_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MIN_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MIN_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MIN_TENANT_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MIN_TENANT_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MIN_TITLE_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MIN_TITLE_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MIN_UPDATED_AT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_MIN_UPDATED_AT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_ABSTRACT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_ABSTRACT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_CREATOR_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_CREATOR_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_LANGUAGE_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_LANGUAGE_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_TENANT_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_TENANT_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_TITLE_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_TITLE_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_ABSTRACT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_ABSTRACT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_CREATOR_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_CREATOR_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_LANGUAGE_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_LANGUAGE_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_TENANT_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_TENANT_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_TITLE_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_TITLE_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_SUM_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_SUM_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_SUM_ABSTRACT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_SUM_ABSTRACT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_SUM_CREATED_AT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_SUM_CREATED_AT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_SUM_CREATOR_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_SUM_CREATOR_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_SUM_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_SUM_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_SUM_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_SUM_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_SUM_LANGUAGE_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_SUM_LANGUAGE_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_SUM_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_SUM_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_SUM_TENANT_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_SUM_TENANT_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_SUM_TITLE_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_SUM_TITLE_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_SUM_UPDATED_AT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_SUM_UPDATED_AT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_ABSTRACT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_ABSTRACT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_CREATOR_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_CREATOR_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_LANGUAGE_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_LANGUAGE_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_TENANT_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_TENANT_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_TITLE_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_TITLE_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_ABSTRACT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_ABSTRACT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_CREATOR_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_CREATOR_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_LANGUAGE_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_LANGUAGE_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_TENANT_ID_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_TENANT_ID_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_TITLE_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_TITLE_DESC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'CONVERSATIONS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'NUMBER_OF_POSTINGS_ASC'
  | 'NUMBER_OF_POSTINGS_DESC'
  | 'NUMBER_OF_UNREAD_POSTINGS_ASC'
  | 'NUMBER_OF_UNREAD_POSTINGS_DESC'
  | 'ORIGIN_ASC'
  | 'ORIGIN_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_BODY_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_BODY_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_CONVERSATION_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_CONVERSATION_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_CREATED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_CREATED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_HASHTAGS_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_HASHTAGS_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_LANGUAGE_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_LANGUAGE_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_SENDER_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_SENDER_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_SUBJECT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_SUBJECT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_SUBMITTED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_SUBMITTED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_UPDATED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_AVERAGE_UPDATED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_COUNT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_COUNT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_BODY_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_BODY_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_CONVERSATION_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_CONVERSATION_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_HASHTAGS_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_HASHTAGS_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_LANGUAGE_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_LANGUAGE_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_SENDER_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_SENDER_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_SUBJECT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_SUBJECT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_SUBMITTED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_SUBMITTED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_BODY_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_BODY_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_CONVERSATION_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_CONVERSATION_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_CREATED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_CREATED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_HASHTAGS_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_HASHTAGS_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_LANGUAGE_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_LANGUAGE_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_SENDER_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_SENDER_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_SUBJECT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_SUBJECT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_SUBMITTED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_SUBMITTED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_UPDATED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MAX_UPDATED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_BODY_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_BODY_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_CONVERSATION_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_CONVERSATION_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_CREATED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_CREATED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_HASHTAGS_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_HASHTAGS_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_LANGUAGE_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_LANGUAGE_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_SENDER_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_SENDER_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_SUBJECT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_SUBJECT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_SUBMITTED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_SUBMITTED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_UPDATED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_MIN_UPDATED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_BODY_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_BODY_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_CONVERSATION_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_CONVERSATION_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_HASHTAGS_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_HASHTAGS_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_LANGUAGE_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_LANGUAGE_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_SENDER_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_SENDER_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_SUBJECT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_SUBJECT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_SUBMITTED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_SUBMITTED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_BODY_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_BODY_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_CONVERSATION_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_CONVERSATION_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_HASHTAGS_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_HASHTAGS_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_LANGUAGE_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_LANGUAGE_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_SENDER_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_SENDER_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_SUBJECT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_SUBJECT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_SUBMITTED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_SUBMITTED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_BODY_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_BODY_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_CONVERSATION_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_CONVERSATION_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_CREATED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_CREATED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_HASHTAGS_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_HASHTAGS_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_LANGUAGE_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_LANGUAGE_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_SENDER_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_SENDER_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_SUBJECT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_SUBJECT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_SUBMITTED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_SUBMITTED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_UPDATED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_SUM_UPDATED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_BODY_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_BODY_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_CONVERSATION_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_CONVERSATION_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_HASHTAGS_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_HASHTAGS_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_LANGUAGE_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_LANGUAGE_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_SENDER_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_SENDER_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_SUBJECT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_SUBJECT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_SUBMITTED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_SUBMITTED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_BODY_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_BODY_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_CONVERSATION_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_CONVERSATION_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_HASHTAGS_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_HASHTAGS_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_LANGUAGE_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_LANGUAGE_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_SENDER_ID_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_SENDER_ID_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_SUBJECT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_SUBJECT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_SUBMITTED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_SUBMITTED_AT_DESC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'POSTINGS_BY_ABOUT_COMMENTABLE_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REGISTERED_AT_ASC'
  | 'REGISTERED_AT_DESC';

export type Conversation = Node & {
  __typename?: 'Conversation';
  /** Reads a single `Commentable` that is related to this `Conversation`. */
  aboutCommentable?: Maybe<Commentable>;
  aboutCommentableId?: Maybe<Scalars['UUID']>;
  abstract?: Maybe<Scalars['String']>;
  countOfUnreadPostings?: Maybe<Scalars['BigInt']>;
  createdAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `Conversation`. */
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['UUID']>;
  fulltext?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isPublic: Scalars['Boolean'];
  language: Scalars['String'];
  latestActivity?: Maybe<Scalars['Datetime']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Posting`. */
  postings: PostingsConnection;
  /** Reads a single `Group` that is related to this `Conversation`. */
  privateGroup?: Maybe<Group>;
  privateToGroupId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Tenant` that is related to this `Conversation`. */
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['UUID'];
  title?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Trial`. */
  trialsByInternalMessagesId: TrialsConnection;
  /** Reads and enables pagination through a set of `Trial`. */
  trialsByMessagesId: TrialsConnection;
  /** Reads and enables pagination through a set of `Posting`. */
  unreadPostings: PostingsConnection;
  updatedAt: Scalars['Datetime'];
};


export type ConversationLatestActivityArgs = {
  includeMemberships?: InputMaybe<Scalars['Boolean']>;
};


export type ConversationPostingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PostingCondition>;
  filter?: InputMaybe<PostingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PostingsOrderBy>>;
};


export type ConversationTrialsByInternalMessagesIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TrialCondition>;
  filter?: InputMaybe<TrialFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TrialsOrderBy>>;
};


export type ConversationTrialsByMessagesIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TrialCondition>;
  filter?: InputMaybe<TrialFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TrialsOrderBy>>;
};


export type ConversationUnreadPostingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PostingCondition>;
  filter?: InputMaybe<PostingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PostingsOrderBy>>;
};

export type ConversationAggregates = {
  __typename?: 'ConversationAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<ConversationAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<ConversationDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<ConversationMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<ConversationMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<ConversationStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<ConversationStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<ConversationSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<ConversationVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<ConversationVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Conversation` object types. */
export type ConversationAggregatesFilter = {
  /** Mean average aggregate over matching `Conversation` objects. */
  average?: InputMaybe<ConversationAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Conversation` objects. */
  distinctCount?: InputMaybe<ConversationDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Conversation` object to be included within the aggregate. */
  filter?: InputMaybe<ConversationFilter>;
  /** Maximum aggregate over matching `Conversation` objects. */
  max?: InputMaybe<ConversationMaxAggregateFilter>;
  /** Minimum aggregate over matching `Conversation` objects. */
  min?: InputMaybe<ConversationMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Conversation` objects. */
  stddevPopulation?: InputMaybe<ConversationStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Conversation` objects. */
  stddevSample?: InputMaybe<ConversationStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Conversation` objects. */
  sum?: InputMaybe<ConversationSumAggregateFilter>;
  /** Population variance aggregate over matching `Conversation` objects. */
  variancePopulation?: InputMaybe<ConversationVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Conversation` objects. */
  varianceSample?: InputMaybe<ConversationVarianceSampleAggregateFilter>;
};

export type ConversationAverageAggregateFilter = {
  countOfUnreadPostings?: InputMaybe<BigIntFilter>;
};

export type ConversationAverageAggregates = {
  __typename?: 'ConversationAverageAggregates';
  /** Mean average of this field across the matching connection. */
  countOfUnreadPostings?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `Conversation` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ConversationCondition = {
  /** Checks for equality with the object’s `aboutCommentableId` field. */
  aboutCommentableId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `abstract` field. */
  abstract?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `countOfUnreadPostings` field. */
  countOfUnreadPostings?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `creatorId` field. */
  creatorId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `fulltext` field. */
  fulltext?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isPublic` field. */
  isPublic?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `language` field. */
  language?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `latestActivity` field. */
  latestActivity?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `privateToGroupId` field. */
  privateToGroupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ConversationDistinctCountAggregateFilter = {
  aboutCommentableId?: InputMaybe<BigIntFilter>;
  abstract?: InputMaybe<BigIntFilter>;
  countOfUnreadPostings?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  creatorId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  isPublic?: InputMaybe<BigIntFilter>;
  language?: InputMaybe<BigIntFilter>;
  latestActivity?: InputMaybe<DatetimeFilter>;
  privateToGroupId?: InputMaybe<BigIntFilter>;
  tenantId?: InputMaybe<BigIntFilter>;
  title?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type ConversationDistinctCountAggregates = {
  __typename?: 'ConversationDistinctCountAggregates';
  /** Distinct count of aboutCommentableId across the matching connection */
  aboutCommentableId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of abstract across the matching connection */
  abstract?: Maybe<Scalars['BigInt']>;
  /** Distinct count of this field across the matching connection. */
  countOfUnreadPostings?: Maybe<Scalars['BigInt']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of creatorId across the matching connection */
  creatorId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of this field across the matching connection. */
  fulltext?: Maybe<Scalars['BigInt']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']>;
  /** Distinct count of isPublic across the matching connection */
  isPublic?: Maybe<Scalars['BigInt']>;
  /** Distinct count of language across the matching connection */
  language?: Maybe<Scalars['BigInt']>;
  /** Distinct count of this field across the matching connection. */
  latestActivity?: Maybe<Scalars['BigInt']>;
  /** Distinct count of privateToGroupId across the matching connection */
  privateToGroupId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of tenantId across the matching connection */
  tenantId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of title across the matching connection */
  title?: Maybe<Scalars['BigInt']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']>;
};


export type ConversationDistinctCountAggregatesLatestActivityArgs = {
  includeMemberships?: InputMaybe<Scalars['Boolean']>;
};

/** A filter to be used against `Conversation` object types. All fields are combined with a logical ‘and.’ */
export type ConversationFilter = {
  /** Filter by the object’s `aboutCommentable` relation. */
  aboutCommentable?: InputMaybe<CommentableFilter>;
  /** A related `aboutCommentable` exists. */
  aboutCommentableExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `aboutCommentableId` field. */
  aboutCommentableId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `abstract` field. */
  abstract?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ConversationFilter>>;
  /** Filter by the object’s `countOfUnreadPostings` field. */
  countOfUnreadPostings?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `creator` relation. */
  creator?: InputMaybe<UserFilter>;
  /** A related `creator` exists. */
  creatorExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `creatorId` field. */
  creatorId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isPublic` field. */
  isPublic?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `language` field. */
  language?: InputMaybe<StringFilter>;
  /** Filter by the object’s `latestActivity` field. */
  latestActivity?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ConversationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ConversationFilter>>;
  /** Filter by the object’s `postings` relation. */
  postings?: InputMaybe<ConversationToManyPostingFilter>;
  /** Some related `postings` exist. */
  postingsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `privateGroup` relation. */
  privateGroup?: InputMaybe<GroupFilter>;
  /** A related `privateGroup` exists. */
  privateGroupExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `privateToGroupId` field. */
  privateToGroupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tenant` relation. */
  tenant?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `trialsByInternalMessagesId` relation. */
  trialsByInternalMessagesId?: InputMaybe<ConversationToManyTrialFilter>;
  /** Some related `trialsByInternalMessagesId` exist. */
  trialsByInternalMessagesIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `trialsByMessagesId` relation. */
  trialsByMessagesId?: InputMaybe<ConversationToManyTrialFilter>;
  /** Some related `trialsByMessagesId` exist. */
  trialsByMessagesIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Conversation` */
export type ConversationInput = {
  aboutCommentableId?: InputMaybe<Scalars['UUID']>;
  abstract?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  privateToGroupId?: InputMaybe<Scalars['UUID']>;
  tenantId?: InputMaybe<Scalars['UUID']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ConversationMaxAggregateFilter = {
  countOfUnreadPostings?: InputMaybe<BigIntFilter>;
};

export type ConversationMaxAggregates = {
  __typename?: 'ConversationMaxAggregates';
  /** Maximum of this field across the matching connection. */
  countOfUnreadPostings?: Maybe<Scalars['BigInt']>;
};

export type ConversationMinAggregateFilter = {
  countOfUnreadPostings?: InputMaybe<BigIntFilter>;
};

export type ConversationMinAggregates = {
  __typename?: 'ConversationMinAggregates';
  /** Minimum of this field across the matching connection. */
  countOfUnreadPostings?: Maybe<Scalars['BigInt']>;
};

/** Represents an update to a `Conversation`. Fields that are set will be updated. */
export type ConversationPatch = {
  aboutCommentableId?: InputMaybe<Scalars['UUID']>;
  abstract?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  isPublic?: InputMaybe<Scalars['Boolean']>;
  language?: InputMaybe<Scalars['String']>;
  privateToGroupId?: InputMaybe<Scalars['UUID']>;
  tenantId?: InputMaybe<Scalars['UUID']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type ConversationStddevPopulationAggregateFilter = {
  countOfUnreadPostings?: InputMaybe<BigIntFilter>;
};

export type ConversationStddevPopulationAggregates = {
  __typename?: 'ConversationStddevPopulationAggregates';
  /** Population standard deviation of this field across the matching connection. */
  countOfUnreadPostings?: Maybe<Scalars['BigFloat']>;
};

export type ConversationStddevSampleAggregateFilter = {
  countOfUnreadPostings?: InputMaybe<BigIntFilter>;
};

export type ConversationStddevSampleAggregates = {
  __typename?: 'ConversationStddevSampleAggregates';
  /** Sample standard deviation of this field across the matching connection. */
  countOfUnreadPostings?: Maybe<Scalars['BigFloat']>;
};

export type ConversationSumAggregateFilter = {
  countOfUnreadPostings?: InputMaybe<BigIntFilter>;
};

export type ConversationSumAggregates = {
  __typename?: 'ConversationSumAggregates';
  /** Sum of this field across the matching connection. */
  countOfUnreadPostings?: Maybe<Scalars['BigFloat']>;
};

/** A filter to be used against many `Posting` object types. All fields are combined with a logical ‘and.’ */
export type ConversationToManyPostingFilter = {
  /** Aggregates across related `Posting` match the filter criteria. */
  aggregates?: InputMaybe<PostingAggregatesFilter>;
  /** Every related `Posting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PostingFilter>;
  /** No related `Posting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PostingFilter>;
  /** Some related `Posting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PostingFilter>;
};

/** A filter to be used against many `Trial` object types. All fields are combined with a logical ‘and.’ */
export type ConversationToManyTrialFilter = {
  /** Aggregates across related `Trial` match the filter criteria. */
  aggregates?: InputMaybe<TrialAggregatesFilter>;
  /** Every related `Trial` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TrialFilter>;
  /** No related `Trial` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TrialFilter>;
  /** Some related `Trial` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TrialFilter>;
};

export type ConversationVariancePopulationAggregateFilter = {
  countOfUnreadPostings?: InputMaybe<BigIntFilter>;
};

export type ConversationVariancePopulationAggregates = {
  __typename?: 'ConversationVariancePopulationAggregates';
  /** Population variance of this field across the matching connection. */
  countOfUnreadPostings?: Maybe<Scalars['BigFloat']>;
};

export type ConversationVarianceSampleAggregateFilter = {
  countOfUnreadPostings?: InputMaybe<BigIntFilter>;
};

export type ConversationVarianceSampleAggregates = {
  __typename?: 'ConversationVarianceSampleAggregates';
  /** Sample variance of this field across the matching connection. */
  countOfUnreadPostings?: Maybe<Scalars['BigFloat']>;
};

/** A connection to a list of `Conversation` values. */
export type ConversationsConnection = {
  __typename?: 'ConversationsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<ConversationAggregates>;
  /** A list of edges which contains the `Conversation` and cursor to aid in pagination. */
  edges: Array<ConversationsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<ConversationAggregates>>;
  /** A list of `Conversation` objects. */
  nodes: Array<Conversation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Conversation` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `Conversation` values. */
export type ConversationsConnectionGroupedAggregatesArgs = {
  groupBy: Array<ConversationsGroupBy>;
  having?: InputMaybe<ConversationsHavingInput>;
};

/** A `Conversation` edge in the connection. */
export type ConversationsEdge = {
  __typename?: 'ConversationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Conversation` at the end of the edge. */
  node: Conversation;
};

/** Grouping methods for `Conversation` for usage during aggregation. */
export type ConversationsGroupBy =
  | 'ABOUT_COMMENTABLE_ID'
  | 'ABSTRACT'
  | 'CREATED_AT'
  | 'CREATED_AT_TRUNCATED_TO_DAY'
  | 'CREATED_AT_TRUNCATED_TO_HOUR'
  | 'CREATOR_ID'
  | 'IS_PUBLIC'
  | 'LANGUAGE'
  | 'PRIVATE_TO_GROUP_ID'
  | 'TENANT_ID'
  | 'TITLE'
  | 'UPDATED_AT'
  | 'UPDATED_AT_TRUNCATED_TO_DAY'
  | 'UPDATED_AT_TRUNCATED_TO_HOUR';

export type ConversationsHavingAverageConversationsCountOfUnreadPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type ConversationsHavingAverageInput = {
  countOfUnreadPostings?: InputMaybe<ConversationsHavingAverageConversationsCountOfUnreadPostingsInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ConversationsHavingDistinctCountConversationsCountOfUnreadPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type ConversationsHavingDistinctCountConversationsLatestActivityArgsInput = {
  includeMemberships?: InputMaybe<Scalars['Boolean']>;
};

export type ConversationsHavingDistinctCountConversationsLatestActivityInput = {
  args?: InputMaybe<ConversationsHavingDistinctCountConversationsLatestActivityArgsInput>;
  filter?: InputMaybe<HavingDatetimeFilter>;
};

export type ConversationsHavingDistinctCountInput = {
  countOfUnreadPostings?: InputMaybe<ConversationsHavingDistinctCountConversationsCountOfUnreadPostingsInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  latestActivity?: InputMaybe<ConversationsHavingDistinctCountConversationsLatestActivityInput>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `Conversation` aggregates. */
export type ConversationsHavingInput = {
  AND?: InputMaybe<Array<ConversationsHavingInput>>;
  OR?: InputMaybe<Array<ConversationsHavingInput>>;
  average?: InputMaybe<ConversationsHavingAverageInput>;
  distinctCount?: InputMaybe<ConversationsHavingDistinctCountInput>;
  max?: InputMaybe<ConversationsHavingMaxInput>;
  min?: InputMaybe<ConversationsHavingMinInput>;
  stddevPopulation?: InputMaybe<ConversationsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<ConversationsHavingStddevSampleInput>;
  sum?: InputMaybe<ConversationsHavingSumInput>;
  variancePopulation?: InputMaybe<ConversationsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<ConversationsHavingVarianceSampleInput>;
};

export type ConversationsHavingMaxConversationsCountOfUnreadPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type ConversationsHavingMaxInput = {
  countOfUnreadPostings?: InputMaybe<ConversationsHavingMaxConversationsCountOfUnreadPostingsInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ConversationsHavingMinConversationsCountOfUnreadPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type ConversationsHavingMinInput = {
  countOfUnreadPostings?: InputMaybe<ConversationsHavingMinConversationsCountOfUnreadPostingsInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ConversationsHavingStddevPopulationConversationsCountOfUnreadPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type ConversationsHavingStddevPopulationInput = {
  countOfUnreadPostings?: InputMaybe<ConversationsHavingStddevPopulationConversationsCountOfUnreadPostingsInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ConversationsHavingStddevSampleConversationsCountOfUnreadPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type ConversationsHavingStddevSampleInput = {
  countOfUnreadPostings?: InputMaybe<ConversationsHavingStddevSampleConversationsCountOfUnreadPostingsInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ConversationsHavingSumConversationsCountOfUnreadPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type ConversationsHavingSumInput = {
  countOfUnreadPostings?: InputMaybe<ConversationsHavingSumConversationsCountOfUnreadPostingsInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ConversationsHavingVariancePopulationConversationsCountOfUnreadPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type ConversationsHavingVariancePopulationInput = {
  countOfUnreadPostings?: InputMaybe<ConversationsHavingVariancePopulationConversationsCountOfUnreadPostingsInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type ConversationsHavingVarianceSampleConversationsCountOfUnreadPostingsInput = {
  filter?: InputMaybe<HavingBigintFilter>;
};

export type ConversationsHavingVarianceSampleInput = {
  countOfUnreadPostings?: InputMaybe<ConversationsHavingVarianceSampleConversationsCountOfUnreadPostingsInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `Conversation`. */
export type ConversationsOrderBy =
  | 'ABOUT_COMMENTABLE_ID_ASC'
  | 'ABOUT_COMMENTABLE_ID_DESC'
  | 'ABSTRACT_ASC'
  | 'ABSTRACT_DESC'
  | 'COUNT_OF_UNREAD_POSTINGS_ASC'
  | 'COUNT_OF_UNREAD_POSTINGS_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'CREATOR_ID_ASC'
  | 'CREATOR_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'IS_PUBLIC_ASC'
  | 'IS_PUBLIC_DESC'
  | 'LANGUAGE_ASC'
  | 'LANGUAGE_DESC'
  | 'LATEST_ACTIVITY_ASC'
  | 'LATEST_ACTIVITY_DESC'
  | 'NATURAL'
  | 'POSTINGS_AVERAGE_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_AVERAGE_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_AVERAGE_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_AVERAGE_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_AVERAGE_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_AVERAGE_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_AVERAGE_BODY_ASC'
  | 'POSTINGS_AVERAGE_BODY_DESC'
  | 'POSTINGS_AVERAGE_CONVERSATION_ID_ASC'
  | 'POSTINGS_AVERAGE_CONVERSATION_ID_DESC'
  | 'POSTINGS_AVERAGE_CREATED_AT_ASC'
  | 'POSTINGS_AVERAGE_CREATED_AT_DESC'
  | 'POSTINGS_AVERAGE_HASHTAGS_ASC'
  | 'POSTINGS_AVERAGE_HASHTAGS_DESC'
  | 'POSTINGS_AVERAGE_ID_ASC'
  | 'POSTINGS_AVERAGE_ID_DESC'
  | 'POSTINGS_AVERAGE_LANGUAGE_ASC'
  | 'POSTINGS_AVERAGE_LANGUAGE_DESC'
  | 'POSTINGS_AVERAGE_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_AVERAGE_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_AVERAGE_SENDER_ID_ASC'
  | 'POSTINGS_AVERAGE_SENDER_ID_DESC'
  | 'POSTINGS_AVERAGE_SUBJECT_ASC'
  | 'POSTINGS_AVERAGE_SUBJECT_DESC'
  | 'POSTINGS_AVERAGE_SUBMITTED_AT_ASC'
  | 'POSTINGS_AVERAGE_SUBMITTED_AT_DESC'
  | 'POSTINGS_AVERAGE_UPDATED_AT_ASC'
  | 'POSTINGS_AVERAGE_UPDATED_AT_DESC'
  | 'POSTINGS_COUNT_ASC'
  | 'POSTINGS_COUNT_DESC'
  | 'POSTINGS_DISTINCT_COUNT_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_DISTINCT_COUNT_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_DISTINCT_COUNT_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_DISTINCT_COUNT_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_DISTINCT_COUNT_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_DISTINCT_COUNT_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_DISTINCT_COUNT_BODY_ASC'
  | 'POSTINGS_DISTINCT_COUNT_BODY_DESC'
  | 'POSTINGS_DISTINCT_COUNT_CONVERSATION_ID_ASC'
  | 'POSTINGS_DISTINCT_COUNT_CONVERSATION_ID_DESC'
  | 'POSTINGS_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'POSTINGS_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'POSTINGS_DISTINCT_COUNT_HASHTAGS_ASC'
  | 'POSTINGS_DISTINCT_COUNT_HASHTAGS_DESC'
  | 'POSTINGS_DISTINCT_COUNT_ID_ASC'
  | 'POSTINGS_DISTINCT_COUNT_ID_DESC'
  | 'POSTINGS_DISTINCT_COUNT_LANGUAGE_ASC'
  | 'POSTINGS_DISTINCT_COUNT_LANGUAGE_DESC'
  | 'POSTINGS_DISTINCT_COUNT_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_DISTINCT_COUNT_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_DISTINCT_COUNT_SENDER_ID_ASC'
  | 'POSTINGS_DISTINCT_COUNT_SENDER_ID_DESC'
  | 'POSTINGS_DISTINCT_COUNT_SUBJECT_ASC'
  | 'POSTINGS_DISTINCT_COUNT_SUBJECT_DESC'
  | 'POSTINGS_DISTINCT_COUNT_SUBMITTED_AT_ASC'
  | 'POSTINGS_DISTINCT_COUNT_SUBMITTED_AT_DESC'
  | 'POSTINGS_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'POSTINGS_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'POSTINGS_MAX_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_MAX_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_MAX_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_MAX_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_MAX_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_MAX_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_MAX_BODY_ASC'
  | 'POSTINGS_MAX_BODY_DESC'
  | 'POSTINGS_MAX_CONVERSATION_ID_ASC'
  | 'POSTINGS_MAX_CONVERSATION_ID_DESC'
  | 'POSTINGS_MAX_CREATED_AT_ASC'
  | 'POSTINGS_MAX_CREATED_AT_DESC'
  | 'POSTINGS_MAX_HASHTAGS_ASC'
  | 'POSTINGS_MAX_HASHTAGS_DESC'
  | 'POSTINGS_MAX_ID_ASC'
  | 'POSTINGS_MAX_ID_DESC'
  | 'POSTINGS_MAX_LANGUAGE_ASC'
  | 'POSTINGS_MAX_LANGUAGE_DESC'
  | 'POSTINGS_MAX_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_MAX_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_MAX_SENDER_ID_ASC'
  | 'POSTINGS_MAX_SENDER_ID_DESC'
  | 'POSTINGS_MAX_SUBJECT_ASC'
  | 'POSTINGS_MAX_SUBJECT_DESC'
  | 'POSTINGS_MAX_SUBMITTED_AT_ASC'
  | 'POSTINGS_MAX_SUBMITTED_AT_DESC'
  | 'POSTINGS_MAX_UPDATED_AT_ASC'
  | 'POSTINGS_MAX_UPDATED_AT_DESC'
  | 'POSTINGS_MIN_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_MIN_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_MIN_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_MIN_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_MIN_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_MIN_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_MIN_BODY_ASC'
  | 'POSTINGS_MIN_BODY_DESC'
  | 'POSTINGS_MIN_CONVERSATION_ID_ASC'
  | 'POSTINGS_MIN_CONVERSATION_ID_DESC'
  | 'POSTINGS_MIN_CREATED_AT_ASC'
  | 'POSTINGS_MIN_CREATED_AT_DESC'
  | 'POSTINGS_MIN_HASHTAGS_ASC'
  | 'POSTINGS_MIN_HASHTAGS_DESC'
  | 'POSTINGS_MIN_ID_ASC'
  | 'POSTINGS_MIN_ID_DESC'
  | 'POSTINGS_MIN_LANGUAGE_ASC'
  | 'POSTINGS_MIN_LANGUAGE_DESC'
  | 'POSTINGS_MIN_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_MIN_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_MIN_SENDER_ID_ASC'
  | 'POSTINGS_MIN_SENDER_ID_DESC'
  | 'POSTINGS_MIN_SUBJECT_ASC'
  | 'POSTINGS_MIN_SUBJECT_DESC'
  | 'POSTINGS_MIN_SUBMITTED_AT_ASC'
  | 'POSTINGS_MIN_SUBMITTED_AT_DESC'
  | 'POSTINGS_MIN_UPDATED_AT_ASC'
  | 'POSTINGS_MIN_UPDATED_AT_DESC'
  | 'POSTINGS_STDDEV_POPULATION_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_STDDEV_POPULATION_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_STDDEV_POPULATION_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_STDDEV_POPULATION_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_STDDEV_POPULATION_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_STDDEV_POPULATION_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_STDDEV_POPULATION_BODY_ASC'
  | 'POSTINGS_STDDEV_POPULATION_BODY_DESC'
  | 'POSTINGS_STDDEV_POPULATION_CONVERSATION_ID_ASC'
  | 'POSTINGS_STDDEV_POPULATION_CONVERSATION_ID_DESC'
  | 'POSTINGS_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'POSTINGS_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'POSTINGS_STDDEV_POPULATION_HASHTAGS_ASC'
  | 'POSTINGS_STDDEV_POPULATION_HASHTAGS_DESC'
  | 'POSTINGS_STDDEV_POPULATION_ID_ASC'
  | 'POSTINGS_STDDEV_POPULATION_ID_DESC'
  | 'POSTINGS_STDDEV_POPULATION_LANGUAGE_ASC'
  | 'POSTINGS_STDDEV_POPULATION_LANGUAGE_DESC'
  | 'POSTINGS_STDDEV_POPULATION_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_STDDEV_POPULATION_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_STDDEV_POPULATION_SENDER_ID_ASC'
  | 'POSTINGS_STDDEV_POPULATION_SENDER_ID_DESC'
  | 'POSTINGS_STDDEV_POPULATION_SUBJECT_ASC'
  | 'POSTINGS_STDDEV_POPULATION_SUBJECT_DESC'
  | 'POSTINGS_STDDEV_POPULATION_SUBMITTED_AT_ASC'
  | 'POSTINGS_STDDEV_POPULATION_SUBMITTED_AT_DESC'
  | 'POSTINGS_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'POSTINGS_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'POSTINGS_STDDEV_SAMPLE_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_STDDEV_SAMPLE_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_STDDEV_SAMPLE_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_STDDEV_SAMPLE_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_STDDEV_SAMPLE_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_STDDEV_SAMPLE_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_STDDEV_SAMPLE_BODY_ASC'
  | 'POSTINGS_STDDEV_SAMPLE_BODY_DESC'
  | 'POSTINGS_STDDEV_SAMPLE_CONVERSATION_ID_ASC'
  | 'POSTINGS_STDDEV_SAMPLE_CONVERSATION_ID_DESC'
  | 'POSTINGS_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'POSTINGS_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'POSTINGS_STDDEV_SAMPLE_HASHTAGS_ASC'
  | 'POSTINGS_STDDEV_SAMPLE_HASHTAGS_DESC'
  | 'POSTINGS_STDDEV_SAMPLE_ID_ASC'
  | 'POSTINGS_STDDEV_SAMPLE_ID_DESC'
  | 'POSTINGS_STDDEV_SAMPLE_LANGUAGE_ASC'
  | 'POSTINGS_STDDEV_SAMPLE_LANGUAGE_DESC'
  | 'POSTINGS_STDDEV_SAMPLE_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_STDDEV_SAMPLE_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_STDDEV_SAMPLE_SENDER_ID_ASC'
  | 'POSTINGS_STDDEV_SAMPLE_SENDER_ID_DESC'
  | 'POSTINGS_STDDEV_SAMPLE_SUBJECT_ASC'
  | 'POSTINGS_STDDEV_SAMPLE_SUBJECT_DESC'
  | 'POSTINGS_STDDEV_SAMPLE_SUBMITTED_AT_ASC'
  | 'POSTINGS_STDDEV_SAMPLE_SUBMITTED_AT_DESC'
  | 'POSTINGS_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'POSTINGS_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'POSTINGS_SUM_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_SUM_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_SUM_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_SUM_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_SUM_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_SUM_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_SUM_BODY_ASC'
  | 'POSTINGS_SUM_BODY_DESC'
  | 'POSTINGS_SUM_CONVERSATION_ID_ASC'
  | 'POSTINGS_SUM_CONVERSATION_ID_DESC'
  | 'POSTINGS_SUM_CREATED_AT_ASC'
  | 'POSTINGS_SUM_CREATED_AT_DESC'
  | 'POSTINGS_SUM_HASHTAGS_ASC'
  | 'POSTINGS_SUM_HASHTAGS_DESC'
  | 'POSTINGS_SUM_ID_ASC'
  | 'POSTINGS_SUM_ID_DESC'
  | 'POSTINGS_SUM_LANGUAGE_ASC'
  | 'POSTINGS_SUM_LANGUAGE_DESC'
  | 'POSTINGS_SUM_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_SUM_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_SUM_SENDER_ID_ASC'
  | 'POSTINGS_SUM_SENDER_ID_DESC'
  | 'POSTINGS_SUM_SUBJECT_ASC'
  | 'POSTINGS_SUM_SUBJECT_DESC'
  | 'POSTINGS_SUM_SUBMITTED_AT_ASC'
  | 'POSTINGS_SUM_SUBMITTED_AT_DESC'
  | 'POSTINGS_SUM_UPDATED_AT_ASC'
  | 'POSTINGS_SUM_UPDATED_AT_DESC'
  | 'POSTINGS_VARIANCE_POPULATION_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_VARIANCE_POPULATION_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_VARIANCE_POPULATION_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_VARIANCE_POPULATION_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_VARIANCE_POPULATION_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_VARIANCE_POPULATION_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_VARIANCE_POPULATION_BODY_ASC'
  | 'POSTINGS_VARIANCE_POPULATION_BODY_DESC'
  | 'POSTINGS_VARIANCE_POPULATION_CONVERSATION_ID_ASC'
  | 'POSTINGS_VARIANCE_POPULATION_CONVERSATION_ID_DESC'
  | 'POSTINGS_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'POSTINGS_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'POSTINGS_VARIANCE_POPULATION_HASHTAGS_ASC'
  | 'POSTINGS_VARIANCE_POPULATION_HASHTAGS_DESC'
  | 'POSTINGS_VARIANCE_POPULATION_ID_ASC'
  | 'POSTINGS_VARIANCE_POPULATION_ID_DESC'
  | 'POSTINGS_VARIANCE_POPULATION_LANGUAGE_ASC'
  | 'POSTINGS_VARIANCE_POPULATION_LANGUAGE_DESC'
  | 'POSTINGS_VARIANCE_POPULATION_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_VARIANCE_POPULATION_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_VARIANCE_POPULATION_SENDER_ID_ASC'
  | 'POSTINGS_VARIANCE_POPULATION_SENDER_ID_DESC'
  | 'POSTINGS_VARIANCE_POPULATION_SUBJECT_ASC'
  | 'POSTINGS_VARIANCE_POPULATION_SUBJECT_DESC'
  | 'POSTINGS_VARIANCE_POPULATION_SUBMITTED_AT_ASC'
  | 'POSTINGS_VARIANCE_POPULATION_SUBMITTED_AT_DESC'
  | 'POSTINGS_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'POSTINGS_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'POSTINGS_VARIANCE_SAMPLE_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_VARIANCE_SAMPLE_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_VARIANCE_SAMPLE_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_VARIANCE_SAMPLE_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_VARIANCE_SAMPLE_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_VARIANCE_SAMPLE_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_VARIANCE_SAMPLE_BODY_ASC'
  | 'POSTINGS_VARIANCE_SAMPLE_BODY_DESC'
  | 'POSTINGS_VARIANCE_SAMPLE_CONVERSATION_ID_ASC'
  | 'POSTINGS_VARIANCE_SAMPLE_CONVERSATION_ID_DESC'
  | 'POSTINGS_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'POSTINGS_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'POSTINGS_VARIANCE_SAMPLE_HASHTAGS_ASC'
  | 'POSTINGS_VARIANCE_SAMPLE_HASHTAGS_DESC'
  | 'POSTINGS_VARIANCE_SAMPLE_ID_ASC'
  | 'POSTINGS_VARIANCE_SAMPLE_ID_DESC'
  | 'POSTINGS_VARIANCE_SAMPLE_LANGUAGE_ASC'
  | 'POSTINGS_VARIANCE_SAMPLE_LANGUAGE_DESC'
  | 'POSTINGS_VARIANCE_SAMPLE_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_VARIANCE_SAMPLE_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_VARIANCE_SAMPLE_SENDER_ID_ASC'
  | 'POSTINGS_VARIANCE_SAMPLE_SENDER_ID_DESC'
  | 'POSTINGS_VARIANCE_SAMPLE_SUBJECT_ASC'
  | 'POSTINGS_VARIANCE_SAMPLE_SUBJECT_DESC'
  | 'POSTINGS_VARIANCE_SAMPLE_SUBMITTED_AT_ASC'
  | 'POSTINGS_VARIANCE_SAMPLE_SUBMITTED_AT_DESC'
  | 'POSTINGS_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'POSTINGS_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PRIVATE_TO_GROUP_ID_ASC'
  | 'PRIVATE_TO_GROUP_ID_DESC'
  | 'TENANT_ID_ASC'
  | 'TENANT_ID_DESC'
  | 'TITLE_ASC'
  | 'TITLE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_AVATAR_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_AVATAR_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_CREATED_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_CREATED_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_MESSAGES_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_MESSAGES_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_NAME_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_NAME_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_STAFF_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_STAFF_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_SUBJECT_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_SUBJECT_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_TENANT_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_TENANT_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_UPDATED_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_AVERAGE_UPDATED_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_COUNT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_COUNT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_AVATAR_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_AVATAR_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_MESSAGES_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_MESSAGES_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_NAME_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_NAME_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_STAFF_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_STAFF_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_SUBJECT_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_SUBJECT_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_TENANT_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_TENANT_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_AVATAR_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_AVATAR_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_CREATED_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_CREATED_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_MESSAGES_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_MESSAGES_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_NAME_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_NAME_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_STAFF_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_STAFF_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_SUBJECT_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_SUBJECT_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_TENANT_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_TENANT_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_UPDATED_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MAX_UPDATED_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_AVATAR_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_AVATAR_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_CREATED_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_CREATED_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_MESSAGES_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_MESSAGES_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_NAME_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_NAME_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_STAFF_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_STAFF_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_SUBJECT_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_SUBJECT_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_TENANT_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_TENANT_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_UPDATED_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_MIN_UPDATED_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_AVATAR_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_AVATAR_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_MESSAGES_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_MESSAGES_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_NAME_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_NAME_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_STAFF_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_STAFF_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_SUBJECT_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_SUBJECT_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_TENANT_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_TENANT_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_AVATAR_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_AVATAR_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_MESSAGES_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_MESSAGES_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_NAME_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_NAME_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_STAFF_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_STAFF_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_SUBJECT_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_SUBJECT_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_TENANT_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_TENANT_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_AVATAR_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_AVATAR_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_CREATED_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_CREATED_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_MESSAGES_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_MESSAGES_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_NAME_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_NAME_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_STAFF_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_STAFF_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_SUBJECT_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_SUBJECT_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_TENANT_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_TENANT_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_UPDATED_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_SUM_UPDATED_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_AVATAR_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_AVATAR_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_MESSAGES_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_MESSAGES_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_NAME_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_NAME_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_STAFF_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_STAFF_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_SUBJECT_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_SUBJECT_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_TENANT_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_TENANT_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_AVATAR_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_AVATAR_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_MESSAGES_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_MESSAGES_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_NAME_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_NAME_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_STAFF_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_STAFF_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_SUBJECT_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_SUBJECT_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_TENANT_ID_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_TENANT_ID_DESC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'TRIALS_BY_INTERNAL_MESSAGES_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_AVATAR_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_AVATAR_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_CREATED_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_CREATED_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_MESSAGES_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_MESSAGES_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_NAME_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_NAME_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_STAFF_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_STAFF_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_SUBJECT_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_SUBJECT_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_TENANT_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_TENANT_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_UPDATED_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_AVERAGE_UPDATED_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_COUNT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_COUNT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_AVATAR_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_AVATAR_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_MESSAGES_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_MESSAGES_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_NAME_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_NAME_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_STAFF_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_STAFF_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_SUBJECT_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_SUBJECT_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_TENANT_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_TENANT_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_AVATAR_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_AVATAR_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_CREATED_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_CREATED_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_MESSAGES_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_MESSAGES_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_NAME_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_NAME_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_STAFF_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_STAFF_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_SUBJECT_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_SUBJECT_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_TENANT_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_TENANT_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_UPDATED_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MAX_UPDATED_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_AVATAR_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_AVATAR_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_CREATED_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_CREATED_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_MESSAGES_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_MESSAGES_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_NAME_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_NAME_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_STAFF_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_STAFF_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_SUBJECT_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_SUBJECT_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_TENANT_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_TENANT_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_UPDATED_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_MIN_UPDATED_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_AVATAR_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_AVATAR_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_MESSAGES_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_MESSAGES_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_NAME_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_NAME_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_STAFF_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_STAFF_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_SUBJECT_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_SUBJECT_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_TENANT_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_TENANT_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_AVATAR_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_AVATAR_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_MESSAGES_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_MESSAGES_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_NAME_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_NAME_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_STAFF_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_STAFF_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_SUBJECT_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_SUBJECT_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_TENANT_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_TENANT_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_AVATAR_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_AVATAR_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_CREATED_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_CREATED_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_MESSAGES_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_MESSAGES_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_NAME_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_NAME_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_STAFF_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_STAFF_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_SUBJECT_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_SUBJECT_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_TENANT_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_TENANT_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_UPDATED_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_SUM_UPDATED_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_AVATAR_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_AVATAR_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_MESSAGES_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_MESSAGES_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_NAME_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_NAME_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_STAFF_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_STAFF_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_SUBJECT_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_SUBJECT_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_TENANT_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_TENANT_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_AVATAR_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_AVATAR_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_MESSAGES_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_MESSAGES_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_NAME_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_NAME_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_STAFF_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_STAFF_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_SUBJECT_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_SUBJECT_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_TENANT_ID_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_TENANT_ID_DESC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'TRIALS_BY_MESSAGES_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

/** All input for the create `Commentable` mutation. */
export type CreateCommentableInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Commentable` to be created by this mutation. */
  commentable: CommentableInput;
};

/** The output of our create `Commentable` mutation. */
export type CreateCommentablePayload = {
  __typename?: 'CreateCommentablePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Commentable` that was created by this mutation. */
  commentable?: Maybe<Commentable>;
  /** An edge for our `Commentable`. May be used by Relay 1. */
  commentableEdge?: Maybe<CommentablesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `Commentable` mutation. */
export type CreateCommentablePayloadCommentableEdgeArgs = {
  orderBy?: InputMaybe<Array<CommentablesOrderBy>>;
};

/** All input for the create `Conversation` mutation. */
export type CreateConversationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Conversation` to be created by this mutation. */
  conversation: ConversationInput;
};

/** The output of our create `Conversation` mutation. */
export type CreateConversationPayload = {
  __typename?: 'CreateConversationPayload';
  /** Reads a single `Commentable` that is related to this `Conversation`. */
  aboutCommentable?: Maybe<Commentable>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Conversation` that was created by this mutation. */
  conversation?: Maybe<Conversation>;
  /** An edge for our `Conversation`. May be used by Relay 1. */
  conversationEdge?: Maybe<ConversationsEdge>;
  /** Reads a single `User` that is related to this `Conversation`. */
  creator?: Maybe<User>;
  /** Reads a single `Group` that is related to this `Conversation`. */
  privateGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Conversation`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our create `Conversation` mutation. */
export type CreateConversationPayloadConversationEdgeArgs = {
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
};

/** All input for the create `EmaEntries2` mutation. */
export type CreateEmaEntries2Input = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `EmaEntries2` to be created by this mutation. */
  emaEntries2: EmaEntries2Input;
};

/** The output of our create `EmaEntries2` mutation. */
export type CreateEmaEntries2Payload = {
  __typename?: 'CreateEmaEntries2Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `EmaEntries2` that was created by this mutation. */
  emaEntries2?: Maybe<EmaEntries2>;
  /** An edge for our `EmaEntries2`. May be used by Relay 1. */
  emaEntries2Edge?: Maybe<EmaEntries2sEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmaEntries2`. */
  subject?: Maybe<User>;
};


/** The output of our create `EmaEntries2` mutation. */
export type CreateEmaEntries2PayloadEmaEntries2EdgeArgs = {
  orderBy?: InputMaybe<Array<EmaEntries2sOrderBy>>;
};

/** All input for the create `EmaEntries3` mutation. */
export type CreateEmaEntries3Input = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `EmaEntries3` to be created by this mutation. */
  emaEntries3: EmaEntries3Input;
};

/** The output of our create `EmaEntries3` mutation. */
export type CreateEmaEntries3Payload = {
  __typename?: 'CreateEmaEntries3Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `EmaEntries3` that was created by this mutation. */
  emaEntries3?: Maybe<EmaEntries3>;
  /** An edge for our `EmaEntries3`. May be used by Relay 1. */
  emaEntries3Edge?: Maybe<EmaEntries3sEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trial` that is related to this `EmaEntries3`. */
  trial?: Maybe<Trial>;
};


/** The output of our create `EmaEntries3` mutation. */
export type CreateEmaEntries3PayloadEmaEntries3EdgeArgs = {
  orderBy?: InputMaybe<Array<EmaEntries3sOrderBy>>;
};

/** All input for the create `EmaEntry` mutation. */
export type CreateEmaEntryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `EmaEntry` to be created by this mutation. */
  emaEntry: EmaEntryInput;
};

/** The output of our create `EmaEntry` mutation. */
export type CreateEmaEntryPayload = {
  __typename?: 'CreateEmaEntryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `EmaEntry` that was created by this mutation. */
  emaEntry?: Maybe<EmaEntry>;
  /** An edge for our `EmaEntry`. May be used by Relay 1. */
  emaEntryEdge?: Maybe<EmaEntriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmaEntry`. */
  subject?: Maybe<User>;
};


/** The output of our create `EmaEntry` mutation. */
export type CreateEmaEntryPayloadEmaEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<EmaEntriesOrderBy>>;
};

/** All input for the create `Event` mutation. */
export type CreateEventInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Event` to be created by this mutation. */
  event: EventInput;
};

/** The output of our create `Event` mutation. */
export type CreateEventPayload = {
  __typename?: 'CreateEventPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Event` that was created by this mutation. */
  event?: Maybe<Event>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the create `FavoritePage` mutation. */
export type CreateFavoritePageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FavoritePage` to be created by this mutation. */
  favoritePage: FavoritePageInput;
};

/** The output of our create `FavoritePage` mutation. */
export type CreateFavoritePagePayload = {
  __typename?: 'CreateFavoritePagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `FavoritePage` that was created by this mutation. */
  favoritePage?: Maybe<FavoritePage>;
  /** An edge for our `FavoritePage`. May be used by Relay 1. */
  favoritePageEdge?: Maybe<FavoritePagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trial` that is related to this `FavoritePage`. */
  trial?: Maybe<Trial>;
};


/** The output of our create `FavoritePage` mutation. */
export type CreateFavoritePagePayloadFavoritePageEdgeArgs = {
  orderBy?: InputMaybe<Array<FavoritePagesOrderBy>>;
};

/** All input for the create `GenericEmiExercise` mutation. */
export type CreateGenericEmiExerciseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `GenericEmiExercise` to be created by this mutation. */
  genericEmiExercise: GenericEmiExerciseInput;
};

/** The output of our create `GenericEmiExercise` mutation. */
export type CreateGenericEmiExercisePayload = {
  __typename?: 'CreateGenericEmiExercisePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `GenericEmiExercise` that was created by this mutation. */
  genericEmiExercise?: Maybe<GenericEmiExercise>;
  /** An edge for our `GenericEmiExercise`. May be used by Relay 1. */
  genericEmiExerciseEdge?: Maybe<GenericEmiExercisesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trial` that is related to this `GenericEmiExercise`. */
  trial?: Maybe<Trial>;
};


/** The output of our create `GenericEmiExercise` mutation. */
export type CreateGenericEmiExercisePayloadGenericEmiExerciseEdgeArgs = {
  orderBy?: InputMaybe<Array<GenericEmiExercisesOrderBy>>;
};

/** All input for the create `GroupHome` mutation. */
export type CreateGroupHomeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `GroupHome` to be created by this mutation. */
  groupHome: GroupHomeInput;
};

/** The output of our create `GroupHome` mutation. */
export type CreateGroupHomePayload = {
  __typename?: 'CreateGroupHomePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `GroupHome` that was created by this mutation. */
  groupHome?: Maybe<GroupHome>;
  /** An edge for our `GroupHome`. May be used by Relay 1. */
  groupHomeEdge?: Maybe<GroupHomesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `GroupHome` mutation. */
export type CreateGroupHomePayloadGroupHomeEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupHomesOrderBy>>;
};

/** All input for the create `Group` mutation. */
export type CreateGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Group` to be created by this mutation. */
  group: GroupInput;
};

/** The output of our create `Group` mutation. */
export type CreateGroupPayload = {
  __typename?: 'CreateGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Group`. */
  creator?: Maybe<User>;
  /** The `Group` that was created by this mutation. */
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Reads a single `GroupHome` that is related to this `Group`. */
  home?: Maybe<GroupHome>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Group`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our create `Group` mutation. */
export type CreateGroupPayloadGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

/** All input for the create `LimesurveyToken` mutation. */
export type CreateLimesurveyTokenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LimesurveyToken` to be created by this mutation. */
  limesurveyToken: LimesurveyTokenInput;
};

/** The output of our create `LimesurveyToken` mutation. */
export type CreateLimesurveyTokenPayload = {
  __typename?: 'CreateLimesurveyTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `LimesurveyToken` that was created by this mutation. */
  limesurveyToken?: Maybe<LimesurveyToken>;
  /** An edge for our `LimesurveyToken`. May be used by Relay 1. */
  limesurveyTokenEdge?: Maybe<LimesurveyTokensEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trial` that is related to this `LimesurveyToken`. */
  trial?: Maybe<Trial>;
};


/** The output of our create `LimesurveyToken` mutation. */
export type CreateLimesurveyTokenPayloadLimesurveyTokenEdgeArgs = {
  orderBy?: InputMaybe<Array<LimesurveyTokensOrderBy>>;
};

/** All input for the create `Membership` mutation. */
export type CreateMembershipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Membership` to be created by this mutation. */
  membership: MembershipInput;
};

/** All input for the create `MembershipInvitationConfirmation` mutation. */
export type CreateMembershipInvitationConfirmationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MembershipInvitationConfirmation` to be created by this mutation. */
  membershipInvitationConfirmation: MembershipInvitationConfirmationInput;
};

/** The output of our create `MembershipInvitationConfirmation` mutation. */
export type CreateMembershipInvitationConfirmationPayload = {
  __typename?: 'CreateMembershipInvitationConfirmationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `MembershipInvitation` that is related to this `MembershipInvitationConfirmation`. */
  invitation?: Maybe<MembershipInvitation>;
  /** Reads a single `Membership` that is related to this `MembershipInvitationConfirmation`. */
  membership?: Maybe<Membership>;
  /** The `MembershipInvitationConfirmation` that was created by this mutation. */
  membershipInvitationConfirmation?: Maybe<MembershipInvitationConfirmation>;
  /** An edge for our `MembershipInvitationConfirmation`. May be used by Relay 1. */
  membershipInvitationConfirmationEdge?: Maybe<MembershipInvitationConfirmationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `MembershipInvitationConfirmation` mutation. */
export type CreateMembershipInvitationConfirmationPayloadMembershipInvitationConfirmationEdgeArgs = {
  orderBy?: InputMaybe<Array<MembershipInvitationConfirmationsOrderBy>>;
};

/** All input for the create `MembershipInvitation` mutation. */
export type CreateMembershipInvitationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MembershipInvitation` to be created by this mutation. */
  membershipInvitation: MembershipInvitationInput;
};

/** The output of our create `MembershipInvitation` mutation. */
export type CreateMembershipInvitationPayload = {
  __typename?: 'CreateMembershipInvitationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Group` that is related to this `MembershipInvitation`. */
  group?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `MembershipInvitation`. */
  invitedGroup?: Maybe<Group>;
  /** Reads a single `User` that is related to this `MembershipInvitation`. */
  invitedUser?: Maybe<User>;
  /** Reads a single `User` that is related to this `MembershipInvitation`. */
  inviter?: Maybe<User>;
  /** The `MembershipInvitation` that was created by this mutation. */
  membershipInvitation?: Maybe<MembershipInvitation>;
  /** An edge for our `MembershipInvitation`. May be used by Relay 1. */
  membershipInvitationEdge?: Maybe<MembershipInvitationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `MembershipInvitation` mutation. */
export type CreateMembershipInvitationPayloadMembershipInvitationEdgeArgs = {
  orderBy?: InputMaybe<Array<MembershipInvitationsOrderBy>>;
};

/** The output of our create `Membership` mutation. */
export type CreateMembershipPayload = {
  __typename?: 'CreateMembershipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Group` that is related to this `Membership`. */
  group?: Maybe<Group>;
  /** The `Membership` that was created by this mutation. */
  membership?: Maybe<Membership>;
  /** An edge for our `Membership`. May be used by Relay 1. */
  membershipEdge?: Maybe<MembershipsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Group` that is related to this `Membership`. */
  subgroup?: Maybe<Group>;
  /** Reads a single `User` that is related to this `Membership`. */
  user?: Maybe<User>;
};


/** The output of our create `Membership` mutation. */
export type CreateMembershipPayloadMembershipEdgeArgs = {
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};

/** All input for the create `PostWaitRandomizationTicket` mutation. */
export type CreatePostWaitRandomizationTicketInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PostWaitRandomizationTicket` to be created by this mutation. */
  postWaitRandomizationTicket: PostWaitRandomizationTicketInput;
};

/** The output of our create `PostWaitRandomizationTicket` mutation. */
export type CreatePostWaitRandomizationTicketPayload = {
  __typename?: 'CreatePostWaitRandomizationTicketPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `PostWaitRandomizationTicket` that was created by this mutation. */
  postWaitRandomizationTicket?: Maybe<PostWaitRandomizationTicket>;
  /** An edge for our `PostWaitRandomizationTicket`. May be used by Relay 1. */
  postWaitRandomizationTicketEdge?: Maybe<PostWaitRandomizationTicketsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trial` that is related to this `PostWaitRandomizationTicket`. */
  trial?: Maybe<Trial>;
};


/** The output of our create `PostWaitRandomizationTicket` mutation. */
export type CreatePostWaitRandomizationTicketPayloadPostWaitRandomizationTicketEdgeArgs = {
  orderBy?: InputMaybe<Array<PostWaitRandomizationTicketsOrderBy>>;
};

/** All input for the create `Posting` mutation. */
export type CreatePostingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Posting` to be created by this mutation. */
  posting: PostingInput;
};

/** The output of our create `Posting` mutation. */
export type CreatePostingPayload = {
  __typename?: 'CreatePostingPayload';
  /** Reads a single `Commentable` that is related to this `Posting`. */
  aboutCommentable?: Maybe<Commentable>;
  /** Reads a single `Posting` that is related to this `Posting`. */
  answeredPosting?: Maybe<Posting>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Conversation` that is related to this `Posting`. */
  conversation?: Maybe<Conversation>;
  /** The `Posting` that was created by this mutation. */
  posting?: Maybe<Posting>;
  /** An edge for our `Posting`. May be used by Relay 1. */
  postingEdge?: Maybe<PostingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Posting`. */
  sender?: Maybe<User>;
};


/** The output of our create `Posting` mutation. */
export type CreatePostingPayloadPostingEdgeArgs = {
  orderBy?: InputMaybe<Array<PostingsOrderBy>>;
};

/** All input for the create `PostingReceipt` mutation. */
export type CreatePostingReceiptInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PostingReceipt` to be created by this mutation. */
  postingReceipt: PostingReceiptInput;
};

/** The output of our create `PostingReceipt` mutation. */
export type CreatePostingReceiptPayload = {
  __typename?: 'CreatePostingReceiptPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Posting` that is related to this `PostingReceipt`. */
  posting?: Maybe<Posting>;
  /** The `PostingReceipt` that was created by this mutation. */
  postingReceipt?: Maybe<PostingReceipt>;
  /** An edge for our `PostingReceipt`. May be used by Relay 1. */
  postingReceiptEdge?: Maybe<PostingReceiptsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PostingReceipt`. */
  user?: Maybe<User>;
};


/** The output of our create `PostingReceipt` mutation. */
export type CreatePostingReceiptPayloadPostingReceiptEdgeArgs = {
  orderBy?: InputMaybe<Array<PostingReceiptsOrderBy>>;
};

/** All input for the create `RandomizationTicket` mutation. */
export type CreateRandomizationTicketInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RandomizationTicket` to be created by this mutation. */
  randomizationTicket: RandomizationTicketInput;
};

/** The output of our create `RandomizationTicket` mutation. */
export type CreateRandomizationTicketPayload = {
  __typename?: 'CreateRandomizationTicketPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RandomizationTicket` that was created by this mutation. */
  randomizationTicket?: Maybe<RandomizationTicket>;
  /** An edge for our `RandomizationTicket`. May be used by Relay 1. */
  randomizationTicketEdge?: Maybe<RandomizationTicketsEdge>;
  /** Reads a single `Trial` that is related to this `RandomizationTicket`. */
  trial?: Maybe<Trial>;
};


/** The output of our create `RandomizationTicket` mutation. */
export type CreateRandomizationTicketPayloadRandomizationTicketEdgeArgs = {
  orderBy?: InputMaybe<Array<RandomizationTicketsOrderBy>>;
};

/** All input for the create `RawUsageDatum` mutation. */
export type CreateRawUsageDatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RawUsageDatum` to be created by this mutation. */
  rawUsageDatum: RawUsageDatumInput;
};

/** The output of our create `RawUsageDatum` mutation. */
export type CreateRawUsageDatumPayload = {
  __typename?: 'CreateRawUsageDatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RawUsageDatum` that was created by this mutation. */
  rawUsageDatum?: Maybe<RawUsageDatum>;
  /** An edge for our `RawUsageDatum`. May be used by Relay 1. */
  rawUsageDatumEdge?: Maybe<RawUsageDataEdge>;
  /** Reads a single `Trial` that is related to this `RawUsageDatum`. */
  trial?: Maybe<Trial>;
  /** Reads a single `User` that is related to this `RawUsageDatum`. */
  user?: Maybe<User>;
};


/** The output of our create `RawUsageDatum` mutation. */
export type CreateRawUsageDatumPayloadRawUsageDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<RawUsageDataOrderBy>>;
};

/** All input for the create `Tenant` mutation. */
export type CreateTenantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Tenant` to be created by this mutation. */
  tenant: TenantInput;
};

/** The output of our create `Tenant` mutation. */
export type CreateTenantPayload = {
  __typename?: 'CreateTenantPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Tenant` that was created by this mutation. */
  tenant?: Maybe<Tenant>;
  /** An edge for our `Tenant`. May be used by Relay 1. */
  tenantEdge?: Maybe<TenantsEdge>;
};


/** The output of our create `Tenant` mutation. */
export type CreateTenantPayloadTenantEdgeArgs = {
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
};

/** All input for the create `Trial` mutation. */
export type CreateTrialInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Trial` to be created by this mutation. */
  trial: TrialInput;
};

/** The output of our create `Trial` mutation. */
export type CreateTrialPayload = {
  __typename?: 'CreateTrialPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Commentable` that is related to this `Trial`. */
  commentableById?: Maybe<Commentable>;
  /** Reads a single `User` that is related to this `Trial`. */
  createdBy?: Maybe<User>;
  /** Reads a single `GroupHome` that is related to this `Trial`. */
  groupHomeById?: Maybe<GroupHome>;
  /** Reads a single `Conversation` that is related to this `Trial`. */
  internalMessages?: Maybe<Conversation>;
  /** Reads a single `Conversation` that is related to this `Trial`. */
  messages?: Maybe<Conversation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Group` that is related to this `Trial`. */
  staff?: Maybe<Group>;
  /** Reads a single `User` that is related to this `Trial`. */
  subject?: Maybe<User>;
  /** Reads a single `Tenant` that is related to this `Trial`. */
  tenant?: Maybe<Tenant>;
  /** The `Trial` that was created by this mutation. */
  trial?: Maybe<Trial>;
  /** An edge for our `Trial`. May be used by Relay 1. */
  trialEdge?: Maybe<TrialsEdge>;
};


/** The output of our create `Trial` mutation. */
export type CreateTrialPayloadTrialEdgeArgs = {
  orderBy?: InputMaybe<Array<TrialsOrderBy>>;
};

/** All input for the create `UserCredential` mutation. */
export type CreateUserCredentialInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserCredential` to be created by this mutation. */
  userCredential: UserCredentialInput;
};

/** The output of our create `UserCredential` mutation. */
export type CreateUserCredentialPayload = {
  __typename?: 'CreateUserCredentialPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `UserCredential`. */
  tenant?: Maybe<Tenant>;
  /** The `UserCredential` that was created by this mutation. */
  userCredential?: Maybe<UserCredential>;
  /** An edge for our `UserCredential`. May be used by Relay 1. */
  userCredentialEdge?: Maybe<UserCredentialsEdge>;
};


/** The output of our create `UserCredential` mutation. */
export type CreateUserCredentialPayloadUserCredentialEdgeArgs = {
  orderBy?: InputMaybe<Array<UserCredentialsOrderBy>>;
};

/** All input for the create `UserEmailAddress` mutation. */
export type CreateUserEmailAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserEmailAddress` to be created by this mutation. */
  userEmailAddress: UserEmailAddressInput;
};

/** The output of our create `UserEmailAddress` mutation. */
export type CreateUserEmailAddressPayload = {
  __typename?: 'CreateUserEmailAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserEmailAddress` that was created by this mutation. */
  userEmailAddress?: Maybe<UserEmailAddress>;
  /** An edge for our `UserEmailAddress`. May be used by Relay 1. */
  userEmailAddressEdge?: Maybe<UserEmailAddressesEdge>;
};


/** The output of our create `UserEmailAddress` mutation. */
export type CreateUserEmailAddressPayloadUserEmailAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<UserEmailAddressesOrderBy>>;
};

/** All input for the create `User` mutation. */
export type CreateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `User` to be created by this mutation. */
  user: UserInput;
};

/** The output of our create `User` mutation. */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `UserCredential` that is related to this `User`. */
  credentials?: Maybe<UserCredential>;
  /** Reads a single `UserEmailAddress` that is related to this `User`. */
  emailAddress?: Maybe<UserEmailAddress>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `User`. */
  tenant?: Maybe<Tenant>;
  /** The `User` that was created by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our create `User` mutation. */
export type CreateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** A filter to be used against Date fields. All fields are combined with a logical ‘and.’ */
export type DateFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Date']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Date']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Date']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Date']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Date']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Date']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Date']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Date']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Date']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Date']>>;
};

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']>>;
};

/** All input for the `deleteCommentableByNodeId` mutation. */
export type DeleteCommentableByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Commentable` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteCommentable` mutation. */
export type DeleteCommentableInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Commentable` mutation. */
export type DeleteCommentablePayload = {
  __typename?: 'DeleteCommentablePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Commentable` that was deleted by this mutation. */
  commentable?: Maybe<Commentable>;
  /** An edge for our `Commentable`. May be used by Relay 1. */
  commentableEdge?: Maybe<CommentablesEdge>;
  deletedCommentableNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `Commentable` mutation. */
export type DeleteCommentablePayloadCommentableEdgeArgs = {
  orderBy?: InputMaybe<Array<CommentablesOrderBy>>;
};

/** All input for the `deleteConversationByNodeId` mutation. */
export type DeleteConversationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Conversation` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteConversation` mutation. */
export type DeleteConversationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Conversation` mutation. */
export type DeleteConversationPayload = {
  __typename?: 'DeleteConversationPayload';
  /** Reads a single `Commentable` that is related to this `Conversation`. */
  aboutCommentable?: Maybe<Commentable>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Conversation` that was deleted by this mutation. */
  conversation?: Maybe<Conversation>;
  /** An edge for our `Conversation`. May be used by Relay 1. */
  conversationEdge?: Maybe<ConversationsEdge>;
  /** Reads a single `User` that is related to this `Conversation`. */
  creator?: Maybe<User>;
  deletedConversationNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Group` that is related to this `Conversation`. */
  privateGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Conversation`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our delete `Conversation` mutation. */
export type DeleteConversationPayloadConversationEdgeArgs = {
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
};

/** All input for the `deleteEmaEntries2ByNodeId` mutation. */
export type DeleteEmaEntries2ByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `EmaEntries2` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteEmaEntries2` mutation. */
export type DeleteEmaEntries2Input = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `EmaEntries2` mutation. */
export type DeleteEmaEntries2Payload = {
  __typename?: 'DeleteEmaEntries2Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedEmaEntries2NodeId?: Maybe<Scalars['ID']>;
  /** The `EmaEntries2` that was deleted by this mutation. */
  emaEntries2?: Maybe<EmaEntries2>;
  /** An edge for our `EmaEntries2`. May be used by Relay 1. */
  emaEntries2Edge?: Maybe<EmaEntries2sEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmaEntries2`. */
  subject?: Maybe<User>;
};


/** The output of our delete `EmaEntries2` mutation. */
export type DeleteEmaEntries2PayloadEmaEntries2EdgeArgs = {
  orderBy?: InputMaybe<Array<EmaEntries2sOrderBy>>;
};

/** All input for the `deleteEmaEntries3ByNodeId` mutation. */
export type DeleteEmaEntries3ByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `EmaEntries3` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteEmaEntries3` mutation. */
export type DeleteEmaEntries3Input = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `EmaEntries3` mutation. */
export type DeleteEmaEntries3Payload = {
  __typename?: 'DeleteEmaEntries3Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedEmaEntries3NodeId?: Maybe<Scalars['ID']>;
  /** The `EmaEntries3` that was deleted by this mutation. */
  emaEntries3?: Maybe<EmaEntries3>;
  /** An edge for our `EmaEntries3`. May be used by Relay 1. */
  emaEntries3Edge?: Maybe<EmaEntries3sEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trial` that is related to this `EmaEntries3`. */
  trial?: Maybe<Trial>;
};


/** The output of our delete `EmaEntries3` mutation. */
export type DeleteEmaEntries3PayloadEmaEntries3EdgeArgs = {
  orderBy?: InputMaybe<Array<EmaEntries3sOrderBy>>;
};

/** All input for the `deleteEmaEntryByNodeId` mutation. */
export type DeleteEmaEntryByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `EmaEntry` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteEmaEntry` mutation. */
export type DeleteEmaEntryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `EmaEntry` mutation. */
export type DeleteEmaEntryPayload = {
  __typename?: 'DeleteEmaEntryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedEmaEntryNodeId?: Maybe<Scalars['ID']>;
  /** The `EmaEntry` that was deleted by this mutation. */
  emaEntry?: Maybe<EmaEntry>;
  /** An edge for our `EmaEntry`. May be used by Relay 1. */
  emaEntryEdge?: Maybe<EmaEntriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmaEntry`. */
  subject?: Maybe<User>;
};


/** The output of our delete `EmaEntry` mutation. */
export type DeleteEmaEntryPayloadEmaEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<EmaEntriesOrderBy>>;
};

/** All input for the `deleteFavoritePageByNodeId` mutation. */
export type DeleteFavoritePageByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FavoritePage` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteFavoritePage` mutation. */
export type DeleteFavoritePageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  route: Scalars['String'];
  trialId: Scalars['UUID'];
};

/** The output of our delete `FavoritePage` mutation. */
export type DeleteFavoritePagePayload = {
  __typename?: 'DeleteFavoritePagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedFavoritePageNodeId?: Maybe<Scalars['ID']>;
  /** The `FavoritePage` that was deleted by this mutation. */
  favoritePage?: Maybe<FavoritePage>;
  /** An edge for our `FavoritePage`. May be used by Relay 1. */
  favoritePageEdge?: Maybe<FavoritePagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trial` that is related to this `FavoritePage`. */
  trial?: Maybe<Trial>;
};


/** The output of our delete `FavoritePage` mutation. */
export type DeleteFavoritePagePayloadFavoritePageEdgeArgs = {
  orderBy?: InputMaybe<Array<FavoritePagesOrderBy>>;
};

/** All input for the `deleteGenericEmiExerciseByNodeId` mutation. */
export type DeleteGenericEmiExerciseByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `GenericEmiExercise` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteGenericEmiExerciseByTrialIdAndName` mutation. */
export type DeleteGenericEmiExerciseByTrialIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  trialId: Scalars['UUID'];
};

/** All input for the `deleteGenericEmiExercise` mutation. */
export type DeleteGenericEmiExerciseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `GenericEmiExercise` mutation. */
export type DeleteGenericEmiExercisePayload = {
  __typename?: 'DeleteGenericEmiExercisePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedGenericEmiExerciseNodeId?: Maybe<Scalars['ID']>;
  /** The `GenericEmiExercise` that was deleted by this mutation. */
  genericEmiExercise?: Maybe<GenericEmiExercise>;
  /** An edge for our `GenericEmiExercise`. May be used by Relay 1. */
  genericEmiExerciseEdge?: Maybe<GenericEmiExercisesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trial` that is related to this `GenericEmiExercise`. */
  trial?: Maybe<Trial>;
};


/** The output of our delete `GenericEmiExercise` mutation. */
export type DeleteGenericEmiExercisePayloadGenericEmiExerciseEdgeArgs = {
  orderBy?: InputMaybe<Array<GenericEmiExercisesOrderBy>>;
};

/** All input for the `deleteGroupByNodeId` mutation. */
export type DeleteGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Group` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteGroupHomeByNodeId` mutation. */
export type DeleteGroupHomeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `GroupHome` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteGroupHome` mutation. */
export type DeleteGroupHomeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `GroupHome` mutation. */
export type DeleteGroupHomePayload = {
  __typename?: 'DeleteGroupHomePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedGroupHomeNodeId?: Maybe<Scalars['ID']>;
  /** The `GroupHome` that was deleted by this mutation. */
  groupHome?: Maybe<GroupHome>;
  /** An edge for our `GroupHome`. May be used by Relay 1. */
  groupHomeEdge?: Maybe<GroupHomesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `GroupHome` mutation. */
export type DeleteGroupHomePayloadGroupHomeEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupHomesOrderBy>>;
};

/** All input for the `deleteGroup` mutation. */
export type DeleteGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Group` mutation. */
export type DeleteGroupPayload = {
  __typename?: 'DeleteGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Group`. */
  creator?: Maybe<User>;
  deletedGroupNodeId?: Maybe<Scalars['ID']>;
  /** The `Group` that was deleted by this mutation. */
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Reads a single `GroupHome` that is related to this `Group`. */
  home?: Maybe<GroupHome>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Group`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our delete `Group` mutation. */
export type DeleteGroupPayloadGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

/** All input for the `deleteLimesurveyTokenByNodeId` mutation. */
export type DeleteLimesurveyTokenByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `LimesurveyToken` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteLimesurveyTokenByTrialIdAndTimeOfMeasurement` mutation. */
export type DeleteLimesurveyTokenByTrialIdAndTimeOfMeasurementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  timeOfMeasurement: Scalars['String'];
  trialId: Scalars['UUID'];
};

/** All input for the `deleteLimesurveyToken` mutation. */
export type DeleteLimesurveyTokenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  surveyId: Scalars['Int'];
  token: Scalars['String'];
};

/** The output of our delete `LimesurveyToken` mutation. */
export type DeleteLimesurveyTokenPayload = {
  __typename?: 'DeleteLimesurveyTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedLimesurveyTokenNodeId?: Maybe<Scalars['ID']>;
  /** The `LimesurveyToken` that was deleted by this mutation. */
  limesurveyToken?: Maybe<LimesurveyToken>;
  /** An edge for our `LimesurveyToken`. May be used by Relay 1. */
  limesurveyTokenEdge?: Maybe<LimesurveyTokensEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trial` that is related to this `LimesurveyToken`. */
  trial?: Maybe<Trial>;
};


/** The output of our delete `LimesurveyToken` mutation. */
export type DeleteLimesurveyTokenPayloadLimesurveyTokenEdgeArgs = {
  orderBy?: InputMaybe<Array<LimesurveyTokensOrderBy>>;
};

/** All input for the `deleteMembershipByGroupIdAndSubgroupId` mutation. */
export type DeleteMembershipByGroupIdAndSubgroupIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  groupId: Scalars['UUID'];
  subgroupId: Scalars['UUID'];
};

/** All input for the `deleteMembershipByGroupIdAndUserId` mutation. */
export type DeleteMembershipByGroupIdAndUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  groupId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** All input for the `deleteMembershipByNodeId` mutation. */
export type DeleteMembershipByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Membership` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteMembership` mutation. */
export type DeleteMembershipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** All input for the `deleteMembershipInvitationByNodeId` mutation. */
export type DeleteMembershipInvitationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MembershipInvitation` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteMembershipInvitationConfirmationByNodeId` mutation. */
export type DeleteMembershipInvitationConfirmationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MembershipInvitationConfirmation` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteMembershipInvitationConfirmation` mutation. */
export type DeleteMembershipInvitationConfirmationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `MembershipInvitationConfirmation` mutation. */
export type DeleteMembershipInvitationConfirmationPayload = {
  __typename?: 'DeleteMembershipInvitationConfirmationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedMembershipInvitationConfirmationNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `MembershipInvitation` that is related to this `MembershipInvitationConfirmation`. */
  invitation?: Maybe<MembershipInvitation>;
  /** Reads a single `Membership` that is related to this `MembershipInvitationConfirmation`. */
  membership?: Maybe<Membership>;
  /** The `MembershipInvitationConfirmation` that was deleted by this mutation. */
  membershipInvitationConfirmation?: Maybe<MembershipInvitationConfirmation>;
  /** An edge for our `MembershipInvitationConfirmation`. May be used by Relay 1. */
  membershipInvitationConfirmationEdge?: Maybe<MembershipInvitationConfirmationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `MembershipInvitationConfirmation` mutation. */
export type DeleteMembershipInvitationConfirmationPayloadMembershipInvitationConfirmationEdgeArgs = {
  orderBy?: InputMaybe<Array<MembershipInvitationConfirmationsOrderBy>>;
};

/** All input for the `deleteMembershipInvitation` mutation. */
export type DeleteMembershipInvitationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `MembershipInvitation` mutation. */
export type DeleteMembershipInvitationPayload = {
  __typename?: 'DeleteMembershipInvitationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedMembershipInvitationNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Group` that is related to this `MembershipInvitation`. */
  group?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `MembershipInvitation`. */
  invitedGroup?: Maybe<Group>;
  /** Reads a single `User` that is related to this `MembershipInvitation`. */
  invitedUser?: Maybe<User>;
  /** Reads a single `User` that is related to this `MembershipInvitation`. */
  inviter?: Maybe<User>;
  /** The `MembershipInvitation` that was deleted by this mutation. */
  membershipInvitation?: Maybe<MembershipInvitation>;
  /** An edge for our `MembershipInvitation`. May be used by Relay 1. */
  membershipInvitationEdge?: Maybe<MembershipInvitationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `MembershipInvitation` mutation. */
export type DeleteMembershipInvitationPayloadMembershipInvitationEdgeArgs = {
  orderBy?: InputMaybe<Array<MembershipInvitationsOrderBy>>;
};

/** The output of our delete `Membership` mutation. */
export type DeleteMembershipPayload = {
  __typename?: 'DeleteMembershipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedMembershipNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Group` that is related to this `Membership`. */
  group?: Maybe<Group>;
  /** The `Membership` that was deleted by this mutation. */
  membership?: Maybe<Membership>;
  /** An edge for our `Membership`. May be used by Relay 1. */
  membershipEdge?: Maybe<MembershipsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Group` that is related to this `Membership`. */
  subgroup?: Maybe<Group>;
  /** Reads a single `User` that is related to this `Membership`. */
  user?: Maybe<User>;
};


/** The output of our delete `Membership` mutation. */
export type DeleteMembershipPayloadMembershipEdgeArgs = {
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};

/** All input for the `deletePostWaitRandomizationTicketByNodeId` mutation. */
export type DeletePostWaitRandomizationTicketByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PostWaitRandomizationTicket` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deletePostWaitRandomizationTicketByTrialId` mutation. */
export type DeletePostWaitRandomizationTicketByTrialIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  trialId: Scalars['UUID'];
};

/** All input for the `deletePostWaitRandomizationTicket` mutation. */
export type DeletePostWaitRandomizationTicketInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `PostWaitRandomizationTicket` mutation. */
export type DeletePostWaitRandomizationTicketPayload = {
  __typename?: 'DeletePostWaitRandomizationTicketPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPostWaitRandomizationTicketNodeId?: Maybe<Scalars['ID']>;
  /** The `PostWaitRandomizationTicket` that was deleted by this mutation. */
  postWaitRandomizationTicket?: Maybe<PostWaitRandomizationTicket>;
  /** An edge for our `PostWaitRandomizationTicket`. May be used by Relay 1. */
  postWaitRandomizationTicketEdge?: Maybe<PostWaitRandomizationTicketsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trial` that is related to this `PostWaitRandomizationTicket`. */
  trial?: Maybe<Trial>;
};


/** The output of our delete `PostWaitRandomizationTicket` mutation. */
export type DeletePostWaitRandomizationTicketPayloadPostWaitRandomizationTicketEdgeArgs = {
  orderBy?: InputMaybe<Array<PostWaitRandomizationTicketsOrderBy>>;
};

/** All input for the `deletePostingByNodeId` mutation. */
export type DeletePostingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Posting` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deletePosting` mutation. */
export type DeletePostingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Posting` mutation. */
export type DeletePostingPayload = {
  __typename?: 'DeletePostingPayload';
  /** Reads a single `Commentable` that is related to this `Posting`. */
  aboutCommentable?: Maybe<Commentable>;
  /** Reads a single `Posting` that is related to this `Posting`. */
  answeredPosting?: Maybe<Posting>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Conversation` that is related to this `Posting`. */
  conversation?: Maybe<Conversation>;
  deletedPostingNodeId?: Maybe<Scalars['ID']>;
  /** The `Posting` that was deleted by this mutation. */
  posting?: Maybe<Posting>;
  /** An edge for our `Posting`. May be used by Relay 1. */
  postingEdge?: Maybe<PostingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Posting`. */
  sender?: Maybe<User>;
};


/** The output of our delete `Posting` mutation. */
export type DeletePostingPayloadPostingEdgeArgs = {
  orderBy?: InputMaybe<Array<PostingsOrderBy>>;
};

/** All input for the `deletePostingReceiptByNodeId` mutation. */
export type DeletePostingReceiptByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PostingReceipt` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deletePostingReceipt` mutation. */
export type DeletePostingReceiptInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  postingId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our delete `PostingReceipt` mutation. */
export type DeletePostingReceiptPayload = {
  __typename?: 'DeletePostingReceiptPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPostingReceiptNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Posting` that is related to this `PostingReceipt`. */
  posting?: Maybe<Posting>;
  /** The `PostingReceipt` that was deleted by this mutation. */
  postingReceipt?: Maybe<PostingReceipt>;
  /** An edge for our `PostingReceipt`. May be used by Relay 1. */
  postingReceiptEdge?: Maybe<PostingReceiptsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PostingReceipt`. */
  user?: Maybe<User>;
};


/** The output of our delete `PostingReceipt` mutation. */
export type DeletePostingReceiptPayloadPostingReceiptEdgeArgs = {
  orderBy?: InputMaybe<Array<PostingReceiptsOrderBy>>;
};

/** All input for the `deleteRandomizationTicketByNodeId` mutation. */
export type DeleteRandomizationTicketByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `RandomizationTicket` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteRandomizationTicketByTrialId` mutation. */
export type DeleteRandomizationTicketByTrialIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  trialId: Scalars['UUID'];
};

/** All input for the `deleteRandomizationTicket` mutation. */
export type DeleteRandomizationTicketInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RandomizationTicket` mutation. */
export type DeleteRandomizationTicketPayload = {
  __typename?: 'DeleteRandomizationTicketPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRandomizationTicketNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RandomizationTicket` that was deleted by this mutation. */
  randomizationTicket?: Maybe<RandomizationTicket>;
  /** An edge for our `RandomizationTicket`. May be used by Relay 1. */
  randomizationTicketEdge?: Maybe<RandomizationTicketsEdge>;
  /** Reads a single `Trial` that is related to this `RandomizationTicket`. */
  trial?: Maybe<Trial>;
};


/** The output of our delete `RandomizationTicket` mutation. */
export type DeleteRandomizationTicketPayloadRandomizationTicketEdgeArgs = {
  orderBy?: InputMaybe<Array<RandomizationTicketsOrderBy>>;
};

/** All input for the `deleteRawUsageDatumByNodeId` mutation. */
export type DeleteRawUsageDatumByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `RawUsageDatum` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteRawUsageDatum` mutation. */
export type DeleteRawUsageDatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `RawUsageDatum` mutation. */
export type DeleteRawUsageDatumPayload = {
  __typename?: 'DeleteRawUsageDatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRawUsageDatumNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RawUsageDatum` that was deleted by this mutation. */
  rawUsageDatum?: Maybe<RawUsageDatum>;
  /** An edge for our `RawUsageDatum`. May be used by Relay 1. */
  rawUsageDatumEdge?: Maybe<RawUsageDataEdge>;
  /** Reads a single `Trial` that is related to this `RawUsageDatum`. */
  trial?: Maybe<Trial>;
  /** Reads a single `User` that is related to this `RawUsageDatum`. */
  user?: Maybe<User>;
};


/** The output of our delete `RawUsageDatum` mutation. */
export type DeleteRawUsageDatumPayloadRawUsageDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<RawUsageDataOrderBy>>;
};

/** All input for the `deleteTenantByName` mutation. */
export type DeleteTenantByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** All input for the `deleteTenantByNodeId` mutation. */
export type DeleteTenantByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Tenant` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteTenantByUrl` mutation. */
export type DeleteTenantByUrlInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  url: Scalars['String'];
};

/** All input for the `deleteTenant` mutation. */
export type DeleteTenantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Tenant` mutation. */
export type DeleteTenantPayload = {
  __typename?: 'DeleteTenantPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedTenantNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Tenant` that was deleted by this mutation. */
  tenant?: Maybe<Tenant>;
  /** An edge for our `Tenant`. May be used by Relay 1. */
  tenantEdge?: Maybe<TenantsEdge>;
};


/** The output of our delete `Tenant` mutation. */
export type DeleteTenantPayloadTenantEdgeArgs = {
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
};

/** All input for the `deleteTrialByHumanReadableId` mutation. */
export type DeleteTrialByHumanReadableIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  humanReadableId: Scalars['BigInt'];
};

/** All input for the `deleteTrialByName` mutation. */
export type DeleteTrialByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

/** All input for the `deleteTrialByNodeId` mutation. */
export type DeleteTrialByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Trial` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteTrial` mutation. */
export type DeleteTrialInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `Trial` mutation. */
export type DeleteTrialPayload = {
  __typename?: 'DeleteTrialPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Commentable` that is related to this `Trial`. */
  commentableById?: Maybe<Commentable>;
  /** Reads a single `User` that is related to this `Trial`. */
  createdBy?: Maybe<User>;
  deletedTrialNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `GroupHome` that is related to this `Trial`. */
  groupHomeById?: Maybe<GroupHome>;
  /** Reads a single `Conversation` that is related to this `Trial`. */
  internalMessages?: Maybe<Conversation>;
  /** Reads a single `Conversation` that is related to this `Trial`. */
  messages?: Maybe<Conversation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Group` that is related to this `Trial`. */
  staff?: Maybe<Group>;
  /** Reads a single `User` that is related to this `Trial`. */
  subject?: Maybe<User>;
  /** Reads a single `Tenant` that is related to this `Trial`. */
  tenant?: Maybe<Tenant>;
  /** The `Trial` that was deleted by this mutation. */
  trial?: Maybe<Trial>;
  /** An edge for our `Trial`. May be used by Relay 1. */
  trialEdge?: Maybe<TrialsEdge>;
};


/** The output of our delete `Trial` mutation. */
export type DeleteTrialPayloadTrialEdgeArgs = {
  orderBy?: InputMaybe<Array<TrialsOrderBy>>;
};

/** All input for the `deleteUserByCredentialsId` mutation. */
export type DeleteUserByCredentialsIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  credentialsId: Scalars['UUID'];
};

/** All input for the `deleteUserByEmailAddressId` mutation. */
export type DeleteUserByEmailAddressIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  emailAddressId: Scalars['UUID'];
};

/** All input for the `deleteUserByIdAndTenantId` mutation. */
export type DeleteUserByIdAndTenantIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  tenantId: Scalars['UUID'];
};

/** All input for the `deleteUserByNodeId` mutation. */
export type DeleteUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `User` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteUserByUsernameAndTenantId` mutation. */
export type DeleteUserByUsernameAndTenantIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['UUID'];
  username: Scalars['String'];
};

/** All input for the `deleteUserCredentialByExternalAuthIdAndTenantId` mutation. */
export type DeleteUserCredentialByExternalAuthIdAndTenantIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalAuthId: Scalars['String'];
  tenantId: Scalars['UUID'];
};

/** All input for the `deleteUserCredentialByNodeId` mutation. */
export type DeleteUserCredentialByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UserCredential` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteUserCredential` mutation. */
export type DeleteUserCredentialInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `UserCredential` mutation. */
export type DeleteUserCredentialPayload = {
  __typename?: 'DeleteUserCredentialPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedUserCredentialNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `UserCredential`. */
  tenant?: Maybe<Tenant>;
  /** The `UserCredential` that was deleted by this mutation. */
  userCredential?: Maybe<UserCredential>;
  /** An edge for our `UserCredential`. May be used by Relay 1. */
  userCredentialEdge?: Maybe<UserCredentialsEdge>;
};


/** The output of our delete `UserCredential` mutation. */
export type DeleteUserCredentialPayloadUserCredentialEdgeArgs = {
  orderBy?: InputMaybe<Array<UserCredentialsOrderBy>>;
};

/** All input for the `deleteUserEmailAddressByEmailAddressAndTenantId` mutation. */
export type DeleteUserEmailAddressByEmailAddressAndTenantIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  tenantId: Scalars['UUID'];
};

/** All input for the `deleteUserEmailAddressByNodeId` mutation. */
export type DeleteUserEmailAddressByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UserEmailAddress` to be deleted. */
  nodeId: Scalars['ID'];
};

/** All input for the `deleteUserEmailAddress` mutation. */
export type DeleteUserEmailAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `UserEmailAddress` mutation. */
export type DeleteUserEmailAddressPayload = {
  __typename?: 'DeleteUserEmailAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedUserEmailAddressNodeId?: Maybe<Scalars['ID']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserEmailAddress` that was deleted by this mutation. */
  userEmailAddress?: Maybe<UserEmailAddress>;
  /** An edge for our `UserEmailAddress`. May be used by Relay 1. */
  userEmailAddressEdge?: Maybe<UserEmailAddressesEdge>;
};


/** The output of our delete `UserEmailAddress` mutation. */
export type DeleteUserEmailAddressPayloadUserEmailAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<UserEmailAddressesOrderBy>>;
};

/** All input for the `deleteUser` mutation. */
export type DeleteUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

/** The output of our delete `User` mutation. */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `UserCredential` that is related to this `User`. */
  credentials?: Maybe<UserCredential>;
  deletedUserNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `UserEmailAddress` that is related to this `User`. */
  emailAddress?: Maybe<UserEmailAddress>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `User`. */
  tenant?: Maybe<Tenant>;
  /** The `User` that was deleted by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our delete `User` mutation. */
export type DeleteUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

export type EmaEntries2 = Node & {
  __typename?: 'EmaEntries2';
  angry?: Maybe<Scalars['Int']>;
  anxious?: Maybe<Scalars['Int']>;
  anxiousDuringContact?: Maybe<Scalars['Int']>;
  avoidedSocialContact?: Maybe<Scalars['Int']>;
  burden?: Maybe<Scalars['Int']>;
  comfortableDuringContact?: Maybe<Scalars['Int']>;
  completedAt?: Maybe<Scalars['Datetime']>;
  createdAt: Scalars['Datetime'];
  deleted: Scalars['Boolean'];
  guilty?: Maybe<Scalars['Int']>;
  hadAnyContactWithOthersSinceTheLastSurvey?: Maybe<Scalars['Boolean']>;
  happy?: Maybe<Scalars['Int']>;
  id: Scalars['UUID'];
  lackOfSocialContactBothersMe?: Maybe<Scalars['Int']>;
  lonely?: Maybe<Scalars['Int']>;
  lookedForAdviceAndComfortFromOthers?: Maybe<Scalars['Int']>;
  noSocialContactDueToOuterConditions?: Maybe<Scalars['Int']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  notTriedToAlterMyThoughtsAndFeelings?: Maybe<Scalars['Int']>;
  plannedHowToProceed?: Maybe<Scalars['Int']>;
  relaxed?: Maybe<Scalars['Int']>;
  rumination?: Maybe<Scalars['Int']>;
  sad?: Maybe<Scalars['Int']>;
  satisfied?: Maybe<Scalars['Int']>;
  scheduledAt: Scalars['Datetime'];
  startedAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `User` that is related to this `EmaEntries2`. */
  subject?: Maybe<User>;
  subjectId: Scalars['UUID'];
  tenseDuringContact?: Maybe<Scalars['Int']>;
  testy?: Maybe<Scalars['Int']>;
  testyDuringContact?: Maybe<Scalars['Int']>;
  thoughtALotAboutMyThoughtsAndFeelings?: Maybe<Scalars['Int']>;
  triedToAcceptMyThoughtsAndFeelings?: Maybe<Scalars['Int']>;
  triedToCalmMyselfDown?: Maybe<Scalars['Int']>;
  triedToChangeMyPerspective?: Maybe<Scalars['Int']>;
  triedToDistractMyselfFromMyThoughtsAndFeelings?: Maybe<Scalars['Int']>;
  triedToHideMyThoughtsAndFeelings?: Maybe<Scalars['Int']>;
  triedToRepressMyThoughtsAndFeelings?: Maybe<Scalars['Int']>;
  unconfidentDuringContact?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Datetime'];
  updatedAtUtc?: Maybe<Scalars['String']>;
  wouldHaveLikedSocialContact?: Maybe<Scalars['Int']>;
};

export type EmaEntries2Aggregates = {
  __typename?: 'EmaEntries2Aggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<EmaEntries2AverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<EmaEntries2DistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<EmaEntries2MaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<EmaEntries2MinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<EmaEntries2StddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<EmaEntries2StddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<EmaEntries2SumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<EmaEntries2VariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<EmaEntries2VarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `EmaEntries2` object types. */
export type EmaEntries2AggregatesFilter = {
  /** Mean average aggregate over matching `EmaEntries2` objects. */
  average?: InputMaybe<EmaEntries2AverageAggregateFilter>;
  /** Distinct count aggregate over matching `EmaEntries2` objects. */
  distinctCount?: InputMaybe<EmaEntries2DistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `EmaEntries2` object to be included within the aggregate. */
  filter?: InputMaybe<EmaEntries2Filter>;
  /** Maximum aggregate over matching `EmaEntries2` objects. */
  max?: InputMaybe<EmaEntries2MaxAggregateFilter>;
  /** Minimum aggregate over matching `EmaEntries2` objects. */
  min?: InputMaybe<EmaEntries2MinAggregateFilter>;
  /** Population standard deviation aggregate over matching `EmaEntries2` objects. */
  stddevPopulation?: InputMaybe<EmaEntries2StddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `EmaEntries2` objects. */
  stddevSample?: InputMaybe<EmaEntries2StddevSampleAggregateFilter>;
  /** Sum aggregate over matching `EmaEntries2` objects. */
  sum?: InputMaybe<EmaEntries2SumAggregateFilter>;
  /** Population variance aggregate over matching `EmaEntries2` objects. */
  variancePopulation?: InputMaybe<EmaEntries2VariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `EmaEntries2` objects. */
  varianceSample?: InputMaybe<EmaEntries2VarianceSampleAggregateFilter>;
};

export type EmaEntries2AverageAggregateFilter = {
  angry?: InputMaybe<BigFloatFilter>;
  anxious?: InputMaybe<BigFloatFilter>;
  anxiousDuringContact?: InputMaybe<BigFloatFilter>;
  avoidedSocialContact?: InputMaybe<BigFloatFilter>;
  burden?: InputMaybe<BigFloatFilter>;
  comfortableDuringContact?: InputMaybe<BigFloatFilter>;
  guilty?: InputMaybe<BigFloatFilter>;
  happy?: InputMaybe<BigFloatFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<BigFloatFilter>;
  lonely?: InputMaybe<BigFloatFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<BigFloatFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<BigFloatFilter>;
  notTriedToAlterMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  plannedHowToProceed?: InputMaybe<BigFloatFilter>;
  relaxed?: InputMaybe<BigFloatFilter>;
  rumination?: InputMaybe<BigFloatFilter>;
  sad?: InputMaybe<BigFloatFilter>;
  satisfied?: InputMaybe<BigFloatFilter>;
  tenseDuringContact?: InputMaybe<BigFloatFilter>;
  testy?: InputMaybe<BigFloatFilter>;
  testyDuringContact?: InputMaybe<BigFloatFilter>;
  thoughtALotAboutMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToAcceptMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToCalmMyselfDown?: InputMaybe<BigFloatFilter>;
  triedToChangeMyPerspective?: InputMaybe<BigFloatFilter>;
  triedToDistractMyselfFromMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToHideMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  unconfidentDuringContact?: InputMaybe<BigFloatFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<BigFloatFilter>;
};

export type EmaEntries2AverageAggregates = {
  __typename?: 'EmaEntries2AverageAggregates';
  /** Mean average of angry across the matching connection */
  angry?: Maybe<Scalars['BigFloat']>;
  /** Mean average of anxious across the matching connection */
  anxious?: Maybe<Scalars['BigFloat']>;
  /** Mean average of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Mean average of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['BigFloat']>;
  /** Mean average of burden across the matching connection */
  burden?: Maybe<Scalars['BigFloat']>;
  /** Mean average of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Mean average of guilty across the matching connection */
  guilty?: Maybe<Scalars['BigFloat']>;
  /** Mean average of happy across the matching connection */
  happy?: Maybe<Scalars['BigFloat']>;
  /** Mean average of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['BigFloat']>;
  /** Mean average of lonely across the matching connection */
  lonely?: Maybe<Scalars['BigFloat']>;
  /** Mean average of lookedForAdviceAndComfortFromOthers across the matching connection */
  lookedForAdviceAndComfortFromOthers?: Maybe<Scalars['BigFloat']>;
  /** Mean average of noSocialContactDueToOuterConditions across the matching connection */
  noSocialContactDueToOuterConditions?: Maybe<Scalars['BigFloat']>;
  /** Mean average of notTriedToAlterMyThoughtsAndFeelings across the matching connection */
  notTriedToAlterMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Mean average of plannedHowToProceed across the matching connection */
  plannedHowToProceed?: Maybe<Scalars['BigFloat']>;
  /** Mean average of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['BigFloat']>;
  /** Mean average of rumination across the matching connection */
  rumination?: Maybe<Scalars['BigFloat']>;
  /** Mean average of sad across the matching connection */
  sad?: Maybe<Scalars['BigFloat']>;
  /** Mean average of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['BigFloat']>;
  /** Mean average of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Mean average of testy across the matching connection */
  testy?: Maybe<Scalars['BigFloat']>;
  /** Mean average of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Mean average of thoughtALotAboutMyThoughtsAndFeelings across the matching connection */
  thoughtALotAboutMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Mean average of triedToAcceptMyThoughtsAndFeelings across the matching connection */
  triedToAcceptMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Mean average of triedToCalmMyselfDown across the matching connection */
  triedToCalmMyselfDown?: Maybe<Scalars['BigFloat']>;
  /** Mean average of triedToChangeMyPerspective across the matching connection */
  triedToChangeMyPerspective?: Maybe<Scalars['BigFloat']>;
  /** Mean average of triedToDistractMyselfFromMyThoughtsAndFeelings across the matching connection */
  triedToDistractMyselfFromMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Mean average of triedToHideMyThoughtsAndFeelings across the matching connection */
  triedToHideMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Mean average of triedToRepressMyThoughtsAndFeelings across the matching connection */
  triedToRepressMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Mean average of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Mean average of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `EmaEntries2` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type EmaEntries2Condition = {
  /** Checks for equality with the object’s `angry` field. */
  angry?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `anxious` field. */
  anxious?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `anxiousDuringContact` field. */
  anxiousDuringContact?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `avoidedSocialContact` field. */
  avoidedSocialContact?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `burden` field. */
  burden?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `comfortableDuringContact` field. */
  comfortableDuringContact?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `completedAt` field. */
  completedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deleted` field. */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `guilty` field. */
  guilty?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `hadAnyContactWithOthersSinceTheLastSurvey` field. */
  hadAnyContactWithOthersSinceTheLastSurvey?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `happy` field. */
  happy?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `lackOfSocialContactBothersMe` field. */
  lackOfSocialContactBothersMe?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `lonely` field. */
  lonely?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `lookedForAdviceAndComfortFromOthers` field. */
  lookedForAdviceAndComfortFromOthers?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `noSocialContactDueToOuterConditions` field. */
  noSocialContactDueToOuterConditions?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `notTriedToAlterMyThoughtsAndFeelings` field. */
  notTriedToAlterMyThoughtsAndFeelings?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `plannedHowToProceed` field. */
  plannedHowToProceed?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `relaxed` field. */
  relaxed?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `rumination` field. */
  rumination?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `sad` field. */
  sad?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `satisfied` field. */
  satisfied?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scheduledAt` field. */
  scheduledAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `startedAt` field. */
  startedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `subjectId` field. */
  subjectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `tenseDuringContact` field. */
  tenseDuringContact?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `testy` field. */
  testy?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `testyDuringContact` field. */
  testyDuringContact?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `thoughtALotAboutMyThoughtsAndFeelings` field. */
  thoughtALotAboutMyThoughtsAndFeelings?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `triedToAcceptMyThoughtsAndFeelings` field. */
  triedToAcceptMyThoughtsAndFeelings?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `triedToCalmMyselfDown` field. */
  triedToCalmMyselfDown?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `triedToChangeMyPerspective` field. */
  triedToChangeMyPerspective?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `triedToDistractMyselfFromMyThoughtsAndFeelings` field. */
  triedToDistractMyselfFromMyThoughtsAndFeelings?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `triedToHideMyThoughtsAndFeelings` field. */
  triedToHideMyThoughtsAndFeelings?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `triedToRepressMyThoughtsAndFeelings` field. */
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `unconfidentDuringContact` field. */
  unconfidentDuringContact?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAtUtc` field. */
  updatedAtUtc?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `wouldHaveLikedSocialContact` field. */
  wouldHaveLikedSocialContact?: InputMaybe<Scalars['Int']>;
};

export type EmaEntries2DistinctCountAggregateFilter = {
  angry?: InputMaybe<BigIntFilter>;
  anxious?: InputMaybe<BigIntFilter>;
  anxiousDuringContact?: InputMaybe<BigIntFilter>;
  avoidedSocialContact?: InputMaybe<BigIntFilter>;
  burden?: InputMaybe<BigIntFilter>;
  comfortableDuringContact?: InputMaybe<BigIntFilter>;
  completedAt?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  deleted?: InputMaybe<BigIntFilter>;
  guilty?: InputMaybe<BigIntFilter>;
  hadAnyContactWithOthersSinceTheLastSurvey?: InputMaybe<BigIntFilter>;
  happy?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<BigIntFilter>;
  lonely?: InputMaybe<BigIntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<BigIntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<BigIntFilter>;
  notTriedToAlterMyThoughtsAndFeelings?: InputMaybe<BigIntFilter>;
  plannedHowToProceed?: InputMaybe<BigIntFilter>;
  relaxed?: InputMaybe<BigIntFilter>;
  rumination?: InputMaybe<BigIntFilter>;
  sad?: InputMaybe<BigIntFilter>;
  satisfied?: InputMaybe<BigIntFilter>;
  scheduledAt?: InputMaybe<BigIntFilter>;
  startedAt?: InputMaybe<BigIntFilter>;
  subjectId?: InputMaybe<BigIntFilter>;
  tenseDuringContact?: InputMaybe<BigIntFilter>;
  testy?: InputMaybe<BigIntFilter>;
  testyDuringContact?: InputMaybe<BigIntFilter>;
  thoughtALotAboutMyThoughtsAndFeelings?: InputMaybe<BigIntFilter>;
  triedToAcceptMyThoughtsAndFeelings?: InputMaybe<BigIntFilter>;
  triedToCalmMyselfDown?: InputMaybe<BigIntFilter>;
  triedToChangeMyPerspective?: InputMaybe<BigIntFilter>;
  triedToDistractMyselfFromMyThoughtsAndFeelings?: InputMaybe<BigIntFilter>;
  triedToHideMyThoughtsAndFeelings?: InputMaybe<BigIntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<BigIntFilter>;
  unconfidentDuringContact?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
  updatedAtUtc?: InputMaybe<StringFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<BigIntFilter>;
};

export type EmaEntries2DistinctCountAggregates = {
  __typename?: 'EmaEntries2DistinctCountAggregates';
  /** Distinct count of angry across the matching connection */
  angry?: Maybe<Scalars['BigInt']>;
  /** Distinct count of anxious across the matching connection */
  anxious?: Maybe<Scalars['BigInt']>;
  /** Distinct count of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['BigInt']>;
  /** Distinct count of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['BigInt']>;
  /** Distinct count of burden across the matching connection */
  burden?: Maybe<Scalars['BigInt']>;
  /** Distinct count of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['BigInt']>;
  /** Distinct count of completedAt across the matching connection */
  completedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of deleted across the matching connection */
  deleted?: Maybe<Scalars['BigInt']>;
  /** Distinct count of guilty across the matching connection */
  guilty?: Maybe<Scalars['BigInt']>;
  /** Distinct count of hadAnyContactWithOthersSinceTheLastSurvey across the matching connection */
  hadAnyContactWithOthersSinceTheLastSurvey?: Maybe<Scalars['BigInt']>;
  /** Distinct count of happy across the matching connection */
  happy?: Maybe<Scalars['BigInt']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']>;
  /** Distinct count of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['BigInt']>;
  /** Distinct count of lonely across the matching connection */
  lonely?: Maybe<Scalars['BigInt']>;
  /** Distinct count of lookedForAdviceAndComfortFromOthers across the matching connection */
  lookedForAdviceAndComfortFromOthers?: Maybe<Scalars['BigInt']>;
  /** Distinct count of noSocialContactDueToOuterConditions across the matching connection */
  noSocialContactDueToOuterConditions?: Maybe<Scalars['BigInt']>;
  /** Distinct count of notTriedToAlterMyThoughtsAndFeelings across the matching connection */
  notTriedToAlterMyThoughtsAndFeelings?: Maybe<Scalars['BigInt']>;
  /** Distinct count of plannedHowToProceed across the matching connection */
  plannedHowToProceed?: Maybe<Scalars['BigInt']>;
  /** Distinct count of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['BigInt']>;
  /** Distinct count of rumination across the matching connection */
  rumination?: Maybe<Scalars['BigInt']>;
  /** Distinct count of sad across the matching connection */
  sad?: Maybe<Scalars['BigInt']>;
  /** Distinct count of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['BigInt']>;
  /** Distinct count of scheduledAt across the matching connection */
  scheduledAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of startedAt across the matching connection */
  startedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of subjectId across the matching connection */
  subjectId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['BigInt']>;
  /** Distinct count of testy across the matching connection */
  testy?: Maybe<Scalars['BigInt']>;
  /** Distinct count of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['BigInt']>;
  /** Distinct count of thoughtALotAboutMyThoughtsAndFeelings across the matching connection */
  thoughtALotAboutMyThoughtsAndFeelings?: Maybe<Scalars['BigInt']>;
  /** Distinct count of triedToAcceptMyThoughtsAndFeelings across the matching connection */
  triedToAcceptMyThoughtsAndFeelings?: Maybe<Scalars['BigInt']>;
  /** Distinct count of triedToCalmMyselfDown across the matching connection */
  triedToCalmMyselfDown?: Maybe<Scalars['BigInt']>;
  /** Distinct count of triedToChangeMyPerspective across the matching connection */
  triedToChangeMyPerspective?: Maybe<Scalars['BigInt']>;
  /** Distinct count of triedToDistractMyselfFromMyThoughtsAndFeelings across the matching connection */
  triedToDistractMyselfFromMyThoughtsAndFeelings?: Maybe<Scalars['BigInt']>;
  /** Distinct count of triedToHideMyThoughtsAndFeelings across the matching connection */
  triedToHideMyThoughtsAndFeelings?: Maybe<Scalars['BigInt']>;
  /** Distinct count of triedToRepressMyThoughtsAndFeelings across the matching connection */
  triedToRepressMyThoughtsAndFeelings?: Maybe<Scalars['BigInt']>;
  /** Distinct count of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['BigInt']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of this field across the matching connection. */
  updatedAtUtc?: Maybe<Scalars['BigInt']>;
  /** Distinct count of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `EmaEntries2` object types. All fields are combined with a logical ‘and.’ */
export type EmaEntries2Filter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EmaEntries2Filter>>;
  /** Filter by the object’s `angry` field. */
  angry?: InputMaybe<IntFilter>;
  /** Filter by the object’s `anxious` field. */
  anxious?: InputMaybe<IntFilter>;
  /** Filter by the object’s `anxiousDuringContact` field. */
  anxiousDuringContact?: InputMaybe<IntFilter>;
  /** Filter by the object’s `avoidedSocialContact` field. */
  avoidedSocialContact?: InputMaybe<IntFilter>;
  /** Filter by the object’s `burden` field. */
  burden?: InputMaybe<IntFilter>;
  /** Filter by the object’s `comfortableDuringContact` field. */
  comfortableDuringContact?: InputMaybe<IntFilter>;
  /** Filter by the object’s `completedAt` field. */
  completedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deleted` field. */
  deleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `guilty` field. */
  guilty?: InputMaybe<IntFilter>;
  /** Filter by the object’s `hadAnyContactWithOthersSinceTheLastSurvey` field. */
  hadAnyContactWithOthersSinceTheLastSurvey?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `happy` field. */
  happy?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `lackOfSocialContactBothersMe` field. */
  lackOfSocialContactBothersMe?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lonely` field. */
  lonely?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lookedForAdviceAndComfortFromOthers` field. */
  lookedForAdviceAndComfortFromOthers?: InputMaybe<IntFilter>;
  /** Filter by the object’s `noSocialContactDueToOuterConditions` field. */
  noSocialContactDueToOuterConditions?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EmaEntries2Filter>;
  /** Filter by the object’s `notTriedToAlterMyThoughtsAndFeelings` field. */
  notTriedToAlterMyThoughtsAndFeelings?: InputMaybe<IntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EmaEntries2Filter>>;
  /** Filter by the object’s `plannedHowToProceed` field. */
  plannedHowToProceed?: InputMaybe<IntFilter>;
  /** Filter by the object’s `relaxed` field. */
  relaxed?: InputMaybe<IntFilter>;
  /** Filter by the object’s `rumination` field. */
  rumination?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sad` field. */
  sad?: InputMaybe<IntFilter>;
  /** Filter by the object’s `satisfied` field. */
  satisfied?: InputMaybe<IntFilter>;
  /** Filter by the object’s `scheduledAt` field. */
  scheduledAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `startedAt` field. */
  startedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `subject` relation. */
  subject?: InputMaybe<UserFilter>;
  /** Filter by the object’s `subjectId` field. */
  subjectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tenseDuringContact` field. */
  tenseDuringContact?: InputMaybe<IntFilter>;
  /** Filter by the object’s `testy` field. */
  testy?: InputMaybe<IntFilter>;
  /** Filter by the object’s `testyDuringContact` field. */
  testyDuringContact?: InputMaybe<IntFilter>;
  /** Filter by the object’s `thoughtALotAboutMyThoughtsAndFeelings` field. */
  thoughtALotAboutMyThoughtsAndFeelings?: InputMaybe<IntFilter>;
  /** Filter by the object’s `triedToAcceptMyThoughtsAndFeelings` field. */
  triedToAcceptMyThoughtsAndFeelings?: InputMaybe<IntFilter>;
  /** Filter by the object’s `triedToCalmMyselfDown` field. */
  triedToCalmMyselfDown?: InputMaybe<IntFilter>;
  /** Filter by the object’s `triedToChangeMyPerspective` field. */
  triedToChangeMyPerspective?: InputMaybe<IntFilter>;
  /** Filter by the object’s `triedToDistractMyselfFromMyThoughtsAndFeelings` field. */
  triedToDistractMyselfFromMyThoughtsAndFeelings?: InputMaybe<IntFilter>;
  /** Filter by the object’s `triedToHideMyThoughtsAndFeelings` field. */
  triedToHideMyThoughtsAndFeelings?: InputMaybe<IntFilter>;
  /** Filter by the object’s `triedToRepressMyThoughtsAndFeelings` field. */
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<IntFilter>;
  /** Filter by the object’s `unconfidentDuringContact` field. */
  unconfidentDuringContact?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAtUtc` field. */
  updatedAtUtc?: InputMaybe<StringFilter>;
  /** Filter by the object’s `wouldHaveLikedSocialContact` field. */
  wouldHaveLikedSocialContact?: InputMaybe<IntFilter>;
};

/** Grouping methods for `EmaEntries2` for usage during aggregation. */
export type EmaEntries2GroupBy =
  | 'ANGRY'
  | 'ANXIOUS'
  | 'ANXIOUS_DURING_CONTACT'
  | 'AVOIDED_SOCIAL_CONTACT'
  | 'BURDEN'
  | 'COMFORTABLE_DURING_CONTACT'
  | 'COMPLETED_AT'
  | 'COMPLETED_AT_TRUNCATED_TO_DAY'
  | 'COMPLETED_AT_TRUNCATED_TO_HOUR'
  | 'CREATED_AT'
  | 'CREATED_AT_TRUNCATED_TO_DAY'
  | 'CREATED_AT_TRUNCATED_TO_HOUR'
  | 'DELETED'
  | 'GUILTY'
  | 'HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY'
  | 'HAPPY'
  | 'LACK_OF_SOCIAL_CONTACT_BOTHERS_ME'
  | 'LONELY'
  | 'LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS'
  | 'NOT_TRIED_TO_ALTER_MY_THOUGHTS_AND_FEELINGS'
  | 'NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS'
  | 'PLANNED_HOW_TO_PROCEED'
  | 'RELAXED'
  | 'RUMINATION'
  | 'SAD'
  | 'SATISFIED'
  | 'SCHEDULED_AT'
  | 'SCHEDULED_AT_TRUNCATED_TO_DAY'
  | 'SCHEDULED_AT_TRUNCATED_TO_HOUR'
  | 'STARTED_AT'
  | 'STARTED_AT_TRUNCATED_TO_DAY'
  | 'STARTED_AT_TRUNCATED_TO_HOUR'
  | 'SUBJECT_ID'
  | 'TENSE_DURING_CONTACT'
  | 'TESTY'
  | 'TESTY_DURING_CONTACT'
  | 'THOUGHT_A_LOT_ABOUT_MY_THOUGHTS_AND_FEELINGS'
  | 'TRIED_TO_ACCEPT_MY_THOUGHTS_AND_FEELINGS'
  | 'TRIED_TO_CALM_MYSELF_DOWN'
  | 'TRIED_TO_CHANGE_MY_PERSPECTIVE'
  | 'TRIED_TO_DISTRACT_MYSELF_FROM_MY_THOUGHTS_AND_FEELINGS'
  | 'TRIED_TO_HIDE_MY_THOUGHTS_AND_FEELINGS'
  | 'TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS'
  | 'UNCONFIDENT_DURING_CONTACT'
  | 'UPDATED_AT'
  | 'UPDATED_AT_TRUNCATED_TO_DAY'
  | 'UPDATED_AT_TRUNCATED_TO_HOUR'
  | 'WOULD_HAVE_LIKED_SOCIAL_CONTACT';

export type EmaEntries2HavingAverageInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  burden?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<HavingIntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<HavingIntFilter>;
  notTriedToAlterMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  plannedHowToProceed?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  rumination?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  thoughtALotAboutMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToAcceptMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToCalmMyselfDown?: InputMaybe<HavingIntFilter>;
  triedToChangeMyPerspective?: InputMaybe<HavingIntFilter>;
  triedToDistractMyselfFromMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToHideMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

export type EmaEntries2HavingDistinctCountInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  burden?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<HavingIntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<HavingIntFilter>;
  notTriedToAlterMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  plannedHowToProceed?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  rumination?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  thoughtALotAboutMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToAcceptMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToCalmMyselfDown?: InputMaybe<HavingIntFilter>;
  triedToChangeMyPerspective?: InputMaybe<HavingIntFilter>;
  triedToDistractMyselfFromMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToHideMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `EmaEntries2` aggregates. */
export type EmaEntries2HavingInput = {
  AND?: InputMaybe<Array<EmaEntries2HavingInput>>;
  OR?: InputMaybe<Array<EmaEntries2HavingInput>>;
  average?: InputMaybe<EmaEntries2HavingAverageInput>;
  distinctCount?: InputMaybe<EmaEntries2HavingDistinctCountInput>;
  max?: InputMaybe<EmaEntries2HavingMaxInput>;
  min?: InputMaybe<EmaEntries2HavingMinInput>;
  stddevPopulation?: InputMaybe<EmaEntries2HavingStddevPopulationInput>;
  stddevSample?: InputMaybe<EmaEntries2HavingStddevSampleInput>;
  sum?: InputMaybe<EmaEntries2HavingSumInput>;
  variancePopulation?: InputMaybe<EmaEntries2HavingVariancePopulationInput>;
  varianceSample?: InputMaybe<EmaEntries2HavingVarianceSampleInput>;
};

export type EmaEntries2HavingMaxInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  burden?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<HavingIntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<HavingIntFilter>;
  notTriedToAlterMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  plannedHowToProceed?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  rumination?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  thoughtALotAboutMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToAcceptMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToCalmMyselfDown?: InputMaybe<HavingIntFilter>;
  triedToChangeMyPerspective?: InputMaybe<HavingIntFilter>;
  triedToDistractMyselfFromMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToHideMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

export type EmaEntries2HavingMinInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  burden?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<HavingIntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<HavingIntFilter>;
  notTriedToAlterMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  plannedHowToProceed?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  rumination?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  thoughtALotAboutMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToAcceptMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToCalmMyselfDown?: InputMaybe<HavingIntFilter>;
  triedToChangeMyPerspective?: InputMaybe<HavingIntFilter>;
  triedToDistractMyselfFromMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToHideMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

export type EmaEntries2HavingStddevPopulationInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  burden?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<HavingIntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<HavingIntFilter>;
  notTriedToAlterMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  plannedHowToProceed?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  rumination?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  thoughtALotAboutMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToAcceptMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToCalmMyselfDown?: InputMaybe<HavingIntFilter>;
  triedToChangeMyPerspective?: InputMaybe<HavingIntFilter>;
  triedToDistractMyselfFromMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToHideMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

export type EmaEntries2HavingStddevSampleInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  burden?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<HavingIntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<HavingIntFilter>;
  notTriedToAlterMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  plannedHowToProceed?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  rumination?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  thoughtALotAboutMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToAcceptMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToCalmMyselfDown?: InputMaybe<HavingIntFilter>;
  triedToChangeMyPerspective?: InputMaybe<HavingIntFilter>;
  triedToDistractMyselfFromMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToHideMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

export type EmaEntries2HavingSumInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  burden?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<HavingIntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<HavingIntFilter>;
  notTriedToAlterMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  plannedHowToProceed?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  rumination?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  thoughtALotAboutMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToAcceptMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToCalmMyselfDown?: InputMaybe<HavingIntFilter>;
  triedToChangeMyPerspective?: InputMaybe<HavingIntFilter>;
  triedToDistractMyselfFromMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToHideMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

export type EmaEntries2HavingVariancePopulationInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  burden?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<HavingIntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<HavingIntFilter>;
  notTriedToAlterMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  plannedHowToProceed?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  rumination?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  thoughtALotAboutMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToAcceptMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToCalmMyselfDown?: InputMaybe<HavingIntFilter>;
  triedToChangeMyPerspective?: InputMaybe<HavingIntFilter>;
  triedToDistractMyselfFromMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToHideMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

export type EmaEntries2HavingVarianceSampleInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  burden?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<HavingIntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<HavingIntFilter>;
  notTriedToAlterMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  plannedHowToProceed?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  rumination?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  thoughtALotAboutMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToAcceptMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToCalmMyselfDown?: InputMaybe<HavingIntFilter>;
  triedToChangeMyPerspective?: InputMaybe<HavingIntFilter>;
  triedToDistractMyselfFromMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToHideMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

/** An input for mutations affecting `EmaEntries2` */
export type EmaEntries2Input = {
  angry?: InputMaybe<Scalars['Int']>;
  anxious?: InputMaybe<Scalars['Int']>;
  anxiousDuringContact?: InputMaybe<Scalars['Int']>;
  avoidedSocialContact?: InputMaybe<Scalars['Int']>;
  burden?: InputMaybe<Scalars['Int']>;
  comfortableDuringContact?: InputMaybe<Scalars['Int']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  guilty?: InputMaybe<Scalars['Int']>;
  hadAnyContactWithOthersSinceTheLastSurvey?: InputMaybe<Scalars['Boolean']>;
  happy?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  lackOfSocialContactBothersMe?: InputMaybe<Scalars['Int']>;
  lonely?: InputMaybe<Scalars['Int']>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<Scalars['Int']>;
  noSocialContactDueToOuterConditions?: InputMaybe<Scalars['Int']>;
  notTriedToAlterMyThoughtsAndFeelings?: InputMaybe<Scalars['Int']>;
  plannedHowToProceed?: InputMaybe<Scalars['Int']>;
  relaxed?: InputMaybe<Scalars['Int']>;
  rumination?: InputMaybe<Scalars['Int']>;
  sad?: InputMaybe<Scalars['Int']>;
  satisfied?: InputMaybe<Scalars['Int']>;
  scheduledAt: Scalars['Datetime'];
  startedAt?: InputMaybe<Scalars['Datetime']>;
  subjectId?: InputMaybe<Scalars['UUID']>;
  tenseDuringContact?: InputMaybe<Scalars['Int']>;
  testy?: InputMaybe<Scalars['Int']>;
  testyDuringContact?: InputMaybe<Scalars['Int']>;
  thoughtALotAboutMyThoughtsAndFeelings?: InputMaybe<Scalars['Int']>;
  triedToAcceptMyThoughtsAndFeelings?: InputMaybe<Scalars['Int']>;
  triedToCalmMyselfDown?: InputMaybe<Scalars['Int']>;
  triedToChangeMyPerspective?: InputMaybe<Scalars['Int']>;
  triedToDistractMyselfFromMyThoughtsAndFeelings?: InputMaybe<Scalars['Int']>;
  triedToHideMyThoughtsAndFeelings?: InputMaybe<Scalars['Int']>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<Scalars['Int']>;
  unconfidentDuringContact?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  wouldHaveLikedSocialContact?: InputMaybe<Scalars['Int']>;
};

export type EmaEntries2MaxAggregateFilter = {
  angry?: InputMaybe<IntFilter>;
  anxious?: InputMaybe<IntFilter>;
  anxiousDuringContact?: InputMaybe<IntFilter>;
  avoidedSocialContact?: InputMaybe<IntFilter>;
  burden?: InputMaybe<IntFilter>;
  comfortableDuringContact?: InputMaybe<IntFilter>;
  guilty?: InputMaybe<IntFilter>;
  happy?: InputMaybe<IntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<IntFilter>;
  lonely?: InputMaybe<IntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<IntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<IntFilter>;
  notTriedToAlterMyThoughtsAndFeelings?: InputMaybe<IntFilter>;
  plannedHowToProceed?: InputMaybe<IntFilter>;
  relaxed?: InputMaybe<IntFilter>;
  rumination?: InputMaybe<IntFilter>;
  sad?: InputMaybe<IntFilter>;
  satisfied?: InputMaybe<IntFilter>;
  tenseDuringContact?: InputMaybe<IntFilter>;
  testy?: InputMaybe<IntFilter>;
  testyDuringContact?: InputMaybe<IntFilter>;
  thoughtALotAboutMyThoughtsAndFeelings?: InputMaybe<IntFilter>;
  triedToAcceptMyThoughtsAndFeelings?: InputMaybe<IntFilter>;
  triedToCalmMyselfDown?: InputMaybe<IntFilter>;
  triedToChangeMyPerspective?: InputMaybe<IntFilter>;
  triedToDistractMyselfFromMyThoughtsAndFeelings?: InputMaybe<IntFilter>;
  triedToHideMyThoughtsAndFeelings?: InputMaybe<IntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<IntFilter>;
  unconfidentDuringContact?: InputMaybe<IntFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<IntFilter>;
};

export type EmaEntries2MaxAggregates = {
  __typename?: 'EmaEntries2MaxAggregates';
  /** Maximum of angry across the matching connection */
  angry?: Maybe<Scalars['Int']>;
  /** Maximum of anxious across the matching connection */
  anxious?: Maybe<Scalars['Int']>;
  /** Maximum of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['Int']>;
  /** Maximum of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['Int']>;
  /** Maximum of burden across the matching connection */
  burden?: Maybe<Scalars['Int']>;
  /** Maximum of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['Int']>;
  /** Maximum of guilty across the matching connection */
  guilty?: Maybe<Scalars['Int']>;
  /** Maximum of happy across the matching connection */
  happy?: Maybe<Scalars['Int']>;
  /** Maximum of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['Int']>;
  /** Maximum of lonely across the matching connection */
  lonely?: Maybe<Scalars['Int']>;
  /** Maximum of lookedForAdviceAndComfortFromOthers across the matching connection */
  lookedForAdviceAndComfortFromOthers?: Maybe<Scalars['Int']>;
  /** Maximum of noSocialContactDueToOuterConditions across the matching connection */
  noSocialContactDueToOuterConditions?: Maybe<Scalars['Int']>;
  /** Maximum of notTriedToAlterMyThoughtsAndFeelings across the matching connection */
  notTriedToAlterMyThoughtsAndFeelings?: Maybe<Scalars['Int']>;
  /** Maximum of plannedHowToProceed across the matching connection */
  plannedHowToProceed?: Maybe<Scalars['Int']>;
  /** Maximum of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['Int']>;
  /** Maximum of rumination across the matching connection */
  rumination?: Maybe<Scalars['Int']>;
  /** Maximum of sad across the matching connection */
  sad?: Maybe<Scalars['Int']>;
  /** Maximum of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['Int']>;
  /** Maximum of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['Int']>;
  /** Maximum of testy across the matching connection */
  testy?: Maybe<Scalars['Int']>;
  /** Maximum of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['Int']>;
  /** Maximum of thoughtALotAboutMyThoughtsAndFeelings across the matching connection */
  thoughtALotAboutMyThoughtsAndFeelings?: Maybe<Scalars['Int']>;
  /** Maximum of triedToAcceptMyThoughtsAndFeelings across the matching connection */
  triedToAcceptMyThoughtsAndFeelings?: Maybe<Scalars['Int']>;
  /** Maximum of triedToCalmMyselfDown across the matching connection */
  triedToCalmMyselfDown?: Maybe<Scalars['Int']>;
  /** Maximum of triedToChangeMyPerspective across the matching connection */
  triedToChangeMyPerspective?: Maybe<Scalars['Int']>;
  /** Maximum of triedToDistractMyselfFromMyThoughtsAndFeelings across the matching connection */
  triedToDistractMyselfFromMyThoughtsAndFeelings?: Maybe<Scalars['Int']>;
  /** Maximum of triedToHideMyThoughtsAndFeelings across the matching connection */
  triedToHideMyThoughtsAndFeelings?: Maybe<Scalars['Int']>;
  /** Maximum of triedToRepressMyThoughtsAndFeelings across the matching connection */
  triedToRepressMyThoughtsAndFeelings?: Maybe<Scalars['Int']>;
  /** Maximum of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['Int']>;
  /** Maximum of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['Int']>;
};

export type EmaEntries2MinAggregateFilter = {
  angry?: InputMaybe<IntFilter>;
  anxious?: InputMaybe<IntFilter>;
  anxiousDuringContact?: InputMaybe<IntFilter>;
  avoidedSocialContact?: InputMaybe<IntFilter>;
  burden?: InputMaybe<IntFilter>;
  comfortableDuringContact?: InputMaybe<IntFilter>;
  guilty?: InputMaybe<IntFilter>;
  happy?: InputMaybe<IntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<IntFilter>;
  lonely?: InputMaybe<IntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<IntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<IntFilter>;
  notTriedToAlterMyThoughtsAndFeelings?: InputMaybe<IntFilter>;
  plannedHowToProceed?: InputMaybe<IntFilter>;
  relaxed?: InputMaybe<IntFilter>;
  rumination?: InputMaybe<IntFilter>;
  sad?: InputMaybe<IntFilter>;
  satisfied?: InputMaybe<IntFilter>;
  tenseDuringContact?: InputMaybe<IntFilter>;
  testy?: InputMaybe<IntFilter>;
  testyDuringContact?: InputMaybe<IntFilter>;
  thoughtALotAboutMyThoughtsAndFeelings?: InputMaybe<IntFilter>;
  triedToAcceptMyThoughtsAndFeelings?: InputMaybe<IntFilter>;
  triedToCalmMyselfDown?: InputMaybe<IntFilter>;
  triedToChangeMyPerspective?: InputMaybe<IntFilter>;
  triedToDistractMyselfFromMyThoughtsAndFeelings?: InputMaybe<IntFilter>;
  triedToHideMyThoughtsAndFeelings?: InputMaybe<IntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<IntFilter>;
  unconfidentDuringContact?: InputMaybe<IntFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<IntFilter>;
};

export type EmaEntries2MinAggregates = {
  __typename?: 'EmaEntries2MinAggregates';
  /** Minimum of angry across the matching connection */
  angry?: Maybe<Scalars['Int']>;
  /** Minimum of anxious across the matching connection */
  anxious?: Maybe<Scalars['Int']>;
  /** Minimum of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['Int']>;
  /** Minimum of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['Int']>;
  /** Minimum of burden across the matching connection */
  burden?: Maybe<Scalars['Int']>;
  /** Minimum of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['Int']>;
  /** Minimum of guilty across the matching connection */
  guilty?: Maybe<Scalars['Int']>;
  /** Minimum of happy across the matching connection */
  happy?: Maybe<Scalars['Int']>;
  /** Minimum of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['Int']>;
  /** Minimum of lonely across the matching connection */
  lonely?: Maybe<Scalars['Int']>;
  /** Minimum of lookedForAdviceAndComfortFromOthers across the matching connection */
  lookedForAdviceAndComfortFromOthers?: Maybe<Scalars['Int']>;
  /** Minimum of noSocialContactDueToOuterConditions across the matching connection */
  noSocialContactDueToOuterConditions?: Maybe<Scalars['Int']>;
  /** Minimum of notTriedToAlterMyThoughtsAndFeelings across the matching connection */
  notTriedToAlterMyThoughtsAndFeelings?: Maybe<Scalars['Int']>;
  /** Minimum of plannedHowToProceed across the matching connection */
  plannedHowToProceed?: Maybe<Scalars['Int']>;
  /** Minimum of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['Int']>;
  /** Minimum of rumination across the matching connection */
  rumination?: Maybe<Scalars['Int']>;
  /** Minimum of sad across the matching connection */
  sad?: Maybe<Scalars['Int']>;
  /** Minimum of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['Int']>;
  /** Minimum of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['Int']>;
  /** Minimum of testy across the matching connection */
  testy?: Maybe<Scalars['Int']>;
  /** Minimum of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['Int']>;
  /** Minimum of thoughtALotAboutMyThoughtsAndFeelings across the matching connection */
  thoughtALotAboutMyThoughtsAndFeelings?: Maybe<Scalars['Int']>;
  /** Minimum of triedToAcceptMyThoughtsAndFeelings across the matching connection */
  triedToAcceptMyThoughtsAndFeelings?: Maybe<Scalars['Int']>;
  /** Minimum of triedToCalmMyselfDown across the matching connection */
  triedToCalmMyselfDown?: Maybe<Scalars['Int']>;
  /** Minimum of triedToChangeMyPerspective across the matching connection */
  triedToChangeMyPerspective?: Maybe<Scalars['Int']>;
  /** Minimum of triedToDistractMyselfFromMyThoughtsAndFeelings across the matching connection */
  triedToDistractMyselfFromMyThoughtsAndFeelings?: Maybe<Scalars['Int']>;
  /** Minimum of triedToHideMyThoughtsAndFeelings across the matching connection */
  triedToHideMyThoughtsAndFeelings?: Maybe<Scalars['Int']>;
  /** Minimum of triedToRepressMyThoughtsAndFeelings across the matching connection */
  triedToRepressMyThoughtsAndFeelings?: Maybe<Scalars['Int']>;
  /** Minimum of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['Int']>;
  /** Minimum of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['Int']>;
};

/** Represents an update to a `EmaEntries2`. Fields that are set will be updated. */
export type EmaEntries2Patch = {
  angry?: InputMaybe<Scalars['Int']>;
  anxious?: InputMaybe<Scalars['Int']>;
  anxiousDuringContact?: InputMaybe<Scalars['Int']>;
  avoidedSocialContact?: InputMaybe<Scalars['Int']>;
  burden?: InputMaybe<Scalars['Int']>;
  comfortableDuringContact?: InputMaybe<Scalars['Int']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  guilty?: InputMaybe<Scalars['Int']>;
  hadAnyContactWithOthersSinceTheLastSurvey?: InputMaybe<Scalars['Boolean']>;
  happy?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  lackOfSocialContactBothersMe?: InputMaybe<Scalars['Int']>;
  lonely?: InputMaybe<Scalars['Int']>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<Scalars['Int']>;
  noSocialContactDueToOuterConditions?: InputMaybe<Scalars['Int']>;
  notTriedToAlterMyThoughtsAndFeelings?: InputMaybe<Scalars['Int']>;
  plannedHowToProceed?: InputMaybe<Scalars['Int']>;
  relaxed?: InputMaybe<Scalars['Int']>;
  rumination?: InputMaybe<Scalars['Int']>;
  sad?: InputMaybe<Scalars['Int']>;
  satisfied?: InputMaybe<Scalars['Int']>;
  scheduledAt?: InputMaybe<Scalars['Datetime']>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  subjectId?: InputMaybe<Scalars['UUID']>;
  tenseDuringContact?: InputMaybe<Scalars['Int']>;
  testy?: InputMaybe<Scalars['Int']>;
  testyDuringContact?: InputMaybe<Scalars['Int']>;
  thoughtALotAboutMyThoughtsAndFeelings?: InputMaybe<Scalars['Int']>;
  triedToAcceptMyThoughtsAndFeelings?: InputMaybe<Scalars['Int']>;
  triedToCalmMyselfDown?: InputMaybe<Scalars['Int']>;
  triedToChangeMyPerspective?: InputMaybe<Scalars['Int']>;
  triedToDistractMyselfFromMyThoughtsAndFeelings?: InputMaybe<Scalars['Int']>;
  triedToHideMyThoughtsAndFeelings?: InputMaybe<Scalars['Int']>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<Scalars['Int']>;
  unconfidentDuringContact?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  wouldHaveLikedSocialContact?: InputMaybe<Scalars['Int']>;
};

export type EmaEntries2StddevPopulationAggregateFilter = {
  angry?: InputMaybe<BigFloatFilter>;
  anxious?: InputMaybe<BigFloatFilter>;
  anxiousDuringContact?: InputMaybe<BigFloatFilter>;
  avoidedSocialContact?: InputMaybe<BigFloatFilter>;
  burden?: InputMaybe<BigFloatFilter>;
  comfortableDuringContact?: InputMaybe<BigFloatFilter>;
  guilty?: InputMaybe<BigFloatFilter>;
  happy?: InputMaybe<BigFloatFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<BigFloatFilter>;
  lonely?: InputMaybe<BigFloatFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<BigFloatFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<BigFloatFilter>;
  notTriedToAlterMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  plannedHowToProceed?: InputMaybe<BigFloatFilter>;
  relaxed?: InputMaybe<BigFloatFilter>;
  rumination?: InputMaybe<BigFloatFilter>;
  sad?: InputMaybe<BigFloatFilter>;
  satisfied?: InputMaybe<BigFloatFilter>;
  tenseDuringContact?: InputMaybe<BigFloatFilter>;
  testy?: InputMaybe<BigFloatFilter>;
  testyDuringContact?: InputMaybe<BigFloatFilter>;
  thoughtALotAboutMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToAcceptMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToCalmMyselfDown?: InputMaybe<BigFloatFilter>;
  triedToChangeMyPerspective?: InputMaybe<BigFloatFilter>;
  triedToDistractMyselfFromMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToHideMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  unconfidentDuringContact?: InputMaybe<BigFloatFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<BigFloatFilter>;
};

export type EmaEntries2StddevPopulationAggregates = {
  __typename?: 'EmaEntries2StddevPopulationAggregates';
  /** Population standard deviation of angry across the matching connection */
  angry?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of anxious across the matching connection */
  anxious?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of burden across the matching connection */
  burden?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of guilty across the matching connection */
  guilty?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of happy across the matching connection */
  happy?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of lonely across the matching connection */
  lonely?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of lookedForAdviceAndComfortFromOthers across the matching connection */
  lookedForAdviceAndComfortFromOthers?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of noSocialContactDueToOuterConditions across the matching connection */
  noSocialContactDueToOuterConditions?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of notTriedToAlterMyThoughtsAndFeelings across the matching connection */
  notTriedToAlterMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of plannedHowToProceed across the matching connection */
  plannedHowToProceed?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of rumination across the matching connection */
  rumination?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of sad across the matching connection */
  sad?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of testy across the matching connection */
  testy?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of thoughtALotAboutMyThoughtsAndFeelings across the matching connection */
  thoughtALotAboutMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of triedToAcceptMyThoughtsAndFeelings across the matching connection */
  triedToAcceptMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of triedToCalmMyselfDown across the matching connection */
  triedToCalmMyselfDown?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of triedToChangeMyPerspective across the matching connection */
  triedToChangeMyPerspective?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of triedToDistractMyselfFromMyThoughtsAndFeelings across the matching connection */
  triedToDistractMyselfFromMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of triedToHideMyThoughtsAndFeelings across the matching connection */
  triedToHideMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of triedToRepressMyThoughtsAndFeelings across the matching connection */
  triedToRepressMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['BigFloat']>;
};

export type EmaEntries2StddevSampleAggregateFilter = {
  angry?: InputMaybe<BigFloatFilter>;
  anxious?: InputMaybe<BigFloatFilter>;
  anxiousDuringContact?: InputMaybe<BigFloatFilter>;
  avoidedSocialContact?: InputMaybe<BigFloatFilter>;
  burden?: InputMaybe<BigFloatFilter>;
  comfortableDuringContact?: InputMaybe<BigFloatFilter>;
  guilty?: InputMaybe<BigFloatFilter>;
  happy?: InputMaybe<BigFloatFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<BigFloatFilter>;
  lonely?: InputMaybe<BigFloatFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<BigFloatFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<BigFloatFilter>;
  notTriedToAlterMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  plannedHowToProceed?: InputMaybe<BigFloatFilter>;
  relaxed?: InputMaybe<BigFloatFilter>;
  rumination?: InputMaybe<BigFloatFilter>;
  sad?: InputMaybe<BigFloatFilter>;
  satisfied?: InputMaybe<BigFloatFilter>;
  tenseDuringContact?: InputMaybe<BigFloatFilter>;
  testy?: InputMaybe<BigFloatFilter>;
  testyDuringContact?: InputMaybe<BigFloatFilter>;
  thoughtALotAboutMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToAcceptMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToCalmMyselfDown?: InputMaybe<BigFloatFilter>;
  triedToChangeMyPerspective?: InputMaybe<BigFloatFilter>;
  triedToDistractMyselfFromMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToHideMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  unconfidentDuringContact?: InputMaybe<BigFloatFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<BigFloatFilter>;
};

export type EmaEntries2StddevSampleAggregates = {
  __typename?: 'EmaEntries2StddevSampleAggregates';
  /** Sample standard deviation of angry across the matching connection */
  angry?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of anxious across the matching connection */
  anxious?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of burden across the matching connection */
  burden?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of guilty across the matching connection */
  guilty?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of happy across the matching connection */
  happy?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of lonely across the matching connection */
  lonely?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of lookedForAdviceAndComfortFromOthers across the matching connection */
  lookedForAdviceAndComfortFromOthers?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of noSocialContactDueToOuterConditions across the matching connection */
  noSocialContactDueToOuterConditions?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of notTriedToAlterMyThoughtsAndFeelings across the matching connection */
  notTriedToAlterMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of plannedHowToProceed across the matching connection */
  plannedHowToProceed?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of rumination across the matching connection */
  rumination?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of sad across the matching connection */
  sad?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of testy across the matching connection */
  testy?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of thoughtALotAboutMyThoughtsAndFeelings across the matching connection */
  thoughtALotAboutMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of triedToAcceptMyThoughtsAndFeelings across the matching connection */
  triedToAcceptMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of triedToCalmMyselfDown across the matching connection */
  triedToCalmMyselfDown?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of triedToChangeMyPerspective across the matching connection */
  triedToChangeMyPerspective?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of triedToDistractMyselfFromMyThoughtsAndFeelings across the matching connection */
  triedToDistractMyselfFromMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of triedToHideMyThoughtsAndFeelings across the matching connection */
  triedToHideMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of triedToRepressMyThoughtsAndFeelings across the matching connection */
  triedToRepressMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['BigFloat']>;
};

export type EmaEntries2SumAggregateFilter = {
  angry?: InputMaybe<BigIntFilter>;
  anxious?: InputMaybe<BigIntFilter>;
  anxiousDuringContact?: InputMaybe<BigIntFilter>;
  avoidedSocialContact?: InputMaybe<BigIntFilter>;
  burden?: InputMaybe<BigIntFilter>;
  comfortableDuringContact?: InputMaybe<BigIntFilter>;
  guilty?: InputMaybe<BigIntFilter>;
  happy?: InputMaybe<BigIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<BigIntFilter>;
  lonely?: InputMaybe<BigIntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<BigIntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<BigIntFilter>;
  notTriedToAlterMyThoughtsAndFeelings?: InputMaybe<BigIntFilter>;
  plannedHowToProceed?: InputMaybe<BigIntFilter>;
  relaxed?: InputMaybe<BigIntFilter>;
  rumination?: InputMaybe<BigIntFilter>;
  sad?: InputMaybe<BigIntFilter>;
  satisfied?: InputMaybe<BigIntFilter>;
  tenseDuringContact?: InputMaybe<BigIntFilter>;
  testy?: InputMaybe<BigIntFilter>;
  testyDuringContact?: InputMaybe<BigIntFilter>;
  thoughtALotAboutMyThoughtsAndFeelings?: InputMaybe<BigIntFilter>;
  triedToAcceptMyThoughtsAndFeelings?: InputMaybe<BigIntFilter>;
  triedToCalmMyselfDown?: InputMaybe<BigIntFilter>;
  triedToChangeMyPerspective?: InputMaybe<BigIntFilter>;
  triedToDistractMyselfFromMyThoughtsAndFeelings?: InputMaybe<BigIntFilter>;
  triedToHideMyThoughtsAndFeelings?: InputMaybe<BigIntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<BigIntFilter>;
  unconfidentDuringContact?: InputMaybe<BigIntFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<BigIntFilter>;
};

export type EmaEntries2SumAggregates = {
  __typename?: 'EmaEntries2SumAggregates';
  /** Sum of angry across the matching connection */
  angry: Scalars['BigInt'];
  /** Sum of anxious across the matching connection */
  anxious: Scalars['BigInt'];
  /** Sum of anxiousDuringContact across the matching connection */
  anxiousDuringContact: Scalars['BigInt'];
  /** Sum of avoidedSocialContact across the matching connection */
  avoidedSocialContact: Scalars['BigInt'];
  /** Sum of burden across the matching connection */
  burden: Scalars['BigInt'];
  /** Sum of comfortableDuringContact across the matching connection */
  comfortableDuringContact: Scalars['BigInt'];
  /** Sum of guilty across the matching connection */
  guilty: Scalars['BigInt'];
  /** Sum of happy across the matching connection */
  happy: Scalars['BigInt'];
  /** Sum of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe: Scalars['BigInt'];
  /** Sum of lonely across the matching connection */
  lonely: Scalars['BigInt'];
  /** Sum of lookedForAdviceAndComfortFromOthers across the matching connection */
  lookedForAdviceAndComfortFromOthers: Scalars['BigInt'];
  /** Sum of noSocialContactDueToOuterConditions across the matching connection */
  noSocialContactDueToOuterConditions: Scalars['BigInt'];
  /** Sum of notTriedToAlterMyThoughtsAndFeelings across the matching connection */
  notTriedToAlterMyThoughtsAndFeelings: Scalars['BigInt'];
  /** Sum of plannedHowToProceed across the matching connection */
  plannedHowToProceed: Scalars['BigInt'];
  /** Sum of relaxed across the matching connection */
  relaxed: Scalars['BigInt'];
  /** Sum of rumination across the matching connection */
  rumination: Scalars['BigInt'];
  /** Sum of sad across the matching connection */
  sad: Scalars['BigInt'];
  /** Sum of satisfied across the matching connection */
  satisfied: Scalars['BigInt'];
  /** Sum of tenseDuringContact across the matching connection */
  tenseDuringContact: Scalars['BigInt'];
  /** Sum of testy across the matching connection */
  testy: Scalars['BigInt'];
  /** Sum of testyDuringContact across the matching connection */
  testyDuringContact: Scalars['BigInt'];
  /** Sum of thoughtALotAboutMyThoughtsAndFeelings across the matching connection */
  thoughtALotAboutMyThoughtsAndFeelings: Scalars['BigInt'];
  /** Sum of triedToAcceptMyThoughtsAndFeelings across the matching connection */
  triedToAcceptMyThoughtsAndFeelings: Scalars['BigInt'];
  /** Sum of triedToCalmMyselfDown across the matching connection */
  triedToCalmMyselfDown: Scalars['BigInt'];
  /** Sum of triedToChangeMyPerspective across the matching connection */
  triedToChangeMyPerspective: Scalars['BigInt'];
  /** Sum of triedToDistractMyselfFromMyThoughtsAndFeelings across the matching connection */
  triedToDistractMyselfFromMyThoughtsAndFeelings: Scalars['BigInt'];
  /** Sum of triedToHideMyThoughtsAndFeelings across the matching connection */
  triedToHideMyThoughtsAndFeelings: Scalars['BigInt'];
  /** Sum of triedToRepressMyThoughtsAndFeelings across the matching connection */
  triedToRepressMyThoughtsAndFeelings: Scalars['BigInt'];
  /** Sum of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact: Scalars['BigInt'];
  /** Sum of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact: Scalars['BigInt'];
};

export type EmaEntries2VariancePopulationAggregateFilter = {
  angry?: InputMaybe<BigFloatFilter>;
  anxious?: InputMaybe<BigFloatFilter>;
  anxiousDuringContact?: InputMaybe<BigFloatFilter>;
  avoidedSocialContact?: InputMaybe<BigFloatFilter>;
  burden?: InputMaybe<BigFloatFilter>;
  comfortableDuringContact?: InputMaybe<BigFloatFilter>;
  guilty?: InputMaybe<BigFloatFilter>;
  happy?: InputMaybe<BigFloatFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<BigFloatFilter>;
  lonely?: InputMaybe<BigFloatFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<BigFloatFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<BigFloatFilter>;
  notTriedToAlterMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  plannedHowToProceed?: InputMaybe<BigFloatFilter>;
  relaxed?: InputMaybe<BigFloatFilter>;
  rumination?: InputMaybe<BigFloatFilter>;
  sad?: InputMaybe<BigFloatFilter>;
  satisfied?: InputMaybe<BigFloatFilter>;
  tenseDuringContact?: InputMaybe<BigFloatFilter>;
  testy?: InputMaybe<BigFloatFilter>;
  testyDuringContact?: InputMaybe<BigFloatFilter>;
  thoughtALotAboutMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToAcceptMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToCalmMyselfDown?: InputMaybe<BigFloatFilter>;
  triedToChangeMyPerspective?: InputMaybe<BigFloatFilter>;
  triedToDistractMyselfFromMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToHideMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  unconfidentDuringContact?: InputMaybe<BigFloatFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<BigFloatFilter>;
};

export type EmaEntries2VariancePopulationAggregates = {
  __typename?: 'EmaEntries2VariancePopulationAggregates';
  /** Population variance of angry across the matching connection */
  angry?: Maybe<Scalars['BigFloat']>;
  /** Population variance of anxious across the matching connection */
  anxious?: Maybe<Scalars['BigFloat']>;
  /** Population variance of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population variance of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['BigFloat']>;
  /** Population variance of burden across the matching connection */
  burden?: Maybe<Scalars['BigFloat']>;
  /** Population variance of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population variance of guilty across the matching connection */
  guilty?: Maybe<Scalars['BigFloat']>;
  /** Population variance of happy across the matching connection */
  happy?: Maybe<Scalars['BigFloat']>;
  /** Population variance of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['BigFloat']>;
  /** Population variance of lonely across the matching connection */
  lonely?: Maybe<Scalars['BigFloat']>;
  /** Population variance of lookedForAdviceAndComfortFromOthers across the matching connection */
  lookedForAdviceAndComfortFromOthers?: Maybe<Scalars['BigFloat']>;
  /** Population variance of noSocialContactDueToOuterConditions across the matching connection */
  noSocialContactDueToOuterConditions?: Maybe<Scalars['BigFloat']>;
  /** Population variance of notTriedToAlterMyThoughtsAndFeelings across the matching connection */
  notTriedToAlterMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Population variance of plannedHowToProceed across the matching connection */
  plannedHowToProceed?: Maybe<Scalars['BigFloat']>;
  /** Population variance of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['BigFloat']>;
  /** Population variance of rumination across the matching connection */
  rumination?: Maybe<Scalars['BigFloat']>;
  /** Population variance of sad across the matching connection */
  sad?: Maybe<Scalars['BigFloat']>;
  /** Population variance of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['BigFloat']>;
  /** Population variance of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population variance of testy across the matching connection */
  testy?: Maybe<Scalars['BigFloat']>;
  /** Population variance of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population variance of thoughtALotAboutMyThoughtsAndFeelings across the matching connection */
  thoughtALotAboutMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Population variance of triedToAcceptMyThoughtsAndFeelings across the matching connection */
  triedToAcceptMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Population variance of triedToCalmMyselfDown across the matching connection */
  triedToCalmMyselfDown?: Maybe<Scalars['BigFloat']>;
  /** Population variance of triedToChangeMyPerspective across the matching connection */
  triedToChangeMyPerspective?: Maybe<Scalars['BigFloat']>;
  /** Population variance of triedToDistractMyselfFromMyThoughtsAndFeelings across the matching connection */
  triedToDistractMyselfFromMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Population variance of triedToHideMyThoughtsAndFeelings across the matching connection */
  triedToHideMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Population variance of triedToRepressMyThoughtsAndFeelings across the matching connection */
  triedToRepressMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Population variance of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population variance of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['BigFloat']>;
};

export type EmaEntries2VarianceSampleAggregateFilter = {
  angry?: InputMaybe<BigFloatFilter>;
  anxious?: InputMaybe<BigFloatFilter>;
  anxiousDuringContact?: InputMaybe<BigFloatFilter>;
  avoidedSocialContact?: InputMaybe<BigFloatFilter>;
  burden?: InputMaybe<BigFloatFilter>;
  comfortableDuringContact?: InputMaybe<BigFloatFilter>;
  guilty?: InputMaybe<BigFloatFilter>;
  happy?: InputMaybe<BigFloatFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<BigFloatFilter>;
  lonely?: InputMaybe<BigFloatFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<BigFloatFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<BigFloatFilter>;
  notTriedToAlterMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  plannedHowToProceed?: InputMaybe<BigFloatFilter>;
  relaxed?: InputMaybe<BigFloatFilter>;
  rumination?: InputMaybe<BigFloatFilter>;
  sad?: InputMaybe<BigFloatFilter>;
  satisfied?: InputMaybe<BigFloatFilter>;
  tenseDuringContact?: InputMaybe<BigFloatFilter>;
  testy?: InputMaybe<BigFloatFilter>;
  testyDuringContact?: InputMaybe<BigFloatFilter>;
  thoughtALotAboutMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToAcceptMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToCalmMyselfDown?: InputMaybe<BigFloatFilter>;
  triedToChangeMyPerspective?: InputMaybe<BigFloatFilter>;
  triedToDistractMyselfFromMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToHideMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  unconfidentDuringContact?: InputMaybe<BigFloatFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<BigFloatFilter>;
};

export type EmaEntries2VarianceSampleAggregates = {
  __typename?: 'EmaEntries2VarianceSampleAggregates';
  /** Sample variance of angry across the matching connection */
  angry?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of anxious across the matching connection */
  anxious?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of burden across the matching connection */
  burden?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of guilty across the matching connection */
  guilty?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of happy across the matching connection */
  happy?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of lonely across the matching connection */
  lonely?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of lookedForAdviceAndComfortFromOthers across the matching connection */
  lookedForAdviceAndComfortFromOthers?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of noSocialContactDueToOuterConditions across the matching connection */
  noSocialContactDueToOuterConditions?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of notTriedToAlterMyThoughtsAndFeelings across the matching connection */
  notTriedToAlterMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of plannedHowToProceed across the matching connection */
  plannedHowToProceed?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of rumination across the matching connection */
  rumination?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of sad across the matching connection */
  sad?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of testy across the matching connection */
  testy?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of thoughtALotAboutMyThoughtsAndFeelings across the matching connection */
  thoughtALotAboutMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of triedToAcceptMyThoughtsAndFeelings across the matching connection */
  triedToAcceptMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of triedToCalmMyselfDown across the matching connection */
  triedToCalmMyselfDown?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of triedToChangeMyPerspective across the matching connection */
  triedToChangeMyPerspective?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of triedToDistractMyselfFromMyThoughtsAndFeelings across the matching connection */
  triedToDistractMyselfFromMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of triedToHideMyThoughtsAndFeelings across the matching connection */
  triedToHideMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of triedToRepressMyThoughtsAndFeelings across the matching connection */
  triedToRepressMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['BigFloat']>;
};

/** A connection to a list of `EmaEntries2` values. */
export type EmaEntries2sConnection = {
  __typename?: 'EmaEntries2sConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<EmaEntries2Aggregates>;
  /** A list of edges which contains the `EmaEntries2` and cursor to aid in pagination. */
  edges: Array<EmaEntries2sEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<EmaEntries2Aggregates>>;
  /** A list of `EmaEntries2` objects. */
  nodes: Array<EmaEntries2>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EmaEntries2` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `EmaEntries2` values. */
export type EmaEntries2sConnectionGroupedAggregatesArgs = {
  groupBy: Array<EmaEntries2GroupBy>;
  having?: InputMaybe<EmaEntries2HavingInput>;
};

/** A `EmaEntries2` edge in the connection. */
export type EmaEntries2sEdge = {
  __typename?: 'EmaEntries2sEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EmaEntries2` at the end of the edge. */
  node: EmaEntries2;
};

/** Methods to use when ordering `EmaEntries2`. */
export type EmaEntries2sOrderBy =
  | 'ANGRY_ASC'
  | 'ANGRY_DESC'
  | 'ANXIOUS_ASC'
  | 'ANXIOUS_DESC'
  | 'ANXIOUS_DURING_CONTACT_ASC'
  | 'ANXIOUS_DURING_CONTACT_DESC'
  | 'AVOIDED_SOCIAL_CONTACT_ASC'
  | 'AVOIDED_SOCIAL_CONTACT_DESC'
  | 'BURDEN_ASC'
  | 'BURDEN_DESC'
  | 'COMFORTABLE_DURING_CONTACT_ASC'
  | 'COMFORTABLE_DURING_CONTACT_DESC'
  | 'COMPLETED_AT_ASC'
  | 'COMPLETED_AT_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DELETED_ASC'
  | 'DELETED_DESC'
  | 'GUILTY_ASC'
  | 'GUILTY_DESC'
  | 'HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'HAPPY_ASC'
  | 'HAPPY_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'LONELY_ASC'
  | 'LONELY_DESC'
  | 'LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_ASC'
  | 'LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_DESC'
  | 'NATURAL'
  | 'NOT_TRIED_TO_ALTER_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'NOT_TRIED_TO_ALTER_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_ASC'
  | 'NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_DESC'
  | 'PLANNED_HOW_TO_PROCEED_ASC'
  | 'PLANNED_HOW_TO_PROCEED_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'RELAXED_ASC'
  | 'RELAXED_DESC'
  | 'RUMINATION_ASC'
  | 'RUMINATION_DESC'
  | 'SAD_ASC'
  | 'SAD_DESC'
  | 'SATISFIED_ASC'
  | 'SATISFIED_DESC'
  | 'SCHEDULED_AT_ASC'
  | 'SCHEDULED_AT_DESC'
  | 'STARTED_AT_ASC'
  | 'STARTED_AT_DESC'
  | 'SUBJECT_ID_ASC'
  | 'SUBJECT_ID_DESC'
  | 'TENSE_DURING_CONTACT_ASC'
  | 'TENSE_DURING_CONTACT_DESC'
  | 'TESTY_ASC'
  | 'TESTY_DESC'
  | 'TESTY_DURING_CONTACT_ASC'
  | 'TESTY_DURING_CONTACT_DESC'
  | 'THOUGHT_A_LOT_ABOUT_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'THOUGHT_A_LOT_ABOUT_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'TRIED_TO_ACCEPT_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'TRIED_TO_ACCEPT_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'TRIED_TO_CALM_MYSELF_DOWN_ASC'
  | 'TRIED_TO_CALM_MYSELF_DOWN_DESC'
  | 'TRIED_TO_CHANGE_MY_PERSPECTIVE_ASC'
  | 'TRIED_TO_CHANGE_MY_PERSPECTIVE_DESC'
  | 'TRIED_TO_DISTRACT_MYSELF_FROM_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'TRIED_TO_DISTRACT_MYSELF_FROM_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'TRIED_TO_HIDE_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'TRIED_TO_HIDE_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'UNCONFIDENT_DURING_CONTACT_ASC'
  | 'UNCONFIDENT_DURING_CONTACT_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'UPDATED_AT_UTC_ASC'
  | 'UPDATED_AT_UTC_DESC'
  | 'WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC';

export type EmaEntries3 = Node & {
  __typename?: 'EmaEntries3';
  angry?: Maybe<Scalars['Int']>;
  anxious?: Maybe<Scalars['Int']>;
  anxiousDuringContact?: Maybe<Scalars['Int']>;
  atThatMomentIFeltMoreComfortableAlone?: Maybe<Scalars['Int']>;
  avoidedSocialContact?: Maybe<Scalars['Int']>;
  burdens?: Maybe<Array<Maybe<Scalars['String']>>>;
  comfortableDuringContact?: Maybe<Scalars['Int']>;
  completedAt?: Maybe<Scalars['Datetime']>;
  couldResolveBurdensInAdvance?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  deleted: Scalars['Boolean'];
  determined?: Maybe<Scalars['Int']>;
  energetic?: Maybe<Scalars['Int']>;
  enthusiastic?: Maybe<Scalars['Int']>;
  expectBurdenInTheNearFuture?: Maybe<Scalars['Int']>;
  expectedBurdenThatDidNotOccur?: Maybe<Scalars['Int']>;
  guilty?: Maybe<Scalars['Int']>;
  hadAnyContactWithOthersSinceTheLastSurvey?: Maybe<Scalars['Boolean']>;
  happy?: Maybe<Scalars['Int']>;
  happyDuringContact?: Maybe<Scalars['Int']>;
  helpless?: Maybe<Scalars['Int']>;
  id: Scalars['UUID'];
  inspiredDuringContact?: Maybe<Scalars['Int']>;
  lackOfSocialContactBothersMe?: Maybe<Scalars['Int']>;
  lackOfSocialContactForExternalReasons?: Maybe<Scalars['Int']>;
  lonely?: Maybe<Scalars['Int']>;
  lookedForAdviceAndComfortFromOthers?: Maybe<Scalars['Int']>;
  noBurdenForExternalReasons?: Maybe<Scalars['Int']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  plannedHowToProceed?: Maybe<Scalars['Int']>;
  relaxed?: Maybe<Scalars['Int']>;
  sad?: Maybe<Scalars['Int']>;
  satisfied?: Maybe<Scalars['Int']>;
  scheduledAt: Scalars['Datetime'];
  smsReceivedAt?: Maybe<Scalars['Time']>;
  socialDistress?: Maybe<Scalars['Int']>;
  startedAt?: Maybe<Scalars['Datetime']>;
  strain?: Maybe<Scalars['Int']>;
  strength?: Maybe<Scalars['Int']>;
  stressed?: Maybe<Scalars['Int']>;
  tenseDuringContact?: Maybe<Scalars['Int']>;
  testy?: Maybe<Scalars['Int']>;
  testyDuringContact?: Maybe<Scalars['Int']>;
  /** Reads a single `Trial` that is related to this `EmaEntries3`. */
  trial?: Maybe<Trial>;
  trialId: Scalars['UUID'];
  triedToCalmMyselfDown?: Maybe<Scalars['Int']>;
  triedToRepressMyThoughtsAndFeelings?: Maybe<Scalars['Int']>;
  triedToThinkDifferently?: Maybe<Scalars['Int']>;
  typicalThatNoBurdenHaveOccured?: Maybe<Scalars['Int']>;
  unconfidentDuringContact?: Maybe<Scalars['Int']>;
  understoodDuringContact?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Datetime'];
  wave?: Maybe<Scalars['String']>;
  wouldHaveLikedSocialContact?: Maybe<Scalars['Int']>;
};

export type EmaEntries3Aggregates = {
  __typename?: 'EmaEntries3Aggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<EmaEntries3AverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<EmaEntries3DistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<EmaEntries3MaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<EmaEntries3MinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<EmaEntries3StddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<EmaEntries3StddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<EmaEntries3SumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<EmaEntries3VariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<EmaEntries3VarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `EmaEntries3` object types. */
export type EmaEntries3AggregatesFilter = {
  /** Mean average aggregate over matching `EmaEntries3` objects. */
  average?: InputMaybe<EmaEntries3AverageAggregateFilter>;
  /** Distinct count aggregate over matching `EmaEntries3` objects. */
  distinctCount?: InputMaybe<EmaEntries3DistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `EmaEntries3` object to be included within the aggregate. */
  filter?: InputMaybe<EmaEntries3Filter>;
  /** Maximum aggregate over matching `EmaEntries3` objects. */
  max?: InputMaybe<EmaEntries3MaxAggregateFilter>;
  /** Minimum aggregate over matching `EmaEntries3` objects. */
  min?: InputMaybe<EmaEntries3MinAggregateFilter>;
  /** Population standard deviation aggregate over matching `EmaEntries3` objects. */
  stddevPopulation?: InputMaybe<EmaEntries3StddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `EmaEntries3` objects. */
  stddevSample?: InputMaybe<EmaEntries3StddevSampleAggregateFilter>;
  /** Sum aggregate over matching `EmaEntries3` objects. */
  sum?: InputMaybe<EmaEntries3SumAggregateFilter>;
  /** Population variance aggregate over matching `EmaEntries3` objects. */
  variancePopulation?: InputMaybe<EmaEntries3VariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `EmaEntries3` objects. */
  varianceSample?: InputMaybe<EmaEntries3VarianceSampleAggregateFilter>;
};

export type EmaEntries3AverageAggregateFilter = {
  angry?: InputMaybe<BigFloatFilter>;
  anxious?: InputMaybe<BigFloatFilter>;
  anxiousDuringContact?: InputMaybe<BigFloatFilter>;
  atThatMomentIFeltMoreComfortableAlone?: InputMaybe<BigFloatFilter>;
  avoidedSocialContact?: InputMaybe<BigFloatFilter>;
  comfortableDuringContact?: InputMaybe<BigFloatFilter>;
  couldResolveBurdensInAdvance?: InputMaybe<BigFloatFilter>;
  determined?: InputMaybe<BigFloatFilter>;
  energetic?: InputMaybe<BigFloatFilter>;
  enthusiastic?: InputMaybe<BigFloatFilter>;
  expectBurdenInTheNearFuture?: InputMaybe<BigFloatFilter>;
  expectedBurdenThatDidNotOccur?: InputMaybe<BigFloatFilter>;
  guilty?: InputMaybe<BigFloatFilter>;
  happy?: InputMaybe<BigFloatFilter>;
  happyDuringContact?: InputMaybe<BigFloatFilter>;
  helpless?: InputMaybe<BigFloatFilter>;
  inspiredDuringContact?: InputMaybe<BigFloatFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<BigFloatFilter>;
  lackOfSocialContactForExternalReasons?: InputMaybe<BigFloatFilter>;
  lonely?: InputMaybe<BigFloatFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<BigFloatFilter>;
  noBurdenForExternalReasons?: InputMaybe<BigFloatFilter>;
  plannedHowToProceed?: InputMaybe<BigFloatFilter>;
  relaxed?: InputMaybe<BigFloatFilter>;
  sad?: InputMaybe<BigFloatFilter>;
  satisfied?: InputMaybe<BigFloatFilter>;
  socialDistress?: InputMaybe<BigFloatFilter>;
  strain?: InputMaybe<BigFloatFilter>;
  strength?: InputMaybe<BigFloatFilter>;
  stressed?: InputMaybe<BigFloatFilter>;
  tenseDuringContact?: InputMaybe<BigFloatFilter>;
  testy?: InputMaybe<BigFloatFilter>;
  testyDuringContact?: InputMaybe<BigFloatFilter>;
  triedToCalmMyselfDown?: InputMaybe<BigFloatFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToThinkDifferently?: InputMaybe<BigFloatFilter>;
  typicalThatNoBurdenHaveOccured?: InputMaybe<BigFloatFilter>;
  unconfidentDuringContact?: InputMaybe<BigFloatFilter>;
  understoodDuringContact?: InputMaybe<BigFloatFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<BigFloatFilter>;
};

export type EmaEntries3AverageAggregates = {
  __typename?: 'EmaEntries3AverageAggregates';
  /** Mean average of angry across the matching connection */
  angry?: Maybe<Scalars['BigFloat']>;
  /** Mean average of anxious across the matching connection */
  anxious?: Maybe<Scalars['BigFloat']>;
  /** Mean average of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Mean average of atThatMomentIFeltMoreComfortableAlone across the matching connection */
  atThatMomentIFeltMoreComfortableAlone?: Maybe<Scalars['BigFloat']>;
  /** Mean average of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['BigFloat']>;
  /** Mean average of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Mean average of couldResolveBurdensInAdvance across the matching connection */
  couldResolveBurdensInAdvance?: Maybe<Scalars['BigFloat']>;
  /** Mean average of determined across the matching connection */
  determined?: Maybe<Scalars['BigFloat']>;
  /** Mean average of energetic across the matching connection */
  energetic?: Maybe<Scalars['BigFloat']>;
  /** Mean average of enthusiastic across the matching connection */
  enthusiastic?: Maybe<Scalars['BigFloat']>;
  /** Mean average of expectBurdenInTheNearFuture across the matching connection */
  expectBurdenInTheNearFuture?: Maybe<Scalars['BigFloat']>;
  /** Mean average of expectedBurdenThatDidNotOccur across the matching connection */
  expectedBurdenThatDidNotOccur?: Maybe<Scalars['BigFloat']>;
  /** Mean average of guilty across the matching connection */
  guilty?: Maybe<Scalars['BigFloat']>;
  /** Mean average of happy across the matching connection */
  happy?: Maybe<Scalars['BigFloat']>;
  /** Mean average of happyDuringContact across the matching connection */
  happyDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Mean average of helpless across the matching connection */
  helpless?: Maybe<Scalars['BigFloat']>;
  /** Mean average of inspiredDuringContact across the matching connection */
  inspiredDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Mean average of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['BigFloat']>;
  /** Mean average of lackOfSocialContactForExternalReasons across the matching connection */
  lackOfSocialContactForExternalReasons?: Maybe<Scalars['BigFloat']>;
  /** Mean average of lonely across the matching connection */
  lonely?: Maybe<Scalars['BigFloat']>;
  /** Mean average of lookedForAdviceAndComfortFromOthers across the matching connection */
  lookedForAdviceAndComfortFromOthers?: Maybe<Scalars['BigFloat']>;
  /** Mean average of noBurdenForExternalReasons across the matching connection */
  noBurdenForExternalReasons?: Maybe<Scalars['BigFloat']>;
  /** Mean average of plannedHowToProceed across the matching connection */
  plannedHowToProceed?: Maybe<Scalars['BigFloat']>;
  /** Mean average of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['BigFloat']>;
  /** Mean average of sad across the matching connection */
  sad?: Maybe<Scalars['BigFloat']>;
  /** Mean average of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['BigFloat']>;
  /** Mean average of socialDistress across the matching connection */
  socialDistress?: Maybe<Scalars['BigFloat']>;
  /** Mean average of strain across the matching connection */
  strain?: Maybe<Scalars['BigFloat']>;
  /** Mean average of strength across the matching connection */
  strength?: Maybe<Scalars['BigFloat']>;
  /** Mean average of stressed across the matching connection */
  stressed?: Maybe<Scalars['BigFloat']>;
  /** Mean average of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Mean average of testy across the matching connection */
  testy?: Maybe<Scalars['BigFloat']>;
  /** Mean average of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Mean average of triedToCalmMyselfDown across the matching connection */
  triedToCalmMyselfDown?: Maybe<Scalars['BigFloat']>;
  /** Mean average of triedToRepressMyThoughtsAndFeelings across the matching connection */
  triedToRepressMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Mean average of triedToThinkDifferently across the matching connection */
  triedToThinkDifferently?: Maybe<Scalars['BigFloat']>;
  /** Mean average of typicalThatNoBurdenHaveOccured across the matching connection */
  typicalThatNoBurdenHaveOccured?: Maybe<Scalars['BigFloat']>;
  /** Mean average of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Mean average of understoodDuringContact across the matching connection */
  understoodDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Mean average of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `EmaEntries3` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type EmaEntries3Condition = {
  /** Checks for equality with the object’s `angry` field. */
  angry?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `anxious` field. */
  anxious?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `anxiousDuringContact` field. */
  anxiousDuringContact?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `atThatMomentIFeltMoreComfortableAlone` field. */
  atThatMomentIFeltMoreComfortableAlone?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `avoidedSocialContact` field. */
  avoidedSocialContact?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `burdens` field. */
  burdens?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `comfortableDuringContact` field. */
  comfortableDuringContact?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `completedAt` field. */
  completedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `couldResolveBurdensInAdvance` field. */
  couldResolveBurdensInAdvance?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deleted` field. */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `determined` field. */
  determined?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `energetic` field. */
  energetic?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `enthusiastic` field. */
  enthusiastic?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `expectBurdenInTheNearFuture` field. */
  expectBurdenInTheNearFuture?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `expectedBurdenThatDidNotOccur` field. */
  expectedBurdenThatDidNotOccur?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `guilty` field. */
  guilty?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `hadAnyContactWithOthersSinceTheLastSurvey` field. */
  hadAnyContactWithOthersSinceTheLastSurvey?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `happy` field. */
  happy?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `happyDuringContact` field. */
  happyDuringContact?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `helpless` field. */
  helpless?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `inspiredDuringContact` field. */
  inspiredDuringContact?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `lackOfSocialContactBothersMe` field. */
  lackOfSocialContactBothersMe?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `lackOfSocialContactForExternalReasons` field. */
  lackOfSocialContactForExternalReasons?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `lonely` field. */
  lonely?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `lookedForAdviceAndComfortFromOthers` field. */
  lookedForAdviceAndComfortFromOthers?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `noBurdenForExternalReasons` field. */
  noBurdenForExternalReasons?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `plannedHowToProceed` field. */
  plannedHowToProceed?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `relaxed` field. */
  relaxed?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `sad` field. */
  sad?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `satisfied` field. */
  satisfied?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scheduledAt` field. */
  scheduledAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `smsReceivedAt` field. */
  smsReceivedAt?: InputMaybe<Scalars['Time']>;
  /** Checks for equality with the object’s `socialDistress` field. */
  socialDistress?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `startedAt` field. */
  startedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `strain` field. */
  strain?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `strength` field. */
  strength?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `stressed` field. */
  stressed?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `tenseDuringContact` field. */
  tenseDuringContact?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `testy` field. */
  testy?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `testyDuringContact` field. */
  testyDuringContact?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `trialId` field. */
  trialId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `triedToCalmMyselfDown` field. */
  triedToCalmMyselfDown?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `triedToRepressMyThoughtsAndFeelings` field. */
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `triedToThinkDifferently` field. */
  triedToThinkDifferently?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `typicalThatNoBurdenHaveOccured` field. */
  typicalThatNoBurdenHaveOccured?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `unconfidentDuringContact` field. */
  unconfidentDuringContact?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `understoodDuringContact` field. */
  understoodDuringContact?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `wave` field. */
  wave?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `wouldHaveLikedSocialContact` field. */
  wouldHaveLikedSocialContact?: InputMaybe<Scalars['Int']>;
};

export type EmaEntries3DistinctCountAggregateFilter = {
  angry?: InputMaybe<BigIntFilter>;
  anxious?: InputMaybe<BigIntFilter>;
  anxiousDuringContact?: InputMaybe<BigIntFilter>;
  atThatMomentIFeltMoreComfortableAlone?: InputMaybe<BigIntFilter>;
  avoidedSocialContact?: InputMaybe<BigIntFilter>;
  burdens?: InputMaybe<BigIntFilter>;
  comfortableDuringContact?: InputMaybe<BigIntFilter>;
  completedAt?: InputMaybe<BigIntFilter>;
  couldResolveBurdensInAdvance?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  deleted?: InputMaybe<BigIntFilter>;
  determined?: InputMaybe<BigIntFilter>;
  energetic?: InputMaybe<BigIntFilter>;
  enthusiastic?: InputMaybe<BigIntFilter>;
  expectBurdenInTheNearFuture?: InputMaybe<BigIntFilter>;
  expectedBurdenThatDidNotOccur?: InputMaybe<BigIntFilter>;
  guilty?: InputMaybe<BigIntFilter>;
  hadAnyContactWithOthersSinceTheLastSurvey?: InputMaybe<BigIntFilter>;
  happy?: InputMaybe<BigIntFilter>;
  happyDuringContact?: InputMaybe<BigIntFilter>;
  helpless?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  inspiredDuringContact?: InputMaybe<BigIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<BigIntFilter>;
  lackOfSocialContactForExternalReasons?: InputMaybe<BigIntFilter>;
  lonely?: InputMaybe<BigIntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<BigIntFilter>;
  noBurdenForExternalReasons?: InputMaybe<BigIntFilter>;
  plannedHowToProceed?: InputMaybe<BigIntFilter>;
  relaxed?: InputMaybe<BigIntFilter>;
  sad?: InputMaybe<BigIntFilter>;
  satisfied?: InputMaybe<BigIntFilter>;
  scheduledAt?: InputMaybe<BigIntFilter>;
  smsReceivedAt?: InputMaybe<BigIntFilter>;
  socialDistress?: InputMaybe<BigIntFilter>;
  startedAt?: InputMaybe<BigIntFilter>;
  strain?: InputMaybe<BigIntFilter>;
  strength?: InputMaybe<BigIntFilter>;
  stressed?: InputMaybe<BigIntFilter>;
  tenseDuringContact?: InputMaybe<BigIntFilter>;
  testy?: InputMaybe<BigIntFilter>;
  testyDuringContact?: InputMaybe<BigIntFilter>;
  trialId?: InputMaybe<BigIntFilter>;
  triedToCalmMyselfDown?: InputMaybe<BigIntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<BigIntFilter>;
  triedToThinkDifferently?: InputMaybe<BigIntFilter>;
  typicalThatNoBurdenHaveOccured?: InputMaybe<BigIntFilter>;
  unconfidentDuringContact?: InputMaybe<BigIntFilter>;
  understoodDuringContact?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
  wave?: InputMaybe<BigIntFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<BigIntFilter>;
};

export type EmaEntries3DistinctCountAggregates = {
  __typename?: 'EmaEntries3DistinctCountAggregates';
  /** Distinct count of angry across the matching connection */
  angry?: Maybe<Scalars['BigInt']>;
  /** Distinct count of anxious across the matching connection */
  anxious?: Maybe<Scalars['BigInt']>;
  /** Distinct count of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['BigInt']>;
  /** Distinct count of atThatMomentIFeltMoreComfortableAlone across the matching connection */
  atThatMomentIFeltMoreComfortableAlone?: Maybe<Scalars['BigInt']>;
  /** Distinct count of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['BigInt']>;
  /** Distinct count of burdens across the matching connection */
  burdens?: Maybe<Scalars['BigInt']>;
  /** Distinct count of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['BigInt']>;
  /** Distinct count of completedAt across the matching connection */
  completedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of couldResolveBurdensInAdvance across the matching connection */
  couldResolveBurdensInAdvance?: Maybe<Scalars['BigInt']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of deleted across the matching connection */
  deleted?: Maybe<Scalars['BigInt']>;
  /** Distinct count of determined across the matching connection */
  determined?: Maybe<Scalars['BigInt']>;
  /** Distinct count of energetic across the matching connection */
  energetic?: Maybe<Scalars['BigInt']>;
  /** Distinct count of enthusiastic across the matching connection */
  enthusiastic?: Maybe<Scalars['BigInt']>;
  /** Distinct count of expectBurdenInTheNearFuture across the matching connection */
  expectBurdenInTheNearFuture?: Maybe<Scalars['BigInt']>;
  /** Distinct count of expectedBurdenThatDidNotOccur across the matching connection */
  expectedBurdenThatDidNotOccur?: Maybe<Scalars['BigInt']>;
  /** Distinct count of guilty across the matching connection */
  guilty?: Maybe<Scalars['BigInt']>;
  /** Distinct count of hadAnyContactWithOthersSinceTheLastSurvey across the matching connection */
  hadAnyContactWithOthersSinceTheLastSurvey?: Maybe<Scalars['BigInt']>;
  /** Distinct count of happy across the matching connection */
  happy?: Maybe<Scalars['BigInt']>;
  /** Distinct count of happyDuringContact across the matching connection */
  happyDuringContact?: Maybe<Scalars['BigInt']>;
  /** Distinct count of helpless across the matching connection */
  helpless?: Maybe<Scalars['BigInt']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']>;
  /** Distinct count of inspiredDuringContact across the matching connection */
  inspiredDuringContact?: Maybe<Scalars['BigInt']>;
  /** Distinct count of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['BigInt']>;
  /** Distinct count of lackOfSocialContactForExternalReasons across the matching connection */
  lackOfSocialContactForExternalReasons?: Maybe<Scalars['BigInt']>;
  /** Distinct count of lonely across the matching connection */
  lonely?: Maybe<Scalars['BigInt']>;
  /** Distinct count of lookedForAdviceAndComfortFromOthers across the matching connection */
  lookedForAdviceAndComfortFromOthers?: Maybe<Scalars['BigInt']>;
  /** Distinct count of noBurdenForExternalReasons across the matching connection */
  noBurdenForExternalReasons?: Maybe<Scalars['BigInt']>;
  /** Distinct count of plannedHowToProceed across the matching connection */
  plannedHowToProceed?: Maybe<Scalars['BigInt']>;
  /** Distinct count of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['BigInt']>;
  /** Distinct count of sad across the matching connection */
  sad?: Maybe<Scalars['BigInt']>;
  /** Distinct count of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['BigInt']>;
  /** Distinct count of scheduledAt across the matching connection */
  scheduledAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of smsReceivedAt across the matching connection */
  smsReceivedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of socialDistress across the matching connection */
  socialDistress?: Maybe<Scalars['BigInt']>;
  /** Distinct count of startedAt across the matching connection */
  startedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of strain across the matching connection */
  strain?: Maybe<Scalars['BigInt']>;
  /** Distinct count of strength across the matching connection */
  strength?: Maybe<Scalars['BigInt']>;
  /** Distinct count of stressed across the matching connection */
  stressed?: Maybe<Scalars['BigInt']>;
  /** Distinct count of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['BigInt']>;
  /** Distinct count of testy across the matching connection */
  testy?: Maybe<Scalars['BigInt']>;
  /** Distinct count of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['BigInt']>;
  /** Distinct count of trialId across the matching connection */
  trialId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of triedToCalmMyselfDown across the matching connection */
  triedToCalmMyselfDown?: Maybe<Scalars['BigInt']>;
  /** Distinct count of triedToRepressMyThoughtsAndFeelings across the matching connection */
  triedToRepressMyThoughtsAndFeelings?: Maybe<Scalars['BigInt']>;
  /** Distinct count of triedToThinkDifferently across the matching connection */
  triedToThinkDifferently?: Maybe<Scalars['BigInt']>;
  /** Distinct count of typicalThatNoBurdenHaveOccured across the matching connection */
  typicalThatNoBurdenHaveOccured?: Maybe<Scalars['BigInt']>;
  /** Distinct count of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['BigInt']>;
  /** Distinct count of understoodDuringContact across the matching connection */
  understoodDuringContact?: Maybe<Scalars['BigInt']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of wave across the matching connection */
  wave?: Maybe<Scalars['BigInt']>;
  /** Distinct count of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `EmaEntries3` object types. All fields are combined with a logical ‘and.’ */
export type EmaEntries3Filter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EmaEntries3Filter>>;
  /** Filter by the object’s `angry` field. */
  angry?: InputMaybe<IntFilter>;
  /** Filter by the object’s `anxious` field. */
  anxious?: InputMaybe<IntFilter>;
  /** Filter by the object’s `anxiousDuringContact` field. */
  anxiousDuringContact?: InputMaybe<IntFilter>;
  /** Filter by the object’s `atThatMomentIFeltMoreComfortableAlone` field. */
  atThatMomentIFeltMoreComfortableAlone?: InputMaybe<IntFilter>;
  /** Filter by the object’s `avoidedSocialContact` field. */
  avoidedSocialContact?: InputMaybe<IntFilter>;
  /** Filter by the object’s `burdens` field. */
  burdens?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `comfortableDuringContact` field. */
  comfortableDuringContact?: InputMaybe<IntFilter>;
  /** Filter by the object’s `completedAt` field. */
  completedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `couldResolveBurdensInAdvance` field. */
  couldResolveBurdensInAdvance?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deleted` field. */
  deleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `determined` field. */
  determined?: InputMaybe<IntFilter>;
  /** Filter by the object’s `energetic` field. */
  energetic?: InputMaybe<IntFilter>;
  /** Filter by the object’s `enthusiastic` field. */
  enthusiastic?: InputMaybe<IntFilter>;
  /** Filter by the object’s `expectBurdenInTheNearFuture` field. */
  expectBurdenInTheNearFuture?: InputMaybe<IntFilter>;
  /** Filter by the object’s `expectedBurdenThatDidNotOccur` field. */
  expectedBurdenThatDidNotOccur?: InputMaybe<IntFilter>;
  /** Filter by the object’s `guilty` field. */
  guilty?: InputMaybe<IntFilter>;
  /** Filter by the object’s `hadAnyContactWithOthersSinceTheLastSurvey` field. */
  hadAnyContactWithOthersSinceTheLastSurvey?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `happy` field. */
  happy?: InputMaybe<IntFilter>;
  /** Filter by the object’s `happyDuringContact` field. */
  happyDuringContact?: InputMaybe<IntFilter>;
  /** Filter by the object’s `helpless` field. */
  helpless?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `inspiredDuringContact` field. */
  inspiredDuringContact?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lackOfSocialContactBothersMe` field. */
  lackOfSocialContactBothersMe?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lackOfSocialContactForExternalReasons` field. */
  lackOfSocialContactForExternalReasons?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lonely` field. */
  lonely?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lookedForAdviceAndComfortFromOthers` field. */
  lookedForAdviceAndComfortFromOthers?: InputMaybe<IntFilter>;
  /** Filter by the object’s `noBurdenForExternalReasons` field. */
  noBurdenForExternalReasons?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EmaEntries3Filter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EmaEntries3Filter>>;
  /** Filter by the object’s `plannedHowToProceed` field. */
  plannedHowToProceed?: InputMaybe<IntFilter>;
  /** Filter by the object’s `relaxed` field. */
  relaxed?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sad` field. */
  sad?: InputMaybe<IntFilter>;
  /** Filter by the object’s `satisfied` field. */
  satisfied?: InputMaybe<IntFilter>;
  /** Filter by the object’s `scheduledAt` field. */
  scheduledAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `smsReceivedAt` field. */
  smsReceivedAt?: InputMaybe<TimeFilter>;
  /** Filter by the object’s `socialDistress` field. */
  socialDistress?: InputMaybe<IntFilter>;
  /** Filter by the object’s `startedAt` field. */
  startedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `strain` field. */
  strain?: InputMaybe<IntFilter>;
  /** Filter by the object’s `strength` field. */
  strength?: InputMaybe<IntFilter>;
  /** Filter by the object’s `stressed` field. */
  stressed?: InputMaybe<IntFilter>;
  /** Filter by the object’s `tenseDuringContact` field. */
  tenseDuringContact?: InputMaybe<IntFilter>;
  /** Filter by the object’s `testy` field. */
  testy?: InputMaybe<IntFilter>;
  /** Filter by the object’s `testyDuringContact` field. */
  testyDuringContact?: InputMaybe<IntFilter>;
  /** Filter by the object’s `trial` relation. */
  trial?: InputMaybe<TrialFilter>;
  /** Filter by the object’s `trialId` field. */
  trialId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `triedToCalmMyselfDown` field. */
  triedToCalmMyselfDown?: InputMaybe<IntFilter>;
  /** Filter by the object’s `triedToRepressMyThoughtsAndFeelings` field. */
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<IntFilter>;
  /** Filter by the object’s `triedToThinkDifferently` field. */
  triedToThinkDifferently?: InputMaybe<IntFilter>;
  /** Filter by the object’s `typicalThatNoBurdenHaveOccured` field. */
  typicalThatNoBurdenHaveOccured?: InputMaybe<IntFilter>;
  /** Filter by the object’s `unconfidentDuringContact` field. */
  unconfidentDuringContact?: InputMaybe<IntFilter>;
  /** Filter by the object’s `understoodDuringContact` field. */
  understoodDuringContact?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `wave` field. */
  wave?: InputMaybe<StringFilter>;
  /** Filter by the object’s `wouldHaveLikedSocialContact` field. */
  wouldHaveLikedSocialContact?: InputMaybe<IntFilter>;
};

/** Grouping methods for `EmaEntries3` for usage during aggregation. */
export type EmaEntries3GroupBy =
  | 'ANGRY'
  | 'ANXIOUS'
  | 'ANXIOUS_DURING_CONTACT'
  | 'AT_THAT_MOMENT_I_FELT_MORE_COMFORTABLE_ALONE'
  | 'AVOIDED_SOCIAL_CONTACT'
  | 'BURDENS'
  | 'COMFORTABLE_DURING_CONTACT'
  | 'COMPLETED_AT'
  | 'COMPLETED_AT_TRUNCATED_TO_DAY'
  | 'COMPLETED_AT_TRUNCATED_TO_HOUR'
  | 'COULD_RESOLVE_BURDENS_IN_ADVANCE'
  | 'CREATED_AT'
  | 'CREATED_AT_TRUNCATED_TO_DAY'
  | 'CREATED_AT_TRUNCATED_TO_HOUR'
  | 'DELETED'
  | 'DETERMINED'
  | 'ENERGETIC'
  | 'ENTHUSIASTIC'
  | 'EXPECTED_BURDEN_THAT_DID_NOT_OCCUR'
  | 'EXPECT_BURDEN_IN_THE_NEAR_FUTURE'
  | 'GUILTY'
  | 'HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY'
  | 'HAPPY'
  | 'HAPPY_DURING_CONTACT'
  | 'HELPLESS'
  | 'INSPIRED_DURING_CONTACT'
  | 'LACK_OF_SOCIAL_CONTACT_BOTHERS_ME'
  | 'LACK_OF_SOCIAL_CONTACT_FOR_EXTERNAL_REASONS'
  | 'LONELY'
  | 'LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS'
  | 'NO_BURDEN_FOR_EXTERNAL_REASONS'
  | 'PLANNED_HOW_TO_PROCEED'
  | 'RELAXED'
  | 'SAD'
  | 'SATISFIED'
  | 'SCHEDULED_AT'
  | 'SCHEDULED_AT_TRUNCATED_TO_DAY'
  | 'SCHEDULED_AT_TRUNCATED_TO_HOUR'
  | 'SMS_RECEIVED_AT'
  | 'SOCIAL_DISTRESS'
  | 'STARTED_AT'
  | 'STARTED_AT_TRUNCATED_TO_DAY'
  | 'STARTED_AT_TRUNCATED_TO_HOUR'
  | 'STRAIN'
  | 'STRENGTH'
  | 'STRESSED'
  | 'TENSE_DURING_CONTACT'
  | 'TESTY'
  | 'TESTY_DURING_CONTACT'
  | 'TRIAL_ID'
  | 'TRIED_TO_CALM_MYSELF_DOWN'
  | 'TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS'
  | 'TRIED_TO_THINK_DIFFERENTLY'
  | 'TYPICAL_THAT_NO_BURDEN_HAVE_OCCURED'
  | 'UNCONFIDENT_DURING_CONTACT'
  | 'UNDERSTOOD_DURING_CONTACT'
  | 'UPDATED_AT'
  | 'UPDATED_AT_TRUNCATED_TO_DAY'
  | 'UPDATED_AT_TRUNCATED_TO_HOUR'
  | 'WAVE'
  | 'WOULD_HAVE_LIKED_SOCIAL_CONTACT';

export type EmaEntries3HavingAverageInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  atThatMomentIFeltMoreComfortableAlone?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  couldResolveBurdensInAdvance?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  determined?: InputMaybe<HavingIntFilter>;
  energetic?: InputMaybe<HavingIntFilter>;
  enthusiastic?: InputMaybe<HavingIntFilter>;
  expectBurdenInTheNearFuture?: InputMaybe<HavingIntFilter>;
  expectedBurdenThatDidNotOccur?: InputMaybe<HavingIntFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  happyDuringContact?: InputMaybe<HavingIntFilter>;
  helpless?: InputMaybe<HavingIntFilter>;
  inspiredDuringContact?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactForExternalReasons?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<HavingIntFilter>;
  noBurdenForExternalReasons?: InputMaybe<HavingIntFilter>;
  plannedHowToProceed?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  socialDistress?: InputMaybe<HavingIntFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  strain?: InputMaybe<HavingIntFilter>;
  strength?: InputMaybe<HavingIntFilter>;
  stressed?: InputMaybe<HavingIntFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  triedToCalmMyselfDown?: InputMaybe<HavingIntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToThinkDifferently?: InputMaybe<HavingIntFilter>;
  typicalThatNoBurdenHaveOccured?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  understoodDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

export type EmaEntries3HavingDistinctCountInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  atThatMomentIFeltMoreComfortableAlone?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  couldResolveBurdensInAdvance?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  determined?: InputMaybe<HavingIntFilter>;
  energetic?: InputMaybe<HavingIntFilter>;
  enthusiastic?: InputMaybe<HavingIntFilter>;
  expectBurdenInTheNearFuture?: InputMaybe<HavingIntFilter>;
  expectedBurdenThatDidNotOccur?: InputMaybe<HavingIntFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  happyDuringContact?: InputMaybe<HavingIntFilter>;
  helpless?: InputMaybe<HavingIntFilter>;
  inspiredDuringContact?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactForExternalReasons?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<HavingIntFilter>;
  noBurdenForExternalReasons?: InputMaybe<HavingIntFilter>;
  plannedHowToProceed?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  socialDistress?: InputMaybe<HavingIntFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  strain?: InputMaybe<HavingIntFilter>;
  strength?: InputMaybe<HavingIntFilter>;
  stressed?: InputMaybe<HavingIntFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  triedToCalmMyselfDown?: InputMaybe<HavingIntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToThinkDifferently?: InputMaybe<HavingIntFilter>;
  typicalThatNoBurdenHaveOccured?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  understoodDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `EmaEntries3` aggregates. */
export type EmaEntries3HavingInput = {
  AND?: InputMaybe<Array<EmaEntries3HavingInput>>;
  OR?: InputMaybe<Array<EmaEntries3HavingInput>>;
  average?: InputMaybe<EmaEntries3HavingAverageInput>;
  distinctCount?: InputMaybe<EmaEntries3HavingDistinctCountInput>;
  max?: InputMaybe<EmaEntries3HavingMaxInput>;
  min?: InputMaybe<EmaEntries3HavingMinInput>;
  stddevPopulation?: InputMaybe<EmaEntries3HavingStddevPopulationInput>;
  stddevSample?: InputMaybe<EmaEntries3HavingStddevSampleInput>;
  sum?: InputMaybe<EmaEntries3HavingSumInput>;
  variancePopulation?: InputMaybe<EmaEntries3HavingVariancePopulationInput>;
  varianceSample?: InputMaybe<EmaEntries3HavingVarianceSampleInput>;
};

export type EmaEntries3HavingMaxInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  atThatMomentIFeltMoreComfortableAlone?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  couldResolveBurdensInAdvance?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  determined?: InputMaybe<HavingIntFilter>;
  energetic?: InputMaybe<HavingIntFilter>;
  enthusiastic?: InputMaybe<HavingIntFilter>;
  expectBurdenInTheNearFuture?: InputMaybe<HavingIntFilter>;
  expectedBurdenThatDidNotOccur?: InputMaybe<HavingIntFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  happyDuringContact?: InputMaybe<HavingIntFilter>;
  helpless?: InputMaybe<HavingIntFilter>;
  inspiredDuringContact?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactForExternalReasons?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<HavingIntFilter>;
  noBurdenForExternalReasons?: InputMaybe<HavingIntFilter>;
  plannedHowToProceed?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  socialDistress?: InputMaybe<HavingIntFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  strain?: InputMaybe<HavingIntFilter>;
  strength?: InputMaybe<HavingIntFilter>;
  stressed?: InputMaybe<HavingIntFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  triedToCalmMyselfDown?: InputMaybe<HavingIntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToThinkDifferently?: InputMaybe<HavingIntFilter>;
  typicalThatNoBurdenHaveOccured?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  understoodDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

export type EmaEntries3HavingMinInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  atThatMomentIFeltMoreComfortableAlone?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  couldResolveBurdensInAdvance?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  determined?: InputMaybe<HavingIntFilter>;
  energetic?: InputMaybe<HavingIntFilter>;
  enthusiastic?: InputMaybe<HavingIntFilter>;
  expectBurdenInTheNearFuture?: InputMaybe<HavingIntFilter>;
  expectedBurdenThatDidNotOccur?: InputMaybe<HavingIntFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  happyDuringContact?: InputMaybe<HavingIntFilter>;
  helpless?: InputMaybe<HavingIntFilter>;
  inspiredDuringContact?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactForExternalReasons?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<HavingIntFilter>;
  noBurdenForExternalReasons?: InputMaybe<HavingIntFilter>;
  plannedHowToProceed?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  socialDistress?: InputMaybe<HavingIntFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  strain?: InputMaybe<HavingIntFilter>;
  strength?: InputMaybe<HavingIntFilter>;
  stressed?: InputMaybe<HavingIntFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  triedToCalmMyselfDown?: InputMaybe<HavingIntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToThinkDifferently?: InputMaybe<HavingIntFilter>;
  typicalThatNoBurdenHaveOccured?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  understoodDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

export type EmaEntries3HavingStddevPopulationInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  atThatMomentIFeltMoreComfortableAlone?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  couldResolveBurdensInAdvance?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  determined?: InputMaybe<HavingIntFilter>;
  energetic?: InputMaybe<HavingIntFilter>;
  enthusiastic?: InputMaybe<HavingIntFilter>;
  expectBurdenInTheNearFuture?: InputMaybe<HavingIntFilter>;
  expectedBurdenThatDidNotOccur?: InputMaybe<HavingIntFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  happyDuringContact?: InputMaybe<HavingIntFilter>;
  helpless?: InputMaybe<HavingIntFilter>;
  inspiredDuringContact?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactForExternalReasons?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<HavingIntFilter>;
  noBurdenForExternalReasons?: InputMaybe<HavingIntFilter>;
  plannedHowToProceed?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  socialDistress?: InputMaybe<HavingIntFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  strain?: InputMaybe<HavingIntFilter>;
  strength?: InputMaybe<HavingIntFilter>;
  stressed?: InputMaybe<HavingIntFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  triedToCalmMyselfDown?: InputMaybe<HavingIntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToThinkDifferently?: InputMaybe<HavingIntFilter>;
  typicalThatNoBurdenHaveOccured?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  understoodDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

export type EmaEntries3HavingStddevSampleInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  atThatMomentIFeltMoreComfortableAlone?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  couldResolveBurdensInAdvance?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  determined?: InputMaybe<HavingIntFilter>;
  energetic?: InputMaybe<HavingIntFilter>;
  enthusiastic?: InputMaybe<HavingIntFilter>;
  expectBurdenInTheNearFuture?: InputMaybe<HavingIntFilter>;
  expectedBurdenThatDidNotOccur?: InputMaybe<HavingIntFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  happyDuringContact?: InputMaybe<HavingIntFilter>;
  helpless?: InputMaybe<HavingIntFilter>;
  inspiredDuringContact?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactForExternalReasons?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<HavingIntFilter>;
  noBurdenForExternalReasons?: InputMaybe<HavingIntFilter>;
  plannedHowToProceed?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  socialDistress?: InputMaybe<HavingIntFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  strain?: InputMaybe<HavingIntFilter>;
  strength?: InputMaybe<HavingIntFilter>;
  stressed?: InputMaybe<HavingIntFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  triedToCalmMyselfDown?: InputMaybe<HavingIntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToThinkDifferently?: InputMaybe<HavingIntFilter>;
  typicalThatNoBurdenHaveOccured?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  understoodDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

export type EmaEntries3HavingSumInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  atThatMomentIFeltMoreComfortableAlone?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  couldResolveBurdensInAdvance?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  determined?: InputMaybe<HavingIntFilter>;
  energetic?: InputMaybe<HavingIntFilter>;
  enthusiastic?: InputMaybe<HavingIntFilter>;
  expectBurdenInTheNearFuture?: InputMaybe<HavingIntFilter>;
  expectedBurdenThatDidNotOccur?: InputMaybe<HavingIntFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  happyDuringContact?: InputMaybe<HavingIntFilter>;
  helpless?: InputMaybe<HavingIntFilter>;
  inspiredDuringContact?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactForExternalReasons?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<HavingIntFilter>;
  noBurdenForExternalReasons?: InputMaybe<HavingIntFilter>;
  plannedHowToProceed?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  socialDistress?: InputMaybe<HavingIntFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  strain?: InputMaybe<HavingIntFilter>;
  strength?: InputMaybe<HavingIntFilter>;
  stressed?: InputMaybe<HavingIntFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  triedToCalmMyselfDown?: InputMaybe<HavingIntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToThinkDifferently?: InputMaybe<HavingIntFilter>;
  typicalThatNoBurdenHaveOccured?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  understoodDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

export type EmaEntries3HavingVariancePopulationInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  atThatMomentIFeltMoreComfortableAlone?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  couldResolveBurdensInAdvance?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  determined?: InputMaybe<HavingIntFilter>;
  energetic?: InputMaybe<HavingIntFilter>;
  enthusiastic?: InputMaybe<HavingIntFilter>;
  expectBurdenInTheNearFuture?: InputMaybe<HavingIntFilter>;
  expectedBurdenThatDidNotOccur?: InputMaybe<HavingIntFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  happyDuringContact?: InputMaybe<HavingIntFilter>;
  helpless?: InputMaybe<HavingIntFilter>;
  inspiredDuringContact?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactForExternalReasons?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<HavingIntFilter>;
  noBurdenForExternalReasons?: InputMaybe<HavingIntFilter>;
  plannedHowToProceed?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  socialDistress?: InputMaybe<HavingIntFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  strain?: InputMaybe<HavingIntFilter>;
  strength?: InputMaybe<HavingIntFilter>;
  stressed?: InputMaybe<HavingIntFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  triedToCalmMyselfDown?: InputMaybe<HavingIntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToThinkDifferently?: InputMaybe<HavingIntFilter>;
  typicalThatNoBurdenHaveOccured?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  understoodDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

export type EmaEntries3HavingVarianceSampleInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  atThatMomentIFeltMoreComfortableAlone?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  couldResolveBurdensInAdvance?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  determined?: InputMaybe<HavingIntFilter>;
  energetic?: InputMaybe<HavingIntFilter>;
  enthusiastic?: InputMaybe<HavingIntFilter>;
  expectBurdenInTheNearFuture?: InputMaybe<HavingIntFilter>;
  expectedBurdenThatDidNotOccur?: InputMaybe<HavingIntFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  happyDuringContact?: InputMaybe<HavingIntFilter>;
  helpless?: InputMaybe<HavingIntFilter>;
  inspiredDuringContact?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactForExternalReasons?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<HavingIntFilter>;
  noBurdenForExternalReasons?: InputMaybe<HavingIntFilter>;
  plannedHowToProceed?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  socialDistress?: InputMaybe<HavingIntFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  strain?: InputMaybe<HavingIntFilter>;
  strength?: InputMaybe<HavingIntFilter>;
  stressed?: InputMaybe<HavingIntFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  triedToCalmMyselfDown?: InputMaybe<HavingIntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<HavingIntFilter>;
  triedToThinkDifferently?: InputMaybe<HavingIntFilter>;
  typicalThatNoBurdenHaveOccured?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  understoodDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

/** An input for mutations affecting `EmaEntries3` */
export type EmaEntries3Input = {
  angry?: InputMaybe<Scalars['Int']>;
  anxious?: InputMaybe<Scalars['Int']>;
  anxiousDuringContact?: InputMaybe<Scalars['Int']>;
  atThatMomentIFeltMoreComfortableAlone?: InputMaybe<Scalars['Int']>;
  avoidedSocialContact?: InputMaybe<Scalars['Int']>;
  burdens?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  comfortableDuringContact?: InputMaybe<Scalars['Int']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  couldResolveBurdensInAdvance?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  determined?: InputMaybe<Scalars['Int']>;
  energetic?: InputMaybe<Scalars['Int']>;
  enthusiastic?: InputMaybe<Scalars['Int']>;
  expectBurdenInTheNearFuture?: InputMaybe<Scalars['Int']>;
  expectedBurdenThatDidNotOccur?: InputMaybe<Scalars['Int']>;
  guilty?: InputMaybe<Scalars['Int']>;
  hadAnyContactWithOthersSinceTheLastSurvey?: InputMaybe<Scalars['Boolean']>;
  happy?: InputMaybe<Scalars['Int']>;
  happyDuringContact?: InputMaybe<Scalars['Int']>;
  helpless?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  inspiredDuringContact?: InputMaybe<Scalars['Int']>;
  lackOfSocialContactBothersMe?: InputMaybe<Scalars['Int']>;
  lackOfSocialContactForExternalReasons?: InputMaybe<Scalars['Int']>;
  lonely?: InputMaybe<Scalars['Int']>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<Scalars['Int']>;
  noBurdenForExternalReasons?: InputMaybe<Scalars['Int']>;
  plannedHowToProceed?: InputMaybe<Scalars['Int']>;
  relaxed?: InputMaybe<Scalars['Int']>;
  sad?: InputMaybe<Scalars['Int']>;
  satisfied?: InputMaybe<Scalars['Int']>;
  scheduledAt: Scalars['Datetime'];
  smsReceivedAt?: InputMaybe<Scalars['Time']>;
  socialDistress?: InputMaybe<Scalars['Int']>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  strain?: InputMaybe<Scalars['Int']>;
  strength?: InputMaybe<Scalars['Int']>;
  stressed?: InputMaybe<Scalars['Int']>;
  tenseDuringContact?: InputMaybe<Scalars['Int']>;
  testy?: InputMaybe<Scalars['Int']>;
  testyDuringContact?: InputMaybe<Scalars['Int']>;
  trialId: Scalars['UUID'];
  triedToCalmMyselfDown?: InputMaybe<Scalars['Int']>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<Scalars['Int']>;
  triedToThinkDifferently?: InputMaybe<Scalars['Int']>;
  typicalThatNoBurdenHaveOccured?: InputMaybe<Scalars['Int']>;
  unconfidentDuringContact?: InputMaybe<Scalars['Int']>;
  understoodDuringContact?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  wave?: InputMaybe<Scalars['String']>;
  wouldHaveLikedSocialContact?: InputMaybe<Scalars['Int']>;
};

export type EmaEntries3MaxAggregateFilter = {
  angry?: InputMaybe<IntFilter>;
  anxious?: InputMaybe<IntFilter>;
  anxiousDuringContact?: InputMaybe<IntFilter>;
  atThatMomentIFeltMoreComfortableAlone?: InputMaybe<IntFilter>;
  avoidedSocialContact?: InputMaybe<IntFilter>;
  comfortableDuringContact?: InputMaybe<IntFilter>;
  couldResolveBurdensInAdvance?: InputMaybe<IntFilter>;
  determined?: InputMaybe<IntFilter>;
  energetic?: InputMaybe<IntFilter>;
  enthusiastic?: InputMaybe<IntFilter>;
  expectBurdenInTheNearFuture?: InputMaybe<IntFilter>;
  expectedBurdenThatDidNotOccur?: InputMaybe<IntFilter>;
  guilty?: InputMaybe<IntFilter>;
  happy?: InputMaybe<IntFilter>;
  happyDuringContact?: InputMaybe<IntFilter>;
  helpless?: InputMaybe<IntFilter>;
  inspiredDuringContact?: InputMaybe<IntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<IntFilter>;
  lackOfSocialContactForExternalReasons?: InputMaybe<IntFilter>;
  lonely?: InputMaybe<IntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<IntFilter>;
  noBurdenForExternalReasons?: InputMaybe<IntFilter>;
  plannedHowToProceed?: InputMaybe<IntFilter>;
  relaxed?: InputMaybe<IntFilter>;
  sad?: InputMaybe<IntFilter>;
  satisfied?: InputMaybe<IntFilter>;
  socialDistress?: InputMaybe<IntFilter>;
  strain?: InputMaybe<IntFilter>;
  strength?: InputMaybe<IntFilter>;
  stressed?: InputMaybe<IntFilter>;
  tenseDuringContact?: InputMaybe<IntFilter>;
  testy?: InputMaybe<IntFilter>;
  testyDuringContact?: InputMaybe<IntFilter>;
  triedToCalmMyselfDown?: InputMaybe<IntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<IntFilter>;
  triedToThinkDifferently?: InputMaybe<IntFilter>;
  typicalThatNoBurdenHaveOccured?: InputMaybe<IntFilter>;
  unconfidentDuringContact?: InputMaybe<IntFilter>;
  understoodDuringContact?: InputMaybe<IntFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<IntFilter>;
};

export type EmaEntries3MaxAggregates = {
  __typename?: 'EmaEntries3MaxAggregates';
  /** Maximum of angry across the matching connection */
  angry?: Maybe<Scalars['Int']>;
  /** Maximum of anxious across the matching connection */
  anxious?: Maybe<Scalars['Int']>;
  /** Maximum of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['Int']>;
  /** Maximum of atThatMomentIFeltMoreComfortableAlone across the matching connection */
  atThatMomentIFeltMoreComfortableAlone?: Maybe<Scalars['Int']>;
  /** Maximum of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['Int']>;
  /** Maximum of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['Int']>;
  /** Maximum of couldResolveBurdensInAdvance across the matching connection */
  couldResolveBurdensInAdvance?: Maybe<Scalars['Int']>;
  /** Maximum of determined across the matching connection */
  determined?: Maybe<Scalars['Int']>;
  /** Maximum of energetic across the matching connection */
  energetic?: Maybe<Scalars['Int']>;
  /** Maximum of enthusiastic across the matching connection */
  enthusiastic?: Maybe<Scalars['Int']>;
  /** Maximum of expectBurdenInTheNearFuture across the matching connection */
  expectBurdenInTheNearFuture?: Maybe<Scalars['Int']>;
  /** Maximum of expectedBurdenThatDidNotOccur across the matching connection */
  expectedBurdenThatDidNotOccur?: Maybe<Scalars['Int']>;
  /** Maximum of guilty across the matching connection */
  guilty?: Maybe<Scalars['Int']>;
  /** Maximum of happy across the matching connection */
  happy?: Maybe<Scalars['Int']>;
  /** Maximum of happyDuringContact across the matching connection */
  happyDuringContact?: Maybe<Scalars['Int']>;
  /** Maximum of helpless across the matching connection */
  helpless?: Maybe<Scalars['Int']>;
  /** Maximum of inspiredDuringContact across the matching connection */
  inspiredDuringContact?: Maybe<Scalars['Int']>;
  /** Maximum of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['Int']>;
  /** Maximum of lackOfSocialContactForExternalReasons across the matching connection */
  lackOfSocialContactForExternalReasons?: Maybe<Scalars['Int']>;
  /** Maximum of lonely across the matching connection */
  lonely?: Maybe<Scalars['Int']>;
  /** Maximum of lookedForAdviceAndComfortFromOthers across the matching connection */
  lookedForAdviceAndComfortFromOthers?: Maybe<Scalars['Int']>;
  /** Maximum of noBurdenForExternalReasons across the matching connection */
  noBurdenForExternalReasons?: Maybe<Scalars['Int']>;
  /** Maximum of plannedHowToProceed across the matching connection */
  plannedHowToProceed?: Maybe<Scalars['Int']>;
  /** Maximum of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['Int']>;
  /** Maximum of sad across the matching connection */
  sad?: Maybe<Scalars['Int']>;
  /** Maximum of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['Int']>;
  /** Maximum of socialDistress across the matching connection */
  socialDistress?: Maybe<Scalars['Int']>;
  /** Maximum of strain across the matching connection */
  strain?: Maybe<Scalars['Int']>;
  /** Maximum of strength across the matching connection */
  strength?: Maybe<Scalars['Int']>;
  /** Maximum of stressed across the matching connection */
  stressed?: Maybe<Scalars['Int']>;
  /** Maximum of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['Int']>;
  /** Maximum of testy across the matching connection */
  testy?: Maybe<Scalars['Int']>;
  /** Maximum of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['Int']>;
  /** Maximum of triedToCalmMyselfDown across the matching connection */
  triedToCalmMyselfDown?: Maybe<Scalars['Int']>;
  /** Maximum of triedToRepressMyThoughtsAndFeelings across the matching connection */
  triedToRepressMyThoughtsAndFeelings?: Maybe<Scalars['Int']>;
  /** Maximum of triedToThinkDifferently across the matching connection */
  triedToThinkDifferently?: Maybe<Scalars['Int']>;
  /** Maximum of typicalThatNoBurdenHaveOccured across the matching connection */
  typicalThatNoBurdenHaveOccured?: Maybe<Scalars['Int']>;
  /** Maximum of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['Int']>;
  /** Maximum of understoodDuringContact across the matching connection */
  understoodDuringContact?: Maybe<Scalars['Int']>;
  /** Maximum of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['Int']>;
};

export type EmaEntries3MinAggregateFilter = {
  angry?: InputMaybe<IntFilter>;
  anxious?: InputMaybe<IntFilter>;
  anxiousDuringContact?: InputMaybe<IntFilter>;
  atThatMomentIFeltMoreComfortableAlone?: InputMaybe<IntFilter>;
  avoidedSocialContact?: InputMaybe<IntFilter>;
  comfortableDuringContact?: InputMaybe<IntFilter>;
  couldResolveBurdensInAdvance?: InputMaybe<IntFilter>;
  determined?: InputMaybe<IntFilter>;
  energetic?: InputMaybe<IntFilter>;
  enthusiastic?: InputMaybe<IntFilter>;
  expectBurdenInTheNearFuture?: InputMaybe<IntFilter>;
  expectedBurdenThatDidNotOccur?: InputMaybe<IntFilter>;
  guilty?: InputMaybe<IntFilter>;
  happy?: InputMaybe<IntFilter>;
  happyDuringContact?: InputMaybe<IntFilter>;
  helpless?: InputMaybe<IntFilter>;
  inspiredDuringContact?: InputMaybe<IntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<IntFilter>;
  lackOfSocialContactForExternalReasons?: InputMaybe<IntFilter>;
  lonely?: InputMaybe<IntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<IntFilter>;
  noBurdenForExternalReasons?: InputMaybe<IntFilter>;
  plannedHowToProceed?: InputMaybe<IntFilter>;
  relaxed?: InputMaybe<IntFilter>;
  sad?: InputMaybe<IntFilter>;
  satisfied?: InputMaybe<IntFilter>;
  socialDistress?: InputMaybe<IntFilter>;
  strain?: InputMaybe<IntFilter>;
  strength?: InputMaybe<IntFilter>;
  stressed?: InputMaybe<IntFilter>;
  tenseDuringContact?: InputMaybe<IntFilter>;
  testy?: InputMaybe<IntFilter>;
  testyDuringContact?: InputMaybe<IntFilter>;
  triedToCalmMyselfDown?: InputMaybe<IntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<IntFilter>;
  triedToThinkDifferently?: InputMaybe<IntFilter>;
  typicalThatNoBurdenHaveOccured?: InputMaybe<IntFilter>;
  unconfidentDuringContact?: InputMaybe<IntFilter>;
  understoodDuringContact?: InputMaybe<IntFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<IntFilter>;
};

export type EmaEntries3MinAggregates = {
  __typename?: 'EmaEntries3MinAggregates';
  /** Minimum of angry across the matching connection */
  angry?: Maybe<Scalars['Int']>;
  /** Minimum of anxious across the matching connection */
  anxious?: Maybe<Scalars['Int']>;
  /** Minimum of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['Int']>;
  /** Minimum of atThatMomentIFeltMoreComfortableAlone across the matching connection */
  atThatMomentIFeltMoreComfortableAlone?: Maybe<Scalars['Int']>;
  /** Minimum of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['Int']>;
  /** Minimum of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['Int']>;
  /** Minimum of couldResolveBurdensInAdvance across the matching connection */
  couldResolveBurdensInAdvance?: Maybe<Scalars['Int']>;
  /** Minimum of determined across the matching connection */
  determined?: Maybe<Scalars['Int']>;
  /** Minimum of energetic across the matching connection */
  energetic?: Maybe<Scalars['Int']>;
  /** Minimum of enthusiastic across the matching connection */
  enthusiastic?: Maybe<Scalars['Int']>;
  /** Minimum of expectBurdenInTheNearFuture across the matching connection */
  expectBurdenInTheNearFuture?: Maybe<Scalars['Int']>;
  /** Minimum of expectedBurdenThatDidNotOccur across the matching connection */
  expectedBurdenThatDidNotOccur?: Maybe<Scalars['Int']>;
  /** Minimum of guilty across the matching connection */
  guilty?: Maybe<Scalars['Int']>;
  /** Minimum of happy across the matching connection */
  happy?: Maybe<Scalars['Int']>;
  /** Minimum of happyDuringContact across the matching connection */
  happyDuringContact?: Maybe<Scalars['Int']>;
  /** Minimum of helpless across the matching connection */
  helpless?: Maybe<Scalars['Int']>;
  /** Minimum of inspiredDuringContact across the matching connection */
  inspiredDuringContact?: Maybe<Scalars['Int']>;
  /** Minimum of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['Int']>;
  /** Minimum of lackOfSocialContactForExternalReasons across the matching connection */
  lackOfSocialContactForExternalReasons?: Maybe<Scalars['Int']>;
  /** Minimum of lonely across the matching connection */
  lonely?: Maybe<Scalars['Int']>;
  /** Minimum of lookedForAdviceAndComfortFromOthers across the matching connection */
  lookedForAdviceAndComfortFromOthers?: Maybe<Scalars['Int']>;
  /** Minimum of noBurdenForExternalReasons across the matching connection */
  noBurdenForExternalReasons?: Maybe<Scalars['Int']>;
  /** Minimum of plannedHowToProceed across the matching connection */
  plannedHowToProceed?: Maybe<Scalars['Int']>;
  /** Minimum of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['Int']>;
  /** Minimum of sad across the matching connection */
  sad?: Maybe<Scalars['Int']>;
  /** Minimum of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['Int']>;
  /** Minimum of socialDistress across the matching connection */
  socialDistress?: Maybe<Scalars['Int']>;
  /** Minimum of strain across the matching connection */
  strain?: Maybe<Scalars['Int']>;
  /** Minimum of strength across the matching connection */
  strength?: Maybe<Scalars['Int']>;
  /** Minimum of stressed across the matching connection */
  stressed?: Maybe<Scalars['Int']>;
  /** Minimum of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['Int']>;
  /** Minimum of testy across the matching connection */
  testy?: Maybe<Scalars['Int']>;
  /** Minimum of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['Int']>;
  /** Minimum of triedToCalmMyselfDown across the matching connection */
  triedToCalmMyselfDown?: Maybe<Scalars['Int']>;
  /** Minimum of triedToRepressMyThoughtsAndFeelings across the matching connection */
  triedToRepressMyThoughtsAndFeelings?: Maybe<Scalars['Int']>;
  /** Minimum of triedToThinkDifferently across the matching connection */
  triedToThinkDifferently?: Maybe<Scalars['Int']>;
  /** Minimum of typicalThatNoBurdenHaveOccured across the matching connection */
  typicalThatNoBurdenHaveOccured?: Maybe<Scalars['Int']>;
  /** Minimum of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['Int']>;
  /** Minimum of understoodDuringContact across the matching connection */
  understoodDuringContact?: Maybe<Scalars['Int']>;
  /** Minimum of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['Int']>;
};

/** Represents an update to a `EmaEntries3`. Fields that are set will be updated. */
export type EmaEntries3Patch = {
  angry?: InputMaybe<Scalars['Int']>;
  anxious?: InputMaybe<Scalars['Int']>;
  anxiousDuringContact?: InputMaybe<Scalars['Int']>;
  atThatMomentIFeltMoreComfortableAlone?: InputMaybe<Scalars['Int']>;
  avoidedSocialContact?: InputMaybe<Scalars['Int']>;
  burdens?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  comfortableDuringContact?: InputMaybe<Scalars['Int']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  couldResolveBurdensInAdvance?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  determined?: InputMaybe<Scalars['Int']>;
  energetic?: InputMaybe<Scalars['Int']>;
  enthusiastic?: InputMaybe<Scalars['Int']>;
  expectBurdenInTheNearFuture?: InputMaybe<Scalars['Int']>;
  expectedBurdenThatDidNotOccur?: InputMaybe<Scalars['Int']>;
  guilty?: InputMaybe<Scalars['Int']>;
  hadAnyContactWithOthersSinceTheLastSurvey?: InputMaybe<Scalars['Boolean']>;
  happy?: InputMaybe<Scalars['Int']>;
  happyDuringContact?: InputMaybe<Scalars['Int']>;
  helpless?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  inspiredDuringContact?: InputMaybe<Scalars['Int']>;
  lackOfSocialContactBothersMe?: InputMaybe<Scalars['Int']>;
  lackOfSocialContactForExternalReasons?: InputMaybe<Scalars['Int']>;
  lonely?: InputMaybe<Scalars['Int']>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<Scalars['Int']>;
  noBurdenForExternalReasons?: InputMaybe<Scalars['Int']>;
  plannedHowToProceed?: InputMaybe<Scalars['Int']>;
  relaxed?: InputMaybe<Scalars['Int']>;
  sad?: InputMaybe<Scalars['Int']>;
  satisfied?: InputMaybe<Scalars['Int']>;
  scheduledAt?: InputMaybe<Scalars['Datetime']>;
  smsReceivedAt?: InputMaybe<Scalars['Time']>;
  socialDistress?: InputMaybe<Scalars['Int']>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  strain?: InputMaybe<Scalars['Int']>;
  strength?: InputMaybe<Scalars['Int']>;
  stressed?: InputMaybe<Scalars['Int']>;
  tenseDuringContact?: InputMaybe<Scalars['Int']>;
  testy?: InputMaybe<Scalars['Int']>;
  testyDuringContact?: InputMaybe<Scalars['Int']>;
  trialId?: InputMaybe<Scalars['UUID']>;
  triedToCalmMyselfDown?: InputMaybe<Scalars['Int']>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<Scalars['Int']>;
  triedToThinkDifferently?: InputMaybe<Scalars['Int']>;
  typicalThatNoBurdenHaveOccured?: InputMaybe<Scalars['Int']>;
  unconfidentDuringContact?: InputMaybe<Scalars['Int']>;
  understoodDuringContact?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  wave?: InputMaybe<Scalars['String']>;
  wouldHaveLikedSocialContact?: InputMaybe<Scalars['Int']>;
};

export type EmaEntries3StddevPopulationAggregateFilter = {
  angry?: InputMaybe<BigFloatFilter>;
  anxious?: InputMaybe<BigFloatFilter>;
  anxiousDuringContact?: InputMaybe<BigFloatFilter>;
  atThatMomentIFeltMoreComfortableAlone?: InputMaybe<BigFloatFilter>;
  avoidedSocialContact?: InputMaybe<BigFloatFilter>;
  comfortableDuringContact?: InputMaybe<BigFloatFilter>;
  couldResolveBurdensInAdvance?: InputMaybe<BigFloatFilter>;
  determined?: InputMaybe<BigFloatFilter>;
  energetic?: InputMaybe<BigFloatFilter>;
  enthusiastic?: InputMaybe<BigFloatFilter>;
  expectBurdenInTheNearFuture?: InputMaybe<BigFloatFilter>;
  expectedBurdenThatDidNotOccur?: InputMaybe<BigFloatFilter>;
  guilty?: InputMaybe<BigFloatFilter>;
  happy?: InputMaybe<BigFloatFilter>;
  happyDuringContact?: InputMaybe<BigFloatFilter>;
  helpless?: InputMaybe<BigFloatFilter>;
  inspiredDuringContact?: InputMaybe<BigFloatFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<BigFloatFilter>;
  lackOfSocialContactForExternalReasons?: InputMaybe<BigFloatFilter>;
  lonely?: InputMaybe<BigFloatFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<BigFloatFilter>;
  noBurdenForExternalReasons?: InputMaybe<BigFloatFilter>;
  plannedHowToProceed?: InputMaybe<BigFloatFilter>;
  relaxed?: InputMaybe<BigFloatFilter>;
  sad?: InputMaybe<BigFloatFilter>;
  satisfied?: InputMaybe<BigFloatFilter>;
  socialDistress?: InputMaybe<BigFloatFilter>;
  strain?: InputMaybe<BigFloatFilter>;
  strength?: InputMaybe<BigFloatFilter>;
  stressed?: InputMaybe<BigFloatFilter>;
  tenseDuringContact?: InputMaybe<BigFloatFilter>;
  testy?: InputMaybe<BigFloatFilter>;
  testyDuringContact?: InputMaybe<BigFloatFilter>;
  triedToCalmMyselfDown?: InputMaybe<BigFloatFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToThinkDifferently?: InputMaybe<BigFloatFilter>;
  typicalThatNoBurdenHaveOccured?: InputMaybe<BigFloatFilter>;
  unconfidentDuringContact?: InputMaybe<BigFloatFilter>;
  understoodDuringContact?: InputMaybe<BigFloatFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<BigFloatFilter>;
};

export type EmaEntries3StddevPopulationAggregates = {
  __typename?: 'EmaEntries3StddevPopulationAggregates';
  /** Population standard deviation of angry across the matching connection */
  angry?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of anxious across the matching connection */
  anxious?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of atThatMomentIFeltMoreComfortableAlone across the matching connection */
  atThatMomentIFeltMoreComfortableAlone?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of couldResolveBurdensInAdvance across the matching connection */
  couldResolveBurdensInAdvance?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of determined across the matching connection */
  determined?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of energetic across the matching connection */
  energetic?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of enthusiastic across the matching connection */
  enthusiastic?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of expectBurdenInTheNearFuture across the matching connection */
  expectBurdenInTheNearFuture?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of expectedBurdenThatDidNotOccur across the matching connection */
  expectedBurdenThatDidNotOccur?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of guilty across the matching connection */
  guilty?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of happy across the matching connection */
  happy?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of happyDuringContact across the matching connection */
  happyDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of helpless across the matching connection */
  helpless?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of inspiredDuringContact across the matching connection */
  inspiredDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of lackOfSocialContactForExternalReasons across the matching connection */
  lackOfSocialContactForExternalReasons?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of lonely across the matching connection */
  lonely?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of lookedForAdviceAndComfortFromOthers across the matching connection */
  lookedForAdviceAndComfortFromOthers?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of noBurdenForExternalReasons across the matching connection */
  noBurdenForExternalReasons?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of plannedHowToProceed across the matching connection */
  plannedHowToProceed?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of sad across the matching connection */
  sad?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of socialDistress across the matching connection */
  socialDistress?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of strain across the matching connection */
  strain?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of strength across the matching connection */
  strength?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of stressed across the matching connection */
  stressed?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of testy across the matching connection */
  testy?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of triedToCalmMyselfDown across the matching connection */
  triedToCalmMyselfDown?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of triedToRepressMyThoughtsAndFeelings across the matching connection */
  triedToRepressMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of triedToThinkDifferently across the matching connection */
  triedToThinkDifferently?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of typicalThatNoBurdenHaveOccured across the matching connection */
  typicalThatNoBurdenHaveOccured?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of understoodDuringContact across the matching connection */
  understoodDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['BigFloat']>;
};

export type EmaEntries3StddevSampleAggregateFilter = {
  angry?: InputMaybe<BigFloatFilter>;
  anxious?: InputMaybe<BigFloatFilter>;
  anxiousDuringContact?: InputMaybe<BigFloatFilter>;
  atThatMomentIFeltMoreComfortableAlone?: InputMaybe<BigFloatFilter>;
  avoidedSocialContact?: InputMaybe<BigFloatFilter>;
  comfortableDuringContact?: InputMaybe<BigFloatFilter>;
  couldResolveBurdensInAdvance?: InputMaybe<BigFloatFilter>;
  determined?: InputMaybe<BigFloatFilter>;
  energetic?: InputMaybe<BigFloatFilter>;
  enthusiastic?: InputMaybe<BigFloatFilter>;
  expectBurdenInTheNearFuture?: InputMaybe<BigFloatFilter>;
  expectedBurdenThatDidNotOccur?: InputMaybe<BigFloatFilter>;
  guilty?: InputMaybe<BigFloatFilter>;
  happy?: InputMaybe<BigFloatFilter>;
  happyDuringContact?: InputMaybe<BigFloatFilter>;
  helpless?: InputMaybe<BigFloatFilter>;
  inspiredDuringContact?: InputMaybe<BigFloatFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<BigFloatFilter>;
  lackOfSocialContactForExternalReasons?: InputMaybe<BigFloatFilter>;
  lonely?: InputMaybe<BigFloatFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<BigFloatFilter>;
  noBurdenForExternalReasons?: InputMaybe<BigFloatFilter>;
  plannedHowToProceed?: InputMaybe<BigFloatFilter>;
  relaxed?: InputMaybe<BigFloatFilter>;
  sad?: InputMaybe<BigFloatFilter>;
  satisfied?: InputMaybe<BigFloatFilter>;
  socialDistress?: InputMaybe<BigFloatFilter>;
  strain?: InputMaybe<BigFloatFilter>;
  strength?: InputMaybe<BigFloatFilter>;
  stressed?: InputMaybe<BigFloatFilter>;
  tenseDuringContact?: InputMaybe<BigFloatFilter>;
  testy?: InputMaybe<BigFloatFilter>;
  testyDuringContact?: InputMaybe<BigFloatFilter>;
  triedToCalmMyselfDown?: InputMaybe<BigFloatFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToThinkDifferently?: InputMaybe<BigFloatFilter>;
  typicalThatNoBurdenHaveOccured?: InputMaybe<BigFloatFilter>;
  unconfidentDuringContact?: InputMaybe<BigFloatFilter>;
  understoodDuringContact?: InputMaybe<BigFloatFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<BigFloatFilter>;
};

export type EmaEntries3StddevSampleAggregates = {
  __typename?: 'EmaEntries3StddevSampleAggregates';
  /** Sample standard deviation of angry across the matching connection */
  angry?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of anxious across the matching connection */
  anxious?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of atThatMomentIFeltMoreComfortableAlone across the matching connection */
  atThatMomentIFeltMoreComfortableAlone?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of couldResolveBurdensInAdvance across the matching connection */
  couldResolveBurdensInAdvance?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of determined across the matching connection */
  determined?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of energetic across the matching connection */
  energetic?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of enthusiastic across the matching connection */
  enthusiastic?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of expectBurdenInTheNearFuture across the matching connection */
  expectBurdenInTheNearFuture?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of expectedBurdenThatDidNotOccur across the matching connection */
  expectedBurdenThatDidNotOccur?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of guilty across the matching connection */
  guilty?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of happy across the matching connection */
  happy?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of happyDuringContact across the matching connection */
  happyDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of helpless across the matching connection */
  helpless?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of inspiredDuringContact across the matching connection */
  inspiredDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of lackOfSocialContactForExternalReasons across the matching connection */
  lackOfSocialContactForExternalReasons?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of lonely across the matching connection */
  lonely?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of lookedForAdviceAndComfortFromOthers across the matching connection */
  lookedForAdviceAndComfortFromOthers?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of noBurdenForExternalReasons across the matching connection */
  noBurdenForExternalReasons?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of plannedHowToProceed across the matching connection */
  plannedHowToProceed?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of sad across the matching connection */
  sad?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of socialDistress across the matching connection */
  socialDistress?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of strain across the matching connection */
  strain?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of strength across the matching connection */
  strength?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of stressed across the matching connection */
  stressed?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of testy across the matching connection */
  testy?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of triedToCalmMyselfDown across the matching connection */
  triedToCalmMyselfDown?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of triedToRepressMyThoughtsAndFeelings across the matching connection */
  triedToRepressMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of triedToThinkDifferently across the matching connection */
  triedToThinkDifferently?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of typicalThatNoBurdenHaveOccured across the matching connection */
  typicalThatNoBurdenHaveOccured?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of understoodDuringContact across the matching connection */
  understoodDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['BigFloat']>;
};

export type EmaEntries3SumAggregateFilter = {
  angry?: InputMaybe<BigIntFilter>;
  anxious?: InputMaybe<BigIntFilter>;
  anxiousDuringContact?: InputMaybe<BigIntFilter>;
  atThatMomentIFeltMoreComfortableAlone?: InputMaybe<BigIntFilter>;
  avoidedSocialContact?: InputMaybe<BigIntFilter>;
  comfortableDuringContact?: InputMaybe<BigIntFilter>;
  couldResolveBurdensInAdvance?: InputMaybe<BigIntFilter>;
  determined?: InputMaybe<BigIntFilter>;
  energetic?: InputMaybe<BigIntFilter>;
  enthusiastic?: InputMaybe<BigIntFilter>;
  expectBurdenInTheNearFuture?: InputMaybe<BigIntFilter>;
  expectedBurdenThatDidNotOccur?: InputMaybe<BigIntFilter>;
  guilty?: InputMaybe<BigIntFilter>;
  happy?: InputMaybe<BigIntFilter>;
  happyDuringContact?: InputMaybe<BigIntFilter>;
  helpless?: InputMaybe<BigIntFilter>;
  inspiredDuringContact?: InputMaybe<BigIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<BigIntFilter>;
  lackOfSocialContactForExternalReasons?: InputMaybe<BigIntFilter>;
  lonely?: InputMaybe<BigIntFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<BigIntFilter>;
  noBurdenForExternalReasons?: InputMaybe<BigIntFilter>;
  plannedHowToProceed?: InputMaybe<BigIntFilter>;
  relaxed?: InputMaybe<BigIntFilter>;
  sad?: InputMaybe<BigIntFilter>;
  satisfied?: InputMaybe<BigIntFilter>;
  socialDistress?: InputMaybe<BigIntFilter>;
  strain?: InputMaybe<BigIntFilter>;
  strength?: InputMaybe<BigIntFilter>;
  stressed?: InputMaybe<BigIntFilter>;
  tenseDuringContact?: InputMaybe<BigIntFilter>;
  testy?: InputMaybe<BigIntFilter>;
  testyDuringContact?: InputMaybe<BigIntFilter>;
  triedToCalmMyselfDown?: InputMaybe<BigIntFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<BigIntFilter>;
  triedToThinkDifferently?: InputMaybe<BigIntFilter>;
  typicalThatNoBurdenHaveOccured?: InputMaybe<BigIntFilter>;
  unconfidentDuringContact?: InputMaybe<BigIntFilter>;
  understoodDuringContact?: InputMaybe<BigIntFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<BigIntFilter>;
};

export type EmaEntries3SumAggregates = {
  __typename?: 'EmaEntries3SumAggregates';
  /** Sum of angry across the matching connection */
  angry: Scalars['BigInt'];
  /** Sum of anxious across the matching connection */
  anxious: Scalars['BigInt'];
  /** Sum of anxiousDuringContact across the matching connection */
  anxiousDuringContact: Scalars['BigInt'];
  /** Sum of atThatMomentIFeltMoreComfortableAlone across the matching connection */
  atThatMomentIFeltMoreComfortableAlone: Scalars['BigInt'];
  /** Sum of avoidedSocialContact across the matching connection */
  avoidedSocialContact: Scalars['BigInt'];
  /** Sum of comfortableDuringContact across the matching connection */
  comfortableDuringContact: Scalars['BigInt'];
  /** Sum of couldResolveBurdensInAdvance across the matching connection */
  couldResolveBurdensInAdvance: Scalars['BigInt'];
  /** Sum of determined across the matching connection */
  determined: Scalars['BigInt'];
  /** Sum of energetic across the matching connection */
  energetic: Scalars['BigInt'];
  /** Sum of enthusiastic across the matching connection */
  enthusiastic: Scalars['BigInt'];
  /** Sum of expectBurdenInTheNearFuture across the matching connection */
  expectBurdenInTheNearFuture: Scalars['BigInt'];
  /** Sum of expectedBurdenThatDidNotOccur across the matching connection */
  expectedBurdenThatDidNotOccur: Scalars['BigInt'];
  /** Sum of guilty across the matching connection */
  guilty: Scalars['BigInt'];
  /** Sum of happy across the matching connection */
  happy: Scalars['BigInt'];
  /** Sum of happyDuringContact across the matching connection */
  happyDuringContact: Scalars['BigInt'];
  /** Sum of helpless across the matching connection */
  helpless: Scalars['BigInt'];
  /** Sum of inspiredDuringContact across the matching connection */
  inspiredDuringContact: Scalars['BigInt'];
  /** Sum of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe: Scalars['BigInt'];
  /** Sum of lackOfSocialContactForExternalReasons across the matching connection */
  lackOfSocialContactForExternalReasons: Scalars['BigInt'];
  /** Sum of lonely across the matching connection */
  lonely: Scalars['BigInt'];
  /** Sum of lookedForAdviceAndComfortFromOthers across the matching connection */
  lookedForAdviceAndComfortFromOthers: Scalars['BigInt'];
  /** Sum of noBurdenForExternalReasons across the matching connection */
  noBurdenForExternalReasons: Scalars['BigInt'];
  /** Sum of plannedHowToProceed across the matching connection */
  plannedHowToProceed: Scalars['BigInt'];
  /** Sum of relaxed across the matching connection */
  relaxed: Scalars['BigInt'];
  /** Sum of sad across the matching connection */
  sad: Scalars['BigInt'];
  /** Sum of satisfied across the matching connection */
  satisfied: Scalars['BigInt'];
  /** Sum of socialDistress across the matching connection */
  socialDistress: Scalars['BigInt'];
  /** Sum of strain across the matching connection */
  strain: Scalars['BigInt'];
  /** Sum of strength across the matching connection */
  strength: Scalars['BigInt'];
  /** Sum of stressed across the matching connection */
  stressed: Scalars['BigInt'];
  /** Sum of tenseDuringContact across the matching connection */
  tenseDuringContact: Scalars['BigInt'];
  /** Sum of testy across the matching connection */
  testy: Scalars['BigInt'];
  /** Sum of testyDuringContact across the matching connection */
  testyDuringContact: Scalars['BigInt'];
  /** Sum of triedToCalmMyselfDown across the matching connection */
  triedToCalmMyselfDown: Scalars['BigInt'];
  /** Sum of triedToRepressMyThoughtsAndFeelings across the matching connection */
  triedToRepressMyThoughtsAndFeelings: Scalars['BigInt'];
  /** Sum of triedToThinkDifferently across the matching connection */
  triedToThinkDifferently: Scalars['BigInt'];
  /** Sum of typicalThatNoBurdenHaveOccured across the matching connection */
  typicalThatNoBurdenHaveOccured: Scalars['BigInt'];
  /** Sum of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact: Scalars['BigInt'];
  /** Sum of understoodDuringContact across the matching connection */
  understoodDuringContact: Scalars['BigInt'];
  /** Sum of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact: Scalars['BigInt'];
};

export type EmaEntries3VariancePopulationAggregateFilter = {
  angry?: InputMaybe<BigFloatFilter>;
  anxious?: InputMaybe<BigFloatFilter>;
  anxiousDuringContact?: InputMaybe<BigFloatFilter>;
  atThatMomentIFeltMoreComfortableAlone?: InputMaybe<BigFloatFilter>;
  avoidedSocialContact?: InputMaybe<BigFloatFilter>;
  comfortableDuringContact?: InputMaybe<BigFloatFilter>;
  couldResolveBurdensInAdvance?: InputMaybe<BigFloatFilter>;
  determined?: InputMaybe<BigFloatFilter>;
  energetic?: InputMaybe<BigFloatFilter>;
  enthusiastic?: InputMaybe<BigFloatFilter>;
  expectBurdenInTheNearFuture?: InputMaybe<BigFloatFilter>;
  expectedBurdenThatDidNotOccur?: InputMaybe<BigFloatFilter>;
  guilty?: InputMaybe<BigFloatFilter>;
  happy?: InputMaybe<BigFloatFilter>;
  happyDuringContact?: InputMaybe<BigFloatFilter>;
  helpless?: InputMaybe<BigFloatFilter>;
  inspiredDuringContact?: InputMaybe<BigFloatFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<BigFloatFilter>;
  lackOfSocialContactForExternalReasons?: InputMaybe<BigFloatFilter>;
  lonely?: InputMaybe<BigFloatFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<BigFloatFilter>;
  noBurdenForExternalReasons?: InputMaybe<BigFloatFilter>;
  plannedHowToProceed?: InputMaybe<BigFloatFilter>;
  relaxed?: InputMaybe<BigFloatFilter>;
  sad?: InputMaybe<BigFloatFilter>;
  satisfied?: InputMaybe<BigFloatFilter>;
  socialDistress?: InputMaybe<BigFloatFilter>;
  strain?: InputMaybe<BigFloatFilter>;
  strength?: InputMaybe<BigFloatFilter>;
  stressed?: InputMaybe<BigFloatFilter>;
  tenseDuringContact?: InputMaybe<BigFloatFilter>;
  testy?: InputMaybe<BigFloatFilter>;
  testyDuringContact?: InputMaybe<BigFloatFilter>;
  triedToCalmMyselfDown?: InputMaybe<BigFloatFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToThinkDifferently?: InputMaybe<BigFloatFilter>;
  typicalThatNoBurdenHaveOccured?: InputMaybe<BigFloatFilter>;
  unconfidentDuringContact?: InputMaybe<BigFloatFilter>;
  understoodDuringContact?: InputMaybe<BigFloatFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<BigFloatFilter>;
};

export type EmaEntries3VariancePopulationAggregates = {
  __typename?: 'EmaEntries3VariancePopulationAggregates';
  /** Population variance of angry across the matching connection */
  angry?: Maybe<Scalars['BigFloat']>;
  /** Population variance of anxious across the matching connection */
  anxious?: Maybe<Scalars['BigFloat']>;
  /** Population variance of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population variance of atThatMomentIFeltMoreComfortableAlone across the matching connection */
  atThatMomentIFeltMoreComfortableAlone?: Maybe<Scalars['BigFloat']>;
  /** Population variance of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['BigFloat']>;
  /** Population variance of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population variance of couldResolveBurdensInAdvance across the matching connection */
  couldResolveBurdensInAdvance?: Maybe<Scalars['BigFloat']>;
  /** Population variance of determined across the matching connection */
  determined?: Maybe<Scalars['BigFloat']>;
  /** Population variance of energetic across the matching connection */
  energetic?: Maybe<Scalars['BigFloat']>;
  /** Population variance of enthusiastic across the matching connection */
  enthusiastic?: Maybe<Scalars['BigFloat']>;
  /** Population variance of expectBurdenInTheNearFuture across the matching connection */
  expectBurdenInTheNearFuture?: Maybe<Scalars['BigFloat']>;
  /** Population variance of expectedBurdenThatDidNotOccur across the matching connection */
  expectedBurdenThatDidNotOccur?: Maybe<Scalars['BigFloat']>;
  /** Population variance of guilty across the matching connection */
  guilty?: Maybe<Scalars['BigFloat']>;
  /** Population variance of happy across the matching connection */
  happy?: Maybe<Scalars['BigFloat']>;
  /** Population variance of happyDuringContact across the matching connection */
  happyDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population variance of helpless across the matching connection */
  helpless?: Maybe<Scalars['BigFloat']>;
  /** Population variance of inspiredDuringContact across the matching connection */
  inspiredDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population variance of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['BigFloat']>;
  /** Population variance of lackOfSocialContactForExternalReasons across the matching connection */
  lackOfSocialContactForExternalReasons?: Maybe<Scalars['BigFloat']>;
  /** Population variance of lonely across the matching connection */
  lonely?: Maybe<Scalars['BigFloat']>;
  /** Population variance of lookedForAdviceAndComfortFromOthers across the matching connection */
  lookedForAdviceAndComfortFromOthers?: Maybe<Scalars['BigFloat']>;
  /** Population variance of noBurdenForExternalReasons across the matching connection */
  noBurdenForExternalReasons?: Maybe<Scalars['BigFloat']>;
  /** Population variance of plannedHowToProceed across the matching connection */
  plannedHowToProceed?: Maybe<Scalars['BigFloat']>;
  /** Population variance of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['BigFloat']>;
  /** Population variance of sad across the matching connection */
  sad?: Maybe<Scalars['BigFloat']>;
  /** Population variance of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['BigFloat']>;
  /** Population variance of socialDistress across the matching connection */
  socialDistress?: Maybe<Scalars['BigFloat']>;
  /** Population variance of strain across the matching connection */
  strain?: Maybe<Scalars['BigFloat']>;
  /** Population variance of strength across the matching connection */
  strength?: Maybe<Scalars['BigFloat']>;
  /** Population variance of stressed across the matching connection */
  stressed?: Maybe<Scalars['BigFloat']>;
  /** Population variance of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population variance of testy across the matching connection */
  testy?: Maybe<Scalars['BigFloat']>;
  /** Population variance of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population variance of triedToCalmMyselfDown across the matching connection */
  triedToCalmMyselfDown?: Maybe<Scalars['BigFloat']>;
  /** Population variance of triedToRepressMyThoughtsAndFeelings across the matching connection */
  triedToRepressMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Population variance of triedToThinkDifferently across the matching connection */
  triedToThinkDifferently?: Maybe<Scalars['BigFloat']>;
  /** Population variance of typicalThatNoBurdenHaveOccured across the matching connection */
  typicalThatNoBurdenHaveOccured?: Maybe<Scalars['BigFloat']>;
  /** Population variance of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population variance of understoodDuringContact across the matching connection */
  understoodDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population variance of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['BigFloat']>;
};

export type EmaEntries3VarianceSampleAggregateFilter = {
  angry?: InputMaybe<BigFloatFilter>;
  anxious?: InputMaybe<BigFloatFilter>;
  anxiousDuringContact?: InputMaybe<BigFloatFilter>;
  atThatMomentIFeltMoreComfortableAlone?: InputMaybe<BigFloatFilter>;
  avoidedSocialContact?: InputMaybe<BigFloatFilter>;
  comfortableDuringContact?: InputMaybe<BigFloatFilter>;
  couldResolveBurdensInAdvance?: InputMaybe<BigFloatFilter>;
  determined?: InputMaybe<BigFloatFilter>;
  energetic?: InputMaybe<BigFloatFilter>;
  enthusiastic?: InputMaybe<BigFloatFilter>;
  expectBurdenInTheNearFuture?: InputMaybe<BigFloatFilter>;
  expectedBurdenThatDidNotOccur?: InputMaybe<BigFloatFilter>;
  guilty?: InputMaybe<BigFloatFilter>;
  happy?: InputMaybe<BigFloatFilter>;
  happyDuringContact?: InputMaybe<BigFloatFilter>;
  helpless?: InputMaybe<BigFloatFilter>;
  inspiredDuringContact?: InputMaybe<BigFloatFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<BigFloatFilter>;
  lackOfSocialContactForExternalReasons?: InputMaybe<BigFloatFilter>;
  lonely?: InputMaybe<BigFloatFilter>;
  lookedForAdviceAndComfortFromOthers?: InputMaybe<BigFloatFilter>;
  noBurdenForExternalReasons?: InputMaybe<BigFloatFilter>;
  plannedHowToProceed?: InputMaybe<BigFloatFilter>;
  relaxed?: InputMaybe<BigFloatFilter>;
  sad?: InputMaybe<BigFloatFilter>;
  satisfied?: InputMaybe<BigFloatFilter>;
  socialDistress?: InputMaybe<BigFloatFilter>;
  strain?: InputMaybe<BigFloatFilter>;
  strength?: InputMaybe<BigFloatFilter>;
  stressed?: InputMaybe<BigFloatFilter>;
  tenseDuringContact?: InputMaybe<BigFloatFilter>;
  testy?: InputMaybe<BigFloatFilter>;
  testyDuringContact?: InputMaybe<BigFloatFilter>;
  triedToCalmMyselfDown?: InputMaybe<BigFloatFilter>;
  triedToRepressMyThoughtsAndFeelings?: InputMaybe<BigFloatFilter>;
  triedToThinkDifferently?: InputMaybe<BigFloatFilter>;
  typicalThatNoBurdenHaveOccured?: InputMaybe<BigFloatFilter>;
  unconfidentDuringContact?: InputMaybe<BigFloatFilter>;
  understoodDuringContact?: InputMaybe<BigFloatFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<BigFloatFilter>;
};

export type EmaEntries3VarianceSampleAggregates = {
  __typename?: 'EmaEntries3VarianceSampleAggregates';
  /** Sample variance of angry across the matching connection */
  angry?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of anxious across the matching connection */
  anxious?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of atThatMomentIFeltMoreComfortableAlone across the matching connection */
  atThatMomentIFeltMoreComfortableAlone?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of couldResolveBurdensInAdvance across the matching connection */
  couldResolveBurdensInAdvance?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of determined across the matching connection */
  determined?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of energetic across the matching connection */
  energetic?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of enthusiastic across the matching connection */
  enthusiastic?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of expectBurdenInTheNearFuture across the matching connection */
  expectBurdenInTheNearFuture?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of expectedBurdenThatDidNotOccur across the matching connection */
  expectedBurdenThatDidNotOccur?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of guilty across the matching connection */
  guilty?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of happy across the matching connection */
  happy?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of happyDuringContact across the matching connection */
  happyDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of helpless across the matching connection */
  helpless?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of inspiredDuringContact across the matching connection */
  inspiredDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of lackOfSocialContactForExternalReasons across the matching connection */
  lackOfSocialContactForExternalReasons?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of lonely across the matching connection */
  lonely?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of lookedForAdviceAndComfortFromOthers across the matching connection */
  lookedForAdviceAndComfortFromOthers?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of noBurdenForExternalReasons across the matching connection */
  noBurdenForExternalReasons?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of plannedHowToProceed across the matching connection */
  plannedHowToProceed?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of sad across the matching connection */
  sad?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of socialDistress across the matching connection */
  socialDistress?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of strain across the matching connection */
  strain?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of strength across the matching connection */
  strength?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of stressed across the matching connection */
  stressed?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of testy across the matching connection */
  testy?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of triedToCalmMyselfDown across the matching connection */
  triedToCalmMyselfDown?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of triedToRepressMyThoughtsAndFeelings across the matching connection */
  triedToRepressMyThoughtsAndFeelings?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of triedToThinkDifferently across the matching connection */
  triedToThinkDifferently?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of typicalThatNoBurdenHaveOccured across the matching connection */
  typicalThatNoBurdenHaveOccured?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of understoodDuringContact across the matching connection */
  understoodDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['BigFloat']>;
};

/** A connection to a list of `EmaEntries3` values. */
export type EmaEntries3sConnection = {
  __typename?: 'EmaEntries3sConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<EmaEntries3Aggregates>;
  /** A list of edges which contains the `EmaEntries3` and cursor to aid in pagination. */
  edges: Array<EmaEntries3sEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<EmaEntries3Aggregates>>;
  /** A list of `EmaEntries3` objects. */
  nodes: Array<EmaEntries3>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EmaEntries3` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `EmaEntries3` values. */
export type EmaEntries3sConnectionGroupedAggregatesArgs = {
  groupBy: Array<EmaEntries3GroupBy>;
  having?: InputMaybe<EmaEntries3HavingInput>;
};

/** A `EmaEntries3` edge in the connection. */
export type EmaEntries3sEdge = {
  __typename?: 'EmaEntries3sEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EmaEntries3` at the end of the edge. */
  node: EmaEntries3;
};

/** Methods to use when ordering `EmaEntries3`. */
export type EmaEntries3sOrderBy =
  | 'ANGRY_ASC'
  | 'ANGRY_DESC'
  | 'ANXIOUS_ASC'
  | 'ANXIOUS_DESC'
  | 'ANXIOUS_DURING_CONTACT_ASC'
  | 'ANXIOUS_DURING_CONTACT_DESC'
  | 'AT_THAT_MOMENT_I_FELT_MORE_COMFORTABLE_ALONE_ASC'
  | 'AT_THAT_MOMENT_I_FELT_MORE_COMFORTABLE_ALONE_DESC'
  | 'AVOIDED_SOCIAL_CONTACT_ASC'
  | 'AVOIDED_SOCIAL_CONTACT_DESC'
  | 'BURDENS_ASC'
  | 'BURDENS_DESC'
  | 'COMFORTABLE_DURING_CONTACT_ASC'
  | 'COMFORTABLE_DURING_CONTACT_DESC'
  | 'COMPLETED_AT_ASC'
  | 'COMPLETED_AT_DESC'
  | 'COULD_RESOLVE_BURDENS_IN_ADVANCE_ASC'
  | 'COULD_RESOLVE_BURDENS_IN_ADVANCE_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DELETED_ASC'
  | 'DELETED_DESC'
  | 'DETERMINED_ASC'
  | 'DETERMINED_DESC'
  | 'ENERGETIC_ASC'
  | 'ENERGETIC_DESC'
  | 'ENTHUSIASTIC_ASC'
  | 'ENTHUSIASTIC_DESC'
  | 'EXPECTED_BURDEN_THAT_DID_NOT_OCCUR_ASC'
  | 'EXPECTED_BURDEN_THAT_DID_NOT_OCCUR_DESC'
  | 'EXPECT_BURDEN_IN_THE_NEAR_FUTURE_ASC'
  | 'EXPECT_BURDEN_IN_THE_NEAR_FUTURE_DESC'
  | 'GUILTY_ASC'
  | 'GUILTY_DESC'
  | 'HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'HAPPY_ASC'
  | 'HAPPY_DESC'
  | 'HAPPY_DURING_CONTACT_ASC'
  | 'HAPPY_DURING_CONTACT_DESC'
  | 'HELPLESS_ASC'
  | 'HELPLESS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INSPIRED_DURING_CONTACT_ASC'
  | 'INSPIRED_DURING_CONTACT_DESC'
  | 'LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'LACK_OF_SOCIAL_CONTACT_FOR_EXTERNAL_REASONS_ASC'
  | 'LACK_OF_SOCIAL_CONTACT_FOR_EXTERNAL_REASONS_DESC'
  | 'LONELY_ASC'
  | 'LONELY_DESC'
  | 'LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_ASC'
  | 'LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_DESC'
  | 'NATURAL'
  | 'NO_BURDEN_FOR_EXTERNAL_REASONS_ASC'
  | 'NO_BURDEN_FOR_EXTERNAL_REASONS_DESC'
  | 'PLANNED_HOW_TO_PROCEED_ASC'
  | 'PLANNED_HOW_TO_PROCEED_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'RELAXED_ASC'
  | 'RELAXED_DESC'
  | 'SAD_ASC'
  | 'SAD_DESC'
  | 'SATISFIED_ASC'
  | 'SATISFIED_DESC'
  | 'SCHEDULED_AT_ASC'
  | 'SCHEDULED_AT_DESC'
  | 'SMS_RECEIVED_AT_ASC'
  | 'SMS_RECEIVED_AT_DESC'
  | 'SOCIAL_DISTRESS_ASC'
  | 'SOCIAL_DISTRESS_DESC'
  | 'STARTED_AT_ASC'
  | 'STARTED_AT_DESC'
  | 'STRAIN_ASC'
  | 'STRAIN_DESC'
  | 'STRENGTH_ASC'
  | 'STRENGTH_DESC'
  | 'STRESSED_ASC'
  | 'STRESSED_DESC'
  | 'TENSE_DURING_CONTACT_ASC'
  | 'TENSE_DURING_CONTACT_DESC'
  | 'TESTY_ASC'
  | 'TESTY_DESC'
  | 'TESTY_DURING_CONTACT_ASC'
  | 'TESTY_DURING_CONTACT_DESC'
  | 'TRIAL_ID_ASC'
  | 'TRIAL_ID_DESC'
  | 'TRIED_TO_CALM_MYSELF_DOWN_ASC'
  | 'TRIED_TO_CALM_MYSELF_DOWN_DESC'
  | 'TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'TRIED_TO_THINK_DIFFERENTLY_ASC'
  | 'TRIED_TO_THINK_DIFFERENTLY_DESC'
  | 'TYPICAL_THAT_NO_BURDEN_HAVE_OCCURED_ASC'
  | 'TYPICAL_THAT_NO_BURDEN_HAVE_OCCURED_DESC'
  | 'UNCONFIDENT_DURING_CONTACT_ASC'
  | 'UNCONFIDENT_DURING_CONTACT_DESC'
  | 'UNDERSTOOD_DURING_CONTACT_ASC'
  | 'UNDERSTOOD_DURING_CONTACT_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'WAVE_ASC'
  | 'WAVE_DESC'
  | 'WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC';

/** A connection to a list of `EmaEntry` values. */
export type EmaEntriesConnection = {
  __typename?: 'EmaEntriesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<EmaEntryAggregates>;
  /** A list of edges which contains the `EmaEntry` and cursor to aid in pagination. */
  edges: Array<EmaEntriesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<EmaEntryAggregates>>;
  /** A list of `EmaEntry` objects. */
  nodes: Array<EmaEntry>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `EmaEntry` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `EmaEntry` values. */
export type EmaEntriesConnectionGroupedAggregatesArgs = {
  groupBy: Array<EmaEntriesGroupBy>;
  having?: InputMaybe<EmaEntriesHavingInput>;
};

/** A `EmaEntry` edge in the connection. */
export type EmaEntriesEdge = {
  __typename?: 'EmaEntriesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `EmaEntry` at the end of the edge. */
  node: EmaEntry;
};

/** Grouping methods for `EmaEntry` for usage during aggregation. */
export type EmaEntriesGroupBy =
  | 'ANGRY'
  | 'ANXIOUS'
  | 'ANXIOUS_DURING_CONTACT'
  | 'AVOIDED_SOCIAL_CONTACT'
  | 'COMFORTABLE_DURING_CONTACT'
  | 'COMPLETED_AT'
  | 'COMPLETED_AT_TRUNCATED_TO_DAY'
  | 'COMPLETED_AT_TRUNCATED_TO_HOUR'
  | 'COPING_HELPED_IN_THE_SITUATION'
  | 'COULD_THINK_OF_NOTHING_ELSE_THAN_THE_SITATION'
  | 'CREATED_AT'
  | 'CREATED_AT_TRUNCATED_TO_DAY'
  | 'CREATED_AT_TRUNCATED_TO_HOUR'
  | 'DELETED'
  | 'GUILTY'
  | 'HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY'
  | 'HAD_A_STRESSFUL_SITUATION'
  | 'HAPPY'
  | 'LACK_OF_SOCIAL_CONTACT_BOTHERS_ME'
  | 'LONELY'
  | 'NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS'
  | 'RELAXED'
  | 'SAD'
  | 'SATISFIED'
  | 'SCHEDULED_AT'
  | 'SCHEDULED_AT_TRUNCATED_TO_DAY'
  | 'SCHEDULED_AT_TRUNCATED_TO_HOUR'
  | 'STARTED_AT'
  | 'STARTED_AT_TRUNCATED_TO_DAY'
  | 'STARTED_AT_TRUNCATED_TO_HOUR'
  | 'SUBJECT_ID'
  | 'TENSE_DURING_CONTACT'
  | 'TESTY'
  | 'TESTY_DURING_CONTACT'
  | 'TRIED_NOT_TO_THINK_OF_THE_SITATION'
  | 'TRIED_SOMETHING_ELSE_TO_COPE_WITH_THE_SITUATION'
  | 'TRIED_TO_ACCEPT_THE_SITUATION'
  | 'TRIED_TO_ALTER_FEELINGS'
  | 'TRIED_TO_CALM_MYSELF'
  | 'TRIED_TO_CHANGE_THE_SITUATION'
  | 'TRIED_TO_FIND_A_SOLUTION_FOR_THE_PROBLEM'
  | 'TRIED_TO_FIND_THE_CAUSE_OF_THE_PROBLEM'
  | 'TRIED_TO_THINK_DIFFERENTLY'
  | 'UNCONFIDENT_DURING_CONTACT'
  | 'UPDATED_AT'
  | 'UPDATED_AT_TRUNCATED_TO_DAY'
  | 'UPDATED_AT_TRUNCATED_TO_HOUR'
  | 'WOULD_HAVE_LIKED_SOCIAL_CONTACT';

export type EmaEntriesHavingAverageInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  copingHelpedInTheSituation?: InputMaybe<HavingIntFilter>;
  couldThinkOfNothingElseThanTheSitation?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  triedNotToThinkOfTheSitation?: InputMaybe<HavingIntFilter>;
  triedSomethingElseToCopeWithTheSituation?: InputMaybe<HavingIntFilter>;
  triedToAcceptTheSituation?: InputMaybe<HavingIntFilter>;
  triedToAlterFeelings?: InputMaybe<HavingIntFilter>;
  triedToCalmMyself?: InputMaybe<HavingIntFilter>;
  triedToChangeTheSituation?: InputMaybe<HavingIntFilter>;
  triedToFindASolutionForTheProblem?: InputMaybe<HavingIntFilter>;
  triedToFindTheCauseOfTheProblem?: InputMaybe<HavingIntFilter>;
  triedToThinkDifferently?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

export type EmaEntriesHavingDistinctCountInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  copingHelpedInTheSituation?: InputMaybe<HavingIntFilter>;
  couldThinkOfNothingElseThanTheSitation?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  triedNotToThinkOfTheSitation?: InputMaybe<HavingIntFilter>;
  triedSomethingElseToCopeWithTheSituation?: InputMaybe<HavingIntFilter>;
  triedToAcceptTheSituation?: InputMaybe<HavingIntFilter>;
  triedToAlterFeelings?: InputMaybe<HavingIntFilter>;
  triedToCalmMyself?: InputMaybe<HavingIntFilter>;
  triedToChangeTheSituation?: InputMaybe<HavingIntFilter>;
  triedToFindASolutionForTheProblem?: InputMaybe<HavingIntFilter>;
  triedToFindTheCauseOfTheProblem?: InputMaybe<HavingIntFilter>;
  triedToThinkDifferently?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `EmaEntry` aggregates. */
export type EmaEntriesHavingInput = {
  AND?: InputMaybe<Array<EmaEntriesHavingInput>>;
  OR?: InputMaybe<Array<EmaEntriesHavingInput>>;
  average?: InputMaybe<EmaEntriesHavingAverageInput>;
  distinctCount?: InputMaybe<EmaEntriesHavingDistinctCountInput>;
  max?: InputMaybe<EmaEntriesHavingMaxInput>;
  min?: InputMaybe<EmaEntriesHavingMinInput>;
  stddevPopulation?: InputMaybe<EmaEntriesHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<EmaEntriesHavingStddevSampleInput>;
  sum?: InputMaybe<EmaEntriesHavingSumInput>;
  variancePopulation?: InputMaybe<EmaEntriesHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<EmaEntriesHavingVarianceSampleInput>;
};

export type EmaEntriesHavingMaxInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  copingHelpedInTheSituation?: InputMaybe<HavingIntFilter>;
  couldThinkOfNothingElseThanTheSitation?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  triedNotToThinkOfTheSitation?: InputMaybe<HavingIntFilter>;
  triedSomethingElseToCopeWithTheSituation?: InputMaybe<HavingIntFilter>;
  triedToAcceptTheSituation?: InputMaybe<HavingIntFilter>;
  triedToAlterFeelings?: InputMaybe<HavingIntFilter>;
  triedToCalmMyself?: InputMaybe<HavingIntFilter>;
  triedToChangeTheSituation?: InputMaybe<HavingIntFilter>;
  triedToFindASolutionForTheProblem?: InputMaybe<HavingIntFilter>;
  triedToFindTheCauseOfTheProblem?: InputMaybe<HavingIntFilter>;
  triedToThinkDifferently?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

export type EmaEntriesHavingMinInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  copingHelpedInTheSituation?: InputMaybe<HavingIntFilter>;
  couldThinkOfNothingElseThanTheSitation?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  triedNotToThinkOfTheSitation?: InputMaybe<HavingIntFilter>;
  triedSomethingElseToCopeWithTheSituation?: InputMaybe<HavingIntFilter>;
  triedToAcceptTheSituation?: InputMaybe<HavingIntFilter>;
  triedToAlterFeelings?: InputMaybe<HavingIntFilter>;
  triedToCalmMyself?: InputMaybe<HavingIntFilter>;
  triedToChangeTheSituation?: InputMaybe<HavingIntFilter>;
  triedToFindASolutionForTheProblem?: InputMaybe<HavingIntFilter>;
  triedToFindTheCauseOfTheProblem?: InputMaybe<HavingIntFilter>;
  triedToThinkDifferently?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

export type EmaEntriesHavingStddevPopulationInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  copingHelpedInTheSituation?: InputMaybe<HavingIntFilter>;
  couldThinkOfNothingElseThanTheSitation?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  triedNotToThinkOfTheSitation?: InputMaybe<HavingIntFilter>;
  triedSomethingElseToCopeWithTheSituation?: InputMaybe<HavingIntFilter>;
  triedToAcceptTheSituation?: InputMaybe<HavingIntFilter>;
  triedToAlterFeelings?: InputMaybe<HavingIntFilter>;
  triedToCalmMyself?: InputMaybe<HavingIntFilter>;
  triedToChangeTheSituation?: InputMaybe<HavingIntFilter>;
  triedToFindASolutionForTheProblem?: InputMaybe<HavingIntFilter>;
  triedToFindTheCauseOfTheProblem?: InputMaybe<HavingIntFilter>;
  triedToThinkDifferently?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

export type EmaEntriesHavingStddevSampleInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  copingHelpedInTheSituation?: InputMaybe<HavingIntFilter>;
  couldThinkOfNothingElseThanTheSitation?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  triedNotToThinkOfTheSitation?: InputMaybe<HavingIntFilter>;
  triedSomethingElseToCopeWithTheSituation?: InputMaybe<HavingIntFilter>;
  triedToAcceptTheSituation?: InputMaybe<HavingIntFilter>;
  triedToAlterFeelings?: InputMaybe<HavingIntFilter>;
  triedToCalmMyself?: InputMaybe<HavingIntFilter>;
  triedToChangeTheSituation?: InputMaybe<HavingIntFilter>;
  triedToFindASolutionForTheProblem?: InputMaybe<HavingIntFilter>;
  triedToFindTheCauseOfTheProblem?: InputMaybe<HavingIntFilter>;
  triedToThinkDifferently?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

export type EmaEntriesHavingSumInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  copingHelpedInTheSituation?: InputMaybe<HavingIntFilter>;
  couldThinkOfNothingElseThanTheSitation?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  triedNotToThinkOfTheSitation?: InputMaybe<HavingIntFilter>;
  triedSomethingElseToCopeWithTheSituation?: InputMaybe<HavingIntFilter>;
  triedToAcceptTheSituation?: InputMaybe<HavingIntFilter>;
  triedToAlterFeelings?: InputMaybe<HavingIntFilter>;
  triedToCalmMyself?: InputMaybe<HavingIntFilter>;
  triedToChangeTheSituation?: InputMaybe<HavingIntFilter>;
  triedToFindASolutionForTheProblem?: InputMaybe<HavingIntFilter>;
  triedToFindTheCauseOfTheProblem?: InputMaybe<HavingIntFilter>;
  triedToThinkDifferently?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

export type EmaEntriesHavingVariancePopulationInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  copingHelpedInTheSituation?: InputMaybe<HavingIntFilter>;
  couldThinkOfNothingElseThanTheSitation?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  triedNotToThinkOfTheSitation?: InputMaybe<HavingIntFilter>;
  triedSomethingElseToCopeWithTheSituation?: InputMaybe<HavingIntFilter>;
  triedToAcceptTheSituation?: InputMaybe<HavingIntFilter>;
  triedToAlterFeelings?: InputMaybe<HavingIntFilter>;
  triedToCalmMyself?: InputMaybe<HavingIntFilter>;
  triedToChangeTheSituation?: InputMaybe<HavingIntFilter>;
  triedToFindASolutionForTheProblem?: InputMaybe<HavingIntFilter>;
  triedToFindTheCauseOfTheProblem?: InputMaybe<HavingIntFilter>;
  triedToThinkDifferently?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

export type EmaEntriesHavingVarianceSampleInput = {
  angry?: InputMaybe<HavingIntFilter>;
  anxious?: InputMaybe<HavingIntFilter>;
  anxiousDuringContact?: InputMaybe<HavingIntFilter>;
  avoidedSocialContact?: InputMaybe<HavingIntFilter>;
  comfortableDuringContact?: InputMaybe<HavingIntFilter>;
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  copingHelpedInTheSituation?: InputMaybe<HavingIntFilter>;
  couldThinkOfNothingElseThanTheSitation?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  guilty?: InputMaybe<HavingIntFilter>;
  happy?: InputMaybe<HavingIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<HavingIntFilter>;
  lonely?: InputMaybe<HavingIntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<HavingIntFilter>;
  relaxed?: InputMaybe<HavingIntFilter>;
  sad?: InputMaybe<HavingIntFilter>;
  satisfied?: InputMaybe<HavingIntFilter>;
  scheduledAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  tenseDuringContact?: InputMaybe<HavingIntFilter>;
  testy?: InputMaybe<HavingIntFilter>;
  testyDuringContact?: InputMaybe<HavingIntFilter>;
  triedNotToThinkOfTheSitation?: InputMaybe<HavingIntFilter>;
  triedSomethingElseToCopeWithTheSituation?: InputMaybe<HavingIntFilter>;
  triedToAcceptTheSituation?: InputMaybe<HavingIntFilter>;
  triedToAlterFeelings?: InputMaybe<HavingIntFilter>;
  triedToCalmMyself?: InputMaybe<HavingIntFilter>;
  triedToChangeTheSituation?: InputMaybe<HavingIntFilter>;
  triedToFindASolutionForTheProblem?: InputMaybe<HavingIntFilter>;
  triedToFindTheCauseOfTheProblem?: InputMaybe<HavingIntFilter>;
  triedToThinkDifferently?: InputMaybe<HavingIntFilter>;
  unconfidentDuringContact?: InputMaybe<HavingIntFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<HavingIntFilter>;
};

/** Methods to use when ordering `EmaEntry`. */
export type EmaEntriesOrderBy =
  | 'ANGRY_ASC'
  | 'ANGRY_DESC'
  | 'ANXIOUS_ASC'
  | 'ANXIOUS_DESC'
  | 'ANXIOUS_DURING_CONTACT_ASC'
  | 'ANXIOUS_DURING_CONTACT_DESC'
  | 'AVOIDED_SOCIAL_CONTACT_ASC'
  | 'AVOIDED_SOCIAL_CONTACT_DESC'
  | 'COMFORTABLE_DURING_CONTACT_ASC'
  | 'COMFORTABLE_DURING_CONTACT_DESC'
  | 'COMPLETED_AT_ASC'
  | 'COMPLETED_AT_DESC'
  | 'COPING_HELPED_IN_THE_SITUATION_ASC'
  | 'COPING_HELPED_IN_THE_SITUATION_DESC'
  | 'COULD_THINK_OF_NOTHING_ELSE_THAN_THE_SITATION_ASC'
  | 'COULD_THINK_OF_NOTHING_ELSE_THAN_THE_SITATION_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'DELETED_ASC'
  | 'DELETED_DESC'
  | 'GUILTY_ASC'
  | 'GUILTY_DESC'
  | 'HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'HAD_A_STRESSFUL_SITUATION_ASC'
  | 'HAD_A_STRESSFUL_SITUATION_DESC'
  | 'HAPPY_ASC'
  | 'HAPPY_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'LONELY_ASC'
  | 'LONELY_DESC'
  | 'NATURAL'
  | 'NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_ASC'
  | 'NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'RELAXED_ASC'
  | 'RELAXED_DESC'
  | 'SAD_ASC'
  | 'SAD_DESC'
  | 'SATISFIED_ASC'
  | 'SATISFIED_DESC'
  | 'SCHEDULED_AT_ASC'
  | 'SCHEDULED_AT_DESC'
  | 'STARTED_AT_ASC'
  | 'STARTED_AT_DESC'
  | 'SUBJECT_ID_ASC'
  | 'SUBJECT_ID_DESC'
  | 'TENSE_DURING_CONTACT_ASC'
  | 'TENSE_DURING_CONTACT_DESC'
  | 'TESTY_ASC'
  | 'TESTY_DESC'
  | 'TESTY_DURING_CONTACT_ASC'
  | 'TESTY_DURING_CONTACT_DESC'
  | 'TRIED_NOT_TO_THINK_OF_THE_SITATION_ASC'
  | 'TRIED_NOT_TO_THINK_OF_THE_SITATION_DESC'
  | 'TRIED_SOMETHING_ELSE_TO_COPE_WITH_THE_SITUATION_ASC'
  | 'TRIED_SOMETHING_ELSE_TO_COPE_WITH_THE_SITUATION_DESC'
  | 'TRIED_TO_ACCEPT_THE_SITUATION_ASC'
  | 'TRIED_TO_ACCEPT_THE_SITUATION_DESC'
  | 'TRIED_TO_ALTER_FEELINGS_ASC'
  | 'TRIED_TO_ALTER_FEELINGS_DESC'
  | 'TRIED_TO_CALM_MYSELF_ASC'
  | 'TRIED_TO_CALM_MYSELF_DESC'
  | 'TRIED_TO_CHANGE_THE_SITUATION_ASC'
  | 'TRIED_TO_CHANGE_THE_SITUATION_DESC'
  | 'TRIED_TO_FIND_A_SOLUTION_FOR_THE_PROBLEM_ASC'
  | 'TRIED_TO_FIND_A_SOLUTION_FOR_THE_PROBLEM_DESC'
  | 'TRIED_TO_FIND_THE_CAUSE_OF_THE_PROBLEM_ASC'
  | 'TRIED_TO_FIND_THE_CAUSE_OF_THE_PROBLEM_DESC'
  | 'TRIED_TO_THINK_DIFFERENTLY_ASC'
  | 'TRIED_TO_THINK_DIFFERENTLY_DESC'
  | 'UNCONFIDENT_DURING_CONTACT_ASC'
  | 'UNCONFIDENT_DURING_CONTACT_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'UPDATED_AT_UTC_ASC'
  | 'UPDATED_AT_UTC_DESC'
  | 'WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC';

export type EmaEntry = Node & {
  __typename?: 'EmaEntry';
  angry?: Maybe<Scalars['Int']>;
  anxious?: Maybe<Scalars['Int']>;
  anxiousDuringContact?: Maybe<Scalars['Int']>;
  avoidedSocialContact?: Maybe<Scalars['Int']>;
  comfortableDuringContact?: Maybe<Scalars['Int']>;
  completedAt?: Maybe<Scalars['Datetime']>;
  copingHelpedInTheSituation?: Maybe<Scalars['Int']>;
  couldThinkOfNothingElseThanTheSitation?: Maybe<Scalars['Int']>;
  createdAt: Scalars['Datetime'];
  deleted: Scalars['Boolean'];
  guilty?: Maybe<Scalars['Int']>;
  hadAStressfulSituation?: Maybe<Scalars['Boolean']>;
  hadAnyContactWithOthersSinceTheLastSurvey?: Maybe<Scalars['Boolean']>;
  happy?: Maybe<Scalars['Int']>;
  id: Scalars['UUID'];
  lackOfSocialContactBothersMe?: Maybe<Scalars['Int']>;
  lonely?: Maybe<Scalars['Int']>;
  noSocialContactDueToOuterConditions?: Maybe<Scalars['Int']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  relaxed?: Maybe<Scalars['Int']>;
  sad?: Maybe<Scalars['Int']>;
  satisfied?: Maybe<Scalars['Int']>;
  scheduledAt: Scalars['Datetime'];
  startedAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `User` that is related to this `EmaEntry`. */
  subject?: Maybe<User>;
  subjectId: Scalars['UUID'];
  tenseDuringContact?: Maybe<Scalars['Int']>;
  testy?: Maybe<Scalars['Int']>;
  testyDuringContact?: Maybe<Scalars['Int']>;
  triedNotToThinkOfTheSitation?: Maybe<Scalars['Int']>;
  triedSomethingElseToCopeWithTheSituation?: Maybe<Scalars['Int']>;
  triedToAcceptTheSituation?: Maybe<Scalars['Int']>;
  triedToAlterFeelings?: Maybe<Scalars['Int']>;
  triedToCalmMyself?: Maybe<Scalars['Int']>;
  triedToChangeTheSituation?: Maybe<Scalars['Int']>;
  triedToFindASolutionForTheProblem?: Maybe<Scalars['Int']>;
  triedToFindTheCauseOfTheProblem?: Maybe<Scalars['Int']>;
  triedToThinkDifferently?: Maybe<Scalars['Int']>;
  unconfidentDuringContact?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['Datetime'];
  updatedAtUtc?: Maybe<Scalars['String']>;
  wouldHaveLikedSocialContact?: Maybe<Scalars['Int']>;
};

export type EmaEntryAggregates = {
  __typename?: 'EmaEntryAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<EmaEntryAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<EmaEntryDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<EmaEntryMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<EmaEntryMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<EmaEntryStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<EmaEntryStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<EmaEntrySumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<EmaEntryVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<EmaEntryVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `EmaEntry` object types. */
export type EmaEntryAggregatesFilter = {
  /** Mean average aggregate over matching `EmaEntry` objects. */
  average?: InputMaybe<EmaEntryAverageAggregateFilter>;
  /** Distinct count aggregate over matching `EmaEntry` objects. */
  distinctCount?: InputMaybe<EmaEntryDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `EmaEntry` object to be included within the aggregate. */
  filter?: InputMaybe<EmaEntryFilter>;
  /** Maximum aggregate over matching `EmaEntry` objects. */
  max?: InputMaybe<EmaEntryMaxAggregateFilter>;
  /** Minimum aggregate over matching `EmaEntry` objects. */
  min?: InputMaybe<EmaEntryMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `EmaEntry` objects. */
  stddevPopulation?: InputMaybe<EmaEntryStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `EmaEntry` objects. */
  stddevSample?: InputMaybe<EmaEntryStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `EmaEntry` objects. */
  sum?: InputMaybe<EmaEntrySumAggregateFilter>;
  /** Population variance aggregate over matching `EmaEntry` objects. */
  variancePopulation?: InputMaybe<EmaEntryVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `EmaEntry` objects. */
  varianceSample?: InputMaybe<EmaEntryVarianceSampleAggregateFilter>;
};

export type EmaEntryAverageAggregateFilter = {
  angry?: InputMaybe<BigFloatFilter>;
  anxious?: InputMaybe<BigFloatFilter>;
  anxiousDuringContact?: InputMaybe<BigFloatFilter>;
  avoidedSocialContact?: InputMaybe<BigFloatFilter>;
  comfortableDuringContact?: InputMaybe<BigFloatFilter>;
  copingHelpedInTheSituation?: InputMaybe<BigFloatFilter>;
  couldThinkOfNothingElseThanTheSitation?: InputMaybe<BigFloatFilter>;
  guilty?: InputMaybe<BigFloatFilter>;
  happy?: InputMaybe<BigFloatFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<BigFloatFilter>;
  lonely?: InputMaybe<BigFloatFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<BigFloatFilter>;
  relaxed?: InputMaybe<BigFloatFilter>;
  sad?: InputMaybe<BigFloatFilter>;
  satisfied?: InputMaybe<BigFloatFilter>;
  tenseDuringContact?: InputMaybe<BigFloatFilter>;
  testy?: InputMaybe<BigFloatFilter>;
  testyDuringContact?: InputMaybe<BigFloatFilter>;
  triedNotToThinkOfTheSitation?: InputMaybe<BigFloatFilter>;
  triedSomethingElseToCopeWithTheSituation?: InputMaybe<BigFloatFilter>;
  triedToAcceptTheSituation?: InputMaybe<BigFloatFilter>;
  triedToAlterFeelings?: InputMaybe<BigFloatFilter>;
  triedToCalmMyself?: InputMaybe<BigFloatFilter>;
  triedToChangeTheSituation?: InputMaybe<BigFloatFilter>;
  triedToFindASolutionForTheProblem?: InputMaybe<BigFloatFilter>;
  triedToFindTheCauseOfTheProblem?: InputMaybe<BigFloatFilter>;
  triedToThinkDifferently?: InputMaybe<BigFloatFilter>;
  unconfidentDuringContact?: InputMaybe<BigFloatFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<BigFloatFilter>;
};

export type EmaEntryAverageAggregates = {
  __typename?: 'EmaEntryAverageAggregates';
  /** Mean average of angry across the matching connection */
  angry?: Maybe<Scalars['BigFloat']>;
  /** Mean average of anxious across the matching connection */
  anxious?: Maybe<Scalars['BigFloat']>;
  /** Mean average of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Mean average of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['BigFloat']>;
  /** Mean average of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Mean average of copingHelpedInTheSituation across the matching connection */
  copingHelpedInTheSituation?: Maybe<Scalars['BigFloat']>;
  /** Mean average of couldThinkOfNothingElseThanTheSitation across the matching connection */
  couldThinkOfNothingElseThanTheSitation?: Maybe<Scalars['BigFloat']>;
  /** Mean average of guilty across the matching connection */
  guilty?: Maybe<Scalars['BigFloat']>;
  /** Mean average of happy across the matching connection */
  happy?: Maybe<Scalars['BigFloat']>;
  /** Mean average of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['BigFloat']>;
  /** Mean average of lonely across the matching connection */
  lonely?: Maybe<Scalars['BigFloat']>;
  /** Mean average of noSocialContactDueToOuterConditions across the matching connection */
  noSocialContactDueToOuterConditions?: Maybe<Scalars['BigFloat']>;
  /** Mean average of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['BigFloat']>;
  /** Mean average of sad across the matching connection */
  sad?: Maybe<Scalars['BigFloat']>;
  /** Mean average of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['BigFloat']>;
  /** Mean average of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Mean average of testy across the matching connection */
  testy?: Maybe<Scalars['BigFloat']>;
  /** Mean average of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Mean average of triedNotToThinkOfTheSitation across the matching connection */
  triedNotToThinkOfTheSitation?: Maybe<Scalars['BigFloat']>;
  /** Mean average of triedSomethingElseToCopeWithTheSituation across the matching connection */
  triedSomethingElseToCopeWithTheSituation?: Maybe<Scalars['BigFloat']>;
  /** Mean average of triedToAcceptTheSituation across the matching connection */
  triedToAcceptTheSituation?: Maybe<Scalars['BigFloat']>;
  /** Mean average of triedToAlterFeelings across the matching connection */
  triedToAlterFeelings?: Maybe<Scalars['BigFloat']>;
  /** Mean average of triedToCalmMyself across the matching connection */
  triedToCalmMyself?: Maybe<Scalars['BigFloat']>;
  /** Mean average of triedToChangeTheSituation across the matching connection */
  triedToChangeTheSituation?: Maybe<Scalars['BigFloat']>;
  /** Mean average of triedToFindASolutionForTheProblem across the matching connection */
  triedToFindASolutionForTheProblem?: Maybe<Scalars['BigFloat']>;
  /** Mean average of triedToFindTheCauseOfTheProblem across the matching connection */
  triedToFindTheCauseOfTheProblem?: Maybe<Scalars['BigFloat']>;
  /** Mean average of triedToThinkDifferently across the matching connection */
  triedToThinkDifferently?: Maybe<Scalars['BigFloat']>;
  /** Mean average of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Mean average of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `EmaEntry` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type EmaEntryCondition = {
  /** Checks for equality with the object’s `angry` field. */
  angry?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `anxious` field. */
  anxious?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `anxiousDuringContact` field. */
  anxiousDuringContact?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `avoidedSocialContact` field. */
  avoidedSocialContact?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `comfortableDuringContact` field. */
  comfortableDuringContact?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `completedAt` field. */
  completedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `copingHelpedInTheSituation` field. */
  copingHelpedInTheSituation?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `couldThinkOfNothingElseThanTheSitation` field. */
  couldThinkOfNothingElseThanTheSitation?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `deleted` field. */
  deleted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `guilty` field. */
  guilty?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `hadAStressfulSituation` field. */
  hadAStressfulSituation?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `hadAnyContactWithOthersSinceTheLastSurvey` field. */
  hadAnyContactWithOthersSinceTheLastSurvey?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `happy` field. */
  happy?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `lackOfSocialContactBothersMe` field. */
  lackOfSocialContactBothersMe?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `lonely` field. */
  lonely?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `noSocialContactDueToOuterConditions` field. */
  noSocialContactDueToOuterConditions?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `relaxed` field. */
  relaxed?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `sad` field. */
  sad?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `satisfied` field. */
  satisfied?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `scheduledAt` field. */
  scheduledAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `startedAt` field. */
  startedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `subjectId` field. */
  subjectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `tenseDuringContact` field. */
  tenseDuringContact?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `testy` field. */
  testy?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `testyDuringContact` field. */
  testyDuringContact?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `triedNotToThinkOfTheSitation` field. */
  triedNotToThinkOfTheSitation?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `triedSomethingElseToCopeWithTheSituation` field. */
  triedSomethingElseToCopeWithTheSituation?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `triedToAcceptTheSituation` field. */
  triedToAcceptTheSituation?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `triedToAlterFeelings` field. */
  triedToAlterFeelings?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `triedToCalmMyself` field. */
  triedToCalmMyself?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `triedToChangeTheSituation` field. */
  triedToChangeTheSituation?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `triedToFindASolutionForTheProblem` field. */
  triedToFindASolutionForTheProblem?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `triedToFindTheCauseOfTheProblem` field. */
  triedToFindTheCauseOfTheProblem?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `triedToThinkDifferently` field. */
  triedToThinkDifferently?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `unconfidentDuringContact` field. */
  unconfidentDuringContact?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAtUtc` field. */
  updatedAtUtc?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `wouldHaveLikedSocialContact` field. */
  wouldHaveLikedSocialContact?: InputMaybe<Scalars['Int']>;
};

export type EmaEntryDistinctCountAggregateFilter = {
  angry?: InputMaybe<BigIntFilter>;
  anxious?: InputMaybe<BigIntFilter>;
  anxiousDuringContact?: InputMaybe<BigIntFilter>;
  avoidedSocialContact?: InputMaybe<BigIntFilter>;
  comfortableDuringContact?: InputMaybe<BigIntFilter>;
  completedAt?: InputMaybe<BigIntFilter>;
  copingHelpedInTheSituation?: InputMaybe<BigIntFilter>;
  couldThinkOfNothingElseThanTheSitation?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  deleted?: InputMaybe<BigIntFilter>;
  guilty?: InputMaybe<BigIntFilter>;
  hadAStressfulSituation?: InputMaybe<BigIntFilter>;
  hadAnyContactWithOthersSinceTheLastSurvey?: InputMaybe<BigIntFilter>;
  happy?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<BigIntFilter>;
  lonely?: InputMaybe<BigIntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<BigIntFilter>;
  relaxed?: InputMaybe<BigIntFilter>;
  sad?: InputMaybe<BigIntFilter>;
  satisfied?: InputMaybe<BigIntFilter>;
  scheduledAt?: InputMaybe<BigIntFilter>;
  startedAt?: InputMaybe<BigIntFilter>;
  subjectId?: InputMaybe<BigIntFilter>;
  tenseDuringContact?: InputMaybe<BigIntFilter>;
  testy?: InputMaybe<BigIntFilter>;
  testyDuringContact?: InputMaybe<BigIntFilter>;
  triedNotToThinkOfTheSitation?: InputMaybe<BigIntFilter>;
  triedSomethingElseToCopeWithTheSituation?: InputMaybe<BigIntFilter>;
  triedToAcceptTheSituation?: InputMaybe<BigIntFilter>;
  triedToAlterFeelings?: InputMaybe<BigIntFilter>;
  triedToCalmMyself?: InputMaybe<BigIntFilter>;
  triedToChangeTheSituation?: InputMaybe<BigIntFilter>;
  triedToFindASolutionForTheProblem?: InputMaybe<BigIntFilter>;
  triedToFindTheCauseOfTheProblem?: InputMaybe<BigIntFilter>;
  triedToThinkDifferently?: InputMaybe<BigIntFilter>;
  unconfidentDuringContact?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
  updatedAtUtc?: InputMaybe<StringFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<BigIntFilter>;
};

export type EmaEntryDistinctCountAggregates = {
  __typename?: 'EmaEntryDistinctCountAggregates';
  /** Distinct count of angry across the matching connection */
  angry?: Maybe<Scalars['BigInt']>;
  /** Distinct count of anxious across the matching connection */
  anxious?: Maybe<Scalars['BigInt']>;
  /** Distinct count of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['BigInt']>;
  /** Distinct count of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['BigInt']>;
  /** Distinct count of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['BigInt']>;
  /** Distinct count of completedAt across the matching connection */
  completedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of copingHelpedInTheSituation across the matching connection */
  copingHelpedInTheSituation?: Maybe<Scalars['BigInt']>;
  /** Distinct count of couldThinkOfNothingElseThanTheSitation across the matching connection */
  couldThinkOfNothingElseThanTheSitation?: Maybe<Scalars['BigInt']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of deleted across the matching connection */
  deleted?: Maybe<Scalars['BigInt']>;
  /** Distinct count of guilty across the matching connection */
  guilty?: Maybe<Scalars['BigInt']>;
  /** Distinct count of hadAStressfulSituation across the matching connection */
  hadAStressfulSituation?: Maybe<Scalars['BigInt']>;
  /** Distinct count of hadAnyContactWithOthersSinceTheLastSurvey across the matching connection */
  hadAnyContactWithOthersSinceTheLastSurvey?: Maybe<Scalars['BigInt']>;
  /** Distinct count of happy across the matching connection */
  happy?: Maybe<Scalars['BigInt']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']>;
  /** Distinct count of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['BigInt']>;
  /** Distinct count of lonely across the matching connection */
  lonely?: Maybe<Scalars['BigInt']>;
  /** Distinct count of noSocialContactDueToOuterConditions across the matching connection */
  noSocialContactDueToOuterConditions?: Maybe<Scalars['BigInt']>;
  /** Distinct count of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['BigInt']>;
  /** Distinct count of sad across the matching connection */
  sad?: Maybe<Scalars['BigInt']>;
  /** Distinct count of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['BigInt']>;
  /** Distinct count of scheduledAt across the matching connection */
  scheduledAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of startedAt across the matching connection */
  startedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of subjectId across the matching connection */
  subjectId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['BigInt']>;
  /** Distinct count of testy across the matching connection */
  testy?: Maybe<Scalars['BigInt']>;
  /** Distinct count of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['BigInt']>;
  /** Distinct count of triedNotToThinkOfTheSitation across the matching connection */
  triedNotToThinkOfTheSitation?: Maybe<Scalars['BigInt']>;
  /** Distinct count of triedSomethingElseToCopeWithTheSituation across the matching connection */
  triedSomethingElseToCopeWithTheSituation?: Maybe<Scalars['BigInt']>;
  /** Distinct count of triedToAcceptTheSituation across the matching connection */
  triedToAcceptTheSituation?: Maybe<Scalars['BigInt']>;
  /** Distinct count of triedToAlterFeelings across the matching connection */
  triedToAlterFeelings?: Maybe<Scalars['BigInt']>;
  /** Distinct count of triedToCalmMyself across the matching connection */
  triedToCalmMyself?: Maybe<Scalars['BigInt']>;
  /** Distinct count of triedToChangeTheSituation across the matching connection */
  triedToChangeTheSituation?: Maybe<Scalars['BigInt']>;
  /** Distinct count of triedToFindASolutionForTheProblem across the matching connection */
  triedToFindASolutionForTheProblem?: Maybe<Scalars['BigInt']>;
  /** Distinct count of triedToFindTheCauseOfTheProblem across the matching connection */
  triedToFindTheCauseOfTheProblem?: Maybe<Scalars['BigInt']>;
  /** Distinct count of triedToThinkDifferently across the matching connection */
  triedToThinkDifferently?: Maybe<Scalars['BigInt']>;
  /** Distinct count of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['BigInt']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of this field across the matching connection. */
  updatedAtUtc?: Maybe<Scalars['BigInt']>;
  /** Distinct count of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `EmaEntry` object types. All fields are combined with a logical ‘and.’ */
export type EmaEntryFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<EmaEntryFilter>>;
  /** Filter by the object’s `angry` field. */
  angry?: InputMaybe<IntFilter>;
  /** Filter by the object’s `anxious` field. */
  anxious?: InputMaybe<IntFilter>;
  /** Filter by the object’s `anxiousDuringContact` field. */
  anxiousDuringContact?: InputMaybe<IntFilter>;
  /** Filter by the object’s `avoidedSocialContact` field. */
  avoidedSocialContact?: InputMaybe<IntFilter>;
  /** Filter by the object’s `comfortableDuringContact` field. */
  comfortableDuringContact?: InputMaybe<IntFilter>;
  /** Filter by the object’s `completedAt` field. */
  completedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `copingHelpedInTheSituation` field. */
  copingHelpedInTheSituation?: InputMaybe<IntFilter>;
  /** Filter by the object’s `couldThinkOfNothingElseThanTheSitation` field. */
  couldThinkOfNothingElseThanTheSitation?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `deleted` field. */
  deleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `guilty` field. */
  guilty?: InputMaybe<IntFilter>;
  /** Filter by the object’s `hadAStressfulSituation` field. */
  hadAStressfulSituation?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `hadAnyContactWithOthersSinceTheLastSurvey` field. */
  hadAnyContactWithOthersSinceTheLastSurvey?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `happy` field. */
  happy?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `lackOfSocialContactBothersMe` field. */
  lackOfSocialContactBothersMe?: InputMaybe<IntFilter>;
  /** Filter by the object’s `lonely` field. */
  lonely?: InputMaybe<IntFilter>;
  /** Filter by the object’s `noSocialContactDueToOuterConditions` field. */
  noSocialContactDueToOuterConditions?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<EmaEntryFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<EmaEntryFilter>>;
  /** Filter by the object’s `relaxed` field. */
  relaxed?: InputMaybe<IntFilter>;
  /** Filter by the object’s `sad` field. */
  sad?: InputMaybe<IntFilter>;
  /** Filter by the object’s `satisfied` field. */
  satisfied?: InputMaybe<IntFilter>;
  /** Filter by the object’s `scheduledAt` field. */
  scheduledAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `startedAt` field. */
  startedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `subject` relation. */
  subject?: InputMaybe<UserFilter>;
  /** Filter by the object’s `subjectId` field. */
  subjectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tenseDuringContact` field. */
  tenseDuringContact?: InputMaybe<IntFilter>;
  /** Filter by the object’s `testy` field. */
  testy?: InputMaybe<IntFilter>;
  /** Filter by the object’s `testyDuringContact` field. */
  testyDuringContact?: InputMaybe<IntFilter>;
  /** Filter by the object’s `triedNotToThinkOfTheSitation` field. */
  triedNotToThinkOfTheSitation?: InputMaybe<IntFilter>;
  /** Filter by the object’s `triedSomethingElseToCopeWithTheSituation` field. */
  triedSomethingElseToCopeWithTheSituation?: InputMaybe<IntFilter>;
  /** Filter by the object’s `triedToAcceptTheSituation` field. */
  triedToAcceptTheSituation?: InputMaybe<IntFilter>;
  /** Filter by the object’s `triedToAlterFeelings` field. */
  triedToAlterFeelings?: InputMaybe<IntFilter>;
  /** Filter by the object’s `triedToCalmMyself` field. */
  triedToCalmMyself?: InputMaybe<IntFilter>;
  /** Filter by the object’s `triedToChangeTheSituation` field. */
  triedToChangeTheSituation?: InputMaybe<IntFilter>;
  /** Filter by the object’s `triedToFindASolutionForTheProblem` field. */
  triedToFindASolutionForTheProblem?: InputMaybe<IntFilter>;
  /** Filter by the object’s `triedToFindTheCauseOfTheProblem` field. */
  triedToFindTheCauseOfTheProblem?: InputMaybe<IntFilter>;
  /** Filter by the object’s `triedToThinkDifferently` field. */
  triedToThinkDifferently?: InputMaybe<IntFilter>;
  /** Filter by the object’s `unconfidentDuringContact` field. */
  unconfidentDuringContact?: InputMaybe<IntFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAtUtc` field. */
  updatedAtUtc?: InputMaybe<StringFilter>;
  /** Filter by the object’s `wouldHaveLikedSocialContact` field. */
  wouldHaveLikedSocialContact?: InputMaybe<IntFilter>;
};

/** An input for mutations affecting `EmaEntry` */
export type EmaEntryInput = {
  angry?: InputMaybe<Scalars['Int']>;
  anxious?: InputMaybe<Scalars['Int']>;
  anxiousDuringContact?: InputMaybe<Scalars['Int']>;
  avoidedSocialContact?: InputMaybe<Scalars['Int']>;
  comfortableDuringContact?: InputMaybe<Scalars['Int']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  copingHelpedInTheSituation?: InputMaybe<Scalars['Int']>;
  couldThinkOfNothingElseThanTheSitation?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  guilty?: InputMaybe<Scalars['Int']>;
  hadAStressfulSituation?: InputMaybe<Scalars['Boolean']>;
  hadAnyContactWithOthersSinceTheLastSurvey?: InputMaybe<Scalars['Boolean']>;
  happy?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  lackOfSocialContactBothersMe?: InputMaybe<Scalars['Int']>;
  lonely?: InputMaybe<Scalars['Int']>;
  noSocialContactDueToOuterConditions?: InputMaybe<Scalars['Int']>;
  relaxed?: InputMaybe<Scalars['Int']>;
  sad?: InputMaybe<Scalars['Int']>;
  satisfied?: InputMaybe<Scalars['Int']>;
  scheduledAt: Scalars['Datetime'];
  startedAt?: InputMaybe<Scalars['Datetime']>;
  subjectId?: InputMaybe<Scalars['UUID']>;
  tenseDuringContact?: InputMaybe<Scalars['Int']>;
  testy?: InputMaybe<Scalars['Int']>;
  testyDuringContact?: InputMaybe<Scalars['Int']>;
  triedNotToThinkOfTheSitation?: InputMaybe<Scalars['Int']>;
  triedSomethingElseToCopeWithTheSituation?: InputMaybe<Scalars['Int']>;
  triedToAcceptTheSituation?: InputMaybe<Scalars['Int']>;
  triedToAlterFeelings?: InputMaybe<Scalars['Int']>;
  triedToCalmMyself?: InputMaybe<Scalars['Int']>;
  triedToChangeTheSituation?: InputMaybe<Scalars['Int']>;
  triedToFindASolutionForTheProblem?: InputMaybe<Scalars['Int']>;
  triedToFindTheCauseOfTheProblem?: InputMaybe<Scalars['Int']>;
  triedToThinkDifferently?: InputMaybe<Scalars['Int']>;
  unconfidentDuringContact?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  wouldHaveLikedSocialContact?: InputMaybe<Scalars['Int']>;
};

export type EmaEntryMaxAggregateFilter = {
  angry?: InputMaybe<IntFilter>;
  anxious?: InputMaybe<IntFilter>;
  anxiousDuringContact?: InputMaybe<IntFilter>;
  avoidedSocialContact?: InputMaybe<IntFilter>;
  comfortableDuringContact?: InputMaybe<IntFilter>;
  copingHelpedInTheSituation?: InputMaybe<IntFilter>;
  couldThinkOfNothingElseThanTheSitation?: InputMaybe<IntFilter>;
  guilty?: InputMaybe<IntFilter>;
  happy?: InputMaybe<IntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<IntFilter>;
  lonely?: InputMaybe<IntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<IntFilter>;
  relaxed?: InputMaybe<IntFilter>;
  sad?: InputMaybe<IntFilter>;
  satisfied?: InputMaybe<IntFilter>;
  tenseDuringContact?: InputMaybe<IntFilter>;
  testy?: InputMaybe<IntFilter>;
  testyDuringContact?: InputMaybe<IntFilter>;
  triedNotToThinkOfTheSitation?: InputMaybe<IntFilter>;
  triedSomethingElseToCopeWithTheSituation?: InputMaybe<IntFilter>;
  triedToAcceptTheSituation?: InputMaybe<IntFilter>;
  triedToAlterFeelings?: InputMaybe<IntFilter>;
  triedToCalmMyself?: InputMaybe<IntFilter>;
  triedToChangeTheSituation?: InputMaybe<IntFilter>;
  triedToFindASolutionForTheProblem?: InputMaybe<IntFilter>;
  triedToFindTheCauseOfTheProblem?: InputMaybe<IntFilter>;
  triedToThinkDifferently?: InputMaybe<IntFilter>;
  unconfidentDuringContact?: InputMaybe<IntFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<IntFilter>;
};

export type EmaEntryMaxAggregates = {
  __typename?: 'EmaEntryMaxAggregates';
  /** Maximum of angry across the matching connection */
  angry?: Maybe<Scalars['Int']>;
  /** Maximum of anxious across the matching connection */
  anxious?: Maybe<Scalars['Int']>;
  /** Maximum of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['Int']>;
  /** Maximum of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['Int']>;
  /** Maximum of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['Int']>;
  /** Maximum of copingHelpedInTheSituation across the matching connection */
  copingHelpedInTheSituation?: Maybe<Scalars['Int']>;
  /** Maximum of couldThinkOfNothingElseThanTheSitation across the matching connection */
  couldThinkOfNothingElseThanTheSitation?: Maybe<Scalars['Int']>;
  /** Maximum of guilty across the matching connection */
  guilty?: Maybe<Scalars['Int']>;
  /** Maximum of happy across the matching connection */
  happy?: Maybe<Scalars['Int']>;
  /** Maximum of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['Int']>;
  /** Maximum of lonely across the matching connection */
  lonely?: Maybe<Scalars['Int']>;
  /** Maximum of noSocialContactDueToOuterConditions across the matching connection */
  noSocialContactDueToOuterConditions?: Maybe<Scalars['Int']>;
  /** Maximum of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['Int']>;
  /** Maximum of sad across the matching connection */
  sad?: Maybe<Scalars['Int']>;
  /** Maximum of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['Int']>;
  /** Maximum of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['Int']>;
  /** Maximum of testy across the matching connection */
  testy?: Maybe<Scalars['Int']>;
  /** Maximum of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['Int']>;
  /** Maximum of triedNotToThinkOfTheSitation across the matching connection */
  triedNotToThinkOfTheSitation?: Maybe<Scalars['Int']>;
  /** Maximum of triedSomethingElseToCopeWithTheSituation across the matching connection */
  triedSomethingElseToCopeWithTheSituation?: Maybe<Scalars['Int']>;
  /** Maximum of triedToAcceptTheSituation across the matching connection */
  triedToAcceptTheSituation?: Maybe<Scalars['Int']>;
  /** Maximum of triedToAlterFeelings across the matching connection */
  triedToAlterFeelings?: Maybe<Scalars['Int']>;
  /** Maximum of triedToCalmMyself across the matching connection */
  triedToCalmMyself?: Maybe<Scalars['Int']>;
  /** Maximum of triedToChangeTheSituation across the matching connection */
  triedToChangeTheSituation?: Maybe<Scalars['Int']>;
  /** Maximum of triedToFindASolutionForTheProblem across the matching connection */
  triedToFindASolutionForTheProblem?: Maybe<Scalars['Int']>;
  /** Maximum of triedToFindTheCauseOfTheProblem across the matching connection */
  triedToFindTheCauseOfTheProblem?: Maybe<Scalars['Int']>;
  /** Maximum of triedToThinkDifferently across the matching connection */
  triedToThinkDifferently?: Maybe<Scalars['Int']>;
  /** Maximum of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['Int']>;
  /** Maximum of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['Int']>;
};

export type EmaEntryMinAggregateFilter = {
  angry?: InputMaybe<IntFilter>;
  anxious?: InputMaybe<IntFilter>;
  anxiousDuringContact?: InputMaybe<IntFilter>;
  avoidedSocialContact?: InputMaybe<IntFilter>;
  comfortableDuringContact?: InputMaybe<IntFilter>;
  copingHelpedInTheSituation?: InputMaybe<IntFilter>;
  couldThinkOfNothingElseThanTheSitation?: InputMaybe<IntFilter>;
  guilty?: InputMaybe<IntFilter>;
  happy?: InputMaybe<IntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<IntFilter>;
  lonely?: InputMaybe<IntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<IntFilter>;
  relaxed?: InputMaybe<IntFilter>;
  sad?: InputMaybe<IntFilter>;
  satisfied?: InputMaybe<IntFilter>;
  tenseDuringContact?: InputMaybe<IntFilter>;
  testy?: InputMaybe<IntFilter>;
  testyDuringContact?: InputMaybe<IntFilter>;
  triedNotToThinkOfTheSitation?: InputMaybe<IntFilter>;
  triedSomethingElseToCopeWithTheSituation?: InputMaybe<IntFilter>;
  triedToAcceptTheSituation?: InputMaybe<IntFilter>;
  triedToAlterFeelings?: InputMaybe<IntFilter>;
  triedToCalmMyself?: InputMaybe<IntFilter>;
  triedToChangeTheSituation?: InputMaybe<IntFilter>;
  triedToFindASolutionForTheProblem?: InputMaybe<IntFilter>;
  triedToFindTheCauseOfTheProblem?: InputMaybe<IntFilter>;
  triedToThinkDifferently?: InputMaybe<IntFilter>;
  unconfidentDuringContact?: InputMaybe<IntFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<IntFilter>;
};

export type EmaEntryMinAggregates = {
  __typename?: 'EmaEntryMinAggregates';
  /** Minimum of angry across the matching connection */
  angry?: Maybe<Scalars['Int']>;
  /** Minimum of anxious across the matching connection */
  anxious?: Maybe<Scalars['Int']>;
  /** Minimum of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['Int']>;
  /** Minimum of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['Int']>;
  /** Minimum of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['Int']>;
  /** Minimum of copingHelpedInTheSituation across the matching connection */
  copingHelpedInTheSituation?: Maybe<Scalars['Int']>;
  /** Minimum of couldThinkOfNothingElseThanTheSitation across the matching connection */
  couldThinkOfNothingElseThanTheSitation?: Maybe<Scalars['Int']>;
  /** Minimum of guilty across the matching connection */
  guilty?: Maybe<Scalars['Int']>;
  /** Minimum of happy across the matching connection */
  happy?: Maybe<Scalars['Int']>;
  /** Minimum of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['Int']>;
  /** Minimum of lonely across the matching connection */
  lonely?: Maybe<Scalars['Int']>;
  /** Minimum of noSocialContactDueToOuterConditions across the matching connection */
  noSocialContactDueToOuterConditions?: Maybe<Scalars['Int']>;
  /** Minimum of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['Int']>;
  /** Minimum of sad across the matching connection */
  sad?: Maybe<Scalars['Int']>;
  /** Minimum of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['Int']>;
  /** Minimum of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['Int']>;
  /** Minimum of testy across the matching connection */
  testy?: Maybe<Scalars['Int']>;
  /** Minimum of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['Int']>;
  /** Minimum of triedNotToThinkOfTheSitation across the matching connection */
  triedNotToThinkOfTheSitation?: Maybe<Scalars['Int']>;
  /** Minimum of triedSomethingElseToCopeWithTheSituation across the matching connection */
  triedSomethingElseToCopeWithTheSituation?: Maybe<Scalars['Int']>;
  /** Minimum of triedToAcceptTheSituation across the matching connection */
  triedToAcceptTheSituation?: Maybe<Scalars['Int']>;
  /** Minimum of triedToAlterFeelings across the matching connection */
  triedToAlterFeelings?: Maybe<Scalars['Int']>;
  /** Minimum of triedToCalmMyself across the matching connection */
  triedToCalmMyself?: Maybe<Scalars['Int']>;
  /** Minimum of triedToChangeTheSituation across the matching connection */
  triedToChangeTheSituation?: Maybe<Scalars['Int']>;
  /** Minimum of triedToFindASolutionForTheProblem across the matching connection */
  triedToFindASolutionForTheProblem?: Maybe<Scalars['Int']>;
  /** Minimum of triedToFindTheCauseOfTheProblem across the matching connection */
  triedToFindTheCauseOfTheProblem?: Maybe<Scalars['Int']>;
  /** Minimum of triedToThinkDifferently across the matching connection */
  triedToThinkDifferently?: Maybe<Scalars['Int']>;
  /** Minimum of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['Int']>;
  /** Minimum of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['Int']>;
};

/** Represents an update to a `EmaEntry`. Fields that are set will be updated. */
export type EmaEntryPatch = {
  angry?: InputMaybe<Scalars['Int']>;
  anxious?: InputMaybe<Scalars['Int']>;
  anxiousDuringContact?: InputMaybe<Scalars['Int']>;
  avoidedSocialContact?: InputMaybe<Scalars['Int']>;
  comfortableDuringContact?: InputMaybe<Scalars['Int']>;
  completedAt?: InputMaybe<Scalars['Datetime']>;
  copingHelpedInTheSituation?: InputMaybe<Scalars['Int']>;
  couldThinkOfNothingElseThanTheSitation?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  guilty?: InputMaybe<Scalars['Int']>;
  hadAStressfulSituation?: InputMaybe<Scalars['Boolean']>;
  hadAnyContactWithOthersSinceTheLastSurvey?: InputMaybe<Scalars['Boolean']>;
  happy?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['UUID']>;
  lackOfSocialContactBothersMe?: InputMaybe<Scalars['Int']>;
  lonely?: InputMaybe<Scalars['Int']>;
  noSocialContactDueToOuterConditions?: InputMaybe<Scalars['Int']>;
  relaxed?: InputMaybe<Scalars['Int']>;
  sad?: InputMaybe<Scalars['Int']>;
  satisfied?: InputMaybe<Scalars['Int']>;
  scheduledAt?: InputMaybe<Scalars['Datetime']>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  subjectId?: InputMaybe<Scalars['UUID']>;
  tenseDuringContact?: InputMaybe<Scalars['Int']>;
  testy?: InputMaybe<Scalars['Int']>;
  testyDuringContact?: InputMaybe<Scalars['Int']>;
  triedNotToThinkOfTheSitation?: InputMaybe<Scalars['Int']>;
  triedSomethingElseToCopeWithTheSituation?: InputMaybe<Scalars['Int']>;
  triedToAcceptTheSituation?: InputMaybe<Scalars['Int']>;
  triedToAlterFeelings?: InputMaybe<Scalars['Int']>;
  triedToCalmMyself?: InputMaybe<Scalars['Int']>;
  triedToChangeTheSituation?: InputMaybe<Scalars['Int']>;
  triedToFindASolutionForTheProblem?: InputMaybe<Scalars['Int']>;
  triedToFindTheCauseOfTheProblem?: InputMaybe<Scalars['Int']>;
  triedToThinkDifferently?: InputMaybe<Scalars['Int']>;
  unconfidentDuringContact?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  wouldHaveLikedSocialContact?: InputMaybe<Scalars['Int']>;
};

export type EmaEntryStddevPopulationAggregateFilter = {
  angry?: InputMaybe<BigFloatFilter>;
  anxious?: InputMaybe<BigFloatFilter>;
  anxiousDuringContact?: InputMaybe<BigFloatFilter>;
  avoidedSocialContact?: InputMaybe<BigFloatFilter>;
  comfortableDuringContact?: InputMaybe<BigFloatFilter>;
  copingHelpedInTheSituation?: InputMaybe<BigFloatFilter>;
  couldThinkOfNothingElseThanTheSitation?: InputMaybe<BigFloatFilter>;
  guilty?: InputMaybe<BigFloatFilter>;
  happy?: InputMaybe<BigFloatFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<BigFloatFilter>;
  lonely?: InputMaybe<BigFloatFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<BigFloatFilter>;
  relaxed?: InputMaybe<BigFloatFilter>;
  sad?: InputMaybe<BigFloatFilter>;
  satisfied?: InputMaybe<BigFloatFilter>;
  tenseDuringContact?: InputMaybe<BigFloatFilter>;
  testy?: InputMaybe<BigFloatFilter>;
  testyDuringContact?: InputMaybe<BigFloatFilter>;
  triedNotToThinkOfTheSitation?: InputMaybe<BigFloatFilter>;
  triedSomethingElseToCopeWithTheSituation?: InputMaybe<BigFloatFilter>;
  triedToAcceptTheSituation?: InputMaybe<BigFloatFilter>;
  triedToAlterFeelings?: InputMaybe<BigFloatFilter>;
  triedToCalmMyself?: InputMaybe<BigFloatFilter>;
  triedToChangeTheSituation?: InputMaybe<BigFloatFilter>;
  triedToFindASolutionForTheProblem?: InputMaybe<BigFloatFilter>;
  triedToFindTheCauseOfTheProblem?: InputMaybe<BigFloatFilter>;
  triedToThinkDifferently?: InputMaybe<BigFloatFilter>;
  unconfidentDuringContact?: InputMaybe<BigFloatFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<BigFloatFilter>;
};

export type EmaEntryStddevPopulationAggregates = {
  __typename?: 'EmaEntryStddevPopulationAggregates';
  /** Population standard deviation of angry across the matching connection */
  angry?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of anxious across the matching connection */
  anxious?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of copingHelpedInTheSituation across the matching connection */
  copingHelpedInTheSituation?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of couldThinkOfNothingElseThanTheSitation across the matching connection */
  couldThinkOfNothingElseThanTheSitation?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of guilty across the matching connection */
  guilty?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of happy across the matching connection */
  happy?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of lonely across the matching connection */
  lonely?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of noSocialContactDueToOuterConditions across the matching connection */
  noSocialContactDueToOuterConditions?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of sad across the matching connection */
  sad?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of testy across the matching connection */
  testy?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of triedNotToThinkOfTheSitation across the matching connection */
  triedNotToThinkOfTheSitation?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of triedSomethingElseToCopeWithTheSituation across the matching connection */
  triedSomethingElseToCopeWithTheSituation?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of triedToAcceptTheSituation across the matching connection */
  triedToAcceptTheSituation?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of triedToAlterFeelings across the matching connection */
  triedToAlterFeelings?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of triedToCalmMyself across the matching connection */
  triedToCalmMyself?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of triedToChangeTheSituation across the matching connection */
  triedToChangeTheSituation?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of triedToFindASolutionForTheProblem across the matching connection */
  triedToFindASolutionForTheProblem?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of triedToFindTheCauseOfTheProblem across the matching connection */
  triedToFindTheCauseOfTheProblem?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of triedToThinkDifferently across the matching connection */
  triedToThinkDifferently?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population standard deviation of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['BigFloat']>;
};

export type EmaEntryStddevSampleAggregateFilter = {
  angry?: InputMaybe<BigFloatFilter>;
  anxious?: InputMaybe<BigFloatFilter>;
  anxiousDuringContact?: InputMaybe<BigFloatFilter>;
  avoidedSocialContact?: InputMaybe<BigFloatFilter>;
  comfortableDuringContact?: InputMaybe<BigFloatFilter>;
  copingHelpedInTheSituation?: InputMaybe<BigFloatFilter>;
  couldThinkOfNothingElseThanTheSitation?: InputMaybe<BigFloatFilter>;
  guilty?: InputMaybe<BigFloatFilter>;
  happy?: InputMaybe<BigFloatFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<BigFloatFilter>;
  lonely?: InputMaybe<BigFloatFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<BigFloatFilter>;
  relaxed?: InputMaybe<BigFloatFilter>;
  sad?: InputMaybe<BigFloatFilter>;
  satisfied?: InputMaybe<BigFloatFilter>;
  tenseDuringContact?: InputMaybe<BigFloatFilter>;
  testy?: InputMaybe<BigFloatFilter>;
  testyDuringContact?: InputMaybe<BigFloatFilter>;
  triedNotToThinkOfTheSitation?: InputMaybe<BigFloatFilter>;
  triedSomethingElseToCopeWithTheSituation?: InputMaybe<BigFloatFilter>;
  triedToAcceptTheSituation?: InputMaybe<BigFloatFilter>;
  triedToAlterFeelings?: InputMaybe<BigFloatFilter>;
  triedToCalmMyself?: InputMaybe<BigFloatFilter>;
  triedToChangeTheSituation?: InputMaybe<BigFloatFilter>;
  triedToFindASolutionForTheProblem?: InputMaybe<BigFloatFilter>;
  triedToFindTheCauseOfTheProblem?: InputMaybe<BigFloatFilter>;
  triedToThinkDifferently?: InputMaybe<BigFloatFilter>;
  unconfidentDuringContact?: InputMaybe<BigFloatFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<BigFloatFilter>;
};

export type EmaEntryStddevSampleAggregates = {
  __typename?: 'EmaEntryStddevSampleAggregates';
  /** Sample standard deviation of angry across the matching connection */
  angry?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of anxious across the matching connection */
  anxious?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of copingHelpedInTheSituation across the matching connection */
  copingHelpedInTheSituation?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of couldThinkOfNothingElseThanTheSitation across the matching connection */
  couldThinkOfNothingElseThanTheSitation?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of guilty across the matching connection */
  guilty?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of happy across the matching connection */
  happy?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of lonely across the matching connection */
  lonely?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of noSocialContactDueToOuterConditions across the matching connection */
  noSocialContactDueToOuterConditions?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of sad across the matching connection */
  sad?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of testy across the matching connection */
  testy?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of triedNotToThinkOfTheSitation across the matching connection */
  triedNotToThinkOfTheSitation?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of triedSomethingElseToCopeWithTheSituation across the matching connection */
  triedSomethingElseToCopeWithTheSituation?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of triedToAcceptTheSituation across the matching connection */
  triedToAcceptTheSituation?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of triedToAlterFeelings across the matching connection */
  triedToAlterFeelings?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of triedToCalmMyself across the matching connection */
  triedToCalmMyself?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of triedToChangeTheSituation across the matching connection */
  triedToChangeTheSituation?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of triedToFindASolutionForTheProblem across the matching connection */
  triedToFindASolutionForTheProblem?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of triedToFindTheCauseOfTheProblem across the matching connection */
  triedToFindTheCauseOfTheProblem?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of triedToThinkDifferently across the matching connection */
  triedToThinkDifferently?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample standard deviation of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['BigFloat']>;
};

export type EmaEntrySumAggregateFilter = {
  angry?: InputMaybe<BigIntFilter>;
  anxious?: InputMaybe<BigIntFilter>;
  anxiousDuringContact?: InputMaybe<BigIntFilter>;
  avoidedSocialContact?: InputMaybe<BigIntFilter>;
  comfortableDuringContact?: InputMaybe<BigIntFilter>;
  copingHelpedInTheSituation?: InputMaybe<BigIntFilter>;
  couldThinkOfNothingElseThanTheSitation?: InputMaybe<BigIntFilter>;
  guilty?: InputMaybe<BigIntFilter>;
  happy?: InputMaybe<BigIntFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<BigIntFilter>;
  lonely?: InputMaybe<BigIntFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<BigIntFilter>;
  relaxed?: InputMaybe<BigIntFilter>;
  sad?: InputMaybe<BigIntFilter>;
  satisfied?: InputMaybe<BigIntFilter>;
  tenseDuringContact?: InputMaybe<BigIntFilter>;
  testy?: InputMaybe<BigIntFilter>;
  testyDuringContact?: InputMaybe<BigIntFilter>;
  triedNotToThinkOfTheSitation?: InputMaybe<BigIntFilter>;
  triedSomethingElseToCopeWithTheSituation?: InputMaybe<BigIntFilter>;
  triedToAcceptTheSituation?: InputMaybe<BigIntFilter>;
  triedToAlterFeelings?: InputMaybe<BigIntFilter>;
  triedToCalmMyself?: InputMaybe<BigIntFilter>;
  triedToChangeTheSituation?: InputMaybe<BigIntFilter>;
  triedToFindASolutionForTheProblem?: InputMaybe<BigIntFilter>;
  triedToFindTheCauseOfTheProblem?: InputMaybe<BigIntFilter>;
  triedToThinkDifferently?: InputMaybe<BigIntFilter>;
  unconfidentDuringContact?: InputMaybe<BigIntFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<BigIntFilter>;
};

export type EmaEntrySumAggregates = {
  __typename?: 'EmaEntrySumAggregates';
  /** Sum of angry across the matching connection */
  angry: Scalars['BigInt'];
  /** Sum of anxious across the matching connection */
  anxious: Scalars['BigInt'];
  /** Sum of anxiousDuringContact across the matching connection */
  anxiousDuringContact: Scalars['BigInt'];
  /** Sum of avoidedSocialContact across the matching connection */
  avoidedSocialContact: Scalars['BigInt'];
  /** Sum of comfortableDuringContact across the matching connection */
  comfortableDuringContact: Scalars['BigInt'];
  /** Sum of copingHelpedInTheSituation across the matching connection */
  copingHelpedInTheSituation: Scalars['BigInt'];
  /** Sum of couldThinkOfNothingElseThanTheSitation across the matching connection */
  couldThinkOfNothingElseThanTheSitation: Scalars['BigInt'];
  /** Sum of guilty across the matching connection */
  guilty: Scalars['BigInt'];
  /** Sum of happy across the matching connection */
  happy: Scalars['BigInt'];
  /** Sum of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe: Scalars['BigInt'];
  /** Sum of lonely across the matching connection */
  lonely: Scalars['BigInt'];
  /** Sum of noSocialContactDueToOuterConditions across the matching connection */
  noSocialContactDueToOuterConditions: Scalars['BigInt'];
  /** Sum of relaxed across the matching connection */
  relaxed: Scalars['BigInt'];
  /** Sum of sad across the matching connection */
  sad: Scalars['BigInt'];
  /** Sum of satisfied across the matching connection */
  satisfied: Scalars['BigInt'];
  /** Sum of tenseDuringContact across the matching connection */
  tenseDuringContact: Scalars['BigInt'];
  /** Sum of testy across the matching connection */
  testy: Scalars['BigInt'];
  /** Sum of testyDuringContact across the matching connection */
  testyDuringContact: Scalars['BigInt'];
  /** Sum of triedNotToThinkOfTheSitation across the matching connection */
  triedNotToThinkOfTheSitation: Scalars['BigInt'];
  /** Sum of triedSomethingElseToCopeWithTheSituation across the matching connection */
  triedSomethingElseToCopeWithTheSituation: Scalars['BigInt'];
  /** Sum of triedToAcceptTheSituation across the matching connection */
  triedToAcceptTheSituation: Scalars['BigInt'];
  /** Sum of triedToAlterFeelings across the matching connection */
  triedToAlterFeelings: Scalars['BigInt'];
  /** Sum of triedToCalmMyself across the matching connection */
  triedToCalmMyself: Scalars['BigInt'];
  /** Sum of triedToChangeTheSituation across the matching connection */
  triedToChangeTheSituation: Scalars['BigInt'];
  /** Sum of triedToFindASolutionForTheProblem across the matching connection */
  triedToFindASolutionForTheProblem: Scalars['BigInt'];
  /** Sum of triedToFindTheCauseOfTheProblem across the matching connection */
  triedToFindTheCauseOfTheProblem: Scalars['BigInt'];
  /** Sum of triedToThinkDifferently across the matching connection */
  triedToThinkDifferently: Scalars['BigInt'];
  /** Sum of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact: Scalars['BigInt'];
  /** Sum of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact: Scalars['BigInt'];
};

export type EmaEntryVariancePopulationAggregateFilter = {
  angry?: InputMaybe<BigFloatFilter>;
  anxious?: InputMaybe<BigFloatFilter>;
  anxiousDuringContact?: InputMaybe<BigFloatFilter>;
  avoidedSocialContact?: InputMaybe<BigFloatFilter>;
  comfortableDuringContact?: InputMaybe<BigFloatFilter>;
  copingHelpedInTheSituation?: InputMaybe<BigFloatFilter>;
  couldThinkOfNothingElseThanTheSitation?: InputMaybe<BigFloatFilter>;
  guilty?: InputMaybe<BigFloatFilter>;
  happy?: InputMaybe<BigFloatFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<BigFloatFilter>;
  lonely?: InputMaybe<BigFloatFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<BigFloatFilter>;
  relaxed?: InputMaybe<BigFloatFilter>;
  sad?: InputMaybe<BigFloatFilter>;
  satisfied?: InputMaybe<BigFloatFilter>;
  tenseDuringContact?: InputMaybe<BigFloatFilter>;
  testy?: InputMaybe<BigFloatFilter>;
  testyDuringContact?: InputMaybe<BigFloatFilter>;
  triedNotToThinkOfTheSitation?: InputMaybe<BigFloatFilter>;
  triedSomethingElseToCopeWithTheSituation?: InputMaybe<BigFloatFilter>;
  triedToAcceptTheSituation?: InputMaybe<BigFloatFilter>;
  triedToAlterFeelings?: InputMaybe<BigFloatFilter>;
  triedToCalmMyself?: InputMaybe<BigFloatFilter>;
  triedToChangeTheSituation?: InputMaybe<BigFloatFilter>;
  triedToFindASolutionForTheProblem?: InputMaybe<BigFloatFilter>;
  triedToFindTheCauseOfTheProblem?: InputMaybe<BigFloatFilter>;
  triedToThinkDifferently?: InputMaybe<BigFloatFilter>;
  unconfidentDuringContact?: InputMaybe<BigFloatFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<BigFloatFilter>;
};

export type EmaEntryVariancePopulationAggregates = {
  __typename?: 'EmaEntryVariancePopulationAggregates';
  /** Population variance of angry across the matching connection */
  angry?: Maybe<Scalars['BigFloat']>;
  /** Population variance of anxious across the matching connection */
  anxious?: Maybe<Scalars['BigFloat']>;
  /** Population variance of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population variance of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['BigFloat']>;
  /** Population variance of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population variance of copingHelpedInTheSituation across the matching connection */
  copingHelpedInTheSituation?: Maybe<Scalars['BigFloat']>;
  /** Population variance of couldThinkOfNothingElseThanTheSitation across the matching connection */
  couldThinkOfNothingElseThanTheSitation?: Maybe<Scalars['BigFloat']>;
  /** Population variance of guilty across the matching connection */
  guilty?: Maybe<Scalars['BigFloat']>;
  /** Population variance of happy across the matching connection */
  happy?: Maybe<Scalars['BigFloat']>;
  /** Population variance of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['BigFloat']>;
  /** Population variance of lonely across the matching connection */
  lonely?: Maybe<Scalars['BigFloat']>;
  /** Population variance of noSocialContactDueToOuterConditions across the matching connection */
  noSocialContactDueToOuterConditions?: Maybe<Scalars['BigFloat']>;
  /** Population variance of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['BigFloat']>;
  /** Population variance of sad across the matching connection */
  sad?: Maybe<Scalars['BigFloat']>;
  /** Population variance of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['BigFloat']>;
  /** Population variance of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population variance of testy across the matching connection */
  testy?: Maybe<Scalars['BigFloat']>;
  /** Population variance of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population variance of triedNotToThinkOfTheSitation across the matching connection */
  triedNotToThinkOfTheSitation?: Maybe<Scalars['BigFloat']>;
  /** Population variance of triedSomethingElseToCopeWithTheSituation across the matching connection */
  triedSomethingElseToCopeWithTheSituation?: Maybe<Scalars['BigFloat']>;
  /** Population variance of triedToAcceptTheSituation across the matching connection */
  triedToAcceptTheSituation?: Maybe<Scalars['BigFloat']>;
  /** Population variance of triedToAlterFeelings across the matching connection */
  triedToAlterFeelings?: Maybe<Scalars['BigFloat']>;
  /** Population variance of triedToCalmMyself across the matching connection */
  triedToCalmMyself?: Maybe<Scalars['BigFloat']>;
  /** Population variance of triedToChangeTheSituation across the matching connection */
  triedToChangeTheSituation?: Maybe<Scalars['BigFloat']>;
  /** Population variance of triedToFindASolutionForTheProblem across the matching connection */
  triedToFindASolutionForTheProblem?: Maybe<Scalars['BigFloat']>;
  /** Population variance of triedToFindTheCauseOfTheProblem across the matching connection */
  triedToFindTheCauseOfTheProblem?: Maybe<Scalars['BigFloat']>;
  /** Population variance of triedToThinkDifferently across the matching connection */
  triedToThinkDifferently?: Maybe<Scalars['BigFloat']>;
  /** Population variance of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Population variance of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['BigFloat']>;
};

export type EmaEntryVarianceSampleAggregateFilter = {
  angry?: InputMaybe<BigFloatFilter>;
  anxious?: InputMaybe<BigFloatFilter>;
  anxiousDuringContact?: InputMaybe<BigFloatFilter>;
  avoidedSocialContact?: InputMaybe<BigFloatFilter>;
  comfortableDuringContact?: InputMaybe<BigFloatFilter>;
  copingHelpedInTheSituation?: InputMaybe<BigFloatFilter>;
  couldThinkOfNothingElseThanTheSitation?: InputMaybe<BigFloatFilter>;
  guilty?: InputMaybe<BigFloatFilter>;
  happy?: InputMaybe<BigFloatFilter>;
  lackOfSocialContactBothersMe?: InputMaybe<BigFloatFilter>;
  lonely?: InputMaybe<BigFloatFilter>;
  noSocialContactDueToOuterConditions?: InputMaybe<BigFloatFilter>;
  relaxed?: InputMaybe<BigFloatFilter>;
  sad?: InputMaybe<BigFloatFilter>;
  satisfied?: InputMaybe<BigFloatFilter>;
  tenseDuringContact?: InputMaybe<BigFloatFilter>;
  testy?: InputMaybe<BigFloatFilter>;
  testyDuringContact?: InputMaybe<BigFloatFilter>;
  triedNotToThinkOfTheSitation?: InputMaybe<BigFloatFilter>;
  triedSomethingElseToCopeWithTheSituation?: InputMaybe<BigFloatFilter>;
  triedToAcceptTheSituation?: InputMaybe<BigFloatFilter>;
  triedToAlterFeelings?: InputMaybe<BigFloatFilter>;
  triedToCalmMyself?: InputMaybe<BigFloatFilter>;
  triedToChangeTheSituation?: InputMaybe<BigFloatFilter>;
  triedToFindASolutionForTheProblem?: InputMaybe<BigFloatFilter>;
  triedToFindTheCauseOfTheProblem?: InputMaybe<BigFloatFilter>;
  triedToThinkDifferently?: InputMaybe<BigFloatFilter>;
  unconfidentDuringContact?: InputMaybe<BigFloatFilter>;
  wouldHaveLikedSocialContact?: InputMaybe<BigFloatFilter>;
};

export type EmaEntryVarianceSampleAggregates = {
  __typename?: 'EmaEntryVarianceSampleAggregates';
  /** Sample variance of angry across the matching connection */
  angry?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of anxious across the matching connection */
  anxious?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of anxiousDuringContact across the matching connection */
  anxiousDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of avoidedSocialContact across the matching connection */
  avoidedSocialContact?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of comfortableDuringContact across the matching connection */
  comfortableDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of copingHelpedInTheSituation across the matching connection */
  copingHelpedInTheSituation?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of couldThinkOfNothingElseThanTheSitation across the matching connection */
  couldThinkOfNothingElseThanTheSitation?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of guilty across the matching connection */
  guilty?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of happy across the matching connection */
  happy?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of lackOfSocialContactBothersMe across the matching connection */
  lackOfSocialContactBothersMe?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of lonely across the matching connection */
  lonely?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of noSocialContactDueToOuterConditions across the matching connection */
  noSocialContactDueToOuterConditions?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of relaxed across the matching connection */
  relaxed?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of sad across the matching connection */
  sad?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of satisfied across the matching connection */
  satisfied?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of tenseDuringContact across the matching connection */
  tenseDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of testy across the matching connection */
  testy?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of testyDuringContact across the matching connection */
  testyDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of triedNotToThinkOfTheSitation across the matching connection */
  triedNotToThinkOfTheSitation?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of triedSomethingElseToCopeWithTheSituation across the matching connection */
  triedSomethingElseToCopeWithTheSituation?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of triedToAcceptTheSituation across the matching connection */
  triedToAcceptTheSituation?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of triedToAlterFeelings across the matching connection */
  triedToAlterFeelings?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of triedToCalmMyself across the matching connection */
  triedToCalmMyself?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of triedToChangeTheSituation across the matching connection */
  triedToChangeTheSituation?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of triedToFindASolutionForTheProblem across the matching connection */
  triedToFindASolutionForTheProblem?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of triedToFindTheCauseOfTheProblem across the matching connection */
  triedToFindTheCauseOfTheProblem?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of triedToThinkDifferently across the matching connection */
  triedToThinkDifferently?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of unconfidentDuringContact across the matching connection */
  unconfidentDuringContact?: Maybe<Scalars['BigFloat']>;
  /** Sample variance of wouldHaveLikedSocialContact across the matching connection */
  wouldHaveLikedSocialContact?: Maybe<Scalars['BigFloat']>;
};

export type EmergencyContact = {
  __typename?: 'EmergencyContact';
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

/** An input for mutations affecting `EmergencyContact` */
export type EmergencyContactInput = {
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type Event = Node & {
  __typename?: 'Event';
  accountId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  level?: Maybe<LogLevel>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  payload?: Maybe<Scalars['JSON']>;
  remoteAddress?: Maybe<Scalars['String']>;
  trackedAt: Scalars['Datetime'];
  type: Scalars['String'];
  userAgent?: Maybe<Scalars['String']>;
};

/** An input for mutations affecting `Event` */
export type EventInput = {
  accountId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  level?: InputMaybe<LogLevel>;
  payload?: InputMaybe<Scalars['JSON']>;
  remoteAddress?: InputMaybe<Scalars['String']>;
  trackedAt?: InputMaybe<Scalars['Datetime']>;
  type: Scalars['String'];
  userAgent?: InputMaybe<Scalars['String']>;
};

export type FavoritePage = Node & {
  __typename?: 'FavoritePage';
  addedAt: Scalars['Datetime'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  route: Scalars['String'];
  /** Reads a single `Trial` that is related to this `FavoritePage`. */
  trial?: Maybe<Trial>;
  trialId: Scalars['UUID'];
};

export type FavoritePageAggregates = {
  __typename?: 'FavoritePageAggregates';
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<FavoritePageDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
};

/** A filter to be used against aggregates of `FavoritePage` object types. */
export type FavoritePageAggregatesFilter = {
  /** Distinct count aggregate over matching `FavoritePage` objects. */
  distinctCount?: InputMaybe<FavoritePageDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `FavoritePage` object to be included within the aggregate. */
  filter?: InputMaybe<FavoritePageFilter>;
};

/**
 * A condition to be used against `FavoritePage` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type FavoritePageCondition = {
  /** Checks for equality with the object’s `addedAt` field. */
  addedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `route` field. */
  route?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `trialId` field. */
  trialId?: InputMaybe<Scalars['UUID']>;
};

export type FavoritePageDistinctCountAggregateFilter = {
  addedAt?: InputMaybe<BigIntFilter>;
  route?: InputMaybe<BigIntFilter>;
  trialId?: InputMaybe<BigIntFilter>;
};

export type FavoritePageDistinctCountAggregates = {
  __typename?: 'FavoritePageDistinctCountAggregates';
  /** Distinct count of addedAt across the matching connection */
  addedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of route across the matching connection */
  route?: Maybe<Scalars['BigInt']>;
  /** Distinct count of trialId across the matching connection */
  trialId?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `FavoritePage` object types. All fields are combined with a logical ‘and.’ */
export type FavoritePageFilter = {
  /** Filter by the object’s `addedAt` field. */
  addedAt?: InputMaybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<FavoritePageFilter>>;
  /** Negates the expression. */
  not?: InputMaybe<FavoritePageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<FavoritePageFilter>>;
  /** Filter by the object’s `route` field. */
  route?: InputMaybe<StringFilter>;
  /** Filter by the object’s `trial` relation. */
  trial?: InputMaybe<TrialFilter>;
  /** Filter by the object’s `trialId` field. */
  trialId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `FavoritePage` */
export type FavoritePageInput = {
  addedAt?: InputMaybe<Scalars['Datetime']>;
  route: Scalars['String'];
  trialId?: InputMaybe<Scalars['UUID']>;
};

/** Represents an update to a `FavoritePage`. Fields that are set will be updated. */
export type FavoritePagePatch = {
  addedAt?: InputMaybe<Scalars['Datetime']>;
  route?: InputMaybe<Scalars['String']>;
  trialId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `FavoritePage` values. */
export type FavoritePagesConnection = {
  __typename?: 'FavoritePagesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<FavoritePageAggregates>;
  /** A list of edges which contains the `FavoritePage` and cursor to aid in pagination. */
  edges: Array<FavoritePagesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<FavoritePageAggregates>>;
  /** A list of `FavoritePage` objects. */
  nodes: Array<FavoritePage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `FavoritePage` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `FavoritePage` values. */
export type FavoritePagesConnectionGroupedAggregatesArgs = {
  groupBy: Array<FavoritePagesGroupBy>;
  having?: InputMaybe<FavoritePagesHavingInput>;
};

/** A `FavoritePage` edge in the connection. */
export type FavoritePagesEdge = {
  __typename?: 'FavoritePagesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `FavoritePage` at the end of the edge. */
  node: FavoritePage;
};

/** Grouping methods for `FavoritePage` for usage during aggregation. */
export type FavoritePagesGroupBy =
  | 'ADDED_AT'
  | 'ADDED_AT_TRUNCATED_TO_DAY'
  | 'ADDED_AT_TRUNCATED_TO_HOUR'
  | 'ROUTE'
  | 'TRIAL_ID';

export type FavoritePagesHavingAverageInput = {
  addedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FavoritePagesHavingDistinctCountInput = {
  addedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `FavoritePage` aggregates. */
export type FavoritePagesHavingInput = {
  AND?: InputMaybe<Array<FavoritePagesHavingInput>>;
  OR?: InputMaybe<Array<FavoritePagesHavingInput>>;
  average?: InputMaybe<FavoritePagesHavingAverageInput>;
  distinctCount?: InputMaybe<FavoritePagesHavingDistinctCountInput>;
  max?: InputMaybe<FavoritePagesHavingMaxInput>;
  min?: InputMaybe<FavoritePagesHavingMinInput>;
  stddevPopulation?: InputMaybe<FavoritePagesHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<FavoritePagesHavingStddevSampleInput>;
  sum?: InputMaybe<FavoritePagesHavingSumInput>;
  variancePopulation?: InputMaybe<FavoritePagesHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<FavoritePagesHavingVarianceSampleInput>;
};

export type FavoritePagesHavingMaxInput = {
  addedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FavoritePagesHavingMinInput = {
  addedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FavoritePagesHavingStddevPopulationInput = {
  addedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FavoritePagesHavingStddevSampleInput = {
  addedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FavoritePagesHavingSumInput = {
  addedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FavoritePagesHavingVariancePopulationInput = {
  addedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type FavoritePagesHavingVarianceSampleInput = {
  addedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `FavoritePage`. */
export type FavoritePagesOrderBy =
  | 'ADDED_AT_ASC'
  | 'ADDED_AT_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'ROUTE_ASC'
  | 'ROUTE_DESC'
  | 'TRIAL_ID_ASC'
  | 'TRIAL_ID_DESC';

/** All input for the `generateGravatarHashFromEmail` mutation. */
export type GenerateGravatarHashFromEmailInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `generateGravatarHashFromEmail` mutation. */
export type GenerateGravatarHashFromEmailPayload = {
  __typename?: 'GenerateGravatarHashFromEmailPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  string?: Maybe<Scalars['String']>;
};

/** All input for the `generateSamplingPlan2` mutation. */
export type GenerateSamplingPlan2Input = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  forDays?: InputMaybe<Scalars['Int']>;
};

/** The output of our `generateSamplingPlan2` mutation. */
export type GenerateSamplingPlan2Payload = {
  __typename?: 'GenerateSamplingPlan2Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  emaEntries2S?: Maybe<Array<EmaEntries2>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `generateSamplingPlan3` mutation. */
export type GenerateSamplingPlan3Input = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  forDays?: InputMaybe<Scalars['Int']>;
  startsAt?: InputMaybe<Scalars['Date']>;
};

/** The output of our `generateSamplingPlan3` mutation. */
export type GenerateSamplingPlan3Payload = {
  __typename?: 'GenerateSamplingPlan3Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  emaEntries3S?: Maybe<Array<EmaEntries3>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `generateSamplingPlan` mutation. */
export type GenerateSamplingPlanInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  forDays?: InputMaybe<Scalars['Int']>;
};

/** The output of our `generateSamplingPlan` mutation. */
export type GenerateSamplingPlanPayload = {
  __typename?: 'GenerateSamplingPlanPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  emaEntries?: Maybe<Array<EmaEntry>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type GenericEmiExercise = Node & {
  __typename?: 'GenericEmiExercise';
  body: Scalars['JSON'];
  createdAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Trial` that is related to this `GenericEmiExercise`. */
  trial?: Maybe<Trial>;
  trialId: Scalars['UUID'];
  type: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};

export type GenericEmiExerciseAggregates = {
  __typename?: 'GenericEmiExerciseAggregates';
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<GenericEmiExerciseDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
};

/** A filter to be used against aggregates of `GenericEmiExercise` object types. */
export type GenericEmiExerciseAggregatesFilter = {
  /** Distinct count aggregate over matching `GenericEmiExercise` objects. */
  distinctCount?: InputMaybe<GenericEmiExerciseDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `GenericEmiExercise` object to be included within the aggregate. */
  filter?: InputMaybe<GenericEmiExerciseFilter>;
};

/**
 * A condition to be used against `GenericEmiExercise` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type GenericEmiExerciseCondition = {
  /** Checks for equality with the object’s `body` field. */
  body?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `trialId` field. */
  trialId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type GenericEmiExerciseDistinctCountAggregateFilter = {
  body?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  name?: InputMaybe<BigIntFilter>;
  trialId?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type GenericEmiExerciseDistinctCountAggregates = {
  __typename?: 'GenericEmiExerciseDistinctCountAggregates';
  /** Distinct count of body across the matching connection */
  body?: Maybe<Scalars['BigInt']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']>;
  /** Distinct count of name across the matching connection */
  name?: Maybe<Scalars['BigInt']>;
  /** Distinct count of trialId across the matching connection */
  trialId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `GenericEmiExercise` object types. All fields are combined with a logical ‘and.’ */
export type GenericEmiExerciseFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GenericEmiExerciseFilter>>;
  /** Filter by the object’s `body` field. */
  body?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GenericEmiExerciseFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GenericEmiExerciseFilter>>;
  /** Filter by the object’s `trial` relation. */
  trial?: InputMaybe<TrialFilter>;
  /** Filter by the object’s `trialId` field. */
  trialId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `GenericEmiExercise` */
export type GenericEmiExerciseInput = {
  body?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  trialId?: InputMaybe<Scalars['UUID']>;
  type: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `GenericEmiExercise`. Fields that are set will be updated. */
export type GenericEmiExercisePatch = {
  body?: InputMaybe<Scalars['JSON']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  trialId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `GenericEmiExercise` values. */
export type GenericEmiExercisesConnection = {
  __typename?: 'GenericEmiExercisesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<GenericEmiExerciseAggregates>;
  /** A list of edges which contains the `GenericEmiExercise` and cursor to aid in pagination. */
  edges: Array<GenericEmiExercisesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<GenericEmiExerciseAggregates>>;
  /** A list of `GenericEmiExercise` objects. */
  nodes: Array<GenericEmiExercise>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GenericEmiExercise` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `GenericEmiExercise` values. */
export type GenericEmiExercisesConnectionGroupedAggregatesArgs = {
  groupBy: Array<GenericEmiExercisesGroupBy>;
  having?: InputMaybe<GenericEmiExercisesHavingInput>;
};

/** A `GenericEmiExercise` edge in the connection. */
export type GenericEmiExercisesEdge = {
  __typename?: 'GenericEmiExercisesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GenericEmiExercise` at the end of the edge. */
  node: GenericEmiExercise;
};

/** Grouping methods for `GenericEmiExercise` for usage during aggregation. */
export type GenericEmiExercisesGroupBy =
  | 'BODY'
  | 'CREATED_AT'
  | 'CREATED_AT_TRUNCATED_TO_DAY'
  | 'CREATED_AT_TRUNCATED_TO_HOUR'
  | 'NAME'
  | 'TRIAL_ID'
  | 'TYPE'
  | 'UPDATED_AT'
  | 'UPDATED_AT_TRUNCATED_TO_DAY'
  | 'UPDATED_AT_TRUNCATED_TO_HOUR';

export type GenericEmiExercisesHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type GenericEmiExercisesHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `GenericEmiExercise` aggregates. */
export type GenericEmiExercisesHavingInput = {
  AND?: InputMaybe<Array<GenericEmiExercisesHavingInput>>;
  OR?: InputMaybe<Array<GenericEmiExercisesHavingInput>>;
  average?: InputMaybe<GenericEmiExercisesHavingAverageInput>;
  distinctCount?: InputMaybe<GenericEmiExercisesHavingDistinctCountInput>;
  max?: InputMaybe<GenericEmiExercisesHavingMaxInput>;
  min?: InputMaybe<GenericEmiExercisesHavingMinInput>;
  stddevPopulation?: InputMaybe<GenericEmiExercisesHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<GenericEmiExercisesHavingStddevSampleInput>;
  sum?: InputMaybe<GenericEmiExercisesHavingSumInput>;
  variancePopulation?: InputMaybe<GenericEmiExercisesHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<GenericEmiExercisesHavingVarianceSampleInput>;
};

export type GenericEmiExercisesHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type GenericEmiExercisesHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type GenericEmiExercisesHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type GenericEmiExercisesHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type GenericEmiExercisesHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type GenericEmiExercisesHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type GenericEmiExercisesHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `GenericEmiExercise`. */
export type GenericEmiExercisesOrderBy =
  | 'BODY_ASC'
  | 'BODY_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TRIAL_ID_ASC'
  | 'TRIAL_ID_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

export type Group = Node & {
  __typename?: 'Group';
  canJoin: GroupVisibility;
  canManage: GroupRole;
  countOfMembers?: Maybe<Scalars['BigInt']>;
  createdAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `Group`. */
  creator?: Maybe<User>;
  creatorId?: Maybe<Scalars['UUID']>;
  externalNames?: Maybe<Array<Maybe<Scalars['String']>>>;
  flags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Reads a single `GroupHome` that is related to this `Group`. */
  home?: Maybe<GroupHome>;
  homeId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  /** Reads and enables pagination through a set of `MembershipInvitation`. */
  membershipInvitations: MembershipInvitationsConnection;
  /** Reads and enables pagination through a set of `MembershipInvitation`. */
  membershipInvitationsByInvitedGroupId: MembershipInvitationsConnection;
  /** Reads and enables pagination through a set of `Membership`. */
  memberships: MembershipsConnection;
  /** Reads and enables pagination through a set of `Membership`. */
  membershipsBySubgroupId: MembershipsConnection;
  myEffectiveRole?: Maybe<GroupRole>;
  /** Reads and enables pagination through a set of `MembershipInvitation`. */
  myIssuedInvitations: MembershipInvitationsConnection;
  myMembership?: Maybe<Membership>;
  myMembershipExists?: Maybe<Scalars['Boolean']>;
  /** Reads and enables pagination through a set of `Membership`. */
  myMemberships: MembershipsConnection;
  /** Reads and enables pagination through a set of `Membership`. */
  myPeersMemberships: MembershipsConnection;
  /** Reads and enables pagination through a set of `MembershipInvitation`. */
  myReceivedInvitations: MembershipInvitationsConnection;
  name?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Conversation`. */
  privateConversations: ConversationsConnection;
  /** Reads a single `Tenant` that is related to this `Group`. */
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `Trial`. */
  trialsByStaffId: TrialsConnection;
  updatedAt: Scalars['Datetime'];
};


export type GroupCountOfMembersArgs = {
  ifRoleIsAtLeast?: InputMaybe<GroupRole>;
  ifRoleIsAtMost?: InputMaybe<GroupRole>;
};


export type GroupMembershipInvitationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MembershipInvitationCondition>;
  filter?: InputMaybe<MembershipInvitationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MembershipInvitationsOrderBy>>;
};


export type GroupMembershipInvitationsByInvitedGroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MembershipInvitationCondition>;
  filter?: InputMaybe<MembershipInvitationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MembershipInvitationsOrderBy>>;
};


export type GroupMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MembershipCondition>;
  filter?: InputMaybe<MembershipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};


export type GroupMembershipsBySubgroupIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MembershipCondition>;
  filter?: InputMaybe<MembershipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};


export type GroupMyIssuedInvitationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MembershipInvitationCondition>;
  filter?: InputMaybe<MembershipInvitationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MembershipInvitationsOrderBy>>;
};


export type GroupMyMembershipExistsArgs = {
  ifRoleIsAtLeast?: InputMaybe<GroupRole>;
  ifRoleIsAtMost?: InputMaybe<GroupRole>;
};


export type GroupMyMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MembershipCondition>;
  filter?: InputMaybe<MembershipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};


export type GroupMyPeersMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MembershipCondition>;
  filter?: InputMaybe<MembershipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  includeSupergroups?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};


export type GroupMyReceivedInvitationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MembershipInvitationCondition>;
  filter?: InputMaybe<MembershipInvitationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  includeGroupInvitations?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MembershipInvitationsOrderBy>>;
};


export type GroupPrivateConversationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ConversationCondition>;
  filter?: InputMaybe<ConversationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
};


export type GroupTrialsByStaffIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TrialCondition>;
  filter?: InputMaybe<TrialFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TrialsOrderBy>>;
};

export type GroupAggregates = {
  __typename?: 'GroupAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<GroupAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<GroupDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<GroupMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<GroupMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<GroupStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<GroupStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<GroupSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<GroupVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<GroupVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Group` object types. */
export type GroupAggregatesFilter = {
  /** Mean average aggregate over matching `Group` objects. */
  average?: InputMaybe<GroupAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Group` objects. */
  distinctCount?: InputMaybe<GroupDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Group` object to be included within the aggregate. */
  filter?: InputMaybe<GroupFilter>;
  /** Maximum aggregate over matching `Group` objects. */
  max?: InputMaybe<GroupMaxAggregateFilter>;
  /** Minimum aggregate over matching `Group` objects. */
  min?: InputMaybe<GroupMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Group` objects. */
  stddevPopulation?: InputMaybe<GroupStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Group` objects. */
  stddevSample?: InputMaybe<GroupStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Group` objects. */
  sum?: InputMaybe<GroupSumAggregateFilter>;
  /** Population variance aggregate over matching `Group` objects. */
  variancePopulation?: InputMaybe<GroupVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Group` objects. */
  varianceSample?: InputMaybe<GroupVarianceSampleAggregateFilter>;
};

export type GroupAverageAggregateFilter = {
  countOfMembers?: InputMaybe<BigIntFilter>;
};

export type GroupAverageAggregates = {
  __typename?: 'GroupAverageAggregates';
  /** Mean average of this field across the matching connection. */
  countOfMembers?: Maybe<Scalars['BigFloat']>;
};


export type GroupAverageAggregatesCountOfMembersArgs = {
  ifRoleIsAtLeast?: InputMaybe<GroupRole>;
  ifRoleIsAtMost?: InputMaybe<GroupRole>;
};

/** A condition to be used against `Group` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type GroupCondition = {
  /** Checks for equality with the object’s `canJoin` field. */
  canJoin?: InputMaybe<GroupVisibility>;
  /** Checks for equality with the object’s `canManage` field. */
  canManage?: InputMaybe<GroupRole>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `creatorId` field. */
  creatorId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `externalNames` field. */
  externalNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `flags` field. */
  flags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `homeId` field. */
  homeId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `myEffectiveRole` field. */
  myEffectiveRole?: InputMaybe<GroupRole>;
  /** Checks for equality with the object’s `myMembershipExists` field. */
  myMembershipExists?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type GroupDistinctCountAggregateFilter = {
  canJoin?: InputMaybe<BigIntFilter>;
  canManage?: InputMaybe<BigIntFilter>;
  countOfMembers?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  creatorId?: InputMaybe<BigIntFilter>;
  externalNames?: InputMaybe<BigIntFilter>;
  flags?: InputMaybe<BigIntFilter>;
  homeId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  myEffectiveRole?: InputMaybe<GroupRoleFilter>;
  myMembershipExists?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<BigIntFilter>;
  tenantId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type GroupDistinctCountAggregates = {
  __typename?: 'GroupDistinctCountAggregates';
  /** Distinct count of canJoin across the matching connection */
  canJoin?: Maybe<Scalars['BigInt']>;
  /** Distinct count of canManage across the matching connection */
  canManage?: Maybe<Scalars['BigInt']>;
  /** Distinct count of this field across the matching connection. */
  countOfMembers?: Maybe<Scalars['BigInt']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of creatorId across the matching connection */
  creatorId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of externalNames across the matching connection */
  externalNames?: Maybe<Scalars['BigInt']>;
  /** Distinct count of flags across the matching connection */
  flags?: Maybe<Scalars['BigInt']>;
  /** Distinct count of homeId across the matching connection */
  homeId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']>;
  /** Distinct count of this field across the matching connection. */
  myEffectiveRole?: Maybe<Scalars['BigInt']>;
  /** Distinct count of this field across the matching connection. */
  myMembership?: Maybe<Scalars['BigInt']>;
  /** Distinct count of this field across the matching connection. */
  myMembershipExists?: Maybe<Scalars['BigInt']>;
  /** Distinct count of name across the matching connection */
  name?: Maybe<Scalars['BigInt']>;
  /** Distinct count of tenantId across the matching connection */
  tenantId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']>;
};


export type GroupDistinctCountAggregatesCountOfMembersArgs = {
  ifRoleIsAtLeast?: InputMaybe<GroupRole>;
  ifRoleIsAtMost?: InputMaybe<GroupRole>;
};


export type GroupDistinctCountAggregatesMyMembershipExistsArgs = {
  ifRoleIsAtLeast?: InputMaybe<GroupRole>;
  ifRoleIsAtMost?: InputMaybe<GroupRole>;
};

/** A filter to be used against `Group` object types. All fields are combined with a logical ‘and.’ */
export type GroupFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GroupFilter>>;
  /** Filter by the object’s `canJoin` field. */
  canJoin?: InputMaybe<GroupVisibilityFilter>;
  /** Filter by the object’s `canManage` field. */
  canManage?: InputMaybe<GroupRoleFilter>;
  /** Filter by the object’s `countOfMembers` field. */
  countOfMembers?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `creator` relation. */
  creator?: InputMaybe<UserFilter>;
  /** A related `creator` exists. */
  creatorExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `creatorId` field. */
  creatorId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `externalNames` field. */
  externalNames?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `flags` field. */
  flags?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `home` relation. */
  home?: InputMaybe<GroupHomeFilter>;
  /** A related `home` exists. */
  homeExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `homeId` field. */
  homeId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `membershipInvitations` relation. */
  membershipInvitations?: InputMaybe<GroupToManyMembershipInvitationFilter>;
  /** Filter by the object’s `membershipInvitationsByInvitedGroupId` relation. */
  membershipInvitationsByInvitedGroupId?: InputMaybe<GroupToManyMembershipInvitationFilter>;
  /** Some related `membershipInvitationsByInvitedGroupId` exist. */
  membershipInvitationsByInvitedGroupIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Some related `membershipInvitations` exist. */
  membershipInvitationsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `memberships` relation. */
  memberships?: InputMaybe<GroupToManyMembershipFilter>;
  /** Filter by the object’s `membershipsBySubgroupId` relation. */
  membershipsBySubgroupId?: InputMaybe<GroupToManyMembershipFilter>;
  /** Some related `membershipsBySubgroupId` exist. */
  membershipsBySubgroupIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Some related `memberships` exist. */
  membershipsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `myEffectiveRole` field. */
  myEffectiveRole?: InputMaybe<GroupRoleFilter>;
  /** Filter by the object’s `myMembershipExists` field. */
  myMembershipExists?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GroupFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GroupFilter>>;
  /** Filter by the object’s `privateConversations` relation. */
  privateConversations?: InputMaybe<GroupToManyConversationFilter>;
  /** Some related `privateConversations` exist. */
  privateConversationsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `tenant` relation. */
  tenant?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `trialsByStaffId` relation. */
  trialsByStaffId?: InputMaybe<GroupToManyTrialFilter>;
  /** Some related `trialsByStaffId` exist. */
  trialsByStaffIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type GroupHome = Node & {
  __typename?: 'GroupHome';
  /** Reads and enables pagination through a set of `Group`. */
  groupsByHomeId: GroupsConnection;
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  origin: Scalars['RegClass'];
  registeredAt: Scalars['Datetime'];
  /** Reads a single `Trial` that is related to this `GroupHome`. */
  trialById?: Maybe<Trial>;
  /**
   * Reads and enables pagination through a set of `Trial`.
   * @deprecated Please use trialById instead
   */
  trialsById: TrialsConnection;
};


export type GroupHomeGroupsByHomeIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupCondition>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


export type GroupHomeTrialsByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TrialCondition>;
  filter?: InputMaybe<TrialFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TrialsOrderBy>>;
};

export type GroupHomeAggregates = {
  __typename?: 'GroupHomeAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<GroupHomeAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<GroupHomeDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<GroupHomeMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<GroupHomeMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<GroupHomeStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<GroupHomeStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<GroupHomeSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<GroupHomeVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<GroupHomeVarianceSampleAggregates>;
};

export type GroupHomeAverageAggregates = {
  __typename?: 'GroupHomeAverageAggregates';
  /** Mean average of origin across the matching connection */
  origin?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `GroupHome` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type GroupHomeCondition = {
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `origin` field. */
  origin?: InputMaybe<Scalars['RegClass']>;
  /** Checks for equality with the object’s `registeredAt` field. */
  registeredAt?: InputMaybe<Scalars['Datetime']>;
};

export type GroupHomeDistinctCountAggregates = {
  __typename?: 'GroupHomeDistinctCountAggregates';
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']>;
  /** Distinct count of origin across the matching connection */
  origin?: Maybe<Scalars['BigInt']>;
  /** Distinct count of registeredAt across the matching connection */
  registeredAt?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `GroupHome` object types. All fields are combined with a logical ‘and.’ */
export type GroupHomeFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<GroupHomeFilter>>;
  /** Filter by the object’s `groupsByHomeId` relation. */
  groupsByHomeId?: InputMaybe<GroupHomeToManyGroupFilter>;
  /** Some related `groupsByHomeId` exist. */
  groupsByHomeIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<GroupHomeFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<GroupHomeFilter>>;
  /** Filter by the object’s `registeredAt` field. */
  registeredAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `trialById` relation. */
  trialById?: InputMaybe<TrialFilter>;
  /** A related `trialById` exists. */
  trialByIdExists?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `GroupHome` */
export type GroupHomeInput = {
  id: Scalars['UUID'];
  origin: Scalars['RegClass'];
  registeredAt?: InputMaybe<Scalars['Datetime']>;
};

export type GroupHomeMaxAggregates = {
  __typename?: 'GroupHomeMaxAggregates';
  /** Maximum of origin across the matching connection */
  origin?: Maybe<Scalars['RegClass']>;
};

export type GroupHomeMinAggregates = {
  __typename?: 'GroupHomeMinAggregates';
  /** Minimum of origin across the matching connection */
  origin?: Maybe<Scalars['RegClass']>;
};

/** Represents an update to a `GroupHome`. Fields that are set will be updated. */
export type GroupHomePatch = {
  id?: InputMaybe<Scalars['UUID']>;
  origin?: InputMaybe<Scalars['RegClass']>;
  registeredAt?: InputMaybe<Scalars['Datetime']>;
};

export type GroupHomeStddevPopulationAggregates = {
  __typename?: 'GroupHomeStddevPopulationAggregates';
  /** Population standard deviation of origin across the matching connection */
  origin?: Maybe<Scalars['BigFloat']>;
};

export type GroupHomeStddevSampleAggregates = {
  __typename?: 'GroupHomeStddevSampleAggregates';
  /** Sample standard deviation of origin across the matching connection */
  origin?: Maybe<Scalars['BigFloat']>;
};

export type GroupHomeSumAggregates = {
  __typename?: 'GroupHomeSumAggregates';
  /** Sum of origin across the matching connection */
  origin: Scalars['BigFloat'];
};

/** A filter to be used against many `Group` object types. All fields are combined with a logical ‘and.’ */
export type GroupHomeToManyGroupFilter = {
  /** Aggregates across related `Group` match the filter criteria. */
  aggregates?: InputMaybe<GroupAggregatesFilter>;
  /** Every related `Group` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GroupFilter>;
  /** No related `Group` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GroupFilter>;
  /** Some related `Group` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GroupFilter>;
};

export type GroupHomeVariancePopulationAggregates = {
  __typename?: 'GroupHomeVariancePopulationAggregates';
  /** Population variance of origin across the matching connection */
  origin?: Maybe<Scalars['BigFloat']>;
};

export type GroupHomeVarianceSampleAggregates = {
  __typename?: 'GroupHomeVarianceSampleAggregates';
  /** Sample variance of origin across the matching connection */
  origin?: Maybe<Scalars['BigFloat']>;
};

/** A connection to a list of `GroupHome` values. */
export type GroupHomesConnection = {
  __typename?: 'GroupHomesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<GroupHomeAggregates>;
  /** A list of edges which contains the `GroupHome` and cursor to aid in pagination. */
  edges: Array<GroupHomesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<GroupHomeAggregates>>;
  /** A list of `GroupHome` objects. */
  nodes: Array<GroupHome>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `GroupHome` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `GroupHome` values. */
export type GroupHomesConnectionGroupedAggregatesArgs = {
  groupBy: Array<GroupHomesGroupBy>;
  having?: InputMaybe<GroupHomesHavingInput>;
};

/** A `GroupHome` edge in the connection. */
export type GroupHomesEdge = {
  __typename?: 'GroupHomesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `GroupHome` at the end of the edge. */
  node: GroupHome;
};

/** Grouping methods for `GroupHome` for usage during aggregation. */
export type GroupHomesGroupBy =
  | 'ORIGIN'
  | 'REGISTERED_AT'
  | 'REGISTERED_AT_TRUNCATED_TO_DAY'
  | 'REGISTERED_AT_TRUNCATED_TO_HOUR';

export type GroupHomesHavingAverageInput = {
  registeredAt?: InputMaybe<HavingDatetimeFilter>;
};

export type GroupHomesHavingDistinctCountInput = {
  registeredAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `GroupHome` aggregates. */
export type GroupHomesHavingInput = {
  AND?: InputMaybe<Array<GroupHomesHavingInput>>;
  OR?: InputMaybe<Array<GroupHomesHavingInput>>;
  average?: InputMaybe<GroupHomesHavingAverageInput>;
  distinctCount?: InputMaybe<GroupHomesHavingDistinctCountInput>;
  max?: InputMaybe<GroupHomesHavingMaxInput>;
  min?: InputMaybe<GroupHomesHavingMinInput>;
  stddevPopulation?: InputMaybe<GroupHomesHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<GroupHomesHavingStddevSampleInput>;
  sum?: InputMaybe<GroupHomesHavingSumInput>;
  variancePopulation?: InputMaybe<GroupHomesHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<GroupHomesHavingVarianceSampleInput>;
};

export type GroupHomesHavingMaxInput = {
  registeredAt?: InputMaybe<HavingDatetimeFilter>;
};

export type GroupHomesHavingMinInput = {
  registeredAt?: InputMaybe<HavingDatetimeFilter>;
};

export type GroupHomesHavingStddevPopulationInput = {
  registeredAt?: InputMaybe<HavingDatetimeFilter>;
};

export type GroupHomesHavingStddevSampleInput = {
  registeredAt?: InputMaybe<HavingDatetimeFilter>;
};

export type GroupHomesHavingSumInput = {
  registeredAt?: InputMaybe<HavingDatetimeFilter>;
};

export type GroupHomesHavingVariancePopulationInput = {
  registeredAt?: InputMaybe<HavingDatetimeFilter>;
};

export type GroupHomesHavingVarianceSampleInput = {
  registeredAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `GroupHome`. */
export type GroupHomesOrderBy =
  | 'GROUPS_BY_HOME_ID_AVERAGE_CAN_JOIN_ASC'
  | 'GROUPS_BY_HOME_ID_AVERAGE_CAN_JOIN_DESC'
  | 'GROUPS_BY_HOME_ID_AVERAGE_CAN_MANAGE_ASC'
  | 'GROUPS_BY_HOME_ID_AVERAGE_CAN_MANAGE_DESC'
  | 'GROUPS_BY_HOME_ID_AVERAGE_CREATED_AT_ASC'
  | 'GROUPS_BY_HOME_ID_AVERAGE_CREATED_AT_DESC'
  | 'GROUPS_BY_HOME_ID_AVERAGE_CREATOR_ID_ASC'
  | 'GROUPS_BY_HOME_ID_AVERAGE_CREATOR_ID_DESC'
  | 'GROUPS_BY_HOME_ID_AVERAGE_EXTERNAL_NAMES_ASC'
  | 'GROUPS_BY_HOME_ID_AVERAGE_EXTERNAL_NAMES_DESC'
  | 'GROUPS_BY_HOME_ID_AVERAGE_FLAGS_ASC'
  | 'GROUPS_BY_HOME_ID_AVERAGE_FLAGS_DESC'
  | 'GROUPS_BY_HOME_ID_AVERAGE_HOME_ID_ASC'
  | 'GROUPS_BY_HOME_ID_AVERAGE_HOME_ID_DESC'
  | 'GROUPS_BY_HOME_ID_AVERAGE_ID_ASC'
  | 'GROUPS_BY_HOME_ID_AVERAGE_ID_DESC'
  | 'GROUPS_BY_HOME_ID_AVERAGE_NAME_ASC'
  | 'GROUPS_BY_HOME_ID_AVERAGE_NAME_DESC'
  | 'GROUPS_BY_HOME_ID_AVERAGE_TENANT_ID_ASC'
  | 'GROUPS_BY_HOME_ID_AVERAGE_TENANT_ID_DESC'
  | 'GROUPS_BY_HOME_ID_AVERAGE_UPDATED_AT_ASC'
  | 'GROUPS_BY_HOME_ID_AVERAGE_UPDATED_AT_DESC'
  | 'GROUPS_BY_HOME_ID_COUNT_ASC'
  | 'GROUPS_BY_HOME_ID_COUNT_DESC'
  | 'GROUPS_BY_HOME_ID_DISTINCT_COUNT_CAN_JOIN_ASC'
  | 'GROUPS_BY_HOME_ID_DISTINCT_COUNT_CAN_JOIN_DESC'
  | 'GROUPS_BY_HOME_ID_DISTINCT_COUNT_CAN_MANAGE_ASC'
  | 'GROUPS_BY_HOME_ID_DISTINCT_COUNT_CAN_MANAGE_DESC'
  | 'GROUPS_BY_HOME_ID_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'GROUPS_BY_HOME_ID_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'GROUPS_BY_HOME_ID_DISTINCT_COUNT_CREATOR_ID_ASC'
  | 'GROUPS_BY_HOME_ID_DISTINCT_COUNT_CREATOR_ID_DESC'
  | 'GROUPS_BY_HOME_ID_DISTINCT_COUNT_EXTERNAL_NAMES_ASC'
  | 'GROUPS_BY_HOME_ID_DISTINCT_COUNT_EXTERNAL_NAMES_DESC'
  | 'GROUPS_BY_HOME_ID_DISTINCT_COUNT_FLAGS_ASC'
  | 'GROUPS_BY_HOME_ID_DISTINCT_COUNT_FLAGS_DESC'
  | 'GROUPS_BY_HOME_ID_DISTINCT_COUNT_HOME_ID_ASC'
  | 'GROUPS_BY_HOME_ID_DISTINCT_COUNT_HOME_ID_DESC'
  | 'GROUPS_BY_HOME_ID_DISTINCT_COUNT_ID_ASC'
  | 'GROUPS_BY_HOME_ID_DISTINCT_COUNT_ID_DESC'
  | 'GROUPS_BY_HOME_ID_DISTINCT_COUNT_NAME_ASC'
  | 'GROUPS_BY_HOME_ID_DISTINCT_COUNT_NAME_DESC'
  | 'GROUPS_BY_HOME_ID_DISTINCT_COUNT_TENANT_ID_ASC'
  | 'GROUPS_BY_HOME_ID_DISTINCT_COUNT_TENANT_ID_DESC'
  | 'GROUPS_BY_HOME_ID_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'GROUPS_BY_HOME_ID_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'GROUPS_BY_HOME_ID_MAX_CAN_JOIN_ASC'
  | 'GROUPS_BY_HOME_ID_MAX_CAN_JOIN_DESC'
  | 'GROUPS_BY_HOME_ID_MAX_CAN_MANAGE_ASC'
  | 'GROUPS_BY_HOME_ID_MAX_CAN_MANAGE_DESC'
  | 'GROUPS_BY_HOME_ID_MAX_CREATED_AT_ASC'
  | 'GROUPS_BY_HOME_ID_MAX_CREATED_AT_DESC'
  | 'GROUPS_BY_HOME_ID_MAX_CREATOR_ID_ASC'
  | 'GROUPS_BY_HOME_ID_MAX_CREATOR_ID_DESC'
  | 'GROUPS_BY_HOME_ID_MAX_EXTERNAL_NAMES_ASC'
  | 'GROUPS_BY_HOME_ID_MAX_EXTERNAL_NAMES_DESC'
  | 'GROUPS_BY_HOME_ID_MAX_FLAGS_ASC'
  | 'GROUPS_BY_HOME_ID_MAX_FLAGS_DESC'
  | 'GROUPS_BY_HOME_ID_MAX_HOME_ID_ASC'
  | 'GROUPS_BY_HOME_ID_MAX_HOME_ID_DESC'
  | 'GROUPS_BY_HOME_ID_MAX_ID_ASC'
  | 'GROUPS_BY_HOME_ID_MAX_ID_DESC'
  | 'GROUPS_BY_HOME_ID_MAX_NAME_ASC'
  | 'GROUPS_BY_HOME_ID_MAX_NAME_DESC'
  | 'GROUPS_BY_HOME_ID_MAX_TENANT_ID_ASC'
  | 'GROUPS_BY_HOME_ID_MAX_TENANT_ID_DESC'
  | 'GROUPS_BY_HOME_ID_MAX_UPDATED_AT_ASC'
  | 'GROUPS_BY_HOME_ID_MAX_UPDATED_AT_DESC'
  | 'GROUPS_BY_HOME_ID_MIN_CAN_JOIN_ASC'
  | 'GROUPS_BY_HOME_ID_MIN_CAN_JOIN_DESC'
  | 'GROUPS_BY_HOME_ID_MIN_CAN_MANAGE_ASC'
  | 'GROUPS_BY_HOME_ID_MIN_CAN_MANAGE_DESC'
  | 'GROUPS_BY_HOME_ID_MIN_CREATED_AT_ASC'
  | 'GROUPS_BY_HOME_ID_MIN_CREATED_AT_DESC'
  | 'GROUPS_BY_HOME_ID_MIN_CREATOR_ID_ASC'
  | 'GROUPS_BY_HOME_ID_MIN_CREATOR_ID_DESC'
  | 'GROUPS_BY_HOME_ID_MIN_EXTERNAL_NAMES_ASC'
  | 'GROUPS_BY_HOME_ID_MIN_EXTERNAL_NAMES_DESC'
  | 'GROUPS_BY_HOME_ID_MIN_FLAGS_ASC'
  | 'GROUPS_BY_HOME_ID_MIN_FLAGS_DESC'
  | 'GROUPS_BY_HOME_ID_MIN_HOME_ID_ASC'
  | 'GROUPS_BY_HOME_ID_MIN_HOME_ID_DESC'
  | 'GROUPS_BY_HOME_ID_MIN_ID_ASC'
  | 'GROUPS_BY_HOME_ID_MIN_ID_DESC'
  | 'GROUPS_BY_HOME_ID_MIN_NAME_ASC'
  | 'GROUPS_BY_HOME_ID_MIN_NAME_DESC'
  | 'GROUPS_BY_HOME_ID_MIN_TENANT_ID_ASC'
  | 'GROUPS_BY_HOME_ID_MIN_TENANT_ID_DESC'
  | 'GROUPS_BY_HOME_ID_MIN_UPDATED_AT_ASC'
  | 'GROUPS_BY_HOME_ID_MIN_UPDATED_AT_DESC'
  | 'GROUPS_BY_HOME_ID_STDDEV_POPULATION_CAN_JOIN_ASC'
  | 'GROUPS_BY_HOME_ID_STDDEV_POPULATION_CAN_JOIN_DESC'
  | 'GROUPS_BY_HOME_ID_STDDEV_POPULATION_CAN_MANAGE_ASC'
  | 'GROUPS_BY_HOME_ID_STDDEV_POPULATION_CAN_MANAGE_DESC'
  | 'GROUPS_BY_HOME_ID_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'GROUPS_BY_HOME_ID_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'GROUPS_BY_HOME_ID_STDDEV_POPULATION_CREATOR_ID_ASC'
  | 'GROUPS_BY_HOME_ID_STDDEV_POPULATION_CREATOR_ID_DESC'
  | 'GROUPS_BY_HOME_ID_STDDEV_POPULATION_EXTERNAL_NAMES_ASC'
  | 'GROUPS_BY_HOME_ID_STDDEV_POPULATION_EXTERNAL_NAMES_DESC'
  | 'GROUPS_BY_HOME_ID_STDDEV_POPULATION_FLAGS_ASC'
  | 'GROUPS_BY_HOME_ID_STDDEV_POPULATION_FLAGS_DESC'
  | 'GROUPS_BY_HOME_ID_STDDEV_POPULATION_HOME_ID_ASC'
  | 'GROUPS_BY_HOME_ID_STDDEV_POPULATION_HOME_ID_DESC'
  | 'GROUPS_BY_HOME_ID_STDDEV_POPULATION_ID_ASC'
  | 'GROUPS_BY_HOME_ID_STDDEV_POPULATION_ID_DESC'
  | 'GROUPS_BY_HOME_ID_STDDEV_POPULATION_NAME_ASC'
  | 'GROUPS_BY_HOME_ID_STDDEV_POPULATION_NAME_DESC'
  | 'GROUPS_BY_HOME_ID_STDDEV_POPULATION_TENANT_ID_ASC'
  | 'GROUPS_BY_HOME_ID_STDDEV_POPULATION_TENANT_ID_DESC'
  | 'GROUPS_BY_HOME_ID_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'GROUPS_BY_HOME_ID_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'GROUPS_BY_HOME_ID_STDDEV_SAMPLE_CAN_JOIN_ASC'
  | 'GROUPS_BY_HOME_ID_STDDEV_SAMPLE_CAN_JOIN_DESC'
  | 'GROUPS_BY_HOME_ID_STDDEV_SAMPLE_CAN_MANAGE_ASC'
  | 'GROUPS_BY_HOME_ID_STDDEV_SAMPLE_CAN_MANAGE_DESC'
  | 'GROUPS_BY_HOME_ID_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'GROUPS_BY_HOME_ID_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'GROUPS_BY_HOME_ID_STDDEV_SAMPLE_CREATOR_ID_ASC'
  | 'GROUPS_BY_HOME_ID_STDDEV_SAMPLE_CREATOR_ID_DESC'
  | 'GROUPS_BY_HOME_ID_STDDEV_SAMPLE_EXTERNAL_NAMES_ASC'
  | 'GROUPS_BY_HOME_ID_STDDEV_SAMPLE_EXTERNAL_NAMES_DESC'
  | 'GROUPS_BY_HOME_ID_STDDEV_SAMPLE_FLAGS_ASC'
  | 'GROUPS_BY_HOME_ID_STDDEV_SAMPLE_FLAGS_DESC'
  | 'GROUPS_BY_HOME_ID_STDDEV_SAMPLE_HOME_ID_ASC'
  | 'GROUPS_BY_HOME_ID_STDDEV_SAMPLE_HOME_ID_DESC'
  | 'GROUPS_BY_HOME_ID_STDDEV_SAMPLE_ID_ASC'
  | 'GROUPS_BY_HOME_ID_STDDEV_SAMPLE_ID_DESC'
  | 'GROUPS_BY_HOME_ID_STDDEV_SAMPLE_NAME_ASC'
  | 'GROUPS_BY_HOME_ID_STDDEV_SAMPLE_NAME_DESC'
  | 'GROUPS_BY_HOME_ID_STDDEV_SAMPLE_TENANT_ID_ASC'
  | 'GROUPS_BY_HOME_ID_STDDEV_SAMPLE_TENANT_ID_DESC'
  | 'GROUPS_BY_HOME_ID_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'GROUPS_BY_HOME_ID_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'GROUPS_BY_HOME_ID_SUM_CAN_JOIN_ASC'
  | 'GROUPS_BY_HOME_ID_SUM_CAN_JOIN_DESC'
  | 'GROUPS_BY_HOME_ID_SUM_CAN_MANAGE_ASC'
  | 'GROUPS_BY_HOME_ID_SUM_CAN_MANAGE_DESC'
  | 'GROUPS_BY_HOME_ID_SUM_CREATED_AT_ASC'
  | 'GROUPS_BY_HOME_ID_SUM_CREATED_AT_DESC'
  | 'GROUPS_BY_HOME_ID_SUM_CREATOR_ID_ASC'
  | 'GROUPS_BY_HOME_ID_SUM_CREATOR_ID_DESC'
  | 'GROUPS_BY_HOME_ID_SUM_EXTERNAL_NAMES_ASC'
  | 'GROUPS_BY_HOME_ID_SUM_EXTERNAL_NAMES_DESC'
  | 'GROUPS_BY_HOME_ID_SUM_FLAGS_ASC'
  | 'GROUPS_BY_HOME_ID_SUM_FLAGS_DESC'
  | 'GROUPS_BY_HOME_ID_SUM_HOME_ID_ASC'
  | 'GROUPS_BY_HOME_ID_SUM_HOME_ID_DESC'
  | 'GROUPS_BY_HOME_ID_SUM_ID_ASC'
  | 'GROUPS_BY_HOME_ID_SUM_ID_DESC'
  | 'GROUPS_BY_HOME_ID_SUM_NAME_ASC'
  | 'GROUPS_BY_HOME_ID_SUM_NAME_DESC'
  | 'GROUPS_BY_HOME_ID_SUM_TENANT_ID_ASC'
  | 'GROUPS_BY_HOME_ID_SUM_TENANT_ID_DESC'
  | 'GROUPS_BY_HOME_ID_SUM_UPDATED_AT_ASC'
  | 'GROUPS_BY_HOME_ID_SUM_UPDATED_AT_DESC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_POPULATION_CAN_JOIN_ASC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_POPULATION_CAN_JOIN_DESC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_POPULATION_CAN_MANAGE_ASC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_POPULATION_CAN_MANAGE_DESC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_POPULATION_CREATOR_ID_ASC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_POPULATION_CREATOR_ID_DESC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_POPULATION_EXTERNAL_NAMES_ASC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_POPULATION_EXTERNAL_NAMES_DESC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_POPULATION_FLAGS_ASC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_POPULATION_FLAGS_DESC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_POPULATION_HOME_ID_ASC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_POPULATION_HOME_ID_DESC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_POPULATION_ID_ASC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_POPULATION_ID_DESC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_POPULATION_NAME_ASC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_POPULATION_NAME_DESC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_POPULATION_TENANT_ID_ASC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_POPULATION_TENANT_ID_DESC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_SAMPLE_CAN_JOIN_ASC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_SAMPLE_CAN_JOIN_DESC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_SAMPLE_CAN_MANAGE_ASC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_SAMPLE_CAN_MANAGE_DESC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_SAMPLE_CREATOR_ID_ASC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_SAMPLE_CREATOR_ID_DESC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_SAMPLE_EXTERNAL_NAMES_ASC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_SAMPLE_EXTERNAL_NAMES_DESC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_SAMPLE_FLAGS_ASC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_SAMPLE_FLAGS_DESC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_SAMPLE_HOME_ID_ASC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_SAMPLE_HOME_ID_DESC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_SAMPLE_NAME_ASC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_SAMPLE_NAME_DESC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_SAMPLE_TENANT_ID_ASC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_SAMPLE_TENANT_ID_DESC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'GROUPS_BY_HOME_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'ORIGIN_ASC'
  | 'ORIGIN_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REGISTERED_AT_ASC'
  | 'REGISTERED_AT_DESC';

/** An input for mutations affecting `Group` */
export type GroupInput = {
  canJoin?: InputMaybe<GroupVisibility>;
  canManage?: InputMaybe<GroupRole>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorId?: InputMaybe<Scalars['UUID']>;
  externalNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  flags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  homeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type GroupMaxAggregateFilter = {
  countOfMembers?: InputMaybe<BigIntFilter>;
};

export type GroupMaxAggregates = {
  __typename?: 'GroupMaxAggregates';
  /** Maximum of this field across the matching connection. */
  countOfMembers?: Maybe<Scalars['BigInt']>;
};


export type GroupMaxAggregatesCountOfMembersArgs = {
  ifRoleIsAtLeast?: InputMaybe<GroupRole>;
  ifRoleIsAtMost?: InputMaybe<GroupRole>;
};

export type GroupMinAggregateFilter = {
  countOfMembers?: InputMaybe<BigIntFilter>;
};

export type GroupMinAggregates = {
  __typename?: 'GroupMinAggregates';
  /** Minimum of this field across the matching connection. */
  countOfMembers?: Maybe<Scalars['BigInt']>;
};


export type GroupMinAggregatesCountOfMembersArgs = {
  ifRoleIsAtLeast?: InputMaybe<GroupRole>;
  ifRoleIsAtMost?: InputMaybe<GroupRole>;
};

/** Represents an update to a `Group`. Fields that are set will be updated. */
export type GroupPatch = {
  canJoin?: InputMaybe<GroupVisibility>;
  canManage?: InputMaybe<GroupRole>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  creatorId?: InputMaybe<Scalars['UUID']>;
  externalNames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  flags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  homeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type GroupRole =
  | 'BANNED'
  | 'GUEST'
  | 'MEMBER'
  | 'MODERATOR'
  | 'OWNER';

/** A filter to be used against GroupRole fields. All fields are combined with a logical ‘and.’ */
export type GroupRoleFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<GroupRole>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<GroupRole>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<GroupRole>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<GroupRole>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<GroupRole>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<GroupRole>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<GroupRole>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<GroupRole>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<GroupRole>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<GroupRole>>;
};

export type GroupStddevPopulationAggregateFilter = {
  countOfMembers?: InputMaybe<BigIntFilter>;
};

export type GroupStddevPopulationAggregates = {
  __typename?: 'GroupStddevPopulationAggregates';
  /** Population standard deviation of this field across the matching connection. */
  countOfMembers?: Maybe<Scalars['BigFloat']>;
};


export type GroupStddevPopulationAggregatesCountOfMembersArgs = {
  ifRoleIsAtLeast?: InputMaybe<GroupRole>;
  ifRoleIsAtMost?: InputMaybe<GroupRole>;
};

export type GroupStddevSampleAggregateFilter = {
  countOfMembers?: InputMaybe<BigIntFilter>;
};

export type GroupStddevSampleAggregates = {
  __typename?: 'GroupStddevSampleAggregates';
  /** Sample standard deviation of this field across the matching connection. */
  countOfMembers?: Maybe<Scalars['BigFloat']>;
};


export type GroupStddevSampleAggregatesCountOfMembersArgs = {
  ifRoleIsAtLeast?: InputMaybe<GroupRole>;
  ifRoleIsAtMost?: InputMaybe<GroupRole>;
};

export type GroupSumAggregateFilter = {
  countOfMembers?: InputMaybe<BigIntFilter>;
};

export type GroupSumAggregates = {
  __typename?: 'GroupSumAggregates';
  /** Sum of this field across the matching connection. */
  countOfMembers?: Maybe<Scalars['BigFloat']>;
};


export type GroupSumAggregatesCountOfMembersArgs = {
  ifRoleIsAtLeast?: InputMaybe<GroupRole>;
  ifRoleIsAtMost?: InputMaybe<GroupRole>;
};

/** A filter to be used against many `Conversation` object types. All fields are combined with a logical ‘and.’ */
export type GroupToManyConversationFilter = {
  /** Aggregates across related `Conversation` match the filter criteria. */
  aggregates?: InputMaybe<ConversationAggregatesFilter>;
  /** Every related `Conversation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ConversationFilter>;
  /** No related `Conversation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ConversationFilter>;
  /** Some related `Conversation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ConversationFilter>;
};

/** A filter to be used against many `Membership` object types. All fields are combined with a logical ‘and.’ */
export type GroupToManyMembershipFilter = {
  /** Aggregates across related `Membership` match the filter criteria. */
  aggregates?: InputMaybe<MembershipAggregatesFilter>;
  /** Every related `Membership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MembershipFilter>;
  /** No related `Membership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MembershipFilter>;
  /** Some related `Membership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MembershipFilter>;
};

/** A filter to be used against many `MembershipInvitation` object types. All fields are combined with a logical ‘and.’ */
export type GroupToManyMembershipInvitationFilter = {
  /** Aggregates across related `MembershipInvitation` match the filter criteria. */
  aggregates?: InputMaybe<MembershipInvitationAggregatesFilter>;
  /** Every related `MembershipInvitation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MembershipInvitationFilter>;
  /** No related `MembershipInvitation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MembershipInvitationFilter>;
  /** Some related `MembershipInvitation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MembershipInvitationFilter>;
};

/** A filter to be used against many `Trial` object types. All fields are combined with a logical ‘and.’ */
export type GroupToManyTrialFilter = {
  /** Aggregates across related `Trial` match the filter criteria. */
  aggregates?: InputMaybe<TrialAggregatesFilter>;
  /** Every related `Trial` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TrialFilter>;
  /** No related `Trial` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TrialFilter>;
  /** Some related `Trial` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TrialFilter>;
};

export type GroupVariancePopulationAggregateFilter = {
  countOfMembers?: InputMaybe<BigIntFilter>;
};

export type GroupVariancePopulationAggregates = {
  __typename?: 'GroupVariancePopulationAggregates';
  /** Population variance of this field across the matching connection. */
  countOfMembers?: Maybe<Scalars['BigFloat']>;
};


export type GroupVariancePopulationAggregatesCountOfMembersArgs = {
  ifRoleIsAtLeast?: InputMaybe<GroupRole>;
  ifRoleIsAtMost?: InputMaybe<GroupRole>;
};

export type GroupVarianceSampleAggregateFilter = {
  countOfMembers?: InputMaybe<BigIntFilter>;
};

export type GroupVarianceSampleAggregates = {
  __typename?: 'GroupVarianceSampleAggregates';
  /** Sample variance of this field across the matching connection. */
  countOfMembers?: Maybe<Scalars['BigFloat']>;
};


export type GroupVarianceSampleAggregatesCountOfMembersArgs = {
  ifRoleIsAtLeast?: InputMaybe<GroupRole>;
  ifRoleIsAtMost?: InputMaybe<GroupRole>;
};

export type GroupVisibility =
  | 'PEERS'
  | 'PRIVATE'
  | 'PUBLIC'
  | 'USERS';

/** A filter to be used against GroupVisibility fields. All fields are combined with a logical ‘and.’ */
export type GroupVisibilityFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<GroupVisibility>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<GroupVisibility>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<GroupVisibility>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<GroupVisibility>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<GroupVisibility>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<GroupVisibility>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<GroupVisibility>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<GroupVisibility>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<GroupVisibility>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<GroupVisibility>>;
};

/** A connection to a list of `Group` values. */
export type GroupsConnection = {
  __typename?: 'GroupsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<GroupAggregates>;
  /** A list of edges which contains the `Group` and cursor to aid in pagination. */
  edges: Array<GroupsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<GroupAggregates>>;
  /** A list of `Group` objects. */
  nodes: Array<Group>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Group` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `Group` values. */
export type GroupsConnectionGroupedAggregatesArgs = {
  groupBy: Array<GroupsGroupBy>;
  having?: InputMaybe<GroupsHavingInput>;
};

/** A `Group` edge in the connection. */
export type GroupsEdge = {
  __typename?: 'GroupsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Group` at the end of the edge. */
  node: Group;
};

/** Grouping methods for `Group` for usage during aggregation. */
export type GroupsGroupBy =
  | 'CAN_JOIN'
  | 'CAN_MANAGE'
  | 'CREATED_AT'
  | 'CREATED_AT_TRUNCATED_TO_DAY'
  | 'CREATED_AT_TRUNCATED_TO_HOUR'
  | 'CREATOR_ID'
  | 'EXTERNAL_NAMES'
  | 'FLAGS'
  | 'HOME_ID'
  | 'NAME'
  | 'TENANT_ID'
  | 'UPDATED_AT'
  | 'UPDATED_AT_TRUNCATED_TO_DAY'
  | 'UPDATED_AT_TRUNCATED_TO_HOUR';

export type GroupsHavingAverageGroupsCountOfMembersArgsInput = {
  ifRoleIsAtLeast?: InputMaybe<GroupRole>;
  ifRoleIsAtMost?: InputMaybe<GroupRole>;
};

export type GroupsHavingAverageGroupsCountOfMembersInput = {
  args?: InputMaybe<GroupsHavingAverageGroupsCountOfMembersArgsInput>;
  filter?: InputMaybe<HavingBigintFilter>;
};

export type GroupsHavingAverageInput = {
  countOfMembers?: InputMaybe<GroupsHavingAverageGroupsCountOfMembersInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type GroupsHavingDistinctCountGroupsCountOfMembersArgsInput = {
  ifRoleIsAtLeast?: InputMaybe<GroupRole>;
  ifRoleIsAtMost?: InputMaybe<GroupRole>;
};

export type GroupsHavingDistinctCountGroupsCountOfMembersInput = {
  args?: InputMaybe<GroupsHavingDistinctCountGroupsCountOfMembersArgsInput>;
  filter?: InputMaybe<HavingBigintFilter>;
};

export type GroupsHavingDistinctCountInput = {
  countOfMembers?: InputMaybe<GroupsHavingDistinctCountGroupsCountOfMembersInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `Group` aggregates. */
export type GroupsHavingInput = {
  AND?: InputMaybe<Array<GroupsHavingInput>>;
  OR?: InputMaybe<Array<GroupsHavingInput>>;
  average?: InputMaybe<GroupsHavingAverageInput>;
  distinctCount?: InputMaybe<GroupsHavingDistinctCountInput>;
  max?: InputMaybe<GroupsHavingMaxInput>;
  min?: InputMaybe<GroupsHavingMinInput>;
  stddevPopulation?: InputMaybe<GroupsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<GroupsHavingStddevSampleInput>;
  sum?: InputMaybe<GroupsHavingSumInput>;
  variancePopulation?: InputMaybe<GroupsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<GroupsHavingVarianceSampleInput>;
};

export type GroupsHavingMaxGroupsCountOfMembersArgsInput = {
  ifRoleIsAtLeast?: InputMaybe<GroupRole>;
  ifRoleIsAtMost?: InputMaybe<GroupRole>;
};

export type GroupsHavingMaxGroupsCountOfMembersInput = {
  args?: InputMaybe<GroupsHavingMaxGroupsCountOfMembersArgsInput>;
  filter?: InputMaybe<HavingBigintFilter>;
};

export type GroupsHavingMaxInput = {
  countOfMembers?: InputMaybe<GroupsHavingMaxGroupsCountOfMembersInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type GroupsHavingMinGroupsCountOfMembersArgsInput = {
  ifRoleIsAtLeast?: InputMaybe<GroupRole>;
  ifRoleIsAtMost?: InputMaybe<GroupRole>;
};

export type GroupsHavingMinGroupsCountOfMembersInput = {
  args?: InputMaybe<GroupsHavingMinGroupsCountOfMembersArgsInput>;
  filter?: InputMaybe<HavingBigintFilter>;
};

export type GroupsHavingMinInput = {
  countOfMembers?: InputMaybe<GroupsHavingMinGroupsCountOfMembersInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type GroupsHavingStddevPopulationGroupsCountOfMembersArgsInput = {
  ifRoleIsAtLeast?: InputMaybe<GroupRole>;
  ifRoleIsAtMost?: InputMaybe<GroupRole>;
};

export type GroupsHavingStddevPopulationGroupsCountOfMembersInput = {
  args?: InputMaybe<GroupsHavingStddevPopulationGroupsCountOfMembersArgsInput>;
  filter?: InputMaybe<HavingBigintFilter>;
};

export type GroupsHavingStddevPopulationInput = {
  countOfMembers?: InputMaybe<GroupsHavingStddevPopulationGroupsCountOfMembersInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type GroupsHavingStddevSampleGroupsCountOfMembersArgsInput = {
  ifRoleIsAtLeast?: InputMaybe<GroupRole>;
  ifRoleIsAtMost?: InputMaybe<GroupRole>;
};

export type GroupsHavingStddevSampleGroupsCountOfMembersInput = {
  args?: InputMaybe<GroupsHavingStddevSampleGroupsCountOfMembersArgsInput>;
  filter?: InputMaybe<HavingBigintFilter>;
};

export type GroupsHavingStddevSampleInput = {
  countOfMembers?: InputMaybe<GroupsHavingStddevSampleGroupsCountOfMembersInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type GroupsHavingSumGroupsCountOfMembersArgsInput = {
  ifRoleIsAtLeast?: InputMaybe<GroupRole>;
  ifRoleIsAtMost?: InputMaybe<GroupRole>;
};

export type GroupsHavingSumGroupsCountOfMembersInput = {
  args?: InputMaybe<GroupsHavingSumGroupsCountOfMembersArgsInput>;
  filter?: InputMaybe<HavingBigintFilter>;
};

export type GroupsHavingSumInput = {
  countOfMembers?: InputMaybe<GroupsHavingSumGroupsCountOfMembersInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type GroupsHavingVariancePopulationGroupsCountOfMembersArgsInput = {
  ifRoleIsAtLeast?: InputMaybe<GroupRole>;
  ifRoleIsAtMost?: InputMaybe<GroupRole>;
};

export type GroupsHavingVariancePopulationGroupsCountOfMembersInput = {
  args?: InputMaybe<GroupsHavingVariancePopulationGroupsCountOfMembersArgsInput>;
  filter?: InputMaybe<HavingBigintFilter>;
};

export type GroupsHavingVariancePopulationInput = {
  countOfMembers?: InputMaybe<GroupsHavingVariancePopulationGroupsCountOfMembersInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type GroupsHavingVarianceSampleGroupsCountOfMembersArgsInput = {
  ifRoleIsAtLeast?: InputMaybe<GroupRole>;
  ifRoleIsAtMost?: InputMaybe<GroupRole>;
};

export type GroupsHavingVarianceSampleGroupsCountOfMembersInput = {
  args?: InputMaybe<GroupsHavingVarianceSampleGroupsCountOfMembersArgsInput>;
  filter?: InputMaybe<HavingBigintFilter>;
};

export type GroupsHavingVarianceSampleInput = {
  countOfMembers?: InputMaybe<GroupsHavingVarianceSampleGroupsCountOfMembersInput>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `Group`. */
export type GroupsOrderBy =
  | 'CAN_JOIN_ASC'
  | 'CAN_JOIN_DESC'
  | 'CAN_MANAGE_ASC'
  | 'CAN_MANAGE_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'CREATOR_ID_ASC'
  | 'CREATOR_ID_DESC'
  | 'EXTERNAL_NAMES_ASC'
  | 'EXTERNAL_NAMES_DESC'
  | 'FLAGS_ASC'
  | 'FLAGS_DESC'
  | 'HOME_ID_ASC'
  | 'HOME_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'MEMBERSHIPS_AVERAGE_CREATED_AT_ASC'
  | 'MEMBERSHIPS_AVERAGE_CREATED_AT_DESC'
  | 'MEMBERSHIPS_AVERAGE_FLAGS_ASC'
  | 'MEMBERSHIPS_AVERAGE_FLAGS_DESC'
  | 'MEMBERSHIPS_AVERAGE_GROUP_ID_ASC'
  | 'MEMBERSHIPS_AVERAGE_GROUP_ID_DESC'
  | 'MEMBERSHIPS_AVERAGE_ID_ASC'
  | 'MEMBERSHIPS_AVERAGE_ID_DESC'
  | 'MEMBERSHIPS_AVERAGE_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_AVERAGE_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_AVERAGE_ROLE_ASC'
  | 'MEMBERSHIPS_AVERAGE_ROLE_DESC'
  | 'MEMBERSHIPS_AVERAGE_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_AVERAGE_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_AVERAGE_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_AVERAGE_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_AVERAGE_USER_ID_ASC'
  | 'MEMBERSHIPS_AVERAGE_USER_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_AVERAGE_CREATED_AT_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_AVERAGE_CREATED_AT_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_AVERAGE_FLAGS_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_AVERAGE_FLAGS_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_AVERAGE_GROUP_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_AVERAGE_GROUP_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_AVERAGE_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_AVERAGE_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_AVERAGE_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_AVERAGE_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_AVERAGE_ROLE_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_AVERAGE_ROLE_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_AVERAGE_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_AVERAGE_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_AVERAGE_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_AVERAGE_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_AVERAGE_USER_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_AVERAGE_USER_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_COUNT_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_COUNT_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_DISTINCT_COUNT_FLAGS_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_DISTINCT_COUNT_FLAGS_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_DISTINCT_COUNT_GROUP_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_DISTINCT_COUNT_GROUP_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_DISTINCT_COUNT_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_DISTINCT_COUNT_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_DISTINCT_COUNT_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_DISTINCT_COUNT_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_DISTINCT_COUNT_ROLE_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_DISTINCT_COUNT_ROLE_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_DISTINCT_COUNT_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_DISTINCT_COUNT_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_DISTINCT_COUNT_USER_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_DISTINCT_COUNT_USER_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MAX_CREATED_AT_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MAX_CREATED_AT_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MAX_FLAGS_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MAX_FLAGS_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MAX_GROUP_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MAX_GROUP_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MAX_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MAX_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MAX_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MAX_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MAX_ROLE_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MAX_ROLE_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MAX_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MAX_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MAX_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MAX_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MAX_USER_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MAX_USER_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MIN_CREATED_AT_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MIN_CREATED_AT_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MIN_FLAGS_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MIN_FLAGS_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MIN_GROUP_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MIN_GROUP_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MIN_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MIN_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MIN_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MIN_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MIN_ROLE_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MIN_ROLE_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MIN_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MIN_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MIN_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MIN_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MIN_USER_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_MIN_USER_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_POPULATION_FLAGS_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_POPULATION_FLAGS_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_POPULATION_GROUP_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_POPULATION_GROUP_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_POPULATION_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_POPULATION_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_POPULATION_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_POPULATION_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_POPULATION_ROLE_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_POPULATION_ROLE_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_POPULATION_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_POPULATION_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_POPULATION_USER_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_POPULATION_USER_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_SAMPLE_FLAGS_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_SAMPLE_FLAGS_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_SAMPLE_GROUP_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_SAMPLE_GROUP_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_SAMPLE_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_SAMPLE_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_SAMPLE_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_SAMPLE_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_SAMPLE_ROLE_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_SAMPLE_ROLE_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_SAMPLE_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_SAMPLE_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_SAMPLE_USER_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_STDDEV_SAMPLE_USER_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_SUM_CREATED_AT_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_SUM_CREATED_AT_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_SUM_FLAGS_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_SUM_FLAGS_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_SUM_GROUP_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_SUM_GROUP_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_SUM_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_SUM_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_SUM_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_SUM_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_SUM_ROLE_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_SUM_ROLE_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_SUM_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_SUM_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_SUM_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_SUM_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_SUM_USER_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_SUM_USER_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_POPULATION_FLAGS_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_POPULATION_FLAGS_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_POPULATION_GROUP_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_POPULATION_GROUP_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_POPULATION_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_POPULATION_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_POPULATION_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_POPULATION_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_POPULATION_ROLE_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_POPULATION_ROLE_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_POPULATION_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_POPULATION_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_POPULATION_USER_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_POPULATION_USER_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_SAMPLE_FLAGS_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_SAMPLE_FLAGS_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_SAMPLE_GROUP_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_SAMPLE_GROUP_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_SAMPLE_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_SAMPLE_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_SAMPLE_ROLE_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_SAMPLE_ROLE_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_SAMPLE_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_SAMPLE_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_SAMPLE_USER_ID_ASC'
  | 'MEMBERSHIPS_BY_SUBGROUP_ID_VARIANCE_SAMPLE_USER_ID_DESC'
  | 'MEMBERSHIPS_COUNT_ASC'
  | 'MEMBERSHIPS_COUNT_DESC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_FLAGS_ASC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_FLAGS_DESC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_GROUP_ID_ASC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_GROUP_ID_DESC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_ID_ASC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_ID_DESC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_ROLE_ASC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_ROLE_DESC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_USER_ID_ASC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_USER_ID_DESC'
  | 'MEMBERSHIPS_MAX_CREATED_AT_ASC'
  | 'MEMBERSHIPS_MAX_CREATED_AT_DESC'
  | 'MEMBERSHIPS_MAX_FLAGS_ASC'
  | 'MEMBERSHIPS_MAX_FLAGS_DESC'
  | 'MEMBERSHIPS_MAX_GROUP_ID_ASC'
  | 'MEMBERSHIPS_MAX_GROUP_ID_DESC'
  | 'MEMBERSHIPS_MAX_ID_ASC'
  | 'MEMBERSHIPS_MAX_ID_DESC'
  | 'MEMBERSHIPS_MAX_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_MAX_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_MAX_ROLE_ASC'
  | 'MEMBERSHIPS_MAX_ROLE_DESC'
  | 'MEMBERSHIPS_MAX_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_MAX_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_MAX_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_MAX_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_MAX_USER_ID_ASC'
  | 'MEMBERSHIPS_MAX_USER_ID_DESC'
  | 'MEMBERSHIPS_MIN_CREATED_AT_ASC'
  | 'MEMBERSHIPS_MIN_CREATED_AT_DESC'
  | 'MEMBERSHIPS_MIN_FLAGS_ASC'
  | 'MEMBERSHIPS_MIN_FLAGS_DESC'
  | 'MEMBERSHIPS_MIN_GROUP_ID_ASC'
  | 'MEMBERSHIPS_MIN_GROUP_ID_DESC'
  | 'MEMBERSHIPS_MIN_ID_ASC'
  | 'MEMBERSHIPS_MIN_ID_DESC'
  | 'MEMBERSHIPS_MIN_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_MIN_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_MIN_ROLE_ASC'
  | 'MEMBERSHIPS_MIN_ROLE_DESC'
  | 'MEMBERSHIPS_MIN_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_MIN_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_MIN_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_MIN_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_MIN_USER_ID_ASC'
  | 'MEMBERSHIPS_MIN_USER_ID_DESC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_FLAGS_ASC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_FLAGS_DESC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_GROUP_ID_ASC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_GROUP_ID_DESC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_ID_ASC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_ID_DESC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_ROLE_ASC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_ROLE_DESC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_USER_ID_ASC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_USER_ID_DESC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_FLAGS_ASC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_FLAGS_DESC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_GROUP_ID_ASC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_GROUP_ID_DESC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_ID_ASC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_ID_DESC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_ROLE_ASC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_ROLE_DESC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_USER_ID_ASC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_USER_ID_DESC'
  | 'MEMBERSHIPS_SUM_CREATED_AT_ASC'
  | 'MEMBERSHIPS_SUM_CREATED_AT_DESC'
  | 'MEMBERSHIPS_SUM_FLAGS_ASC'
  | 'MEMBERSHIPS_SUM_FLAGS_DESC'
  | 'MEMBERSHIPS_SUM_GROUP_ID_ASC'
  | 'MEMBERSHIPS_SUM_GROUP_ID_DESC'
  | 'MEMBERSHIPS_SUM_ID_ASC'
  | 'MEMBERSHIPS_SUM_ID_DESC'
  | 'MEMBERSHIPS_SUM_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_SUM_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_SUM_ROLE_ASC'
  | 'MEMBERSHIPS_SUM_ROLE_DESC'
  | 'MEMBERSHIPS_SUM_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_SUM_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_SUM_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_SUM_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_SUM_USER_ID_ASC'
  | 'MEMBERSHIPS_SUM_USER_ID_DESC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_FLAGS_ASC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_FLAGS_DESC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_GROUP_ID_ASC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_GROUP_ID_DESC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_ID_ASC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_ID_DESC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_ROLE_ASC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_ROLE_DESC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_USER_ID_ASC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_USER_ID_DESC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_FLAGS_ASC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_FLAGS_DESC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_GROUP_ID_ASC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_GROUP_ID_DESC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_ID_ASC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_ID_DESC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_ROLE_ASC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_ROLE_DESC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_USER_ID_ASC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_AVERAGE_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_AVERAGE_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_COUNT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_COUNT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_DISTINCT_COUNT_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MAX_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_MIN_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_POPULATION_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_STDDEV_SAMPLE_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_SUM_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_POPULATION_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_GROUP_ID_VARIANCE_SAMPLE_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_COUNT_ASC'
  | 'MEMBERSHIP_INVITATIONS_COUNT_DESC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_DISTINCT_COUNT_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_MAX_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_MAX_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_MAX_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_MAX_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_MAX_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_MAX_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_MAX_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_MAX_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_MAX_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_MAX_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_MAX_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_MAX_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_MAX_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_MAX_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_MAX_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_MAX_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_MAX_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_MAX_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_MAX_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_MAX_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_MAX_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_MAX_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_MAX_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_MAX_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_MAX_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_MAX_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_MIN_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_MIN_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_MIN_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_MIN_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_MIN_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_MIN_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_MIN_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_MIN_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_MIN_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_MIN_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_MIN_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_MIN_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_MIN_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_MIN_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_MIN_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_MIN_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_MIN_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_MIN_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_MIN_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_MIN_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_MIN_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_MIN_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_MIN_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_MIN_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_MIN_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_MIN_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_POPULATION_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_STDDEV_SAMPLE_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_SUM_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_SUM_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_SUM_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_SUM_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_SUM_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_SUM_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_SUM_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_SUM_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_SUM_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_SUM_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_SUM_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_SUM_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_SUM_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_SUM_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_SUM_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_SUM_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_SUM_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_SUM_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_SUM_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_SUM_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_SUM_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_SUM_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_SUM_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_SUM_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_SUM_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_SUM_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_POPULATION_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_VARIANCE_SAMPLE_VALID_UNTIL_DESC'
  | 'MY_EFFECTIVE_ROLE_ASC'
  | 'MY_EFFECTIVE_ROLE_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'PRIVATE_CONVERSATIONS_AVERAGE_ABOUT_COMMENTABLE_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_AVERAGE_ABOUT_COMMENTABLE_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_AVERAGE_ABSTRACT_ASC'
  | 'PRIVATE_CONVERSATIONS_AVERAGE_ABSTRACT_DESC'
  | 'PRIVATE_CONVERSATIONS_AVERAGE_CREATED_AT_ASC'
  | 'PRIVATE_CONVERSATIONS_AVERAGE_CREATED_AT_DESC'
  | 'PRIVATE_CONVERSATIONS_AVERAGE_CREATOR_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_AVERAGE_CREATOR_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_AVERAGE_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_AVERAGE_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_AVERAGE_IS_PUBLIC_ASC'
  | 'PRIVATE_CONVERSATIONS_AVERAGE_IS_PUBLIC_DESC'
  | 'PRIVATE_CONVERSATIONS_AVERAGE_LANGUAGE_ASC'
  | 'PRIVATE_CONVERSATIONS_AVERAGE_LANGUAGE_DESC'
  | 'PRIVATE_CONVERSATIONS_AVERAGE_PRIVATE_TO_GROUP_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_AVERAGE_PRIVATE_TO_GROUP_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_AVERAGE_TENANT_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_AVERAGE_TENANT_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_AVERAGE_TITLE_ASC'
  | 'PRIVATE_CONVERSATIONS_AVERAGE_TITLE_DESC'
  | 'PRIVATE_CONVERSATIONS_AVERAGE_UPDATED_AT_ASC'
  | 'PRIVATE_CONVERSATIONS_AVERAGE_UPDATED_AT_DESC'
  | 'PRIVATE_CONVERSATIONS_COUNT_ASC'
  | 'PRIVATE_CONVERSATIONS_COUNT_DESC'
  | 'PRIVATE_CONVERSATIONS_DISTINCT_COUNT_ABOUT_COMMENTABLE_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_DISTINCT_COUNT_ABOUT_COMMENTABLE_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_DISTINCT_COUNT_ABSTRACT_ASC'
  | 'PRIVATE_CONVERSATIONS_DISTINCT_COUNT_ABSTRACT_DESC'
  | 'PRIVATE_CONVERSATIONS_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'PRIVATE_CONVERSATIONS_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'PRIVATE_CONVERSATIONS_DISTINCT_COUNT_CREATOR_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_DISTINCT_COUNT_CREATOR_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_DISTINCT_COUNT_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_DISTINCT_COUNT_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_DISTINCT_COUNT_IS_PUBLIC_ASC'
  | 'PRIVATE_CONVERSATIONS_DISTINCT_COUNT_IS_PUBLIC_DESC'
  | 'PRIVATE_CONVERSATIONS_DISTINCT_COUNT_LANGUAGE_ASC'
  | 'PRIVATE_CONVERSATIONS_DISTINCT_COUNT_LANGUAGE_DESC'
  | 'PRIVATE_CONVERSATIONS_DISTINCT_COUNT_PRIVATE_TO_GROUP_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_DISTINCT_COUNT_PRIVATE_TO_GROUP_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_DISTINCT_COUNT_TENANT_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_DISTINCT_COUNT_TENANT_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_DISTINCT_COUNT_TITLE_ASC'
  | 'PRIVATE_CONVERSATIONS_DISTINCT_COUNT_TITLE_DESC'
  | 'PRIVATE_CONVERSATIONS_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'PRIVATE_CONVERSATIONS_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'PRIVATE_CONVERSATIONS_MAX_ABOUT_COMMENTABLE_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_MAX_ABOUT_COMMENTABLE_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_MAX_ABSTRACT_ASC'
  | 'PRIVATE_CONVERSATIONS_MAX_ABSTRACT_DESC'
  | 'PRIVATE_CONVERSATIONS_MAX_CREATED_AT_ASC'
  | 'PRIVATE_CONVERSATIONS_MAX_CREATED_AT_DESC'
  | 'PRIVATE_CONVERSATIONS_MAX_CREATOR_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_MAX_CREATOR_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_MAX_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_MAX_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_MAX_IS_PUBLIC_ASC'
  | 'PRIVATE_CONVERSATIONS_MAX_IS_PUBLIC_DESC'
  | 'PRIVATE_CONVERSATIONS_MAX_LANGUAGE_ASC'
  | 'PRIVATE_CONVERSATIONS_MAX_LANGUAGE_DESC'
  | 'PRIVATE_CONVERSATIONS_MAX_PRIVATE_TO_GROUP_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_MAX_PRIVATE_TO_GROUP_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_MAX_TENANT_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_MAX_TENANT_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_MAX_TITLE_ASC'
  | 'PRIVATE_CONVERSATIONS_MAX_TITLE_DESC'
  | 'PRIVATE_CONVERSATIONS_MAX_UPDATED_AT_ASC'
  | 'PRIVATE_CONVERSATIONS_MAX_UPDATED_AT_DESC'
  | 'PRIVATE_CONVERSATIONS_MIN_ABOUT_COMMENTABLE_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_MIN_ABOUT_COMMENTABLE_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_MIN_ABSTRACT_ASC'
  | 'PRIVATE_CONVERSATIONS_MIN_ABSTRACT_DESC'
  | 'PRIVATE_CONVERSATIONS_MIN_CREATED_AT_ASC'
  | 'PRIVATE_CONVERSATIONS_MIN_CREATED_AT_DESC'
  | 'PRIVATE_CONVERSATIONS_MIN_CREATOR_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_MIN_CREATOR_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_MIN_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_MIN_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_MIN_IS_PUBLIC_ASC'
  | 'PRIVATE_CONVERSATIONS_MIN_IS_PUBLIC_DESC'
  | 'PRIVATE_CONVERSATIONS_MIN_LANGUAGE_ASC'
  | 'PRIVATE_CONVERSATIONS_MIN_LANGUAGE_DESC'
  | 'PRIVATE_CONVERSATIONS_MIN_PRIVATE_TO_GROUP_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_MIN_PRIVATE_TO_GROUP_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_MIN_TENANT_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_MIN_TENANT_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_MIN_TITLE_ASC'
  | 'PRIVATE_CONVERSATIONS_MIN_TITLE_DESC'
  | 'PRIVATE_CONVERSATIONS_MIN_UPDATED_AT_ASC'
  | 'PRIVATE_CONVERSATIONS_MIN_UPDATED_AT_DESC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_POPULATION_ABOUT_COMMENTABLE_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_POPULATION_ABOUT_COMMENTABLE_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_POPULATION_ABSTRACT_ASC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_POPULATION_ABSTRACT_DESC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_POPULATION_CREATOR_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_POPULATION_CREATOR_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_POPULATION_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_POPULATION_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_POPULATION_IS_PUBLIC_ASC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_POPULATION_IS_PUBLIC_DESC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_POPULATION_LANGUAGE_ASC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_POPULATION_LANGUAGE_DESC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_POPULATION_PRIVATE_TO_GROUP_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_POPULATION_PRIVATE_TO_GROUP_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_POPULATION_TENANT_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_POPULATION_TENANT_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_POPULATION_TITLE_ASC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_POPULATION_TITLE_DESC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_SAMPLE_ABOUT_COMMENTABLE_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_SAMPLE_ABOUT_COMMENTABLE_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_SAMPLE_ABSTRACT_ASC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_SAMPLE_ABSTRACT_DESC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_SAMPLE_CREATOR_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_SAMPLE_CREATOR_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_SAMPLE_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_SAMPLE_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_SAMPLE_IS_PUBLIC_ASC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_SAMPLE_IS_PUBLIC_DESC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_SAMPLE_LANGUAGE_ASC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_SAMPLE_LANGUAGE_DESC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_SAMPLE_PRIVATE_TO_GROUP_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_SAMPLE_PRIVATE_TO_GROUP_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_SAMPLE_TENANT_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_SAMPLE_TENANT_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_SAMPLE_TITLE_ASC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_SAMPLE_TITLE_DESC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'PRIVATE_CONVERSATIONS_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'PRIVATE_CONVERSATIONS_SUM_ABOUT_COMMENTABLE_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_SUM_ABOUT_COMMENTABLE_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_SUM_ABSTRACT_ASC'
  | 'PRIVATE_CONVERSATIONS_SUM_ABSTRACT_DESC'
  | 'PRIVATE_CONVERSATIONS_SUM_CREATED_AT_ASC'
  | 'PRIVATE_CONVERSATIONS_SUM_CREATED_AT_DESC'
  | 'PRIVATE_CONVERSATIONS_SUM_CREATOR_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_SUM_CREATOR_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_SUM_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_SUM_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_SUM_IS_PUBLIC_ASC'
  | 'PRIVATE_CONVERSATIONS_SUM_IS_PUBLIC_DESC'
  | 'PRIVATE_CONVERSATIONS_SUM_LANGUAGE_ASC'
  | 'PRIVATE_CONVERSATIONS_SUM_LANGUAGE_DESC'
  | 'PRIVATE_CONVERSATIONS_SUM_PRIVATE_TO_GROUP_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_SUM_PRIVATE_TO_GROUP_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_SUM_TENANT_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_SUM_TENANT_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_SUM_TITLE_ASC'
  | 'PRIVATE_CONVERSATIONS_SUM_TITLE_DESC'
  | 'PRIVATE_CONVERSATIONS_SUM_UPDATED_AT_ASC'
  | 'PRIVATE_CONVERSATIONS_SUM_UPDATED_AT_DESC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_POPULATION_ABOUT_COMMENTABLE_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_POPULATION_ABOUT_COMMENTABLE_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_POPULATION_ABSTRACT_ASC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_POPULATION_ABSTRACT_DESC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_POPULATION_CREATOR_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_POPULATION_CREATOR_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_POPULATION_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_POPULATION_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_POPULATION_IS_PUBLIC_ASC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_POPULATION_IS_PUBLIC_DESC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_POPULATION_LANGUAGE_ASC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_POPULATION_LANGUAGE_DESC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_POPULATION_PRIVATE_TO_GROUP_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_POPULATION_PRIVATE_TO_GROUP_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_POPULATION_TENANT_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_POPULATION_TENANT_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_POPULATION_TITLE_ASC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_POPULATION_TITLE_DESC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_SAMPLE_ABOUT_COMMENTABLE_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_SAMPLE_ABOUT_COMMENTABLE_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_SAMPLE_ABSTRACT_ASC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_SAMPLE_ABSTRACT_DESC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_SAMPLE_CREATOR_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_SAMPLE_CREATOR_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_SAMPLE_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_SAMPLE_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_SAMPLE_IS_PUBLIC_ASC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_SAMPLE_IS_PUBLIC_DESC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_SAMPLE_LANGUAGE_ASC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_SAMPLE_LANGUAGE_DESC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_SAMPLE_PRIVATE_TO_GROUP_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_SAMPLE_PRIVATE_TO_GROUP_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_SAMPLE_TENANT_ID_ASC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_SAMPLE_TENANT_ID_DESC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_SAMPLE_TITLE_ASC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_SAMPLE_TITLE_DESC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'PRIVATE_CONVERSATIONS_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'TENANT_ID_ASC'
  | 'TENANT_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_AVATAR_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_AVATAR_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_CREATED_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_CREATED_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_MESSAGES_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_MESSAGES_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_NAME_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_NAME_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_STAFF_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_STAFF_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_SUBJECT_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_SUBJECT_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_TENANT_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_TENANT_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_UPDATED_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_AVERAGE_UPDATED_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_COUNT_ASC'
  | 'TRIALS_BY_STAFF_ID_COUNT_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_AVATAR_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_AVATAR_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_MESSAGES_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_MESSAGES_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_NAME_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_NAME_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_STAFF_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_STAFF_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_SUBJECT_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_SUBJECT_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_TENANT_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_TENANT_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_AVATAR_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_AVATAR_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_CREATED_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_CREATED_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_MESSAGES_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_MESSAGES_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_NAME_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_NAME_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_STAFF_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_STAFF_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_SUBJECT_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_SUBJECT_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_TENANT_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_TENANT_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_MAX_UPDATED_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_MAX_UPDATED_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_AVATAR_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_AVATAR_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_CREATED_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_CREATED_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_MESSAGES_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_MESSAGES_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_NAME_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_NAME_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_STAFF_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_STAFF_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_SUBJECT_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_SUBJECT_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_TENANT_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_TENANT_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_MIN_UPDATED_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_MIN_UPDATED_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_AVATAR_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_AVATAR_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_MESSAGES_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_MESSAGES_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_NAME_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_NAME_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_STAFF_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_STAFF_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_SUBJECT_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_SUBJECT_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_TENANT_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_TENANT_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_AVATAR_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_AVATAR_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_MESSAGES_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_MESSAGES_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_NAME_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_NAME_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_STAFF_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_STAFF_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_SUBJECT_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_SUBJECT_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_TENANT_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_TENANT_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_AVATAR_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_AVATAR_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_CREATED_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_CREATED_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_MESSAGES_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_MESSAGES_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_NAME_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_NAME_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_STAFF_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_STAFF_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_SUBJECT_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_SUBJECT_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_TENANT_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_TENANT_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_SUM_UPDATED_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_SUM_UPDATED_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_AVATAR_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_AVATAR_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_MESSAGES_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_MESSAGES_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_NAME_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_NAME_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_STAFF_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_STAFF_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_SUBJECT_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_SUBJECT_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_TENANT_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_TENANT_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_AVATAR_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_AVATAR_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_MESSAGES_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_MESSAGES_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_NAME_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_NAME_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_STAFF_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_STAFF_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_SUBJECT_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_SUBJECT_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_TENANT_ID_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_TENANT_ID_DESC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'TRIALS_BY_STAFF_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

export type HavingBigintFilter = {
  equalTo?: InputMaybe<Scalars['BigInt']>;
  greaterThan?: InputMaybe<Scalars['BigInt']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['BigInt']>;
  lessThan?: InputMaybe<Scalars['BigInt']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['BigInt']>;
  notEqualTo?: InputMaybe<Scalars['BigInt']>;
};

export type HavingDatetimeFilter = {
  equalTo?: InputMaybe<Scalars['Datetime']>;
  greaterThan?: InputMaybe<Scalars['Datetime']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  lessThan?: InputMaybe<Scalars['Datetime']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']>;
  notEqualTo?: InputMaybe<Scalars['Datetime']>;
};

export type HavingIntFilter = {
  equalTo?: InputMaybe<Scalars['Int']>;
  greaterThan?: InputMaybe<Scalars['Int']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  lessThan?: InputMaybe<Scalars['Int']>;
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  notEqualTo?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

/** A filter to be used against InternetAddress List fields. All fields are combined with a logical ‘and.’ */
export type InternetAddressListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['InternetAddress']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['InternetAddress']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['InternetAddress']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['InternetAddress']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['InternetAddress']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['InternetAddress']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['InternetAddress']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['InternetAddress']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['InternetAddress']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['InternetAddress']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['InternetAddress']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['InternetAddress']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['InternetAddress']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['InternetAddress']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['InternetAddress']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['InternetAddress']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['InternetAddress']>>>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type Interval = {
  __typename?: 'Interval';
  /** A quantity of days. */
  days?: Maybe<Scalars['Int']>;
  /** A quantity of hours. */
  hours?: Maybe<Scalars['Int']>;
  /** A quantity of minutes. */
  minutes?: Maybe<Scalars['Int']>;
  /** A quantity of months. */
  months?: Maybe<Scalars['Int']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: Maybe<Scalars['Float']>;
  /** A quantity of years. */
  years?: Maybe<Scalars['Int']>;
};

/** A filter to be used against Interval fields. All fields are combined with a logical ‘and.’ */
export type IntervalFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<IntervalInput>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<IntervalInput>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<IntervalInput>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<IntervalInput>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<IntervalInput>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<IntervalInput>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<IntervalInput>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<IntervalInput>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<IntervalInput>>;
};

/** An interval of time that has passed where the smallest distinct unit is a second. */
export type IntervalInput = {
  /** A quantity of days. */
  days?: InputMaybe<Scalars['Int']>;
  /** A quantity of hours. */
  hours?: InputMaybe<Scalars['Int']>;
  /** A quantity of minutes. */
  minutes?: InputMaybe<Scalars['Int']>;
  /** A quantity of months. */
  months?: InputMaybe<Scalars['Int']>;
  /**
   * A quantity of seconds. This is the only non-integer field, as all the other
   * fields will dump their overflow into a smaller unit of time. Intervals don’t
   * have a smaller unit than seconds.
   */
  seconds?: InputMaybe<Scalars['Float']>;
  /** A quantity of years. */
  years?: InputMaybe<Scalars['Int']>;
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']>>;
};

export type LimesurveyToken = Node & {
  __typename?: 'LimesurveyToken';
  completedAt?: Maybe<Scalars['Datetime']>;
  handedOutAt?: Maybe<Scalars['Datetime']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  startedAt?: Maybe<Scalars['Datetime']>;
  surveyId: Scalars['Int'];
  timeOfMeasurement?: Maybe<Scalars['String']>;
  token: Scalars['String'];
  /** Reads a single `Trial` that is related to this `LimesurveyToken`. */
  trial?: Maybe<Trial>;
  trialId?: Maybe<Scalars['UUID']>;
};

export type LimesurveyTokenAggregates = {
  __typename?: 'LimesurveyTokenAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<LimesurveyTokenAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<LimesurveyTokenDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<LimesurveyTokenMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<LimesurveyTokenMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<LimesurveyTokenStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<LimesurveyTokenStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<LimesurveyTokenSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<LimesurveyTokenVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<LimesurveyTokenVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `LimesurveyToken` object types. */
export type LimesurveyTokenAggregatesFilter = {
  /** Mean average aggregate over matching `LimesurveyToken` objects. */
  average?: InputMaybe<LimesurveyTokenAverageAggregateFilter>;
  /** Distinct count aggregate over matching `LimesurveyToken` objects. */
  distinctCount?: InputMaybe<LimesurveyTokenDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `LimesurveyToken` object to be included within the aggregate. */
  filter?: InputMaybe<LimesurveyTokenFilter>;
  /** Maximum aggregate over matching `LimesurveyToken` objects. */
  max?: InputMaybe<LimesurveyTokenMaxAggregateFilter>;
  /** Minimum aggregate over matching `LimesurveyToken` objects. */
  min?: InputMaybe<LimesurveyTokenMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `LimesurveyToken` objects. */
  stddevPopulation?: InputMaybe<LimesurveyTokenStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `LimesurveyToken` objects. */
  stddevSample?: InputMaybe<LimesurveyTokenStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `LimesurveyToken` objects. */
  sum?: InputMaybe<LimesurveyTokenSumAggregateFilter>;
  /** Population variance aggregate over matching `LimesurveyToken` objects. */
  variancePopulation?: InputMaybe<LimesurveyTokenVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `LimesurveyToken` objects. */
  varianceSample?: InputMaybe<LimesurveyTokenVarianceSampleAggregateFilter>;
};

export type LimesurveyTokenAverageAggregateFilter = {
  surveyId?: InputMaybe<BigFloatFilter>;
};

export type LimesurveyTokenAverageAggregates = {
  __typename?: 'LimesurveyTokenAverageAggregates';
  /** Mean average of surveyId across the matching connection */
  surveyId?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `LimesurveyToken` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type LimesurveyTokenCondition = {
  /** Checks for equality with the object’s `completedAt` field. */
  completedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `handedOutAt` field. */
  handedOutAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `startedAt` field. */
  startedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `surveyId` field. */
  surveyId?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `token` field. */
  token?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `trialId` field. */
  trialId?: InputMaybe<Scalars['UUID']>;
};

export type LimesurveyTokenDistinctCountAggregateFilter = {
  completedAt?: InputMaybe<BigIntFilter>;
  handedOutAt?: InputMaybe<BigIntFilter>;
  startedAt?: InputMaybe<BigIntFilter>;
  surveyId?: InputMaybe<BigIntFilter>;
  timeOfMeasurement?: InputMaybe<BigIntFilter>;
  token?: InputMaybe<BigIntFilter>;
  trialId?: InputMaybe<BigIntFilter>;
};

export type LimesurveyTokenDistinctCountAggregates = {
  __typename?: 'LimesurveyTokenDistinctCountAggregates';
  /** Distinct count of completedAt across the matching connection */
  completedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of handedOutAt across the matching connection */
  handedOutAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of startedAt across the matching connection */
  startedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of surveyId across the matching connection */
  surveyId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of timeOfMeasurement across the matching connection */
  timeOfMeasurement?: Maybe<Scalars['BigInt']>;
  /** Distinct count of token across the matching connection */
  token?: Maybe<Scalars['BigInt']>;
  /** Distinct count of trialId across the matching connection */
  trialId?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `LimesurveyToken` object types. All fields are combined with a logical ‘and.’ */
export type LimesurveyTokenFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<LimesurveyTokenFilter>>;
  /** Filter by the object’s `completedAt` field. */
  completedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `handedOutAt` field. */
  handedOutAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<LimesurveyTokenFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<LimesurveyTokenFilter>>;
  /** Filter by the object’s `startedAt` field. */
  startedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `surveyId` field. */
  surveyId?: InputMaybe<IntFilter>;
  /** Filter by the object’s `timeOfMeasurement` field. */
  timeOfMeasurement?: InputMaybe<StringFilter>;
  /** Filter by the object’s `token` field. */
  token?: InputMaybe<StringFilter>;
  /** Filter by the object’s `trial` relation. */
  trial?: InputMaybe<TrialFilter>;
  /** A related `trial` exists. */
  trialExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `trialId` field. */
  trialId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `LimesurveyToken` */
export type LimesurveyTokenInput = {
  completedAt?: InputMaybe<Scalars['Datetime']>;
  handedOutAt?: InputMaybe<Scalars['Datetime']>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  surveyId: Scalars['Int'];
  timeOfMeasurement?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
  trialId?: InputMaybe<Scalars['UUID']>;
};

export type LimesurveyTokenMaxAggregateFilter = {
  surveyId?: InputMaybe<IntFilter>;
};

export type LimesurveyTokenMaxAggregates = {
  __typename?: 'LimesurveyTokenMaxAggregates';
  /** Maximum of surveyId across the matching connection */
  surveyId?: Maybe<Scalars['Int']>;
};

export type LimesurveyTokenMinAggregateFilter = {
  surveyId?: InputMaybe<IntFilter>;
};

export type LimesurveyTokenMinAggregates = {
  __typename?: 'LimesurveyTokenMinAggregates';
  /** Minimum of surveyId across the matching connection */
  surveyId?: Maybe<Scalars['Int']>;
};

/** Represents an update to a `LimesurveyToken`. Fields that are set will be updated. */
export type LimesurveyTokenPatch = {
  completedAt?: InputMaybe<Scalars['Datetime']>;
  handedOutAt?: InputMaybe<Scalars['Datetime']>;
  startedAt?: InputMaybe<Scalars['Datetime']>;
  surveyId?: InputMaybe<Scalars['Int']>;
  timeOfMeasurement?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  trialId?: InputMaybe<Scalars['UUID']>;
};

export type LimesurveyTokenStddevPopulationAggregateFilter = {
  surveyId?: InputMaybe<BigFloatFilter>;
};

export type LimesurveyTokenStddevPopulationAggregates = {
  __typename?: 'LimesurveyTokenStddevPopulationAggregates';
  /** Population standard deviation of surveyId across the matching connection */
  surveyId?: Maybe<Scalars['BigFloat']>;
};

export type LimesurveyTokenStddevSampleAggregateFilter = {
  surveyId?: InputMaybe<BigFloatFilter>;
};

export type LimesurveyTokenStddevSampleAggregates = {
  __typename?: 'LimesurveyTokenStddevSampleAggregates';
  /** Sample standard deviation of surveyId across the matching connection */
  surveyId?: Maybe<Scalars['BigFloat']>;
};

export type LimesurveyTokenSumAggregateFilter = {
  surveyId?: InputMaybe<BigIntFilter>;
};

export type LimesurveyTokenSumAggregates = {
  __typename?: 'LimesurveyTokenSumAggregates';
  /** Sum of surveyId across the matching connection */
  surveyId: Scalars['BigInt'];
};

export type LimesurveyTokenVariancePopulationAggregateFilter = {
  surveyId?: InputMaybe<BigFloatFilter>;
};

export type LimesurveyTokenVariancePopulationAggregates = {
  __typename?: 'LimesurveyTokenVariancePopulationAggregates';
  /** Population variance of surveyId across the matching connection */
  surveyId?: Maybe<Scalars['BigFloat']>;
};

export type LimesurveyTokenVarianceSampleAggregateFilter = {
  surveyId?: InputMaybe<BigFloatFilter>;
};

export type LimesurveyTokenVarianceSampleAggregates = {
  __typename?: 'LimesurveyTokenVarianceSampleAggregates';
  /** Sample variance of surveyId across the matching connection */
  surveyId?: Maybe<Scalars['BigFloat']>;
};

/** A connection to a list of `LimesurveyToken` values. */
export type LimesurveyTokensConnection = {
  __typename?: 'LimesurveyTokensConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<LimesurveyTokenAggregates>;
  /** A list of edges which contains the `LimesurveyToken` and cursor to aid in pagination. */
  edges: Array<LimesurveyTokensEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<LimesurveyTokenAggregates>>;
  /** A list of `LimesurveyToken` objects. */
  nodes: Array<LimesurveyToken>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `LimesurveyToken` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `LimesurveyToken` values. */
export type LimesurveyTokensConnectionGroupedAggregatesArgs = {
  groupBy: Array<LimesurveyTokensGroupBy>;
  having?: InputMaybe<LimesurveyTokensHavingInput>;
};

/** A `LimesurveyToken` edge in the connection. */
export type LimesurveyTokensEdge = {
  __typename?: 'LimesurveyTokensEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `LimesurveyToken` at the end of the edge. */
  node: LimesurveyToken;
};

/** Grouping methods for `LimesurveyToken` for usage during aggregation. */
export type LimesurveyTokensGroupBy =
  | 'COMPLETED_AT'
  | 'COMPLETED_AT_TRUNCATED_TO_DAY'
  | 'COMPLETED_AT_TRUNCATED_TO_HOUR'
  | 'HANDED_OUT_AT'
  | 'HANDED_OUT_AT_TRUNCATED_TO_DAY'
  | 'HANDED_OUT_AT_TRUNCATED_TO_HOUR'
  | 'STARTED_AT'
  | 'STARTED_AT_TRUNCATED_TO_DAY'
  | 'STARTED_AT_TRUNCATED_TO_HOUR'
  | 'SURVEY_ID'
  | 'TIME_OF_MEASUREMENT'
  | 'TOKEN'
  | 'TRIAL_ID';

export type LimesurveyTokensHavingAverageInput = {
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  surveyId?: InputMaybe<HavingIntFilter>;
};

export type LimesurveyTokensHavingDistinctCountInput = {
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  surveyId?: InputMaybe<HavingIntFilter>;
};

/** Conditions for `LimesurveyToken` aggregates. */
export type LimesurveyTokensHavingInput = {
  AND?: InputMaybe<Array<LimesurveyTokensHavingInput>>;
  OR?: InputMaybe<Array<LimesurveyTokensHavingInput>>;
  average?: InputMaybe<LimesurveyTokensHavingAverageInput>;
  distinctCount?: InputMaybe<LimesurveyTokensHavingDistinctCountInput>;
  max?: InputMaybe<LimesurveyTokensHavingMaxInput>;
  min?: InputMaybe<LimesurveyTokensHavingMinInput>;
  stddevPopulation?: InputMaybe<LimesurveyTokensHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<LimesurveyTokensHavingStddevSampleInput>;
  sum?: InputMaybe<LimesurveyTokensHavingSumInput>;
  variancePopulation?: InputMaybe<LimesurveyTokensHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<LimesurveyTokensHavingVarianceSampleInput>;
};

export type LimesurveyTokensHavingMaxInput = {
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  surveyId?: InputMaybe<HavingIntFilter>;
};

export type LimesurveyTokensHavingMinInput = {
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  surveyId?: InputMaybe<HavingIntFilter>;
};

export type LimesurveyTokensHavingStddevPopulationInput = {
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  surveyId?: InputMaybe<HavingIntFilter>;
};

export type LimesurveyTokensHavingStddevSampleInput = {
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  surveyId?: InputMaybe<HavingIntFilter>;
};

export type LimesurveyTokensHavingSumInput = {
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  surveyId?: InputMaybe<HavingIntFilter>;
};

export type LimesurveyTokensHavingVariancePopulationInput = {
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  surveyId?: InputMaybe<HavingIntFilter>;
};

export type LimesurveyTokensHavingVarianceSampleInput = {
  completedAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
  startedAt?: InputMaybe<HavingDatetimeFilter>;
  surveyId?: InputMaybe<HavingIntFilter>;
};

/** Methods to use when ordering `LimesurveyToken`. */
export type LimesurveyTokensOrderBy =
  | 'COMPLETED_AT_ASC'
  | 'COMPLETED_AT_DESC'
  | 'HANDED_OUT_AT_ASC'
  | 'HANDED_OUT_AT_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'STARTED_AT_ASC'
  | 'STARTED_AT_DESC'
  | 'SURVEY_ID_ASC'
  | 'SURVEY_ID_DESC'
  | 'TIME_OF_MEASUREMENT_ASC'
  | 'TIME_OF_MEASUREMENT_DESC'
  | 'TOKEN_ASC'
  | 'TOKEN_DESC'
  | 'TRIAL_ID_ASC'
  | 'TRIAL_ID_DESC';

export type ListenPayload = {
  __typename?: 'ListenPayload';
  /** Our root query field type. Allows us to run any query from our subscription payload. */
  query?: Maybe<Query>;
  relatedNode?: Maybe<Node>;
  relatedNodeId?: Maybe<Scalars['ID']>;
};

export type LogLevel =
  | 'DEBUG'
  | 'DEBUG2'
  | 'ERROR'
  | 'FATAL'
  | 'INFO'
  | 'LOG'
  | 'NOTICE'
  | 'PANIC'
  | 'WARNING';

/** All input for the `markPostingsAsReceived` mutation. */
export type MarkPostingsAsReceivedInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  postingIds: Array<InputMaybe<Scalars['UUID']>>;
};

/** The output of our `markPostingsAsReceived` mutation. */
export type MarkPostingsAsReceivedPayload = {
  __typename?: 'MarkPostingsAsReceivedPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  postingReceipts?: Maybe<Array<PostingReceipt>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

export type Membership = Node & {
  __typename?: 'Membership';
  createdAt: Scalars['Datetime'];
  flags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Reads a single `Group` that is related to this `Membership`. */
  group?: Maybe<Group>;
  groupId: Scalars['UUID'];
  id: Scalars['UUID'];
  isManagedExternally: Scalars['Boolean'];
  /** Reads and enables pagination through a set of `MembershipInvitationConfirmation`. */
  membershipInvitationConfirmations: MembershipInvitationConfirmationsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  role: GroupRole;
  /** Reads a single `Group` that is related to this `Membership`. */
  subgroup?: Maybe<Group>;
  subgroupId?: Maybe<Scalars['UUID']>;
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `Membership`. */
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};


export type MembershipMembershipInvitationConfirmationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MembershipInvitationConfirmationCondition>;
  filter?: InputMaybe<MembershipInvitationConfirmationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MembershipInvitationConfirmationsOrderBy>>;
};

export type MembershipAggregates = {
  __typename?: 'MembershipAggregates';
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<MembershipDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
};

/** A filter to be used against aggregates of `Membership` object types. */
export type MembershipAggregatesFilter = {
  /** Distinct count aggregate over matching `Membership` objects. */
  distinctCount?: InputMaybe<MembershipDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Membership` object to be included within the aggregate. */
  filter?: InputMaybe<MembershipFilter>;
};

/**
 * A condition to be used against `Membership` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type MembershipCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `flags` field. */
  flags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isManagedExternally` field. */
  isManagedExternally?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `role` field. */
  role?: InputMaybe<GroupRole>;
  /** Checks for equality with the object’s `subgroupId` field. */
  subgroupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

export type MembershipDistinctCountAggregateFilter = {
  createdAt?: InputMaybe<BigIntFilter>;
  flags?: InputMaybe<BigIntFilter>;
  groupId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  isManagedExternally?: InputMaybe<BigIntFilter>;
  role?: InputMaybe<BigIntFilter>;
  subgroupId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type MembershipDistinctCountAggregates = {
  __typename?: 'MembershipDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of flags across the matching connection */
  flags?: Maybe<Scalars['BigInt']>;
  /** Distinct count of groupId across the matching connection */
  groupId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']>;
  /** Distinct count of isManagedExternally across the matching connection */
  isManagedExternally?: Maybe<Scalars['BigInt']>;
  /** Distinct count of role across the matching connection */
  role?: Maybe<Scalars['BigInt']>;
  /** Distinct count of subgroupId across the matching connection */
  subgroupId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `Membership` object types. All fields are combined with a logical ‘and.’ */
export type MembershipFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MembershipFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `flags` field. */
  flags?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `group` relation. */
  group?: InputMaybe<GroupFilter>;
  /** Filter by the object’s `groupId` field. */
  groupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isManagedExternally` field. */
  isManagedExternally?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `membershipInvitationConfirmations` relation. */
  membershipInvitationConfirmations?: InputMaybe<MembershipToManyMembershipInvitationConfirmationFilter>;
  /** Some related `membershipInvitationConfirmations` exist. */
  membershipInvitationConfirmationsExist?: InputMaybe<Scalars['Boolean']>;
  /** Negates the expression. */
  not?: InputMaybe<MembershipFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MembershipFilter>>;
  /** Filter by the object’s `role` field. */
  role?: InputMaybe<GroupRoleFilter>;
  /** Filter by the object’s `subgroup` relation. */
  subgroup?: InputMaybe<GroupFilter>;
  /** A related `subgroup` exists. */
  subgroupExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `subgroupId` field. */
  subgroupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `Membership` */
export type MembershipInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId: Scalars['UUID'];
  id?: InputMaybe<Scalars['UUID']>;
  isManagedExternally?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<GroupRole>;
  subgroupId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type MembershipInvitation = Node & {
  __typename?: 'MembershipInvitation';
  acceptedAt?: Maybe<Scalars['Datetime']>;
  alsoAppliesInSubgroups?: Maybe<Scalars['Boolean']>;
  directedToMembers?: Maybe<Scalars['Boolean']>;
  /** Reads a single `Group` that is related to this `MembershipInvitation`. */
  group?: Maybe<Group>;
  groupId: Scalars['UUID'];
  id: Scalars['UUID'];
  invitedAs: GroupRole;
  invitedAt: Scalars['Datetime'];
  /** Reads a single `Group` that is related to this `MembershipInvitation`. */
  invitedGroup?: Maybe<Group>;
  invitedGroupId?: Maybe<Scalars['UUID']>;
  /** Reads a single `User` that is related to this `MembershipInvitation`. */
  invitedUser?: Maybe<User>;
  invitedUserId?: Maybe<Scalars['UUID']>;
  /** Reads a single `User` that is related to this `MembershipInvitation`. */
  inviter?: Maybe<User>;
  inviterId: Scalars['UUID'];
  maximumUses?: Maybe<Scalars['Int']>;
  /** Reads and enables pagination through a set of `MembershipInvitationConfirmation`. */
  membershipInvitationConfirmationsByInvitationId: MembershipInvitationConfirmationsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  validUntil?: Maybe<Scalars['Datetime']>;
};


export type MembershipInvitationMembershipInvitationConfirmationsByInvitationIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MembershipInvitationConfirmationCondition>;
  filter?: InputMaybe<MembershipInvitationConfirmationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MembershipInvitationConfirmationsOrderBy>>;
};

export type MembershipInvitationAggregates = {
  __typename?: 'MembershipInvitationAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<MembershipInvitationAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<MembershipInvitationDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<MembershipInvitationMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<MembershipInvitationMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<MembershipInvitationStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<MembershipInvitationStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<MembershipInvitationSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<MembershipInvitationVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<MembershipInvitationVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `MembershipInvitation` object types. */
export type MembershipInvitationAggregatesFilter = {
  /** Mean average aggregate over matching `MembershipInvitation` objects. */
  average?: InputMaybe<MembershipInvitationAverageAggregateFilter>;
  /** Distinct count aggregate over matching `MembershipInvitation` objects. */
  distinctCount?: InputMaybe<MembershipInvitationDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `MembershipInvitation` object to be included within the aggregate. */
  filter?: InputMaybe<MembershipInvitationFilter>;
  /** Maximum aggregate over matching `MembershipInvitation` objects. */
  max?: InputMaybe<MembershipInvitationMaxAggregateFilter>;
  /** Minimum aggregate over matching `MembershipInvitation` objects. */
  min?: InputMaybe<MembershipInvitationMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `MembershipInvitation` objects. */
  stddevPopulation?: InputMaybe<MembershipInvitationStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `MembershipInvitation` objects. */
  stddevSample?: InputMaybe<MembershipInvitationStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `MembershipInvitation` objects. */
  sum?: InputMaybe<MembershipInvitationSumAggregateFilter>;
  /** Population variance aggregate over matching `MembershipInvitation` objects. */
  variancePopulation?: InputMaybe<MembershipInvitationVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `MembershipInvitation` objects. */
  varianceSample?: InputMaybe<MembershipInvitationVarianceSampleAggregateFilter>;
};

export type MembershipInvitationAverageAggregateFilter = {
  maximumUses?: InputMaybe<BigFloatFilter>;
};

export type MembershipInvitationAverageAggregates = {
  __typename?: 'MembershipInvitationAverageAggregates';
  /** Mean average of maximumUses across the matching connection */
  maximumUses?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `MembershipInvitation` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type MembershipInvitationCondition = {
  /** Checks for equality with the object’s `acceptedAt` field. */
  acceptedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `alsoAppliesInSubgroups` field. */
  alsoAppliesInSubgroups?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `directedToMembers` field. */
  directedToMembers?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `groupId` field. */
  groupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `invitedAs` field. */
  invitedAs?: InputMaybe<GroupRole>;
  /** Checks for equality with the object’s `invitedAt` field. */
  invitedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `invitedGroupId` field. */
  invitedGroupId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `invitedUserId` field. */
  invitedUserId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `inviterId` field. */
  inviterId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `maximumUses` field. */
  maximumUses?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `note` field. */
  note?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `validUntil` field. */
  validUntil?: InputMaybe<Scalars['Datetime']>;
};

export type MembershipInvitationConfirmation = Node & {
  __typename?: 'MembershipInvitationConfirmation';
  acceptedAt: Scalars['Datetime'];
  id: Scalars['UUID'];
  /** Reads a single `MembershipInvitation` that is related to this `MembershipInvitationConfirmation`. */
  invitation?: Maybe<MembershipInvitation>;
  invitationId: Scalars['UUID'];
  /** Reads a single `Membership` that is related to this `MembershipInvitationConfirmation`. */
  membership?: Maybe<Membership>;
  membershipId: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

export type MembershipInvitationConfirmationAggregates = {
  __typename?: 'MembershipInvitationConfirmationAggregates';
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<MembershipInvitationConfirmationDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
};

/** A filter to be used against aggregates of `MembershipInvitationConfirmation` object types. */
export type MembershipInvitationConfirmationAggregatesFilter = {
  /** Distinct count aggregate over matching `MembershipInvitationConfirmation` objects. */
  distinctCount?: InputMaybe<MembershipInvitationConfirmationDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `MembershipInvitationConfirmation` object to be included within the aggregate. */
  filter?: InputMaybe<MembershipInvitationConfirmationFilter>;
};

/**
 * A condition to be used against `MembershipInvitationConfirmation` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type MembershipInvitationConfirmationCondition = {
  /** Checks for equality with the object’s `acceptedAt` field. */
  acceptedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `invitationId` field. */
  invitationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `membershipId` field. */
  membershipId?: InputMaybe<Scalars['UUID']>;
};

export type MembershipInvitationConfirmationDistinctCountAggregateFilter = {
  acceptedAt?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  invitationId?: InputMaybe<BigIntFilter>;
  membershipId?: InputMaybe<BigIntFilter>;
};

export type MembershipInvitationConfirmationDistinctCountAggregates = {
  __typename?: 'MembershipInvitationConfirmationDistinctCountAggregates';
  /** Distinct count of acceptedAt across the matching connection */
  acceptedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']>;
  /** Distinct count of invitationId across the matching connection */
  invitationId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of membershipId across the matching connection */
  membershipId?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `MembershipInvitationConfirmation` object types. All fields are combined with a logical ‘and.’ */
export type MembershipInvitationConfirmationFilter = {
  /** Filter by the object’s `acceptedAt` field. */
  acceptedAt?: InputMaybe<DatetimeFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MembershipInvitationConfirmationFilter>>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `invitation` relation. */
  invitation?: InputMaybe<MembershipInvitationFilter>;
  /** Filter by the object’s `invitationId` field. */
  invitationId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `membership` relation. */
  membership?: InputMaybe<MembershipFilter>;
  /** Filter by the object’s `membershipId` field. */
  membershipId?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<MembershipInvitationConfirmationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MembershipInvitationConfirmationFilter>>;
};

/** An input for mutations affecting `MembershipInvitationConfirmation` */
export type MembershipInvitationConfirmationInput = {
  acceptedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  invitationId: Scalars['UUID'];
  membershipId: Scalars['UUID'];
};

/** Represents an update to a `MembershipInvitationConfirmation`. Fields that are set will be updated. */
export type MembershipInvitationConfirmationPatch = {
  acceptedAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  invitationId?: InputMaybe<Scalars['UUID']>;
  membershipId?: InputMaybe<Scalars['UUID']>;
};

/** A connection to a list of `MembershipInvitationConfirmation` values. */
export type MembershipInvitationConfirmationsConnection = {
  __typename?: 'MembershipInvitationConfirmationsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<MembershipInvitationConfirmationAggregates>;
  /** A list of edges which contains the `MembershipInvitationConfirmation` and cursor to aid in pagination. */
  edges: Array<MembershipInvitationConfirmationsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<MembershipInvitationConfirmationAggregates>>;
  /** A list of `MembershipInvitationConfirmation` objects. */
  nodes: Array<MembershipInvitationConfirmation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MembershipInvitationConfirmation` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `MembershipInvitationConfirmation` values. */
export type MembershipInvitationConfirmationsConnectionGroupedAggregatesArgs = {
  groupBy: Array<MembershipInvitationConfirmationsGroupBy>;
  having?: InputMaybe<MembershipInvitationConfirmationsHavingInput>;
};

/** A `MembershipInvitationConfirmation` edge in the connection. */
export type MembershipInvitationConfirmationsEdge = {
  __typename?: 'MembershipInvitationConfirmationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MembershipInvitationConfirmation` at the end of the edge. */
  node: MembershipInvitationConfirmation;
};

/** Grouping methods for `MembershipInvitationConfirmation` for usage during aggregation. */
export type MembershipInvitationConfirmationsGroupBy =
  | 'ACCEPTED_AT'
  | 'ACCEPTED_AT_TRUNCATED_TO_DAY'
  | 'ACCEPTED_AT_TRUNCATED_TO_HOUR'
  | 'INVITATION_ID'
  | 'MEMBERSHIP_ID';

export type MembershipInvitationConfirmationsHavingAverageInput = {
  acceptedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MembershipInvitationConfirmationsHavingDistinctCountInput = {
  acceptedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `MembershipInvitationConfirmation` aggregates. */
export type MembershipInvitationConfirmationsHavingInput = {
  AND?: InputMaybe<Array<MembershipInvitationConfirmationsHavingInput>>;
  OR?: InputMaybe<Array<MembershipInvitationConfirmationsHavingInput>>;
  average?: InputMaybe<MembershipInvitationConfirmationsHavingAverageInput>;
  distinctCount?: InputMaybe<MembershipInvitationConfirmationsHavingDistinctCountInput>;
  max?: InputMaybe<MembershipInvitationConfirmationsHavingMaxInput>;
  min?: InputMaybe<MembershipInvitationConfirmationsHavingMinInput>;
  stddevPopulation?: InputMaybe<MembershipInvitationConfirmationsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<MembershipInvitationConfirmationsHavingStddevSampleInput>;
  sum?: InputMaybe<MembershipInvitationConfirmationsHavingSumInput>;
  variancePopulation?: InputMaybe<MembershipInvitationConfirmationsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<MembershipInvitationConfirmationsHavingVarianceSampleInput>;
};

export type MembershipInvitationConfirmationsHavingMaxInput = {
  acceptedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MembershipInvitationConfirmationsHavingMinInput = {
  acceptedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MembershipInvitationConfirmationsHavingStddevPopulationInput = {
  acceptedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MembershipInvitationConfirmationsHavingStddevSampleInput = {
  acceptedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MembershipInvitationConfirmationsHavingSumInput = {
  acceptedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MembershipInvitationConfirmationsHavingVariancePopulationInput = {
  acceptedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MembershipInvitationConfirmationsHavingVarianceSampleInput = {
  acceptedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `MembershipInvitationConfirmation`. */
export type MembershipInvitationConfirmationsOrderBy =
  | 'ACCEPTED_AT_ASC'
  | 'ACCEPTED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INVITATION_ID_ASC'
  | 'INVITATION_ID_DESC'
  | 'MEMBERSHIP_ID_ASC'
  | 'MEMBERSHIP_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC';

export type MembershipInvitationDistinctCountAggregateFilter = {
  acceptedAt?: InputMaybe<BigIntFilter>;
  alsoAppliesInSubgroups?: InputMaybe<BigIntFilter>;
  directedToMembers?: InputMaybe<BigIntFilter>;
  groupId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  invitedAs?: InputMaybe<BigIntFilter>;
  invitedAt?: InputMaybe<BigIntFilter>;
  invitedGroupId?: InputMaybe<BigIntFilter>;
  invitedUserId?: InputMaybe<BigIntFilter>;
  inviterId?: InputMaybe<BigIntFilter>;
  maximumUses?: InputMaybe<BigIntFilter>;
  note?: InputMaybe<BigIntFilter>;
  validUntil?: InputMaybe<BigIntFilter>;
};

export type MembershipInvitationDistinctCountAggregates = {
  __typename?: 'MembershipInvitationDistinctCountAggregates';
  /** Distinct count of acceptedAt across the matching connection */
  acceptedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of alsoAppliesInSubgroups across the matching connection */
  alsoAppliesInSubgroups?: Maybe<Scalars['BigInt']>;
  /** Distinct count of directedToMembers across the matching connection */
  directedToMembers?: Maybe<Scalars['BigInt']>;
  /** Distinct count of groupId across the matching connection */
  groupId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']>;
  /** Distinct count of invitedAs across the matching connection */
  invitedAs?: Maybe<Scalars['BigInt']>;
  /** Distinct count of invitedAt across the matching connection */
  invitedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of invitedGroupId across the matching connection */
  invitedGroupId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of invitedUserId across the matching connection */
  invitedUserId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of inviterId across the matching connection */
  inviterId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of maximumUses across the matching connection */
  maximumUses?: Maybe<Scalars['BigInt']>;
  /** Distinct count of note across the matching connection */
  note?: Maybe<Scalars['BigInt']>;
  /** Distinct count of validUntil across the matching connection */
  validUntil?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `MembershipInvitation` object types. All fields are combined with a logical ‘and.’ */
export type MembershipInvitationFilter = {
  /** Filter by the object’s `acceptedAt` field. */
  acceptedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `alsoAppliesInSubgroups` field. */
  alsoAppliesInSubgroups?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<MembershipInvitationFilter>>;
  /** Filter by the object’s `directedToMembers` field. */
  directedToMembers?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `group` relation. */
  group?: InputMaybe<GroupFilter>;
  /** Filter by the object’s `groupId` field. */
  groupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `invitedAs` field. */
  invitedAs?: InputMaybe<GroupRoleFilter>;
  /** Filter by the object’s `invitedAt` field. */
  invitedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `invitedGroup` relation. */
  invitedGroup?: InputMaybe<GroupFilter>;
  /** A related `invitedGroup` exists. */
  invitedGroupExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `invitedGroupId` field. */
  invitedGroupId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `invitedUser` relation. */
  invitedUser?: InputMaybe<UserFilter>;
  /** A related `invitedUser` exists. */
  invitedUserExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `invitedUserId` field. */
  invitedUserId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `inviter` relation. */
  inviter?: InputMaybe<UserFilter>;
  /** Filter by the object’s `inviterId` field. */
  inviterId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `maximumUses` field. */
  maximumUses?: InputMaybe<IntFilter>;
  /** Filter by the object’s `membershipInvitationConfirmationsByInvitationId` relation. */
  membershipInvitationConfirmationsByInvitationId?: InputMaybe<MembershipInvitationToManyMembershipInvitationConfirmationFilter>;
  /** Some related `membershipInvitationConfirmationsByInvitationId` exist. */
  membershipInvitationConfirmationsByInvitationIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Negates the expression. */
  not?: InputMaybe<MembershipInvitationFilter>;
  /** Filter by the object’s `note` field. */
  note?: InputMaybe<StringFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<MembershipInvitationFilter>>;
  /** Filter by the object’s `validUntil` field. */
  validUntil?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `MembershipInvitation` */
export type MembershipInvitationInput = {
  acceptedAt?: InputMaybe<Scalars['Datetime']>;
  alsoAppliesInSubgroups?: InputMaybe<Scalars['Boolean']>;
  directedToMembers?: InputMaybe<Scalars['Boolean']>;
  groupId: Scalars['UUID'];
  id?: InputMaybe<Scalars['UUID']>;
  invitedAs?: InputMaybe<GroupRole>;
  invitedAt?: InputMaybe<Scalars['Datetime']>;
  invitedGroupId?: InputMaybe<Scalars['UUID']>;
  invitedUserId?: InputMaybe<Scalars['UUID']>;
  inviterId: Scalars['UUID'];
  maximumUses?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  validUntil?: InputMaybe<Scalars['Datetime']>;
};

export type MembershipInvitationMaxAggregateFilter = {
  maximumUses?: InputMaybe<IntFilter>;
};

export type MembershipInvitationMaxAggregates = {
  __typename?: 'MembershipInvitationMaxAggregates';
  /** Maximum of maximumUses across the matching connection */
  maximumUses?: Maybe<Scalars['Int']>;
};

export type MembershipInvitationMinAggregateFilter = {
  maximumUses?: InputMaybe<IntFilter>;
};

export type MembershipInvitationMinAggregates = {
  __typename?: 'MembershipInvitationMinAggregates';
  /** Minimum of maximumUses across the matching connection */
  maximumUses?: Maybe<Scalars['Int']>;
};

/** Represents an update to a `MembershipInvitation`. Fields that are set will be updated. */
export type MembershipInvitationPatch = {
  acceptedAt?: InputMaybe<Scalars['Datetime']>;
  alsoAppliesInSubgroups?: InputMaybe<Scalars['Boolean']>;
  directedToMembers?: InputMaybe<Scalars['Boolean']>;
  groupId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  invitedAs?: InputMaybe<GroupRole>;
  invitedAt?: InputMaybe<Scalars['Datetime']>;
  invitedGroupId?: InputMaybe<Scalars['UUID']>;
  invitedUserId?: InputMaybe<Scalars['UUID']>;
  inviterId?: InputMaybe<Scalars['UUID']>;
  maximumUses?: InputMaybe<Scalars['Int']>;
  note?: InputMaybe<Scalars['String']>;
  validUntil?: InputMaybe<Scalars['Datetime']>;
};

export type MembershipInvitationStddevPopulationAggregateFilter = {
  maximumUses?: InputMaybe<BigFloatFilter>;
};

export type MembershipInvitationStddevPopulationAggregates = {
  __typename?: 'MembershipInvitationStddevPopulationAggregates';
  /** Population standard deviation of maximumUses across the matching connection */
  maximumUses?: Maybe<Scalars['BigFloat']>;
};

export type MembershipInvitationStddevSampleAggregateFilter = {
  maximumUses?: InputMaybe<BigFloatFilter>;
};

export type MembershipInvitationStddevSampleAggregates = {
  __typename?: 'MembershipInvitationStddevSampleAggregates';
  /** Sample standard deviation of maximumUses across the matching connection */
  maximumUses?: Maybe<Scalars['BigFloat']>;
};

export type MembershipInvitationSumAggregateFilter = {
  maximumUses?: InputMaybe<BigIntFilter>;
};

export type MembershipInvitationSumAggregates = {
  __typename?: 'MembershipInvitationSumAggregates';
  /** Sum of maximumUses across the matching connection */
  maximumUses: Scalars['BigInt'];
};

/** A filter to be used against many `MembershipInvitationConfirmation` object types. All fields are combined with a logical ‘and.’ */
export type MembershipInvitationToManyMembershipInvitationConfirmationFilter = {
  /** Aggregates across related `MembershipInvitationConfirmation` match the filter criteria. */
  aggregates?: InputMaybe<MembershipInvitationConfirmationAggregatesFilter>;
  /** Every related `MembershipInvitationConfirmation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MembershipInvitationConfirmationFilter>;
  /** No related `MembershipInvitationConfirmation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MembershipInvitationConfirmationFilter>;
  /** Some related `MembershipInvitationConfirmation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MembershipInvitationConfirmationFilter>;
};

export type MembershipInvitationVariancePopulationAggregateFilter = {
  maximumUses?: InputMaybe<BigFloatFilter>;
};

export type MembershipInvitationVariancePopulationAggregates = {
  __typename?: 'MembershipInvitationVariancePopulationAggregates';
  /** Population variance of maximumUses across the matching connection */
  maximumUses?: Maybe<Scalars['BigFloat']>;
};

export type MembershipInvitationVarianceSampleAggregateFilter = {
  maximumUses?: InputMaybe<BigFloatFilter>;
};

export type MembershipInvitationVarianceSampleAggregates = {
  __typename?: 'MembershipInvitationVarianceSampleAggregates';
  /** Sample variance of maximumUses across the matching connection */
  maximumUses?: Maybe<Scalars['BigFloat']>;
};

/** A connection to a list of `MembershipInvitation` values. */
export type MembershipInvitationsConnection = {
  __typename?: 'MembershipInvitationsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<MembershipInvitationAggregates>;
  /** A list of edges which contains the `MembershipInvitation` and cursor to aid in pagination. */
  edges: Array<MembershipInvitationsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<MembershipInvitationAggregates>>;
  /** A list of `MembershipInvitation` objects. */
  nodes: Array<MembershipInvitation>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `MembershipInvitation` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `MembershipInvitation` values. */
export type MembershipInvitationsConnectionGroupedAggregatesArgs = {
  groupBy: Array<MembershipInvitationsGroupBy>;
  having?: InputMaybe<MembershipInvitationsHavingInput>;
};

/** A `MembershipInvitation` edge in the connection. */
export type MembershipInvitationsEdge = {
  __typename?: 'MembershipInvitationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `MembershipInvitation` at the end of the edge. */
  node: MembershipInvitation;
};

/** Grouping methods for `MembershipInvitation` for usage during aggregation. */
export type MembershipInvitationsGroupBy =
  | 'ACCEPTED_AT'
  | 'ACCEPTED_AT_TRUNCATED_TO_DAY'
  | 'ACCEPTED_AT_TRUNCATED_TO_HOUR'
  | 'ALSO_APPLIES_IN_SUBGROUPS'
  | 'DIRECTED_TO_MEMBERS'
  | 'GROUP_ID'
  | 'INVITED_AS'
  | 'INVITED_AT'
  | 'INVITED_AT_TRUNCATED_TO_DAY'
  | 'INVITED_AT_TRUNCATED_TO_HOUR'
  | 'INVITED_GROUP_ID'
  | 'INVITED_USER_ID'
  | 'INVITER_ID'
  | 'MAXIMUM_USES'
  | 'NOTE'
  | 'VALID_UNTIL'
  | 'VALID_UNTIL_TRUNCATED_TO_DAY'
  | 'VALID_UNTIL_TRUNCATED_TO_HOUR';

export type MembershipInvitationsHavingAverageInput = {
  acceptedAt?: InputMaybe<HavingDatetimeFilter>;
  invitedAt?: InputMaybe<HavingDatetimeFilter>;
  maximumUses?: InputMaybe<HavingIntFilter>;
  validUntil?: InputMaybe<HavingDatetimeFilter>;
};

export type MembershipInvitationsHavingDistinctCountInput = {
  acceptedAt?: InputMaybe<HavingDatetimeFilter>;
  invitedAt?: InputMaybe<HavingDatetimeFilter>;
  maximumUses?: InputMaybe<HavingIntFilter>;
  validUntil?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `MembershipInvitation` aggregates. */
export type MembershipInvitationsHavingInput = {
  AND?: InputMaybe<Array<MembershipInvitationsHavingInput>>;
  OR?: InputMaybe<Array<MembershipInvitationsHavingInput>>;
  average?: InputMaybe<MembershipInvitationsHavingAverageInput>;
  distinctCount?: InputMaybe<MembershipInvitationsHavingDistinctCountInput>;
  max?: InputMaybe<MembershipInvitationsHavingMaxInput>;
  min?: InputMaybe<MembershipInvitationsHavingMinInput>;
  stddevPopulation?: InputMaybe<MembershipInvitationsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<MembershipInvitationsHavingStddevSampleInput>;
  sum?: InputMaybe<MembershipInvitationsHavingSumInput>;
  variancePopulation?: InputMaybe<MembershipInvitationsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<MembershipInvitationsHavingVarianceSampleInput>;
};

export type MembershipInvitationsHavingMaxInput = {
  acceptedAt?: InputMaybe<HavingDatetimeFilter>;
  invitedAt?: InputMaybe<HavingDatetimeFilter>;
  maximumUses?: InputMaybe<HavingIntFilter>;
  validUntil?: InputMaybe<HavingDatetimeFilter>;
};

export type MembershipInvitationsHavingMinInput = {
  acceptedAt?: InputMaybe<HavingDatetimeFilter>;
  invitedAt?: InputMaybe<HavingDatetimeFilter>;
  maximumUses?: InputMaybe<HavingIntFilter>;
  validUntil?: InputMaybe<HavingDatetimeFilter>;
};

export type MembershipInvitationsHavingStddevPopulationInput = {
  acceptedAt?: InputMaybe<HavingDatetimeFilter>;
  invitedAt?: InputMaybe<HavingDatetimeFilter>;
  maximumUses?: InputMaybe<HavingIntFilter>;
  validUntil?: InputMaybe<HavingDatetimeFilter>;
};

export type MembershipInvitationsHavingStddevSampleInput = {
  acceptedAt?: InputMaybe<HavingDatetimeFilter>;
  invitedAt?: InputMaybe<HavingDatetimeFilter>;
  maximumUses?: InputMaybe<HavingIntFilter>;
  validUntil?: InputMaybe<HavingDatetimeFilter>;
};

export type MembershipInvitationsHavingSumInput = {
  acceptedAt?: InputMaybe<HavingDatetimeFilter>;
  invitedAt?: InputMaybe<HavingDatetimeFilter>;
  maximumUses?: InputMaybe<HavingIntFilter>;
  validUntil?: InputMaybe<HavingDatetimeFilter>;
};

export type MembershipInvitationsHavingVariancePopulationInput = {
  acceptedAt?: InputMaybe<HavingDatetimeFilter>;
  invitedAt?: InputMaybe<HavingDatetimeFilter>;
  maximumUses?: InputMaybe<HavingIntFilter>;
  validUntil?: InputMaybe<HavingDatetimeFilter>;
};

export type MembershipInvitationsHavingVarianceSampleInput = {
  acceptedAt?: InputMaybe<HavingDatetimeFilter>;
  invitedAt?: InputMaybe<HavingDatetimeFilter>;
  maximumUses?: InputMaybe<HavingIntFilter>;
  validUntil?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `MembershipInvitation`. */
export type MembershipInvitationsOrderBy =
  | 'ACCEPTED_AT_ASC'
  | 'ACCEPTED_AT_DESC'
  | 'ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'DIRECTED_TO_MEMBERS_ASC'
  | 'DIRECTED_TO_MEMBERS_DESC'
  | 'GROUP_ID_ASC'
  | 'GROUP_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INVITED_AS_ASC'
  | 'INVITED_AS_DESC'
  | 'INVITED_AT_ASC'
  | 'INVITED_AT_DESC'
  | 'INVITED_GROUP_ID_ASC'
  | 'INVITED_GROUP_ID_DESC'
  | 'INVITED_USER_ID_ASC'
  | 'INVITED_USER_ID_DESC'
  | 'INVITER_ID_ASC'
  | 'INVITER_ID_DESC'
  | 'MAXIMUM_USES_ASC'
  | 'MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_AVERAGE_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_AVERAGE_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_AVERAGE_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_AVERAGE_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_AVERAGE_INVITATION_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_AVERAGE_INVITATION_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_AVERAGE_MEMBERSHIP_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_AVERAGE_MEMBERSHIP_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_COUNT_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_COUNT_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_DISTINCT_COUNT_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_DISTINCT_COUNT_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_DISTINCT_COUNT_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_DISTINCT_COUNT_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_DISTINCT_COUNT_INVITATION_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_DISTINCT_COUNT_INVITATION_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_DISTINCT_COUNT_MEMBERSHIP_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_DISTINCT_COUNT_MEMBERSHIP_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_MAX_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_MAX_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_MAX_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_MAX_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_MAX_INVITATION_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_MAX_INVITATION_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_MAX_MEMBERSHIP_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_MAX_MEMBERSHIP_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_MIN_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_MIN_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_MIN_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_MIN_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_MIN_INVITATION_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_MIN_INVITATION_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_MIN_MEMBERSHIP_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_MIN_MEMBERSHIP_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_STDDEV_POPULATION_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_STDDEV_POPULATION_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_STDDEV_POPULATION_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_STDDEV_POPULATION_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_STDDEV_POPULATION_INVITATION_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_STDDEV_POPULATION_INVITATION_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_STDDEV_POPULATION_MEMBERSHIP_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_STDDEV_POPULATION_MEMBERSHIP_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_STDDEV_SAMPLE_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_STDDEV_SAMPLE_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_STDDEV_SAMPLE_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_STDDEV_SAMPLE_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_STDDEV_SAMPLE_INVITATION_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_STDDEV_SAMPLE_INVITATION_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_STDDEV_SAMPLE_MEMBERSHIP_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_STDDEV_SAMPLE_MEMBERSHIP_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_SUM_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_SUM_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_SUM_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_SUM_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_SUM_INVITATION_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_SUM_INVITATION_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_SUM_MEMBERSHIP_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_SUM_MEMBERSHIP_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_VARIANCE_POPULATION_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_VARIANCE_POPULATION_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_VARIANCE_POPULATION_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_VARIANCE_POPULATION_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_VARIANCE_POPULATION_INVITATION_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_VARIANCE_POPULATION_INVITATION_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_VARIANCE_POPULATION_MEMBERSHIP_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_VARIANCE_POPULATION_MEMBERSHIP_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_VARIANCE_SAMPLE_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_VARIANCE_SAMPLE_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_VARIANCE_SAMPLE_INVITATION_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_VARIANCE_SAMPLE_INVITATION_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_VARIANCE_SAMPLE_MEMBERSHIP_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_BY_INVITATION_ID_VARIANCE_SAMPLE_MEMBERSHIP_ID_DESC'
  | 'NATURAL'
  | 'NOTE_ASC'
  | 'NOTE_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'VALID_UNTIL_ASC'
  | 'VALID_UNTIL_DESC';

/** Represents an update to a `Membership`. Fields that are set will be updated. */
export type MembershipPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  flags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  groupId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  isManagedExternally?: InputMaybe<Scalars['Boolean']>;
  role?: InputMaybe<GroupRole>;
  subgroupId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** A filter to be used against many `MembershipInvitationConfirmation` object types. All fields are combined with a logical ‘and.’ */
export type MembershipToManyMembershipInvitationConfirmationFilter = {
  /** Aggregates across related `MembershipInvitationConfirmation` match the filter criteria. */
  aggregates?: InputMaybe<MembershipInvitationConfirmationAggregatesFilter>;
  /** Every related `MembershipInvitationConfirmation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MembershipInvitationConfirmationFilter>;
  /** No related `MembershipInvitationConfirmation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MembershipInvitationConfirmationFilter>;
  /** Some related `MembershipInvitationConfirmation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MembershipInvitationConfirmationFilter>;
};

/** A connection to a list of `Membership` values. */
export type MembershipsConnection = {
  __typename?: 'MembershipsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<MembershipAggregates>;
  /** A list of edges which contains the `Membership` and cursor to aid in pagination. */
  edges: Array<MembershipsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<MembershipAggregates>>;
  /** A list of `Membership` objects. */
  nodes: Array<Membership>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Membership` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `Membership` values. */
export type MembershipsConnectionGroupedAggregatesArgs = {
  groupBy: Array<MembershipsGroupBy>;
  having?: InputMaybe<MembershipsHavingInput>;
};

/** A `Membership` edge in the connection. */
export type MembershipsEdge = {
  __typename?: 'MembershipsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Membership` at the end of the edge. */
  node: Membership;
};

/** Grouping methods for `Membership` for usage during aggregation. */
export type MembershipsGroupBy =
  | 'CREATED_AT'
  | 'CREATED_AT_TRUNCATED_TO_DAY'
  | 'CREATED_AT_TRUNCATED_TO_HOUR'
  | 'FLAGS'
  | 'GROUP_ID'
  | 'IS_MANAGED_EXTERNALLY'
  | 'ROLE'
  | 'SUBGROUP_ID'
  | 'UPDATED_AT'
  | 'UPDATED_AT_TRUNCATED_TO_DAY'
  | 'UPDATED_AT_TRUNCATED_TO_HOUR'
  | 'USER_ID';

export type MembershipsHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MembershipsHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `Membership` aggregates. */
export type MembershipsHavingInput = {
  AND?: InputMaybe<Array<MembershipsHavingInput>>;
  OR?: InputMaybe<Array<MembershipsHavingInput>>;
  average?: InputMaybe<MembershipsHavingAverageInput>;
  distinctCount?: InputMaybe<MembershipsHavingDistinctCountInput>;
  max?: InputMaybe<MembershipsHavingMaxInput>;
  min?: InputMaybe<MembershipsHavingMinInput>;
  stddevPopulation?: InputMaybe<MembershipsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<MembershipsHavingStddevSampleInput>;
  sum?: InputMaybe<MembershipsHavingSumInput>;
  variancePopulation?: InputMaybe<MembershipsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<MembershipsHavingVarianceSampleInput>;
};

export type MembershipsHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MembershipsHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MembershipsHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MembershipsHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MembershipsHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MembershipsHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type MembershipsHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `Membership`. */
export type MembershipsOrderBy =
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'FLAGS_ASC'
  | 'FLAGS_DESC'
  | 'GROUP_ID_ASC'
  | 'GROUP_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'IS_MANAGED_EXTERNALLY_ASC'
  | 'IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_AVERAGE_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_AVERAGE_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_AVERAGE_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_AVERAGE_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_AVERAGE_INVITATION_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_AVERAGE_INVITATION_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_AVERAGE_MEMBERSHIP_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_AVERAGE_MEMBERSHIP_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_COUNT_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_COUNT_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_DISTINCT_COUNT_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_DISTINCT_COUNT_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_DISTINCT_COUNT_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_DISTINCT_COUNT_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_DISTINCT_COUNT_INVITATION_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_DISTINCT_COUNT_INVITATION_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_DISTINCT_COUNT_MEMBERSHIP_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_DISTINCT_COUNT_MEMBERSHIP_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_MAX_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_MAX_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_MAX_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_MAX_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_MAX_INVITATION_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_MAX_INVITATION_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_MAX_MEMBERSHIP_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_MAX_MEMBERSHIP_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_MIN_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_MIN_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_MIN_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_MIN_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_MIN_INVITATION_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_MIN_INVITATION_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_MIN_MEMBERSHIP_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_MIN_MEMBERSHIP_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_STDDEV_POPULATION_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_STDDEV_POPULATION_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_STDDEV_POPULATION_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_STDDEV_POPULATION_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_STDDEV_POPULATION_INVITATION_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_STDDEV_POPULATION_INVITATION_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_STDDEV_POPULATION_MEMBERSHIP_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_STDDEV_POPULATION_MEMBERSHIP_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_STDDEV_SAMPLE_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_STDDEV_SAMPLE_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_STDDEV_SAMPLE_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_STDDEV_SAMPLE_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_STDDEV_SAMPLE_INVITATION_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_STDDEV_SAMPLE_INVITATION_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_STDDEV_SAMPLE_MEMBERSHIP_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_STDDEV_SAMPLE_MEMBERSHIP_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_SUM_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_SUM_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_SUM_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_SUM_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_SUM_INVITATION_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_SUM_INVITATION_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_SUM_MEMBERSHIP_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_SUM_MEMBERSHIP_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_VARIANCE_POPULATION_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_VARIANCE_POPULATION_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_VARIANCE_POPULATION_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_VARIANCE_POPULATION_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_VARIANCE_POPULATION_INVITATION_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_VARIANCE_POPULATION_INVITATION_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_VARIANCE_POPULATION_MEMBERSHIP_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_VARIANCE_POPULATION_MEMBERSHIP_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_VARIANCE_SAMPLE_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_VARIANCE_SAMPLE_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_VARIANCE_SAMPLE_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_VARIANCE_SAMPLE_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_VARIANCE_SAMPLE_INVITATION_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_VARIANCE_SAMPLE_INVITATION_ID_DESC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_VARIANCE_SAMPLE_MEMBERSHIP_ID_ASC'
  | 'MEMBERSHIP_INVITATION_CONFIRMATIONS_VARIANCE_SAMPLE_MEMBERSHIP_ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'ROLE_ASC'
  | 'ROLE_DESC'
  | 'SUBGROUP_ID_ASC'
  | 'SUBGROUP_ID_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

/** A filter to be used against MimeType fields. All fields are combined with a logical ‘and.’ */
export type MimeTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['MimeType']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['MimeType']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['MimeType']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['MimeType']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['MimeType']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['MimeType']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['MimeType']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['MimeType']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['MimeType']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['MimeType']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['MimeType']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['MimeType']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['MimeType']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['MimeType']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['MimeType']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['MimeType']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['MimeType']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['MimeType']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['MimeType']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['MimeType']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['MimeType']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['MimeType']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['MimeType']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['MimeType']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['MimeType']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['MimeType']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['MimeType']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['MimeType']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['MimeType']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['MimeType']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['MimeType']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['MimeType']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['MimeType']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['MimeType']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['MimeType']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['MimeType']>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  acceptMembershipInvitation?: Maybe<AcceptMembershipInvitationPayload>;
  /** Creates a single `Commentable`. */
  createCommentable?: Maybe<CreateCommentablePayload>;
  /** Creates a single `Conversation`. */
  createConversation?: Maybe<CreateConversationPayload>;
  /** Creates a single `EmaEntries2`. */
  createEmaEntries2?: Maybe<CreateEmaEntries2Payload>;
  /** Creates a single `EmaEntries3`. */
  createEmaEntries3?: Maybe<CreateEmaEntries3Payload>;
  /** Creates a single `EmaEntry`. */
  createEmaEntry?: Maybe<CreateEmaEntryPayload>;
  /** Creates a single `Event`. */
  createEvent?: Maybe<CreateEventPayload>;
  /** Creates a single `FavoritePage`. */
  createFavoritePage?: Maybe<CreateFavoritePagePayload>;
  /** Creates a single `GenericEmiExercise`. */
  createGenericEmiExercise?: Maybe<CreateGenericEmiExercisePayload>;
  /** Creates a single `Group`. */
  createGroup?: Maybe<CreateGroupPayload>;
  /** Creates a single `GroupHome`. */
  createGroupHome?: Maybe<CreateGroupHomePayload>;
  /** Creates a single `LimesurveyToken`. */
  createLimesurveyToken?: Maybe<CreateLimesurveyTokenPayload>;
  /** Creates a single `Membership`. */
  createMembership?: Maybe<CreateMembershipPayload>;
  /** Creates a single `MembershipInvitation`. */
  createMembershipInvitation?: Maybe<CreateMembershipInvitationPayload>;
  /** Creates a single `MembershipInvitationConfirmation`. */
  createMembershipInvitationConfirmation?: Maybe<CreateMembershipInvitationConfirmationPayload>;
  /** Creates a single `PostWaitRandomizationTicket`. */
  createPostWaitRandomizationTicket?: Maybe<CreatePostWaitRandomizationTicketPayload>;
  /** Creates a single `Posting`. */
  createPosting?: Maybe<CreatePostingPayload>;
  /** Creates a single `PostingReceipt`. */
  createPostingReceipt?: Maybe<CreatePostingReceiptPayload>;
  /** Creates a single `RandomizationTicket`. */
  createRandomizationTicket?: Maybe<CreateRandomizationTicketPayload>;
  /** Creates a single `RawUsageDatum`. */
  createRawUsageDatum?: Maybe<CreateRawUsageDatumPayload>;
  /** Creates a single `Tenant`. */
  createTenant?: Maybe<CreateTenantPayload>;
  /** Creates a single `Trial`. */
  createTrial?: Maybe<CreateTrialPayload>;
  /** Creates a single `User`. */
  createUser?: Maybe<CreateUserPayload>;
  /** Creates a single `UserCredential`. */
  createUserCredential?: Maybe<CreateUserCredentialPayload>;
  /** Creates a single `UserEmailAddress`. */
  createUserEmailAddress?: Maybe<CreateUserEmailAddressPayload>;
  /** Deletes a single `Commentable` using a unique key. */
  deleteCommentable?: Maybe<DeleteCommentablePayload>;
  /** Deletes a single `Commentable` using its globally unique id. */
  deleteCommentableByNodeId?: Maybe<DeleteCommentablePayload>;
  /** Deletes a single `Conversation` using a unique key. */
  deleteConversation?: Maybe<DeleteConversationPayload>;
  /** Deletes a single `Conversation` using its globally unique id. */
  deleteConversationByNodeId?: Maybe<DeleteConversationPayload>;
  /** Deletes a single `EmaEntries2` using a unique key. */
  deleteEmaEntries2?: Maybe<DeleteEmaEntries2Payload>;
  /** Deletes a single `EmaEntries2` using its globally unique id. */
  deleteEmaEntries2ByNodeId?: Maybe<DeleteEmaEntries2Payload>;
  /** Deletes a single `EmaEntries3` using a unique key. */
  deleteEmaEntries3?: Maybe<DeleteEmaEntries3Payload>;
  /** Deletes a single `EmaEntries3` using its globally unique id. */
  deleteEmaEntries3ByNodeId?: Maybe<DeleteEmaEntries3Payload>;
  /** Deletes a single `EmaEntry` using a unique key. */
  deleteEmaEntry?: Maybe<DeleteEmaEntryPayload>;
  /** Deletes a single `EmaEntry` using its globally unique id. */
  deleteEmaEntryByNodeId?: Maybe<DeleteEmaEntryPayload>;
  /** Deletes a single `FavoritePage` using a unique key. */
  deleteFavoritePage?: Maybe<DeleteFavoritePagePayload>;
  /** Deletes a single `FavoritePage` using its globally unique id. */
  deleteFavoritePageByNodeId?: Maybe<DeleteFavoritePagePayload>;
  /** Deletes a single `GenericEmiExercise` using a unique key. */
  deleteGenericEmiExercise?: Maybe<DeleteGenericEmiExercisePayload>;
  /** Deletes a single `GenericEmiExercise` using its globally unique id. */
  deleteGenericEmiExerciseByNodeId?: Maybe<DeleteGenericEmiExercisePayload>;
  /** Deletes a single `GenericEmiExercise` using a unique key. */
  deleteGenericEmiExerciseByTrialIdAndName?: Maybe<DeleteGenericEmiExercisePayload>;
  /** Deletes a single `Group` using a unique key. */
  deleteGroup?: Maybe<DeleteGroupPayload>;
  /** Deletes a single `Group` using its globally unique id. */
  deleteGroupByNodeId?: Maybe<DeleteGroupPayload>;
  /** Deletes a single `GroupHome` using a unique key. */
  deleteGroupHome?: Maybe<DeleteGroupHomePayload>;
  /** Deletes a single `GroupHome` using its globally unique id. */
  deleteGroupHomeByNodeId?: Maybe<DeleteGroupHomePayload>;
  /** Deletes a single `LimesurveyToken` using a unique key. */
  deleteLimesurveyToken?: Maybe<DeleteLimesurveyTokenPayload>;
  /** Deletes a single `LimesurveyToken` using its globally unique id. */
  deleteLimesurveyTokenByNodeId?: Maybe<DeleteLimesurveyTokenPayload>;
  /** Deletes a single `LimesurveyToken` using a unique key. */
  deleteLimesurveyTokenByTrialIdAndTimeOfMeasurement?: Maybe<DeleteLimesurveyTokenPayload>;
  /** Deletes a single `Membership` using a unique key. */
  deleteMembership?: Maybe<DeleteMembershipPayload>;
  /** Deletes a single `Membership` using a unique key. */
  deleteMembershipByGroupIdAndSubgroupId?: Maybe<DeleteMembershipPayload>;
  /** Deletes a single `Membership` using a unique key. */
  deleteMembershipByGroupIdAndUserId?: Maybe<DeleteMembershipPayload>;
  /** Deletes a single `Membership` using its globally unique id. */
  deleteMembershipByNodeId?: Maybe<DeleteMembershipPayload>;
  /** Deletes a single `MembershipInvitation` using a unique key. */
  deleteMembershipInvitation?: Maybe<DeleteMembershipInvitationPayload>;
  /** Deletes a single `MembershipInvitation` using its globally unique id. */
  deleteMembershipInvitationByNodeId?: Maybe<DeleteMembershipInvitationPayload>;
  /** Deletes a single `MembershipInvitationConfirmation` using a unique key. */
  deleteMembershipInvitationConfirmation?: Maybe<DeleteMembershipInvitationConfirmationPayload>;
  /** Deletes a single `MembershipInvitationConfirmation` using its globally unique id. */
  deleteMembershipInvitationConfirmationByNodeId?: Maybe<DeleteMembershipInvitationConfirmationPayload>;
  /** Deletes a single `PostWaitRandomizationTicket` using a unique key. */
  deletePostWaitRandomizationTicket?: Maybe<DeletePostWaitRandomizationTicketPayload>;
  /** Deletes a single `PostWaitRandomizationTicket` using its globally unique id. */
  deletePostWaitRandomizationTicketByNodeId?: Maybe<DeletePostWaitRandomizationTicketPayload>;
  /** Deletes a single `PostWaitRandomizationTicket` using a unique key. */
  deletePostWaitRandomizationTicketByTrialId?: Maybe<DeletePostWaitRandomizationTicketPayload>;
  /** Deletes a single `Posting` using a unique key. */
  deletePosting?: Maybe<DeletePostingPayload>;
  /** Deletes a single `Posting` using its globally unique id. */
  deletePostingByNodeId?: Maybe<DeletePostingPayload>;
  /** Deletes a single `PostingReceipt` using a unique key. */
  deletePostingReceipt?: Maybe<DeletePostingReceiptPayload>;
  /** Deletes a single `PostingReceipt` using its globally unique id. */
  deletePostingReceiptByNodeId?: Maybe<DeletePostingReceiptPayload>;
  /** Deletes a single `RandomizationTicket` using a unique key. */
  deleteRandomizationTicket?: Maybe<DeleteRandomizationTicketPayload>;
  /** Deletes a single `RandomizationTicket` using its globally unique id. */
  deleteRandomizationTicketByNodeId?: Maybe<DeleteRandomizationTicketPayload>;
  /** Deletes a single `RandomizationTicket` using a unique key. */
  deleteRandomizationTicketByTrialId?: Maybe<DeleteRandomizationTicketPayload>;
  /** Deletes a single `RawUsageDatum` using a unique key. */
  deleteRawUsageDatum?: Maybe<DeleteRawUsageDatumPayload>;
  /** Deletes a single `RawUsageDatum` using its globally unique id. */
  deleteRawUsageDatumByNodeId?: Maybe<DeleteRawUsageDatumPayload>;
  /** Deletes a single `Tenant` using a unique key. */
  deleteTenant?: Maybe<DeleteTenantPayload>;
  /** Deletes a single `Tenant` using a unique key. */
  deleteTenantByName?: Maybe<DeleteTenantPayload>;
  /** Deletes a single `Tenant` using its globally unique id. */
  deleteTenantByNodeId?: Maybe<DeleteTenantPayload>;
  /** Deletes a single `Tenant` using a unique key. */
  deleteTenantByUrl?: Maybe<DeleteTenantPayload>;
  /** Deletes a single `Trial` using a unique key. */
  deleteTrial?: Maybe<DeleteTrialPayload>;
  /** Deletes a single `Trial` using a unique key. */
  deleteTrialByHumanReadableId?: Maybe<DeleteTrialPayload>;
  /** Deletes a single `Trial` using a unique key. */
  deleteTrialByName?: Maybe<DeleteTrialPayload>;
  /** Deletes a single `Trial` using its globally unique id. */
  deleteTrialByNodeId?: Maybe<DeleteTrialPayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUser?: Maybe<DeleteUserPayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUserByCredentialsId?: Maybe<DeleteUserPayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUserByEmailAddressId?: Maybe<DeleteUserPayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUserByIdAndTenantId?: Maybe<DeleteUserPayload>;
  /** Deletes a single `User` using its globally unique id. */
  deleteUserByNodeId?: Maybe<DeleteUserPayload>;
  /** Deletes a single `User` using a unique key. */
  deleteUserByUsernameAndTenantId?: Maybe<DeleteUserPayload>;
  /** Deletes a single `UserCredential` using a unique key. */
  deleteUserCredential?: Maybe<DeleteUserCredentialPayload>;
  /** Deletes a single `UserCredential` using a unique key. */
  deleteUserCredentialByExternalAuthIdAndTenantId?: Maybe<DeleteUserCredentialPayload>;
  /** Deletes a single `UserCredential` using its globally unique id. */
  deleteUserCredentialByNodeId?: Maybe<DeleteUserCredentialPayload>;
  /** Deletes a single `UserEmailAddress` using a unique key. */
  deleteUserEmailAddress?: Maybe<DeleteUserEmailAddressPayload>;
  /** Deletes a single `UserEmailAddress` using a unique key. */
  deleteUserEmailAddressByEmailAddressAndTenantId?: Maybe<DeleteUserEmailAddressPayload>;
  /** Deletes a single `UserEmailAddress` using its globally unique id. */
  deleteUserEmailAddressByNodeId?: Maybe<DeleteUserEmailAddressPayload>;
  generateGravatarHashFromEmail?: Maybe<GenerateGravatarHashFromEmailPayload>;
  generateSamplingPlan?: Maybe<GenerateSamplingPlanPayload>;
  generateSamplingPlan2?: Maybe<GenerateSamplingPlan2Payload>;
  generateSamplingPlan3?: Maybe<GenerateSamplingPlan3Payload>;
  markPostingsAsReceived?: Maybe<MarkPostingsAsReceivedPayload>;
  /** Creates one or many `PostingReceipt`. */
  mnCreatePostingReceipt?: Maybe<MnCreatePostingReceiptPayload>;
  /** Deletes one or many `PostingReceipt` a unique key via a patch. */
  mnDeletePostingReceipt?: Maybe<MnDeletePostingReceiptPayload>;
  /** Updates one or many `PostingReceipt` using a unique key and a patch. */
  mnUpdatePostingReceipt?: Maybe<MnUpdatePostingReceiptPayload>;
  pullEmaEntries2?: Maybe<PullEmaEntries2Payload>;
  pushEmaEntry?: Maybe<PushEmaEntryPayload>;
  setAvatar?: Maybe<SetAvatarPayload>;
  setEmergencyPhoneNumbers?: Maybe<SetEmergencyPhoneNumbersPayload>;
  setNickname?: Maybe<SetNicknamePayload>;
  signIn?: Maybe<SignInPayload>;
  signUpWithAccessToken?: Maybe<SignUpWithAccessTokenPayload>;
  toggleFavoriteOfRoute?: Maybe<ToggleFavoriteOfRoutePayload>;
  /** Updates a single `Commentable` using a unique key and a patch. */
  updateCommentable?: Maybe<UpdateCommentablePayload>;
  /** Updates a single `Commentable` using its globally unique id and a patch. */
  updateCommentableByNodeId?: Maybe<UpdateCommentablePayload>;
  /** Updates a single `Conversation` using a unique key and a patch. */
  updateConversation?: Maybe<UpdateConversationPayload>;
  /** Updates a single `Conversation` using its globally unique id and a patch. */
  updateConversationByNodeId?: Maybe<UpdateConversationPayload>;
  /** Updates a single `EmaEntries2` using a unique key and a patch. */
  updateEmaEntries2?: Maybe<UpdateEmaEntries2Payload>;
  /** Updates a single `EmaEntries2` using its globally unique id and a patch. */
  updateEmaEntries2ByNodeId?: Maybe<UpdateEmaEntries2Payload>;
  /** Updates a single `EmaEntries3` using a unique key and a patch. */
  updateEmaEntries3?: Maybe<UpdateEmaEntries3Payload>;
  /** Updates a single `EmaEntries3` using its globally unique id and a patch. */
  updateEmaEntries3ByNodeId?: Maybe<UpdateEmaEntries3Payload>;
  /** Updates a single `EmaEntry` using a unique key and a patch. */
  updateEmaEntry?: Maybe<UpdateEmaEntryPayload>;
  /** Updates a single `EmaEntry` using its globally unique id and a patch. */
  updateEmaEntryByNodeId?: Maybe<UpdateEmaEntryPayload>;
  /** Updates a single `FavoritePage` using a unique key and a patch. */
  updateFavoritePage?: Maybe<UpdateFavoritePagePayload>;
  /** Updates a single `FavoritePage` using its globally unique id and a patch. */
  updateFavoritePageByNodeId?: Maybe<UpdateFavoritePagePayload>;
  /** Updates a single `GenericEmiExercise` using a unique key and a patch. */
  updateGenericEmiExercise?: Maybe<UpdateGenericEmiExercisePayload>;
  /** Updates a single `GenericEmiExercise` using its globally unique id and a patch. */
  updateGenericEmiExerciseByNodeId?: Maybe<UpdateGenericEmiExercisePayload>;
  /** Updates a single `GenericEmiExercise` using a unique key and a patch. */
  updateGenericEmiExerciseByTrialIdAndName?: Maybe<UpdateGenericEmiExercisePayload>;
  /** Updates a single `Group` using a unique key and a patch. */
  updateGroup?: Maybe<UpdateGroupPayload>;
  /** Updates a single `Group` using its globally unique id and a patch. */
  updateGroupByNodeId?: Maybe<UpdateGroupPayload>;
  /** Updates a single `GroupHome` using a unique key and a patch. */
  updateGroupHome?: Maybe<UpdateGroupHomePayload>;
  /** Updates a single `GroupHome` using its globally unique id and a patch. */
  updateGroupHomeByNodeId?: Maybe<UpdateGroupHomePayload>;
  /** Updates a single `LimesurveyToken` using a unique key and a patch. */
  updateLimesurveyToken?: Maybe<UpdateLimesurveyTokenPayload>;
  /** Updates a single `LimesurveyToken` using its globally unique id and a patch. */
  updateLimesurveyTokenByNodeId?: Maybe<UpdateLimesurveyTokenPayload>;
  /** Updates a single `LimesurveyToken` using a unique key and a patch. */
  updateLimesurveyTokenByTrialIdAndTimeOfMeasurement?: Maybe<UpdateLimesurveyTokenPayload>;
  /** Updates a single `Membership` using a unique key and a patch. */
  updateMembership?: Maybe<UpdateMembershipPayload>;
  /** Updates a single `Membership` using a unique key and a patch. */
  updateMembershipByGroupIdAndSubgroupId?: Maybe<UpdateMembershipPayload>;
  /** Updates a single `Membership` using a unique key and a patch. */
  updateMembershipByGroupIdAndUserId?: Maybe<UpdateMembershipPayload>;
  /** Updates a single `Membership` using its globally unique id and a patch. */
  updateMembershipByNodeId?: Maybe<UpdateMembershipPayload>;
  /** Updates a single `MembershipInvitation` using a unique key and a patch. */
  updateMembershipInvitation?: Maybe<UpdateMembershipInvitationPayload>;
  /** Updates a single `MembershipInvitation` using its globally unique id and a patch. */
  updateMembershipInvitationByNodeId?: Maybe<UpdateMembershipInvitationPayload>;
  /** Updates a single `MembershipInvitationConfirmation` using a unique key and a patch. */
  updateMembershipInvitationConfirmation?: Maybe<UpdateMembershipInvitationConfirmationPayload>;
  /** Updates a single `MembershipInvitationConfirmation` using its globally unique id and a patch. */
  updateMembershipInvitationConfirmationByNodeId?: Maybe<UpdateMembershipInvitationConfirmationPayload>;
  /** Updates a single `PostWaitRandomizationTicket` using a unique key and a patch. */
  updatePostWaitRandomizationTicket?: Maybe<UpdatePostWaitRandomizationTicketPayload>;
  /** Updates a single `PostWaitRandomizationTicket` using its globally unique id and a patch. */
  updatePostWaitRandomizationTicketByNodeId?: Maybe<UpdatePostWaitRandomizationTicketPayload>;
  /** Updates a single `PostWaitRandomizationTicket` using a unique key and a patch. */
  updatePostWaitRandomizationTicketByTrialId?: Maybe<UpdatePostWaitRandomizationTicketPayload>;
  /** Updates a single `Posting` using a unique key and a patch. */
  updatePosting?: Maybe<UpdatePostingPayload>;
  /** Updates a single `Posting` using its globally unique id and a patch. */
  updatePostingByNodeId?: Maybe<UpdatePostingPayload>;
  /** Updates a single `PostingReceipt` using a unique key and a patch. */
  updatePostingReceipt?: Maybe<UpdatePostingReceiptPayload>;
  /** Updates a single `PostingReceipt` using its globally unique id and a patch. */
  updatePostingReceiptByNodeId?: Maybe<UpdatePostingReceiptPayload>;
  /** Updates a single `RandomizationTicket` using a unique key and a patch. */
  updateRandomizationTicket?: Maybe<UpdateRandomizationTicketPayload>;
  /** Updates a single `RandomizationTicket` using its globally unique id and a patch. */
  updateRandomizationTicketByNodeId?: Maybe<UpdateRandomizationTicketPayload>;
  /** Updates a single `RandomizationTicket` using a unique key and a patch. */
  updateRandomizationTicketByTrialId?: Maybe<UpdateRandomizationTicketPayload>;
  /** Updates a single `RawUsageDatum` using a unique key and a patch. */
  updateRawUsageDatum?: Maybe<UpdateRawUsageDatumPayload>;
  /** Updates a single `RawUsageDatum` using its globally unique id and a patch. */
  updateRawUsageDatumByNodeId?: Maybe<UpdateRawUsageDatumPayload>;
  /** Updates a single `Tenant` using a unique key and a patch. */
  updateTenant?: Maybe<UpdateTenantPayload>;
  /** Updates a single `Tenant` using a unique key and a patch. */
  updateTenantByName?: Maybe<UpdateTenantPayload>;
  /** Updates a single `Tenant` using its globally unique id and a patch. */
  updateTenantByNodeId?: Maybe<UpdateTenantPayload>;
  /** Updates a single `Tenant` using a unique key and a patch. */
  updateTenantByUrl?: Maybe<UpdateTenantPayload>;
  /** Updates a single `Trial` using a unique key and a patch. */
  updateTrial?: Maybe<UpdateTrialPayload>;
  /** Updates a single `Trial` using a unique key and a patch. */
  updateTrialByHumanReadableId?: Maybe<UpdateTrialPayload>;
  /** Updates a single `Trial` using a unique key and a patch. */
  updateTrialByName?: Maybe<UpdateTrialPayload>;
  /** Updates a single `Trial` using its globally unique id and a patch. */
  updateTrialByNodeId?: Maybe<UpdateTrialPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUser?: Maybe<UpdateUserPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUserByCredentialsId?: Maybe<UpdateUserPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUserByEmailAddressId?: Maybe<UpdateUserPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUserByIdAndTenantId?: Maybe<UpdateUserPayload>;
  /** Updates a single `User` using its globally unique id and a patch. */
  updateUserByNodeId?: Maybe<UpdateUserPayload>;
  /** Updates a single `User` using a unique key and a patch. */
  updateUserByUsernameAndTenantId?: Maybe<UpdateUserPayload>;
  /** Updates a single `UserCredential` using a unique key and a patch. */
  updateUserCredential?: Maybe<UpdateUserCredentialPayload>;
  /** Updates a single `UserCredential` using a unique key and a patch. */
  updateUserCredentialByExternalAuthIdAndTenantId?: Maybe<UpdateUserCredentialPayload>;
  /** Updates a single `UserCredential` using its globally unique id and a patch. */
  updateUserCredentialByNodeId?: Maybe<UpdateUserCredentialPayload>;
  /** Updates a single `UserEmailAddress` using a unique key and a patch. */
  updateUserEmailAddress?: Maybe<UpdateUserEmailAddressPayload>;
  /** Updates a single `UserEmailAddress` using a unique key and a patch. */
  updateUserEmailAddressByEmailAddressAndTenantId?: Maybe<UpdateUserEmailAddressPayload>;
  /** Updates a single `UserEmailAddress` using its globally unique id and a patch. */
  updateUserEmailAddressByNodeId?: Maybe<UpdateUserEmailAddressPayload>;
  /** Upserts a single `Commentable`. */
  upsertCommentable?: Maybe<UpsertCommentablePayload>;
  /** Upserts a single `Conversation`. */
  upsertConversation?: Maybe<UpsertConversationPayload>;
  /** Upserts a single `EmaEntries2`. */
  upsertEmaEntries2?: Maybe<UpsertEmaEntries2Payload>;
  /** Upserts a single `EmaEntries3`. */
  upsertEmaEntries3?: Maybe<UpsertEmaEntries3Payload>;
  /** Upserts a single `EmaEntry`. */
  upsertEmaEntry?: Maybe<UpsertEmaEntryPayload>;
  /** Upserts a single `Event`. */
  upsertEvent?: Maybe<UpsertEventPayload>;
  /** Upserts a single `FavoritePage`. */
  upsertFavoritePage?: Maybe<UpsertFavoritePagePayload>;
  /** Upserts a single `GenericEmiExercise`. */
  upsertGenericEmiExercise?: Maybe<UpsertGenericEmiExercisePayload>;
  /** Upserts a single `Group`. */
  upsertGroup?: Maybe<UpsertGroupPayload>;
  /** Upserts a single `GroupHome`. */
  upsertGroupHome?: Maybe<UpsertGroupHomePayload>;
  /** Upserts a single `LimesurveyToken`. */
  upsertLimesurveyToken?: Maybe<UpsertLimesurveyTokenPayload>;
  /** Upserts a single `Membership`. */
  upsertMembership?: Maybe<UpsertMembershipPayload>;
  /** Upserts a single `MembershipInvitation`. */
  upsertMembershipInvitation?: Maybe<UpsertMembershipInvitationPayload>;
  /** Upserts a single `MembershipInvitationConfirmation`. */
  upsertMembershipInvitationConfirmation?: Maybe<UpsertMembershipInvitationConfirmationPayload>;
  /** Upserts a single `PostWaitRandomizationTicket`. */
  upsertPostWaitRandomizationTicket?: Maybe<UpsertPostWaitRandomizationTicketPayload>;
  /** Upserts a single `Posting`. */
  upsertPosting?: Maybe<UpsertPostingPayload>;
  /** Upserts a single `PostingReceipt`. */
  upsertPostingReceipt?: Maybe<UpsertPostingReceiptPayload>;
  /** Upserts a single `RandomizationTicket`. */
  upsertRandomizationTicket?: Maybe<UpsertRandomizationTicketPayload>;
  /** Upserts a single `RawUsageDatum`. */
  upsertRawUsageDatum?: Maybe<UpsertRawUsageDatumPayload>;
  /** Upserts a single `Tenant`. */
  upsertTenant?: Maybe<UpsertTenantPayload>;
  /** Upserts a single `Trial`. */
  upsertTrial?: Maybe<UpsertTrialPayload>;
  /** Upserts a single `User`. */
  upsertUser?: Maybe<UpsertUserPayload>;
  /** Upserts a single `UserCredential`. */
  upsertUserCredential?: Maybe<UpsertUserCredentialPayload>;
  /** Upserts a single `UserEmailAddress`. */
  upsertUserEmailAddress?: Maybe<UpsertUserEmailAddressPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAcceptMembershipInvitationArgs = {
  input: AcceptMembershipInvitationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateCommentableArgs = {
  input: CreateCommentableInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateConversationArgs = {
  input: CreateConversationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEmaEntries2Args = {
  input: CreateEmaEntries2Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEmaEntries3Args = {
  input: CreateEmaEntries3Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEmaEntryArgs = {
  input: CreateEmaEntryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateEventArgs = {
  input: CreateEventInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateFavoritePageArgs = {
  input: CreateFavoritePageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGenericEmiExerciseArgs = {
  input: CreateGenericEmiExerciseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateGroupHomeArgs = {
  input: CreateGroupHomeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateLimesurveyTokenArgs = {
  input: CreateLimesurveyTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMembershipArgs = {
  input: CreateMembershipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMembershipInvitationArgs = {
  input: CreateMembershipInvitationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateMembershipInvitationConfirmationArgs = {
  input: CreateMembershipInvitationConfirmationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePostWaitRandomizationTicketArgs = {
  input: CreatePostWaitRandomizationTicketInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePostingArgs = {
  input: CreatePostingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreatePostingReceiptArgs = {
  input: CreatePostingReceiptInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRandomizationTicketArgs = {
  input: CreateRandomizationTicketInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateRawUsageDatumArgs = {
  input: CreateRawUsageDatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTenantArgs = {
  input: CreateTenantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateTrialArgs = {
  input: CreateTrialInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserCredentialArgs = {
  input: CreateUserCredentialInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateUserEmailAddressArgs = {
  input: CreateUserEmailAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCommentableArgs = {
  input: DeleteCommentableInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteCommentableByNodeIdArgs = {
  input: DeleteCommentableByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteConversationArgs = {
  input: DeleteConversationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteConversationByNodeIdArgs = {
  input: DeleteConversationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEmaEntries2Args = {
  input: DeleteEmaEntries2Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEmaEntries2ByNodeIdArgs = {
  input: DeleteEmaEntries2ByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEmaEntries3Args = {
  input: DeleteEmaEntries3Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEmaEntries3ByNodeIdArgs = {
  input: DeleteEmaEntries3ByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEmaEntryArgs = {
  input: DeleteEmaEntryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteEmaEntryByNodeIdArgs = {
  input: DeleteEmaEntryByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFavoritePageArgs = {
  input: DeleteFavoritePageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteFavoritePageByNodeIdArgs = {
  input: DeleteFavoritePageByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGenericEmiExerciseArgs = {
  input: DeleteGenericEmiExerciseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGenericEmiExerciseByNodeIdArgs = {
  input: DeleteGenericEmiExerciseByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGenericEmiExerciseByTrialIdAndNameArgs = {
  input: DeleteGenericEmiExerciseByTrialIdAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGroupArgs = {
  input: DeleteGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGroupByNodeIdArgs = {
  input: DeleteGroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGroupHomeArgs = {
  input: DeleteGroupHomeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteGroupHomeByNodeIdArgs = {
  input: DeleteGroupHomeByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLimesurveyTokenArgs = {
  input: DeleteLimesurveyTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLimesurveyTokenByNodeIdArgs = {
  input: DeleteLimesurveyTokenByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteLimesurveyTokenByTrialIdAndTimeOfMeasurementArgs = {
  input: DeleteLimesurveyTokenByTrialIdAndTimeOfMeasurementInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMembershipArgs = {
  input: DeleteMembershipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMembershipByGroupIdAndSubgroupIdArgs = {
  input: DeleteMembershipByGroupIdAndSubgroupIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMembershipByGroupIdAndUserIdArgs = {
  input: DeleteMembershipByGroupIdAndUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMembershipByNodeIdArgs = {
  input: DeleteMembershipByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMembershipInvitationArgs = {
  input: DeleteMembershipInvitationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMembershipInvitationByNodeIdArgs = {
  input: DeleteMembershipInvitationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMembershipInvitationConfirmationArgs = {
  input: DeleteMembershipInvitationConfirmationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteMembershipInvitationConfirmationByNodeIdArgs = {
  input: DeleteMembershipInvitationConfirmationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePostWaitRandomizationTicketArgs = {
  input: DeletePostWaitRandomizationTicketInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePostWaitRandomizationTicketByNodeIdArgs = {
  input: DeletePostWaitRandomizationTicketByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePostWaitRandomizationTicketByTrialIdArgs = {
  input: DeletePostWaitRandomizationTicketByTrialIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePostingArgs = {
  input: DeletePostingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePostingByNodeIdArgs = {
  input: DeletePostingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePostingReceiptArgs = {
  input: DeletePostingReceiptInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeletePostingReceiptByNodeIdArgs = {
  input: DeletePostingReceiptByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRandomizationTicketArgs = {
  input: DeleteRandomizationTicketInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRandomizationTicketByNodeIdArgs = {
  input: DeleteRandomizationTicketByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRandomizationTicketByTrialIdArgs = {
  input: DeleteRandomizationTicketByTrialIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRawUsageDatumArgs = {
  input: DeleteRawUsageDatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteRawUsageDatumByNodeIdArgs = {
  input: DeleteRawUsageDatumByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTenantArgs = {
  input: DeleteTenantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTenantByNameArgs = {
  input: DeleteTenantByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTenantByNodeIdArgs = {
  input: DeleteTenantByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTenantByUrlArgs = {
  input: DeleteTenantByUrlInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTrialArgs = {
  input: DeleteTrialInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTrialByHumanReadableIdArgs = {
  input: DeleteTrialByHumanReadableIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTrialByNameArgs = {
  input: DeleteTrialByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteTrialByNodeIdArgs = {
  input: DeleteTrialByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserByCredentialsIdArgs = {
  input: DeleteUserByCredentialsIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserByEmailAddressIdArgs = {
  input: DeleteUserByEmailAddressIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserByIdAndTenantIdArgs = {
  input: DeleteUserByIdAndTenantIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserByNodeIdArgs = {
  input: DeleteUserByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserByUsernameAndTenantIdArgs = {
  input: DeleteUserByUsernameAndTenantIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserCredentialArgs = {
  input: DeleteUserCredentialInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserCredentialByExternalAuthIdAndTenantIdArgs = {
  input: DeleteUserCredentialByExternalAuthIdAndTenantIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserCredentialByNodeIdArgs = {
  input: DeleteUserCredentialByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserEmailAddressArgs = {
  input: DeleteUserEmailAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserEmailAddressByEmailAddressAndTenantIdArgs = {
  input: DeleteUserEmailAddressByEmailAddressAndTenantIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteUserEmailAddressByNodeIdArgs = {
  input: DeleteUserEmailAddressByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateGravatarHashFromEmailArgs = {
  input: GenerateGravatarHashFromEmailInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateSamplingPlanArgs = {
  input: GenerateSamplingPlanInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateSamplingPlan2Args = {
  input: GenerateSamplingPlan2Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateSamplingPlan3Args = {
  input: GenerateSamplingPlan3Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMarkPostingsAsReceivedArgs = {
  input: MarkPostingsAsReceivedInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnCreatePostingReceiptArgs = {
  input: MnCreatePostingReceiptInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnDeletePostingReceiptArgs = {
  input: MnDeletePostingReceiptInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationMnUpdatePostingReceiptArgs = {
  input: MnUpdatePostingReceiptInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPullEmaEntries2Args = {
  input: PullEmaEntries2Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationPushEmaEntryArgs = {
  input: PushEmaEntryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetAvatarArgs = {
  input: SetAvatarInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetEmergencyPhoneNumbersArgs = {
  input: SetEmergencyPhoneNumbersInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetNicknameArgs = {
  input: SetNicknameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSignInArgs = {
  input: SignInInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSignUpWithAccessTokenArgs = {
  input: SignUpWithAccessTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationToggleFavoriteOfRouteArgs = {
  input: ToggleFavoriteOfRouteInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCommentableArgs = {
  input: UpdateCommentableInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateCommentableByNodeIdArgs = {
  input: UpdateCommentableByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateConversationArgs = {
  input: UpdateConversationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateConversationByNodeIdArgs = {
  input: UpdateConversationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmaEntries2Args = {
  input: UpdateEmaEntries2Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmaEntries2ByNodeIdArgs = {
  input: UpdateEmaEntries2ByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmaEntries3Args = {
  input: UpdateEmaEntries3Input;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmaEntries3ByNodeIdArgs = {
  input: UpdateEmaEntries3ByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmaEntryArgs = {
  input: UpdateEmaEntryInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateEmaEntryByNodeIdArgs = {
  input: UpdateEmaEntryByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFavoritePageArgs = {
  input: UpdateFavoritePageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateFavoritePageByNodeIdArgs = {
  input: UpdateFavoritePageByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGenericEmiExerciseArgs = {
  input: UpdateGenericEmiExerciseInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGenericEmiExerciseByNodeIdArgs = {
  input: UpdateGenericEmiExerciseByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGenericEmiExerciseByTrialIdAndNameArgs = {
  input: UpdateGenericEmiExerciseByTrialIdAndNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGroupByNodeIdArgs = {
  input: UpdateGroupByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGroupHomeArgs = {
  input: UpdateGroupHomeInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateGroupHomeByNodeIdArgs = {
  input: UpdateGroupHomeByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLimesurveyTokenArgs = {
  input: UpdateLimesurveyTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLimesurveyTokenByNodeIdArgs = {
  input: UpdateLimesurveyTokenByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateLimesurveyTokenByTrialIdAndTimeOfMeasurementArgs = {
  input: UpdateLimesurveyTokenByTrialIdAndTimeOfMeasurementInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMembershipArgs = {
  input: UpdateMembershipInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMembershipByGroupIdAndSubgroupIdArgs = {
  input: UpdateMembershipByGroupIdAndSubgroupIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMembershipByGroupIdAndUserIdArgs = {
  input: UpdateMembershipByGroupIdAndUserIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMembershipByNodeIdArgs = {
  input: UpdateMembershipByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMembershipInvitationArgs = {
  input: UpdateMembershipInvitationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMembershipInvitationByNodeIdArgs = {
  input: UpdateMembershipInvitationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMembershipInvitationConfirmationArgs = {
  input: UpdateMembershipInvitationConfirmationInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateMembershipInvitationConfirmationByNodeIdArgs = {
  input: UpdateMembershipInvitationConfirmationByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePostWaitRandomizationTicketArgs = {
  input: UpdatePostWaitRandomizationTicketInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePostWaitRandomizationTicketByNodeIdArgs = {
  input: UpdatePostWaitRandomizationTicketByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePostWaitRandomizationTicketByTrialIdArgs = {
  input: UpdatePostWaitRandomizationTicketByTrialIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePostingArgs = {
  input: UpdatePostingInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePostingByNodeIdArgs = {
  input: UpdatePostingByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePostingReceiptArgs = {
  input: UpdatePostingReceiptInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdatePostingReceiptByNodeIdArgs = {
  input: UpdatePostingReceiptByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRandomizationTicketArgs = {
  input: UpdateRandomizationTicketInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRandomizationTicketByNodeIdArgs = {
  input: UpdateRandomizationTicketByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRandomizationTicketByTrialIdArgs = {
  input: UpdateRandomizationTicketByTrialIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRawUsageDatumArgs = {
  input: UpdateRawUsageDatumInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateRawUsageDatumByNodeIdArgs = {
  input: UpdateRawUsageDatumByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTenantArgs = {
  input: UpdateTenantInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTenantByNameArgs = {
  input: UpdateTenantByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTenantByNodeIdArgs = {
  input: UpdateTenantByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTenantByUrlArgs = {
  input: UpdateTenantByUrlInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTrialArgs = {
  input: UpdateTrialInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTrialByHumanReadableIdArgs = {
  input: UpdateTrialByHumanReadableIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTrialByNameArgs = {
  input: UpdateTrialByNameInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateTrialByNodeIdArgs = {
  input: UpdateTrialByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserByCredentialsIdArgs = {
  input: UpdateUserByCredentialsIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserByEmailAddressIdArgs = {
  input: UpdateUserByEmailAddressIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserByIdAndTenantIdArgs = {
  input: UpdateUserByIdAndTenantIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserByNodeIdArgs = {
  input: UpdateUserByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserByUsernameAndTenantIdArgs = {
  input: UpdateUserByUsernameAndTenantIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserCredentialArgs = {
  input: UpdateUserCredentialInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserCredentialByExternalAuthIdAndTenantIdArgs = {
  input: UpdateUserCredentialByExternalAuthIdAndTenantIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserCredentialByNodeIdArgs = {
  input: UpdateUserCredentialByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserEmailAddressArgs = {
  input: UpdateUserEmailAddressInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserEmailAddressByEmailAddressAndTenantIdArgs = {
  input: UpdateUserEmailAddressByEmailAddressAndTenantIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateUserEmailAddressByNodeIdArgs = {
  input: UpdateUserEmailAddressByNodeIdInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertCommentableArgs = {
  input: UpsertCommentableInput;
  where?: InputMaybe<UpsertCommentableWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertConversationArgs = {
  input: UpsertConversationInput;
  where?: InputMaybe<UpsertConversationWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertEmaEntries2Args = {
  input: UpsertEmaEntries2Input;
  where?: InputMaybe<UpsertEmaEntries2Where>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertEmaEntries3Args = {
  input: UpsertEmaEntries3Input;
  where?: InputMaybe<UpsertEmaEntries3Where>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertEmaEntryArgs = {
  input: UpsertEmaEntryInput;
  where?: InputMaybe<UpsertEmaEntryWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertEventArgs = {
  input: UpsertEventInput;
  where?: InputMaybe<UpsertEventWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertFavoritePageArgs = {
  input: UpsertFavoritePageInput;
  where?: InputMaybe<UpsertFavoritePageWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertGenericEmiExerciseArgs = {
  input: UpsertGenericEmiExerciseInput;
  where?: InputMaybe<UpsertGenericEmiExerciseWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertGroupArgs = {
  input: UpsertGroupInput;
  where?: InputMaybe<UpsertGroupWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertGroupHomeArgs = {
  input: UpsertGroupHomeInput;
  where?: InputMaybe<UpsertGroupHomeWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertLimesurveyTokenArgs = {
  input: UpsertLimesurveyTokenInput;
  where?: InputMaybe<UpsertLimesurveyTokenWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertMembershipArgs = {
  input: UpsertMembershipInput;
  where?: InputMaybe<UpsertMembershipWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertMembershipInvitationArgs = {
  input: UpsertMembershipInvitationInput;
  where?: InputMaybe<UpsertMembershipInvitationWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertMembershipInvitationConfirmationArgs = {
  input: UpsertMembershipInvitationConfirmationInput;
  where?: InputMaybe<UpsertMembershipInvitationConfirmationWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertPostWaitRandomizationTicketArgs = {
  input: UpsertPostWaitRandomizationTicketInput;
  where?: InputMaybe<UpsertPostWaitRandomizationTicketWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertPostingArgs = {
  input: UpsertPostingInput;
  where?: InputMaybe<UpsertPostingWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertPostingReceiptArgs = {
  input: UpsertPostingReceiptInput;
  where?: InputMaybe<UpsertPostingReceiptWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertRandomizationTicketArgs = {
  input: UpsertRandomizationTicketInput;
  where?: InputMaybe<UpsertRandomizationTicketWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertRawUsageDatumArgs = {
  input: UpsertRawUsageDatumInput;
  where?: InputMaybe<UpsertRawUsageDatumWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertTenantArgs = {
  input: UpsertTenantInput;
  where?: InputMaybe<UpsertTenantWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertTrialArgs = {
  input: UpsertTrialInput;
  where?: InputMaybe<UpsertTrialWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertUserArgs = {
  input: UpsertUserInput;
  where?: InputMaybe<UpsertUserWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertUserCredentialArgs = {
  input: UpsertUserCredentialInput;
  where?: InputMaybe<UpsertUserCredentialWhere>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpsertUserEmailAddressArgs = {
  input: UpsertUserEmailAddressInput;
  where?: InputMaybe<UpsertUserEmailAddressWhere>;
};

/** An object with a globally unique `ID`. */
export type Node = {
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
};

export type PageHit = {
  __typename?: 'PageHit';
  duration?: Maybe<Interval>;
  nthVisit?: Maybe<Scalars['BigInt']>;
  path?: Maybe<Scalars['String']>;
  queryParameters?: Maybe<Scalars['JSON']>;
  route?: Maybe<Scalars['String']>;
  trackedAt?: Maybe<Scalars['Datetime']>;
  /** Reads a single `Trial` that is related to this `PageHit`. */
  trial?: Maybe<Trial>;
  trialId?: Maybe<Scalars['UUID']>;
};

export type PageHitAggregates = {
  __typename?: 'PageHitAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PageHitAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PageHitDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PageHitMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PageHitMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PageHitStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PageHitStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PageHitSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PageHitVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PageHitVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `PageHit` object types. */
export type PageHitAggregatesFilter = {
  /** Mean average aggregate over matching `PageHit` objects. */
  average?: InputMaybe<PageHitAverageAggregateFilter>;
  /** Distinct count aggregate over matching `PageHit` objects. */
  distinctCount?: InputMaybe<PageHitDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `PageHit` object to be included within the aggregate. */
  filter?: InputMaybe<PageHitFilter>;
  /** Maximum aggregate over matching `PageHit` objects. */
  max?: InputMaybe<PageHitMaxAggregateFilter>;
  /** Minimum aggregate over matching `PageHit` objects. */
  min?: InputMaybe<PageHitMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `PageHit` objects. */
  stddevPopulation?: InputMaybe<PageHitStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `PageHit` objects. */
  stddevSample?: InputMaybe<PageHitStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `PageHit` objects. */
  sum?: InputMaybe<PageHitSumAggregateFilter>;
  /** Population variance aggregate over matching `PageHit` objects. */
  variancePopulation?: InputMaybe<PageHitVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `PageHit` objects. */
  varianceSample?: InputMaybe<PageHitVarianceSampleAggregateFilter>;
};

export type PageHitAverageAggregateFilter = {
  nthVisit?: InputMaybe<BigFloatFilter>;
};

export type PageHitAverageAggregates = {
  __typename?: 'PageHitAverageAggregates';
  /** Mean average of nthVisit across the matching connection */
  nthVisit?: Maybe<Scalars['BigFloat']>;
};

/** A condition to be used against `PageHit` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PageHitCondition = {
  /** Checks for equality with the object’s `duration` field. */
  duration?: InputMaybe<IntervalInput>;
  /** Checks for equality with the object’s `nthVisit` field. */
  nthVisit?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `path` field. */
  path?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `queryParameters` field. */
  queryParameters?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `route` field. */
  route?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `trackedAt` field. */
  trackedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `trialId` field. */
  trialId?: InputMaybe<Scalars['UUID']>;
};

export type PageHitDistinctCountAggregateFilter = {
  duration?: InputMaybe<BigIntFilter>;
  nthVisit?: InputMaybe<BigIntFilter>;
  path?: InputMaybe<BigIntFilter>;
  queryParameters?: InputMaybe<BigIntFilter>;
  route?: InputMaybe<BigIntFilter>;
  trackedAt?: InputMaybe<BigIntFilter>;
  trialId?: InputMaybe<BigIntFilter>;
};

export type PageHitDistinctCountAggregates = {
  __typename?: 'PageHitDistinctCountAggregates';
  /** Distinct count of duration across the matching connection */
  duration?: Maybe<Scalars['BigInt']>;
  /** Distinct count of nthVisit across the matching connection */
  nthVisit?: Maybe<Scalars['BigInt']>;
  /** Distinct count of path across the matching connection */
  path?: Maybe<Scalars['BigInt']>;
  /** Distinct count of queryParameters across the matching connection */
  queryParameters?: Maybe<Scalars['BigInt']>;
  /** Distinct count of route across the matching connection */
  route?: Maybe<Scalars['BigInt']>;
  /** Distinct count of trackedAt across the matching connection */
  trackedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of trialId across the matching connection */
  trialId?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `PageHit` object types. All fields are combined with a logical ‘and.’ */
export type PageHitFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PageHitFilter>>;
  /** Filter by the object’s `duration` field. */
  duration?: InputMaybe<IntervalFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PageHitFilter>;
  /** Filter by the object’s `nthVisit` field. */
  nthVisit?: InputMaybe<BigIntFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PageHitFilter>>;
  /** Filter by the object’s `path` field. */
  path?: InputMaybe<StringFilter>;
  /** Filter by the object’s `queryParameters` field. */
  queryParameters?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `route` field. */
  route?: InputMaybe<StringFilter>;
  /** Filter by the object’s `trackedAt` field. */
  trackedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `trial` relation. */
  trial?: InputMaybe<TrialFilter>;
  /** A related `trial` exists. */
  trialExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `trialId` field. */
  trialId?: InputMaybe<UuidFilter>;
};

export type PageHitMaxAggregateFilter = {
  nthVisit?: InputMaybe<BigIntFilter>;
};

export type PageHitMaxAggregates = {
  __typename?: 'PageHitMaxAggregates';
  /** Maximum of nthVisit across the matching connection */
  nthVisit?: Maybe<Scalars['BigInt']>;
};

export type PageHitMinAggregateFilter = {
  nthVisit?: InputMaybe<BigIntFilter>;
};

export type PageHitMinAggregates = {
  __typename?: 'PageHitMinAggregates';
  /** Minimum of nthVisit across the matching connection */
  nthVisit?: Maybe<Scalars['BigInt']>;
};

export type PageHitStddevPopulationAggregateFilter = {
  nthVisit?: InputMaybe<BigFloatFilter>;
};

export type PageHitStddevPopulationAggregates = {
  __typename?: 'PageHitStddevPopulationAggregates';
  /** Population standard deviation of nthVisit across the matching connection */
  nthVisit?: Maybe<Scalars['BigFloat']>;
};

export type PageHitStddevSampleAggregateFilter = {
  nthVisit?: InputMaybe<BigFloatFilter>;
};

export type PageHitStddevSampleAggregates = {
  __typename?: 'PageHitStddevSampleAggregates';
  /** Sample standard deviation of nthVisit across the matching connection */
  nthVisit?: Maybe<Scalars['BigFloat']>;
};

export type PageHitSumAggregateFilter = {
  nthVisit?: InputMaybe<BigFloatFilter>;
};

export type PageHitSumAggregates = {
  __typename?: 'PageHitSumAggregates';
  /** Sum of nthVisit across the matching connection */
  nthVisit: Scalars['BigFloat'];
};

export type PageHitVariancePopulationAggregateFilter = {
  nthVisit?: InputMaybe<BigFloatFilter>;
};

export type PageHitVariancePopulationAggregates = {
  __typename?: 'PageHitVariancePopulationAggregates';
  /** Population variance of nthVisit across the matching connection */
  nthVisit?: Maybe<Scalars['BigFloat']>;
};

export type PageHitVarianceSampleAggregateFilter = {
  nthVisit?: InputMaybe<BigFloatFilter>;
};

export type PageHitVarianceSampleAggregates = {
  __typename?: 'PageHitVarianceSampleAggregates';
  /** Sample variance of nthVisit across the matching connection */
  nthVisit?: Maybe<Scalars['BigFloat']>;
};

/** A connection to a list of `PageHit` values. */
export type PageHitsConnection = {
  __typename?: 'PageHitsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PageHitAggregates>;
  /** A list of edges which contains the `PageHit` and cursor to aid in pagination. */
  edges: Array<PageHitsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PageHitAggregates>>;
  /** A list of `PageHit` objects. */
  nodes: Array<PageHit>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PageHit` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `PageHit` values. */
export type PageHitsConnectionGroupedAggregatesArgs = {
  groupBy: Array<PageHitsGroupBy>;
  having?: InputMaybe<PageHitsHavingInput>;
};

/** A `PageHit` edge in the connection. */
export type PageHitsEdge = {
  __typename?: 'PageHitsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PageHit` at the end of the edge. */
  node: PageHit;
};

/** Grouping methods for `PageHit` for usage during aggregation. */
export type PageHitsGroupBy =
  | 'DURATION'
  | 'NTH_VISIT'
  | 'PATH'
  | 'QUERY_PARAMETERS'
  | 'ROUTE'
  | 'TRACKED_AT'
  | 'TRACKED_AT_TRUNCATED_TO_DAY'
  | 'TRACKED_AT_TRUNCATED_TO_HOUR'
  | 'TRIAL_ID';

export type PageHitsHavingAverageInput = {
  nthVisit?: InputMaybe<HavingBigintFilter>;
  trackedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PageHitsHavingDistinctCountInput = {
  nthVisit?: InputMaybe<HavingBigintFilter>;
  trackedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `PageHit` aggregates. */
export type PageHitsHavingInput = {
  AND?: InputMaybe<Array<PageHitsHavingInput>>;
  OR?: InputMaybe<Array<PageHitsHavingInput>>;
  average?: InputMaybe<PageHitsHavingAverageInput>;
  distinctCount?: InputMaybe<PageHitsHavingDistinctCountInput>;
  max?: InputMaybe<PageHitsHavingMaxInput>;
  min?: InputMaybe<PageHitsHavingMinInput>;
  stddevPopulation?: InputMaybe<PageHitsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PageHitsHavingStddevSampleInput>;
  sum?: InputMaybe<PageHitsHavingSumInput>;
  variancePopulation?: InputMaybe<PageHitsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PageHitsHavingVarianceSampleInput>;
};

export type PageHitsHavingMaxInput = {
  nthVisit?: InputMaybe<HavingBigintFilter>;
  trackedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PageHitsHavingMinInput = {
  nthVisit?: InputMaybe<HavingBigintFilter>;
  trackedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PageHitsHavingStddevPopulationInput = {
  nthVisit?: InputMaybe<HavingBigintFilter>;
  trackedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PageHitsHavingStddevSampleInput = {
  nthVisit?: InputMaybe<HavingBigintFilter>;
  trackedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PageHitsHavingSumInput = {
  nthVisit?: InputMaybe<HavingBigintFilter>;
  trackedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PageHitsHavingVariancePopulationInput = {
  nthVisit?: InputMaybe<HavingBigintFilter>;
  trackedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PageHitsHavingVarianceSampleInput = {
  nthVisit?: InputMaybe<HavingBigintFilter>;
  trackedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `PageHit`. */
export type PageHitsOrderBy =
  | 'DURATION_ASC'
  | 'DURATION_DESC'
  | 'NATURAL'
  | 'NTH_VISIT_ASC'
  | 'NTH_VISIT_DESC'
  | 'PATH_ASC'
  | 'PATH_DESC'
  | 'QUERY_PARAMETERS_ASC'
  | 'QUERY_PARAMETERS_DESC'
  | 'ROUTE_ASC'
  | 'ROUTE_DESC'
  | 'TRACKED_AT_ASC'
  | 'TRACKED_AT_DESC'
  | 'TRIAL_ID_ASC'
  | 'TRIAL_ID_DESC';

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']>;
};

export type PostWaitRandomizationTicket = Node & {
  __typename?: 'PostWaitRandomizationTicket';
  blockNumber: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  handedOutAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  stratum: Scalars['String'];
  treatment: Scalars['String'];
  /** Reads a single `Trial` that is related to this `PostWaitRandomizationTicket`. */
  trial?: Maybe<Trial>;
  trialId?: Maybe<Scalars['UUID']>;
};

export type PostWaitRandomizationTicketAggregates = {
  __typename?: 'PostWaitRandomizationTicketAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<PostWaitRandomizationTicketAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PostWaitRandomizationTicketDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<PostWaitRandomizationTicketMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<PostWaitRandomizationTicketMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<PostWaitRandomizationTicketStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<PostWaitRandomizationTicketStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<PostWaitRandomizationTicketSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<PostWaitRandomizationTicketVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<PostWaitRandomizationTicketVarianceSampleAggregates>;
};

export type PostWaitRandomizationTicketAverageAggregates = {
  __typename?: 'PostWaitRandomizationTicketAverageAggregates';
  /** Mean average of blockNumber across the matching connection */
  blockNumber?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `PostWaitRandomizationTicket` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type PostWaitRandomizationTicketCondition = {
  /** Checks for equality with the object’s `blockNumber` field. */
  blockNumber?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `handedOutAt` field. */
  handedOutAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `stratum` field. */
  stratum?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `treatment` field. */
  treatment?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `trialId` field. */
  trialId?: InputMaybe<Scalars['UUID']>;
};

export type PostWaitRandomizationTicketDistinctCountAggregates = {
  __typename?: 'PostWaitRandomizationTicketDistinctCountAggregates';
  /** Distinct count of blockNumber across the matching connection */
  blockNumber?: Maybe<Scalars['BigInt']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of handedOutAt across the matching connection */
  handedOutAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']>;
  /** Distinct count of stratum across the matching connection */
  stratum?: Maybe<Scalars['BigInt']>;
  /** Distinct count of treatment across the matching connection */
  treatment?: Maybe<Scalars['BigInt']>;
  /** Distinct count of trialId across the matching connection */
  trialId?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `PostWaitRandomizationTicket` object types. All fields are combined with a logical ‘and.’ */
export type PostWaitRandomizationTicketFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PostWaitRandomizationTicketFilter>>;
  /** Filter by the object’s `blockNumber` field. */
  blockNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `handedOutAt` field. */
  handedOutAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PostWaitRandomizationTicketFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PostWaitRandomizationTicketFilter>>;
  /** Filter by the object’s `stratum` field. */
  stratum?: InputMaybe<StringFilter>;
  /** Filter by the object’s `treatment` field. */
  treatment?: InputMaybe<StringFilter>;
  /** Filter by the object’s `trial` relation. */
  trial?: InputMaybe<TrialFilter>;
  /** A related `trial` exists. */
  trialExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `trialId` field. */
  trialId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `PostWaitRandomizationTicket` */
export type PostWaitRandomizationTicketInput = {
  blockNumber: Scalars['Int'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  handedOutAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  stratum: Scalars['String'];
  treatment: Scalars['String'];
  trialId?: InputMaybe<Scalars['UUID']>;
};

export type PostWaitRandomizationTicketMaxAggregates = {
  __typename?: 'PostWaitRandomizationTicketMaxAggregates';
  /** Maximum of blockNumber across the matching connection */
  blockNumber?: Maybe<Scalars['Int']>;
};

export type PostWaitRandomizationTicketMinAggregates = {
  __typename?: 'PostWaitRandomizationTicketMinAggregates';
  /** Minimum of blockNumber across the matching connection */
  blockNumber?: Maybe<Scalars['Int']>;
};

/** Represents an update to a `PostWaitRandomizationTicket`. Fields that are set will be updated. */
export type PostWaitRandomizationTicketPatch = {
  blockNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  handedOutAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  stratum?: InputMaybe<Scalars['String']>;
  treatment?: InputMaybe<Scalars['String']>;
  trialId?: InputMaybe<Scalars['UUID']>;
};

export type PostWaitRandomizationTicketStddevPopulationAggregates = {
  __typename?: 'PostWaitRandomizationTicketStddevPopulationAggregates';
  /** Population standard deviation of blockNumber across the matching connection */
  blockNumber?: Maybe<Scalars['BigFloat']>;
};

export type PostWaitRandomizationTicketStddevSampleAggregates = {
  __typename?: 'PostWaitRandomizationTicketStddevSampleAggregates';
  /** Sample standard deviation of blockNumber across the matching connection */
  blockNumber?: Maybe<Scalars['BigFloat']>;
};

export type PostWaitRandomizationTicketSumAggregates = {
  __typename?: 'PostWaitRandomizationTicketSumAggregates';
  /** Sum of blockNumber across the matching connection */
  blockNumber: Scalars['BigInt'];
};

export type PostWaitRandomizationTicketVariancePopulationAggregates = {
  __typename?: 'PostWaitRandomizationTicketVariancePopulationAggregates';
  /** Population variance of blockNumber across the matching connection */
  blockNumber?: Maybe<Scalars['BigFloat']>;
};

export type PostWaitRandomizationTicketVarianceSampleAggregates = {
  __typename?: 'PostWaitRandomizationTicketVarianceSampleAggregates';
  /** Sample variance of blockNumber across the matching connection */
  blockNumber?: Maybe<Scalars['BigFloat']>;
};

/** A connection to a list of `PostWaitRandomizationTicket` values. */
export type PostWaitRandomizationTicketsConnection = {
  __typename?: 'PostWaitRandomizationTicketsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PostWaitRandomizationTicketAggregates>;
  /** A list of edges which contains the `PostWaitRandomizationTicket` and cursor to aid in pagination. */
  edges: Array<PostWaitRandomizationTicketsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PostWaitRandomizationTicketAggregates>>;
  /** A list of `PostWaitRandomizationTicket` objects. */
  nodes: Array<PostWaitRandomizationTicket>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PostWaitRandomizationTicket` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `PostWaitRandomizationTicket` values. */
export type PostWaitRandomizationTicketsConnectionGroupedAggregatesArgs = {
  groupBy: Array<PostWaitRandomizationTicketsGroupBy>;
  having?: InputMaybe<PostWaitRandomizationTicketsHavingInput>;
};

/** A `PostWaitRandomizationTicket` edge in the connection. */
export type PostWaitRandomizationTicketsEdge = {
  __typename?: 'PostWaitRandomizationTicketsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PostWaitRandomizationTicket` at the end of the edge. */
  node: PostWaitRandomizationTicket;
};

/** Grouping methods for `PostWaitRandomizationTicket` for usage during aggregation. */
export type PostWaitRandomizationTicketsGroupBy =
  | 'BLOCK_NUMBER'
  | 'CREATED_AT'
  | 'CREATED_AT_TRUNCATED_TO_DAY'
  | 'CREATED_AT_TRUNCATED_TO_HOUR'
  | 'HANDED_OUT_AT'
  | 'HANDED_OUT_AT_TRUNCATED_TO_DAY'
  | 'HANDED_OUT_AT_TRUNCATED_TO_HOUR'
  | 'STRATUM'
  | 'TREATMENT';

export type PostWaitRandomizationTicketsHavingAverageInput = {
  blockNumber?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PostWaitRandomizationTicketsHavingDistinctCountInput = {
  blockNumber?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `PostWaitRandomizationTicket` aggregates. */
export type PostWaitRandomizationTicketsHavingInput = {
  AND?: InputMaybe<Array<PostWaitRandomizationTicketsHavingInput>>;
  OR?: InputMaybe<Array<PostWaitRandomizationTicketsHavingInput>>;
  average?: InputMaybe<PostWaitRandomizationTicketsHavingAverageInput>;
  distinctCount?: InputMaybe<PostWaitRandomizationTicketsHavingDistinctCountInput>;
  max?: InputMaybe<PostWaitRandomizationTicketsHavingMaxInput>;
  min?: InputMaybe<PostWaitRandomizationTicketsHavingMinInput>;
  stddevPopulation?: InputMaybe<PostWaitRandomizationTicketsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PostWaitRandomizationTicketsHavingStddevSampleInput>;
  sum?: InputMaybe<PostWaitRandomizationTicketsHavingSumInput>;
  variancePopulation?: InputMaybe<PostWaitRandomizationTicketsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PostWaitRandomizationTicketsHavingVarianceSampleInput>;
};

export type PostWaitRandomizationTicketsHavingMaxInput = {
  blockNumber?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PostWaitRandomizationTicketsHavingMinInput = {
  blockNumber?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PostWaitRandomizationTicketsHavingStddevPopulationInput = {
  blockNumber?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PostWaitRandomizationTicketsHavingStddevSampleInput = {
  blockNumber?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PostWaitRandomizationTicketsHavingSumInput = {
  blockNumber?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PostWaitRandomizationTicketsHavingVariancePopulationInput = {
  blockNumber?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PostWaitRandomizationTicketsHavingVarianceSampleInput = {
  blockNumber?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `PostWaitRandomizationTicket`. */
export type PostWaitRandomizationTicketsOrderBy =
  | 'BLOCK_NUMBER_ASC'
  | 'BLOCK_NUMBER_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'HANDED_OUT_AT_ASC'
  | 'HANDED_OUT_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'STRATUM_ASC'
  | 'STRATUM_DESC'
  | 'TREATMENT_ASC'
  | 'TREATMENT_DESC'
  | 'TRIAL_ID_ASC'
  | 'TRIAL_ID_DESC';

export type Posting = Node & {
  __typename?: 'Posting';
  /** Reads a single `Commentable` that is related to this `Posting`. */
  aboutCommentable?: Maybe<Commentable>;
  aboutCommentableId?: Maybe<Scalars['UUID']>;
  /** Reads a single `Posting` that is related to this `Posting`. */
  answeredPosting?: Maybe<Posting>;
  answeredPostingId?: Maybe<Scalars['UUID']>;
  answeredPostingWasDeleted?: Maybe<Scalars['Boolean']>;
  /** Reads and enables pagination through a set of `Posting`. */
  answers: PostingsConnection;
  body: Scalars['String'];
  /** Reads a single `Conversation` that is related to this `Posting`. */
  conversation?: Maybe<Conversation>;
  conversationId: Scalars['UUID'];
  createdAt: Scalars['Datetime'];
  fulltext?: Maybe<Scalars['String']>;
  hashtags?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['UUID'];
  isUnread?: Maybe<Scalars['Boolean']>;
  language: Scalars['String'];
  mentionedUsernames?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Reads and enables pagination through a set of `User`. */
  mentionedUsers: UsersConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PostingReceipt`. */
  receipts: PostingReceiptsConnection;
  /** Reads a single `User` that is related to this `Posting`. */
  sender?: Maybe<User>;
  senderId?: Maybe<Scalars['UUID']>;
  subject?: Maybe<Scalars['String']>;
  submittedAt?: Maybe<Scalars['Datetime']>;
  updatedAt: Scalars['Datetime'];
};


export type PostingAnswersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PostingCondition>;
  filter?: InputMaybe<PostingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PostingsOrderBy>>;
};


export type PostingMentionedUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PostingReceiptsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PostingReceiptCondition>;
  filter?: InputMaybe<PostingReceiptFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PostingReceiptsOrderBy>>;
};

export type PostingAggregates = {
  __typename?: 'PostingAggregates';
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PostingDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
};

/** A filter to be used against aggregates of `Posting` object types. */
export type PostingAggregatesFilter = {
  /** Distinct count aggregate over matching `Posting` objects. */
  distinctCount?: InputMaybe<PostingDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Posting` object to be included within the aggregate. */
  filter?: InputMaybe<PostingFilter>;
};

/** A condition to be used against `Posting` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type PostingCondition = {
  /** Checks for equality with the object’s `aboutCommentableId` field. */
  aboutCommentableId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `answeredPostingId` field. */
  answeredPostingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `answeredPostingWasDeleted` field. */
  answeredPostingWasDeleted?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `body` field. */
  body?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `conversationId` field. */
  conversationId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `fulltext` field. */
  fulltext?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `hashtags` field. */
  hashtags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isUnread` field. */
  isUnread?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `language` field. */
  language?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `mentionedUsernames` field. */
  mentionedUsernames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `senderId` field. */
  senderId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `subject` field. */
  subject?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `submittedAt` field. */
  submittedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type PostingDistinctCountAggregateFilter = {
  aboutCommentableId?: InputMaybe<BigIntFilter>;
  answeredPostingId?: InputMaybe<BigIntFilter>;
  answeredPostingWasDeleted?: InputMaybe<BigIntFilter>;
  body?: InputMaybe<BigIntFilter>;
  conversationId?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  hashtags?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  isUnread?: InputMaybe<BooleanFilter>;
  language?: InputMaybe<BigIntFilter>;
  mentionedUsernames?: InputMaybe<BigIntFilter>;
  senderId?: InputMaybe<BigIntFilter>;
  subject?: InputMaybe<BigIntFilter>;
  submittedAt?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type PostingDistinctCountAggregates = {
  __typename?: 'PostingDistinctCountAggregates';
  /** Distinct count of aboutCommentableId across the matching connection */
  aboutCommentableId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of answeredPostingId across the matching connection */
  answeredPostingId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of answeredPostingWasDeleted across the matching connection */
  answeredPostingWasDeleted?: Maybe<Scalars['BigInt']>;
  /** Distinct count of body across the matching connection */
  body?: Maybe<Scalars['BigInt']>;
  /** Distinct count of conversationId across the matching connection */
  conversationId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of this field across the matching connection. */
  fulltext?: Maybe<Scalars['BigInt']>;
  /** Distinct count of hashtags across the matching connection */
  hashtags?: Maybe<Scalars['BigInt']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']>;
  /** Distinct count of this field across the matching connection. */
  isUnread?: Maybe<Scalars['BigInt']>;
  /** Distinct count of language across the matching connection */
  language?: Maybe<Scalars['BigInt']>;
  /** Distinct count of mentionedUsernames across the matching connection */
  mentionedUsernames?: Maybe<Scalars['BigInt']>;
  /** Distinct count of senderId across the matching connection */
  senderId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of subject across the matching connection */
  subject?: Maybe<Scalars['BigInt']>;
  /** Distinct count of submittedAt across the matching connection */
  submittedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `Posting` object types. All fields are combined with a logical ‘and.’ */
export type PostingFilter = {
  /** Filter by the object’s `aboutCommentable` relation. */
  aboutCommentable?: InputMaybe<CommentableFilter>;
  /** A related `aboutCommentable` exists. */
  aboutCommentableExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `aboutCommentableId` field. */
  aboutCommentableId?: InputMaybe<UuidFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PostingFilter>>;
  /** Filter by the object’s `answeredPosting` relation. */
  answeredPosting?: InputMaybe<PostingFilter>;
  /** A related `answeredPosting` exists. */
  answeredPostingExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `answeredPostingId` field. */
  answeredPostingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `answeredPostingWasDeleted` field. */
  answeredPostingWasDeleted?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `answers` relation. */
  answers?: InputMaybe<PostingToManyPostingFilter>;
  /** Some related `answers` exist. */
  answersExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `body` field. */
  body?: InputMaybe<StringFilter>;
  /** Filter by the object’s `conversation` relation. */
  conversation?: InputMaybe<ConversationFilter>;
  /** Filter by the object’s `conversationId` field. */
  conversationId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `hashtags` field. */
  hashtags?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isUnread` field. */
  isUnread?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `language` field. */
  language?: InputMaybe<StringFilter>;
  /** Filter by the object’s `mentionedUsernames` field. */
  mentionedUsernames?: InputMaybe<StringListFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PostingFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PostingFilter>>;
  /** Filter by the object’s `receipts` relation. */
  receipts?: InputMaybe<PostingToManyPostingReceiptFilter>;
  /** Some related `receipts` exist. */
  receiptsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `sender` relation. */
  sender?: InputMaybe<UserFilter>;
  /** A related `sender` exists. */
  senderExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `senderId` field. */
  senderId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `subject` field. */
  subject?: InputMaybe<StringFilter>;
  /** Filter by the object’s `submittedAt` field. */
  submittedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Posting` */
export type PostingInput = {
  aboutCommentableId?: InputMaybe<Scalars['UUID']>;
  answeredPostingId?: InputMaybe<Scalars['UUID']>;
  answeredPostingWasDeleted?: InputMaybe<Scalars['Boolean']>;
  body: Scalars['String'];
  conversationId: Scalars['UUID'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  hashtags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  language?: InputMaybe<Scalars['String']>;
  mentionedUsernames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  senderId?: InputMaybe<Scalars['UUID']>;
  subject?: InputMaybe<Scalars['String']>;
  submittedAt?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `Posting`. Fields that are set will be updated. */
export type PostingPatch = {
  aboutCommentableId?: InputMaybe<Scalars['UUID']>;
  answeredPostingId?: InputMaybe<Scalars['UUID']>;
  answeredPostingWasDeleted?: InputMaybe<Scalars['Boolean']>;
  body?: InputMaybe<Scalars['String']>;
  conversationId?: InputMaybe<Scalars['UUID']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  hashtags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  id?: InputMaybe<Scalars['UUID']>;
  language?: InputMaybe<Scalars['String']>;
  mentionedUsernames?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  senderId?: InputMaybe<Scalars['UUID']>;
  subject?: InputMaybe<Scalars['String']>;
  submittedAt?: InputMaybe<Scalars['Datetime']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type PostingReceipt = Node & {
  __typename?: 'PostingReceipt';
  manuallyConfirmedAt?: Maybe<Scalars['Datetime']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Posting` that is related to this `PostingReceipt`. */
  posting?: Maybe<Posting>;
  postingId: Scalars['UUID'];
  receivedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `PostingReceipt`. */
  user?: Maybe<User>;
  userId: Scalars['UUID'];
  viewedAt?: Maybe<Scalars['Datetime']>;
};

export type PostingReceiptAggregates = {
  __typename?: 'PostingReceiptAggregates';
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<PostingReceiptDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
};

/** A filter to be used against aggregates of `PostingReceipt` object types. */
export type PostingReceiptAggregatesFilter = {
  /** Distinct count aggregate over matching `PostingReceipt` objects. */
  distinctCount?: InputMaybe<PostingReceiptDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `PostingReceipt` object to be included within the aggregate. */
  filter?: InputMaybe<PostingReceiptFilter>;
};

/**
 * A condition to be used against `PostingReceipt` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type PostingReceiptCondition = {
  /** Checks for equality with the object’s `manuallyConfirmedAt` field. */
  manuallyConfirmedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `postingId` field. */
  postingId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `receivedAt` field. */
  receivedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `viewedAt` field. */
  viewedAt?: InputMaybe<Scalars['Datetime']>;
};

export type PostingReceiptDistinctCountAggregateFilter = {
  manuallyConfirmedAt?: InputMaybe<BigIntFilter>;
  postingId?: InputMaybe<BigIntFilter>;
  receivedAt?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
  viewedAt?: InputMaybe<BigIntFilter>;
};

export type PostingReceiptDistinctCountAggregates = {
  __typename?: 'PostingReceiptDistinctCountAggregates';
  /** Distinct count of manuallyConfirmedAt across the matching connection */
  manuallyConfirmedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of postingId across the matching connection */
  postingId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of receivedAt across the matching connection */
  receivedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of viewedAt across the matching connection */
  viewedAt?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `PostingReceipt` object types. All fields are combined with a logical ‘and.’ */
export type PostingReceiptFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<PostingReceiptFilter>>;
  /** Filter by the object’s `manuallyConfirmedAt` field. */
  manuallyConfirmedAt?: InputMaybe<DatetimeFilter>;
  /** Negates the expression. */
  not?: InputMaybe<PostingReceiptFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<PostingReceiptFilter>>;
  /** Filter by the object’s `posting` relation. */
  posting?: InputMaybe<PostingFilter>;
  /** Filter by the object’s `postingId` field. */
  postingId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `receivedAt` field. */
  receivedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `viewedAt` field. */
  viewedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `PostingReceipt` */
export type PostingReceiptInput = {
  manuallyConfirmedAt?: InputMaybe<Scalars['Datetime']>;
  postingId: Scalars['UUID'];
  receivedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['UUID']>;
  viewedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `PostingReceipt`. Fields that are set will be updated. */
export type PostingReceiptPatch = {
  manuallyConfirmedAt?: InputMaybe<Scalars['Datetime']>;
  postingId?: InputMaybe<Scalars['UUID']>;
  receivedAt?: InputMaybe<Scalars['Datetime']>;
  userId?: InputMaybe<Scalars['UUID']>;
  viewedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `PostingReceipt` values. */
export type PostingReceiptsConnection = {
  __typename?: 'PostingReceiptsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PostingReceiptAggregates>;
  /** A list of edges which contains the `PostingReceipt` and cursor to aid in pagination. */
  edges: Array<PostingReceiptsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PostingReceiptAggregates>>;
  /** A list of `PostingReceipt` objects. */
  nodes: Array<PostingReceipt>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `PostingReceipt` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `PostingReceipt` values. */
export type PostingReceiptsConnectionGroupedAggregatesArgs = {
  groupBy: Array<PostingReceiptsGroupBy>;
  having?: InputMaybe<PostingReceiptsHavingInput>;
};

/** A `PostingReceipt` edge in the connection. */
export type PostingReceiptsEdge = {
  __typename?: 'PostingReceiptsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `PostingReceipt` at the end of the edge. */
  node: PostingReceipt;
};

/** Grouping methods for `PostingReceipt` for usage during aggregation. */
export type PostingReceiptsGroupBy =
  | 'MANUALLY_CONFIRMED_AT'
  | 'MANUALLY_CONFIRMED_AT_TRUNCATED_TO_DAY'
  | 'MANUALLY_CONFIRMED_AT_TRUNCATED_TO_HOUR'
  | 'POSTING_ID'
  | 'RECEIVED_AT'
  | 'RECEIVED_AT_TRUNCATED_TO_DAY'
  | 'RECEIVED_AT_TRUNCATED_TO_HOUR'
  | 'USER_ID'
  | 'VIEWED_AT'
  | 'VIEWED_AT_TRUNCATED_TO_DAY'
  | 'VIEWED_AT_TRUNCATED_TO_HOUR';

export type PostingReceiptsHavingAverageInput = {
  manuallyConfirmedAt?: InputMaybe<HavingDatetimeFilter>;
  receivedAt?: InputMaybe<HavingDatetimeFilter>;
  viewedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PostingReceiptsHavingDistinctCountInput = {
  manuallyConfirmedAt?: InputMaybe<HavingDatetimeFilter>;
  receivedAt?: InputMaybe<HavingDatetimeFilter>;
  viewedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `PostingReceipt` aggregates. */
export type PostingReceiptsHavingInput = {
  AND?: InputMaybe<Array<PostingReceiptsHavingInput>>;
  OR?: InputMaybe<Array<PostingReceiptsHavingInput>>;
  average?: InputMaybe<PostingReceiptsHavingAverageInput>;
  distinctCount?: InputMaybe<PostingReceiptsHavingDistinctCountInput>;
  max?: InputMaybe<PostingReceiptsHavingMaxInput>;
  min?: InputMaybe<PostingReceiptsHavingMinInput>;
  stddevPopulation?: InputMaybe<PostingReceiptsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PostingReceiptsHavingStddevSampleInput>;
  sum?: InputMaybe<PostingReceiptsHavingSumInput>;
  variancePopulation?: InputMaybe<PostingReceiptsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PostingReceiptsHavingVarianceSampleInput>;
};

export type PostingReceiptsHavingMaxInput = {
  manuallyConfirmedAt?: InputMaybe<HavingDatetimeFilter>;
  receivedAt?: InputMaybe<HavingDatetimeFilter>;
  viewedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PostingReceiptsHavingMinInput = {
  manuallyConfirmedAt?: InputMaybe<HavingDatetimeFilter>;
  receivedAt?: InputMaybe<HavingDatetimeFilter>;
  viewedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PostingReceiptsHavingStddevPopulationInput = {
  manuallyConfirmedAt?: InputMaybe<HavingDatetimeFilter>;
  receivedAt?: InputMaybe<HavingDatetimeFilter>;
  viewedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PostingReceiptsHavingStddevSampleInput = {
  manuallyConfirmedAt?: InputMaybe<HavingDatetimeFilter>;
  receivedAt?: InputMaybe<HavingDatetimeFilter>;
  viewedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PostingReceiptsHavingSumInput = {
  manuallyConfirmedAt?: InputMaybe<HavingDatetimeFilter>;
  receivedAt?: InputMaybe<HavingDatetimeFilter>;
  viewedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PostingReceiptsHavingVariancePopulationInput = {
  manuallyConfirmedAt?: InputMaybe<HavingDatetimeFilter>;
  receivedAt?: InputMaybe<HavingDatetimeFilter>;
  viewedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PostingReceiptsHavingVarianceSampleInput = {
  manuallyConfirmedAt?: InputMaybe<HavingDatetimeFilter>;
  receivedAt?: InputMaybe<HavingDatetimeFilter>;
  viewedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `PostingReceipt`. */
export type PostingReceiptsOrderBy =
  | 'MANUALLY_CONFIRMED_AT_ASC'
  | 'MANUALLY_CONFIRMED_AT_DESC'
  | 'NATURAL'
  | 'POSTING_ID_ASC'
  | 'POSTING_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'RECEIVED_AT_ASC'
  | 'RECEIVED_AT_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC'
  | 'VIEWED_AT_ASC'
  | 'VIEWED_AT_DESC';

/** A filter to be used against many `Posting` object types. All fields are combined with a logical ‘and.’ */
export type PostingToManyPostingFilter = {
  /** Aggregates across related `Posting` match the filter criteria. */
  aggregates?: InputMaybe<PostingAggregatesFilter>;
  /** Every related `Posting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PostingFilter>;
  /** No related `Posting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PostingFilter>;
  /** Some related `Posting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PostingFilter>;
};

/** A filter to be used against many `PostingReceipt` object types. All fields are combined with a logical ‘and.’ */
export type PostingToManyPostingReceiptFilter = {
  /** Aggregates across related `PostingReceipt` match the filter criteria. */
  aggregates?: InputMaybe<PostingReceiptAggregatesFilter>;
  /** Every related `PostingReceipt` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PostingReceiptFilter>;
  /** No related `PostingReceipt` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PostingReceiptFilter>;
  /** Some related `PostingReceipt` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PostingReceiptFilter>;
};

/** A connection to a list of `Posting` values. */
export type PostingsConnection = {
  __typename?: 'PostingsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<PostingAggregates>;
  /** A list of edges which contains the `Posting` and cursor to aid in pagination. */
  edges: Array<PostingsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<PostingAggregates>>;
  /** A list of `Posting` objects. */
  nodes: Array<Posting>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Posting` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `Posting` values. */
export type PostingsConnectionGroupedAggregatesArgs = {
  groupBy: Array<PostingsGroupBy>;
  having?: InputMaybe<PostingsHavingInput>;
};

/** A `Posting` edge in the connection. */
export type PostingsEdge = {
  __typename?: 'PostingsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Posting` at the end of the edge. */
  node: Posting;
};

/** Grouping methods for `Posting` for usage during aggregation. */
export type PostingsGroupBy =
  | 'ABOUT_COMMENTABLE_ID'
  | 'ANSWERED_POSTING_ID'
  | 'ANSWERED_POSTING_WAS_DELETED'
  | 'BODY'
  | 'CONVERSATION_ID'
  | 'CREATED_AT'
  | 'CREATED_AT_TRUNCATED_TO_DAY'
  | 'CREATED_AT_TRUNCATED_TO_HOUR'
  | 'HASHTAGS'
  | 'LANGUAGE'
  | 'MENTIONED_USERNAMES'
  | 'SENDER_ID'
  | 'SUBJECT'
  | 'SUBMITTED_AT'
  | 'SUBMITTED_AT_TRUNCATED_TO_DAY'
  | 'SUBMITTED_AT_TRUNCATED_TO_HOUR'
  | 'UPDATED_AT'
  | 'UPDATED_AT_TRUNCATED_TO_DAY'
  | 'UPDATED_AT_TRUNCATED_TO_HOUR';

export type PostingsHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PostingsHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `Posting` aggregates. */
export type PostingsHavingInput = {
  AND?: InputMaybe<Array<PostingsHavingInput>>;
  OR?: InputMaybe<Array<PostingsHavingInput>>;
  average?: InputMaybe<PostingsHavingAverageInput>;
  distinctCount?: InputMaybe<PostingsHavingDistinctCountInput>;
  max?: InputMaybe<PostingsHavingMaxInput>;
  min?: InputMaybe<PostingsHavingMinInput>;
  stddevPopulation?: InputMaybe<PostingsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<PostingsHavingStddevSampleInput>;
  sum?: InputMaybe<PostingsHavingSumInput>;
  variancePopulation?: InputMaybe<PostingsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<PostingsHavingVarianceSampleInput>;
};

export type PostingsHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PostingsHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PostingsHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PostingsHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PostingsHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PostingsHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type PostingsHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  submittedAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `Posting`. */
export type PostingsOrderBy =
  | 'ABOUT_COMMENTABLE_ID_ASC'
  | 'ABOUT_COMMENTABLE_ID_DESC'
  | 'ANSWERED_POSTING_ID_ASC'
  | 'ANSWERED_POSTING_ID_DESC'
  | 'ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'ANSWERS_AVERAGE_ABOUT_COMMENTABLE_ID_ASC'
  | 'ANSWERS_AVERAGE_ABOUT_COMMENTABLE_ID_DESC'
  | 'ANSWERS_AVERAGE_ANSWERED_POSTING_ID_ASC'
  | 'ANSWERS_AVERAGE_ANSWERED_POSTING_ID_DESC'
  | 'ANSWERS_AVERAGE_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'ANSWERS_AVERAGE_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'ANSWERS_AVERAGE_BODY_ASC'
  | 'ANSWERS_AVERAGE_BODY_DESC'
  | 'ANSWERS_AVERAGE_CONVERSATION_ID_ASC'
  | 'ANSWERS_AVERAGE_CONVERSATION_ID_DESC'
  | 'ANSWERS_AVERAGE_CREATED_AT_ASC'
  | 'ANSWERS_AVERAGE_CREATED_AT_DESC'
  | 'ANSWERS_AVERAGE_HASHTAGS_ASC'
  | 'ANSWERS_AVERAGE_HASHTAGS_DESC'
  | 'ANSWERS_AVERAGE_ID_ASC'
  | 'ANSWERS_AVERAGE_ID_DESC'
  | 'ANSWERS_AVERAGE_LANGUAGE_ASC'
  | 'ANSWERS_AVERAGE_LANGUAGE_DESC'
  | 'ANSWERS_AVERAGE_MENTIONED_USERNAMES_ASC'
  | 'ANSWERS_AVERAGE_MENTIONED_USERNAMES_DESC'
  | 'ANSWERS_AVERAGE_SENDER_ID_ASC'
  | 'ANSWERS_AVERAGE_SENDER_ID_DESC'
  | 'ANSWERS_AVERAGE_SUBJECT_ASC'
  | 'ANSWERS_AVERAGE_SUBJECT_DESC'
  | 'ANSWERS_AVERAGE_SUBMITTED_AT_ASC'
  | 'ANSWERS_AVERAGE_SUBMITTED_AT_DESC'
  | 'ANSWERS_AVERAGE_UPDATED_AT_ASC'
  | 'ANSWERS_AVERAGE_UPDATED_AT_DESC'
  | 'ANSWERS_COUNT_ASC'
  | 'ANSWERS_COUNT_DESC'
  | 'ANSWERS_DISTINCT_COUNT_ABOUT_COMMENTABLE_ID_ASC'
  | 'ANSWERS_DISTINCT_COUNT_ABOUT_COMMENTABLE_ID_DESC'
  | 'ANSWERS_DISTINCT_COUNT_ANSWERED_POSTING_ID_ASC'
  | 'ANSWERS_DISTINCT_COUNT_ANSWERED_POSTING_ID_DESC'
  | 'ANSWERS_DISTINCT_COUNT_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'ANSWERS_DISTINCT_COUNT_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'ANSWERS_DISTINCT_COUNT_BODY_ASC'
  | 'ANSWERS_DISTINCT_COUNT_BODY_DESC'
  | 'ANSWERS_DISTINCT_COUNT_CONVERSATION_ID_ASC'
  | 'ANSWERS_DISTINCT_COUNT_CONVERSATION_ID_DESC'
  | 'ANSWERS_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'ANSWERS_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'ANSWERS_DISTINCT_COUNT_HASHTAGS_ASC'
  | 'ANSWERS_DISTINCT_COUNT_HASHTAGS_DESC'
  | 'ANSWERS_DISTINCT_COUNT_ID_ASC'
  | 'ANSWERS_DISTINCT_COUNT_ID_DESC'
  | 'ANSWERS_DISTINCT_COUNT_LANGUAGE_ASC'
  | 'ANSWERS_DISTINCT_COUNT_LANGUAGE_DESC'
  | 'ANSWERS_DISTINCT_COUNT_MENTIONED_USERNAMES_ASC'
  | 'ANSWERS_DISTINCT_COUNT_MENTIONED_USERNAMES_DESC'
  | 'ANSWERS_DISTINCT_COUNT_SENDER_ID_ASC'
  | 'ANSWERS_DISTINCT_COUNT_SENDER_ID_DESC'
  | 'ANSWERS_DISTINCT_COUNT_SUBJECT_ASC'
  | 'ANSWERS_DISTINCT_COUNT_SUBJECT_DESC'
  | 'ANSWERS_DISTINCT_COUNT_SUBMITTED_AT_ASC'
  | 'ANSWERS_DISTINCT_COUNT_SUBMITTED_AT_DESC'
  | 'ANSWERS_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'ANSWERS_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'ANSWERS_MAX_ABOUT_COMMENTABLE_ID_ASC'
  | 'ANSWERS_MAX_ABOUT_COMMENTABLE_ID_DESC'
  | 'ANSWERS_MAX_ANSWERED_POSTING_ID_ASC'
  | 'ANSWERS_MAX_ANSWERED_POSTING_ID_DESC'
  | 'ANSWERS_MAX_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'ANSWERS_MAX_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'ANSWERS_MAX_BODY_ASC'
  | 'ANSWERS_MAX_BODY_DESC'
  | 'ANSWERS_MAX_CONVERSATION_ID_ASC'
  | 'ANSWERS_MAX_CONVERSATION_ID_DESC'
  | 'ANSWERS_MAX_CREATED_AT_ASC'
  | 'ANSWERS_MAX_CREATED_AT_DESC'
  | 'ANSWERS_MAX_HASHTAGS_ASC'
  | 'ANSWERS_MAX_HASHTAGS_DESC'
  | 'ANSWERS_MAX_ID_ASC'
  | 'ANSWERS_MAX_ID_DESC'
  | 'ANSWERS_MAX_LANGUAGE_ASC'
  | 'ANSWERS_MAX_LANGUAGE_DESC'
  | 'ANSWERS_MAX_MENTIONED_USERNAMES_ASC'
  | 'ANSWERS_MAX_MENTIONED_USERNAMES_DESC'
  | 'ANSWERS_MAX_SENDER_ID_ASC'
  | 'ANSWERS_MAX_SENDER_ID_DESC'
  | 'ANSWERS_MAX_SUBJECT_ASC'
  | 'ANSWERS_MAX_SUBJECT_DESC'
  | 'ANSWERS_MAX_SUBMITTED_AT_ASC'
  | 'ANSWERS_MAX_SUBMITTED_AT_DESC'
  | 'ANSWERS_MAX_UPDATED_AT_ASC'
  | 'ANSWERS_MAX_UPDATED_AT_DESC'
  | 'ANSWERS_MIN_ABOUT_COMMENTABLE_ID_ASC'
  | 'ANSWERS_MIN_ABOUT_COMMENTABLE_ID_DESC'
  | 'ANSWERS_MIN_ANSWERED_POSTING_ID_ASC'
  | 'ANSWERS_MIN_ANSWERED_POSTING_ID_DESC'
  | 'ANSWERS_MIN_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'ANSWERS_MIN_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'ANSWERS_MIN_BODY_ASC'
  | 'ANSWERS_MIN_BODY_DESC'
  | 'ANSWERS_MIN_CONVERSATION_ID_ASC'
  | 'ANSWERS_MIN_CONVERSATION_ID_DESC'
  | 'ANSWERS_MIN_CREATED_AT_ASC'
  | 'ANSWERS_MIN_CREATED_AT_DESC'
  | 'ANSWERS_MIN_HASHTAGS_ASC'
  | 'ANSWERS_MIN_HASHTAGS_DESC'
  | 'ANSWERS_MIN_ID_ASC'
  | 'ANSWERS_MIN_ID_DESC'
  | 'ANSWERS_MIN_LANGUAGE_ASC'
  | 'ANSWERS_MIN_LANGUAGE_DESC'
  | 'ANSWERS_MIN_MENTIONED_USERNAMES_ASC'
  | 'ANSWERS_MIN_MENTIONED_USERNAMES_DESC'
  | 'ANSWERS_MIN_SENDER_ID_ASC'
  | 'ANSWERS_MIN_SENDER_ID_DESC'
  | 'ANSWERS_MIN_SUBJECT_ASC'
  | 'ANSWERS_MIN_SUBJECT_DESC'
  | 'ANSWERS_MIN_SUBMITTED_AT_ASC'
  | 'ANSWERS_MIN_SUBMITTED_AT_DESC'
  | 'ANSWERS_MIN_UPDATED_AT_ASC'
  | 'ANSWERS_MIN_UPDATED_AT_DESC'
  | 'ANSWERS_STDDEV_POPULATION_ABOUT_COMMENTABLE_ID_ASC'
  | 'ANSWERS_STDDEV_POPULATION_ABOUT_COMMENTABLE_ID_DESC'
  | 'ANSWERS_STDDEV_POPULATION_ANSWERED_POSTING_ID_ASC'
  | 'ANSWERS_STDDEV_POPULATION_ANSWERED_POSTING_ID_DESC'
  | 'ANSWERS_STDDEV_POPULATION_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'ANSWERS_STDDEV_POPULATION_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'ANSWERS_STDDEV_POPULATION_BODY_ASC'
  | 'ANSWERS_STDDEV_POPULATION_BODY_DESC'
  | 'ANSWERS_STDDEV_POPULATION_CONVERSATION_ID_ASC'
  | 'ANSWERS_STDDEV_POPULATION_CONVERSATION_ID_DESC'
  | 'ANSWERS_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'ANSWERS_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'ANSWERS_STDDEV_POPULATION_HASHTAGS_ASC'
  | 'ANSWERS_STDDEV_POPULATION_HASHTAGS_DESC'
  | 'ANSWERS_STDDEV_POPULATION_ID_ASC'
  | 'ANSWERS_STDDEV_POPULATION_ID_DESC'
  | 'ANSWERS_STDDEV_POPULATION_LANGUAGE_ASC'
  | 'ANSWERS_STDDEV_POPULATION_LANGUAGE_DESC'
  | 'ANSWERS_STDDEV_POPULATION_MENTIONED_USERNAMES_ASC'
  | 'ANSWERS_STDDEV_POPULATION_MENTIONED_USERNAMES_DESC'
  | 'ANSWERS_STDDEV_POPULATION_SENDER_ID_ASC'
  | 'ANSWERS_STDDEV_POPULATION_SENDER_ID_DESC'
  | 'ANSWERS_STDDEV_POPULATION_SUBJECT_ASC'
  | 'ANSWERS_STDDEV_POPULATION_SUBJECT_DESC'
  | 'ANSWERS_STDDEV_POPULATION_SUBMITTED_AT_ASC'
  | 'ANSWERS_STDDEV_POPULATION_SUBMITTED_AT_DESC'
  | 'ANSWERS_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'ANSWERS_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'ANSWERS_STDDEV_SAMPLE_ABOUT_COMMENTABLE_ID_ASC'
  | 'ANSWERS_STDDEV_SAMPLE_ABOUT_COMMENTABLE_ID_DESC'
  | 'ANSWERS_STDDEV_SAMPLE_ANSWERED_POSTING_ID_ASC'
  | 'ANSWERS_STDDEV_SAMPLE_ANSWERED_POSTING_ID_DESC'
  | 'ANSWERS_STDDEV_SAMPLE_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'ANSWERS_STDDEV_SAMPLE_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'ANSWERS_STDDEV_SAMPLE_BODY_ASC'
  | 'ANSWERS_STDDEV_SAMPLE_BODY_DESC'
  | 'ANSWERS_STDDEV_SAMPLE_CONVERSATION_ID_ASC'
  | 'ANSWERS_STDDEV_SAMPLE_CONVERSATION_ID_DESC'
  | 'ANSWERS_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'ANSWERS_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'ANSWERS_STDDEV_SAMPLE_HASHTAGS_ASC'
  | 'ANSWERS_STDDEV_SAMPLE_HASHTAGS_DESC'
  | 'ANSWERS_STDDEV_SAMPLE_ID_ASC'
  | 'ANSWERS_STDDEV_SAMPLE_ID_DESC'
  | 'ANSWERS_STDDEV_SAMPLE_LANGUAGE_ASC'
  | 'ANSWERS_STDDEV_SAMPLE_LANGUAGE_DESC'
  | 'ANSWERS_STDDEV_SAMPLE_MENTIONED_USERNAMES_ASC'
  | 'ANSWERS_STDDEV_SAMPLE_MENTIONED_USERNAMES_DESC'
  | 'ANSWERS_STDDEV_SAMPLE_SENDER_ID_ASC'
  | 'ANSWERS_STDDEV_SAMPLE_SENDER_ID_DESC'
  | 'ANSWERS_STDDEV_SAMPLE_SUBJECT_ASC'
  | 'ANSWERS_STDDEV_SAMPLE_SUBJECT_DESC'
  | 'ANSWERS_STDDEV_SAMPLE_SUBMITTED_AT_ASC'
  | 'ANSWERS_STDDEV_SAMPLE_SUBMITTED_AT_DESC'
  | 'ANSWERS_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'ANSWERS_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'ANSWERS_SUM_ABOUT_COMMENTABLE_ID_ASC'
  | 'ANSWERS_SUM_ABOUT_COMMENTABLE_ID_DESC'
  | 'ANSWERS_SUM_ANSWERED_POSTING_ID_ASC'
  | 'ANSWERS_SUM_ANSWERED_POSTING_ID_DESC'
  | 'ANSWERS_SUM_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'ANSWERS_SUM_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'ANSWERS_SUM_BODY_ASC'
  | 'ANSWERS_SUM_BODY_DESC'
  | 'ANSWERS_SUM_CONVERSATION_ID_ASC'
  | 'ANSWERS_SUM_CONVERSATION_ID_DESC'
  | 'ANSWERS_SUM_CREATED_AT_ASC'
  | 'ANSWERS_SUM_CREATED_AT_DESC'
  | 'ANSWERS_SUM_HASHTAGS_ASC'
  | 'ANSWERS_SUM_HASHTAGS_DESC'
  | 'ANSWERS_SUM_ID_ASC'
  | 'ANSWERS_SUM_ID_DESC'
  | 'ANSWERS_SUM_LANGUAGE_ASC'
  | 'ANSWERS_SUM_LANGUAGE_DESC'
  | 'ANSWERS_SUM_MENTIONED_USERNAMES_ASC'
  | 'ANSWERS_SUM_MENTIONED_USERNAMES_DESC'
  | 'ANSWERS_SUM_SENDER_ID_ASC'
  | 'ANSWERS_SUM_SENDER_ID_DESC'
  | 'ANSWERS_SUM_SUBJECT_ASC'
  | 'ANSWERS_SUM_SUBJECT_DESC'
  | 'ANSWERS_SUM_SUBMITTED_AT_ASC'
  | 'ANSWERS_SUM_SUBMITTED_AT_DESC'
  | 'ANSWERS_SUM_UPDATED_AT_ASC'
  | 'ANSWERS_SUM_UPDATED_AT_DESC'
  | 'ANSWERS_VARIANCE_POPULATION_ABOUT_COMMENTABLE_ID_ASC'
  | 'ANSWERS_VARIANCE_POPULATION_ABOUT_COMMENTABLE_ID_DESC'
  | 'ANSWERS_VARIANCE_POPULATION_ANSWERED_POSTING_ID_ASC'
  | 'ANSWERS_VARIANCE_POPULATION_ANSWERED_POSTING_ID_DESC'
  | 'ANSWERS_VARIANCE_POPULATION_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'ANSWERS_VARIANCE_POPULATION_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'ANSWERS_VARIANCE_POPULATION_BODY_ASC'
  | 'ANSWERS_VARIANCE_POPULATION_BODY_DESC'
  | 'ANSWERS_VARIANCE_POPULATION_CONVERSATION_ID_ASC'
  | 'ANSWERS_VARIANCE_POPULATION_CONVERSATION_ID_DESC'
  | 'ANSWERS_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'ANSWERS_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'ANSWERS_VARIANCE_POPULATION_HASHTAGS_ASC'
  | 'ANSWERS_VARIANCE_POPULATION_HASHTAGS_DESC'
  | 'ANSWERS_VARIANCE_POPULATION_ID_ASC'
  | 'ANSWERS_VARIANCE_POPULATION_ID_DESC'
  | 'ANSWERS_VARIANCE_POPULATION_LANGUAGE_ASC'
  | 'ANSWERS_VARIANCE_POPULATION_LANGUAGE_DESC'
  | 'ANSWERS_VARIANCE_POPULATION_MENTIONED_USERNAMES_ASC'
  | 'ANSWERS_VARIANCE_POPULATION_MENTIONED_USERNAMES_DESC'
  | 'ANSWERS_VARIANCE_POPULATION_SENDER_ID_ASC'
  | 'ANSWERS_VARIANCE_POPULATION_SENDER_ID_DESC'
  | 'ANSWERS_VARIANCE_POPULATION_SUBJECT_ASC'
  | 'ANSWERS_VARIANCE_POPULATION_SUBJECT_DESC'
  | 'ANSWERS_VARIANCE_POPULATION_SUBMITTED_AT_ASC'
  | 'ANSWERS_VARIANCE_POPULATION_SUBMITTED_AT_DESC'
  | 'ANSWERS_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'ANSWERS_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'ANSWERS_VARIANCE_SAMPLE_ABOUT_COMMENTABLE_ID_ASC'
  | 'ANSWERS_VARIANCE_SAMPLE_ABOUT_COMMENTABLE_ID_DESC'
  | 'ANSWERS_VARIANCE_SAMPLE_ANSWERED_POSTING_ID_ASC'
  | 'ANSWERS_VARIANCE_SAMPLE_ANSWERED_POSTING_ID_DESC'
  | 'ANSWERS_VARIANCE_SAMPLE_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'ANSWERS_VARIANCE_SAMPLE_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'ANSWERS_VARIANCE_SAMPLE_BODY_ASC'
  | 'ANSWERS_VARIANCE_SAMPLE_BODY_DESC'
  | 'ANSWERS_VARIANCE_SAMPLE_CONVERSATION_ID_ASC'
  | 'ANSWERS_VARIANCE_SAMPLE_CONVERSATION_ID_DESC'
  | 'ANSWERS_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'ANSWERS_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'ANSWERS_VARIANCE_SAMPLE_HASHTAGS_ASC'
  | 'ANSWERS_VARIANCE_SAMPLE_HASHTAGS_DESC'
  | 'ANSWERS_VARIANCE_SAMPLE_ID_ASC'
  | 'ANSWERS_VARIANCE_SAMPLE_ID_DESC'
  | 'ANSWERS_VARIANCE_SAMPLE_LANGUAGE_ASC'
  | 'ANSWERS_VARIANCE_SAMPLE_LANGUAGE_DESC'
  | 'ANSWERS_VARIANCE_SAMPLE_MENTIONED_USERNAMES_ASC'
  | 'ANSWERS_VARIANCE_SAMPLE_MENTIONED_USERNAMES_DESC'
  | 'ANSWERS_VARIANCE_SAMPLE_SENDER_ID_ASC'
  | 'ANSWERS_VARIANCE_SAMPLE_SENDER_ID_DESC'
  | 'ANSWERS_VARIANCE_SAMPLE_SUBJECT_ASC'
  | 'ANSWERS_VARIANCE_SAMPLE_SUBJECT_DESC'
  | 'ANSWERS_VARIANCE_SAMPLE_SUBMITTED_AT_ASC'
  | 'ANSWERS_VARIANCE_SAMPLE_SUBMITTED_AT_DESC'
  | 'ANSWERS_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'ANSWERS_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'BODY_ASC'
  | 'BODY_DESC'
  | 'CONVERSATION_ID_ASC'
  | 'CONVERSATION_ID_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'HASHTAGS_ASC'
  | 'HASHTAGS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'LANGUAGE_ASC'
  | 'LANGUAGE_DESC'
  | 'MENTIONED_USERNAMES_ASC'
  | 'MENTIONED_USERNAMES_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'RECEIPTS_AVERAGE_MANUALLY_CONFIRMED_AT_ASC'
  | 'RECEIPTS_AVERAGE_MANUALLY_CONFIRMED_AT_DESC'
  | 'RECEIPTS_AVERAGE_POSTING_ID_ASC'
  | 'RECEIPTS_AVERAGE_POSTING_ID_DESC'
  | 'RECEIPTS_AVERAGE_RECEIVED_AT_ASC'
  | 'RECEIPTS_AVERAGE_RECEIVED_AT_DESC'
  | 'RECEIPTS_AVERAGE_USER_ID_ASC'
  | 'RECEIPTS_AVERAGE_USER_ID_DESC'
  | 'RECEIPTS_AVERAGE_VIEWED_AT_ASC'
  | 'RECEIPTS_AVERAGE_VIEWED_AT_DESC'
  | 'RECEIPTS_COUNT_ASC'
  | 'RECEIPTS_COUNT_DESC'
  | 'RECEIPTS_DISTINCT_COUNT_MANUALLY_CONFIRMED_AT_ASC'
  | 'RECEIPTS_DISTINCT_COUNT_MANUALLY_CONFIRMED_AT_DESC'
  | 'RECEIPTS_DISTINCT_COUNT_POSTING_ID_ASC'
  | 'RECEIPTS_DISTINCT_COUNT_POSTING_ID_DESC'
  | 'RECEIPTS_DISTINCT_COUNT_RECEIVED_AT_ASC'
  | 'RECEIPTS_DISTINCT_COUNT_RECEIVED_AT_DESC'
  | 'RECEIPTS_DISTINCT_COUNT_USER_ID_ASC'
  | 'RECEIPTS_DISTINCT_COUNT_USER_ID_DESC'
  | 'RECEIPTS_DISTINCT_COUNT_VIEWED_AT_ASC'
  | 'RECEIPTS_DISTINCT_COUNT_VIEWED_AT_DESC'
  | 'RECEIPTS_MAX_MANUALLY_CONFIRMED_AT_ASC'
  | 'RECEIPTS_MAX_MANUALLY_CONFIRMED_AT_DESC'
  | 'RECEIPTS_MAX_POSTING_ID_ASC'
  | 'RECEIPTS_MAX_POSTING_ID_DESC'
  | 'RECEIPTS_MAX_RECEIVED_AT_ASC'
  | 'RECEIPTS_MAX_RECEIVED_AT_DESC'
  | 'RECEIPTS_MAX_USER_ID_ASC'
  | 'RECEIPTS_MAX_USER_ID_DESC'
  | 'RECEIPTS_MAX_VIEWED_AT_ASC'
  | 'RECEIPTS_MAX_VIEWED_AT_DESC'
  | 'RECEIPTS_MIN_MANUALLY_CONFIRMED_AT_ASC'
  | 'RECEIPTS_MIN_MANUALLY_CONFIRMED_AT_DESC'
  | 'RECEIPTS_MIN_POSTING_ID_ASC'
  | 'RECEIPTS_MIN_POSTING_ID_DESC'
  | 'RECEIPTS_MIN_RECEIVED_AT_ASC'
  | 'RECEIPTS_MIN_RECEIVED_AT_DESC'
  | 'RECEIPTS_MIN_USER_ID_ASC'
  | 'RECEIPTS_MIN_USER_ID_DESC'
  | 'RECEIPTS_MIN_VIEWED_AT_ASC'
  | 'RECEIPTS_MIN_VIEWED_AT_DESC'
  | 'RECEIPTS_STDDEV_POPULATION_MANUALLY_CONFIRMED_AT_ASC'
  | 'RECEIPTS_STDDEV_POPULATION_MANUALLY_CONFIRMED_AT_DESC'
  | 'RECEIPTS_STDDEV_POPULATION_POSTING_ID_ASC'
  | 'RECEIPTS_STDDEV_POPULATION_POSTING_ID_DESC'
  | 'RECEIPTS_STDDEV_POPULATION_RECEIVED_AT_ASC'
  | 'RECEIPTS_STDDEV_POPULATION_RECEIVED_AT_DESC'
  | 'RECEIPTS_STDDEV_POPULATION_USER_ID_ASC'
  | 'RECEIPTS_STDDEV_POPULATION_USER_ID_DESC'
  | 'RECEIPTS_STDDEV_POPULATION_VIEWED_AT_ASC'
  | 'RECEIPTS_STDDEV_POPULATION_VIEWED_AT_DESC'
  | 'RECEIPTS_STDDEV_SAMPLE_MANUALLY_CONFIRMED_AT_ASC'
  | 'RECEIPTS_STDDEV_SAMPLE_MANUALLY_CONFIRMED_AT_DESC'
  | 'RECEIPTS_STDDEV_SAMPLE_POSTING_ID_ASC'
  | 'RECEIPTS_STDDEV_SAMPLE_POSTING_ID_DESC'
  | 'RECEIPTS_STDDEV_SAMPLE_RECEIVED_AT_ASC'
  | 'RECEIPTS_STDDEV_SAMPLE_RECEIVED_AT_DESC'
  | 'RECEIPTS_STDDEV_SAMPLE_USER_ID_ASC'
  | 'RECEIPTS_STDDEV_SAMPLE_USER_ID_DESC'
  | 'RECEIPTS_STDDEV_SAMPLE_VIEWED_AT_ASC'
  | 'RECEIPTS_STDDEV_SAMPLE_VIEWED_AT_DESC'
  | 'RECEIPTS_SUM_MANUALLY_CONFIRMED_AT_ASC'
  | 'RECEIPTS_SUM_MANUALLY_CONFIRMED_AT_DESC'
  | 'RECEIPTS_SUM_POSTING_ID_ASC'
  | 'RECEIPTS_SUM_POSTING_ID_DESC'
  | 'RECEIPTS_SUM_RECEIVED_AT_ASC'
  | 'RECEIPTS_SUM_RECEIVED_AT_DESC'
  | 'RECEIPTS_SUM_USER_ID_ASC'
  | 'RECEIPTS_SUM_USER_ID_DESC'
  | 'RECEIPTS_SUM_VIEWED_AT_ASC'
  | 'RECEIPTS_SUM_VIEWED_AT_DESC'
  | 'RECEIPTS_VARIANCE_POPULATION_MANUALLY_CONFIRMED_AT_ASC'
  | 'RECEIPTS_VARIANCE_POPULATION_MANUALLY_CONFIRMED_AT_DESC'
  | 'RECEIPTS_VARIANCE_POPULATION_POSTING_ID_ASC'
  | 'RECEIPTS_VARIANCE_POPULATION_POSTING_ID_DESC'
  | 'RECEIPTS_VARIANCE_POPULATION_RECEIVED_AT_ASC'
  | 'RECEIPTS_VARIANCE_POPULATION_RECEIVED_AT_DESC'
  | 'RECEIPTS_VARIANCE_POPULATION_USER_ID_ASC'
  | 'RECEIPTS_VARIANCE_POPULATION_USER_ID_DESC'
  | 'RECEIPTS_VARIANCE_POPULATION_VIEWED_AT_ASC'
  | 'RECEIPTS_VARIANCE_POPULATION_VIEWED_AT_DESC'
  | 'RECEIPTS_VARIANCE_SAMPLE_MANUALLY_CONFIRMED_AT_ASC'
  | 'RECEIPTS_VARIANCE_SAMPLE_MANUALLY_CONFIRMED_AT_DESC'
  | 'RECEIPTS_VARIANCE_SAMPLE_POSTING_ID_ASC'
  | 'RECEIPTS_VARIANCE_SAMPLE_POSTING_ID_DESC'
  | 'RECEIPTS_VARIANCE_SAMPLE_RECEIVED_AT_ASC'
  | 'RECEIPTS_VARIANCE_SAMPLE_RECEIVED_AT_DESC'
  | 'RECEIPTS_VARIANCE_SAMPLE_USER_ID_ASC'
  | 'RECEIPTS_VARIANCE_SAMPLE_USER_ID_DESC'
  | 'RECEIPTS_VARIANCE_SAMPLE_VIEWED_AT_ASC'
  | 'RECEIPTS_VARIANCE_SAMPLE_VIEWED_AT_DESC'
  | 'SENDER_ID_ASC'
  | 'SENDER_ID_DESC'
  | 'SUBJECT_ASC'
  | 'SUBJECT_DESC'
  | 'SUBMITTED_AT_ASC'
  | 'SUBMITTED_AT_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

/** All input for the `pullEmaEntries2` mutation. */
export type PullEmaEntries2Input = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  lastId?: InputMaybe<Scalars['UUID']>;
  minUpdatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** The output of our `pullEmaEntries2` mutation. */
export type PullEmaEntries2Payload = {
  __typename?: 'PullEmaEntries2Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  emaEntries2S?: Maybe<Array<EmaEntries2>>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** All input for the `pushEmaEntry` mutation. */
export type PushEmaEntryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  input: EmaEntryPatch;
};

/** The output of our `pushEmaEntry` mutation. */
export type PushEmaEntryPayload = {
  __typename?: 'PushEmaEntryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** An edge for our `EmaEntry`. May be used by Relay 1. */
  emaEntryEdge?: Maybe<EmaEntriesEdge>;
  newEntry?: Maybe<EmaEntry>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmaEntry`. */
  subject?: Maybe<User>;
};


/** The output of our `pushEmaEntry` mutation. */
export type PushEmaEntryPayloadEmaEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<EmaEntriesOrderBy>>;
};

/** The root query type which gives access points into the data universe. */
export type Query = Node & {
  __typename?: 'Query';
  commentable?: Maybe<Commentable>;
  /** Reads a single `Commentable` using its globally unique `ID`. */
  commentableByNodeId?: Maybe<Commentable>;
  /** Reads and enables pagination through a set of `Commentable`. */
  commentables?: Maybe<CommentablesConnection>;
  conversation?: Maybe<Conversation>;
  /** Reads a single `Conversation` using its globally unique `ID`. */
  conversationByNodeId?: Maybe<Conversation>;
  /** Reads and enables pagination through a set of `Conversation`. */
  conversations?: Maybe<ConversationsConnection>;
  /** Reads and enables pagination through a set of `EmaEntry`. */
  emaEntries?: Maybe<EmaEntriesConnection>;
  emaEntries2?: Maybe<EmaEntries2>;
  /** Reads a single `EmaEntries2` using its globally unique `ID`. */
  emaEntries2ByNodeId?: Maybe<EmaEntries2>;
  /** Reads and enables pagination through a set of `EmaEntries2`. */
  emaEntries2s?: Maybe<EmaEntries2sConnection>;
  emaEntries3?: Maybe<EmaEntries3>;
  /** Reads a single `EmaEntries3` using its globally unique `ID`. */
  emaEntries3ByNodeId?: Maybe<EmaEntries3>;
  /** Reads and enables pagination through a set of `EmaEntries3`. */
  emaEntries3s?: Maybe<EmaEntries3sConnection>;
  emaEntry?: Maybe<EmaEntry>;
  /** Reads a single `EmaEntry` using its globally unique `ID`. */
  emaEntryByNodeId?: Maybe<EmaEntry>;
  event?: Maybe<Event>;
  /** Reads a single `Event` using its globally unique `ID`. */
  eventByNodeId?: Maybe<Event>;
  favoritePage?: Maybe<FavoritePage>;
  /** Reads a single `FavoritePage` using its globally unique `ID`. */
  favoritePageByNodeId?: Maybe<FavoritePage>;
  /** Reads and enables pagination through a set of `FavoritePage`. */
  favoritePages?: Maybe<FavoritePagesConnection>;
  genericEmiExercise?: Maybe<GenericEmiExercise>;
  /** Reads a single `GenericEmiExercise` using its globally unique `ID`. */
  genericEmiExerciseByNodeId?: Maybe<GenericEmiExercise>;
  genericEmiExerciseByTrialIdAndName?: Maybe<GenericEmiExercise>;
  /** Reads and enables pagination through a set of `GenericEmiExercise`. */
  genericEmiExercises?: Maybe<GenericEmiExercisesConnection>;
  group?: Maybe<Group>;
  /** Reads a single `Group` using its globally unique `ID`. */
  groupByNodeId?: Maybe<Group>;
  groupHome?: Maybe<GroupHome>;
  /** Reads a single `GroupHome` using its globally unique `ID`. */
  groupHomeByNodeId?: Maybe<GroupHome>;
  /** Reads and enables pagination through a set of `GroupHome`. */
  groupHomes?: Maybe<GroupHomesConnection>;
  /** Reads and enables pagination through a set of `Group`. */
  groups?: Maybe<GroupsConnection>;
  keycloakClientRoles?: Maybe<Array<Maybe<Scalars['String']>>>;
  keycloakRealmRoles?: Maybe<Array<Maybe<Scalars['String']>>>;
  limesurveyToken?: Maybe<LimesurveyToken>;
  /** Reads a single `LimesurveyToken` using its globally unique `ID`. */
  limesurveyTokenByNodeId?: Maybe<LimesurveyToken>;
  limesurveyTokenByTrialIdAndTimeOfMeasurement?: Maybe<LimesurveyToken>;
  /** Reads and enables pagination through a set of `LimesurveyToken`. */
  limesurveyTokens?: Maybe<LimesurveyTokensConnection>;
  membership?: Maybe<Membership>;
  membershipByGroupIdAndSubgroupId?: Maybe<Membership>;
  membershipByGroupIdAndUserId?: Maybe<Membership>;
  /** Reads a single `Membership` using its globally unique `ID`. */
  membershipByNodeId?: Maybe<Membership>;
  membershipInvitation?: Maybe<MembershipInvitation>;
  /** Reads a single `MembershipInvitation` using its globally unique `ID`. */
  membershipInvitationByNodeId?: Maybe<MembershipInvitation>;
  membershipInvitationConfirmation?: Maybe<MembershipInvitationConfirmation>;
  /** Reads a single `MembershipInvitationConfirmation` using its globally unique `ID`. */
  membershipInvitationConfirmationByNodeId?: Maybe<MembershipInvitationConfirmation>;
  /** Reads and enables pagination through a set of `MembershipInvitationConfirmation`. */
  membershipInvitationConfirmations?: Maybe<MembershipInvitationConfirmationsConnection>;
  /** Reads and enables pagination through a set of `MembershipInvitation`. */
  membershipInvitations?: Maybe<MembershipInvitationsConnection>;
  /** Reads and enables pagination through a set of `Membership`. */
  memberships?: Maybe<MembershipsConnection>;
  myAccount?: Maybe<User>;
  myAccountId?: Maybe<Scalars['UUID']>;
  myCurrentTrial?: Maybe<Trial>;
  myCurrentTrialId?: Maybe<Scalars['UUID']>;
  myIssuedMembershipInvitations?: Maybe<MembershipInvitation>;
  /** Reads and enables pagination through a set of `Membership`. */
  myMemberships?: Maybe<MembershipsConnection>;
  /** Reads and enables pagination through a set of `User`. */
  myPeers?: Maybe<UsersConnection>;
  /** Reads and enables pagination through a set of `Membership`. */
  myPeersMemberships?: Maybe<MembershipsConnection>;
  /** Reads and enables pagination through a set of `Conversation`. */
  myPrivateConversations?: Maybe<ConversationsConnection>;
  /** Reads and enables pagination through a set of `MembershipInvitation`. */
  myReceivedMembershipInvitations?: Maybe<MembershipInvitationsConnection>;
  /** @deprecated true */
  myReceivedMembershipInvitationsDeprecated?: Maybe<MembershipInvitation>;
  myTenant?: Maybe<Tenant>;
  myTenantId?: Maybe<Scalars['UUID']>;
  /** Fetches an object given its globally unique `ID`. */
  node?: Maybe<Node>;
  /** The root query type must be a `Node` to work well with Relay 1 mutations. This just resolves to `query`. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PageHit`. */
  pageHits?: Maybe<PageHitsConnection>;
  postWaitRandomizationTicket?: Maybe<PostWaitRandomizationTicket>;
  /** Reads a single `PostWaitRandomizationTicket` using its globally unique `ID`. */
  postWaitRandomizationTicketByNodeId?: Maybe<PostWaitRandomizationTicket>;
  postWaitRandomizationTicketByTrialId?: Maybe<PostWaitRandomizationTicket>;
  /** Reads and enables pagination through a set of `PostWaitRandomizationTicket`. */
  postWaitRandomizationTickets?: Maybe<PostWaitRandomizationTicketsConnection>;
  posting?: Maybe<Posting>;
  /** Reads a single `Posting` using its globally unique `ID`. */
  postingByNodeId?: Maybe<Posting>;
  postingReceipt?: Maybe<PostingReceipt>;
  /** Reads a single `PostingReceipt` using its globally unique `ID`. */
  postingReceiptByNodeId?: Maybe<PostingReceipt>;
  /** Reads and enables pagination through a set of `PostingReceipt`. */
  postingReceipts?: Maybe<PostingReceiptsConnection>;
  /** Reads and enables pagination through a set of `Posting`. */
  postings?: Maybe<PostingsConnection>;
  /** Reads and enables pagination through a set of `EmaEntry`. */
  pullEmaEntriesList?: Maybe<Array<EmaEntry>>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  randomizationTicket?: Maybe<RandomizationTicket>;
  /** Reads a single `RandomizationTicket` using its globally unique `ID`. */
  randomizationTicketByNodeId?: Maybe<RandomizationTicket>;
  randomizationTicketByTrialId?: Maybe<RandomizationTicket>;
  /** Reads and enables pagination through a set of `RandomizationTicket`. */
  randomizationTickets?: Maybe<RandomizationTicketsConnection>;
  /** Reads and enables pagination through a set of `RawUsageDatum`. */
  rawUsageData?: Maybe<RawUsageDataConnection>;
  rawUsageDatum?: Maybe<RawUsageDatum>;
  /** Reads a single `RawUsageDatum` using its globally unique `ID`. */
  rawUsageDatumByNodeId?: Maybe<RawUsageDatum>;
  tenant?: Maybe<Tenant>;
  tenantByName?: Maybe<Tenant>;
  /** Reads a single `Tenant` using its globally unique `ID`. */
  tenantByNodeId?: Maybe<Tenant>;
  tenantByUrl?: Maybe<Tenant>;
  /** Reads and enables pagination through a set of `Tenant`. */
  tenants?: Maybe<TenantsConnection>;
  trial?: Maybe<Trial>;
  trialByHumanReadableId?: Maybe<Trial>;
  trialByName?: Maybe<Trial>;
  /** Reads a single `Trial` using its globally unique `ID`. */
  trialByNodeId?: Maybe<Trial>;
  /** Reads and enables pagination through a set of `Trial`. */
  trials?: Maybe<TrialsConnection>;
  user?: Maybe<User>;
  userByCredentialsId?: Maybe<User>;
  userByEmailAddressId?: Maybe<User>;
  userByIdAndTenantId?: Maybe<User>;
  /** Reads a single `User` using its globally unique `ID`. */
  userByNodeId?: Maybe<User>;
  userByUsernameAndTenantId?: Maybe<User>;
  userCredential?: Maybe<UserCredential>;
  userCredentialByExternalAuthIdAndTenantId?: Maybe<UserCredential>;
  /** Reads a single `UserCredential` using its globally unique `ID`. */
  userCredentialByNodeId?: Maybe<UserCredential>;
  /** Reads and enables pagination through a set of `UserCredential`. */
  userCredentials?: Maybe<UserCredentialsConnection>;
  userEmailAddress?: Maybe<UserEmailAddress>;
  userEmailAddressByEmailAddressAndTenantId?: Maybe<UserEmailAddress>;
  /** Reads a single `UserEmailAddress` using its globally unique `ID`. */
  userEmailAddressByNodeId?: Maybe<UserEmailAddress>;
  /** Reads and enables pagination through a set of `UserEmailAddress`. */
  userEmailAddresses?: Maybe<UserEmailAddressesConnection>;
  /** Reads and enables pagination through a set of `User`. */
  users?: Maybe<UsersConnection>;
};


/** The root query type which gives access points into the data universe. */
export type QueryCommentableArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCommentableByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryCommentablesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<CommentableCondition>;
  filter?: InputMaybe<CommentableFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<CommentablesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryConversationArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryConversationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryConversationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ConversationCondition>;
  filter?: InputMaybe<ConversationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEmaEntriesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmaEntryCondition>;
  filter?: InputMaybe<EmaEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmaEntriesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEmaEntries2Args = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmaEntries2ByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmaEntries2sArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmaEntries2Condition>;
  filter?: InputMaybe<EmaEntries2Filter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmaEntries2sOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEmaEntries3Args = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmaEntries3ByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmaEntries3sArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmaEntries3Condition>;
  filter?: InputMaybe<EmaEntries3Filter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmaEntries3sOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryEmaEntryArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEmaEntryByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryEventByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFavoritePageArgs = {
  route: Scalars['String'];
  trialId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFavoritePageByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryFavoritePagesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FavoritePageCondition>;
  filter?: InputMaybe<FavoritePageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FavoritePagesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGenericEmiExerciseArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGenericEmiExerciseByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGenericEmiExerciseByTrialIdAndNameArgs = {
  name: Scalars['String'];
  trialId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGenericEmiExercisesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GenericEmiExerciseCondition>;
  filter?: InputMaybe<GenericEmiExerciseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GenericEmiExercisesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupHomeArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupHomeByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupHomesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupHomeCondition>;
  filter?: InputMaybe<GroupHomeFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupHomesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupCondition>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryKeycloakClientRolesArgs = {
  client?: InputMaybe<Scalars['String']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryLimesurveyTokenArgs = {
  surveyId: Scalars['Int'];
  token: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLimesurveyTokenByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLimesurveyTokenByTrialIdAndTimeOfMeasurementArgs = {
  timeOfMeasurement: Scalars['String'];
  trialId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryLimesurveyTokensArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LimesurveyTokenCondition>;
  filter?: InputMaybe<LimesurveyTokenFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LimesurveyTokensOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipByGroupIdAndSubgroupIdArgs = {
  groupId: Scalars['UUID'];
  subgroupId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipByGroupIdAndUserIdArgs = {
  groupId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipInvitationArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipInvitationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipInvitationConfirmationArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipInvitationConfirmationByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipInvitationConfirmationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MembershipInvitationConfirmationCondition>;
  filter?: InputMaybe<MembershipInvitationConfirmationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MembershipInvitationConfirmationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipInvitationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MembershipInvitationCondition>;
  filter?: InputMaybe<MembershipInvitationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MembershipInvitationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MembershipCondition>;
  filter?: InputMaybe<MembershipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyAccountArgs = {
  failIfNotFound?: InputMaybe<Scalars['Boolean']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyAccountIdArgs = {
  failIfNotFound?: InputMaybe<Scalars['Boolean']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<MembershipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  includeSupergroups?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  thatICanManage?: InputMaybe<Scalars['Boolean']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyPeersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyPeersMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  filter?: InputMaybe<MembershipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  includeForeignGroups?: InputMaybe<Scalars['Boolean']>;
  includeSupergroups?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyPrivateConversationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ConversationCondition>;
  filter?: InputMaybe<ConversationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  includeSupergroups?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyReceivedMembershipInvitationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MembershipInvitationCondition>;
  filter?: InputMaybe<MembershipInvitationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  includeGroupInvitations?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MembershipInvitationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyReceivedMembershipInvitationsDeprecatedArgs = {
  includeGroupsThatICanManage?: InputMaybe<Scalars['Boolean']>;
  includeSupergroups?: InputMaybe<Scalars['Boolean']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyTenantArgs = {
  failIfNotFound?: InputMaybe<Scalars['Boolean']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryMyTenantIdArgs = {
  failIfNotFound?: InputMaybe<Scalars['Boolean']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryNodeArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPageHitsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PageHitCondition>;
  filter?: InputMaybe<PageHitFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PageHitsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPostWaitRandomizationTicketArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPostWaitRandomizationTicketByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPostWaitRandomizationTicketByTrialIdArgs = {
  trialId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPostWaitRandomizationTicketsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PostWaitRandomizationTicketCondition>;
  filter?: InputMaybe<PostWaitRandomizationTicketFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PostWaitRandomizationTicketsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPostingArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPostingByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPostingReceiptArgs = {
  postingId: Scalars['UUID'];
  userId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPostingReceiptByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryPostingReceiptsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PostingReceiptCondition>;
  filter?: InputMaybe<PostingReceiptFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PostingReceiptsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPostingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PostingCondition>;
  filter?: InputMaybe<PostingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PostingsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryPullEmaEntriesListArgs = {
  filter?: InputMaybe<EmaEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  lastId?: InputMaybe<Scalars['UUID']>;
  minUpdatedAt?: InputMaybe<Scalars['Datetime']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRandomizationTicketArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRandomizationTicketByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRandomizationTicketByTrialIdArgs = {
  trialId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRandomizationTicketsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RandomizationTicketCondition>;
  filter?: InputMaybe<RandomizationTicketFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RandomizationTicketsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRawUsageDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RawUsageDatumCondition>;
  filter?: InputMaybe<RawUsageDatumFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RawUsageDataOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryRawUsageDatumArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryRawUsageDatumByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTenantArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTenantByNameArgs = {
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTenantByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTenantByUrlArgs = {
  url: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTenantsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TenantCondition>;
  filter?: InputMaybe<TenantFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryTrialArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTrialByHumanReadableIdArgs = {
  humanReadableId: Scalars['BigInt'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTrialByNameArgs = {
  name: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTrialByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryTrialsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TrialCondition>;
  filter?: InputMaybe<TrialFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TrialsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByCredentialsIdArgs = {
  credentialsId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByEmailAddressIdArgs = {
  emailAddressId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByIdAndTenantIdArgs = {
  id: Scalars['UUID'];
  tenantId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserByUsernameAndTenantIdArgs = {
  tenantId: Scalars['UUID'];
  username: Scalars['String'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserCredentialArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserCredentialByExternalAuthIdAndTenantIdArgs = {
  externalAuthId: Scalars['String'];
  tenantId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserCredentialByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserCredentialsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCredentialCondition>;
  filter?: InputMaybe<UserCredentialFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCredentialsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUserEmailAddressArgs = {
  id: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserEmailAddressByEmailAddressAndTenantIdArgs = {
  emailAddress: Scalars['String'];
  tenantId: Scalars['UUID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserEmailAddressByNodeIdArgs = {
  nodeId: Scalars['ID'];
};


/** The root query type which gives access points into the data universe. */
export type QueryUserEmailAddressesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserEmailAddressCondition>;
  filter?: InputMaybe<UserEmailAddressFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserEmailAddressesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

export type RandomizationTicket = Node & {
  __typename?: 'RandomizationTicket';
  blockNumber: Scalars['Int'];
  createdAt: Scalars['Datetime'];
  handedOutAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  stratum: Scalars['String'];
  treatment: Scalars['String'];
  /** Reads a single `Trial` that is related to this `RandomizationTicket`. */
  trial?: Maybe<Trial>;
  trialId?: Maybe<Scalars['UUID']>;
};

export type RandomizationTicketAggregates = {
  __typename?: 'RandomizationTicketAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<RandomizationTicketAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<RandomizationTicketDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<RandomizationTicketMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<RandomizationTicketMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<RandomizationTicketStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<RandomizationTicketStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<RandomizationTicketSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<RandomizationTicketVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<RandomizationTicketVarianceSampleAggregates>;
};

export type RandomizationTicketAverageAggregates = {
  __typename?: 'RandomizationTicketAverageAggregates';
  /** Mean average of blockNumber across the matching connection */
  blockNumber?: Maybe<Scalars['BigFloat']>;
};

/**
 * A condition to be used against `RandomizationTicket` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type RandomizationTicketCondition = {
  /** Checks for equality with the object’s `blockNumber` field. */
  blockNumber?: InputMaybe<Scalars['Int']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `handedOutAt` field. */
  handedOutAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `stratum` field. */
  stratum?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `treatment` field. */
  treatment?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `trialId` field. */
  trialId?: InputMaybe<Scalars['UUID']>;
};

export type RandomizationTicketDistinctCountAggregates = {
  __typename?: 'RandomizationTicketDistinctCountAggregates';
  /** Distinct count of blockNumber across the matching connection */
  blockNumber?: Maybe<Scalars['BigInt']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of handedOutAt across the matching connection */
  handedOutAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']>;
  /** Distinct count of stratum across the matching connection */
  stratum?: Maybe<Scalars['BigInt']>;
  /** Distinct count of treatment across the matching connection */
  treatment?: Maybe<Scalars['BigInt']>;
  /** Distinct count of trialId across the matching connection */
  trialId?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `RandomizationTicket` object types. All fields are combined with a logical ‘and.’ */
export type RandomizationTicketFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RandomizationTicketFilter>>;
  /** Filter by the object’s `blockNumber` field. */
  blockNumber?: InputMaybe<IntFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `handedOutAt` field. */
  handedOutAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RandomizationTicketFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RandomizationTicketFilter>>;
  /** Filter by the object’s `stratum` field. */
  stratum?: InputMaybe<StringFilter>;
  /** Filter by the object’s `treatment` field. */
  treatment?: InputMaybe<StringFilter>;
  /** Filter by the object’s `trial` relation. */
  trial?: InputMaybe<TrialFilter>;
  /** A related `trial` exists. */
  trialExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `trialId` field. */
  trialId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `RandomizationTicket` */
export type RandomizationTicketInput = {
  blockNumber: Scalars['Int'];
  createdAt?: InputMaybe<Scalars['Datetime']>;
  handedOutAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  stratum: Scalars['String'];
  treatment: Scalars['String'];
  trialId?: InputMaybe<Scalars['UUID']>;
};

export type RandomizationTicketMaxAggregates = {
  __typename?: 'RandomizationTicketMaxAggregates';
  /** Maximum of blockNumber across the matching connection */
  blockNumber?: Maybe<Scalars['Int']>;
};

export type RandomizationTicketMinAggregates = {
  __typename?: 'RandomizationTicketMinAggregates';
  /** Minimum of blockNumber across the matching connection */
  blockNumber?: Maybe<Scalars['Int']>;
};

/** Represents an update to a `RandomizationTicket`. Fields that are set will be updated. */
export type RandomizationTicketPatch = {
  blockNumber?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  handedOutAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  stratum?: InputMaybe<Scalars['String']>;
  treatment?: InputMaybe<Scalars['String']>;
  trialId?: InputMaybe<Scalars['UUID']>;
};

export type RandomizationTicketStddevPopulationAggregates = {
  __typename?: 'RandomizationTicketStddevPopulationAggregates';
  /** Population standard deviation of blockNumber across the matching connection */
  blockNumber?: Maybe<Scalars['BigFloat']>;
};

export type RandomizationTicketStddevSampleAggregates = {
  __typename?: 'RandomizationTicketStddevSampleAggregates';
  /** Sample standard deviation of blockNumber across the matching connection */
  blockNumber?: Maybe<Scalars['BigFloat']>;
};

export type RandomizationTicketSumAggregates = {
  __typename?: 'RandomizationTicketSumAggregates';
  /** Sum of blockNumber across the matching connection */
  blockNumber: Scalars['BigInt'];
};

export type RandomizationTicketVariancePopulationAggregates = {
  __typename?: 'RandomizationTicketVariancePopulationAggregates';
  /** Population variance of blockNumber across the matching connection */
  blockNumber?: Maybe<Scalars['BigFloat']>;
};

export type RandomizationTicketVarianceSampleAggregates = {
  __typename?: 'RandomizationTicketVarianceSampleAggregates';
  /** Sample variance of blockNumber across the matching connection */
  blockNumber?: Maybe<Scalars['BigFloat']>;
};

/** A connection to a list of `RandomizationTicket` values. */
export type RandomizationTicketsConnection = {
  __typename?: 'RandomizationTicketsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<RandomizationTicketAggregates>;
  /** A list of edges which contains the `RandomizationTicket` and cursor to aid in pagination. */
  edges: Array<RandomizationTicketsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<RandomizationTicketAggregates>>;
  /** A list of `RandomizationTicket` objects. */
  nodes: Array<RandomizationTicket>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RandomizationTicket` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `RandomizationTicket` values. */
export type RandomizationTicketsConnectionGroupedAggregatesArgs = {
  groupBy: Array<RandomizationTicketsGroupBy>;
  having?: InputMaybe<RandomizationTicketsHavingInput>;
};

/** A `RandomizationTicket` edge in the connection. */
export type RandomizationTicketsEdge = {
  __typename?: 'RandomizationTicketsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RandomizationTicket` at the end of the edge. */
  node: RandomizationTicket;
};

/** Grouping methods for `RandomizationTicket` for usage during aggregation. */
export type RandomizationTicketsGroupBy =
  | 'BLOCK_NUMBER'
  | 'CREATED_AT'
  | 'CREATED_AT_TRUNCATED_TO_DAY'
  | 'CREATED_AT_TRUNCATED_TO_HOUR'
  | 'HANDED_OUT_AT'
  | 'HANDED_OUT_AT_TRUNCATED_TO_DAY'
  | 'HANDED_OUT_AT_TRUNCATED_TO_HOUR'
  | 'STRATUM'
  | 'TREATMENT';

export type RandomizationTicketsHavingAverageInput = {
  blockNumber?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
};

export type RandomizationTicketsHavingDistinctCountInput = {
  blockNumber?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `RandomizationTicket` aggregates. */
export type RandomizationTicketsHavingInput = {
  AND?: InputMaybe<Array<RandomizationTicketsHavingInput>>;
  OR?: InputMaybe<Array<RandomizationTicketsHavingInput>>;
  average?: InputMaybe<RandomizationTicketsHavingAverageInput>;
  distinctCount?: InputMaybe<RandomizationTicketsHavingDistinctCountInput>;
  max?: InputMaybe<RandomizationTicketsHavingMaxInput>;
  min?: InputMaybe<RandomizationTicketsHavingMinInput>;
  stddevPopulation?: InputMaybe<RandomizationTicketsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<RandomizationTicketsHavingStddevSampleInput>;
  sum?: InputMaybe<RandomizationTicketsHavingSumInput>;
  variancePopulation?: InputMaybe<RandomizationTicketsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<RandomizationTicketsHavingVarianceSampleInput>;
};

export type RandomizationTicketsHavingMaxInput = {
  blockNumber?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
};

export type RandomizationTicketsHavingMinInput = {
  blockNumber?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
};

export type RandomizationTicketsHavingStddevPopulationInput = {
  blockNumber?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
};

export type RandomizationTicketsHavingStddevSampleInput = {
  blockNumber?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
};

export type RandomizationTicketsHavingSumInput = {
  blockNumber?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
};

export type RandomizationTicketsHavingVariancePopulationInput = {
  blockNumber?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
};

export type RandomizationTicketsHavingVarianceSampleInput = {
  blockNumber?: InputMaybe<HavingIntFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  handedOutAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `RandomizationTicket`. */
export type RandomizationTicketsOrderBy =
  | 'BLOCK_NUMBER_ASC'
  | 'BLOCK_NUMBER_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'HANDED_OUT_AT_ASC'
  | 'HANDED_OUT_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'STRATUM_ASC'
  | 'STRATUM_DESC'
  | 'TREATMENT_ASC'
  | 'TREATMENT_DESC'
  | 'TRIAL_ID_ASC'
  | 'TRIAL_ID_DESC';

/** A connection to a list of `RawUsageDatum` values. */
export type RawUsageDataConnection = {
  __typename?: 'RawUsageDataConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<RawUsageDatumAggregates>;
  /** A list of edges which contains the `RawUsageDatum` and cursor to aid in pagination. */
  edges: Array<RawUsageDataEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<RawUsageDatumAggregates>>;
  /** A list of `RawUsageDatum` objects. */
  nodes: Array<RawUsageDatum>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `RawUsageDatum` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `RawUsageDatum` values. */
export type RawUsageDataConnectionGroupedAggregatesArgs = {
  groupBy: Array<RawUsageDataGroupBy>;
  having?: InputMaybe<RawUsageDataHavingInput>;
};

/** A `RawUsageDatum` edge in the connection. */
export type RawUsageDataEdge = {
  __typename?: 'RawUsageDataEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `RawUsageDatum` at the end of the edge. */
  node: RawUsageDatum;
};

/** Grouping methods for `RawUsageDatum` for usage during aggregation. */
export type RawUsageDataGroupBy =
  | 'CLIENT_HASH'
  | 'PAYLOAD'
  | 'REMOTE_ADDRESS'
  | 'TRACKED_AT'
  | 'TRACKED_AT_TRUNCATED_TO_DAY'
  | 'TRACKED_AT_TRUNCATED_TO_HOUR'
  | 'TRIAL_ID'
  | 'TYPE'
  | 'USER_AGENT'
  | 'USER_ID';

export type RawUsageDataHavingAverageInput = {
  trackedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type RawUsageDataHavingDistinctCountInput = {
  trackedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `RawUsageDatum` aggregates. */
export type RawUsageDataHavingInput = {
  AND?: InputMaybe<Array<RawUsageDataHavingInput>>;
  OR?: InputMaybe<Array<RawUsageDataHavingInput>>;
  average?: InputMaybe<RawUsageDataHavingAverageInput>;
  distinctCount?: InputMaybe<RawUsageDataHavingDistinctCountInput>;
  max?: InputMaybe<RawUsageDataHavingMaxInput>;
  min?: InputMaybe<RawUsageDataHavingMinInput>;
  stddevPopulation?: InputMaybe<RawUsageDataHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<RawUsageDataHavingStddevSampleInput>;
  sum?: InputMaybe<RawUsageDataHavingSumInput>;
  variancePopulation?: InputMaybe<RawUsageDataHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<RawUsageDataHavingVarianceSampleInput>;
};

export type RawUsageDataHavingMaxInput = {
  trackedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type RawUsageDataHavingMinInput = {
  trackedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type RawUsageDataHavingStddevPopulationInput = {
  trackedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type RawUsageDataHavingStddevSampleInput = {
  trackedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type RawUsageDataHavingSumInput = {
  trackedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type RawUsageDataHavingVariancePopulationInput = {
  trackedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type RawUsageDataHavingVarianceSampleInput = {
  trackedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `RawUsageDatum`. */
export type RawUsageDataOrderBy =
  | 'CLIENT_HASH_ASC'
  | 'CLIENT_HASH_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PAYLOAD_ASC'
  | 'PAYLOAD_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'REMOTE_ADDRESS_ASC'
  | 'REMOTE_ADDRESS_DESC'
  | 'TRACKED_AT_ASC'
  | 'TRACKED_AT_DESC'
  | 'TRIAL_ID_ASC'
  | 'TRIAL_ID_DESC'
  | 'TYPE_ASC'
  | 'TYPE_DESC'
  | 'USER_AGENT_ASC'
  | 'USER_AGENT_DESC'
  | 'USER_ID_ASC'
  | 'USER_ID_DESC';

export type RawUsageDatum = Node & {
  __typename?: 'RawUsageDatum';
  clientHash?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  payload?: Maybe<Scalars['JSON']>;
  remoteAddress?: Maybe<Array<Maybe<Scalars['InternetAddress']>>>;
  trackedAt: Scalars['Datetime'];
  /** Reads a single `Trial` that is related to this `RawUsageDatum`. */
  trial?: Maybe<Trial>;
  trialId?: Maybe<Scalars['UUID']>;
  type: Scalars['String'];
  /** Reads a single `User` that is related to this `RawUsageDatum`. */
  user?: Maybe<User>;
  userAgent?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['UUID']>;
};

export type RawUsageDatumAggregates = {
  __typename?: 'RawUsageDatumAggregates';
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<RawUsageDatumDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
};

/** A filter to be used against aggregates of `RawUsageDatum` object types. */
export type RawUsageDatumAggregatesFilter = {
  /** Distinct count aggregate over matching `RawUsageDatum` objects. */
  distinctCount?: InputMaybe<RawUsageDatumDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `RawUsageDatum` object to be included within the aggregate. */
  filter?: InputMaybe<RawUsageDatumFilter>;
};

/**
 * A condition to be used against `RawUsageDatum` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type RawUsageDatumCondition = {
  /** Checks for equality with the object’s `clientHash` field. */
  clientHash?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `payload` field. */
  payload?: InputMaybe<Scalars['JSON']>;
  /** Checks for equality with the object’s `remoteAddress` field. */
  remoteAddress?: InputMaybe<Array<InputMaybe<Scalars['InternetAddress']>>>;
  /** Checks for equality with the object’s `trackedAt` field. */
  trackedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `trialId` field. */
  trialId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `type` field. */
  type?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `userAgent` field. */
  userAgent?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `userId` field. */
  userId?: InputMaybe<Scalars['UUID']>;
};

export type RawUsageDatumDistinctCountAggregateFilter = {
  clientHash?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  payload?: InputMaybe<BigIntFilter>;
  remoteAddress?: InputMaybe<BigIntFilter>;
  trackedAt?: InputMaybe<BigIntFilter>;
  trialId?: InputMaybe<BigIntFilter>;
  type?: InputMaybe<BigIntFilter>;
  userAgent?: InputMaybe<BigIntFilter>;
  userId?: InputMaybe<BigIntFilter>;
};

export type RawUsageDatumDistinctCountAggregates = {
  __typename?: 'RawUsageDatumDistinctCountAggregates';
  /** Distinct count of clientHash across the matching connection */
  clientHash?: Maybe<Scalars['BigInt']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']>;
  /** Distinct count of payload across the matching connection */
  payload?: Maybe<Scalars['BigInt']>;
  /** Distinct count of remoteAddress across the matching connection */
  remoteAddress?: Maybe<Scalars['BigInt']>;
  /** Distinct count of trackedAt across the matching connection */
  trackedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of trialId across the matching connection */
  trialId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of type across the matching connection */
  type?: Maybe<Scalars['BigInt']>;
  /** Distinct count of userAgent across the matching connection */
  userAgent?: Maybe<Scalars['BigInt']>;
  /** Distinct count of userId across the matching connection */
  userId?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `RawUsageDatum` object types. All fields are combined with a logical ‘and.’ */
export type RawUsageDatumFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<RawUsageDatumFilter>>;
  /** Filter by the object’s `clientHash` field. */
  clientHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<RawUsageDatumFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<RawUsageDatumFilter>>;
  /** Filter by the object’s `payload` field. */
  payload?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `remoteAddress` field. */
  remoteAddress?: InputMaybe<InternetAddressListFilter>;
  /** Filter by the object’s `trackedAt` field. */
  trackedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `trial` relation. */
  trial?: InputMaybe<TrialFilter>;
  /** A related `trial` exists. */
  trialExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `trialId` field. */
  trialId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `type` field. */
  type?: InputMaybe<StringFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** Filter by the object’s `userAgent` field. */
  userAgent?: InputMaybe<StringFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `userId` field. */
  userId?: InputMaybe<UuidFilter>;
};

/** An input for mutations affecting `RawUsageDatum` */
export type RawUsageDatumInput = {
  clientHash?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  payload?: InputMaybe<Scalars['JSON']>;
  remoteAddress?: InputMaybe<Array<InputMaybe<Scalars['InternetAddress']>>>;
  trackedAt?: InputMaybe<Scalars['Datetime']>;
  trialId?: InputMaybe<Scalars['UUID']>;
  type: Scalars['String'];
  userAgent?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Represents an update to a `RawUsageDatum`. Fields that are set will be updated. */
export type RawUsageDatumPatch = {
  clientHash?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  payload?: InputMaybe<Scalars['JSON']>;
  remoteAddress?: InputMaybe<Array<InputMaybe<Scalars['InternetAddress']>>>;
  trackedAt?: InputMaybe<Scalars['Datetime']>;
  trialId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<Scalars['String']>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** All input for the `setAvatar` mutation. */
export type SetAvatarInput = {
  avatar?: InputMaybe<AvatarIcon>;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `setAvatar` mutation. */
export type SetAvatarPayload = {
  __typename?: 'SetAvatarPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Commentable` that is related to this `Trial`. */
  commentableById?: Maybe<Commentable>;
  /** Reads a single `User` that is related to this `Trial`. */
  createdBy?: Maybe<User>;
  /** Reads a single `GroupHome` that is related to this `Trial`. */
  groupHomeById?: Maybe<GroupHome>;
  /** Reads a single `Conversation` that is related to this `Trial`. */
  internalMessages?: Maybe<Conversation>;
  /** Reads a single `Conversation` that is related to this `Trial`. */
  messages?: Maybe<Conversation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Group` that is related to this `Trial`. */
  staff?: Maybe<Group>;
  /** Reads a single `User` that is related to this `Trial`. */
  subject?: Maybe<User>;
  /** Reads a single `Tenant` that is related to this `Trial`. */
  tenant?: Maybe<Tenant>;
  trial?: Maybe<Trial>;
  /** An edge for our `Trial`. May be used by Relay 1. */
  trialEdge?: Maybe<TrialsEdge>;
};


/** The output of our `setAvatar` mutation. */
export type SetAvatarPayloadTrialEdgeArgs = {
  orderBy?: InputMaybe<Array<TrialsOrderBy>>;
};

/** All input for the `setEmergencyPhoneNumbers` mutation. */
export type SetEmergencyPhoneNumbersInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  phoneNumbers: Array<InputMaybe<EmergencyContactInput>>;
};

/** The output of our `setEmergencyPhoneNumbers` mutation. */
export type SetEmergencyPhoneNumbersPayload = {
  __typename?: 'SetEmergencyPhoneNumbersPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Commentable` that is related to this `Trial`. */
  commentableById?: Maybe<Commentable>;
  /** Reads a single `User` that is related to this `Trial`. */
  createdBy?: Maybe<User>;
  /** Reads a single `GroupHome` that is related to this `Trial`. */
  groupHomeById?: Maybe<GroupHome>;
  /** Reads a single `Conversation` that is related to this `Trial`. */
  internalMessages?: Maybe<Conversation>;
  /** Reads a single `Conversation` that is related to this `Trial`. */
  messages?: Maybe<Conversation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Group` that is related to this `Trial`. */
  staff?: Maybe<Group>;
  /** Reads a single `User` that is related to this `Trial`. */
  subject?: Maybe<User>;
  /** Reads a single `Tenant` that is related to this `Trial`. */
  tenant?: Maybe<Tenant>;
  trial?: Maybe<Trial>;
  /** An edge for our `Trial`. May be used by Relay 1. */
  trialEdge?: Maybe<TrialsEdge>;
};


/** The output of our `setEmergencyPhoneNumbers` mutation. */
export type SetEmergencyPhoneNumbersPayloadTrialEdgeArgs = {
  orderBy?: InputMaybe<Array<TrialsOrderBy>>;
};

/** All input for the `setNickname` mutation. */
export type SetNicknameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  nickname?: InputMaybe<Scalars['String']>;
};

/** The output of our `setNickname` mutation. */
export type SetNicknamePayload = {
  __typename?: 'SetNicknamePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Commentable` that is related to this `Trial`. */
  commentableById?: Maybe<Commentable>;
  /** Reads a single `User` that is related to this `Trial`. */
  createdBy?: Maybe<User>;
  /** Reads a single `GroupHome` that is related to this `Trial`. */
  groupHomeById?: Maybe<GroupHome>;
  /** Reads a single `Conversation` that is related to this `Trial`. */
  internalMessages?: Maybe<Conversation>;
  /** Reads a single `Conversation` that is related to this `Trial`. */
  messages?: Maybe<Conversation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Group` that is related to this `Trial`. */
  staff?: Maybe<Group>;
  /** Reads a single `User` that is related to this `Trial`. */
  subject?: Maybe<User>;
  /** Reads a single `Tenant` that is related to this `Trial`. */
  tenant?: Maybe<Tenant>;
  trial?: Maybe<Trial>;
  /** An edge for our `Trial`. May be used by Relay 1. */
  trialEdge?: Maybe<TrialsEdge>;
};


/** The output of our `setNickname` mutation. */
export type SetNicknamePayloadTrialEdgeArgs = {
  orderBy?: InputMaybe<Array<TrialsOrderBy>>;
};

/** All input for the `signIn` mutation. */
export type SignInInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  emailOrUsername: Scalars['String'];
  password: Scalars['String'];
  tenantId?: InputMaybe<Scalars['UUID']>;
};

/** The output of our `signIn` mutation. */
export type SignInPayload = {
  __typename?: 'SignInPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  result?: Maybe<SignInRecord>;
};

/** The return type of our `signIn` mutation. */
export type SignInRecord = {
  __typename?: 'SignInRecord';
  tenant?: Maybe<Tenant>;
  token?: Maybe<AuthToken>;
  user?: Maybe<User>;
};

/** All input for the `signUpWithAccessToken` mutation. */
export type SignUpWithAccessTokenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** The output of our `signUpWithAccessToken` mutation. */
export type SignUpWithAccessTokenPayload = {
  __typename?: 'SignUpWithAccessTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  result?: Maybe<SignUpWithAccessTokenRecord>;
};

/** The return type of our `signUpWithAccessToken` mutation. */
export type SignUpWithAccessTokenRecord = {
  __typename?: 'SignUpWithAccessTokenRecord';
  tenant?: Maybe<Tenant>;
  user?: Maybe<User>;
};

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against String List fields. All fields are combined with a logical ‘and.’ */
export type StringListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['String']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['String']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['String']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['String']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['String']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type Subscription = {
  __typename?: 'Subscription';
  listen: ListenPayload;
};


/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type SubscriptionListenArgs = {
  topic: Scalars['String'];
};

export type Tenant = Node & {
  __typename?: 'Tenant';
  /** Reads and enables pagination through a set of `Conversation`. */
  conversations: ConversationsConnection;
  createdAt: Scalars['Datetime'];
  /** Reads and enables pagination through a set of `Group`. */
  groups: GroupsConnection;
  id: Scalars['UUID'];
  keycloakRealmUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `Trial`. */
  trials: TrialsConnection;
  updatedAt: Scalars['Datetime'];
  url?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `UserCredential`. */
  userCredentials: UserCredentialsConnection;
  /** Reads and enables pagination through a set of `User`. */
  users: UsersConnection;
};


export type TenantConversationsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ConversationCondition>;
  filter?: InputMaybe<ConversationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
};


export type TenantGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupCondition>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


export type TenantTrialsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TrialCondition>;
  filter?: InputMaybe<TrialFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TrialsOrderBy>>;
};


export type TenantUserCredentialsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCredentialCondition>;
  filter?: InputMaybe<UserCredentialFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserCredentialsOrderBy>>;
};


export type TenantUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

export type TenantAggregates = {
  __typename?: 'TenantAggregates';
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<TenantDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
};

/** A condition to be used against `Tenant` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type TenantCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `keycloakRealmUrl` field. */
  keycloakRealmUrl?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `url` field. */
  url?: InputMaybe<Scalars['String']>;
};

export type TenantDistinctCountAggregates = {
  __typename?: 'TenantDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']>;
  /** Distinct count of keycloakRealmUrl across the matching connection */
  keycloakRealmUrl?: Maybe<Scalars['BigInt']>;
  /** Distinct count of name across the matching connection */
  name?: Maybe<Scalars['BigInt']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of url across the matching connection */
  url?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `Tenant` object types. All fields are combined with a logical ‘and.’ */
export type TenantFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TenantFilter>>;
  /** Filter by the object’s `conversations` relation. */
  conversations?: InputMaybe<TenantToManyConversationFilter>;
  /** Some related `conversations` exist. */
  conversationsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `groups` relation. */
  groups?: InputMaybe<TenantToManyGroupFilter>;
  /** Some related `groups` exist. */
  groupsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `keycloakRealmUrl` field. */
  keycloakRealmUrl?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TenantFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TenantFilter>>;
  /** Filter by the object’s `trials` relation. */
  trials?: InputMaybe<TenantToManyTrialFilter>;
  /** Some related `trials` exist. */
  trialsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `url` field. */
  url?: InputMaybe<StringFilter>;
  /** Filter by the object’s `userCredentials` relation. */
  userCredentials?: InputMaybe<TenantToManyUserCredentialFilter>;
  /** Some related `userCredentials` exist. */
  userCredentialsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `users` relation. */
  users?: InputMaybe<TenantToManyUserFilter>;
  /** Some related `users` exist. */
  usersExist?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `Tenant` */
export type TenantInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  keycloakRealmUrl?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
};

/** Represents an update to a `Tenant`. Fields that are set will be updated. */
export type TenantPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  id?: InputMaybe<Scalars['UUID']>;
  keycloakRealmUrl?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  url?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against many `Conversation` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyConversationFilter = {
  /** Aggregates across related `Conversation` match the filter criteria. */
  aggregates?: InputMaybe<ConversationAggregatesFilter>;
  /** Every related `Conversation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ConversationFilter>;
  /** No related `Conversation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ConversationFilter>;
  /** Some related `Conversation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ConversationFilter>;
};

/** A filter to be used against many `Group` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyGroupFilter = {
  /** Aggregates across related `Group` match the filter criteria. */
  aggregates?: InputMaybe<GroupAggregatesFilter>;
  /** Every related `Group` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GroupFilter>;
  /** No related `Group` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GroupFilter>;
  /** Some related `Group` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GroupFilter>;
};

/** A filter to be used against many `Trial` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyTrialFilter = {
  /** Aggregates across related `Trial` match the filter criteria. */
  aggregates?: InputMaybe<TrialAggregatesFilter>;
  /** Every related `Trial` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TrialFilter>;
  /** No related `Trial` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TrialFilter>;
  /** Some related `Trial` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TrialFilter>;
};

/** A filter to be used against many `UserCredential` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyUserCredentialFilter = {
  /** Aggregates across related `UserCredential` match the filter criteria. */
  aggregates?: InputMaybe<UserCredentialAggregatesFilter>;
  /** Every related `UserCredential` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserCredentialFilter>;
  /** No related `UserCredential` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserCredentialFilter>;
  /** Some related `UserCredential` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserCredentialFilter>;
};

/** A filter to be used against many `User` object types. All fields are combined with a logical ‘and.’ */
export type TenantToManyUserFilter = {
  /** Aggregates across related `User` match the filter criteria. */
  aggregates?: InputMaybe<UserAggregatesFilter>;
  /** Every related `User` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<UserFilter>;
  /** No related `User` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<UserFilter>;
  /** Some related `User` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<UserFilter>;
};

/** A connection to a list of `Tenant` values. */
export type TenantsConnection = {
  __typename?: 'TenantsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<TenantAggregates>;
  /** A list of edges which contains the `Tenant` and cursor to aid in pagination. */
  edges: Array<TenantsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<TenantAggregates>>;
  /** A list of `Tenant` objects. */
  nodes: Array<Tenant>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Tenant` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `Tenant` values. */
export type TenantsConnectionGroupedAggregatesArgs = {
  groupBy: Array<TenantsGroupBy>;
  having?: InputMaybe<TenantsHavingInput>;
};

/** A `Tenant` edge in the connection. */
export type TenantsEdge = {
  __typename?: 'TenantsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Tenant` at the end of the edge. */
  node: Tenant;
};

/** Grouping methods for `Tenant` for usage during aggregation. */
export type TenantsGroupBy =
  | 'CREATED_AT'
  | 'CREATED_AT_TRUNCATED_TO_DAY'
  | 'CREATED_AT_TRUNCATED_TO_HOUR'
  | 'KEYCLOAK_REALM_URL'
  | 'UPDATED_AT'
  | 'UPDATED_AT_TRUNCATED_TO_DAY'
  | 'UPDATED_AT_TRUNCATED_TO_HOUR';

export type TenantsHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TenantsHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `Tenant` aggregates. */
export type TenantsHavingInput = {
  AND?: InputMaybe<Array<TenantsHavingInput>>;
  OR?: InputMaybe<Array<TenantsHavingInput>>;
  average?: InputMaybe<TenantsHavingAverageInput>;
  distinctCount?: InputMaybe<TenantsHavingDistinctCountInput>;
  max?: InputMaybe<TenantsHavingMaxInput>;
  min?: InputMaybe<TenantsHavingMinInput>;
  stddevPopulation?: InputMaybe<TenantsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<TenantsHavingStddevSampleInput>;
  sum?: InputMaybe<TenantsHavingSumInput>;
  variancePopulation?: InputMaybe<TenantsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<TenantsHavingVarianceSampleInput>;
};

export type TenantsHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TenantsHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TenantsHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TenantsHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TenantsHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TenantsHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TenantsHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `Tenant`. */
export type TenantsOrderBy =
  | 'CONVERSATIONS_AVERAGE_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_AVERAGE_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_AVERAGE_ABSTRACT_ASC'
  | 'CONVERSATIONS_AVERAGE_ABSTRACT_DESC'
  | 'CONVERSATIONS_AVERAGE_CREATED_AT_ASC'
  | 'CONVERSATIONS_AVERAGE_CREATED_AT_DESC'
  | 'CONVERSATIONS_AVERAGE_CREATOR_ID_ASC'
  | 'CONVERSATIONS_AVERAGE_CREATOR_ID_DESC'
  | 'CONVERSATIONS_AVERAGE_ID_ASC'
  | 'CONVERSATIONS_AVERAGE_ID_DESC'
  | 'CONVERSATIONS_AVERAGE_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_AVERAGE_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_AVERAGE_LANGUAGE_ASC'
  | 'CONVERSATIONS_AVERAGE_LANGUAGE_DESC'
  | 'CONVERSATIONS_AVERAGE_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_AVERAGE_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_AVERAGE_TENANT_ID_ASC'
  | 'CONVERSATIONS_AVERAGE_TENANT_ID_DESC'
  | 'CONVERSATIONS_AVERAGE_TITLE_ASC'
  | 'CONVERSATIONS_AVERAGE_TITLE_DESC'
  | 'CONVERSATIONS_AVERAGE_UPDATED_AT_ASC'
  | 'CONVERSATIONS_AVERAGE_UPDATED_AT_DESC'
  | 'CONVERSATIONS_COUNT_ASC'
  | 'CONVERSATIONS_COUNT_DESC'
  | 'CONVERSATIONS_DISTINCT_COUNT_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_DISTINCT_COUNT_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_DISTINCT_COUNT_ABSTRACT_ASC'
  | 'CONVERSATIONS_DISTINCT_COUNT_ABSTRACT_DESC'
  | 'CONVERSATIONS_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'CONVERSATIONS_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'CONVERSATIONS_DISTINCT_COUNT_CREATOR_ID_ASC'
  | 'CONVERSATIONS_DISTINCT_COUNT_CREATOR_ID_DESC'
  | 'CONVERSATIONS_DISTINCT_COUNT_ID_ASC'
  | 'CONVERSATIONS_DISTINCT_COUNT_ID_DESC'
  | 'CONVERSATIONS_DISTINCT_COUNT_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_DISTINCT_COUNT_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_DISTINCT_COUNT_LANGUAGE_ASC'
  | 'CONVERSATIONS_DISTINCT_COUNT_LANGUAGE_DESC'
  | 'CONVERSATIONS_DISTINCT_COUNT_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_DISTINCT_COUNT_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_DISTINCT_COUNT_TENANT_ID_ASC'
  | 'CONVERSATIONS_DISTINCT_COUNT_TENANT_ID_DESC'
  | 'CONVERSATIONS_DISTINCT_COUNT_TITLE_ASC'
  | 'CONVERSATIONS_DISTINCT_COUNT_TITLE_DESC'
  | 'CONVERSATIONS_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'CONVERSATIONS_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'CONVERSATIONS_MAX_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_MAX_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_MAX_ABSTRACT_ASC'
  | 'CONVERSATIONS_MAX_ABSTRACT_DESC'
  | 'CONVERSATIONS_MAX_CREATED_AT_ASC'
  | 'CONVERSATIONS_MAX_CREATED_AT_DESC'
  | 'CONVERSATIONS_MAX_CREATOR_ID_ASC'
  | 'CONVERSATIONS_MAX_CREATOR_ID_DESC'
  | 'CONVERSATIONS_MAX_ID_ASC'
  | 'CONVERSATIONS_MAX_ID_DESC'
  | 'CONVERSATIONS_MAX_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_MAX_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_MAX_LANGUAGE_ASC'
  | 'CONVERSATIONS_MAX_LANGUAGE_DESC'
  | 'CONVERSATIONS_MAX_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_MAX_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_MAX_TENANT_ID_ASC'
  | 'CONVERSATIONS_MAX_TENANT_ID_DESC'
  | 'CONVERSATIONS_MAX_TITLE_ASC'
  | 'CONVERSATIONS_MAX_TITLE_DESC'
  | 'CONVERSATIONS_MAX_UPDATED_AT_ASC'
  | 'CONVERSATIONS_MAX_UPDATED_AT_DESC'
  | 'CONVERSATIONS_MIN_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_MIN_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_MIN_ABSTRACT_ASC'
  | 'CONVERSATIONS_MIN_ABSTRACT_DESC'
  | 'CONVERSATIONS_MIN_CREATED_AT_ASC'
  | 'CONVERSATIONS_MIN_CREATED_AT_DESC'
  | 'CONVERSATIONS_MIN_CREATOR_ID_ASC'
  | 'CONVERSATIONS_MIN_CREATOR_ID_DESC'
  | 'CONVERSATIONS_MIN_ID_ASC'
  | 'CONVERSATIONS_MIN_ID_DESC'
  | 'CONVERSATIONS_MIN_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_MIN_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_MIN_LANGUAGE_ASC'
  | 'CONVERSATIONS_MIN_LANGUAGE_DESC'
  | 'CONVERSATIONS_MIN_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_MIN_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_MIN_TENANT_ID_ASC'
  | 'CONVERSATIONS_MIN_TENANT_ID_DESC'
  | 'CONVERSATIONS_MIN_TITLE_ASC'
  | 'CONVERSATIONS_MIN_TITLE_DESC'
  | 'CONVERSATIONS_MIN_UPDATED_AT_ASC'
  | 'CONVERSATIONS_MIN_UPDATED_AT_DESC'
  | 'CONVERSATIONS_STDDEV_POPULATION_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_STDDEV_POPULATION_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_STDDEV_POPULATION_ABSTRACT_ASC'
  | 'CONVERSATIONS_STDDEV_POPULATION_ABSTRACT_DESC'
  | 'CONVERSATIONS_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'CONVERSATIONS_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'CONVERSATIONS_STDDEV_POPULATION_CREATOR_ID_ASC'
  | 'CONVERSATIONS_STDDEV_POPULATION_CREATOR_ID_DESC'
  | 'CONVERSATIONS_STDDEV_POPULATION_ID_ASC'
  | 'CONVERSATIONS_STDDEV_POPULATION_ID_DESC'
  | 'CONVERSATIONS_STDDEV_POPULATION_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_STDDEV_POPULATION_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_STDDEV_POPULATION_LANGUAGE_ASC'
  | 'CONVERSATIONS_STDDEV_POPULATION_LANGUAGE_DESC'
  | 'CONVERSATIONS_STDDEV_POPULATION_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_STDDEV_POPULATION_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_STDDEV_POPULATION_TENANT_ID_ASC'
  | 'CONVERSATIONS_STDDEV_POPULATION_TENANT_ID_DESC'
  | 'CONVERSATIONS_STDDEV_POPULATION_TITLE_ASC'
  | 'CONVERSATIONS_STDDEV_POPULATION_TITLE_DESC'
  | 'CONVERSATIONS_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'CONVERSATIONS_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'CONVERSATIONS_STDDEV_SAMPLE_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_STDDEV_SAMPLE_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_STDDEV_SAMPLE_ABSTRACT_ASC'
  | 'CONVERSATIONS_STDDEV_SAMPLE_ABSTRACT_DESC'
  | 'CONVERSATIONS_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'CONVERSATIONS_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'CONVERSATIONS_STDDEV_SAMPLE_CREATOR_ID_ASC'
  | 'CONVERSATIONS_STDDEV_SAMPLE_CREATOR_ID_DESC'
  | 'CONVERSATIONS_STDDEV_SAMPLE_ID_ASC'
  | 'CONVERSATIONS_STDDEV_SAMPLE_ID_DESC'
  | 'CONVERSATIONS_STDDEV_SAMPLE_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_STDDEV_SAMPLE_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_STDDEV_SAMPLE_LANGUAGE_ASC'
  | 'CONVERSATIONS_STDDEV_SAMPLE_LANGUAGE_DESC'
  | 'CONVERSATIONS_STDDEV_SAMPLE_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_STDDEV_SAMPLE_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_STDDEV_SAMPLE_TENANT_ID_ASC'
  | 'CONVERSATIONS_STDDEV_SAMPLE_TENANT_ID_DESC'
  | 'CONVERSATIONS_STDDEV_SAMPLE_TITLE_ASC'
  | 'CONVERSATIONS_STDDEV_SAMPLE_TITLE_DESC'
  | 'CONVERSATIONS_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'CONVERSATIONS_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'CONVERSATIONS_SUM_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_SUM_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_SUM_ABSTRACT_ASC'
  | 'CONVERSATIONS_SUM_ABSTRACT_DESC'
  | 'CONVERSATIONS_SUM_CREATED_AT_ASC'
  | 'CONVERSATIONS_SUM_CREATED_AT_DESC'
  | 'CONVERSATIONS_SUM_CREATOR_ID_ASC'
  | 'CONVERSATIONS_SUM_CREATOR_ID_DESC'
  | 'CONVERSATIONS_SUM_ID_ASC'
  | 'CONVERSATIONS_SUM_ID_DESC'
  | 'CONVERSATIONS_SUM_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_SUM_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_SUM_LANGUAGE_ASC'
  | 'CONVERSATIONS_SUM_LANGUAGE_DESC'
  | 'CONVERSATIONS_SUM_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_SUM_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_SUM_TENANT_ID_ASC'
  | 'CONVERSATIONS_SUM_TENANT_ID_DESC'
  | 'CONVERSATIONS_SUM_TITLE_ASC'
  | 'CONVERSATIONS_SUM_TITLE_DESC'
  | 'CONVERSATIONS_SUM_UPDATED_AT_ASC'
  | 'CONVERSATIONS_SUM_UPDATED_AT_DESC'
  | 'CONVERSATIONS_VARIANCE_POPULATION_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_VARIANCE_POPULATION_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_VARIANCE_POPULATION_ABSTRACT_ASC'
  | 'CONVERSATIONS_VARIANCE_POPULATION_ABSTRACT_DESC'
  | 'CONVERSATIONS_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'CONVERSATIONS_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'CONVERSATIONS_VARIANCE_POPULATION_CREATOR_ID_ASC'
  | 'CONVERSATIONS_VARIANCE_POPULATION_CREATOR_ID_DESC'
  | 'CONVERSATIONS_VARIANCE_POPULATION_ID_ASC'
  | 'CONVERSATIONS_VARIANCE_POPULATION_ID_DESC'
  | 'CONVERSATIONS_VARIANCE_POPULATION_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_VARIANCE_POPULATION_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_VARIANCE_POPULATION_LANGUAGE_ASC'
  | 'CONVERSATIONS_VARIANCE_POPULATION_LANGUAGE_DESC'
  | 'CONVERSATIONS_VARIANCE_POPULATION_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_VARIANCE_POPULATION_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_VARIANCE_POPULATION_TENANT_ID_ASC'
  | 'CONVERSATIONS_VARIANCE_POPULATION_TENANT_ID_DESC'
  | 'CONVERSATIONS_VARIANCE_POPULATION_TITLE_ASC'
  | 'CONVERSATIONS_VARIANCE_POPULATION_TITLE_DESC'
  | 'CONVERSATIONS_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'CONVERSATIONS_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'CONVERSATIONS_VARIANCE_SAMPLE_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_VARIANCE_SAMPLE_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_VARIANCE_SAMPLE_ABSTRACT_ASC'
  | 'CONVERSATIONS_VARIANCE_SAMPLE_ABSTRACT_DESC'
  | 'CONVERSATIONS_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'CONVERSATIONS_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'CONVERSATIONS_VARIANCE_SAMPLE_CREATOR_ID_ASC'
  | 'CONVERSATIONS_VARIANCE_SAMPLE_CREATOR_ID_DESC'
  | 'CONVERSATIONS_VARIANCE_SAMPLE_ID_ASC'
  | 'CONVERSATIONS_VARIANCE_SAMPLE_ID_DESC'
  | 'CONVERSATIONS_VARIANCE_SAMPLE_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_VARIANCE_SAMPLE_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_VARIANCE_SAMPLE_LANGUAGE_ASC'
  | 'CONVERSATIONS_VARIANCE_SAMPLE_LANGUAGE_DESC'
  | 'CONVERSATIONS_VARIANCE_SAMPLE_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_VARIANCE_SAMPLE_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_VARIANCE_SAMPLE_TENANT_ID_ASC'
  | 'CONVERSATIONS_VARIANCE_SAMPLE_TENANT_ID_DESC'
  | 'CONVERSATIONS_VARIANCE_SAMPLE_TITLE_ASC'
  | 'CONVERSATIONS_VARIANCE_SAMPLE_TITLE_DESC'
  | 'CONVERSATIONS_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'CONVERSATIONS_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'GROUPS_AVERAGE_CAN_JOIN_ASC'
  | 'GROUPS_AVERAGE_CAN_JOIN_DESC'
  | 'GROUPS_AVERAGE_CAN_MANAGE_ASC'
  | 'GROUPS_AVERAGE_CAN_MANAGE_DESC'
  | 'GROUPS_AVERAGE_CREATED_AT_ASC'
  | 'GROUPS_AVERAGE_CREATED_AT_DESC'
  | 'GROUPS_AVERAGE_CREATOR_ID_ASC'
  | 'GROUPS_AVERAGE_CREATOR_ID_DESC'
  | 'GROUPS_AVERAGE_EXTERNAL_NAMES_ASC'
  | 'GROUPS_AVERAGE_EXTERNAL_NAMES_DESC'
  | 'GROUPS_AVERAGE_FLAGS_ASC'
  | 'GROUPS_AVERAGE_FLAGS_DESC'
  | 'GROUPS_AVERAGE_HOME_ID_ASC'
  | 'GROUPS_AVERAGE_HOME_ID_DESC'
  | 'GROUPS_AVERAGE_ID_ASC'
  | 'GROUPS_AVERAGE_ID_DESC'
  | 'GROUPS_AVERAGE_NAME_ASC'
  | 'GROUPS_AVERAGE_NAME_DESC'
  | 'GROUPS_AVERAGE_TENANT_ID_ASC'
  | 'GROUPS_AVERAGE_TENANT_ID_DESC'
  | 'GROUPS_AVERAGE_UPDATED_AT_ASC'
  | 'GROUPS_AVERAGE_UPDATED_AT_DESC'
  | 'GROUPS_COUNT_ASC'
  | 'GROUPS_COUNT_DESC'
  | 'GROUPS_DISTINCT_COUNT_CAN_JOIN_ASC'
  | 'GROUPS_DISTINCT_COUNT_CAN_JOIN_DESC'
  | 'GROUPS_DISTINCT_COUNT_CAN_MANAGE_ASC'
  | 'GROUPS_DISTINCT_COUNT_CAN_MANAGE_DESC'
  | 'GROUPS_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'GROUPS_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'GROUPS_DISTINCT_COUNT_CREATOR_ID_ASC'
  | 'GROUPS_DISTINCT_COUNT_CREATOR_ID_DESC'
  | 'GROUPS_DISTINCT_COUNT_EXTERNAL_NAMES_ASC'
  | 'GROUPS_DISTINCT_COUNT_EXTERNAL_NAMES_DESC'
  | 'GROUPS_DISTINCT_COUNT_FLAGS_ASC'
  | 'GROUPS_DISTINCT_COUNT_FLAGS_DESC'
  | 'GROUPS_DISTINCT_COUNT_HOME_ID_ASC'
  | 'GROUPS_DISTINCT_COUNT_HOME_ID_DESC'
  | 'GROUPS_DISTINCT_COUNT_ID_ASC'
  | 'GROUPS_DISTINCT_COUNT_ID_DESC'
  | 'GROUPS_DISTINCT_COUNT_NAME_ASC'
  | 'GROUPS_DISTINCT_COUNT_NAME_DESC'
  | 'GROUPS_DISTINCT_COUNT_TENANT_ID_ASC'
  | 'GROUPS_DISTINCT_COUNT_TENANT_ID_DESC'
  | 'GROUPS_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'GROUPS_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'GROUPS_MAX_CAN_JOIN_ASC'
  | 'GROUPS_MAX_CAN_JOIN_DESC'
  | 'GROUPS_MAX_CAN_MANAGE_ASC'
  | 'GROUPS_MAX_CAN_MANAGE_DESC'
  | 'GROUPS_MAX_CREATED_AT_ASC'
  | 'GROUPS_MAX_CREATED_AT_DESC'
  | 'GROUPS_MAX_CREATOR_ID_ASC'
  | 'GROUPS_MAX_CREATOR_ID_DESC'
  | 'GROUPS_MAX_EXTERNAL_NAMES_ASC'
  | 'GROUPS_MAX_EXTERNAL_NAMES_DESC'
  | 'GROUPS_MAX_FLAGS_ASC'
  | 'GROUPS_MAX_FLAGS_DESC'
  | 'GROUPS_MAX_HOME_ID_ASC'
  | 'GROUPS_MAX_HOME_ID_DESC'
  | 'GROUPS_MAX_ID_ASC'
  | 'GROUPS_MAX_ID_DESC'
  | 'GROUPS_MAX_NAME_ASC'
  | 'GROUPS_MAX_NAME_DESC'
  | 'GROUPS_MAX_TENANT_ID_ASC'
  | 'GROUPS_MAX_TENANT_ID_DESC'
  | 'GROUPS_MAX_UPDATED_AT_ASC'
  | 'GROUPS_MAX_UPDATED_AT_DESC'
  | 'GROUPS_MIN_CAN_JOIN_ASC'
  | 'GROUPS_MIN_CAN_JOIN_DESC'
  | 'GROUPS_MIN_CAN_MANAGE_ASC'
  | 'GROUPS_MIN_CAN_MANAGE_DESC'
  | 'GROUPS_MIN_CREATED_AT_ASC'
  | 'GROUPS_MIN_CREATED_AT_DESC'
  | 'GROUPS_MIN_CREATOR_ID_ASC'
  | 'GROUPS_MIN_CREATOR_ID_DESC'
  | 'GROUPS_MIN_EXTERNAL_NAMES_ASC'
  | 'GROUPS_MIN_EXTERNAL_NAMES_DESC'
  | 'GROUPS_MIN_FLAGS_ASC'
  | 'GROUPS_MIN_FLAGS_DESC'
  | 'GROUPS_MIN_HOME_ID_ASC'
  | 'GROUPS_MIN_HOME_ID_DESC'
  | 'GROUPS_MIN_ID_ASC'
  | 'GROUPS_MIN_ID_DESC'
  | 'GROUPS_MIN_NAME_ASC'
  | 'GROUPS_MIN_NAME_DESC'
  | 'GROUPS_MIN_TENANT_ID_ASC'
  | 'GROUPS_MIN_TENANT_ID_DESC'
  | 'GROUPS_MIN_UPDATED_AT_ASC'
  | 'GROUPS_MIN_UPDATED_AT_DESC'
  | 'GROUPS_STDDEV_POPULATION_CAN_JOIN_ASC'
  | 'GROUPS_STDDEV_POPULATION_CAN_JOIN_DESC'
  | 'GROUPS_STDDEV_POPULATION_CAN_MANAGE_ASC'
  | 'GROUPS_STDDEV_POPULATION_CAN_MANAGE_DESC'
  | 'GROUPS_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'GROUPS_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'GROUPS_STDDEV_POPULATION_CREATOR_ID_ASC'
  | 'GROUPS_STDDEV_POPULATION_CREATOR_ID_DESC'
  | 'GROUPS_STDDEV_POPULATION_EXTERNAL_NAMES_ASC'
  | 'GROUPS_STDDEV_POPULATION_EXTERNAL_NAMES_DESC'
  | 'GROUPS_STDDEV_POPULATION_FLAGS_ASC'
  | 'GROUPS_STDDEV_POPULATION_FLAGS_DESC'
  | 'GROUPS_STDDEV_POPULATION_HOME_ID_ASC'
  | 'GROUPS_STDDEV_POPULATION_HOME_ID_DESC'
  | 'GROUPS_STDDEV_POPULATION_ID_ASC'
  | 'GROUPS_STDDEV_POPULATION_ID_DESC'
  | 'GROUPS_STDDEV_POPULATION_NAME_ASC'
  | 'GROUPS_STDDEV_POPULATION_NAME_DESC'
  | 'GROUPS_STDDEV_POPULATION_TENANT_ID_ASC'
  | 'GROUPS_STDDEV_POPULATION_TENANT_ID_DESC'
  | 'GROUPS_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'GROUPS_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'GROUPS_STDDEV_SAMPLE_CAN_JOIN_ASC'
  | 'GROUPS_STDDEV_SAMPLE_CAN_JOIN_DESC'
  | 'GROUPS_STDDEV_SAMPLE_CAN_MANAGE_ASC'
  | 'GROUPS_STDDEV_SAMPLE_CAN_MANAGE_DESC'
  | 'GROUPS_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'GROUPS_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'GROUPS_STDDEV_SAMPLE_CREATOR_ID_ASC'
  | 'GROUPS_STDDEV_SAMPLE_CREATOR_ID_DESC'
  | 'GROUPS_STDDEV_SAMPLE_EXTERNAL_NAMES_ASC'
  | 'GROUPS_STDDEV_SAMPLE_EXTERNAL_NAMES_DESC'
  | 'GROUPS_STDDEV_SAMPLE_FLAGS_ASC'
  | 'GROUPS_STDDEV_SAMPLE_FLAGS_DESC'
  | 'GROUPS_STDDEV_SAMPLE_HOME_ID_ASC'
  | 'GROUPS_STDDEV_SAMPLE_HOME_ID_DESC'
  | 'GROUPS_STDDEV_SAMPLE_ID_ASC'
  | 'GROUPS_STDDEV_SAMPLE_ID_DESC'
  | 'GROUPS_STDDEV_SAMPLE_NAME_ASC'
  | 'GROUPS_STDDEV_SAMPLE_NAME_DESC'
  | 'GROUPS_STDDEV_SAMPLE_TENANT_ID_ASC'
  | 'GROUPS_STDDEV_SAMPLE_TENANT_ID_DESC'
  | 'GROUPS_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'GROUPS_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'GROUPS_SUM_CAN_JOIN_ASC'
  | 'GROUPS_SUM_CAN_JOIN_DESC'
  | 'GROUPS_SUM_CAN_MANAGE_ASC'
  | 'GROUPS_SUM_CAN_MANAGE_DESC'
  | 'GROUPS_SUM_CREATED_AT_ASC'
  | 'GROUPS_SUM_CREATED_AT_DESC'
  | 'GROUPS_SUM_CREATOR_ID_ASC'
  | 'GROUPS_SUM_CREATOR_ID_DESC'
  | 'GROUPS_SUM_EXTERNAL_NAMES_ASC'
  | 'GROUPS_SUM_EXTERNAL_NAMES_DESC'
  | 'GROUPS_SUM_FLAGS_ASC'
  | 'GROUPS_SUM_FLAGS_DESC'
  | 'GROUPS_SUM_HOME_ID_ASC'
  | 'GROUPS_SUM_HOME_ID_DESC'
  | 'GROUPS_SUM_ID_ASC'
  | 'GROUPS_SUM_ID_DESC'
  | 'GROUPS_SUM_NAME_ASC'
  | 'GROUPS_SUM_NAME_DESC'
  | 'GROUPS_SUM_TENANT_ID_ASC'
  | 'GROUPS_SUM_TENANT_ID_DESC'
  | 'GROUPS_SUM_UPDATED_AT_ASC'
  | 'GROUPS_SUM_UPDATED_AT_DESC'
  | 'GROUPS_VARIANCE_POPULATION_CAN_JOIN_ASC'
  | 'GROUPS_VARIANCE_POPULATION_CAN_JOIN_DESC'
  | 'GROUPS_VARIANCE_POPULATION_CAN_MANAGE_ASC'
  | 'GROUPS_VARIANCE_POPULATION_CAN_MANAGE_DESC'
  | 'GROUPS_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'GROUPS_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'GROUPS_VARIANCE_POPULATION_CREATOR_ID_ASC'
  | 'GROUPS_VARIANCE_POPULATION_CREATOR_ID_DESC'
  | 'GROUPS_VARIANCE_POPULATION_EXTERNAL_NAMES_ASC'
  | 'GROUPS_VARIANCE_POPULATION_EXTERNAL_NAMES_DESC'
  | 'GROUPS_VARIANCE_POPULATION_FLAGS_ASC'
  | 'GROUPS_VARIANCE_POPULATION_FLAGS_DESC'
  | 'GROUPS_VARIANCE_POPULATION_HOME_ID_ASC'
  | 'GROUPS_VARIANCE_POPULATION_HOME_ID_DESC'
  | 'GROUPS_VARIANCE_POPULATION_ID_ASC'
  | 'GROUPS_VARIANCE_POPULATION_ID_DESC'
  | 'GROUPS_VARIANCE_POPULATION_NAME_ASC'
  | 'GROUPS_VARIANCE_POPULATION_NAME_DESC'
  | 'GROUPS_VARIANCE_POPULATION_TENANT_ID_ASC'
  | 'GROUPS_VARIANCE_POPULATION_TENANT_ID_DESC'
  | 'GROUPS_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'GROUPS_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'GROUPS_VARIANCE_SAMPLE_CAN_JOIN_ASC'
  | 'GROUPS_VARIANCE_SAMPLE_CAN_JOIN_DESC'
  | 'GROUPS_VARIANCE_SAMPLE_CAN_MANAGE_ASC'
  | 'GROUPS_VARIANCE_SAMPLE_CAN_MANAGE_DESC'
  | 'GROUPS_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'GROUPS_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'GROUPS_VARIANCE_SAMPLE_CREATOR_ID_ASC'
  | 'GROUPS_VARIANCE_SAMPLE_CREATOR_ID_DESC'
  | 'GROUPS_VARIANCE_SAMPLE_EXTERNAL_NAMES_ASC'
  | 'GROUPS_VARIANCE_SAMPLE_EXTERNAL_NAMES_DESC'
  | 'GROUPS_VARIANCE_SAMPLE_FLAGS_ASC'
  | 'GROUPS_VARIANCE_SAMPLE_FLAGS_DESC'
  | 'GROUPS_VARIANCE_SAMPLE_HOME_ID_ASC'
  | 'GROUPS_VARIANCE_SAMPLE_HOME_ID_DESC'
  | 'GROUPS_VARIANCE_SAMPLE_ID_ASC'
  | 'GROUPS_VARIANCE_SAMPLE_ID_DESC'
  | 'GROUPS_VARIANCE_SAMPLE_NAME_ASC'
  | 'GROUPS_VARIANCE_SAMPLE_NAME_DESC'
  | 'GROUPS_VARIANCE_SAMPLE_TENANT_ID_ASC'
  | 'GROUPS_VARIANCE_SAMPLE_TENANT_ID_DESC'
  | 'GROUPS_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'GROUPS_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'KEYCLOAK_REALM_URL_ASC'
  | 'KEYCLOAK_REALM_URL_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TRIALS_AVERAGE_AVATAR_ASC'
  | 'TRIALS_AVERAGE_AVATAR_DESC'
  | 'TRIALS_AVERAGE_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_AVERAGE_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_AVERAGE_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_AVERAGE_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_AVERAGE_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_AVERAGE_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_AVERAGE_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_AVERAGE_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_AVERAGE_CREATED_AT_ASC'
  | 'TRIALS_AVERAGE_CREATED_AT_DESC'
  | 'TRIALS_AVERAGE_CREATED_BY_ID_ASC'
  | 'TRIALS_AVERAGE_CREATED_BY_ID_DESC'
  | 'TRIALS_AVERAGE_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_AVERAGE_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_AVERAGE_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_AVERAGE_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_AVERAGE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_AVERAGE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_AVERAGE_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_AVERAGE_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_AVERAGE_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_AVERAGE_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_AVERAGE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_AVERAGE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_AVERAGE_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_AVERAGE_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_AVERAGE_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_AVERAGE_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_AVERAGE_ID_ASC'
  | 'TRIALS_AVERAGE_ID_DESC'
  | 'TRIALS_AVERAGE_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_AVERAGE_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_AVERAGE_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_AVERAGE_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_AVERAGE_MESSAGES_ID_ASC'
  | 'TRIALS_AVERAGE_MESSAGES_ID_DESC'
  | 'TRIALS_AVERAGE_NAME_ASC'
  | 'TRIALS_AVERAGE_NAME_DESC'
  | 'TRIALS_AVERAGE_STAFF_ID_ASC'
  | 'TRIALS_AVERAGE_STAFF_ID_DESC'
  | 'TRIALS_AVERAGE_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_AVERAGE_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_AVERAGE_SUBJECT_ID_ASC'
  | 'TRIALS_AVERAGE_SUBJECT_ID_DESC'
  | 'TRIALS_AVERAGE_TENANT_ID_ASC'
  | 'TRIALS_AVERAGE_TENANT_ID_DESC'
  | 'TRIALS_AVERAGE_UPDATED_AT_ASC'
  | 'TRIALS_AVERAGE_UPDATED_AT_DESC'
  | 'TRIALS_COUNT_ASC'
  | 'TRIALS_COUNT_DESC'
  | 'TRIALS_DISTINCT_COUNT_AVATAR_ASC'
  | 'TRIALS_DISTINCT_COUNT_AVATAR_DESC'
  | 'TRIALS_DISTINCT_COUNT_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_DISTINCT_COUNT_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_DISTINCT_COUNT_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_DISTINCT_COUNT_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_DISTINCT_COUNT_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_DISTINCT_COUNT_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_DISTINCT_COUNT_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_DISTINCT_COUNT_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'TRIALS_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'TRIALS_DISTINCT_COUNT_CREATED_BY_ID_ASC'
  | 'TRIALS_DISTINCT_COUNT_CREATED_BY_ID_DESC'
  | 'TRIALS_DISTINCT_COUNT_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_DISTINCT_COUNT_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_DISTINCT_COUNT_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_DISTINCT_COUNT_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_DISTINCT_COUNT_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_DISTINCT_COUNT_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_DISTINCT_COUNT_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_DISTINCT_COUNT_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_DISTINCT_COUNT_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_DISTINCT_COUNT_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_DISTINCT_COUNT_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_DISTINCT_COUNT_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_DISTINCT_COUNT_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_DISTINCT_COUNT_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_DISTINCT_COUNT_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_DISTINCT_COUNT_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_DISTINCT_COUNT_ID_ASC'
  | 'TRIALS_DISTINCT_COUNT_ID_DESC'
  | 'TRIALS_DISTINCT_COUNT_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_DISTINCT_COUNT_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_DISTINCT_COUNT_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_DISTINCT_COUNT_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_DISTINCT_COUNT_MESSAGES_ID_ASC'
  | 'TRIALS_DISTINCT_COUNT_MESSAGES_ID_DESC'
  | 'TRIALS_DISTINCT_COUNT_NAME_ASC'
  | 'TRIALS_DISTINCT_COUNT_NAME_DESC'
  | 'TRIALS_DISTINCT_COUNT_STAFF_ID_ASC'
  | 'TRIALS_DISTINCT_COUNT_STAFF_ID_DESC'
  | 'TRIALS_DISTINCT_COUNT_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_DISTINCT_COUNT_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_DISTINCT_COUNT_SUBJECT_ID_ASC'
  | 'TRIALS_DISTINCT_COUNT_SUBJECT_ID_DESC'
  | 'TRIALS_DISTINCT_COUNT_TENANT_ID_ASC'
  | 'TRIALS_DISTINCT_COUNT_TENANT_ID_DESC'
  | 'TRIALS_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'TRIALS_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'TRIALS_MAX_AVATAR_ASC'
  | 'TRIALS_MAX_AVATAR_DESC'
  | 'TRIALS_MAX_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_MAX_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_MAX_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_MAX_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_MAX_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_MAX_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_MAX_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_MAX_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_MAX_CREATED_AT_ASC'
  | 'TRIALS_MAX_CREATED_AT_DESC'
  | 'TRIALS_MAX_CREATED_BY_ID_ASC'
  | 'TRIALS_MAX_CREATED_BY_ID_DESC'
  | 'TRIALS_MAX_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_MAX_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_MAX_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_MAX_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_MAX_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_MAX_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_MAX_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_MAX_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_MAX_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_MAX_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_MAX_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_MAX_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_MAX_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_MAX_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_MAX_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_MAX_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_MAX_ID_ASC'
  | 'TRIALS_MAX_ID_DESC'
  | 'TRIALS_MAX_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_MAX_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_MAX_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_MAX_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_MAX_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_MAX_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_MAX_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_MAX_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_MAX_MESSAGES_ID_ASC'
  | 'TRIALS_MAX_MESSAGES_ID_DESC'
  | 'TRIALS_MAX_NAME_ASC'
  | 'TRIALS_MAX_NAME_DESC'
  | 'TRIALS_MAX_STAFF_ID_ASC'
  | 'TRIALS_MAX_STAFF_ID_DESC'
  | 'TRIALS_MAX_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_MAX_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_MAX_SUBJECT_ID_ASC'
  | 'TRIALS_MAX_SUBJECT_ID_DESC'
  | 'TRIALS_MAX_TENANT_ID_ASC'
  | 'TRIALS_MAX_TENANT_ID_DESC'
  | 'TRIALS_MAX_UPDATED_AT_ASC'
  | 'TRIALS_MAX_UPDATED_AT_DESC'
  | 'TRIALS_MIN_AVATAR_ASC'
  | 'TRIALS_MIN_AVATAR_DESC'
  | 'TRIALS_MIN_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_MIN_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_MIN_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_MIN_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_MIN_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_MIN_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_MIN_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_MIN_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_MIN_CREATED_AT_ASC'
  | 'TRIALS_MIN_CREATED_AT_DESC'
  | 'TRIALS_MIN_CREATED_BY_ID_ASC'
  | 'TRIALS_MIN_CREATED_BY_ID_DESC'
  | 'TRIALS_MIN_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_MIN_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_MIN_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_MIN_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_MIN_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_MIN_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_MIN_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_MIN_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_MIN_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_MIN_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_MIN_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_MIN_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_MIN_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_MIN_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_MIN_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_MIN_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_MIN_ID_ASC'
  | 'TRIALS_MIN_ID_DESC'
  | 'TRIALS_MIN_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_MIN_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_MIN_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_MIN_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_MIN_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_MIN_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_MIN_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_MIN_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_MIN_MESSAGES_ID_ASC'
  | 'TRIALS_MIN_MESSAGES_ID_DESC'
  | 'TRIALS_MIN_NAME_ASC'
  | 'TRIALS_MIN_NAME_DESC'
  | 'TRIALS_MIN_STAFF_ID_ASC'
  | 'TRIALS_MIN_STAFF_ID_DESC'
  | 'TRIALS_MIN_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_MIN_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_MIN_SUBJECT_ID_ASC'
  | 'TRIALS_MIN_SUBJECT_ID_DESC'
  | 'TRIALS_MIN_TENANT_ID_ASC'
  | 'TRIALS_MIN_TENANT_ID_DESC'
  | 'TRIALS_MIN_UPDATED_AT_ASC'
  | 'TRIALS_MIN_UPDATED_AT_DESC'
  | 'TRIALS_STDDEV_POPULATION_AVATAR_ASC'
  | 'TRIALS_STDDEV_POPULATION_AVATAR_DESC'
  | 'TRIALS_STDDEV_POPULATION_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_STDDEV_POPULATION_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_STDDEV_POPULATION_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_STDDEV_POPULATION_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_STDDEV_POPULATION_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_STDDEV_POPULATION_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_STDDEV_POPULATION_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_STDDEV_POPULATION_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'TRIALS_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'TRIALS_STDDEV_POPULATION_CREATED_BY_ID_ASC'
  | 'TRIALS_STDDEV_POPULATION_CREATED_BY_ID_DESC'
  | 'TRIALS_STDDEV_POPULATION_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_STDDEV_POPULATION_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_STDDEV_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_STDDEV_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_STDDEV_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_STDDEV_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_STDDEV_POPULATION_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_STDDEV_POPULATION_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_STDDEV_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_STDDEV_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_STDDEV_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_STDDEV_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_STDDEV_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_STDDEV_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_STDDEV_POPULATION_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_STDDEV_POPULATION_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_STDDEV_POPULATION_ID_ASC'
  | 'TRIALS_STDDEV_POPULATION_ID_DESC'
  | 'TRIALS_STDDEV_POPULATION_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_STDDEV_POPULATION_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_STDDEV_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_STDDEV_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_STDDEV_POPULATION_MESSAGES_ID_ASC'
  | 'TRIALS_STDDEV_POPULATION_MESSAGES_ID_DESC'
  | 'TRIALS_STDDEV_POPULATION_NAME_ASC'
  | 'TRIALS_STDDEV_POPULATION_NAME_DESC'
  | 'TRIALS_STDDEV_POPULATION_STAFF_ID_ASC'
  | 'TRIALS_STDDEV_POPULATION_STAFF_ID_DESC'
  | 'TRIALS_STDDEV_POPULATION_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_STDDEV_POPULATION_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_STDDEV_POPULATION_SUBJECT_ID_ASC'
  | 'TRIALS_STDDEV_POPULATION_SUBJECT_ID_DESC'
  | 'TRIALS_STDDEV_POPULATION_TENANT_ID_ASC'
  | 'TRIALS_STDDEV_POPULATION_TENANT_ID_DESC'
  | 'TRIALS_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'TRIALS_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'TRIALS_STDDEV_SAMPLE_AVATAR_ASC'
  | 'TRIALS_STDDEV_SAMPLE_AVATAR_DESC'
  | 'TRIALS_STDDEV_SAMPLE_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_STDDEV_SAMPLE_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_STDDEV_SAMPLE_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_STDDEV_SAMPLE_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_STDDEV_SAMPLE_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_STDDEV_SAMPLE_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_STDDEV_SAMPLE_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_STDDEV_SAMPLE_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'TRIALS_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'TRIALS_STDDEV_SAMPLE_CREATED_BY_ID_ASC'
  | 'TRIALS_STDDEV_SAMPLE_CREATED_BY_ID_DESC'
  | 'TRIALS_STDDEV_SAMPLE_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_STDDEV_SAMPLE_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_STDDEV_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_STDDEV_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_STDDEV_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_STDDEV_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_STDDEV_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_STDDEV_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_STDDEV_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_STDDEV_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_STDDEV_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_STDDEV_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_STDDEV_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_STDDEV_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_STDDEV_SAMPLE_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_STDDEV_SAMPLE_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_STDDEV_SAMPLE_ID_ASC'
  | 'TRIALS_STDDEV_SAMPLE_ID_DESC'
  | 'TRIALS_STDDEV_SAMPLE_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_STDDEV_SAMPLE_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_STDDEV_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_STDDEV_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_STDDEV_SAMPLE_MESSAGES_ID_ASC'
  | 'TRIALS_STDDEV_SAMPLE_MESSAGES_ID_DESC'
  | 'TRIALS_STDDEV_SAMPLE_NAME_ASC'
  | 'TRIALS_STDDEV_SAMPLE_NAME_DESC'
  | 'TRIALS_STDDEV_SAMPLE_STAFF_ID_ASC'
  | 'TRIALS_STDDEV_SAMPLE_STAFF_ID_DESC'
  | 'TRIALS_STDDEV_SAMPLE_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_STDDEV_SAMPLE_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_STDDEV_SAMPLE_SUBJECT_ID_ASC'
  | 'TRIALS_STDDEV_SAMPLE_SUBJECT_ID_DESC'
  | 'TRIALS_STDDEV_SAMPLE_TENANT_ID_ASC'
  | 'TRIALS_STDDEV_SAMPLE_TENANT_ID_DESC'
  | 'TRIALS_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'TRIALS_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'TRIALS_SUM_AVATAR_ASC'
  | 'TRIALS_SUM_AVATAR_DESC'
  | 'TRIALS_SUM_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_SUM_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_SUM_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_SUM_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_SUM_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_SUM_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_SUM_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_SUM_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_SUM_CREATED_AT_ASC'
  | 'TRIALS_SUM_CREATED_AT_DESC'
  | 'TRIALS_SUM_CREATED_BY_ID_ASC'
  | 'TRIALS_SUM_CREATED_BY_ID_DESC'
  | 'TRIALS_SUM_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_SUM_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_SUM_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_SUM_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_SUM_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_SUM_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_SUM_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_SUM_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_SUM_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_SUM_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_SUM_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_SUM_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_SUM_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_SUM_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_SUM_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_SUM_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_SUM_ID_ASC'
  | 'TRIALS_SUM_ID_DESC'
  | 'TRIALS_SUM_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_SUM_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_SUM_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_SUM_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_SUM_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_SUM_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_SUM_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_SUM_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_SUM_MESSAGES_ID_ASC'
  | 'TRIALS_SUM_MESSAGES_ID_DESC'
  | 'TRIALS_SUM_NAME_ASC'
  | 'TRIALS_SUM_NAME_DESC'
  | 'TRIALS_SUM_STAFF_ID_ASC'
  | 'TRIALS_SUM_STAFF_ID_DESC'
  | 'TRIALS_SUM_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_SUM_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_SUM_SUBJECT_ID_ASC'
  | 'TRIALS_SUM_SUBJECT_ID_DESC'
  | 'TRIALS_SUM_TENANT_ID_ASC'
  | 'TRIALS_SUM_TENANT_ID_DESC'
  | 'TRIALS_SUM_UPDATED_AT_ASC'
  | 'TRIALS_SUM_UPDATED_AT_DESC'
  | 'TRIALS_VARIANCE_POPULATION_AVATAR_ASC'
  | 'TRIALS_VARIANCE_POPULATION_AVATAR_DESC'
  | 'TRIALS_VARIANCE_POPULATION_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_VARIANCE_POPULATION_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_VARIANCE_POPULATION_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_VARIANCE_POPULATION_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_VARIANCE_POPULATION_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_VARIANCE_POPULATION_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_VARIANCE_POPULATION_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_VARIANCE_POPULATION_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'TRIALS_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'TRIALS_VARIANCE_POPULATION_CREATED_BY_ID_ASC'
  | 'TRIALS_VARIANCE_POPULATION_CREATED_BY_ID_DESC'
  | 'TRIALS_VARIANCE_POPULATION_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_VARIANCE_POPULATION_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_VARIANCE_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_VARIANCE_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_VARIANCE_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_VARIANCE_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_VARIANCE_POPULATION_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_VARIANCE_POPULATION_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_VARIANCE_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_VARIANCE_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_VARIANCE_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_VARIANCE_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_VARIANCE_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_VARIANCE_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_VARIANCE_POPULATION_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_VARIANCE_POPULATION_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_VARIANCE_POPULATION_ID_ASC'
  | 'TRIALS_VARIANCE_POPULATION_ID_DESC'
  | 'TRIALS_VARIANCE_POPULATION_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_VARIANCE_POPULATION_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_VARIANCE_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_VARIANCE_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_VARIANCE_POPULATION_MESSAGES_ID_ASC'
  | 'TRIALS_VARIANCE_POPULATION_MESSAGES_ID_DESC'
  | 'TRIALS_VARIANCE_POPULATION_NAME_ASC'
  | 'TRIALS_VARIANCE_POPULATION_NAME_DESC'
  | 'TRIALS_VARIANCE_POPULATION_STAFF_ID_ASC'
  | 'TRIALS_VARIANCE_POPULATION_STAFF_ID_DESC'
  | 'TRIALS_VARIANCE_POPULATION_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_VARIANCE_POPULATION_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_VARIANCE_POPULATION_SUBJECT_ID_ASC'
  | 'TRIALS_VARIANCE_POPULATION_SUBJECT_ID_DESC'
  | 'TRIALS_VARIANCE_POPULATION_TENANT_ID_ASC'
  | 'TRIALS_VARIANCE_POPULATION_TENANT_ID_DESC'
  | 'TRIALS_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'TRIALS_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_AVATAR_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_AVATAR_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_CREATED_BY_ID_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_CREATED_BY_ID_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_ID_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_ID_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_MESSAGES_ID_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_MESSAGES_ID_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_NAME_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_NAME_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_STAFF_ID_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_STAFF_ID_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_SUBJECT_ID_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_SUBJECT_ID_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_TENANT_ID_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_TENANT_ID_DESC'
  | 'TRIALS_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'TRIALS_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'URL_ASC'
  | 'URL_DESC'
  | 'USERS_AVERAGE_ABOUT_ME_ASC'
  | 'USERS_AVERAGE_ABOUT_ME_DESC'
  | 'USERS_AVERAGE_ABOUT_ME_FORMAT_ASC'
  | 'USERS_AVERAGE_ABOUT_ME_FORMAT_DESC'
  | 'USERS_AVERAGE_CREATED_AT_ASC'
  | 'USERS_AVERAGE_CREATED_AT_DESC'
  | 'USERS_AVERAGE_CREDENTIALS_ID_ASC'
  | 'USERS_AVERAGE_CREDENTIALS_ID_DESC'
  | 'USERS_AVERAGE_EMAIL_ADDRESS_ID_ASC'
  | 'USERS_AVERAGE_EMAIL_ADDRESS_ID_DESC'
  | 'USERS_AVERAGE_EXTERNAL_ROLES_ASC'
  | 'USERS_AVERAGE_EXTERNAL_ROLES_DESC'
  | 'USERS_AVERAGE_GRAVATAR_HASH_ASC'
  | 'USERS_AVERAGE_GRAVATAR_HASH_DESC'
  | 'USERS_AVERAGE_ID_ASC'
  | 'USERS_AVERAGE_ID_DESC'
  | 'USERS_AVERAGE_IS_TENANT_ADMIN_ASC'
  | 'USERS_AVERAGE_IS_TENANT_ADMIN_DESC'
  | 'USERS_AVERAGE_TENANT_ID_ASC'
  | 'USERS_AVERAGE_TENANT_ID_DESC'
  | 'USERS_AVERAGE_UPDATED_AT_ASC'
  | 'USERS_AVERAGE_UPDATED_AT_DESC'
  | 'USERS_AVERAGE_USERNAME_ASC'
  | 'USERS_AVERAGE_USERNAME_DESC'
  | 'USERS_COUNT_ASC'
  | 'USERS_COUNT_DESC'
  | 'USERS_DISTINCT_COUNT_ABOUT_ME_ASC'
  | 'USERS_DISTINCT_COUNT_ABOUT_ME_DESC'
  | 'USERS_DISTINCT_COUNT_ABOUT_ME_FORMAT_ASC'
  | 'USERS_DISTINCT_COUNT_ABOUT_ME_FORMAT_DESC'
  | 'USERS_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'USERS_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'USERS_DISTINCT_COUNT_CREDENTIALS_ID_ASC'
  | 'USERS_DISTINCT_COUNT_CREDENTIALS_ID_DESC'
  | 'USERS_DISTINCT_COUNT_EMAIL_ADDRESS_ID_ASC'
  | 'USERS_DISTINCT_COUNT_EMAIL_ADDRESS_ID_DESC'
  | 'USERS_DISTINCT_COUNT_EXTERNAL_ROLES_ASC'
  | 'USERS_DISTINCT_COUNT_EXTERNAL_ROLES_DESC'
  | 'USERS_DISTINCT_COUNT_GRAVATAR_HASH_ASC'
  | 'USERS_DISTINCT_COUNT_GRAVATAR_HASH_DESC'
  | 'USERS_DISTINCT_COUNT_ID_ASC'
  | 'USERS_DISTINCT_COUNT_ID_DESC'
  | 'USERS_DISTINCT_COUNT_IS_TENANT_ADMIN_ASC'
  | 'USERS_DISTINCT_COUNT_IS_TENANT_ADMIN_DESC'
  | 'USERS_DISTINCT_COUNT_TENANT_ID_ASC'
  | 'USERS_DISTINCT_COUNT_TENANT_ID_DESC'
  | 'USERS_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'USERS_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'USERS_DISTINCT_COUNT_USERNAME_ASC'
  | 'USERS_DISTINCT_COUNT_USERNAME_DESC'
  | 'USERS_MAX_ABOUT_ME_ASC'
  | 'USERS_MAX_ABOUT_ME_DESC'
  | 'USERS_MAX_ABOUT_ME_FORMAT_ASC'
  | 'USERS_MAX_ABOUT_ME_FORMAT_DESC'
  | 'USERS_MAX_CREATED_AT_ASC'
  | 'USERS_MAX_CREATED_AT_DESC'
  | 'USERS_MAX_CREDENTIALS_ID_ASC'
  | 'USERS_MAX_CREDENTIALS_ID_DESC'
  | 'USERS_MAX_EMAIL_ADDRESS_ID_ASC'
  | 'USERS_MAX_EMAIL_ADDRESS_ID_DESC'
  | 'USERS_MAX_EXTERNAL_ROLES_ASC'
  | 'USERS_MAX_EXTERNAL_ROLES_DESC'
  | 'USERS_MAX_GRAVATAR_HASH_ASC'
  | 'USERS_MAX_GRAVATAR_HASH_DESC'
  | 'USERS_MAX_ID_ASC'
  | 'USERS_MAX_ID_DESC'
  | 'USERS_MAX_IS_TENANT_ADMIN_ASC'
  | 'USERS_MAX_IS_TENANT_ADMIN_DESC'
  | 'USERS_MAX_TENANT_ID_ASC'
  | 'USERS_MAX_TENANT_ID_DESC'
  | 'USERS_MAX_UPDATED_AT_ASC'
  | 'USERS_MAX_UPDATED_AT_DESC'
  | 'USERS_MAX_USERNAME_ASC'
  | 'USERS_MAX_USERNAME_DESC'
  | 'USERS_MIN_ABOUT_ME_ASC'
  | 'USERS_MIN_ABOUT_ME_DESC'
  | 'USERS_MIN_ABOUT_ME_FORMAT_ASC'
  | 'USERS_MIN_ABOUT_ME_FORMAT_DESC'
  | 'USERS_MIN_CREATED_AT_ASC'
  | 'USERS_MIN_CREATED_AT_DESC'
  | 'USERS_MIN_CREDENTIALS_ID_ASC'
  | 'USERS_MIN_CREDENTIALS_ID_DESC'
  | 'USERS_MIN_EMAIL_ADDRESS_ID_ASC'
  | 'USERS_MIN_EMAIL_ADDRESS_ID_DESC'
  | 'USERS_MIN_EXTERNAL_ROLES_ASC'
  | 'USERS_MIN_EXTERNAL_ROLES_DESC'
  | 'USERS_MIN_GRAVATAR_HASH_ASC'
  | 'USERS_MIN_GRAVATAR_HASH_DESC'
  | 'USERS_MIN_ID_ASC'
  | 'USERS_MIN_ID_DESC'
  | 'USERS_MIN_IS_TENANT_ADMIN_ASC'
  | 'USERS_MIN_IS_TENANT_ADMIN_DESC'
  | 'USERS_MIN_TENANT_ID_ASC'
  | 'USERS_MIN_TENANT_ID_DESC'
  | 'USERS_MIN_UPDATED_AT_ASC'
  | 'USERS_MIN_UPDATED_AT_DESC'
  | 'USERS_MIN_USERNAME_ASC'
  | 'USERS_MIN_USERNAME_DESC'
  | 'USERS_STDDEV_POPULATION_ABOUT_ME_ASC'
  | 'USERS_STDDEV_POPULATION_ABOUT_ME_DESC'
  | 'USERS_STDDEV_POPULATION_ABOUT_ME_FORMAT_ASC'
  | 'USERS_STDDEV_POPULATION_ABOUT_ME_FORMAT_DESC'
  | 'USERS_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'USERS_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'USERS_STDDEV_POPULATION_CREDENTIALS_ID_ASC'
  | 'USERS_STDDEV_POPULATION_CREDENTIALS_ID_DESC'
  | 'USERS_STDDEV_POPULATION_EMAIL_ADDRESS_ID_ASC'
  | 'USERS_STDDEV_POPULATION_EMAIL_ADDRESS_ID_DESC'
  | 'USERS_STDDEV_POPULATION_EXTERNAL_ROLES_ASC'
  | 'USERS_STDDEV_POPULATION_EXTERNAL_ROLES_DESC'
  | 'USERS_STDDEV_POPULATION_GRAVATAR_HASH_ASC'
  | 'USERS_STDDEV_POPULATION_GRAVATAR_HASH_DESC'
  | 'USERS_STDDEV_POPULATION_ID_ASC'
  | 'USERS_STDDEV_POPULATION_ID_DESC'
  | 'USERS_STDDEV_POPULATION_IS_TENANT_ADMIN_ASC'
  | 'USERS_STDDEV_POPULATION_IS_TENANT_ADMIN_DESC'
  | 'USERS_STDDEV_POPULATION_TENANT_ID_ASC'
  | 'USERS_STDDEV_POPULATION_TENANT_ID_DESC'
  | 'USERS_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'USERS_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'USERS_STDDEV_POPULATION_USERNAME_ASC'
  | 'USERS_STDDEV_POPULATION_USERNAME_DESC'
  | 'USERS_STDDEV_SAMPLE_ABOUT_ME_ASC'
  | 'USERS_STDDEV_SAMPLE_ABOUT_ME_DESC'
  | 'USERS_STDDEV_SAMPLE_ABOUT_ME_FORMAT_ASC'
  | 'USERS_STDDEV_SAMPLE_ABOUT_ME_FORMAT_DESC'
  | 'USERS_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'USERS_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'USERS_STDDEV_SAMPLE_CREDENTIALS_ID_ASC'
  | 'USERS_STDDEV_SAMPLE_CREDENTIALS_ID_DESC'
  | 'USERS_STDDEV_SAMPLE_EMAIL_ADDRESS_ID_ASC'
  | 'USERS_STDDEV_SAMPLE_EMAIL_ADDRESS_ID_DESC'
  | 'USERS_STDDEV_SAMPLE_EXTERNAL_ROLES_ASC'
  | 'USERS_STDDEV_SAMPLE_EXTERNAL_ROLES_DESC'
  | 'USERS_STDDEV_SAMPLE_GRAVATAR_HASH_ASC'
  | 'USERS_STDDEV_SAMPLE_GRAVATAR_HASH_DESC'
  | 'USERS_STDDEV_SAMPLE_ID_ASC'
  | 'USERS_STDDEV_SAMPLE_ID_DESC'
  | 'USERS_STDDEV_SAMPLE_IS_TENANT_ADMIN_ASC'
  | 'USERS_STDDEV_SAMPLE_IS_TENANT_ADMIN_DESC'
  | 'USERS_STDDEV_SAMPLE_TENANT_ID_ASC'
  | 'USERS_STDDEV_SAMPLE_TENANT_ID_DESC'
  | 'USERS_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'USERS_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'USERS_STDDEV_SAMPLE_USERNAME_ASC'
  | 'USERS_STDDEV_SAMPLE_USERNAME_DESC'
  | 'USERS_SUM_ABOUT_ME_ASC'
  | 'USERS_SUM_ABOUT_ME_DESC'
  | 'USERS_SUM_ABOUT_ME_FORMAT_ASC'
  | 'USERS_SUM_ABOUT_ME_FORMAT_DESC'
  | 'USERS_SUM_CREATED_AT_ASC'
  | 'USERS_SUM_CREATED_AT_DESC'
  | 'USERS_SUM_CREDENTIALS_ID_ASC'
  | 'USERS_SUM_CREDENTIALS_ID_DESC'
  | 'USERS_SUM_EMAIL_ADDRESS_ID_ASC'
  | 'USERS_SUM_EMAIL_ADDRESS_ID_DESC'
  | 'USERS_SUM_EXTERNAL_ROLES_ASC'
  | 'USERS_SUM_EXTERNAL_ROLES_DESC'
  | 'USERS_SUM_GRAVATAR_HASH_ASC'
  | 'USERS_SUM_GRAVATAR_HASH_DESC'
  | 'USERS_SUM_ID_ASC'
  | 'USERS_SUM_ID_DESC'
  | 'USERS_SUM_IS_TENANT_ADMIN_ASC'
  | 'USERS_SUM_IS_TENANT_ADMIN_DESC'
  | 'USERS_SUM_TENANT_ID_ASC'
  | 'USERS_SUM_TENANT_ID_DESC'
  | 'USERS_SUM_UPDATED_AT_ASC'
  | 'USERS_SUM_UPDATED_AT_DESC'
  | 'USERS_SUM_USERNAME_ASC'
  | 'USERS_SUM_USERNAME_DESC'
  | 'USERS_VARIANCE_POPULATION_ABOUT_ME_ASC'
  | 'USERS_VARIANCE_POPULATION_ABOUT_ME_DESC'
  | 'USERS_VARIANCE_POPULATION_ABOUT_ME_FORMAT_ASC'
  | 'USERS_VARIANCE_POPULATION_ABOUT_ME_FORMAT_DESC'
  | 'USERS_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'USERS_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'USERS_VARIANCE_POPULATION_CREDENTIALS_ID_ASC'
  | 'USERS_VARIANCE_POPULATION_CREDENTIALS_ID_DESC'
  | 'USERS_VARIANCE_POPULATION_EMAIL_ADDRESS_ID_ASC'
  | 'USERS_VARIANCE_POPULATION_EMAIL_ADDRESS_ID_DESC'
  | 'USERS_VARIANCE_POPULATION_EXTERNAL_ROLES_ASC'
  | 'USERS_VARIANCE_POPULATION_EXTERNAL_ROLES_DESC'
  | 'USERS_VARIANCE_POPULATION_GRAVATAR_HASH_ASC'
  | 'USERS_VARIANCE_POPULATION_GRAVATAR_HASH_DESC'
  | 'USERS_VARIANCE_POPULATION_ID_ASC'
  | 'USERS_VARIANCE_POPULATION_ID_DESC'
  | 'USERS_VARIANCE_POPULATION_IS_TENANT_ADMIN_ASC'
  | 'USERS_VARIANCE_POPULATION_IS_TENANT_ADMIN_DESC'
  | 'USERS_VARIANCE_POPULATION_TENANT_ID_ASC'
  | 'USERS_VARIANCE_POPULATION_TENANT_ID_DESC'
  | 'USERS_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'USERS_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'USERS_VARIANCE_POPULATION_USERNAME_ASC'
  | 'USERS_VARIANCE_POPULATION_USERNAME_DESC'
  | 'USERS_VARIANCE_SAMPLE_ABOUT_ME_ASC'
  | 'USERS_VARIANCE_SAMPLE_ABOUT_ME_DESC'
  | 'USERS_VARIANCE_SAMPLE_ABOUT_ME_FORMAT_ASC'
  | 'USERS_VARIANCE_SAMPLE_ABOUT_ME_FORMAT_DESC'
  | 'USERS_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'USERS_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'USERS_VARIANCE_SAMPLE_CREDENTIALS_ID_ASC'
  | 'USERS_VARIANCE_SAMPLE_CREDENTIALS_ID_DESC'
  | 'USERS_VARIANCE_SAMPLE_EMAIL_ADDRESS_ID_ASC'
  | 'USERS_VARIANCE_SAMPLE_EMAIL_ADDRESS_ID_DESC'
  | 'USERS_VARIANCE_SAMPLE_EXTERNAL_ROLES_ASC'
  | 'USERS_VARIANCE_SAMPLE_EXTERNAL_ROLES_DESC'
  | 'USERS_VARIANCE_SAMPLE_GRAVATAR_HASH_ASC'
  | 'USERS_VARIANCE_SAMPLE_GRAVATAR_HASH_DESC'
  | 'USERS_VARIANCE_SAMPLE_ID_ASC'
  | 'USERS_VARIANCE_SAMPLE_ID_DESC'
  | 'USERS_VARIANCE_SAMPLE_IS_TENANT_ADMIN_ASC'
  | 'USERS_VARIANCE_SAMPLE_IS_TENANT_ADMIN_DESC'
  | 'USERS_VARIANCE_SAMPLE_TENANT_ID_ASC'
  | 'USERS_VARIANCE_SAMPLE_TENANT_ID_DESC'
  | 'USERS_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'USERS_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'USERS_VARIANCE_SAMPLE_USERNAME_ASC'
  | 'USERS_VARIANCE_SAMPLE_USERNAME_DESC'
  | 'USER_CREDENTIALS_AVERAGE_CREATED_AT_ASC'
  | 'USER_CREDENTIALS_AVERAGE_CREATED_AT_DESC'
  | 'USER_CREDENTIALS_AVERAGE_ENCRYPTED_PASSWORD_ASC'
  | 'USER_CREDENTIALS_AVERAGE_ENCRYPTED_PASSWORD_DESC'
  | 'USER_CREDENTIALS_AVERAGE_EXTERNAL_AUTH_ID_ASC'
  | 'USER_CREDENTIALS_AVERAGE_EXTERNAL_AUTH_ID_DESC'
  | 'USER_CREDENTIALS_AVERAGE_ID_ASC'
  | 'USER_CREDENTIALS_AVERAGE_ID_DESC'
  | 'USER_CREDENTIALS_AVERAGE_TENANT_ID_ASC'
  | 'USER_CREDENTIALS_AVERAGE_TENANT_ID_DESC'
  | 'USER_CREDENTIALS_AVERAGE_UPDATED_AT_ASC'
  | 'USER_CREDENTIALS_AVERAGE_UPDATED_AT_DESC'
  | 'USER_CREDENTIALS_COUNT_ASC'
  | 'USER_CREDENTIALS_COUNT_DESC'
  | 'USER_CREDENTIALS_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'USER_CREDENTIALS_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'USER_CREDENTIALS_DISTINCT_COUNT_ENCRYPTED_PASSWORD_ASC'
  | 'USER_CREDENTIALS_DISTINCT_COUNT_ENCRYPTED_PASSWORD_DESC'
  | 'USER_CREDENTIALS_DISTINCT_COUNT_EXTERNAL_AUTH_ID_ASC'
  | 'USER_CREDENTIALS_DISTINCT_COUNT_EXTERNAL_AUTH_ID_DESC'
  | 'USER_CREDENTIALS_DISTINCT_COUNT_ID_ASC'
  | 'USER_CREDENTIALS_DISTINCT_COUNT_ID_DESC'
  | 'USER_CREDENTIALS_DISTINCT_COUNT_TENANT_ID_ASC'
  | 'USER_CREDENTIALS_DISTINCT_COUNT_TENANT_ID_DESC'
  | 'USER_CREDENTIALS_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'USER_CREDENTIALS_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'USER_CREDENTIALS_MAX_CREATED_AT_ASC'
  | 'USER_CREDENTIALS_MAX_CREATED_AT_DESC'
  | 'USER_CREDENTIALS_MAX_ENCRYPTED_PASSWORD_ASC'
  | 'USER_CREDENTIALS_MAX_ENCRYPTED_PASSWORD_DESC'
  | 'USER_CREDENTIALS_MAX_EXTERNAL_AUTH_ID_ASC'
  | 'USER_CREDENTIALS_MAX_EXTERNAL_AUTH_ID_DESC'
  | 'USER_CREDENTIALS_MAX_ID_ASC'
  | 'USER_CREDENTIALS_MAX_ID_DESC'
  | 'USER_CREDENTIALS_MAX_TENANT_ID_ASC'
  | 'USER_CREDENTIALS_MAX_TENANT_ID_DESC'
  | 'USER_CREDENTIALS_MAX_UPDATED_AT_ASC'
  | 'USER_CREDENTIALS_MAX_UPDATED_AT_DESC'
  | 'USER_CREDENTIALS_MIN_CREATED_AT_ASC'
  | 'USER_CREDENTIALS_MIN_CREATED_AT_DESC'
  | 'USER_CREDENTIALS_MIN_ENCRYPTED_PASSWORD_ASC'
  | 'USER_CREDENTIALS_MIN_ENCRYPTED_PASSWORD_DESC'
  | 'USER_CREDENTIALS_MIN_EXTERNAL_AUTH_ID_ASC'
  | 'USER_CREDENTIALS_MIN_EXTERNAL_AUTH_ID_DESC'
  | 'USER_CREDENTIALS_MIN_ID_ASC'
  | 'USER_CREDENTIALS_MIN_ID_DESC'
  | 'USER_CREDENTIALS_MIN_TENANT_ID_ASC'
  | 'USER_CREDENTIALS_MIN_TENANT_ID_DESC'
  | 'USER_CREDENTIALS_MIN_UPDATED_AT_ASC'
  | 'USER_CREDENTIALS_MIN_UPDATED_AT_DESC'
  | 'USER_CREDENTIALS_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'USER_CREDENTIALS_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'USER_CREDENTIALS_STDDEV_POPULATION_ENCRYPTED_PASSWORD_ASC'
  | 'USER_CREDENTIALS_STDDEV_POPULATION_ENCRYPTED_PASSWORD_DESC'
  | 'USER_CREDENTIALS_STDDEV_POPULATION_EXTERNAL_AUTH_ID_ASC'
  | 'USER_CREDENTIALS_STDDEV_POPULATION_EXTERNAL_AUTH_ID_DESC'
  | 'USER_CREDENTIALS_STDDEV_POPULATION_ID_ASC'
  | 'USER_CREDENTIALS_STDDEV_POPULATION_ID_DESC'
  | 'USER_CREDENTIALS_STDDEV_POPULATION_TENANT_ID_ASC'
  | 'USER_CREDENTIALS_STDDEV_POPULATION_TENANT_ID_DESC'
  | 'USER_CREDENTIALS_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'USER_CREDENTIALS_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'USER_CREDENTIALS_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'USER_CREDENTIALS_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'USER_CREDENTIALS_STDDEV_SAMPLE_ENCRYPTED_PASSWORD_ASC'
  | 'USER_CREDENTIALS_STDDEV_SAMPLE_ENCRYPTED_PASSWORD_DESC'
  | 'USER_CREDENTIALS_STDDEV_SAMPLE_EXTERNAL_AUTH_ID_ASC'
  | 'USER_CREDENTIALS_STDDEV_SAMPLE_EXTERNAL_AUTH_ID_DESC'
  | 'USER_CREDENTIALS_STDDEV_SAMPLE_ID_ASC'
  | 'USER_CREDENTIALS_STDDEV_SAMPLE_ID_DESC'
  | 'USER_CREDENTIALS_STDDEV_SAMPLE_TENANT_ID_ASC'
  | 'USER_CREDENTIALS_STDDEV_SAMPLE_TENANT_ID_DESC'
  | 'USER_CREDENTIALS_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'USER_CREDENTIALS_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'USER_CREDENTIALS_SUM_CREATED_AT_ASC'
  | 'USER_CREDENTIALS_SUM_CREATED_AT_DESC'
  | 'USER_CREDENTIALS_SUM_ENCRYPTED_PASSWORD_ASC'
  | 'USER_CREDENTIALS_SUM_ENCRYPTED_PASSWORD_DESC'
  | 'USER_CREDENTIALS_SUM_EXTERNAL_AUTH_ID_ASC'
  | 'USER_CREDENTIALS_SUM_EXTERNAL_AUTH_ID_DESC'
  | 'USER_CREDENTIALS_SUM_ID_ASC'
  | 'USER_CREDENTIALS_SUM_ID_DESC'
  | 'USER_CREDENTIALS_SUM_TENANT_ID_ASC'
  | 'USER_CREDENTIALS_SUM_TENANT_ID_DESC'
  | 'USER_CREDENTIALS_SUM_UPDATED_AT_ASC'
  | 'USER_CREDENTIALS_SUM_UPDATED_AT_DESC'
  | 'USER_CREDENTIALS_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'USER_CREDENTIALS_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'USER_CREDENTIALS_VARIANCE_POPULATION_ENCRYPTED_PASSWORD_ASC'
  | 'USER_CREDENTIALS_VARIANCE_POPULATION_ENCRYPTED_PASSWORD_DESC'
  | 'USER_CREDENTIALS_VARIANCE_POPULATION_EXTERNAL_AUTH_ID_ASC'
  | 'USER_CREDENTIALS_VARIANCE_POPULATION_EXTERNAL_AUTH_ID_DESC'
  | 'USER_CREDENTIALS_VARIANCE_POPULATION_ID_ASC'
  | 'USER_CREDENTIALS_VARIANCE_POPULATION_ID_DESC'
  | 'USER_CREDENTIALS_VARIANCE_POPULATION_TENANT_ID_ASC'
  | 'USER_CREDENTIALS_VARIANCE_POPULATION_TENANT_ID_DESC'
  | 'USER_CREDENTIALS_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'USER_CREDENTIALS_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'USER_CREDENTIALS_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'USER_CREDENTIALS_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'USER_CREDENTIALS_VARIANCE_SAMPLE_ENCRYPTED_PASSWORD_ASC'
  | 'USER_CREDENTIALS_VARIANCE_SAMPLE_ENCRYPTED_PASSWORD_DESC'
  | 'USER_CREDENTIALS_VARIANCE_SAMPLE_EXTERNAL_AUTH_ID_ASC'
  | 'USER_CREDENTIALS_VARIANCE_SAMPLE_EXTERNAL_AUTH_ID_DESC'
  | 'USER_CREDENTIALS_VARIANCE_SAMPLE_ID_ASC'
  | 'USER_CREDENTIALS_VARIANCE_SAMPLE_ID_DESC'
  | 'USER_CREDENTIALS_VARIANCE_SAMPLE_TENANT_ID_ASC'
  | 'USER_CREDENTIALS_VARIANCE_SAMPLE_TENANT_ID_DESC'
  | 'USER_CREDENTIALS_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'USER_CREDENTIALS_VARIANCE_SAMPLE_UPDATED_AT_DESC';

/** A filter to be used against Time fields. All fields are combined with a logical ‘and.’ */
export type TimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Time']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Time']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Time']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Time']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Time']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Time']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Time']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Time']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Time']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Time']>>;
};

/** All input for the `toggleFavoriteOfRoute` mutation. */
export type ToggleFavoriteOfRouteInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  route?: InputMaybe<Scalars['String']>;
};

/** The output of our `toggleFavoriteOfRoute` mutation. */
export type ToggleFavoriteOfRoutePayload = {
  __typename?: 'ToggleFavoriteOfRoutePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  entry?: Maybe<FavoritePage>;
  /** An edge for our `FavoritePage`. May be used by Relay 1. */
  favoritePageEdge?: Maybe<FavoritePagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trial` that is related to this `FavoritePage`. */
  trial?: Maybe<Trial>;
};


/** The output of our `toggleFavoriteOfRoute` mutation. */
export type ToggleFavoriteOfRoutePayloadFavoritePageEdgeArgs = {
  orderBy?: InputMaybe<Array<FavoritePagesOrderBy>>;
};

export type Trial = Node & {
  __typename?: 'Trial';
  avatar?: Maybe<AvatarIcon>;
  canAccessErSince?: Maybe<Scalars['Datetime']>;
  canAccessSipSince?: Maybe<Scalars['Datetime']>;
  canBeIncluded?: Maybe<Scalars['Boolean']>;
  cannotUseTheIntervention: Scalars['Boolean'];
  /** Reads a single `Commentable` that is related to this `Trial`. */
  commentableById?: Maybe<Commentable>;
  createdAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `Trial`. */
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `EmaEntries3`. */
  emaEntries3s: EmaEntries3sConnection;
  emergencyPhoneNumbers: Array<Maybe<EmergencyContact>>;
  /** Reads and enables pagination through a set of `FavoritePage`. */
  favoritePages: FavoritePagesConnection;
  /** Reads and enables pagination through a set of `GenericEmiExercise`. */
  genericEmiExercises: GenericEmiExercisesConnection;
  /** Reads a single `GroupHome` that is related to this `Trial`. */
  groupHomeById?: Maybe<GroupHome>;
  hasAccessToASmartphone: Scalars['Boolean'];
  hasAdequateKnowledgeOfGerman: Scalars['Boolean'];
  hasAgeBetween18And25: Scalars['Boolean'];
  hasCurrentSuicidalIdeation: Scalars['Boolean'];
  hasFacedAdverseChildhoodExperiences: Scalars['Boolean'];
  hasGivenInformedConsentAt?: Maybe<Scalars['Date']>;
  humanReadableId: Scalars['BigInt'];
  id: Scalars['UUID'];
  /** Reads a single `Conversation` that is related to this `Trial`. */
  internalMessages?: Maybe<Conversation>;
  internalMessagesId: Scalars['UUID'];
  lastResumableRoute?: Maybe<Scalars['JSON']>;
  /** Reads and enables pagination through a set of `LimesurveyToken`. */
  limesurveyTokens: LimesurveyTokensConnection;
  meetsAllInclusionCriteria?: Maybe<Scalars['Boolean']>;
  meetsAllInclusionCriteriaExceptInformedConsent?: Maybe<Scalars['Boolean']>;
  meetsAnyExclusionCriteria?: Maybe<Scalars['Boolean']>;
  /** Reads a single `Conversation` that is related to this `Trial`. */
  messages?: Maybe<Conversation>;
  messagesId: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PageHit`. */
  pageHits: PageHitsConnection;
  /** Reads a single `PostWaitRandomizationTicket` that is related to this `Trial`. */
  postWaitRandomizationTicket?: Maybe<PostWaitRandomizationTicket>;
  /**
   * Reads and enables pagination through a set of `PostWaitRandomizationTicket`.
   * @deprecated Please use postWaitRandomizationTicket instead
   */
  postWaitRandomizationTickets: PostWaitRandomizationTicketsConnection;
  /** Reads a single `RandomizationTicket` that is related to this `Trial`. */
  randomizationTicket?: Maybe<RandomizationTicket>;
  /**
   * Reads and enables pagination through a set of `RandomizationTicket`.
   * @deprecated Please use randomizationTicket instead
   */
  randomizationTickets: RandomizationTicketsConnection;
  /** Reads and enables pagination through a set of `RawUsageDatum`. */
  rawUsageData: RawUsageDataConnection;
  /** Reads a single `Group` that is related to this `Trial`. */
  staff?: Maybe<Group>;
  staffId: Scalars['UUID'];
  /** Reads a single `User` that is related to this `Trial`. */
  subject?: Maybe<User>;
  subjectId: Scalars['UUID'];
  subjectsNickname?: Maybe<Scalars['String']>;
  /** Reads a single `Tenant` that is related to this `Trial`. */
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
};


export type TrialEmaEntries3sArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmaEntries3Condition>;
  filter?: InputMaybe<EmaEntries3Filter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmaEntries3sOrderBy>>;
};


export type TrialFavoritePagesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<FavoritePageCondition>;
  filter?: InputMaybe<FavoritePageFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<FavoritePagesOrderBy>>;
};


export type TrialGenericEmiExercisesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GenericEmiExerciseCondition>;
  filter?: InputMaybe<GenericEmiExerciseFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GenericEmiExercisesOrderBy>>;
};


export type TrialLimesurveyTokensArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<LimesurveyTokenCondition>;
  filter?: InputMaybe<LimesurveyTokenFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<LimesurveyTokensOrderBy>>;
};


export type TrialPageHitsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PageHitCondition>;
  filter?: InputMaybe<PageHitFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PageHitsOrderBy>>;
};


export type TrialPostWaitRandomizationTicketsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PostWaitRandomizationTicketCondition>;
  filter?: InputMaybe<PostWaitRandomizationTicketFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PostWaitRandomizationTicketsOrderBy>>;
};


export type TrialRandomizationTicketsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RandomizationTicketCondition>;
  filter?: InputMaybe<RandomizationTicketFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RandomizationTicketsOrderBy>>;
};


export type TrialRawUsageDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RawUsageDatumCondition>;
  filter?: InputMaybe<RawUsageDatumFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RawUsageDataOrderBy>>;
};

export type TrialAggregates = {
  __typename?: 'TrialAggregates';
  /** Mean average aggregates across the matching connection (ignoring before/after/first/last/offset) */
  average?: Maybe<TrialAverageAggregates>;
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<TrialDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
  /** Maximum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  max?: Maybe<TrialMaxAggregates>;
  /** Minimum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  min?: Maybe<TrialMinAggregates>;
  /** Population standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevPopulation?: Maybe<TrialStddevPopulationAggregates>;
  /** Sample standard deviation aggregates across the matching connection (ignoring before/after/first/last/offset) */
  stddevSample?: Maybe<TrialStddevSampleAggregates>;
  /** Sum aggregates across the matching connection (ignoring before/after/first/last/offset) */
  sum?: Maybe<TrialSumAggregates>;
  /** Population variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  variancePopulation?: Maybe<TrialVariancePopulationAggregates>;
  /** Sample variance aggregates across the matching connection (ignoring before/after/first/last/offset) */
  varianceSample?: Maybe<TrialVarianceSampleAggregates>;
};

/** A filter to be used against aggregates of `Trial` object types. */
export type TrialAggregatesFilter = {
  /** Mean average aggregate over matching `Trial` objects. */
  average?: InputMaybe<TrialAverageAggregateFilter>;
  /** Distinct count aggregate over matching `Trial` objects. */
  distinctCount?: InputMaybe<TrialDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `Trial` object to be included within the aggregate. */
  filter?: InputMaybe<TrialFilter>;
  /** Maximum aggregate over matching `Trial` objects. */
  max?: InputMaybe<TrialMaxAggregateFilter>;
  /** Minimum aggregate over matching `Trial` objects. */
  min?: InputMaybe<TrialMinAggregateFilter>;
  /** Population standard deviation aggregate over matching `Trial` objects. */
  stddevPopulation?: InputMaybe<TrialStddevPopulationAggregateFilter>;
  /** Sample standard deviation aggregate over matching `Trial` objects. */
  stddevSample?: InputMaybe<TrialStddevSampleAggregateFilter>;
  /** Sum aggregate over matching `Trial` objects. */
  sum?: InputMaybe<TrialSumAggregateFilter>;
  /** Population variance aggregate over matching `Trial` objects. */
  variancePopulation?: InputMaybe<TrialVariancePopulationAggregateFilter>;
  /** Sample variance aggregate over matching `Trial` objects. */
  varianceSample?: InputMaybe<TrialVarianceSampleAggregateFilter>;
};

export type TrialAverageAggregateFilter = {
  humanReadableId?: InputMaybe<BigFloatFilter>;
};

export type TrialAverageAggregates = {
  __typename?: 'TrialAverageAggregates';
  /** Mean average of humanReadableId across the matching connection */
  humanReadableId?: Maybe<Scalars['BigFloat']>;
};

/** A condition to be used against `Trial` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type TrialCondition = {
  /** Checks for equality with the object’s `avatar` field. */
  avatar?: InputMaybe<AvatarIcon>;
  /** Checks for equality with the object’s `canAccessErSince` field. */
  canAccessErSince?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `canAccessSipSince` field. */
  canAccessSipSince?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `canBeIncluded` field. */
  canBeIncluded?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `cannotUseTheIntervention` field. */
  cannotUseTheIntervention?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `createdById` field. */
  createdById?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `emergencyPhoneNumbers` field. */
  emergencyPhoneNumbers?: InputMaybe<Array<InputMaybe<EmergencyContactInput>>>;
  /** Checks for equality with the object’s `hasAccessToASmartphone` field. */
  hasAccessToASmartphone?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `hasAdequateKnowledgeOfGerman` field. */
  hasAdequateKnowledgeOfGerman?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `hasAgeBetween18And25` field. */
  hasAgeBetween18And25?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `hasCurrentSuicidalIdeation` field. */
  hasCurrentSuicidalIdeation?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `hasFacedAdverseChildhoodExperiences` field. */
  hasFacedAdverseChildhoodExperiences?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `hasGivenInformedConsentAt` field. */
  hasGivenInformedConsentAt?: InputMaybe<Scalars['Date']>;
  /** Checks for equality with the object’s `humanReadableId` field. */
  humanReadableId?: InputMaybe<Scalars['BigInt']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `internalMessagesId` field. */
  internalMessagesId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `meetsAllInclusionCriteria` field. */
  meetsAllInclusionCriteria?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `meetsAllInclusionCriteriaExceptInformedConsent` field. */
  meetsAllInclusionCriteriaExceptInformedConsent?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `meetsAnyExclusionCriteria` field. */
  meetsAnyExclusionCriteria?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `messagesId` field. */
  messagesId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `staffId` field. */
  staffId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `subjectId` field. */
  subjectId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `subjectsNickname` field. */
  subjectsNickname?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type TrialDistinctCountAggregateFilter = {
  avatar?: InputMaybe<BigIntFilter>;
  canAccessErSince?: InputMaybe<BigIntFilter>;
  canAccessSipSince?: InputMaybe<BigIntFilter>;
  canBeIncluded?: InputMaybe<BigIntFilter>;
  cannotUseTheIntervention?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  createdById?: InputMaybe<BigIntFilter>;
  emergencyPhoneNumbers?: InputMaybe<BigIntFilter>;
  hasAccessToASmartphone?: InputMaybe<BigIntFilter>;
  hasAdequateKnowledgeOfGerman?: InputMaybe<BigIntFilter>;
  hasAgeBetween18And25?: InputMaybe<BigIntFilter>;
  hasCurrentSuicidalIdeation?: InputMaybe<BigIntFilter>;
  hasFacedAdverseChildhoodExperiences?: InputMaybe<BigIntFilter>;
  hasGivenInformedConsentAt?: InputMaybe<BigIntFilter>;
  humanReadableId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  internalMessagesId?: InputMaybe<BigIntFilter>;
  lastResumableRoute?: InputMaybe<JsonFilter>;
  meetsAllInclusionCriteria?: InputMaybe<BigIntFilter>;
  meetsAllInclusionCriteriaExceptInformedConsent?: InputMaybe<BigIntFilter>;
  meetsAnyExclusionCriteria?: InputMaybe<BigIntFilter>;
  messagesId?: InputMaybe<BigIntFilter>;
  name?: InputMaybe<BigIntFilter>;
  staffId?: InputMaybe<BigIntFilter>;
  subjectId?: InputMaybe<BigIntFilter>;
  subjectsNickname?: InputMaybe<BigIntFilter>;
  tenantId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type TrialDistinctCountAggregates = {
  __typename?: 'TrialDistinctCountAggregates';
  /** Distinct count of avatar across the matching connection */
  avatar?: Maybe<Scalars['BigInt']>;
  /** Distinct count of canAccessErSince across the matching connection */
  canAccessErSince?: Maybe<Scalars['BigInt']>;
  /** Distinct count of canAccessSipSince across the matching connection */
  canAccessSipSince?: Maybe<Scalars['BigInt']>;
  /** Distinct count of canBeIncluded across the matching connection */
  canBeIncluded?: Maybe<Scalars['BigInt']>;
  /** Distinct count of cannotUseTheIntervention across the matching connection */
  cannotUseTheIntervention?: Maybe<Scalars['BigInt']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of createdById across the matching connection */
  createdById?: Maybe<Scalars['BigInt']>;
  /** Distinct count of emergencyPhoneNumbers across the matching connection */
  emergencyPhoneNumbers?: Maybe<Scalars['BigInt']>;
  /** Distinct count of hasAccessToASmartphone across the matching connection */
  hasAccessToASmartphone?: Maybe<Scalars['BigInt']>;
  /** Distinct count of hasAdequateKnowledgeOfGerman across the matching connection */
  hasAdequateKnowledgeOfGerman?: Maybe<Scalars['BigInt']>;
  /** Distinct count of hasAgeBetween18And25 across the matching connection */
  hasAgeBetween18And25?: Maybe<Scalars['BigInt']>;
  /** Distinct count of hasCurrentSuicidalIdeation across the matching connection */
  hasCurrentSuicidalIdeation?: Maybe<Scalars['BigInt']>;
  /** Distinct count of hasFacedAdverseChildhoodExperiences across the matching connection */
  hasFacedAdverseChildhoodExperiences?: Maybe<Scalars['BigInt']>;
  /** Distinct count of hasGivenInformedConsentAt across the matching connection */
  hasGivenInformedConsentAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of humanReadableId across the matching connection */
  humanReadableId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']>;
  /** Distinct count of internalMessagesId across the matching connection */
  internalMessagesId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of this field across the matching connection. */
  lastResumableRoute?: Maybe<Scalars['BigInt']>;
  /** Distinct count of meetsAllInclusionCriteria across the matching connection */
  meetsAllInclusionCriteria?: Maybe<Scalars['BigInt']>;
  /** Distinct count of meetsAllInclusionCriteriaExceptInformedConsent across the matching connection */
  meetsAllInclusionCriteriaExceptInformedConsent?: Maybe<Scalars['BigInt']>;
  /** Distinct count of meetsAnyExclusionCriteria across the matching connection */
  meetsAnyExclusionCriteria?: Maybe<Scalars['BigInt']>;
  /** Distinct count of messagesId across the matching connection */
  messagesId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of name across the matching connection */
  name?: Maybe<Scalars['BigInt']>;
  /** Distinct count of staffId across the matching connection */
  staffId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of subjectId across the matching connection */
  subjectId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of subjectsNickname across the matching connection */
  subjectsNickname?: Maybe<Scalars['BigInt']>;
  /** Distinct count of tenantId across the matching connection */
  tenantId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `Trial` object types. All fields are combined with a logical ‘and.’ */
export type TrialFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<TrialFilter>>;
  /** Filter by the object’s `avatar` field. */
  avatar?: InputMaybe<AvatarIconFilter>;
  /** Filter by the object’s `canAccessErSince` field. */
  canAccessErSince?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `canAccessSipSince` field. */
  canAccessSipSince?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `canBeIncluded` field. */
  canBeIncluded?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `cannotUseTheIntervention` field. */
  cannotUseTheIntervention?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `commentableById` relation. */
  commentableById?: InputMaybe<CommentableFilter>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdBy` relation. */
  createdBy?: InputMaybe<UserFilter>;
  /** A related `createdBy` exists. */
  createdByExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `createdById` field. */
  createdById?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `emaEntries3s` relation. */
  emaEntries3s?: InputMaybe<TrialToManyEmaEntries3Filter>;
  /** Some related `emaEntries3s` exist. */
  emaEntries3sExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `favoritePages` relation. */
  favoritePages?: InputMaybe<TrialToManyFavoritePageFilter>;
  /** Some related `favoritePages` exist. */
  favoritePagesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `genericEmiExercises` relation. */
  genericEmiExercises?: InputMaybe<TrialToManyGenericEmiExerciseFilter>;
  /** Some related `genericEmiExercises` exist. */
  genericEmiExercisesExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `groupHomeById` relation. */
  groupHomeById?: InputMaybe<GroupHomeFilter>;
  /** Filter by the object’s `hasAccessToASmartphone` field. */
  hasAccessToASmartphone?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `hasAdequateKnowledgeOfGerman` field. */
  hasAdequateKnowledgeOfGerman?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `hasAgeBetween18And25` field. */
  hasAgeBetween18And25?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `hasCurrentSuicidalIdeation` field. */
  hasCurrentSuicidalIdeation?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `hasFacedAdverseChildhoodExperiences` field. */
  hasFacedAdverseChildhoodExperiences?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `hasGivenInformedConsentAt` field. */
  hasGivenInformedConsentAt?: InputMaybe<DateFilter>;
  /** Filter by the object’s `humanReadableId` field. */
  humanReadableId?: InputMaybe<BigIntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `internalMessages` relation. */
  internalMessages?: InputMaybe<ConversationFilter>;
  /** Filter by the object’s `internalMessagesId` field. */
  internalMessagesId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `lastResumableRoute` field. */
  lastResumableRoute?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `limesurveyTokens` relation. */
  limesurveyTokens?: InputMaybe<TrialToManyLimesurveyTokenFilter>;
  /** Some related `limesurveyTokens` exist. */
  limesurveyTokensExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `meetsAllInclusionCriteria` field. */
  meetsAllInclusionCriteria?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `meetsAllInclusionCriteriaExceptInformedConsent` field. */
  meetsAllInclusionCriteriaExceptInformedConsent?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `meetsAnyExclusionCriteria` field. */
  meetsAnyExclusionCriteria?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `messages` relation. */
  messages?: InputMaybe<ConversationFilter>;
  /** Filter by the object’s `messagesId` field. */
  messagesId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<TrialFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<TrialFilter>>;
  /** Filter by the object’s `pageHits` relation. */
  pageHits?: InputMaybe<TrialToManyPageHitFilter>;
  /** Some related `pageHits` exist. */
  pageHitsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `postWaitRandomizationTicket` relation. */
  postWaitRandomizationTicket?: InputMaybe<PostWaitRandomizationTicketFilter>;
  /** A related `postWaitRandomizationTicket` exists. */
  postWaitRandomizationTicketExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `randomizationTicket` relation. */
  randomizationTicket?: InputMaybe<RandomizationTicketFilter>;
  /** A related `randomizationTicket` exists. */
  randomizationTicketExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `rawUsageData` relation. */
  rawUsageData?: InputMaybe<TrialToManyRawUsageDatumFilter>;
  /** Some related `rawUsageData` exist. */
  rawUsageDataExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `staff` relation. */
  staff?: InputMaybe<GroupFilter>;
  /** Filter by the object’s `staffId` field. */
  staffId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `subject` relation. */
  subject?: InputMaybe<UserFilter>;
  /** Filter by the object’s `subjectId` field. */
  subjectId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `subjectsNickname` field. */
  subjectsNickname?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tenant` relation. */
  tenant?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
};

/** An input for mutations affecting `Trial` */
export type TrialInput = {
  avatar?: InputMaybe<AvatarIcon>;
  canAccessErSince?: InputMaybe<Scalars['Datetime']>;
  canAccessSipSince?: InputMaybe<Scalars['Datetime']>;
  canBeIncluded?: InputMaybe<Scalars['Boolean']>;
  cannotUseTheIntervention?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['UUID']>;
  emergencyPhoneNumbers?: InputMaybe<Array<InputMaybe<EmergencyContactInput>>>;
  hasAccessToASmartphone?: InputMaybe<Scalars['Boolean']>;
  hasAdequateKnowledgeOfGerman?: InputMaybe<Scalars['Boolean']>;
  hasAgeBetween18And25?: InputMaybe<Scalars['Boolean']>;
  hasCurrentSuicidalIdeation?: InputMaybe<Scalars['Boolean']>;
  hasFacedAdverseChildhoodExperiences?: InputMaybe<Scalars['Boolean']>;
  hasGivenInformedConsentAt?: InputMaybe<Scalars['Date']>;
  humanReadableId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalMessagesId?: InputMaybe<Scalars['UUID']>;
  meetsAllInclusionCriteria?: InputMaybe<Scalars['Boolean']>;
  meetsAllInclusionCriteriaExceptInformedConsent?: InputMaybe<Scalars['Boolean']>;
  meetsAnyExclusionCriteria?: InputMaybe<Scalars['Boolean']>;
  messagesId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  staffId?: InputMaybe<Scalars['UUID']>;
  subjectId: Scalars['UUID'];
  subjectsNickname?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type TrialMaxAggregateFilter = {
  humanReadableId?: InputMaybe<BigIntFilter>;
};

export type TrialMaxAggregates = {
  __typename?: 'TrialMaxAggregates';
  /** Maximum of humanReadableId across the matching connection */
  humanReadableId?: Maybe<Scalars['BigInt']>;
};

export type TrialMinAggregateFilter = {
  humanReadableId?: InputMaybe<BigIntFilter>;
};

export type TrialMinAggregates = {
  __typename?: 'TrialMinAggregates';
  /** Minimum of humanReadableId across the matching connection */
  humanReadableId?: Maybe<Scalars['BigInt']>;
};

/** Represents an update to a `Trial`. Fields that are set will be updated. */
export type TrialPatch = {
  avatar?: InputMaybe<AvatarIcon>;
  canAccessErSince?: InputMaybe<Scalars['Datetime']>;
  canAccessSipSince?: InputMaybe<Scalars['Datetime']>;
  canBeIncluded?: InputMaybe<Scalars['Boolean']>;
  cannotUseTheIntervention?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  createdById?: InputMaybe<Scalars['UUID']>;
  emergencyPhoneNumbers?: InputMaybe<Array<InputMaybe<EmergencyContactInput>>>;
  hasAccessToASmartphone?: InputMaybe<Scalars['Boolean']>;
  hasAdequateKnowledgeOfGerman?: InputMaybe<Scalars['Boolean']>;
  hasAgeBetween18And25?: InputMaybe<Scalars['Boolean']>;
  hasCurrentSuicidalIdeation?: InputMaybe<Scalars['Boolean']>;
  hasFacedAdverseChildhoodExperiences?: InputMaybe<Scalars['Boolean']>;
  hasGivenInformedConsentAt?: InputMaybe<Scalars['Date']>;
  humanReadableId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['UUID']>;
  internalMessagesId?: InputMaybe<Scalars['UUID']>;
  meetsAllInclusionCriteria?: InputMaybe<Scalars['Boolean']>;
  meetsAllInclusionCriteriaExceptInformedConsent?: InputMaybe<Scalars['Boolean']>;
  meetsAnyExclusionCriteria?: InputMaybe<Scalars['Boolean']>;
  messagesId?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  staffId?: InputMaybe<Scalars['UUID']>;
  subjectId?: InputMaybe<Scalars['UUID']>;
  subjectsNickname?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type TrialStddevPopulationAggregateFilter = {
  humanReadableId?: InputMaybe<BigFloatFilter>;
};

export type TrialStddevPopulationAggregates = {
  __typename?: 'TrialStddevPopulationAggregates';
  /** Population standard deviation of humanReadableId across the matching connection */
  humanReadableId?: Maybe<Scalars['BigFloat']>;
};

export type TrialStddevSampleAggregateFilter = {
  humanReadableId?: InputMaybe<BigFloatFilter>;
};

export type TrialStddevSampleAggregates = {
  __typename?: 'TrialStddevSampleAggregates';
  /** Sample standard deviation of humanReadableId across the matching connection */
  humanReadableId?: Maybe<Scalars['BigFloat']>;
};

export type TrialSumAggregateFilter = {
  humanReadableId?: InputMaybe<BigFloatFilter>;
};

export type TrialSumAggregates = {
  __typename?: 'TrialSumAggregates';
  /** Sum of humanReadableId across the matching connection */
  humanReadableId: Scalars['BigFloat'];
};

/** A filter to be used against many `EmaEntries3` object types. All fields are combined with a logical ‘and.’ */
export type TrialToManyEmaEntries3Filter = {
  /** Aggregates across related `EmaEntries3` match the filter criteria. */
  aggregates?: InputMaybe<EmaEntries3AggregatesFilter>;
  /** Every related `EmaEntries3` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EmaEntries3Filter>;
  /** No related `EmaEntries3` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EmaEntries3Filter>;
  /** Some related `EmaEntries3` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EmaEntries3Filter>;
};

/** A filter to be used against many `FavoritePage` object types. All fields are combined with a logical ‘and.’ */
export type TrialToManyFavoritePageFilter = {
  /** Aggregates across related `FavoritePage` match the filter criteria. */
  aggregates?: InputMaybe<FavoritePageAggregatesFilter>;
  /** Every related `FavoritePage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<FavoritePageFilter>;
  /** No related `FavoritePage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<FavoritePageFilter>;
  /** Some related `FavoritePage` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<FavoritePageFilter>;
};

/** A filter to be used against many `GenericEmiExercise` object types. All fields are combined with a logical ‘and.’ */
export type TrialToManyGenericEmiExerciseFilter = {
  /** Aggregates across related `GenericEmiExercise` match the filter criteria. */
  aggregates?: InputMaybe<GenericEmiExerciseAggregatesFilter>;
  /** Every related `GenericEmiExercise` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GenericEmiExerciseFilter>;
  /** No related `GenericEmiExercise` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GenericEmiExerciseFilter>;
  /** Some related `GenericEmiExercise` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GenericEmiExerciseFilter>;
};

/** A filter to be used against many `LimesurveyToken` object types. All fields are combined with a logical ‘and.’ */
export type TrialToManyLimesurveyTokenFilter = {
  /** Aggregates across related `LimesurveyToken` match the filter criteria. */
  aggregates?: InputMaybe<LimesurveyTokenAggregatesFilter>;
  /** Every related `LimesurveyToken` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<LimesurveyTokenFilter>;
  /** No related `LimesurveyToken` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<LimesurveyTokenFilter>;
  /** Some related `LimesurveyToken` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<LimesurveyTokenFilter>;
};

/** A filter to be used against many `PageHit` object types. All fields are combined with a logical ‘and.’ */
export type TrialToManyPageHitFilter = {
  /** Aggregates across related `PageHit` match the filter criteria. */
  aggregates?: InputMaybe<PageHitAggregatesFilter>;
  /** Every related `PageHit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PageHitFilter>;
  /** No related `PageHit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PageHitFilter>;
  /** Some related `PageHit` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PageHitFilter>;
};

/** A filter to be used against many `RawUsageDatum` object types. All fields are combined with a logical ‘and.’ */
export type TrialToManyRawUsageDatumFilter = {
  /** Aggregates across related `RawUsageDatum` match the filter criteria. */
  aggregates?: InputMaybe<RawUsageDatumAggregatesFilter>;
  /** Every related `RawUsageDatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RawUsageDatumFilter>;
  /** No related `RawUsageDatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RawUsageDatumFilter>;
  /** Some related `RawUsageDatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RawUsageDatumFilter>;
};

export type TrialVariancePopulationAggregateFilter = {
  humanReadableId?: InputMaybe<BigFloatFilter>;
};

export type TrialVariancePopulationAggregates = {
  __typename?: 'TrialVariancePopulationAggregates';
  /** Population variance of humanReadableId across the matching connection */
  humanReadableId?: Maybe<Scalars['BigFloat']>;
};

export type TrialVarianceSampleAggregateFilter = {
  humanReadableId?: InputMaybe<BigFloatFilter>;
};

export type TrialVarianceSampleAggregates = {
  __typename?: 'TrialVarianceSampleAggregates';
  /** Sample variance of humanReadableId across the matching connection */
  humanReadableId?: Maybe<Scalars['BigFloat']>;
};

/** A connection to a list of `Trial` values. */
export type TrialsConnection = {
  __typename?: 'TrialsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<TrialAggregates>;
  /** A list of edges which contains the `Trial` and cursor to aid in pagination. */
  edges: Array<TrialsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<TrialAggregates>>;
  /** A list of `Trial` objects. */
  nodes: Array<Trial>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `Trial` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `Trial` values. */
export type TrialsConnectionGroupedAggregatesArgs = {
  groupBy: Array<TrialsGroupBy>;
  having?: InputMaybe<TrialsHavingInput>;
};

/** A `Trial` edge in the connection. */
export type TrialsEdge = {
  __typename?: 'TrialsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `Trial` at the end of the edge. */
  node: Trial;
};

/** Grouping methods for `Trial` for usage during aggregation. */
export type TrialsGroupBy =
  | 'AVATAR'
  | 'CANNOT_USE_THE_INTERVENTION'
  | 'CAN_ACCESS_ER_SINCE'
  | 'CAN_ACCESS_ER_SINCE_TRUNCATED_TO_DAY'
  | 'CAN_ACCESS_ER_SINCE_TRUNCATED_TO_HOUR'
  | 'CAN_ACCESS_SIP_SINCE'
  | 'CAN_ACCESS_SIP_SINCE_TRUNCATED_TO_DAY'
  | 'CAN_ACCESS_SIP_SINCE_TRUNCATED_TO_HOUR'
  | 'CAN_BE_INCLUDED'
  | 'CREATED_AT'
  | 'CREATED_AT_TRUNCATED_TO_DAY'
  | 'CREATED_AT_TRUNCATED_TO_HOUR'
  | 'CREATED_BY_ID'
  | 'EMERGENCY_PHONE_NUMBERS'
  | 'HAS_ACCESS_TO_A_SMARTPHONE'
  | 'HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN'
  | 'HAS_AGE_BETWEEN_18_AND_25'
  | 'HAS_CURRENT_SUICIDAL_IDEATION'
  | 'HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES'
  | 'HAS_GIVEN_INFORMED_CONSENT_AT'
  | 'INTERNAL_MESSAGES_ID'
  | 'MEETS_ALL_INCLUSION_CRITERIA'
  | 'MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT'
  | 'MEETS_ANY_EXCLUSION_CRITERIA'
  | 'MESSAGES_ID'
  | 'STAFF_ID'
  | 'SUBJECTS_NICKNAME'
  | 'SUBJECT_ID'
  | 'TENANT_ID'
  | 'UPDATED_AT'
  | 'UPDATED_AT_TRUNCATED_TO_DAY'
  | 'UPDATED_AT_TRUNCATED_TO_HOUR';

export type TrialsHavingAverageInput = {
  canAccessErSince?: InputMaybe<HavingDatetimeFilter>;
  canAccessSipSince?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  hasGivenInformedConsentAt?: InputMaybe<HavingDatetimeFilter>;
  humanReadableId?: InputMaybe<HavingBigintFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TrialsHavingDistinctCountInput = {
  canAccessErSince?: InputMaybe<HavingDatetimeFilter>;
  canAccessSipSince?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  hasGivenInformedConsentAt?: InputMaybe<HavingDatetimeFilter>;
  humanReadableId?: InputMaybe<HavingBigintFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `Trial` aggregates. */
export type TrialsHavingInput = {
  AND?: InputMaybe<Array<TrialsHavingInput>>;
  OR?: InputMaybe<Array<TrialsHavingInput>>;
  average?: InputMaybe<TrialsHavingAverageInput>;
  distinctCount?: InputMaybe<TrialsHavingDistinctCountInput>;
  max?: InputMaybe<TrialsHavingMaxInput>;
  min?: InputMaybe<TrialsHavingMinInput>;
  stddevPopulation?: InputMaybe<TrialsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<TrialsHavingStddevSampleInput>;
  sum?: InputMaybe<TrialsHavingSumInput>;
  variancePopulation?: InputMaybe<TrialsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<TrialsHavingVarianceSampleInput>;
};

export type TrialsHavingMaxInput = {
  canAccessErSince?: InputMaybe<HavingDatetimeFilter>;
  canAccessSipSince?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  hasGivenInformedConsentAt?: InputMaybe<HavingDatetimeFilter>;
  humanReadableId?: InputMaybe<HavingBigintFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TrialsHavingMinInput = {
  canAccessErSince?: InputMaybe<HavingDatetimeFilter>;
  canAccessSipSince?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  hasGivenInformedConsentAt?: InputMaybe<HavingDatetimeFilter>;
  humanReadableId?: InputMaybe<HavingBigintFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TrialsHavingStddevPopulationInput = {
  canAccessErSince?: InputMaybe<HavingDatetimeFilter>;
  canAccessSipSince?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  hasGivenInformedConsentAt?: InputMaybe<HavingDatetimeFilter>;
  humanReadableId?: InputMaybe<HavingBigintFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TrialsHavingStddevSampleInput = {
  canAccessErSince?: InputMaybe<HavingDatetimeFilter>;
  canAccessSipSince?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  hasGivenInformedConsentAt?: InputMaybe<HavingDatetimeFilter>;
  humanReadableId?: InputMaybe<HavingBigintFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TrialsHavingSumInput = {
  canAccessErSince?: InputMaybe<HavingDatetimeFilter>;
  canAccessSipSince?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  hasGivenInformedConsentAt?: InputMaybe<HavingDatetimeFilter>;
  humanReadableId?: InputMaybe<HavingBigintFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TrialsHavingVariancePopulationInput = {
  canAccessErSince?: InputMaybe<HavingDatetimeFilter>;
  canAccessSipSince?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  hasGivenInformedConsentAt?: InputMaybe<HavingDatetimeFilter>;
  humanReadableId?: InputMaybe<HavingBigintFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type TrialsHavingVarianceSampleInput = {
  canAccessErSince?: InputMaybe<HavingDatetimeFilter>;
  canAccessSipSince?: InputMaybe<HavingDatetimeFilter>;
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  hasGivenInformedConsentAt?: InputMaybe<HavingDatetimeFilter>;
  humanReadableId?: InputMaybe<HavingBigintFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `Trial`. */
export type TrialsOrderBy =
  | 'AVATAR_ASC'
  | 'AVATAR_DESC'
  | 'CANNOT_USE_THE_INTERVENTION_ASC'
  | 'CANNOT_USE_THE_INTERVENTION_DESC'
  | 'CAN_ACCESS_ER_SINCE_ASC'
  | 'CAN_ACCESS_ER_SINCE_DESC'
  | 'CAN_ACCESS_SIP_SINCE_ASC'
  | 'CAN_ACCESS_SIP_SINCE_DESC'
  | 'CAN_BE_INCLUDED_ASC'
  | 'CAN_BE_INCLUDED_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'CREATED_BY_ID_ASC'
  | 'CREATED_BY_ID_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_ANGRY_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_ANGRY_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_ANXIOUS_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_ANXIOUS_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_AT_THAT_MOMENT_I_FELT_MORE_COMFORTABLE_ALONE_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_AT_THAT_MOMENT_I_FELT_MORE_COMFORTABLE_ALONE_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_BURDENS_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_BURDENS_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_COULD_RESOLVE_BURDENS_IN_ADVANCE_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_COULD_RESOLVE_BURDENS_IN_ADVANCE_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_CREATED_AT_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_CREATED_AT_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_DELETED_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_DELETED_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_DETERMINED_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_DETERMINED_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_ENERGETIC_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_ENERGETIC_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_ENTHUSIASTIC_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_ENTHUSIASTIC_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_EXPECTED_BURDEN_THAT_DID_NOT_OCCUR_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_EXPECTED_BURDEN_THAT_DID_NOT_OCCUR_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_EXPECT_BURDEN_IN_THE_NEAR_FUTURE_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_EXPECT_BURDEN_IN_THE_NEAR_FUTURE_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_GUILTY_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_GUILTY_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_HAPPY_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_HAPPY_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_HAPPY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_HAPPY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_HELPLESS_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_HELPLESS_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_ID_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_ID_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_INSPIRED_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_INSPIRED_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_LACK_OF_SOCIAL_CONTACT_FOR_EXTERNAL_REASONS_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_LACK_OF_SOCIAL_CONTACT_FOR_EXTERNAL_REASONS_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_LONELY_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_LONELY_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_NO_BURDEN_FOR_EXTERNAL_REASONS_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_NO_BURDEN_FOR_EXTERNAL_REASONS_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_PLANNED_HOW_TO_PROCEED_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_PLANNED_HOW_TO_PROCEED_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_RELAXED_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_RELAXED_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_SAD_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_SAD_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_SATISFIED_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_SATISFIED_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_SMS_RECEIVED_AT_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_SMS_RECEIVED_AT_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_SOCIAL_DISTRESS_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_SOCIAL_DISTRESS_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_STARTED_AT_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_STARTED_AT_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_STRAIN_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_STRAIN_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_STRENGTH_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_STRENGTH_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_STRESSED_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_STRESSED_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_TESTY_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_TESTY_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_TRIAL_ID_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_TRIAL_ID_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_TRIED_TO_CALM_MYSELF_DOWN_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_TRIED_TO_CALM_MYSELF_DOWN_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_TRIED_TO_THINK_DIFFERENTLY_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_TRIED_TO_THINK_DIFFERENTLY_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_TYPICAL_THAT_NO_BURDEN_HAVE_OCCURED_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_TYPICAL_THAT_NO_BURDEN_HAVE_OCCURED_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_UNDERSTOOD_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_UNDERSTOOD_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_UPDATED_AT_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_UPDATED_AT_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_WAVE_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_WAVE_DESC'
  | 'EMA_ENTRIES3S_AVERAGE_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES3S_AVERAGE_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES3S_COUNT_ASC'
  | 'EMA_ENTRIES3S_COUNT_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_ANGRY_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_ANGRY_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_ANXIOUS_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_ANXIOUS_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_AT_THAT_MOMENT_I_FELT_MORE_COMFORTABLE_ALONE_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_AT_THAT_MOMENT_I_FELT_MORE_COMFORTABLE_ALONE_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_BURDENS_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_BURDENS_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_COULD_RESOLVE_BURDENS_IN_ADVANCE_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_COULD_RESOLVE_BURDENS_IN_ADVANCE_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_DELETED_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_DELETED_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_DETERMINED_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_DETERMINED_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_ENERGETIC_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_ENERGETIC_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_ENTHUSIASTIC_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_ENTHUSIASTIC_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_EXPECTED_BURDEN_THAT_DID_NOT_OCCUR_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_EXPECTED_BURDEN_THAT_DID_NOT_OCCUR_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_EXPECT_BURDEN_IN_THE_NEAR_FUTURE_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_EXPECT_BURDEN_IN_THE_NEAR_FUTURE_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_GUILTY_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_GUILTY_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_HAPPY_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_HAPPY_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_HAPPY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_HAPPY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_HELPLESS_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_HELPLESS_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_ID_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_ID_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_INSPIRED_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_INSPIRED_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_LACK_OF_SOCIAL_CONTACT_FOR_EXTERNAL_REASONS_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_LACK_OF_SOCIAL_CONTACT_FOR_EXTERNAL_REASONS_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_LONELY_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_LONELY_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_NO_BURDEN_FOR_EXTERNAL_REASONS_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_NO_BURDEN_FOR_EXTERNAL_REASONS_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_PLANNED_HOW_TO_PROCEED_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_PLANNED_HOW_TO_PROCEED_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_RELAXED_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_RELAXED_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_SAD_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_SAD_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_SATISFIED_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_SATISFIED_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_SMS_RECEIVED_AT_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_SMS_RECEIVED_AT_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_SOCIAL_DISTRESS_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_SOCIAL_DISTRESS_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_STARTED_AT_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_STARTED_AT_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_STRAIN_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_STRAIN_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_STRENGTH_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_STRENGTH_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_STRESSED_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_STRESSED_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_TESTY_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_TESTY_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_TRIAL_ID_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_TRIAL_ID_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_TRIED_TO_CALM_MYSELF_DOWN_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_TRIED_TO_CALM_MYSELF_DOWN_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_TRIED_TO_THINK_DIFFERENTLY_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_TRIED_TO_THINK_DIFFERENTLY_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_TYPICAL_THAT_NO_BURDEN_HAVE_OCCURED_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_TYPICAL_THAT_NO_BURDEN_HAVE_OCCURED_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_UNDERSTOOD_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_UNDERSTOOD_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_WAVE_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_WAVE_DESC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES3S_DISTINCT_COUNT_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES3S_MAX_ANGRY_ASC'
  | 'EMA_ENTRIES3S_MAX_ANGRY_DESC'
  | 'EMA_ENTRIES3S_MAX_ANXIOUS_ASC'
  | 'EMA_ENTRIES3S_MAX_ANXIOUS_DESC'
  | 'EMA_ENTRIES3S_MAX_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_MAX_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_MAX_AT_THAT_MOMENT_I_FELT_MORE_COMFORTABLE_ALONE_ASC'
  | 'EMA_ENTRIES3S_MAX_AT_THAT_MOMENT_I_FELT_MORE_COMFORTABLE_ALONE_DESC'
  | 'EMA_ENTRIES3S_MAX_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES3S_MAX_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES3S_MAX_BURDENS_ASC'
  | 'EMA_ENTRIES3S_MAX_BURDENS_DESC'
  | 'EMA_ENTRIES3S_MAX_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_MAX_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_MAX_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES3S_MAX_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES3S_MAX_COULD_RESOLVE_BURDENS_IN_ADVANCE_ASC'
  | 'EMA_ENTRIES3S_MAX_COULD_RESOLVE_BURDENS_IN_ADVANCE_DESC'
  | 'EMA_ENTRIES3S_MAX_CREATED_AT_ASC'
  | 'EMA_ENTRIES3S_MAX_CREATED_AT_DESC'
  | 'EMA_ENTRIES3S_MAX_DELETED_ASC'
  | 'EMA_ENTRIES3S_MAX_DELETED_DESC'
  | 'EMA_ENTRIES3S_MAX_DETERMINED_ASC'
  | 'EMA_ENTRIES3S_MAX_DETERMINED_DESC'
  | 'EMA_ENTRIES3S_MAX_ENERGETIC_ASC'
  | 'EMA_ENTRIES3S_MAX_ENERGETIC_DESC'
  | 'EMA_ENTRIES3S_MAX_ENTHUSIASTIC_ASC'
  | 'EMA_ENTRIES3S_MAX_ENTHUSIASTIC_DESC'
  | 'EMA_ENTRIES3S_MAX_EXPECTED_BURDEN_THAT_DID_NOT_OCCUR_ASC'
  | 'EMA_ENTRIES3S_MAX_EXPECTED_BURDEN_THAT_DID_NOT_OCCUR_DESC'
  | 'EMA_ENTRIES3S_MAX_EXPECT_BURDEN_IN_THE_NEAR_FUTURE_ASC'
  | 'EMA_ENTRIES3S_MAX_EXPECT_BURDEN_IN_THE_NEAR_FUTURE_DESC'
  | 'EMA_ENTRIES3S_MAX_GUILTY_ASC'
  | 'EMA_ENTRIES3S_MAX_GUILTY_DESC'
  | 'EMA_ENTRIES3S_MAX_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES3S_MAX_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES3S_MAX_HAPPY_ASC'
  | 'EMA_ENTRIES3S_MAX_HAPPY_DESC'
  | 'EMA_ENTRIES3S_MAX_HAPPY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_MAX_HAPPY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_MAX_HELPLESS_ASC'
  | 'EMA_ENTRIES3S_MAX_HELPLESS_DESC'
  | 'EMA_ENTRIES3S_MAX_ID_ASC'
  | 'EMA_ENTRIES3S_MAX_ID_DESC'
  | 'EMA_ENTRIES3S_MAX_INSPIRED_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_MAX_INSPIRED_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_MAX_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES3S_MAX_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES3S_MAX_LACK_OF_SOCIAL_CONTACT_FOR_EXTERNAL_REASONS_ASC'
  | 'EMA_ENTRIES3S_MAX_LACK_OF_SOCIAL_CONTACT_FOR_EXTERNAL_REASONS_DESC'
  | 'EMA_ENTRIES3S_MAX_LONELY_ASC'
  | 'EMA_ENTRIES3S_MAX_LONELY_DESC'
  | 'EMA_ENTRIES3S_MAX_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_ASC'
  | 'EMA_ENTRIES3S_MAX_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_DESC'
  | 'EMA_ENTRIES3S_MAX_NO_BURDEN_FOR_EXTERNAL_REASONS_ASC'
  | 'EMA_ENTRIES3S_MAX_NO_BURDEN_FOR_EXTERNAL_REASONS_DESC'
  | 'EMA_ENTRIES3S_MAX_PLANNED_HOW_TO_PROCEED_ASC'
  | 'EMA_ENTRIES3S_MAX_PLANNED_HOW_TO_PROCEED_DESC'
  | 'EMA_ENTRIES3S_MAX_RELAXED_ASC'
  | 'EMA_ENTRIES3S_MAX_RELAXED_DESC'
  | 'EMA_ENTRIES3S_MAX_SAD_ASC'
  | 'EMA_ENTRIES3S_MAX_SAD_DESC'
  | 'EMA_ENTRIES3S_MAX_SATISFIED_ASC'
  | 'EMA_ENTRIES3S_MAX_SATISFIED_DESC'
  | 'EMA_ENTRIES3S_MAX_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES3S_MAX_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES3S_MAX_SMS_RECEIVED_AT_ASC'
  | 'EMA_ENTRIES3S_MAX_SMS_RECEIVED_AT_DESC'
  | 'EMA_ENTRIES3S_MAX_SOCIAL_DISTRESS_ASC'
  | 'EMA_ENTRIES3S_MAX_SOCIAL_DISTRESS_DESC'
  | 'EMA_ENTRIES3S_MAX_STARTED_AT_ASC'
  | 'EMA_ENTRIES3S_MAX_STARTED_AT_DESC'
  | 'EMA_ENTRIES3S_MAX_STRAIN_ASC'
  | 'EMA_ENTRIES3S_MAX_STRAIN_DESC'
  | 'EMA_ENTRIES3S_MAX_STRENGTH_ASC'
  | 'EMA_ENTRIES3S_MAX_STRENGTH_DESC'
  | 'EMA_ENTRIES3S_MAX_STRESSED_ASC'
  | 'EMA_ENTRIES3S_MAX_STRESSED_DESC'
  | 'EMA_ENTRIES3S_MAX_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_MAX_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_MAX_TESTY_ASC'
  | 'EMA_ENTRIES3S_MAX_TESTY_DESC'
  | 'EMA_ENTRIES3S_MAX_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_MAX_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_MAX_TRIAL_ID_ASC'
  | 'EMA_ENTRIES3S_MAX_TRIAL_ID_DESC'
  | 'EMA_ENTRIES3S_MAX_TRIED_TO_CALM_MYSELF_DOWN_ASC'
  | 'EMA_ENTRIES3S_MAX_TRIED_TO_CALM_MYSELF_DOWN_DESC'
  | 'EMA_ENTRIES3S_MAX_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES3S_MAX_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES3S_MAX_TRIED_TO_THINK_DIFFERENTLY_ASC'
  | 'EMA_ENTRIES3S_MAX_TRIED_TO_THINK_DIFFERENTLY_DESC'
  | 'EMA_ENTRIES3S_MAX_TYPICAL_THAT_NO_BURDEN_HAVE_OCCURED_ASC'
  | 'EMA_ENTRIES3S_MAX_TYPICAL_THAT_NO_BURDEN_HAVE_OCCURED_DESC'
  | 'EMA_ENTRIES3S_MAX_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_MAX_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_MAX_UNDERSTOOD_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_MAX_UNDERSTOOD_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_MAX_UPDATED_AT_ASC'
  | 'EMA_ENTRIES3S_MAX_UPDATED_AT_DESC'
  | 'EMA_ENTRIES3S_MAX_WAVE_ASC'
  | 'EMA_ENTRIES3S_MAX_WAVE_DESC'
  | 'EMA_ENTRIES3S_MAX_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES3S_MAX_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES3S_MIN_ANGRY_ASC'
  | 'EMA_ENTRIES3S_MIN_ANGRY_DESC'
  | 'EMA_ENTRIES3S_MIN_ANXIOUS_ASC'
  | 'EMA_ENTRIES3S_MIN_ANXIOUS_DESC'
  | 'EMA_ENTRIES3S_MIN_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_MIN_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_MIN_AT_THAT_MOMENT_I_FELT_MORE_COMFORTABLE_ALONE_ASC'
  | 'EMA_ENTRIES3S_MIN_AT_THAT_MOMENT_I_FELT_MORE_COMFORTABLE_ALONE_DESC'
  | 'EMA_ENTRIES3S_MIN_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES3S_MIN_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES3S_MIN_BURDENS_ASC'
  | 'EMA_ENTRIES3S_MIN_BURDENS_DESC'
  | 'EMA_ENTRIES3S_MIN_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_MIN_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_MIN_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES3S_MIN_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES3S_MIN_COULD_RESOLVE_BURDENS_IN_ADVANCE_ASC'
  | 'EMA_ENTRIES3S_MIN_COULD_RESOLVE_BURDENS_IN_ADVANCE_DESC'
  | 'EMA_ENTRIES3S_MIN_CREATED_AT_ASC'
  | 'EMA_ENTRIES3S_MIN_CREATED_AT_DESC'
  | 'EMA_ENTRIES3S_MIN_DELETED_ASC'
  | 'EMA_ENTRIES3S_MIN_DELETED_DESC'
  | 'EMA_ENTRIES3S_MIN_DETERMINED_ASC'
  | 'EMA_ENTRIES3S_MIN_DETERMINED_DESC'
  | 'EMA_ENTRIES3S_MIN_ENERGETIC_ASC'
  | 'EMA_ENTRIES3S_MIN_ENERGETIC_DESC'
  | 'EMA_ENTRIES3S_MIN_ENTHUSIASTIC_ASC'
  | 'EMA_ENTRIES3S_MIN_ENTHUSIASTIC_DESC'
  | 'EMA_ENTRIES3S_MIN_EXPECTED_BURDEN_THAT_DID_NOT_OCCUR_ASC'
  | 'EMA_ENTRIES3S_MIN_EXPECTED_BURDEN_THAT_DID_NOT_OCCUR_DESC'
  | 'EMA_ENTRIES3S_MIN_EXPECT_BURDEN_IN_THE_NEAR_FUTURE_ASC'
  | 'EMA_ENTRIES3S_MIN_EXPECT_BURDEN_IN_THE_NEAR_FUTURE_DESC'
  | 'EMA_ENTRIES3S_MIN_GUILTY_ASC'
  | 'EMA_ENTRIES3S_MIN_GUILTY_DESC'
  | 'EMA_ENTRIES3S_MIN_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES3S_MIN_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES3S_MIN_HAPPY_ASC'
  | 'EMA_ENTRIES3S_MIN_HAPPY_DESC'
  | 'EMA_ENTRIES3S_MIN_HAPPY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_MIN_HAPPY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_MIN_HELPLESS_ASC'
  | 'EMA_ENTRIES3S_MIN_HELPLESS_DESC'
  | 'EMA_ENTRIES3S_MIN_ID_ASC'
  | 'EMA_ENTRIES3S_MIN_ID_DESC'
  | 'EMA_ENTRIES3S_MIN_INSPIRED_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_MIN_INSPIRED_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_MIN_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES3S_MIN_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES3S_MIN_LACK_OF_SOCIAL_CONTACT_FOR_EXTERNAL_REASONS_ASC'
  | 'EMA_ENTRIES3S_MIN_LACK_OF_SOCIAL_CONTACT_FOR_EXTERNAL_REASONS_DESC'
  | 'EMA_ENTRIES3S_MIN_LONELY_ASC'
  | 'EMA_ENTRIES3S_MIN_LONELY_DESC'
  | 'EMA_ENTRIES3S_MIN_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_ASC'
  | 'EMA_ENTRIES3S_MIN_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_DESC'
  | 'EMA_ENTRIES3S_MIN_NO_BURDEN_FOR_EXTERNAL_REASONS_ASC'
  | 'EMA_ENTRIES3S_MIN_NO_BURDEN_FOR_EXTERNAL_REASONS_DESC'
  | 'EMA_ENTRIES3S_MIN_PLANNED_HOW_TO_PROCEED_ASC'
  | 'EMA_ENTRIES3S_MIN_PLANNED_HOW_TO_PROCEED_DESC'
  | 'EMA_ENTRIES3S_MIN_RELAXED_ASC'
  | 'EMA_ENTRIES3S_MIN_RELAXED_DESC'
  | 'EMA_ENTRIES3S_MIN_SAD_ASC'
  | 'EMA_ENTRIES3S_MIN_SAD_DESC'
  | 'EMA_ENTRIES3S_MIN_SATISFIED_ASC'
  | 'EMA_ENTRIES3S_MIN_SATISFIED_DESC'
  | 'EMA_ENTRIES3S_MIN_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES3S_MIN_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES3S_MIN_SMS_RECEIVED_AT_ASC'
  | 'EMA_ENTRIES3S_MIN_SMS_RECEIVED_AT_DESC'
  | 'EMA_ENTRIES3S_MIN_SOCIAL_DISTRESS_ASC'
  | 'EMA_ENTRIES3S_MIN_SOCIAL_DISTRESS_DESC'
  | 'EMA_ENTRIES3S_MIN_STARTED_AT_ASC'
  | 'EMA_ENTRIES3S_MIN_STARTED_AT_DESC'
  | 'EMA_ENTRIES3S_MIN_STRAIN_ASC'
  | 'EMA_ENTRIES3S_MIN_STRAIN_DESC'
  | 'EMA_ENTRIES3S_MIN_STRENGTH_ASC'
  | 'EMA_ENTRIES3S_MIN_STRENGTH_DESC'
  | 'EMA_ENTRIES3S_MIN_STRESSED_ASC'
  | 'EMA_ENTRIES3S_MIN_STRESSED_DESC'
  | 'EMA_ENTRIES3S_MIN_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_MIN_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_MIN_TESTY_ASC'
  | 'EMA_ENTRIES3S_MIN_TESTY_DESC'
  | 'EMA_ENTRIES3S_MIN_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_MIN_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_MIN_TRIAL_ID_ASC'
  | 'EMA_ENTRIES3S_MIN_TRIAL_ID_DESC'
  | 'EMA_ENTRIES3S_MIN_TRIED_TO_CALM_MYSELF_DOWN_ASC'
  | 'EMA_ENTRIES3S_MIN_TRIED_TO_CALM_MYSELF_DOWN_DESC'
  | 'EMA_ENTRIES3S_MIN_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES3S_MIN_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES3S_MIN_TRIED_TO_THINK_DIFFERENTLY_ASC'
  | 'EMA_ENTRIES3S_MIN_TRIED_TO_THINK_DIFFERENTLY_DESC'
  | 'EMA_ENTRIES3S_MIN_TYPICAL_THAT_NO_BURDEN_HAVE_OCCURED_ASC'
  | 'EMA_ENTRIES3S_MIN_TYPICAL_THAT_NO_BURDEN_HAVE_OCCURED_DESC'
  | 'EMA_ENTRIES3S_MIN_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_MIN_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_MIN_UNDERSTOOD_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_MIN_UNDERSTOOD_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_MIN_UPDATED_AT_ASC'
  | 'EMA_ENTRIES3S_MIN_UPDATED_AT_DESC'
  | 'EMA_ENTRIES3S_MIN_WAVE_ASC'
  | 'EMA_ENTRIES3S_MIN_WAVE_DESC'
  | 'EMA_ENTRIES3S_MIN_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES3S_MIN_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_ANGRY_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_ANGRY_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_ANXIOUS_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_ANXIOUS_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_AT_THAT_MOMENT_I_FELT_MORE_COMFORTABLE_ALONE_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_AT_THAT_MOMENT_I_FELT_MORE_COMFORTABLE_ALONE_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_BURDENS_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_BURDENS_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_COULD_RESOLVE_BURDENS_IN_ADVANCE_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_COULD_RESOLVE_BURDENS_IN_ADVANCE_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_DELETED_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_DELETED_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_DETERMINED_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_DETERMINED_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_ENERGETIC_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_ENERGETIC_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_ENTHUSIASTIC_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_ENTHUSIASTIC_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_EXPECTED_BURDEN_THAT_DID_NOT_OCCUR_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_EXPECTED_BURDEN_THAT_DID_NOT_OCCUR_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_EXPECT_BURDEN_IN_THE_NEAR_FUTURE_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_EXPECT_BURDEN_IN_THE_NEAR_FUTURE_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_GUILTY_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_GUILTY_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_HAPPY_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_HAPPY_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_HAPPY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_HAPPY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_HELPLESS_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_HELPLESS_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_ID_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_ID_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_INSPIRED_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_INSPIRED_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_LACK_OF_SOCIAL_CONTACT_FOR_EXTERNAL_REASONS_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_LACK_OF_SOCIAL_CONTACT_FOR_EXTERNAL_REASONS_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_LONELY_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_LONELY_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_NO_BURDEN_FOR_EXTERNAL_REASONS_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_NO_BURDEN_FOR_EXTERNAL_REASONS_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_PLANNED_HOW_TO_PROCEED_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_PLANNED_HOW_TO_PROCEED_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_RELAXED_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_RELAXED_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_SAD_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_SAD_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_SATISFIED_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_SATISFIED_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_SMS_RECEIVED_AT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_SMS_RECEIVED_AT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_SOCIAL_DISTRESS_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_SOCIAL_DISTRESS_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_STARTED_AT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_STARTED_AT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_STRAIN_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_STRAIN_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_STRENGTH_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_STRENGTH_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_STRESSED_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_STRESSED_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_TESTY_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_TESTY_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_TRIAL_ID_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_TRIAL_ID_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_TRIED_TO_CALM_MYSELF_DOWN_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_TRIED_TO_CALM_MYSELF_DOWN_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_TRIED_TO_THINK_DIFFERENTLY_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_TRIED_TO_THINK_DIFFERENTLY_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_TYPICAL_THAT_NO_BURDEN_HAVE_OCCURED_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_TYPICAL_THAT_NO_BURDEN_HAVE_OCCURED_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_UNDERSTOOD_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_UNDERSTOOD_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_WAVE_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_WAVE_DESC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_POPULATION_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_ANGRY_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_ANGRY_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_ANXIOUS_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_ANXIOUS_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_AT_THAT_MOMENT_I_FELT_MORE_COMFORTABLE_ALONE_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_AT_THAT_MOMENT_I_FELT_MORE_COMFORTABLE_ALONE_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_BURDENS_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_BURDENS_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_COULD_RESOLVE_BURDENS_IN_ADVANCE_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_COULD_RESOLVE_BURDENS_IN_ADVANCE_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_DELETED_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_DELETED_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_DETERMINED_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_DETERMINED_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_ENERGETIC_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_ENERGETIC_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_ENTHUSIASTIC_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_ENTHUSIASTIC_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_EXPECTED_BURDEN_THAT_DID_NOT_OCCUR_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_EXPECTED_BURDEN_THAT_DID_NOT_OCCUR_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_EXPECT_BURDEN_IN_THE_NEAR_FUTURE_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_EXPECT_BURDEN_IN_THE_NEAR_FUTURE_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_GUILTY_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_GUILTY_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_HAPPY_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_HAPPY_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_HAPPY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_HAPPY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_HELPLESS_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_HELPLESS_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_ID_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_ID_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_INSPIRED_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_INSPIRED_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_LACK_OF_SOCIAL_CONTACT_FOR_EXTERNAL_REASONS_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_LACK_OF_SOCIAL_CONTACT_FOR_EXTERNAL_REASONS_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_LONELY_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_LONELY_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_NO_BURDEN_FOR_EXTERNAL_REASONS_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_NO_BURDEN_FOR_EXTERNAL_REASONS_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_PLANNED_HOW_TO_PROCEED_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_PLANNED_HOW_TO_PROCEED_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_RELAXED_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_RELAXED_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_SAD_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_SAD_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_SATISFIED_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_SATISFIED_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_SMS_RECEIVED_AT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_SMS_RECEIVED_AT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_SOCIAL_DISTRESS_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_SOCIAL_DISTRESS_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_STARTED_AT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_STARTED_AT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_STRAIN_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_STRAIN_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_STRENGTH_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_STRENGTH_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_STRESSED_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_STRESSED_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_TESTY_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_TESTY_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_TRIAL_ID_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_TRIAL_ID_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_TRIED_TO_CALM_MYSELF_DOWN_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_TRIED_TO_CALM_MYSELF_DOWN_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_TRIED_TO_THINK_DIFFERENTLY_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_TRIED_TO_THINK_DIFFERENTLY_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_TYPICAL_THAT_NO_BURDEN_HAVE_OCCURED_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_TYPICAL_THAT_NO_BURDEN_HAVE_OCCURED_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_UNDERSTOOD_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_UNDERSTOOD_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_WAVE_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_WAVE_DESC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES3S_STDDEV_SAMPLE_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES3S_SUM_ANGRY_ASC'
  | 'EMA_ENTRIES3S_SUM_ANGRY_DESC'
  | 'EMA_ENTRIES3S_SUM_ANXIOUS_ASC'
  | 'EMA_ENTRIES3S_SUM_ANXIOUS_DESC'
  | 'EMA_ENTRIES3S_SUM_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_SUM_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_SUM_AT_THAT_MOMENT_I_FELT_MORE_COMFORTABLE_ALONE_ASC'
  | 'EMA_ENTRIES3S_SUM_AT_THAT_MOMENT_I_FELT_MORE_COMFORTABLE_ALONE_DESC'
  | 'EMA_ENTRIES3S_SUM_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES3S_SUM_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES3S_SUM_BURDENS_ASC'
  | 'EMA_ENTRIES3S_SUM_BURDENS_DESC'
  | 'EMA_ENTRIES3S_SUM_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_SUM_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_SUM_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES3S_SUM_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES3S_SUM_COULD_RESOLVE_BURDENS_IN_ADVANCE_ASC'
  | 'EMA_ENTRIES3S_SUM_COULD_RESOLVE_BURDENS_IN_ADVANCE_DESC'
  | 'EMA_ENTRIES3S_SUM_CREATED_AT_ASC'
  | 'EMA_ENTRIES3S_SUM_CREATED_AT_DESC'
  | 'EMA_ENTRIES3S_SUM_DELETED_ASC'
  | 'EMA_ENTRIES3S_SUM_DELETED_DESC'
  | 'EMA_ENTRIES3S_SUM_DETERMINED_ASC'
  | 'EMA_ENTRIES3S_SUM_DETERMINED_DESC'
  | 'EMA_ENTRIES3S_SUM_ENERGETIC_ASC'
  | 'EMA_ENTRIES3S_SUM_ENERGETIC_DESC'
  | 'EMA_ENTRIES3S_SUM_ENTHUSIASTIC_ASC'
  | 'EMA_ENTRIES3S_SUM_ENTHUSIASTIC_DESC'
  | 'EMA_ENTRIES3S_SUM_EXPECTED_BURDEN_THAT_DID_NOT_OCCUR_ASC'
  | 'EMA_ENTRIES3S_SUM_EXPECTED_BURDEN_THAT_DID_NOT_OCCUR_DESC'
  | 'EMA_ENTRIES3S_SUM_EXPECT_BURDEN_IN_THE_NEAR_FUTURE_ASC'
  | 'EMA_ENTRIES3S_SUM_EXPECT_BURDEN_IN_THE_NEAR_FUTURE_DESC'
  | 'EMA_ENTRIES3S_SUM_GUILTY_ASC'
  | 'EMA_ENTRIES3S_SUM_GUILTY_DESC'
  | 'EMA_ENTRIES3S_SUM_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES3S_SUM_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES3S_SUM_HAPPY_ASC'
  | 'EMA_ENTRIES3S_SUM_HAPPY_DESC'
  | 'EMA_ENTRIES3S_SUM_HAPPY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_SUM_HAPPY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_SUM_HELPLESS_ASC'
  | 'EMA_ENTRIES3S_SUM_HELPLESS_DESC'
  | 'EMA_ENTRIES3S_SUM_ID_ASC'
  | 'EMA_ENTRIES3S_SUM_ID_DESC'
  | 'EMA_ENTRIES3S_SUM_INSPIRED_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_SUM_INSPIRED_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_SUM_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES3S_SUM_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES3S_SUM_LACK_OF_SOCIAL_CONTACT_FOR_EXTERNAL_REASONS_ASC'
  | 'EMA_ENTRIES3S_SUM_LACK_OF_SOCIAL_CONTACT_FOR_EXTERNAL_REASONS_DESC'
  | 'EMA_ENTRIES3S_SUM_LONELY_ASC'
  | 'EMA_ENTRIES3S_SUM_LONELY_DESC'
  | 'EMA_ENTRIES3S_SUM_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_ASC'
  | 'EMA_ENTRIES3S_SUM_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_DESC'
  | 'EMA_ENTRIES3S_SUM_NO_BURDEN_FOR_EXTERNAL_REASONS_ASC'
  | 'EMA_ENTRIES3S_SUM_NO_BURDEN_FOR_EXTERNAL_REASONS_DESC'
  | 'EMA_ENTRIES3S_SUM_PLANNED_HOW_TO_PROCEED_ASC'
  | 'EMA_ENTRIES3S_SUM_PLANNED_HOW_TO_PROCEED_DESC'
  | 'EMA_ENTRIES3S_SUM_RELAXED_ASC'
  | 'EMA_ENTRIES3S_SUM_RELAXED_DESC'
  | 'EMA_ENTRIES3S_SUM_SAD_ASC'
  | 'EMA_ENTRIES3S_SUM_SAD_DESC'
  | 'EMA_ENTRIES3S_SUM_SATISFIED_ASC'
  | 'EMA_ENTRIES3S_SUM_SATISFIED_DESC'
  | 'EMA_ENTRIES3S_SUM_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES3S_SUM_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES3S_SUM_SMS_RECEIVED_AT_ASC'
  | 'EMA_ENTRIES3S_SUM_SMS_RECEIVED_AT_DESC'
  | 'EMA_ENTRIES3S_SUM_SOCIAL_DISTRESS_ASC'
  | 'EMA_ENTRIES3S_SUM_SOCIAL_DISTRESS_DESC'
  | 'EMA_ENTRIES3S_SUM_STARTED_AT_ASC'
  | 'EMA_ENTRIES3S_SUM_STARTED_AT_DESC'
  | 'EMA_ENTRIES3S_SUM_STRAIN_ASC'
  | 'EMA_ENTRIES3S_SUM_STRAIN_DESC'
  | 'EMA_ENTRIES3S_SUM_STRENGTH_ASC'
  | 'EMA_ENTRIES3S_SUM_STRENGTH_DESC'
  | 'EMA_ENTRIES3S_SUM_STRESSED_ASC'
  | 'EMA_ENTRIES3S_SUM_STRESSED_DESC'
  | 'EMA_ENTRIES3S_SUM_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_SUM_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_SUM_TESTY_ASC'
  | 'EMA_ENTRIES3S_SUM_TESTY_DESC'
  | 'EMA_ENTRIES3S_SUM_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_SUM_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_SUM_TRIAL_ID_ASC'
  | 'EMA_ENTRIES3S_SUM_TRIAL_ID_DESC'
  | 'EMA_ENTRIES3S_SUM_TRIED_TO_CALM_MYSELF_DOWN_ASC'
  | 'EMA_ENTRIES3S_SUM_TRIED_TO_CALM_MYSELF_DOWN_DESC'
  | 'EMA_ENTRIES3S_SUM_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES3S_SUM_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES3S_SUM_TRIED_TO_THINK_DIFFERENTLY_ASC'
  | 'EMA_ENTRIES3S_SUM_TRIED_TO_THINK_DIFFERENTLY_DESC'
  | 'EMA_ENTRIES3S_SUM_TYPICAL_THAT_NO_BURDEN_HAVE_OCCURED_ASC'
  | 'EMA_ENTRIES3S_SUM_TYPICAL_THAT_NO_BURDEN_HAVE_OCCURED_DESC'
  | 'EMA_ENTRIES3S_SUM_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_SUM_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_SUM_UNDERSTOOD_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_SUM_UNDERSTOOD_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_SUM_UPDATED_AT_ASC'
  | 'EMA_ENTRIES3S_SUM_UPDATED_AT_DESC'
  | 'EMA_ENTRIES3S_SUM_WAVE_ASC'
  | 'EMA_ENTRIES3S_SUM_WAVE_DESC'
  | 'EMA_ENTRIES3S_SUM_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES3S_SUM_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_ANGRY_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_ANGRY_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_ANXIOUS_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_ANXIOUS_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_AT_THAT_MOMENT_I_FELT_MORE_COMFORTABLE_ALONE_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_AT_THAT_MOMENT_I_FELT_MORE_COMFORTABLE_ALONE_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_BURDENS_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_BURDENS_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_COULD_RESOLVE_BURDENS_IN_ADVANCE_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_COULD_RESOLVE_BURDENS_IN_ADVANCE_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_DELETED_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_DELETED_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_DETERMINED_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_DETERMINED_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_ENERGETIC_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_ENERGETIC_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_ENTHUSIASTIC_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_ENTHUSIASTIC_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_EXPECTED_BURDEN_THAT_DID_NOT_OCCUR_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_EXPECTED_BURDEN_THAT_DID_NOT_OCCUR_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_EXPECT_BURDEN_IN_THE_NEAR_FUTURE_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_EXPECT_BURDEN_IN_THE_NEAR_FUTURE_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_GUILTY_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_GUILTY_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_HAPPY_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_HAPPY_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_HAPPY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_HAPPY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_HELPLESS_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_HELPLESS_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_ID_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_ID_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_INSPIRED_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_INSPIRED_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_LACK_OF_SOCIAL_CONTACT_FOR_EXTERNAL_REASONS_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_LACK_OF_SOCIAL_CONTACT_FOR_EXTERNAL_REASONS_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_LONELY_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_LONELY_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_NO_BURDEN_FOR_EXTERNAL_REASONS_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_NO_BURDEN_FOR_EXTERNAL_REASONS_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_PLANNED_HOW_TO_PROCEED_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_PLANNED_HOW_TO_PROCEED_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_RELAXED_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_RELAXED_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_SAD_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_SAD_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_SATISFIED_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_SATISFIED_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_SMS_RECEIVED_AT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_SMS_RECEIVED_AT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_SOCIAL_DISTRESS_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_SOCIAL_DISTRESS_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_STARTED_AT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_STARTED_AT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_STRAIN_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_STRAIN_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_STRENGTH_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_STRENGTH_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_STRESSED_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_STRESSED_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_TESTY_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_TESTY_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_TRIAL_ID_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_TRIAL_ID_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_TRIED_TO_CALM_MYSELF_DOWN_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_TRIED_TO_CALM_MYSELF_DOWN_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_TRIED_TO_THINK_DIFFERENTLY_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_TRIED_TO_THINK_DIFFERENTLY_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_TYPICAL_THAT_NO_BURDEN_HAVE_OCCURED_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_TYPICAL_THAT_NO_BURDEN_HAVE_OCCURED_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_UNDERSTOOD_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_UNDERSTOOD_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_WAVE_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_WAVE_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_POPULATION_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_ANGRY_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_ANGRY_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_ANXIOUS_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_ANXIOUS_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_AT_THAT_MOMENT_I_FELT_MORE_COMFORTABLE_ALONE_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_AT_THAT_MOMENT_I_FELT_MORE_COMFORTABLE_ALONE_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_BURDENS_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_BURDENS_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_COULD_RESOLVE_BURDENS_IN_ADVANCE_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_COULD_RESOLVE_BURDENS_IN_ADVANCE_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_DELETED_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_DELETED_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_DETERMINED_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_DETERMINED_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_ENERGETIC_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_ENERGETIC_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_ENTHUSIASTIC_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_ENTHUSIASTIC_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_EXPECTED_BURDEN_THAT_DID_NOT_OCCUR_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_EXPECTED_BURDEN_THAT_DID_NOT_OCCUR_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_EXPECT_BURDEN_IN_THE_NEAR_FUTURE_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_EXPECT_BURDEN_IN_THE_NEAR_FUTURE_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_GUILTY_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_GUILTY_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_HAPPY_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_HAPPY_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_HAPPY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_HAPPY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_HELPLESS_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_HELPLESS_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_ID_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_ID_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_INSPIRED_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_INSPIRED_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_LACK_OF_SOCIAL_CONTACT_FOR_EXTERNAL_REASONS_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_LACK_OF_SOCIAL_CONTACT_FOR_EXTERNAL_REASONS_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_LONELY_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_LONELY_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_NO_BURDEN_FOR_EXTERNAL_REASONS_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_NO_BURDEN_FOR_EXTERNAL_REASONS_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_PLANNED_HOW_TO_PROCEED_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_PLANNED_HOW_TO_PROCEED_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_RELAXED_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_RELAXED_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_SAD_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_SAD_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_SATISFIED_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_SATISFIED_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_SMS_RECEIVED_AT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_SMS_RECEIVED_AT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_SOCIAL_DISTRESS_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_SOCIAL_DISTRESS_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_STARTED_AT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_STARTED_AT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_STRAIN_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_STRAIN_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_STRENGTH_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_STRENGTH_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_STRESSED_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_STRESSED_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_TESTY_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_TESTY_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_TRIAL_ID_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_TRIAL_ID_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_TRIED_TO_CALM_MYSELF_DOWN_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_TRIED_TO_CALM_MYSELF_DOWN_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_TRIED_TO_THINK_DIFFERENTLY_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_TRIED_TO_THINK_DIFFERENTLY_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_TYPICAL_THAT_NO_BURDEN_HAVE_OCCURED_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_TYPICAL_THAT_NO_BURDEN_HAVE_OCCURED_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_UNDERSTOOD_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_UNDERSTOOD_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_WAVE_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_WAVE_DESC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES3S_VARIANCE_SAMPLE_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMERGENCY_PHONE_NUMBERS_ASC'
  | 'EMERGENCY_PHONE_NUMBERS_DESC'
  | 'FAVORITE_PAGES_AVERAGE_ADDED_AT_ASC'
  | 'FAVORITE_PAGES_AVERAGE_ADDED_AT_DESC'
  | 'FAVORITE_PAGES_AVERAGE_ROUTE_ASC'
  | 'FAVORITE_PAGES_AVERAGE_ROUTE_DESC'
  | 'FAVORITE_PAGES_AVERAGE_TRIAL_ID_ASC'
  | 'FAVORITE_PAGES_AVERAGE_TRIAL_ID_DESC'
  | 'FAVORITE_PAGES_COUNT_ASC'
  | 'FAVORITE_PAGES_COUNT_DESC'
  | 'FAVORITE_PAGES_DISTINCT_COUNT_ADDED_AT_ASC'
  | 'FAVORITE_PAGES_DISTINCT_COUNT_ADDED_AT_DESC'
  | 'FAVORITE_PAGES_DISTINCT_COUNT_ROUTE_ASC'
  | 'FAVORITE_PAGES_DISTINCT_COUNT_ROUTE_DESC'
  | 'FAVORITE_PAGES_DISTINCT_COUNT_TRIAL_ID_ASC'
  | 'FAVORITE_PAGES_DISTINCT_COUNT_TRIAL_ID_DESC'
  | 'FAVORITE_PAGES_MAX_ADDED_AT_ASC'
  | 'FAVORITE_PAGES_MAX_ADDED_AT_DESC'
  | 'FAVORITE_PAGES_MAX_ROUTE_ASC'
  | 'FAVORITE_PAGES_MAX_ROUTE_DESC'
  | 'FAVORITE_PAGES_MAX_TRIAL_ID_ASC'
  | 'FAVORITE_PAGES_MAX_TRIAL_ID_DESC'
  | 'FAVORITE_PAGES_MIN_ADDED_AT_ASC'
  | 'FAVORITE_PAGES_MIN_ADDED_AT_DESC'
  | 'FAVORITE_PAGES_MIN_ROUTE_ASC'
  | 'FAVORITE_PAGES_MIN_ROUTE_DESC'
  | 'FAVORITE_PAGES_MIN_TRIAL_ID_ASC'
  | 'FAVORITE_PAGES_MIN_TRIAL_ID_DESC'
  | 'FAVORITE_PAGES_STDDEV_POPULATION_ADDED_AT_ASC'
  | 'FAVORITE_PAGES_STDDEV_POPULATION_ADDED_AT_DESC'
  | 'FAVORITE_PAGES_STDDEV_POPULATION_ROUTE_ASC'
  | 'FAVORITE_PAGES_STDDEV_POPULATION_ROUTE_DESC'
  | 'FAVORITE_PAGES_STDDEV_POPULATION_TRIAL_ID_ASC'
  | 'FAVORITE_PAGES_STDDEV_POPULATION_TRIAL_ID_DESC'
  | 'FAVORITE_PAGES_STDDEV_SAMPLE_ADDED_AT_ASC'
  | 'FAVORITE_PAGES_STDDEV_SAMPLE_ADDED_AT_DESC'
  | 'FAVORITE_PAGES_STDDEV_SAMPLE_ROUTE_ASC'
  | 'FAVORITE_PAGES_STDDEV_SAMPLE_ROUTE_DESC'
  | 'FAVORITE_PAGES_STDDEV_SAMPLE_TRIAL_ID_ASC'
  | 'FAVORITE_PAGES_STDDEV_SAMPLE_TRIAL_ID_DESC'
  | 'FAVORITE_PAGES_SUM_ADDED_AT_ASC'
  | 'FAVORITE_PAGES_SUM_ADDED_AT_DESC'
  | 'FAVORITE_PAGES_SUM_ROUTE_ASC'
  | 'FAVORITE_PAGES_SUM_ROUTE_DESC'
  | 'FAVORITE_PAGES_SUM_TRIAL_ID_ASC'
  | 'FAVORITE_PAGES_SUM_TRIAL_ID_DESC'
  | 'FAVORITE_PAGES_VARIANCE_POPULATION_ADDED_AT_ASC'
  | 'FAVORITE_PAGES_VARIANCE_POPULATION_ADDED_AT_DESC'
  | 'FAVORITE_PAGES_VARIANCE_POPULATION_ROUTE_ASC'
  | 'FAVORITE_PAGES_VARIANCE_POPULATION_ROUTE_DESC'
  | 'FAVORITE_PAGES_VARIANCE_POPULATION_TRIAL_ID_ASC'
  | 'FAVORITE_PAGES_VARIANCE_POPULATION_TRIAL_ID_DESC'
  | 'FAVORITE_PAGES_VARIANCE_SAMPLE_ADDED_AT_ASC'
  | 'FAVORITE_PAGES_VARIANCE_SAMPLE_ADDED_AT_DESC'
  | 'FAVORITE_PAGES_VARIANCE_SAMPLE_ROUTE_ASC'
  | 'FAVORITE_PAGES_VARIANCE_SAMPLE_ROUTE_DESC'
  | 'FAVORITE_PAGES_VARIANCE_SAMPLE_TRIAL_ID_ASC'
  | 'FAVORITE_PAGES_VARIANCE_SAMPLE_TRIAL_ID_DESC'
  | 'GENERIC_EMI_EXERCISES_AVERAGE_BODY_ASC'
  | 'GENERIC_EMI_EXERCISES_AVERAGE_BODY_DESC'
  | 'GENERIC_EMI_EXERCISES_AVERAGE_CREATED_AT_ASC'
  | 'GENERIC_EMI_EXERCISES_AVERAGE_CREATED_AT_DESC'
  | 'GENERIC_EMI_EXERCISES_AVERAGE_ID_ASC'
  | 'GENERIC_EMI_EXERCISES_AVERAGE_ID_DESC'
  | 'GENERIC_EMI_EXERCISES_AVERAGE_NAME_ASC'
  | 'GENERIC_EMI_EXERCISES_AVERAGE_NAME_DESC'
  | 'GENERIC_EMI_EXERCISES_AVERAGE_TRIAL_ID_ASC'
  | 'GENERIC_EMI_EXERCISES_AVERAGE_TRIAL_ID_DESC'
  | 'GENERIC_EMI_EXERCISES_AVERAGE_TYPE_ASC'
  | 'GENERIC_EMI_EXERCISES_AVERAGE_TYPE_DESC'
  | 'GENERIC_EMI_EXERCISES_AVERAGE_UPDATED_AT_ASC'
  | 'GENERIC_EMI_EXERCISES_AVERAGE_UPDATED_AT_DESC'
  | 'GENERIC_EMI_EXERCISES_COUNT_ASC'
  | 'GENERIC_EMI_EXERCISES_COUNT_DESC'
  | 'GENERIC_EMI_EXERCISES_DISTINCT_COUNT_BODY_ASC'
  | 'GENERIC_EMI_EXERCISES_DISTINCT_COUNT_BODY_DESC'
  | 'GENERIC_EMI_EXERCISES_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'GENERIC_EMI_EXERCISES_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'GENERIC_EMI_EXERCISES_DISTINCT_COUNT_ID_ASC'
  | 'GENERIC_EMI_EXERCISES_DISTINCT_COUNT_ID_DESC'
  | 'GENERIC_EMI_EXERCISES_DISTINCT_COUNT_NAME_ASC'
  | 'GENERIC_EMI_EXERCISES_DISTINCT_COUNT_NAME_DESC'
  | 'GENERIC_EMI_EXERCISES_DISTINCT_COUNT_TRIAL_ID_ASC'
  | 'GENERIC_EMI_EXERCISES_DISTINCT_COUNT_TRIAL_ID_DESC'
  | 'GENERIC_EMI_EXERCISES_DISTINCT_COUNT_TYPE_ASC'
  | 'GENERIC_EMI_EXERCISES_DISTINCT_COUNT_TYPE_DESC'
  | 'GENERIC_EMI_EXERCISES_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'GENERIC_EMI_EXERCISES_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'GENERIC_EMI_EXERCISES_MAX_BODY_ASC'
  | 'GENERIC_EMI_EXERCISES_MAX_BODY_DESC'
  | 'GENERIC_EMI_EXERCISES_MAX_CREATED_AT_ASC'
  | 'GENERIC_EMI_EXERCISES_MAX_CREATED_AT_DESC'
  | 'GENERIC_EMI_EXERCISES_MAX_ID_ASC'
  | 'GENERIC_EMI_EXERCISES_MAX_ID_DESC'
  | 'GENERIC_EMI_EXERCISES_MAX_NAME_ASC'
  | 'GENERIC_EMI_EXERCISES_MAX_NAME_DESC'
  | 'GENERIC_EMI_EXERCISES_MAX_TRIAL_ID_ASC'
  | 'GENERIC_EMI_EXERCISES_MAX_TRIAL_ID_DESC'
  | 'GENERIC_EMI_EXERCISES_MAX_TYPE_ASC'
  | 'GENERIC_EMI_EXERCISES_MAX_TYPE_DESC'
  | 'GENERIC_EMI_EXERCISES_MAX_UPDATED_AT_ASC'
  | 'GENERIC_EMI_EXERCISES_MAX_UPDATED_AT_DESC'
  | 'GENERIC_EMI_EXERCISES_MIN_BODY_ASC'
  | 'GENERIC_EMI_EXERCISES_MIN_BODY_DESC'
  | 'GENERIC_EMI_EXERCISES_MIN_CREATED_AT_ASC'
  | 'GENERIC_EMI_EXERCISES_MIN_CREATED_AT_DESC'
  | 'GENERIC_EMI_EXERCISES_MIN_ID_ASC'
  | 'GENERIC_EMI_EXERCISES_MIN_ID_DESC'
  | 'GENERIC_EMI_EXERCISES_MIN_NAME_ASC'
  | 'GENERIC_EMI_EXERCISES_MIN_NAME_DESC'
  | 'GENERIC_EMI_EXERCISES_MIN_TRIAL_ID_ASC'
  | 'GENERIC_EMI_EXERCISES_MIN_TRIAL_ID_DESC'
  | 'GENERIC_EMI_EXERCISES_MIN_TYPE_ASC'
  | 'GENERIC_EMI_EXERCISES_MIN_TYPE_DESC'
  | 'GENERIC_EMI_EXERCISES_MIN_UPDATED_AT_ASC'
  | 'GENERIC_EMI_EXERCISES_MIN_UPDATED_AT_DESC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_POPULATION_BODY_ASC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_POPULATION_BODY_DESC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_POPULATION_ID_ASC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_POPULATION_ID_DESC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_POPULATION_NAME_ASC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_POPULATION_NAME_DESC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_POPULATION_TRIAL_ID_ASC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_POPULATION_TRIAL_ID_DESC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_POPULATION_TYPE_ASC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_POPULATION_TYPE_DESC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_SAMPLE_BODY_ASC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_SAMPLE_BODY_DESC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_SAMPLE_ID_ASC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_SAMPLE_ID_DESC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_SAMPLE_NAME_ASC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_SAMPLE_NAME_DESC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_SAMPLE_TRIAL_ID_ASC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_SAMPLE_TRIAL_ID_DESC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_SAMPLE_TYPE_ASC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_SAMPLE_TYPE_DESC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'GENERIC_EMI_EXERCISES_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'GENERIC_EMI_EXERCISES_SUM_BODY_ASC'
  | 'GENERIC_EMI_EXERCISES_SUM_BODY_DESC'
  | 'GENERIC_EMI_EXERCISES_SUM_CREATED_AT_ASC'
  | 'GENERIC_EMI_EXERCISES_SUM_CREATED_AT_DESC'
  | 'GENERIC_EMI_EXERCISES_SUM_ID_ASC'
  | 'GENERIC_EMI_EXERCISES_SUM_ID_DESC'
  | 'GENERIC_EMI_EXERCISES_SUM_NAME_ASC'
  | 'GENERIC_EMI_EXERCISES_SUM_NAME_DESC'
  | 'GENERIC_EMI_EXERCISES_SUM_TRIAL_ID_ASC'
  | 'GENERIC_EMI_EXERCISES_SUM_TRIAL_ID_DESC'
  | 'GENERIC_EMI_EXERCISES_SUM_TYPE_ASC'
  | 'GENERIC_EMI_EXERCISES_SUM_TYPE_DESC'
  | 'GENERIC_EMI_EXERCISES_SUM_UPDATED_AT_ASC'
  | 'GENERIC_EMI_EXERCISES_SUM_UPDATED_AT_DESC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_POPULATION_BODY_ASC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_POPULATION_BODY_DESC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_POPULATION_ID_ASC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_POPULATION_ID_DESC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_POPULATION_NAME_ASC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_POPULATION_NAME_DESC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_POPULATION_TRIAL_ID_ASC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_POPULATION_TRIAL_ID_DESC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_POPULATION_TYPE_ASC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_POPULATION_TYPE_DESC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_SAMPLE_BODY_ASC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_SAMPLE_BODY_DESC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_SAMPLE_ID_ASC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_SAMPLE_ID_DESC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_SAMPLE_NAME_ASC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_SAMPLE_NAME_DESC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_SAMPLE_TRIAL_ID_ASC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_SAMPLE_TRIAL_ID_DESC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_SAMPLE_TYPE_ASC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_SAMPLE_TYPE_DESC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'GENERIC_EMI_EXERCISES_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'HUMAN_READABLE_ID_ASC'
  | 'HUMAN_READABLE_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'INTERNAL_MESSAGES_ID_ASC'
  | 'INTERNAL_MESSAGES_ID_DESC'
  | 'LIMESURVEY_TOKENS_AVERAGE_COMPLETED_AT_ASC'
  | 'LIMESURVEY_TOKENS_AVERAGE_COMPLETED_AT_DESC'
  | 'LIMESURVEY_TOKENS_AVERAGE_HANDED_OUT_AT_ASC'
  | 'LIMESURVEY_TOKENS_AVERAGE_HANDED_OUT_AT_DESC'
  | 'LIMESURVEY_TOKENS_AVERAGE_STARTED_AT_ASC'
  | 'LIMESURVEY_TOKENS_AVERAGE_STARTED_AT_DESC'
  | 'LIMESURVEY_TOKENS_AVERAGE_SURVEY_ID_ASC'
  | 'LIMESURVEY_TOKENS_AVERAGE_SURVEY_ID_DESC'
  | 'LIMESURVEY_TOKENS_AVERAGE_TIME_OF_MEASUREMENT_ASC'
  | 'LIMESURVEY_TOKENS_AVERAGE_TIME_OF_MEASUREMENT_DESC'
  | 'LIMESURVEY_TOKENS_AVERAGE_TOKEN_ASC'
  | 'LIMESURVEY_TOKENS_AVERAGE_TOKEN_DESC'
  | 'LIMESURVEY_TOKENS_AVERAGE_TRIAL_ID_ASC'
  | 'LIMESURVEY_TOKENS_AVERAGE_TRIAL_ID_DESC'
  | 'LIMESURVEY_TOKENS_COUNT_ASC'
  | 'LIMESURVEY_TOKENS_COUNT_DESC'
  | 'LIMESURVEY_TOKENS_DISTINCT_COUNT_COMPLETED_AT_ASC'
  | 'LIMESURVEY_TOKENS_DISTINCT_COUNT_COMPLETED_AT_DESC'
  | 'LIMESURVEY_TOKENS_DISTINCT_COUNT_HANDED_OUT_AT_ASC'
  | 'LIMESURVEY_TOKENS_DISTINCT_COUNT_HANDED_OUT_AT_DESC'
  | 'LIMESURVEY_TOKENS_DISTINCT_COUNT_STARTED_AT_ASC'
  | 'LIMESURVEY_TOKENS_DISTINCT_COUNT_STARTED_AT_DESC'
  | 'LIMESURVEY_TOKENS_DISTINCT_COUNT_SURVEY_ID_ASC'
  | 'LIMESURVEY_TOKENS_DISTINCT_COUNT_SURVEY_ID_DESC'
  | 'LIMESURVEY_TOKENS_DISTINCT_COUNT_TIME_OF_MEASUREMENT_ASC'
  | 'LIMESURVEY_TOKENS_DISTINCT_COUNT_TIME_OF_MEASUREMENT_DESC'
  | 'LIMESURVEY_TOKENS_DISTINCT_COUNT_TOKEN_ASC'
  | 'LIMESURVEY_TOKENS_DISTINCT_COUNT_TOKEN_DESC'
  | 'LIMESURVEY_TOKENS_DISTINCT_COUNT_TRIAL_ID_ASC'
  | 'LIMESURVEY_TOKENS_DISTINCT_COUNT_TRIAL_ID_DESC'
  | 'LIMESURVEY_TOKENS_MAX_COMPLETED_AT_ASC'
  | 'LIMESURVEY_TOKENS_MAX_COMPLETED_AT_DESC'
  | 'LIMESURVEY_TOKENS_MAX_HANDED_OUT_AT_ASC'
  | 'LIMESURVEY_TOKENS_MAX_HANDED_OUT_AT_DESC'
  | 'LIMESURVEY_TOKENS_MAX_STARTED_AT_ASC'
  | 'LIMESURVEY_TOKENS_MAX_STARTED_AT_DESC'
  | 'LIMESURVEY_TOKENS_MAX_SURVEY_ID_ASC'
  | 'LIMESURVEY_TOKENS_MAX_SURVEY_ID_DESC'
  | 'LIMESURVEY_TOKENS_MAX_TIME_OF_MEASUREMENT_ASC'
  | 'LIMESURVEY_TOKENS_MAX_TIME_OF_MEASUREMENT_DESC'
  | 'LIMESURVEY_TOKENS_MAX_TOKEN_ASC'
  | 'LIMESURVEY_TOKENS_MAX_TOKEN_DESC'
  | 'LIMESURVEY_TOKENS_MAX_TRIAL_ID_ASC'
  | 'LIMESURVEY_TOKENS_MAX_TRIAL_ID_DESC'
  | 'LIMESURVEY_TOKENS_MIN_COMPLETED_AT_ASC'
  | 'LIMESURVEY_TOKENS_MIN_COMPLETED_AT_DESC'
  | 'LIMESURVEY_TOKENS_MIN_HANDED_OUT_AT_ASC'
  | 'LIMESURVEY_TOKENS_MIN_HANDED_OUT_AT_DESC'
  | 'LIMESURVEY_TOKENS_MIN_STARTED_AT_ASC'
  | 'LIMESURVEY_TOKENS_MIN_STARTED_AT_DESC'
  | 'LIMESURVEY_TOKENS_MIN_SURVEY_ID_ASC'
  | 'LIMESURVEY_TOKENS_MIN_SURVEY_ID_DESC'
  | 'LIMESURVEY_TOKENS_MIN_TIME_OF_MEASUREMENT_ASC'
  | 'LIMESURVEY_TOKENS_MIN_TIME_OF_MEASUREMENT_DESC'
  | 'LIMESURVEY_TOKENS_MIN_TOKEN_ASC'
  | 'LIMESURVEY_TOKENS_MIN_TOKEN_DESC'
  | 'LIMESURVEY_TOKENS_MIN_TRIAL_ID_ASC'
  | 'LIMESURVEY_TOKENS_MIN_TRIAL_ID_DESC'
  | 'LIMESURVEY_TOKENS_STDDEV_POPULATION_COMPLETED_AT_ASC'
  | 'LIMESURVEY_TOKENS_STDDEV_POPULATION_COMPLETED_AT_DESC'
  | 'LIMESURVEY_TOKENS_STDDEV_POPULATION_HANDED_OUT_AT_ASC'
  | 'LIMESURVEY_TOKENS_STDDEV_POPULATION_HANDED_OUT_AT_DESC'
  | 'LIMESURVEY_TOKENS_STDDEV_POPULATION_STARTED_AT_ASC'
  | 'LIMESURVEY_TOKENS_STDDEV_POPULATION_STARTED_AT_DESC'
  | 'LIMESURVEY_TOKENS_STDDEV_POPULATION_SURVEY_ID_ASC'
  | 'LIMESURVEY_TOKENS_STDDEV_POPULATION_SURVEY_ID_DESC'
  | 'LIMESURVEY_TOKENS_STDDEV_POPULATION_TIME_OF_MEASUREMENT_ASC'
  | 'LIMESURVEY_TOKENS_STDDEV_POPULATION_TIME_OF_MEASUREMENT_DESC'
  | 'LIMESURVEY_TOKENS_STDDEV_POPULATION_TOKEN_ASC'
  | 'LIMESURVEY_TOKENS_STDDEV_POPULATION_TOKEN_DESC'
  | 'LIMESURVEY_TOKENS_STDDEV_POPULATION_TRIAL_ID_ASC'
  | 'LIMESURVEY_TOKENS_STDDEV_POPULATION_TRIAL_ID_DESC'
  | 'LIMESURVEY_TOKENS_STDDEV_SAMPLE_COMPLETED_AT_ASC'
  | 'LIMESURVEY_TOKENS_STDDEV_SAMPLE_COMPLETED_AT_DESC'
  | 'LIMESURVEY_TOKENS_STDDEV_SAMPLE_HANDED_OUT_AT_ASC'
  | 'LIMESURVEY_TOKENS_STDDEV_SAMPLE_HANDED_OUT_AT_DESC'
  | 'LIMESURVEY_TOKENS_STDDEV_SAMPLE_STARTED_AT_ASC'
  | 'LIMESURVEY_TOKENS_STDDEV_SAMPLE_STARTED_AT_DESC'
  | 'LIMESURVEY_TOKENS_STDDEV_SAMPLE_SURVEY_ID_ASC'
  | 'LIMESURVEY_TOKENS_STDDEV_SAMPLE_SURVEY_ID_DESC'
  | 'LIMESURVEY_TOKENS_STDDEV_SAMPLE_TIME_OF_MEASUREMENT_ASC'
  | 'LIMESURVEY_TOKENS_STDDEV_SAMPLE_TIME_OF_MEASUREMENT_DESC'
  | 'LIMESURVEY_TOKENS_STDDEV_SAMPLE_TOKEN_ASC'
  | 'LIMESURVEY_TOKENS_STDDEV_SAMPLE_TOKEN_DESC'
  | 'LIMESURVEY_TOKENS_STDDEV_SAMPLE_TRIAL_ID_ASC'
  | 'LIMESURVEY_TOKENS_STDDEV_SAMPLE_TRIAL_ID_DESC'
  | 'LIMESURVEY_TOKENS_SUM_COMPLETED_AT_ASC'
  | 'LIMESURVEY_TOKENS_SUM_COMPLETED_AT_DESC'
  | 'LIMESURVEY_TOKENS_SUM_HANDED_OUT_AT_ASC'
  | 'LIMESURVEY_TOKENS_SUM_HANDED_OUT_AT_DESC'
  | 'LIMESURVEY_TOKENS_SUM_STARTED_AT_ASC'
  | 'LIMESURVEY_TOKENS_SUM_STARTED_AT_DESC'
  | 'LIMESURVEY_TOKENS_SUM_SURVEY_ID_ASC'
  | 'LIMESURVEY_TOKENS_SUM_SURVEY_ID_DESC'
  | 'LIMESURVEY_TOKENS_SUM_TIME_OF_MEASUREMENT_ASC'
  | 'LIMESURVEY_TOKENS_SUM_TIME_OF_MEASUREMENT_DESC'
  | 'LIMESURVEY_TOKENS_SUM_TOKEN_ASC'
  | 'LIMESURVEY_TOKENS_SUM_TOKEN_DESC'
  | 'LIMESURVEY_TOKENS_SUM_TRIAL_ID_ASC'
  | 'LIMESURVEY_TOKENS_SUM_TRIAL_ID_DESC'
  | 'LIMESURVEY_TOKENS_VARIANCE_POPULATION_COMPLETED_AT_ASC'
  | 'LIMESURVEY_TOKENS_VARIANCE_POPULATION_COMPLETED_AT_DESC'
  | 'LIMESURVEY_TOKENS_VARIANCE_POPULATION_HANDED_OUT_AT_ASC'
  | 'LIMESURVEY_TOKENS_VARIANCE_POPULATION_HANDED_OUT_AT_DESC'
  | 'LIMESURVEY_TOKENS_VARIANCE_POPULATION_STARTED_AT_ASC'
  | 'LIMESURVEY_TOKENS_VARIANCE_POPULATION_STARTED_AT_DESC'
  | 'LIMESURVEY_TOKENS_VARIANCE_POPULATION_SURVEY_ID_ASC'
  | 'LIMESURVEY_TOKENS_VARIANCE_POPULATION_SURVEY_ID_DESC'
  | 'LIMESURVEY_TOKENS_VARIANCE_POPULATION_TIME_OF_MEASUREMENT_ASC'
  | 'LIMESURVEY_TOKENS_VARIANCE_POPULATION_TIME_OF_MEASUREMENT_DESC'
  | 'LIMESURVEY_TOKENS_VARIANCE_POPULATION_TOKEN_ASC'
  | 'LIMESURVEY_TOKENS_VARIANCE_POPULATION_TOKEN_DESC'
  | 'LIMESURVEY_TOKENS_VARIANCE_POPULATION_TRIAL_ID_ASC'
  | 'LIMESURVEY_TOKENS_VARIANCE_POPULATION_TRIAL_ID_DESC'
  | 'LIMESURVEY_TOKENS_VARIANCE_SAMPLE_COMPLETED_AT_ASC'
  | 'LIMESURVEY_TOKENS_VARIANCE_SAMPLE_COMPLETED_AT_DESC'
  | 'LIMESURVEY_TOKENS_VARIANCE_SAMPLE_HANDED_OUT_AT_ASC'
  | 'LIMESURVEY_TOKENS_VARIANCE_SAMPLE_HANDED_OUT_AT_DESC'
  | 'LIMESURVEY_TOKENS_VARIANCE_SAMPLE_STARTED_AT_ASC'
  | 'LIMESURVEY_TOKENS_VARIANCE_SAMPLE_STARTED_AT_DESC'
  | 'LIMESURVEY_TOKENS_VARIANCE_SAMPLE_SURVEY_ID_ASC'
  | 'LIMESURVEY_TOKENS_VARIANCE_SAMPLE_SURVEY_ID_DESC'
  | 'LIMESURVEY_TOKENS_VARIANCE_SAMPLE_TIME_OF_MEASUREMENT_ASC'
  | 'LIMESURVEY_TOKENS_VARIANCE_SAMPLE_TIME_OF_MEASUREMENT_DESC'
  | 'LIMESURVEY_TOKENS_VARIANCE_SAMPLE_TOKEN_ASC'
  | 'LIMESURVEY_TOKENS_VARIANCE_SAMPLE_TOKEN_DESC'
  | 'LIMESURVEY_TOKENS_VARIANCE_SAMPLE_TRIAL_ID_ASC'
  | 'LIMESURVEY_TOKENS_VARIANCE_SAMPLE_TRIAL_ID_DESC'
  | 'MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'MESSAGES_ID_ASC'
  | 'MESSAGES_ID_DESC'
  | 'NAME_ASC'
  | 'NAME_DESC'
  | 'NATURAL'
  | 'PAGE_HITS_AVERAGE_DURATION_ASC'
  | 'PAGE_HITS_AVERAGE_DURATION_DESC'
  | 'PAGE_HITS_AVERAGE_NTH_VISIT_ASC'
  | 'PAGE_HITS_AVERAGE_NTH_VISIT_DESC'
  | 'PAGE_HITS_AVERAGE_PATH_ASC'
  | 'PAGE_HITS_AVERAGE_PATH_DESC'
  | 'PAGE_HITS_AVERAGE_QUERY_PARAMETERS_ASC'
  | 'PAGE_HITS_AVERAGE_QUERY_PARAMETERS_DESC'
  | 'PAGE_HITS_AVERAGE_ROUTE_ASC'
  | 'PAGE_HITS_AVERAGE_ROUTE_DESC'
  | 'PAGE_HITS_AVERAGE_TRACKED_AT_ASC'
  | 'PAGE_HITS_AVERAGE_TRACKED_AT_DESC'
  | 'PAGE_HITS_AVERAGE_TRIAL_ID_ASC'
  | 'PAGE_HITS_AVERAGE_TRIAL_ID_DESC'
  | 'PAGE_HITS_COUNT_ASC'
  | 'PAGE_HITS_COUNT_DESC'
  | 'PAGE_HITS_DISTINCT_COUNT_DURATION_ASC'
  | 'PAGE_HITS_DISTINCT_COUNT_DURATION_DESC'
  | 'PAGE_HITS_DISTINCT_COUNT_NTH_VISIT_ASC'
  | 'PAGE_HITS_DISTINCT_COUNT_NTH_VISIT_DESC'
  | 'PAGE_HITS_DISTINCT_COUNT_PATH_ASC'
  | 'PAGE_HITS_DISTINCT_COUNT_PATH_DESC'
  | 'PAGE_HITS_DISTINCT_COUNT_QUERY_PARAMETERS_ASC'
  | 'PAGE_HITS_DISTINCT_COUNT_QUERY_PARAMETERS_DESC'
  | 'PAGE_HITS_DISTINCT_COUNT_ROUTE_ASC'
  | 'PAGE_HITS_DISTINCT_COUNT_ROUTE_DESC'
  | 'PAGE_HITS_DISTINCT_COUNT_TRACKED_AT_ASC'
  | 'PAGE_HITS_DISTINCT_COUNT_TRACKED_AT_DESC'
  | 'PAGE_HITS_DISTINCT_COUNT_TRIAL_ID_ASC'
  | 'PAGE_HITS_DISTINCT_COUNT_TRIAL_ID_DESC'
  | 'PAGE_HITS_MAX_DURATION_ASC'
  | 'PAGE_HITS_MAX_DURATION_DESC'
  | 'PAGE_HITS_MAX_NTH_VISIT_ASC'
  | 'PAGE_HITS_MAX_NTH_VISIT_DESC'
  | 'PAGE_HITS_MAX_PATH_ASC'
  | 'PAGE_HITS_MAX_PATH_DESC'
  | 'PAGE_HITS_MAX_QUERY_PARAMETERS_ASC'
  | 'PAGE_HITS_MAX_QUERY_PARAMETERS_DESC'
  | 'PAGE_HITS_MAX_ROUTE_ASC'
  | 'PAGE_HITS_MAX_ROUTE_DESC'
  | 'PAGE_HITS_MAX_TRACKED_AT_ASC'
  | 'PAGE_HITS_MAX_TRACKED_AT_DESC'
  | 'PAGE_HITS_MAX_TRIAL_ID_ASC'
  | 'PAGE_HITS_MAX_TRIAL_ID_DESC'
  | 'PAGE_HITS_MIN_DURATION_ASC'
  | 'PAGE_HITS_MIN_DURATION_DESC'
  | 'PAGE_HITS_MIN_NTH_VISIT_ASC'
  | 'PAGE_HITS_MIN_NTH_VISIT_DESC'
  | 'PAGE_HITS_MIN_PATH_ASC'
  | 'PAGE_HITS_MIN_PATH_DESC'
  | 'PAGE_HITS_MIN_QUERY_PARAMETERS_ASC'
  | 'PAGE_HITS_MIN_QUERY_PARAMETERS_DESC'
  | 'PAGE_HITS_MIN_ROUTE_ASC'
  | 'PAGE_HITS_MIN_ROUTE_DESC'
  | 'PAGE_HITS_MIN_TRACKED_AT_ASC'
  | 'PAGE_HITS_MIN_TRACKED_AT_DESC'
  | 'PAGE_HITS_MIN_TRIAL_ID_ASC'
  | 'PAGE_HITS_MIN_TRIAL_ID_DESC'
  | 'PAGE_HITS_STDDEV_POPULATION_DURATION_ASC'
  | 'PAGE_HITS_STDDEV_POPULATION_DURATION_DESC'
  | 'PAGE_HITS_STDDEV_POPULATION_NTH_VISIT_ASC'
  | 'PAGE_HITS_STDDEV_POPULATION_NTH_VISIT_DESC'
  | 'PAGE_HITS_STDDEV_POPULATION_PATH_ASC'
  | 'PAGE_HITS_STDDEV_POPULATION_PATH_DESC'
  | 'PAGE_HITS_STDDEV_POPULATION_QUERY_PARAMETERS_ASC'
  | 'PAGE_HITS_STDDEV_POPULATION_QUERY_PARAMETERS_DESC'
  | 'PAGE_HITS_STDDEV_POPULATION_ROUTE_ASC'
  | 'PAGE_HITS_STDDEV_POPULATION_ROUTE_DESC'
  | 'PAGE_HITS_STDDEV_POPULATION_TRACKED_AT_ASC'
  | 'PAGE_HITS_STDDEV_POPULATION_TRACKED_AT_DESC'
  | 'PAGE_HITS_STDDEV_POPULATION_TRIAL_ID_ASC'
  | 'PAGE_HITS_STDDEV_POPULATION_TRIAL_ID_DESC'
  | 'PAGE_HITS_STDDEV_SAMPLE_DURATION_ASC'
  | 'PAGE_HITS_STDDEV_SAMPLE_DURATION_DESC'
  | 'PAGE_HITS_STDDEV_SAMPLE_NTH_VISIT_ASC'
  | 'PAGE_HITS_STDDEV_SAMPLE_NTH_VISIT_DESC'
  | 'PAGE_HITS_STDDEV_SAMPLE_PATH_ASC'
  | 'PAGE_HITS_STDDEV_SAMPLE_PATH_DESC'
  | 'PAGE_HITS_STDDEV_SAMPLE_QUERY_PARAMETERS_ASC'
  | 'PAGE_HITS_STDDEV_SAMPLE_QUERY_PARAMETERS_DESC'
  | 'PAGE_HITS_STDDEV_SAMPLE_ROUTE_ASC'
  | 'PAGE_HITS_STDDEV_SAMPLE_ROUTE_DESC'
  | 'PAGE_HITS_STDDEV_SAMPLE_TRACKED_AT_ASC'
  | 'PAGE_HITS_STDDEV_SAMPLE_TRACKED_AT_DESC'
  | 'PAGE_HITS_STDDEV_SAMPLE_TRIAL_ID_ASC'
  | 'PAGE_HITS_STDDEV_SAMPLE_TRIAL_ID_DESC'
  | 'PAGE_HITS_SUM_DURATION_ASC'
  | 'PAGE_HITS_SUM_DURATION_DESC'
  | 'PAGE_HITS_SUM_NTH_VISIT_ASC'
  | 'PAGE_HITS_SUM_NTH_VISIT_DESC'
  | 'PAGE_HITS_SUM_PATH_ASC'
  | 'PAGE_HITS_SUM_PATH_DESC'
  | 'PAGE_HITS_SUM_QUERY_PARAMETERS_ASC'
  | 'PAGE_HITS_SUM_QUERY_PARAMETERS_DESC'
  | 'PAGE_HITS_SUM_ROUTE_ASC'
  | 'PAGE_HITS_SUM_ROUTE_DESC'
  | 'PAGE_HITS_SUM_TRACKED_AT_ASC'
  | 'PAGE_HITS_SUM_TRACKED_AT_DESC'
  | 'PAGE_HITS_SUM_TRIAL_ID_ASC'
  | 'PAGE_HITS_SUM_TRIAL_ID_DESC'
  | 'PAGE_HITS_VARIANCE_POPULATION_DURATION_ASC'
  | 'PAGE_HITS_VARIANCE_POPULATION_DURATION_DESC'
  | 'PAGE_HITS_VARIANCE_POPULATION_NTH_VISIT_ASC'
  | 'PAGE_HITS_VARIANCE_POPULATION_NTH_VISIT_DESC'
  | 'PAGE_HITS_VARIANCE_POPULATION_PATH_ASC'
  | 'PAGE_HITS_VARIANCE_POPULATION_PATH_DESC'
  | 'PAGE_HITS_VARIANCE_POPULATION_QUERY_PARAMETERS_ASC'
  | 'PAGE_HITS_VARIANCE_POPULATION_QUERY_PARAMETERS_DESC'
  | 'PAGE_HITS_VARIANCE_POPULATION_ROUTE_ASC'
  | 'PAGE_HITS_VARIANCE_POPULATION_ROUTE_DESC'
  | 'PAGE_HITS_VARIANCE_POPULATION_TRACKED_AT_ASC'
  | 'PAGE_HITS_VARIANCE_POPULATION_TRACKED_AT_DESC'
  | 'PAGE_HITS_VARIANCE_POPULATION_TRIAL_ID_ASC'
  | 'PAGE_HITS_VARIANCE_POPULATION_TRIAL_ID_DESC'
  | 'PAGE_HITS_VARIANCE_SAMPLE_DURATION_ASC'
  | 'PAGE_HITS_VARIANCE_SAMPLE_DURATION_DESC'
  | 'PAGE_HITS_VARIANCE_SAMPLE_NTH_VISIT_ASC'
  | 'PAGE_HITS_VARIANCE_SAMPLE_NTH_VISIT_DESC'
  | 'PAGE_HITS_VARIANCE_SAMPLE_PATH_ASC'
  | 'PAGE_HITS_VARIANCE_SAMPLE_PATH_DESC'
  | 'PAGE_HITS_VARIANCE_SAMPLE_QUERY_PARAMETERS_ASC'
  | 'PAGE_HITS_VARIANCE_SAMPLE_QUERY_PARAMETERS_DESC'
  | 'PAGE_HITS_VARIANCE_SAMPLE_ROUTE_ASC'
  | 'PAGE_HITS_VARIANCE_SAMPLE_ROUTE_DESC'
  | 'PAGE_HITS_VARIANCE_SAMPLE_TRACKED_AT_ASC'
  | 'PAGE_HITS_VARIANCE_SAMPLE_TRACKED_AT_DESC'
  | 'PAGE_HITS_VARIANCE_SAMPLE_TRIAL_ID_ASC'
  | 'PAGE_HITS_VARIANCE_SAMPLE_TRIAL_ID_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'RAW_USAGE_DATA_AVERAGE_CLIENT_HASH_ASC'
  | 'RAW_USAGE_DATA_AVERAGE_CLIENT_HASH_DESC'
  | 'RAW_USAGE_DATA_AVERAGE_ID_ASC'
  | 'RAW_USAGE_DATA_AVERAGE_ID_DESC'
  | 'RAW_USAGE_DATA_AVERAGE_PAYLOAD_ASC'
  | 'RAW_USAGE_DATA_AVERAGE_PAYLOAD_DESC'
  | 'RAW_USAGE_DATA_AVERAGE_REMOTE_ADDRESS_ASC'
  | 'RAW_USAGE_DATA_AVERAGE_REMOTE_ADDRESS_DESC'
  | 'RAW_USAGE_DATA_AVERAGE_TRACKED_AT_ASC'
  | 'RAW_USAGE_DATA_AVERAGE_TRACKED_AT_DESC'
  | 'RAW_USAGE_DATA_AVERAGE_TRIAL_ID_ASC'
  | 'RAW_USAGE_DATA_AVERAGE_TRIAL_ID_DESC'
  | 'RAW_USAGE_DATA_AVERAGE_TYPE_ASC'
  | 'RAW_USAGE_DATA_AVERAGE_TYPE_DESC'
  | 'RAW_USAGE_DATA_AVERAGE_USER_AGENT_ASC'
  | 'RAW_USAGE_DATA_AVERAGE_USER_AGENT_DESC'
  | 'RAW_USAGE_DATA_AVERAGE_USER_ID_ASC'
  | 'RAW_USAGE_DATA_AVERAGE_USER_ID_DESC'
  | 'RAW_USAGE_DATA_COUNT_ASC'
  | 'RAW_USAGE_DATA_COUNT_DESC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_CLIENT_HASH_ASC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_CLIENT_HASH_DESC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_ID_ASC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_ID_DESC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_PAYLOAD_ASC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_PAYLOAD_DESC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_REMOTE_ADDRESS_ASC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_REMOTE_ADDRESS_DESC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_TRACKED_AT_ASC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_TRACKED_AT_DESC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_TRIAL_ID_ASC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_TRIAL_ID_DESC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_TYPE_ASC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_TYPE_DESC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_USER_AGENT_ASC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_USER_AGENT_DESC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_USER_ID_ASC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_USER_ID_DESC'
  | 'RAW_USAGE_DATA_MAX_CLIENT_HASH_ASC'
  | 'RAW_USAGE_DATA_MAX_CLIENT_HASH_DESC'
  | 'RAW_USAGE_DATA_MAX_ID_ASC'
  | 'RAW_USAGE_DATA_MAX_ID_DESC'
  | 'RAW_USAGE_DATA_MAX_PAYLOAD_ASC'
  | 'RAW_USAGE_DATA_MAX_PAYLOAD_DESC'
  | 'RAW_USAGE_DATA_MAX_REMOTE_ADDRESS_ASC'
  | 'RAW_USAGE_DATA_MAX_REMOTE_ADDRESS_DESC'
  | 'RAW_USAGE_DATA_MAX_TRACKED_AT_ASC'
  | 'RAW_USAGE_DATA_MAX_TRACKED_AT_DESC'
  | 'RAW_USAGE_DATA_MAX_TRIAL_ID_ASC'
  | 'RAW_USAGE_DATA_MAX_TRIAL_ID_DESC'
  | 'RAW_USAGE_DATA_MAX_TYPE_ASC'
  | 'RAW_USAGE_DATA_MAX_TYPE_DESC'
  | 'RAW_USAGE_DATA_MAX_USER_AGENT_ASC'
  | 'RAW_USAGE_DATA_MAX_USER_AGENT_DESC'
  | 'RAW_USAGE_DATA_MAX_USER_ID_ASC'
  | 'RAW_USAGE_DATA_MAX_USER_ID_DESC'
  | 'RAW_USAGE_DATA_MIN_CLIENT_HASH_ASC'
  | 'RAW_USAGE_DATA_MIN_CLIENT_HASH_DESC'
  | 'RAW_USAGE_DATA_MIN_ID_ASC'
  | 'RAW_USAGE_DATA_MIN_ID_DESC'
  | 'RAW_USAGE_DATA_MIN_PAYLOAD_ASC'
  | 'RAW_USAGE_DATA_MIN_PAYLOAD_DESC'
  | 'RAW_USAGE_DATA_MIN_REMOTE_ADDRESS_ASC'
  | 'RAW_USAGE_DATA_MIN_REMOTE_ADDRESS_DESC'
  | 'RAW_USAGE_DATA_MIN_TRACKED_AT_ASC'
  | 'RAW_USAGE_DATA_MIN_TRACKED_AT_DESC'
  | 'RAW_USAGE_DATA_MIN_TRIAL_ID_ASC'
  | 'RAW_USAGE_DATA_MIN_TRIAL_ID_DESC'
  | 'RAW_USAGE_DATA_MIN_TYPE_ASC'
  | 'RAW_USAGE_DATA_MIN_TYPE_DESC'
  | 'RAW_USAGE_DATA_MIN_USER_AGENT_ASC'
  | 'RAW_USAGE_DATA_MIN_USER_AGENT_DESC'
  | 'RAW_USAGE_DATA_MIN_USER_ID_ASC'
  | 'RAW_USAGE_DATA_MIN_USER_ID_DESC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_CLIENT_HASH_ASC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_CLIENT_HASH_DESC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_ID_ASC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_ID_DESC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_PAYLOAD_ASC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_PAYLOAD_DESC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_REMOTE_ADDRESS_ASC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_REMOTE_ADDRESS_DESC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_TRACKED_AT_ASC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_TRACKED_AT_DESC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_TRIAL_ID_ASC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_TRIAL_ID_DESC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_TYPE_ASC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_TYPE_DESC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_USER_AGENT_ASC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_USER_AGENT_DESC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_USER_ID_ASC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_USER_ID_DESC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_CLIENT_HASH_ASC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_CLIENT_HASH_DESC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_ID_ASC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_ID_DESC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_PAYLOAD_ASC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_PAYLOAD_DESC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_REMOTE_ADDRESS_ASC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_REMOTE_ADDRESS_DESC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_TRACKED_AT_ASC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_TRACKED_AT_DESC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_TRIAL_ID_ASC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_TRIAL_ID_DESC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_TYPE_ASC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_TYPE_DESC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_USER_AGENT_ASC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_USER_AGENT_DESC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_USER_ID_ASC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_USER_ID_DESC'
  | 'RAW_USAGE_DATA_SUM_CLIENT_HASH_ASC'
  | 'RAW_USAGE_DATA_SUM_CLIENT_HASH_DESC'
  | 'RAW_USAGE_DATA_SUM_ID_ASC'
  | 'RAW_USAGE_DATA_SUM_ID_DESC'
  | 'RAW_USAGE_DATA_SUM_PAYLOAD_ASC'
  | 'RAW_USAGE_DATA_SUM_PAYLOAD_DESC'
  | 'RAW_USAGE_DATA_SUM_REMOTE_ADDRESS_ASC'
  | 'RAW_USAGE_DATA_SUM_REMOTE_ADDRESS_DESC'
  | 'RAW_USAGE_DATA_SUM_TRACKED_AT_ASC'
  | 'RAW_USAGE_DATA_SUM_TRACKED_AT_DESC'
  | 'RAW_USAGE_DATA_SUM_TRIAL_ID_ASC'
  | 'RAW_USAGE_DATA_SUM_TRIAL_ID_DESC'
  | 'RAW_USAGE_DATA_SUM_TYPE_ASC'
  | 'RAW_USAGE_DATA_SUM_TYPE_DESC'
  | 'RAW_USAGE_DATA_SUM_USER_AGENT_ASC'
  | 'RAW_USAGE_DATA_SUM_USER_AGENT_DESC'
  | 'RAW_USAGE_DATA_SUM_USER_ID_ASC'
  | 'RAW_USAGE_DATA_SUM_USER_ID_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_CLIENT_HASH_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_CLIENT_HASH_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_ID_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_ID_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_PAYLOAD_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_PAYLOAD_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_REMOTE_ADDRESS_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_REMOTE_ADDRESS_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_TRACKED_AT_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_TRACKED_AT_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_TRIAL_ID_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_TRIAL_ID_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_TYPE_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_TYPE_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_USER_AGENT_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_USER_AGENT_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_USER_ID_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_USER_ID_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_CLIENT_HASH_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_CLIENT_HASH_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_ID_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_ID_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_PAYLOAD_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_PAYLOAD_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_REMOTE_ADDRESS_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_REMOTE_ADDRESS_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_TRACKED_AT_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_TRACKED_AT_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_TRIAL_ID_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_TRIAL_ID_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_TYPE_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_TYPE_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_USER_AGENT_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_USER_AGENT_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_USER_ID_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_USER_ID_DESC'
  | 'STAFF_ID_ASC'
  | 'STAFF_ID_DESC'
  | 'SUBJECTS_NICKNAME_ASC'
  | 'SUBJECTS_NICKNAME_DESC'
  | 'SUBJECT_ID_ASC'
  | 'SUBJECT_ID_DESC'
  | 'TENANT_ID_ASC'
  | 'TENANT_ID_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']>>;
};

/** All input for the `updateCommentableByNodeId` mutation. */
export type UpdateCommentableByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Commentable` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Commentable` being updated. */
  patch: CommentablePatch;
};

/** All input for the `updateCommentable` mutation. */
export type UpdateCommentableInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Commentable` being updated. */
  patch: CommentablePatch;
};

/** The output of our update `Commentable` mutation. */
export type UpdateCommentablePayload = {
  __typename?: 'UpdateCommentablePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Commentable` that was updated by this mutation. */
  commentable?: Maybe<Commentable>;
  /** An edge for our `Commentable`. May be used by Relay 1. */
  commentableEdge?: Maybe<CommentablesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `Commentable` mutation. */
export type UpdateCommentablePayloadCommentableEdgeArgs = {
  orderBy?: InputMaybe<Array<CommentablesOrderBy>>;
};

/** All input for the `updateConversationByNodeId` mutation. */
export type UpdateConversationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Conversation` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Conversation` being updated. */
  patch: ConversationPatch;
};

/** All input for the `updateConversation` mutation. */
export type UpdateConversationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Conversation` being updated. */
  patch: ConversationPatch;
};

/** The output of our update `Conversation` mutation. */
export type UpdateConversationPayload = {
  __typename?: 'UpdateConversationPayload';
  /** Reads a single `Commentable` that is related to this `Conversation`. */
  aboutCommentable?: Maybe<Commentable>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Conversation` that was updated by this mutation. */
  conversation?: Maybe<Conversation>;
  /** An edge for our `Conversation`. May be used by Relay 1. */
  conversationEdge?: Maybe<ConversationsEdge>;
  /** Reads a single `User` that is related to this `Conversation`. */
  creator?: Maybe<User>;
  /** Reads a single `Group` that is related to this `Conversation`. */
  privateGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Conversation`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our update `Conversation` mutation. */
export type UpdateConversationPayloadConversationEdgeArgs = {
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
};

/** All input for the `updateEmaEntries2ByNodeId` mutation. */
export type UpdateEmaEntries2ByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `EmaEntries2` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `EmaEntries2` being updated. */
  patch: EmaEntries2Patch;
};

/** All input for the `updateEmaEntries2` mutation. */
export type UpdateEmaEntries2Input = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `EmaEntries2` being updated. */
  patch: EmaEntries2Patch;
};

/** The output of our update `EmaEntries2` mutation. */
export type UpdateEmaEntries2Payload = {
  __typename?: 'UpdateEmaEntries2Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `EmaEntries2` that was updated by this mutation. */
  emaEntries2?: Maybe<EmaEntries2>;
  /** An edge for our `EmaEntries2`. May be used by Relay 1. */
  emaEntries2Edge?: Maybe<EmaEntries2sEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmaEntries2`. */
  subject?: Maybe<User>;
};


/** The output of our update `EmaEntries2` mutation. */
export type UpdateEmaEntries2PayloadEmaEntries2EdgeArgs = {
  orderBy?: InputMaybe<Array<EmaEntries2sOrderBy>>;
};

/** All input for the `updateEmaEntries3ByNodeId` mutation. */
export type UpdateEmaEntries3ByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `EmaEntries3` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `EmaEntries3` being updated. */
  patch: EmaEntries3Patch;
};

/** All input for the `updateEmaEntries3` mutation. */
export type UpdateEmaEntries3Input = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `EmaEntries3` being updated. */
  patch: EmaEntries3Patch;
};

/** The output of our update `EmaEntries3` mutation. */
export type UpdateEmaEntries3Payload = {
  __typename?: 'UpdateEmaEntries3Payload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `EmaEntries3` that was updated by this mutation. */
  emaEntries3?: Maybe<EmaEntries3>;
  /** An edge for our `EmaEntries3`. May be used by Relay 1. */
  emaEntries3Edge?: Maybe<EmaEntries3sEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trial` that is related to this `EmaEntries3`. */
  trial?: Maybe<Trial>;
};


/** The output of our update `EmaEntries3` mutation. */
export type UpdateEmaEntries3PayloadEmaEntries3EdgeArgs = {
  orderBy?: InputMaybe<Array<EmaEntries3sOrderBy>>;
};

/** All input for the `updateEmaEntryByNodeId` mutation. */
export type UpdateEmaEntryByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `EmaEntry` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `EmaEntry` being updated. */
  patch: EmaEntryPatch;
};

/** All input for the `updateEmaEntry` mutation. */
export type UpdateEmaEntryInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `EmaEntry` being updated. */
  patch: EmaEntryPatch;
};

/** The output of our update `EmaEntry` mutation. */
export type UpdateEmaEntryPayload = {
  __typename?: 'UpdateEmaEntryPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `EmaEntry` that was updated by this mutation. */
  emaEntry?: Maybe<EmaEntry>;
  /** An edge for our `EmaEntry`. May be used by Relay 1. */
  emaEntryEdge?: Maybe<EmaEntriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmaEntry`. */
  subject?: Maybe<User>;
};


/** The output of our update `EmaEntry` mutation. */
export type UpdateEmaEntryPayloadEmaEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<EmaEntriesOrderBy>>;
};

/** All input for the `updateFavoritePageByNodeId` mutation. */
export type UpdateFavoritePageByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `FavoritePage` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `FavoritePage` being updated. */
  patch: FavoritePagePatch;
};

/** All input for the `updateFavoritePage` mutation. */
export type UpdateFavoritePageInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `FavoritePage` being updated. */
  patch: FavoritePagePatch;
  route: Scalars['String'];
  trialId: Scalars['UUID'];
};

/** The output of our update `FavoritePage` mutation. */
export type UpdateFavoritePagePayload = {
  __typename?: 'UpdateFavoritePagePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `FavoritePage` that was updated by this mutation. */
  favoritePage?: Maybe<FavoritePage>;
  /** An edge for our `FavoritePage`. May be used by Relay 1. */
  favoritePageEdge?: Maybe<FavoritePagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trial` that is related to this `FavoritePage`. */
  trial?: Maybe<Trial>;
};


/** The output of our update `FavoritePage` mutation. */
export type UpdateFavoritePagePayloadFavoritePageEdgeArgs = {
  orderBy?: InputMaybe<Array<FavoritePagesOrderBy>>;
};

/** All input for the `updateGenericEmiExerciseByNodeId` mutation. */
export type UpdateGenericEmiExerciseByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `GenericEmiExercise` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `GenericEmiExercise` being updated. */
  patch: GenericEmiExercisePatch;
};

/** All input for the `updateGenericEmiExerciseByTrialIdAndName` mutation. */
export type UpdateGenericEmiExerciseByTrialIdAndNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `GenericEmiExercise` being updated. */
  patch: GenericEmiExercisePatch;
  trialId: Scalars['UUID'];
};

/** All input for the `updateGenericEmiExercise` mutation. */
export type UpdateGenericEmiExerciseInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `GenericEmiExercise` being updated. */
  patch: GenericEmiExercisePatch;
};

/** The output of our update `GenericEmiExercise` mutation. */
export type UpdateGenericEmiExercisePayload = {
  __typename?: 'UpdateGenericEmiExercisePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `GenericEmiExercise` that was updated by this mutation. */
  genericEmiExercise?: Maybe<GenericEmiExercise>;
  /** An edge for our `GenericEmiExercise`. May be used by Relay 1. */
  genericEmiExerciseEdge?: Maybe<GenericEmiExercisesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trial` that is related to this `GenericEmiExercise`. */
  trial?: Maybe<Trial>;
};


/** The output of our update `GenericEmiExercise` mutation. */
export type UpdateGenericEmiExercisePayloadGenericEmiExerciseEdgeArgs = {
  orderBy?: InputMaybe<Array<GenericEmiExercisesOrderBy>>;
};

/** All input for the `updateGroupByNodeId` mutation. */
export type UpdateGroupByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Group` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Group` being updated. */
  patch: GroupPatch;
};

/** All input for the `updateGroupHomeByNodeId` mutation. */
export type UpdateGroupHomeByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `GroupHome` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `GroupHome` being updated. */
  patch: GroupHomePatch;
};

/** All input for the `updateGroupHome` mutation. */
export type UpdateGroupHomeInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `GroupHome` being updated. */
  patch: GroupHomePatch;
};

/** The output of our update `GroupHome` mutation. */
export type UpdateGroupHomePayload = {
  __typename?: 'UpdateGroupHomePayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `GroupHome` that was updated by this mutation. */
  groupHome?: Maybe<GroupHome>;
  /** An edge for our `GroupHome`. May be used by Relay 1. */
  groupHomeEdge?: Maybe<GroupHomesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `GroupHome` mutation. */
export type UpdateGroupHomePayloadGroupHomeEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupHomesOrderBy>>;
};

/** All input for the `updateGroup` mutation. */
export type UpdateGroupInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Group` being updated. */
  patch: GroupPatch;
};

/** The output of our update `Group` mutation. */
export type UpdateGroupPayload = {
  __typename?: 'UpdateGroupPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Group`. */
  creator?: Maybe<User>;
  /** The `Group` that was updated by this mutation. */
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Reads a single `GroupHome` that is related to this `Group`. */
  home?: Maybe<GroupHome>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Group`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our update `Group` mutation. */
export type UpdateGroupPayloadGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

/** All input for the `updateLimesurveyTokenByNodeId` mutation. */
export type UpdateLimesurveyTokenByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `LimesurveyToken` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `LimesurveyToken` being updated. */
  patch: LimesurveyTokenPatch;
};

/** All input for the `updateLimesurveyTokenByTrialIdAndTimeOfMeasurement` mutation. */
export type UpdateLimesurveyTokenByTrialIdAndTimeOfMeasurementInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `LimesurveyToken` being updated. */
  patch: LimesurveyTokenPatch;
  timeOfMeasurement: Scalars['String'];
  trialId: Scalars['UUID'];
};

/** All input for the `updateLimesurveyToken` mutation. */
export type UpdateLimesurveyTokenInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `LimesurveyToken` being updated. */
  patch: LimesurveyTokenPatch;
  surveyId: Scalars['Int'];
  token: Scalars['String'];
};

/** The output of our update `LimesurveyToken` mutation. */
export type UpdateLimesurveyTokenPayload = {
  __typename?: 'UpdateLimesurveyTokenPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `LimesurveyToken` that was updated by this mutation. */
  limesurveyToken?: Maybe<LimesurveyToken>;
  /** An edge for our `LimesurveyToken`. May be used by Relay 1. */
  limesurveyTokenEdge?: Maybe<LimesurveyTokensEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trial` that is related to this `LimesurveyToken`. */
  trial?: Maybe<Trial>;
};


/** The output of our update `LimesurveyToken` mutation. */
export type UpdateLimesurveyTokenPayloadLimesurveyTokenEdgeArgs = {
  orderBy?: InputMaybe<Array<LimesurveyTokensOrderBy>>;
};

/** All input for the `updateMembershipByGroupIdAndSubgroupId` mutation. */
export type UpdateMembershipByGroupIdAndSubgroupIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  groupId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Membership` being updated. */
  patch: MembershipPatch;
  subgroupId: Scalars['UUID'];
};

/** All input for the `updateMembershipByGroupIdAndUserId` mutation. */
export type UpdateMembershipByGroupIdAndUserIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  groupId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Membership` being updated. */
  patch: MembershipPatch;
  userId: Scalars['UUID'];
};

/** All input for the `updateMembershipByNodeId` mutation. */
export type UpdateMembershipByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Membership` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Membership` being updated. */
  patch: MembershipPatch;
};

/** All input for the `updateMembership` mutation. */
export type UpdateMembershipInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Membership` being updated. */
  patch: MembershipPatch;
};

/** All input for the `updateMembershipInvitationByNodeId` mutation. */
export type UpdateMembershipInvitationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MembershipInvitation` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `MembershipInvitation` being updated. */
  patch: MembershipInvitationPatch;
};

/** All input for the `updateMembershipInvitationConfirmationByNodeId` mutation. */
export type UpdateMembershipInvitationConfirmationByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `MembershipInvitationConfirmation` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `MembershipInvitationConfirmation` being updated. */
  patch: MembershipInvitationConfirmationPatch;
};

/** All input for the `updateMembershipInvitationConfirmation` mutation. */
export type UpdateMembershipInvitationConfirmationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `MembershipInvitationConfirmation` being updated. */
  patch: MembershipInvitationConfirmationPatch;
};

/** The output of our update `MembershipInvitationConfirmation` mutation. */
export type UpdateMembershipInvitationConfirmationPayload = {
  __typename?: 'UpdateMembershipInvitationConfirmationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `MembershipInvitation` that is related to this `MembershipInvitationConfirmation`. */
  invitation?: Maybe<MembershipInvitation>;
  /** Reads a single `Membership` that is related to this `MembershipInvitationConfirmation`. */
  membership?: Maybe<Membership>;
  /** The `MembershipInvitationConfirmation` that was updated by this mutation. */
  membershipInvitationConfirmation?: Maybe<MembershipInvitationConfirmation>;
  /** An edge for our `MembershipInvitationConfirmation`. May be used by Relay 1. */
  membershipInvitationConfirmationEdge?: Maybe<MembershipInvitationConfirmationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `MembershipInvitationConfirmation` mutation. */
export type UpdateMembershipInvitationConfirmationPayloadMembershipInvitationConfirmationEdgeArgs = {
  orderBy?: InputMaybe<Array<MembershipInvitationConfirmationsOrderBy>>;
};

/** All input for the `updateMembershipInvitation` mutation. */
export type UpdateMembershipInvitationInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `MembershipInvitation` being updated. */
  patch: MembershipInvitationPatch;
};

/** The output of our update `MembershipInvitation` mutation. */
export type UpdateMembershipInvitationPayload = {
  __typename?: 'UpdateMembershipInvitationPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Group` that is related to this `MembershipInvitation`. */
  group?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `MembershipInvitation`. */
  invitedGroup?: Maybe<Group>;
  /** Reads a single `User` that is related to this `MembershipInvitation`. */
  invitedUser?: Maybe<User>;
  /** Reads a single `User` that is related to this `MembershipInvitation`. */
  inviter?: Maybe<User>;
  /** The `MembershipInvitation` that was updated by this mutation. */
  membershipInvitation?: Maybe<MembershipInvitation>;
  /** An edge for our `MembershipInvitation`. May be used by Relay 1. */
  membershipInvitationEdge?: Maybe<MembershipInvitationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `MembershipInvitation` mutation. */
export type UpdateMembershipInvitationPayloadMembershipInvitationEdgeArgs = {
  orderBy?: InputMaybe<Array<MembershipInvitationsOrderBy>>;
};

/** The output of our update `Membership` mutation. */
export type UpdateMembershipPayload = {
  __typename?: 'UpdateMembershipPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Group` that is related to this `Membership`. */
  group?: Maybe<Group>;
  /** The `Membership` that was updated by this mutation. */
  membership?: Maybe<Membership>;
  /** An edge for our `Membership`. May be used by Relay 1. */
  membershipEdge?: Maybe<MembershipsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Group` that is related to this `Membership`. */
  subgroup?: Maybe<Group>;
  /** Reads a single `User` that is related to this `Membership`. */
  user?: Maybe<User>;
};


/** The output of our update `Membership` mutation. */
export type UpdateMembershipPayloadMembershipEdgeArgs = {
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};

/** All input for the `updatePostWaitRandomizationTicketByNodeId` mutation. */
export type UpdatePostWaitRandomizationTicketByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PostWaitRandomizationTicket` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `PostWaitRandomizationTicket` being updated. */
  patch: PostWaitRandomizationTicketPatch;
};

/** All input for the `updatePostWaitRandomizationTicketByTrialId` mutation. */
export type UpdatePostWaitRandomizationTicketByTrialIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `PostWaitRandomizationTicket` being updated. */
  patch: PostWaitRandomizationTicketPatch;
  trialId: Scalars['UUID'];
};

/** All input for the `updatePostWaitRandomizationTicket` mutation. */
export type UpdatePostWaitRandomizationTicketInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `PostWaitRandomizationTicket` being updated. */
  patch: PostWaitRandomizationTicketPatch;
};

/** The output of our update `PostWaitRandomizationTicket` mutation. */
export type UpdatePostWaitRandomizationTicketPayload = {
  __typename?: 'UpdatePostWaitRandomizationTicketPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `PostWaitRandomizationTicket` that was updated by this mutation. */
  postWaitRandomizationTicket?: Maybe<PostWaitRandomizationTicket>;
  /** An edge for our `PostWaitRandomizationTicket`. May be used by Relay 1. */
  postWaitRandomizationTicketEdge?: Maybe<PostWaitRandomizationTicketsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trial` that is related to this `PostWaitRandomizationTicket`. */
  trial?: Maybe<Trial>;
};


/** The output of our update `PostWaitRandomizationTicket` mutation. */
export type UpdatePostWaitRandomizationTicketPayloadPostWaitRandomizationTicketEdgeArgs = {
  orderBy?: InputMaybe<Array<PostWaitRandomizationTicketsOrderBy>>;
};

/** All input for the `updatePostingByNodeId` mutation. */
export type UpdatePostingByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Posting` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Posting` being updated. */
  patch: PostingPatch;
};

/** All input for the `updatePosting` mutation. */
export type UpdatePostingInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Posting` being updated. */
  patch: PostingPatch;
};

/** The output of our update `Posting` mutation. */
export type UpdatePostingPayload = {
  __typename?: 'UpdatePostingPayload';
  /** Reads a single `Commentable` that is related to this `Posting`. */
  aboutCommentable?: Maybe<Commentable>;
  /** Reads a single `Posting` that is related to this `Posting`. */
  answeredPosting?: Maybe<Posting>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Conversation` that is related to this `Posting`. */
  conversation?: Maybe<Conversation>;
  /** The `Posting` that was updated by this mutation. */
  posting?: Maybe<Posting>;
  /** An edge for our `Posting`. May be used by Relay 1. */
  postingEdge?: Maybe<PostingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Posting`. */
  sender?: Maybe<User>;
};


/** The output of our update `Posting` mutation. */
export type UpdatePostingPayloadPostingEdgeArgs = {
  orderBy?: InputMaybe<Array<PostingsOrderBy>>;
};

/** All input for the `updatePostingReceiptByNodeId` mutation. */
export type UpdatePostingReceiptByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `PostingReceipt` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `PostingReceipt` being updated. */
  patch: PostingReceiptPatch;
};

/** All input for the `updatePostingReceipt` mutation. */
export type UpdatePostingReceiptInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `PostingReceipt` being updated. */
  patch: PostingReceiptPatch;
  postingId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

/** The output of our update `PostingReceipt` mutation. */
export type UpdatePostingReceiptPayload = {
  __typename?: 'UpdatePostingReceiptPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Posting` that is related to this `PostingReceipt`. */
  posting?: Maybe<Posting>;
  /** The `PostingReceipt` that was updated by this mutation. */
  postingReceipt?: Maybe<PostingReceipt>;
  /** An edge for our `PostingReceipt`. May be used by Relay 1. */
  postingReceiptEdge?: Maybe<PostingReceiptsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PostingReceipt`. */
  user?: Maybe<User>;
};


/** The output of our update `PostingReceipt` mutation. */
export type UpdatePostingReceiptPayloadPostingReceiptEdgeArgs = {
  orderBy?: InputMaybe<Array<PostingReceiptsOrderBy>>;
};

/** All input for the `updateRandomizationTicketByNodeId` mutation. */
export type UpdateRandomizationTicketByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `RandomizationTicket` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `RandomizationTicket` being updated. */
  patch: RandomizationTicketPatch;
};

/** All input for the `updateRandomizationTicketByTrialId` mutation. */
export type UpdateRandomizationTicketByTrialIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `RandomizationTicket` being updated. */
  patch: RandomizationTicketPatch;
  trialId: Scalars['UUID'];
};

/** All input for the `updateRandomizationTicket` mutation. */
export type UpdateRandomizationTicketInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RandomizationTicket` being updated. */
  patch: RandomizationTicketPatch;
};

/** The output of our update `RandomizationTicket` mutation. */
export type UpdateRandomizationTicketPayload = {
  __typename?: 'UpdateRandomizationTicketPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RandomizationTicket` that was updated by this mutation. */
  randomizationTicket?: Maybe<RandomizationTicket>;
  /** An edge for our `RandomizationTicket`. May be used by Relay 1. */
  randomizationTicketEdge?: Maybe<RandomizationTicketsEdge>;
  /** Reads a single `Trial` that is related to this `RandomizationTicket`. */
  trial?: Maybe<Trial>;
};


/** The output of our update `RandomizationTicket` mutation. */
export type UpdateRandomizationTicketPayloadRandomizationTicketEdgeArgs = {
  orderBy?: InputMaybe<Array<RandomizationTicketsOrderBy>>;
};

/** All input for the `updateRawUsageDatumByNodeId` mutation. */
export type UpdateRawUsageDatumByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `RawUsageDatum` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `RawUsageDatum` being updated. */
  patch: RawUsageDatumPatch;
};

/** All input for the `updateRawUsageDatum` mutation. */
export type UpdateRawUsageDatumInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `RawUsageDatum` being updated. */
  patch: RawUsageDatumPatch;
};

/** The output of our update `RawUsageDatum` mutation. */
export type UpdateRawUsageDatumPayload = {
  __typename?: 'UpdateRawUsageDatumPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RawUsageDatum` that was updated by this mutation. */
  rawUsageDatum?: Maybe<RawUsageDatum>;
  /** An edge for our `RawUsageDatum`. May be used by Relay 1. */
  rawUsageDatumEdge?: Maybe<RawUsageDataEdge>;
  /** Reads a single `Trial` that is related to this `RawUsageDatum`. */
  trial?: Maybe<Trial>;
  /** Reads a single `User` that is related to this `RawUsageDatum`. */
  user?: Maybe<User>;
};


/** The output of our update `RawUsageDatum` mutation. */
export type UpdateRawUsageDatumPayloadRawUsageDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<RawUsageDataOrderBy>>;
};

/** All input for the `updateTenantByName` mutation. */
export type UpdateTenantByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `Tenant` being updated. */
  patch: TenantPatch;
};

/** All input for the `updateTenantByNodeId` mutation. */
export type UpdateTenantByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Tenant` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Tenant` being updated. */
  patch: TenantPatch;
};

/** All input for the `updateTenantByUrl` mutation. */
export type UpdateTenantByUrlInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `Tenant` being updated. */
  patch: TenantPatch;
  url: Scalars['String'];
};

/** All input for the `updateTenant` mutation. */
export type UpdateTenantInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Tenant` being updated. */
  patch: TenantPatch;
};

/** The output of our update `Tenant` mutation. */
export type UpdateTenantPayload = {
  __typename?: 'UpdateTenantPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Tenant` that was updated by this mutation. */
  tenant?: Maybe<Tenant>;
  /** An edge for our `Tenant`. May be used by Relay 1. */
  tenantEdge?: Maybe<TenantsEdge>;
};


/** The output of our update `Tenant` mutation. */
export type UpdateTenantPayloadTenantEdgeArgs = {
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
};

/** All input for the `updateTrialByHumanReadableId` mutation. */
export type UpdateTrialByHumanReadableIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  humanReadableId: Scalars['BigInt'];
  /** An object where the defined keys will be set on the `Trial` being updated. */
  patch: TrialPatch;
};

/** All input for the `updateTrialByName` mutation. */
export type UpdateTrialByNameInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  /** An object where the defined keys will be set on the `Trial` being updated. */
  patch: TrialPatch;
};

/** All input for the `updateTrialByNodeId` mutation. */
export type UpdateTrialByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `Trial` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `Trial` being updated. */
  patch: TrialPatch;
};

/** All input for the `updateTrial` mutation. */
export type UpdateTrialInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `Trial` being updated. */
  patch: TrialPatch;
};

/** The output of our update `Trial` mutation. */
export type UpdateTrialPayload = {
  __typename?: 'UpdateTrialPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Commentable` that is related to this `Trial`. */
  commentableById?: Maybe<Commentable>;
  /** Reads a single `User` that is related to this `Trial`. */
  createdBy?: Maybe<User>;
  /** Reads a single `GroupHome` that is related to this `Trial`. */
  groupHomeById?: Maybe<GroupHome>;
  /** Reads a single `Conversation` that is related to this `Trial`. */
  internalMessages?: Maybe<Conversation>;
  /** Reads a single `Conversation` that is related to this `Trial`. */
  messages?: Maybe<Conversation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Group` that is related to this `Trial`. */
  staff?: Maybe<Group>;
  /** Reads a single `User` that is related to this `Trial`. */
  subject?: Maybe<User>;
  /** Reads a single `Tenant` that is related to this `Trial`. */
  tenant?: Maybe<Tenant>;
  /** The `Trial` that was updated by this mutation. */
  trial?: Maybe<Trial>;
  /** An edge for our `Trial`. May be used by Relay 1. */
  trialEdge?: Maybe<TrialsEdge>;
};


/** The output of our update `Trial` mutation. */
export type UpdateTrialPayloadTrialEdgeArgs = {
  orderBy?: InputMaybe<Array<TrialsOrderBy>>;
};

/** All input for the `updateUserByCredentialsId` mutation. */
export type UpdateUserByCredentialsIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  credentialsId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch;
};

/** All input for the `updateUserByEmailAddressId` mutation. */
export type UpdateUserByEmailAddressIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  emailAddressId: Scalars['UUID'];
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch;
};

/** All input for the `updateUserByIdAndTenantId` mutation. */
export type UpdateUserByIdAndTenantIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch;
  tenantId: Scalars['UUID'];
};

/** All input for the `updateUserByNodeId` mutation. */
export type UpdateUserByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `User` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch;
};

/** All input for the `updateUserByUsernameAndTenantId` mutation. */
export type UpdateUserByUsernameAndTenantIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch;
  tenantId: Scalars['UUID'];
  username: Scalars['String'];
};

/** All input for the `updateUserCredentialByExternalAuthIdAndTenantId` mutation. */
export type UpdateUserCredentialByExternalAuthIdAndTenantIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  externalAuthId: Scalars['String'];
  /** An object where the defined keys will be set on the `UserCredential` being updated. */
  patch: UserCredentialPatch;
  tenantId: Scalars['UUID'];
};

/** All input for the `updateUserCredentialByNodeId` mutation. */
export type UpdateUserCredentialByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UserCredential` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `UserCredential` being updated. */
  patch: UserCredentialPatch;
};

/** All input for the `updateUserCredential` mutation. */
export type UpdateUserCredentialInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `UserCredential` being updated. */
  patch: UserCredentialPatch;
};

/** The output of our update `UserCredential` mutation. */
export type UpdateUserCredentialPayload = {
  __typename?: 'UpdateUserCredentialPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `UserCredential`. */
  tenant?: Maybe<Tenant>;
  /** The `UserCredential` that was updated by this mutation. */
  userCredential?: Maybe<UserCredential>;
  /** An edge for our `UserCredential`. May be used by Relay 1. */
  userCredentialEdge?: Maybe<UserCredentialsEdge>;
};


/** The output of our update `UserCredential` mutation. */
export type UpdateUserCredentialPayloadUserCredentialEdgeArgs = {
  orderBy?: InputMaybe<Array<UserCredentialsOrderBy>>;
};

/** All input for the `updateUserEmailAddressByEmailAddressAndTenantId` mutation. */
export type UpdateUserEmailAddressByEmailAddressAndTenantIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  emailAddress: Scalars['String'];
  /** An object where the defined keys will be set on the `UserEmailAddress` being updated. */
  patch: UserEmailAddressPatch;
  tenantId: Scalars['UUID'];
};

/** All input for the `updateUserEmailAddressByNodeId` mutation. */
export type UpdateUserEmailAddressByNodeIdInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The globally unique `ID` which will identify a single `UserEmailAddress` to be updated. */
  nodeId: Scalars['ID'];
  /** An object where the defined keys will be set on the `UserEmailAddress` being updated. */
  patch: UserEmailAddressPatch;
};

/** All input for the `updateUserEmailAddress` mutation. */
export type UpdateUserEmailAddressInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `UserEmailAddress` being updated. */
  patch: UserEmailAddressPatch;
};

/** The output of our update `UserEmailAddress` mutation. */
export type UpdateUserEmailAddressPayload = {
  __typename?: 'UpdateUserEmailAddressPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserEmailAddress` that was updated by this mutation. */
  userEmailAddress?: Maybe<UserEmailAddress>;
  /** An edge for our `UserEmailAddress`. May be used by Relay 1. */
  userEmailAddressEdge?: Maybe<UserEmailAddressesEdge>;
};


/** The output of our update `UserEmailAddress` mutation. */
export type UpdateUserEmailAddressPayloadUserEmailAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<UserEmailAddressesOrderBy>>;
};

/** All input for the `updateUser` mutation. */
export type UpdateUserInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** An object where the defined keys will be set on the `User` being updated. */
  patch: UserPatch;
};

/** The output of our update `User` mutation. */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `UserCredential` that is related to this `User`. */
  credentials?: Maybe<UserCredential>;
  /** Reads a single `UserEmailAddress` that is related to this `User`. */
  emailAddress?: Maybe<UserEmailAddress>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `User`. */
  tenant?: Maybe<Tenant>;
  /** The `User` that was updated by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our update `User` mutation. */
export type UpdateUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** All input for the upsert `Commentable` mutation. */
export type UpsertCommentableInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Commentable` to be upserted by this mutation. */
  commentable: CommentableInput;
};

/** The output of our upsert `Commentable` mutation. */
export type UpsertCommentablePayload = {
  __typename?: 'UpsertCommentablePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Commentable` that was upserted by this mutation. */
  commentable?: Maybe<Commentable>;
  /** An edge for our `Commentable`. May be used by Relay 1. */
  commentableEdge?: Maybe<CommentablesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our upsert `Commentable` mutation. */
export type UpsertCommentablePayloadCommentableEdgeArgs = {
  orderBy?: InputMaybe<Array<CommentablesOrderBy>>;
};

/** Where conditions for the upsert `Commentable` mutation. */
export type UpsertCommentableWhere = {
  id?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `Conversation` mutation. */
export type UpsertConversationInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Conversation` to be upserted by this mutation. */
  conversation: ConversationInput;
};

/** The output of our upsert `Conversation` mutation. */
export type UpsertConversationPayload = {
  __typename?: 'UpsertConversationPayload';
  /** Reads a single `Commentable` that is related to this `Conversation`. */
  aboutCommentable?: Maybe<Commentable>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Conversation` that was upserted by this mutation. */
  conversation?: Maybe<Conversation>;
  /** An edge for our `Conversation`. May be used by Relay 1. */
  conversationEdge?: Maybe<ConversationsEdge>;
  /** Reads a single `User` that is related to this `Conversation`. */
  creator?: Maybe<User>;
  /** Reads a single `Group` that is related to this `Conversation`. */
  privateGroup?: Maybe<Group>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Conversation`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our upsert `Conversation` mutation. */
export type UpsertConversationPayloadConversationEdgeArgs = {
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
};

/** Where conditions for the upsert `Conversation` mutation. */
export type UpsertConversationWhere = {
  id?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `EmaEntries2` mutation. */
export type UpsertEmaEntries2Input = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `EmaEntries2` to be upserted by this mutation. */
  emaEntries2: EmaEntries2Input;
};

/** The output of our upsert `EmaEntries2` mutation. */
export type UpsertEmaEntries2Payload = {
  __typename?: 'UpsertEmaEntries2Payload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `EmaEntries2` that was upserted by this mutation. */
  emaEntries2?: Maybe<EmaEntries2>;
  /** An edge for our `EmaEntries2`. May be used by Relay 1. */
  emaEntries2Edge?: Maybe<EmaEntries2sEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmaEntries2`. */
  subject?: Maybe<User>;
};


/** The output of our upsert `EmaEntries2` mutation. */
export type UpsertEmaEntries2PayloadEmaEntries2EdgeArgs = {
  orderBy?: InputMaybe<Array<EmaEntries2sOrderBy>>;
};

/** Where conditions for the upsert `EmaEntries2` mutation. */
export type UpsertEmaEntries2Where = {
  id?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `EmaEntries3` mutation. */
export type UpsertEmaEntries3Input = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `EmaEntries3` to be upserted by this mutation. */
  emaEntries3: EmaEntries3Input;
};

/** The output of our upsert `EmaEntries3` mutation. */
export type UpsertEmaEntries3Payload = {
  __typename?: 'UpsertEmaEntries3Payload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `EmaEntries3` that was upserted by this mutation. */
  emaEntries3?: Maybe<EmaEntries3>;
  /** An edge for our `EmaEntries3`. May be used by Relay 1. */
  emaEntries3Edge?: Maybe<EmaEntries3sEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trial` that is related to this `EmaEntries3`. */
  trial?: Maybe<Trial>;
};


/** The output of our upsert `EmaEntries3` mutation. */
export type UpsertEmaEntries3PayloadEmaEntries3EdgeArgs = {
  orderBy?: InputMaybe<Array<EmaEntries3sOrderBy>>;
};

/** Where conditions for the upsert `EmaEntries3` mutation. */
export type UpsertEmaEntries3Where = {
  id?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `EmaEntry` mutation. */
export type UpsertEmaEntryInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `EmaEntry` to be upserted by this mutation. */
  emaEntry: EmaEntryInput;
};

/** The output of our upsert `EmaEntry` mutation. */
export type UpsertEmaEntryPayload = {
  __typename?: 'UpsertEmaEntryPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `EmaEntry` that was upserted by this mutation. */
  emaEntry?: Maybe<EmaEntry>;
  /** An edge for our `EmaEntry`. May be used by Relay 1. */
  emaEntryEdge?: Maybe<EmaEntriesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `EmaEntry`. */
  subject?: Maybe<User>;
};


/** The output of our upsert `EmaEntry` mutation. */
export type UpsertEmaEntryPayloadEmaEntryEdgeArgs = {
  orderBy?: InputMaybe<Array<EmaEntriesOrderBy>>;
};

/** Where conditions for the upsert `EmaEntry` mutation. */
export type UpsertEmaEntryWhere = {
  id?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `Event` mutation. */
export type UpsertEventInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Event` to be upserted by this mutation. */
  event: EventInput;
};

/** The output of our upsert `Event` mutation. */
export type UpsertEventPayload = {
  __typename?: 'UpsertEventPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `Event` that was upserted by this mutation. */
  event?: Maybe<Event>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};

/** Where conditions for the upsert `Event` mutation. */
export type UpsertEventWhere = {
  id?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `FavoritePage` mutation. */
export type UpsertFavoritePageInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `FavoritePage` to be upserted by this mutation. */
  favoritePage: FavoritePageInput;
};

/** The output of our upsert `FavoritePage` mutation. */
export type UpsertFavoritePagePayload = {
  __typename?: 'UpsertFavoritePagePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `FavoritePage` that was upserted by this mutation. */
  favoritePage?: Maybe<FavoritePage>;
  /** An edge for our `FavoritePage`. May be used by Relay 1. */
  favoritePageEdge?: Maybe<FavoritePagesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trial` that is related to this `FavoritePage`. */
  trial?: Maybe<Trial>;
};


/** The output of our upsert `FavoritePage` mutation. */
export type UpsertFavoritePagePayloadFavoritePageEdgeArgs = {
  orderBy?: InputMaybe<Array<FavoritePagesOrderBy>>;
};

/** Where conditions for the upsert `FavoritePage` mutation. */
export type UpsertFavoritePageWhere = {
  route?: InputMaybe<Scalars['String']>;
  trialId?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `GenericEmiExercise` mutation. */
export type UpsertGenericEmiExerciseInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `GenericEmiExercise` to be upserted by this mutation. */
  genericEmiExercise: GenericEmiExerciseInput;
};

/** The output of our upsert `GenericEmiExercise` mutation. */
export type UpsertGenericEmiExercisePayload = {
  __typename?: 'UpsertGenericEmiExercisePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `GenericEmiExercise` that was upserted by this mutation. */
  genericEmiExercise?: Maybe<GenericEmiExercise>;
  /** An edge for our `GenericEmiExercise`. May be used by Relay 1. */
  genericEmiExerciseEdge?: Maybe<GenericEmiExercisesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trial` that is related to this `GenericEmiExercise`. */
  trial?: Maybe<Trial>;
};


/** The output of our upsert `GenericEmiExercise` mutation. */
export type UpsertGenericEmiExercisePayloadGenericEmiExerciseEdgeArgs = {
  orderBy?: InputMaybe<Array<GenericEmiExercisesOrderBy>>;
};

/** Where conditions for the upsert `GenericEmiExercise` mutation. */
export type UpsertGenericEmiExerciseWhere = {
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  trialId?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `GroupHome` mutation. */
export type UpsertGroupHomeInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `GroupHome` to be upserted by this mutation. */
  groupHome: GroupHomeInput;
};

/** The output of our upsert `GroupHome` mutation. */
export type UpsertGroupHomePayload = {
  __typename?: 'UpsertGroupHomePayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `GroupHome` that was upserted by this mutation. */
  groupHome?: Maybe<GroupHome>;
  /** An edge for our `GroupHome`. May be used by Relay 1. */
  groupHomeEdge?: Maybe<GroupHomesEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our upsert `GroupHome` mutation. */
export type UpsertGroupHomePayloadGroupHomeEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupHomesOrderBy>>;
};

/** Where conditions for the upsert `GroupHome` mutation. */
export type UpsertGroupHomeWhere = {
  id?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `Group` mutation. */
export type UpsertGroupInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Group` to be upserted by this mutation. */
  group: GroupInput;
};

/** The output of our upsert `Group` mutation. */
export type UpsertGroupPayload = {
  __typename?: 'UpsertGroupPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `User` that is related to this `Group`. */
  creator?: Maybe<User>;
  /** The `Group` that was upserted by this mutation. */
  group?: Maybe<Group>;
  /** An edge for our `Group`. May be used by Relay 1. */
  groupEdge?: Maybe<GroupsEdge>;
  /** Reads a single `GroupHome` that is related to this `Group`. */
  home?: Maybe<GroupHome>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `Group`. */
  tenant?: Maybe<Tenant>;
};


/** The output of our upsert `Group` mutation. */
export type UpsertGroupPayloadGroupEdgeArgs = {
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};

/** Where conditions for the upsert `Group` mutation. */
export type UpsertGroupWhere = {
  id?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `LimesurveyToken` mutation. */
export type UpsertLimesurveyTokenInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `LimesurveyToken` to be upserted by this mutation. */
  limesurveyToken: LimesurveyTokenInput;
};

/** The output of our upsert `LimesurveyToken` mutation. */
export type UpsertLimesurveyTokenPayload = {
  __typename?: 'UpsertLimesurveyTokenPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `LimesurveyToken` that was upserted by this mutation. */
  limesurveyToken?: Maybe<LimesurveyToken>;
  /** An edge for our `LimesurveyToken`. May be used by Relay 1. */
  limesurveyTokenEdge?: Maybe<LimesurveyTokensEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trial` that is related to this `LimesurveyToken`. */
  trial?: Maybe<Trial>;
};


/** The output of our upsert `LimesurveyToken` mutation. */
export type UpsertLimesurveyTokenPayloadLimesurveyTokenEdgeArgs = {
  orderBy?: InputMaybe<Array<LimesurveyTokensOrderBy>>;
};

/** Where conditions for the upsert `LimesurveyToken` mutation. */
export type UpsertLimesurveyTokenWhere = {
  surveyId?: InputMaybe<Scalars['Int']>;
  timeOfMeasurement?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  trialId?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `Membership` mutation. */
export type UpsertMembershipInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Membership` to be upserted by this mutation. */
  membership: MembershipInput;
};

/** All input for the upsert `MembershipInvitationConfirmation` mutation. */
export type UpsertMembershipInvitationConfirmationInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MembershipInvitationConfirmation` to be upserted by this mutation. */
  membershipInvitationConfirmation: MembershipInvitationConfirmationInput;
};

/** The output of our upsert `MembershipInvitationConfirmation` mutation. */
export type UpsertMembershipInvitationConfirmationPayload = {
  __typename?: 'UpsertMembershipInvitationConfirmationPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `MembershipInvitation` that is related to this `MembershipInvitationConfirmation`. */
  invitation?: Maybe<MembershipInvitation>;
  /** Reads a single `Membership` that is related to this `MembershipInvitationConfirmation`. */
  membership?: Maybe<Membership>;
  /** The `MembershipInvitationConfirmation` that was upserted by this mutation. */
  membershipInvitationConfirmation?: Maybe<MembershipInvitationConfirmation>;
  /** An edge for our `MembershipInvitationConfirmation`. May be used by Relay 1. */
  membershipInvitationConfirmationEdge?: Maybe<MembershipInvitationConfirmationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our upsert `MembershipInvitationConfirmation` mutation. */
export type UpsertMembershipInvitationConfirmationPayloadMembershipInvitationConfirmationEdgeArgs = {
  orderBy?: InputMaybe<Array<MembershipInvitationConfirmationsOrderBy>>;
};

/** Where conditions for the upsert `MembershipInvitationConfirmation` mutation. */
export type UpsertMembershipInvitationConfirmationWhere = {
  id?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `MembershipInvitation` mutation. */
export type UpsertMembershipInvitationInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `MembershipInvitation` to be upserted by this mutation. */
  membershipInvitation: MembershipInvitationInput;
};

/** The output of our upsert `MembershipInvitation` mutation. */
export type UpsertMembershipInvitationPayload = {
  __typename?: 'UpsertMembershipInvitationPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Group` that is related to this `MembershipInvitation`. */
  group?: Maybe<Group>;
  /** Reads a single `Group` that is related to this `MembershipInvitation`. */
  invitedGroup?: Maybe<Group>;
  /** Reads a single `User` that is related to this `MembershipInvitation`. */
  invitedUser?: Maybe<User>;
  /** Reads a single `User` that is related to this `MembershipInvitation`. */
  inviter?: Maybe<User>;
  /** The `MembershipInvitation` that was upserted by this mutation. */
  membershipInvitation?: Maybe<MembershipInvitation>;
  /** An edge for our `MembershipInvitation`. May be used by Relay 1. */
  membershipInvitationEdge?: Maybe<MembershipInvitationsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our upsert `MembershipInvitation` mutation. */
export type UpsertMembershipInvitationPayloadMembershipInvitationEdgeArgs = {
  orderBy?: InputMaybe<Array<MembershipInvitationsOrderBy>>;
};

/** Where conditions for the upsert `MembershipInvitation` mutation. */
export type UpsertMembershipInvitationWhere = {
  id?: InputMaybe<Scalars['UUID']>;
};

/** The output of our upsert `Membership` mutation. */
export type UpsertMembershipPayload = {
  __typename?: 'UpsertMembershipPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Group` that is related to this `Membership`. */
  group?: Maybe<Group>;
  /** The `Membership` that was upserted by this mutation. */
  membership?: Maybe<Membership>;
  /** An edge for our `Membership`. May be used by Relay 1. */
  membershipEdge?: Maybe<MembershipsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Group` that is related to this `Membership`. */
  subgroup?: Maybe<Group>;
  /** Reads a single `User` that is related to this `Membership`. */
  user?: Maybe<User>;
};


/** The output of our upsert `Membership` mutation. */
export type UpsertMembershipPayloadMembershipEdgeArgs = {
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};

/** Where conditions for the upsert `Membership` mutation. */
export type UpsertMembershipWhere = {
  groupId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  subgroupId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `PostWaitRandomizationTicket` mutation. */
export type UpsertPostWaitRandomizationTicketInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PostWaitRandomizationTicket` to be upserted by this mutation. */
  postWaitRandomizationTicket: PostWaitRandomizationTicketInput;
};

/** The output of our upsert `PostWaitRandomizationTicket` mutation. */
export type UpsertPostWaitRandomizationTicketPayload = {
  __typename?: 'UpsertPostWaitRandomizationTicketPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The `PostWaitRandomizationTicket` that was upserted by this mutation. */
  postWaitRandomizationTicket?: Maybe<PostWaitRandomizationTicket>;
  /** An edge for our `PostWaitRandomizationTicket`. May be used by Relay 1. */
  postWaitRandomizationTicketEdge?: Maybe<PostWaitRandomizationTicketsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Trial` that is related to this `PostWaitRandomizationTicket`. */
  trial?: Maybe<Trial>;
};


/** The output of our upsert `PostWaitRandomizationTicket` mutation. */
export type UpsertPostWaitRandomizationTicketPayloadPostWaitRandomizationTicketEdgeArgs = {
  orderBy?: InputMaybe<Array<PostWaitRandomizationTicketsOrderBy>>;
};

/** Where conditions for the upsert `PostWaitRandomizationTicket` mutation. */
export type UpsertPostWaitRandomizationTicketWhere = {
  id?: InputMaybe<Scalars['UUID']>;
  trialId?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `Posting` mutation. */
export type UpsertPostingInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Posting` to be upserted by this mutation. */
  posting: PostingInput;
};

/** The output of our upsert `Posting` mutation. */
export type UpsertPostingPayload = {
  __typename?: 'UpsertPostingPayload';
  /** Reads a single `Commentable` that is related to this `Posting`. */
  aboutCommentable?: Maybe<Commentable>;
  /** Reads a single `Posting` that is related to this `Posting`. */
  answeredPosting?: Maybe<Posting>;
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Conversation` that is related to this `Posting`. */
  conversation?: Maybe<Conversation>;
  /** The `Posting` that was upserted by this mutation. */
  posting?: Maybe<Posting>;
  /** An edge for our `Posting`. May be used by Relay 1. */
  postingEdge?: Maybe<PostingsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `Posting`. */
  sender?: Maybe<User>;
};


/** The output of our upsert `Posting` mutation. */
export type UpsertPostingPayloadPostingEdgeArgs = {
  orderBy?: InputMaybe<Array<PostingsOrderBy>>;
};

/** All input for the upsert `PostingReceipt` mutation. */
export type UpsertPostingReceiptInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `PostingReceipt` to be upserted by this mutation. */
  postingReceipt: PostingReceiptInput;
};

/** The output of our upsert `PostingReceipt` mutation. */
export type UpsertPostingReceiptPayload = {
  __typename?: 'UpsertPostingReceiptPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Posting` that is related to this `PostingReceipt`. */
  posting?: Maybe<Posting>;
  /** The `PostingReceipt` that was upserted by this mutation. */
  postingReceipt?: Maybe<PostingReceipt>;
  /** An edge for our `PostingReceipt`. May be used by Relay 1. */
  postingReceiptEdge?: Maybe<PostingReceiptsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PostingReceipt`. */
  user?: Maybe<User>;
};


/** The output of our upsert `PostingReceipt` mutation. */
export type UpsertPostingReceiptPayloadPostingReceiptEdgeArgs = {
  orderBy?: InputMaybe<Array<PostingReceiptsOrderBy>>;
};

/** Where conditions for the upsert `PostingReceipt` mutation. */
export type UpsertPostingReceiptWhere = {
  postingId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

/** Where conditions for the upsert `Posting` mutation. */
export type UpsertPostingWhere = {
  id?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `RandomizationTicket` mutation. */
export type UpsertRandomizationTicketInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RandomizationTicket` to be upserted by this mutation. */
  randomizationTicket: RandomizationTicketInput;
};

/** The output of our upsert `RandomizationTicket` mutation. */
export type UpsertRandomizationTicketPayload = {
  __typename?: 'UpsertRandomizationTicketPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RandomizationTicket` that was upserted by this mutation. */
  randomizationTicket?: Maybe<RandomizationTicket>;
  /** An edge for our `RandomizationTicket`. May be used by Relay 1. */
  randomizationTicketEdge?: Maybe<RandomizationTicketsEdge>;
  /** Reads a single `Trial` that is related to this `RandomizationTicket`. */
  trial?: Maybe<Trial>;
};


/** The output of our upsert `RandomizationTicket` mutation. */
export type UpsertRandomizationTicketPayloadRandomizationTicketEdgeArgs = {
  orderBy?: InputMaybe<Array<RandomizationTicketsOrderBy>>;
};

/** Where conditions for the upsert `RandomizationTicket` mutation. */
export type UpsertRandomizationTicketWhere = {
  id?: InputMaybe<Scalars['UUID']>;
  trialId?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `RawUsageDatum` mutation. */
export type UpsertRawUsageDatumInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `RawUsageDatum` to be upserted by this mutation. */
  rawUsageDatum: RawUsageDatumInput;
};

/** The output of our upsert `RawUsageDatum` mutation. */
export type UpsertRawUsageDatumPayload = {
  __typename?: 'UpsertRawUsageDatumPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `RawUsageDatum` that was upserted by this mutation. */
  rawUsageDatum?: Maybe<RawUsageDatum>;
  /** An edge for our `RawUsageDatum`. May be used by Relay 1. */
  rawUsageDatumEdge?: Maybe<RawUsageDataEdge>;
  /** Reads a single `Trial` that is related to this `RawUsageDatum`. */
  trial?: Maybe<Trial>;
  /** Reads a single `User` that is related to this `RawUsageDatum`. */
  user?: Maybe<User>;
};


/** The output of our upsert `RawUsageDatum` mutation. */
export type UpsertRawUsageDatumPayloadRawUsageDatumEdgeArgs = {
  orderBy?: InputMaybe<Array<RawUsageDataOrderBy>>;
};

/** Where conditions for the upsert `RawUsageDatum` mutation. */
export type UpsertRawUsageDatumWhere = {
  id?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `Tenant` mutation. */
export type UpsertTenantInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Tenant` to be upserted by this mutation. */
  tenant: TenantInput;
};

/** The output of our upsert `Tenant` mutation. */
export type UpsertTenantPayload = {
  __typename?: 'UpsertTenantPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `Tenant` that was upserted by this mutation. */
  tenant?: Maybe<Tenant>;
  /** An edge for our `Tenant`. May be used by Relay 1. */
  tenantEdge?: Maybe<TenantsEdge>;
};


/** The output of our upsert `Tenant` mutation. */
export type UpsertTenantPayloadTenantEdgeArgs = {
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
};

/** Where conditions for the upsert `Tenant` mutation. */
export type UpsertTenantWhere = {
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `Trial` mutation. */
export type UpsertTrialInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `Trial` to be upserted by this mutation. */
  trial: TrialInput;
};

/** The output of our upsert `Trial` mutation. */
export type UpsertTrialPayload = {
  __typename?: 'UpsertTrialPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Commentable` that is related to this `Trial`. */
  commentableById?: Maybe<Commentable>;
  /** Reads a single `User` that is related to this `Trial`. */
  createdBy?: Maybe<User>;
  /** Reads a single `GroupHome` that is related to this `Trial`. */
  groupHomeById?: Maybe<GroupHome>;
  /** Reads a single `Conversation` that is related to this `Trial`. */
  internalMessages?: Maybe<Conversation>;
  /** Reads a single `Conversation` that is related to this `Trial`. */
  messages?: Maybe<Conversation>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Group` that is related to this `Trial`. */
  staff?: Maybe<Group>;
  /** Reads a single `User` that is related to this `Trial`. */
  subject?: Maybe<User>;
  /** Reads a single `Tenant` that is related to this `Trial`. */
  tenant?: Maybe<Tenant>;
  /** The `Trial` that was upserted by this mutation. */
  trial?: Maybe<Trial>;
  /** An edge for our `Trial`. May be used by Relay 1. */
  trialEdge?: Maybe<TrialsEdge>;
};


/** The output of our upsert `Trial` mutation. */
export type UpsertTrialPayloadTrialEdgeArgs = {
  orderBy?: InputMaybe<Array<TrialsOrderBy>>;
};

/** Where conditions for the upsert `Trial` mutation. */
export type UpsertTrialWhere = {
  humanReadableId?: InputMaybe<Scalars['BigInt']>;
  id?: InputMaybe<Scalars['UUID']>;
  name?: InputMaybe<Scalars['String']>;
};

/** All input for the upsert `UserCredential` mutation. */
export type UpsertUserCredentialInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserCredential` to be upserted by this mutation. */
  userCredential: UserCredentialInput;
};

/** The output of our upsert `UserCredential` mutation. */
export type UpsertUserCredentialPayload = {
  __typename?: 'UpsertUserCredentialPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `UserCredential`. */
  tenant?: Maybe<Tenant>;
  /** The `UserCredential` that was upserted by this mutation. */
  userCredential?: Maybe<UserCredential>;
  /** An edge for our `UserCredential`. May be used by Relay 1. */
  userCredentialEdge?: Maybe<UserCredentialsEdge>;
};


/** The output of our upsert `UserCredential` mutation. */
export type UpsertUserCredentialPayloadUserCredentialEdgeArgs = {
  orderBy?: InputMaybe<Array<UserCredentialsOrderBy>>;
};

/** Where conditions for the upsert `UserCredential` mutation. */
export type UpsertUserCredentialWhere = {
  externalAuthId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  tenantId?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `UserEmailAddress` mutation. */
export type UpsertUserEmailAddressInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `UserEmailAddress` to be upserted by this mutation. */
  userEmailAddress: UserEmailAddressInput;
};

/** The output of our upsert `UserEmailAddress` mutation. */
export type UpsertUserEmailAddressPayload = {
  __typename?: 'UpsertUserEmailAddressPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `UserEmailAddress` that was upserted by this mutation. */
  userEmailAddress?: Maybe<UserEmailAddress>;
  /** An edge for our `UserEmailAddress`. May be used by Relay 1. */
  userEmailAddressEdge?: Maybe<UserEmailAddressesEdge>;
};


/** The output of our upsert `UserEmailAddress` mutation. */
export type UpsertUserEmailAddressPayloadUserEmailAddressEdgeArgs = {
  orderBy?: InputMaybe<Array<UserEmailAddressesOrderBy>>;
};

/** Where conditions for the upsert `UserEmailAddress` mutation. */
export type UpsertUserEmailAddressWhere = {
  emailAddress?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  tenantId?: InputMaybe<Scalars['UUID']>;
};

/** All input for the upsert `User` mutation. */
export type UpsertUserInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The `User` to be upserted by this mutation. */
  user: UserInput;
};

/** The output of our upsert `User` mutation. */
export type UpsertUserPayload = {
  __typename?: 'UpsertUserPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `UserCredential` that is related to this `User`. */
  credentials?: Maybe<UserCredential>;
  /** Reads a single `UserEmailAddress` that is related to this `User`. */
  emailAddress?: Maybe<UserEmailAddress>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `Tenant` that is related to this `User`. */
  tenant?: Maybe<Tenant>;
  /** The `User` that was upserted by this mutation. */
  user?: Maybe<User>;
  /** An edge for our `User`. May be used by Relay 1. */
  userEdge?: Maybe<UsersEdge>;
};


/** The output of our upsert `User` mutation. */
export type UpsertUserPayloadUserEdgeArgs = {
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

/** Where conditions for the upsert `User` mutation. */
export type UpsertUserWhere = {
  credentialsId?: InputMaybe<Scalars['UUID']>;
  emailAddressId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  tenantId?: InputMaybe<Scalars['UUID']>;
  username?: InputMaybe<Scalars['String']>;
};

export type User = Node & {
  __typename?: 'User';
  aboutMe?: Maybe<Scalars['String']>;
  aboutMeFormat?: Maybe<Scalars['MimeType']>;
  /** Reads and enables pagination through a set of `Group`. */
  commonGroups: GroupsConnection;
  /** Reads and enables pagination through a set of `Conversation`. */
  conversationsByCreatorId: ConversationsConnection;
  createdAt: Scalars['Datetime'];
  /** Reads a single `UserCredential` that is related to this `User`. */
  credentials?: Maybe<UserCredential>;
  credentialsId?: Maybe<Scalars['UUID']>;
  /** Reads and enables pagination through a set of `EmaEntries2`. */
  emaEntries2SBySubjectId: EmaEntries2sConnection;
  /** Reads and enables pagination through a set of `EmaEntry`. */
  emaEntriesBySubjectId: EmaEntriesConnection;
  /** Reads a single `UserEmailAddress` that is related to this `User`. */
  emailAddress?: Maybe<UserEmailAddress>;
  emailAddressId?: Maybe<Scalars['UUID']>;
  externalRoles?: Maybe<Array<Maybe<Scalars['String']>>>;
  gravatarHash?: Maybe<Scalars['String']>;
  /** Reads and enables pagination through a set of `Group`. */
  groupsByCreatorId: GroupsConnection;
  id: Scalars['UUID'];
  isTenantAdmin?: Maybe<Scalars['Boolean']>;
  /** Reads and enables pagination through a set of `MembershipInvitation`. */
  membershipInvitationsByInvitedUserId: MembershipInvitationsConnection;
  /** Reads and enables pagination through a set of `MembershipInvitation`. */
  membershipInvitationsByInviterId: MembershipInvitationsConnection;
  /** Reads and enables pagination through a set of `Membership`. */
  memberships: MembershipsConnection;
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads and enables pagination through a set of `PostingReceipt`. */
  postingReceipts: PostingReceiptsConnection;
  /** Reads and enables pagination through a set of `Posting`. */
  postingsBySenderId: PostingsConnection;
  /** Reads and enables pagination through a set of `RawUsageDatum`. */
  rawUsageData: RawUsageDataConnection;
  /** Reads a single `Tenant` that is related to this `User`. */
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['UUID'];
  /** Reads and enables pagination through a set of `Trial`. */
  trialsByCreatedById: TrialsConnection;
  /** Reads and enables pagination through a set of `Trial`. */
  trialsBySubjectId: TrialsConnection;
  updatedAt: Scalars['Datetime'];
  username: Scalars['String'];
};


export type UserCommonGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupCondition>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


export type UserConversationsByCreatorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<ConversationCondition>;
  filter?: InputMaybe<ConversationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ConversationsOrderBy>>;
};


export type UserEmaEntries2SBySubjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmaEntries2Condition>;
  filter?: InputMaybe<EmaEntries2Filter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmaEntries2sOrderBy>>;
};


export type UserEmaEntriesBySubjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<EmaEntryCondition>;
  filter?: InputMaybe<EmaEntryFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<EmaEntriesOrderBy>>;
};


export type UserGroupsByCreatorIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<GroupCondition>;
  filter?: InputMaybe<GroupFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<GroupsOrderBy>>;
};


export type UserMembershipInvitationsByInvitedUserIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MembershipInvitationCondition>;
  filter?: InputMaybe<MembershipInvitationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MembershipInvitationsOrderBy>>;
};


export type UserMembershipInvitationsByInviterIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MembershipInvitationCondition>;
  filter?: InputMaybe<MembershipInvitationFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MembershipInvitationsOrderBy>>;
};


export type UserMembershipsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<MembershipCondition>;
  filter?: InputMaybe<MembershipFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<MembershipsOrderBy>>;
};


export type UserPostingReceiptsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PostingReceiptCondition>;
  filter?: InputMaybe<PostingReceiptFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PostingReceiptsOrderBy>>;
};


export type UserPostingsBySenderIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<PostingCondition>;
  filter?: InputMaybe<PostingFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<PostingsOrderBy>>;
};


export type UserRawUsageDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<RawUsageDatumCondition>;
  filter?: InputMaybe<RawUsageDatumFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<RawUsageDataOrderBy>>;
};


export type UserTrialsByCreatedByIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TrialCondition>;
  filter?: InputMaybe<TrialFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TrialsOrderBy>>;
};


export type UserTrialsBySubjectIdArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<TrialCondition>;
  filter?: InputMaybe<TrialFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<TrialsOrderBy>>;
};

export type UserAggregates = {
  __typename?: 'UserAggregates';
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UserDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
};

/** A filter to be used against aggregates of `User` object types. */
export type UserAggregatesFilter = {
  /** Distinct count aggregate over matching `User` objects. */
  distinctCount?: InputMaybe<UserDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `User` object to be included within the aggregate. */
  filter?: InputMaybe<UserFilter>;
};

/** A condition to be used against `User` object types. All fields are tested for equality and combined with a logical ‘and.’ */
export type UserCondition = {
  /** Checks for equality with the object’s `aboutMe` field. */
  aboutMe?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `aboutMeFormat` field. */
  aboutMeFormat?: InputMaybe<Scalars['MimeType']>;
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `credentialsId` field. */
  credentialsId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `emailAddressId` field. */
  emailAddressId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `externalRoles` field. */
  externalRoles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Checks for equality with the object’s `gravatarHash` field. */
  gravatarHash?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `isTenantAdmin` field. */
  isTenantAdmin?: InputMaybe<Scalars['Boolean']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `username` field. */
  username?: InputMaybe<Scalars['String']>;
};

export type UserCredential = Node & {
  __typename?: 'UserCredential';
  createdAt: Scalars['Datetime'];
  encryptedPassword?: Maybe<Scalars['String']>;
  externalAuthId?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  /** Reads a single `Tenant` that is related to this `UserCredential`. */
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `UserCredential`. */
  user?: Maybe<User>;
  /**
   * Reads and enables pagination through a set of `User`.
   * @deprecated Please use user instead
   */
  users: UsersConnection;
};


export type UserCredentialUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

export type UserCredentialAggregates = {
  __typename?: 'UserCredentialAggregates';
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UserCredentialDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
};

/** A filter to be used against aggregates of `UserCredential` object types. */
export type UserCredentialAggregatesFilter = {
  /** Distinct count aggregate over matching `UserCredential` objects. */
  distinctCount?: InputMaybe<UserCredentialDistinctCountAggregateFilter>;
  /** A filter that must pass for the relevant `UserCredential` object to be included within the aggregate. */
  filter?: InputMaybe<UserCredentialFilter>;
};

/**
 * A condition to be used against `UserCredential` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserCredentialCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `encryptedPassword` field. */
  encryptedPassword?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `externalAuthId` field. */
  externalAuthId?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type UserCredentialDistinctCountAggregateFilter = {
  createdAt?: InputMaybe<BigIntFilter>;
  encryptedPassword?: InputMaybe<BigIntFilter>;
  externalAuthId?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  tenantId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
};

export type UserCredentialDistinctCountAggregates = {
  __typename?: 'UserCredentialDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of encryptedPassword across the matching connection */
  encryptedPassword?: Maybe<Scalars['BigInt']>;
  /** Distinct count of externalAuthId across the matching connection */
  externalAuthId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']>;
  /** Distinct count of tenantId across the matching connection */
  tenantId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `UserCredential` object types. All fields are combined with a logical ‘and.’ */
export type UserCredentialFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserCredentialFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `encryptedPassword` field. */
  encryptedPassword?: InputMaybe<StringFilter>;
  /** Filter by the object’s `externalAuthId` field. */
  externalAuthId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserCredentialFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserCredentialFilter>>;
  /** Filter by the object’s `tenant` relation. */
  tenant?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `UserCredential` */
export type UserCredentialInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  encryptedPassword?: InputMaybe<Scalars['String']>;
  externalAuthId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  tenantId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `UserCredential`. Fields that are set will be updated. */
export type UserCredentialPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  encryptedPassword?: InputMaybe<Scalars['String']>;
  externalAuthId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  tenantId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `UserCredential` values. */
export type UserCredentialsConnection = {
  __typename?: 'UserCredentialsConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UserCredentialAggregates>;
  /** A list of edges which contains the `UserCredential` and cursor to aid in pagination. */
  edges: Array<UserCredentialsEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UserCredentialAggregates>>;
  /** A list of `UserCredential` objects. */
  nodes: Array<UserCredential>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserCredential` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `UserCredential` values. */
export type UserCredentialsConnectionGroupedAggregatesArgs = {
  groupBy: Array<UserCredentialsGroupBy>;
  having?: InputMaybe<UserCredentialsHavingInput>;
};

/** A `UserCredential` edge in the connection. */
export type UserCredentialsEdge = {
  __typename?: 'UserCredentialsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserCredential` at the end of the edge. */
  node: UserCredential;
};

/** Grouping methods for `UserCredential` for usage during aggregation. */
export type UserCredentialsGroupBy =
  | 'CREATED_AT'
  | 'CREATED_AT_TRUNCATED_TO_DAY'
  | 'CREATED_AT_TRUNCATED_TO_HOUR'
  | 'ENCRYPTED_PASSWORD'
  | 'EXTERNAL_AUTH_ID'
  | 'TENANT_ID'
  | 'UPDATED_AT'
  | 'UPDATED_AT_TRUNCATED_TO_DAY'
  | 'UPDATED_AT_TRUNCATED_TO_HOUR';

export type UserCredentialsHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserCredentialsHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `UserCredential` aggregates. */
export type UserCredentialsHavingInput = {
  AND?: InputMaybe<Array<UserCredentialsHavingInput>>;
  OR?: InputMaybe<Array<UserCredentialsHavingInput>>;
  average?: InputMaybe<UserCredentialsHavingAverageInput>;
  distinctCount?: InputMaybe<UserCredentialsHavingDistinctCountInput>;
  max?: InputMaybe<UserCredentialsHavingMaxInput>;
  min?: InputMaybe<UserCredentialsHavingMinInput>;
  stddevPopulation?: InputMaybe<UserCredentialsHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UserCredentialsHavingStddevSampleInput>;
  sum?: InputMaybe<UserCredentialsHavingSumInput>;
  variancePopulation?: InputMaybe<UserCredentialsHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UserCredentialsHavingVarianceSampleInput>;
};

export type UserCredentialsHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserCredentialsHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserCredentialsHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserCredentialsHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserCredentialsHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserCredentialsHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserCredentialsHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `UserCredential`. */
export type UserCredentialsOrderBy =
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'ENCRYPTED_PASSWORD_ASC'
  | 'ENCRYPTED_PASSWORD_DESC'
  | 'EXTERNAL_AUTH_ID_ASC'
  | 'EXTERNAL_AUTH_ID_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TENANT_ID_ASC'
  | 'TENANT_ID_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

export type UserDistinctCountAggregateFilter = {
  aboutMe?: InputMaybe<BigIntFilter>;
  aboutMeFormat?: InputMaybe<BigIntFilter>;
  createdAt?: InputMaybe<BigIntFilter>;
  credentialsId?: InputMaybe<BigIntFilter>;
  emailAddressId?: InputMaybe<BigIntFilter>;
  externalRoles?: InputMaybe<BigIntFilter>;
  gravatarHash?: InputMaybe<BigIntFilter>;
  id?: InputMaybe<BigIntFilter>;
  isTenantAdmin?: InputMaybe<BigIntFilter>;
  tenantId?: InputMaybe<BigIntFilter>;
  updatedAt?: InputMaybe<BigIntFilter>;
  username?: InputMaybe<BigIntFilter>;
};

export type UserDistinctCountAggregates = {
  __typename?: 'UserDistinctCountAggregates';
  /** Distinct count of aboutMe across the matching connection */
  aboutMe?: Maybe<Scalars['BigInt']>;
  /** Distinct count of aboutMeFormat across the matching connection */
  aboutMeFormat?: Maybe<Scalars['BigInt']>;
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of credentialsId across the matching connection */
  credentialsId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of emailAddressId across the matching connection */
  emailAddressId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of externalRoles across the matching connection */
  externalRoles?: Maybe<Scalars['BigInt']>;
  /** Distinct count of gravatarHash across the matching connection */
  gravatarHash?: Maybe<Scalars['BigInt']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']>;
  /** Distinct count of isTenantAdmin across the matching connection */
  isTenantAdmin?: Maybe<Scalars['BigInt']>;
  /** Distinct count of tenantId across the matching connection */
  tenantId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of username across the matching connection */
  username?: Maybe<Scalars['BigInt']>;
};

export type UserEmailAddress = Node & {
  __typename?: 'UserEmailAddress';
  createdAt: Scalars['Datetime'];
  emailAddress: Scalars['String'];
  id: Scalars['UUID'];
  /** A globally unique identifier. Can be used in various places throughout the system to identify this single value. */
  nodeId: Scalars['ID'];
  tenantId: Scalars['UUID'];
  updatedAt: Scalars['Datetime'];
  /** Reads a single `User` that is related to this `UserEmailAddress`. */
  user?: Maybe<User>;
  /**
   * Reads and enables pagination through a set of `User`.
   * @deprecated Please use user instead
   */
  users: UsersConnection;
};


export type UserEmailAddressUsersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  condition?: InputMaybe<UserCondition>;
  filter?: InputMaybe<UserFilter>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
};

export type UserEmailAddressAggregates = {
  __typename?: 'UserEmailAddressAggregates';
  /** Distinct count aggregates across the matching connection (ignoring before/after/first/last/offset) */
  distinctCount?: Maybe<UserEmailAddressDistinctCountAggregates>;
  keys?: Maybe<Array<Scalars['String']>>;
};

/**
 * A condition to be used against `UserEmailAddress` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type UserEmailAddressCondition = {
  /** Checks for equality with the object’s `createdAt` field. */
  createdAt?: InputMaybe<Scalars['Datetime']>;
  /** Checks for equality with the object’s `emailAddress` field. */
  emailAddress?: InputMaybe<Scalars['String']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']>;
  /** Checks for equality with the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

export type UserEmailAddressDistinctCountAggregates = {
  __typename?: 'UserEmailAddressDistinctCountAggregates';
  /** Distinct count of createdAt across the matching connection */
  createdAt?: Maybe<Scalars['BigInt']>;
  /** Distinct count of emailAddress across the matching connection */
  emailAddress?: Maybe<Scalars['BigInt']>;
  /** Distinct count of id across the matching connection */
  id?: Maybe<Scalars['BigInt']>;
  /** Distinct count of tenantId across the matching connection */
  tenantId?: Maybe<Scalars['BigInt']>;
  /** Distinct count of updatedAt across the matching connection */
  updatedAt?: Maybe<Scalars['BigInt']>;
};

/** A filter to be used against `UserEmailAddress` object types. All fields are combined with a logical ‘and.’ */
export type UserEmailAddressFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserEmailAddressFilter>>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `emailAddress` field. */
  emailAddress?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<UserEmailAddressFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserEmailAddressFilter>>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `user` relation. */
  user?: InputMaybe<UserFilter>;
  /** A related `user` exists. */
  userExists?: InputMaybe<Scalars['Boolean']>;
};

/** An input for mutations affecting `UserEmailAddress` */
export type UserEmailAddressInput = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  emailAddress: Scalars['String'];
  id?: InputMaybe<Scalars['UUID']>;
  tenantId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** Represents an update to a `UserEmailAddress`. Fields that are set will be updated. */
export type UserEmailAddressPatch = {
  createdAt?: InputMaybe<Scalars['Datetime']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  tenantId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
};

/** A connection to a list of `UserEmailAddress` values. */
export type UserEmailAddressesConnection = {
  __typename?: 'UserEmailAddressesConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UserEmailAddressAggregates>;
  /** A list of edges which contains the `UserEmailAddress` and cursor to aid in pagination. */
  edges: Array<UserEmailAddressesEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UserEmailAddressAggregates>>;
  /** A list of `UserEmailAddress` objects. */
  nodes: Array<UserEmailAddress>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `UserEmailAddress` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `UserEmailAddress` values. */
export type UserEmailAddressesConnectionGroupedAggregatesArgs = {
  groupBy: Array<UserEmailAddressesGroupBy>;
  having?: InputMaybe<UserEmailAddressesHavingInput>;
};

/** A `UserEmailAddress` edge in the connection. */
export type UserEmailAddressesEdge = {
  __typename?: 'UserEmailAddressesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `UserEmailAddress` at the end of the edge. */
  node: UserEmailAddress;
};

/** Grouping methods for `UserEmailAddress` for usage during aggregation. */
export type UserEmailAddressesGroupBy =
  | 'CREATED_AT'
  | 'CREATED_AT_TRUNCATED_TO_DAY'
  | 'CREATED_AT_TRUNCATED_TO_HOUR'
  | 'EMAIL_ADDRESS'
  | 'TENANT_ID'
  | 'UPDATED_AT'
  | 'UPDATED_AT_TRUNCATED_TO_DAY'
  | 'UPDATED_AT_TRUNCATED_TO_HOUR';

export type UserEmailAddressesHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserEmailAddressesHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `UserEmailAddress` aggregates. */
export type UserEmailAddressesHavingInput = {
  AND?: InputMaybe<Array<UserEmailAddressesHavingInput>>;
  OR?: InputMaybe<Array<UserEmailAddressesHavingInput>>;
  average?: InputMaybe<UserEmailAddressesHavingAverageInput>;
  distinctCount?: InputMaybe<UserEmailAddressesHavingDistinctCountInput>;
  max?: InputMaybe<UserEmailAddressesHavingMaxInput>;
  min?: InputMaybe<UserEmailAddressesHavingMinInput>;
  stddevPopulation?: InputMaybe<UserEmailAddressesHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UserEmailAddressesHavingStddevSampleInput>;
  sum?: InputMaybe<UserEmailAddressesHavingSumInput>;
  variancePopulation?: InputMaybe<UserEmailAddressesHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UserEmailAddressesHavingVarianceSampleInput>;
};

export type UserEmailAddressesHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserEmailAddressesHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserEmailAddressesHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserEmailAddressesHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserEmailAddressesHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserEmailAddressesHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UserEmailAddressesHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `UserEmailAddress`. */
export type UserEmailAddressesOrderBy =
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'EMAIL_ADDRESS_ASC'
  | 'EMAIL_ADDRESS_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'NATURAL'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'TENANT_ID_ASC'
  | 'TENANT_ID_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC';

/** A filter to be used against `User` object types. All fields are combined with a logical ‘and.’ */
export type UserFilter = {
  /** Filter by the object’s `aboutMe` field. */
  aboutMe?: InputMaybe<StringFilter>;
  /** Filter by the object’s `aboutMeFormat` field. */
  aboutMeFormat?: InputMaybe<MimeTypeFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `conversationsByCreatorId` relation. */
  conversationsByCreatorId?: InputMaybe<UserToManyConversationFilter>;
  /** Some related `conversationsByCreatorId` exist. */
  conversationsByCreatorIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `createdAt` field. */
  createdAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `credentials` relation. */
  credentials?: InputMaybe<UserCredentialFilter>;
  /** A related `credentials` exists. */
  credentialsExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `credentialsId` field. */
  credentialsId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `emaEntries2SBySubjectId` relation. */
  emaEntries2SBySubjectId?: InputMaybe<UserToManyEmaEntries2Filter>;
  /** Some related `emaEntries2SBySubjectId` exist. */
  emaEntries2SBySubjectIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `emaEntriesBySubjectId` relation. */
  emaEntriesBySubjectId?: InputMaybe<UserToManyEmaEntryFilter>;
  /** Some related `emaEntriesBySubjectId` exist. */
  emaEntriesBySubjectIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `emailAddress` relation. */
  emailAddress?: InputMaybe<UserEmailAddressFilter>;
  /** A related `emailAddress` exists. */
  emailAddressExists?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `emailAddressId` field. */
  emailAddressId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `externalRoles` field. */
  externalRoles?: InputMaybe<StringListFilter>;
  /** Filter by the object’s `gravatarHash` field. */
  gravatarHash?: InputMaybe<StringFilter>;
  /** Filter by the object’s `groupsByCreatorId` relation. */
  groupsByCreatorId?: InputMaybe<UserToManyGroupFilter>;
  /** Some related `groupsByCreatorId` exist. */
  groupsByCreatorIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `isTenantAdmin` field. */
  isTenantAdmin?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `membershipInvitationsByInvitedUserId` relation. */
  membershipInvitationsByInvitedUserId?: InputMaybe<UserToManyMembershipInvitationFilter>;
  /** Some related `membershipInvitationsByInvitedUserId` exist. */
  membershipInvitationsByInvitedUserIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `membershipInvitationsByInviterId` relation. */
  membershipInvitationsByInviterId?: InputMaybe<UserToManyMembershipInvitationFilter>;
  /** Some related `membershipInvitationsByInviterId` exist. */
  membershipInvitationsByInviterIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `memberships` relation. */
  memberships?: InputMaybe<UserToManyMembershipFilter>;
  /** Some related `memberships` exist. */
  membershipsExist?: InputMaybe<Scalars['Boolean']>;
  /** Negates the expression. */
  not?: InputMaybe<UserFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<UserFilter>>;
  /** Filter by the object’s `postingReceipts` relation. */
  postingReceipts?: InputMaybe<UserToManyPostingReceiptFilter>;
  /** Some related `postingReceipts` exist. */
  postingReceiptsExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `postingsBySenderId` relation. */
  postingsBySenderId?: InputMaybe<UserToManyPostingFilter>;
  /** Some related `postingsBySenderId` exist. */
  postingsBySenderIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `rawUsageData` relation. */
  rawUsageData?: InputMaybe<UserToManyRawUsageDatumFilter>;
  /** Some related `rawUsageData` exist. */
  rawUsageDataExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `tenant` relation. */
  tenant?: InputMaybe<TenantFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `trialsByCreatedById` relation. */
  trialsByCreatedById?: InputMaybe<UserToManyTrialFilter>;
  /** Some related `trialsByCreatedById` exist. */
  trialsByCreatedByIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `trialsBySubjectId` relation. */
  trialsBySubjectId?: InputMaybe<UserToManyTrialFilter>;
  /** Some related `trialsBySubjectId` exist. */
  trialsBySubjectIdExist?: InputMaybe<Scalars['Boolean']>;
  /** Filter by the object’s `updatedAt` field. */
  updatedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `username` field. */
  username?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `User` */
export type UserInput = {
  aboutMe?: InputMaybe<Scalars['String']>;
  aboutMeFormat?: InputMaybe<Scalars['MimeType']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  credentialsId?: InputMaybe<Scalars['UUID']>;
  emailAddressId?: InputMaybe<Scalars['UUID']>;
  externalRoles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gravatarHash?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isTenantAdmin?: InputMaybe<Scalars['Boolean']>;
  tenantId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  username: Scalars['String'];
};

/** Represents an update to a `User`. Fields that are set will be updated. */
export type UserPatch = {
  aboutMe?: InputMaybe<Scalars['String']>;
  aboutMeFormat?: InputMaybe<Scalars['MimeType']>;
  createdAt?: InputMaybe<Scalars['Datetime']>;
  credentialsId?: InputMaybe<Scalars['UUID']>;
  emailAddressId?: InputMaybe<Scalars['UUID']>;
  externalRoles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  gravatarHash?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  isTenantAdmin?: InputMaybe<Scalars['Boolean']>;
  tenantId?: InputMaybe<Scalars['UUID']>;
  updatedAt?: InputMaybe<Scalars['Datetime']>;
  username?: InputMaybe<Scalars['String']>;
};

/** A filter to be used against many `Conversation` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyConversationFilter = {
  /** Aggregates across related `Conversation` match the filter criteria. */
  aggregates?: InputMaybe<ConversationAggregatesFilter>;
  /** Every related `Conversation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ConversationFilter>;
  /** No related `Conversation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ConversationFilter>;
  /** Some related `Conversation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ConversationFilter>;
};

/** A filter to be used against many `EmaEntries2` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyEmaEntries2Filter = {
  /** Aggregates across related `EmaEntries2` match the filter criteria. */
  aggregates?: InputMaybe<EmaEntries2AggregatesFilter>;
  /** Every related `EmaEntries2` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EmaEntries2Filter>;
  /** No related `EmaEntries2` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EmaEntries2Filter>;
  /** Some related `EmaEntries2` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EmaEntries2Filter>;
};

/** A filter to be used against many `EmaEntry` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyEmaEntryFilter = {
  /** Aggregates across related `EmaEntry` match the filter criteria. */
  aggregates?: InputMaybe<EmaEntryAggregatesFilter>;
  /** Every related `EmaEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<EmaEntryFilter>;
  /** No related `EmaEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<EmaEntryFilter>;
  /** Some related `EmaEntry` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<EmaEntryFilter>;
};

/** A filter to be used against many `Group` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyGroupFilter = {
  /** Aggregates across related `Group` match the filter criteria. */
  aggregates?: InputMaybe<GroupAggregatesFilter>;
  /** Every related `Group` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<GroupFilter>;
  /** No related `Group` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<GroupFilter>;
  /** Some related `Group` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<GroupFilter>;
};

/** A filter to be used against many `Membership` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyMembershipFilter = {
  /** Aggregates across related `Membership` match the filter criteria. */
  aggregates?: InputMaybe<MembershipAggregatesFilter>;
  /** Every related `Membership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MembershipFilter>;
  /** No related `Membership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MembershipFilter>;
  /** Some related `Membership` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MembershipFilter>;
};

/** A filter to be used against many `MembershipInvitation` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyMembershipInvitationFilter = {
  /** Aggregates across related `MembershipInvitation` match the filter criteria. */
  aggregates?: InputMaybe<MembershipInvitationAggregatesFilter>;
  /** Every related `MembershipInvitation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<MembershipInvitationFilter>;
  /** No related `MembershipInvitation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<MembershipInvitationFilter>;
  /** Some related `MembershipInvitation` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<MembershipInvitationFilter>;
};

/** A filter to be used against many `Posting` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyPostingFilter = {
  /** Aggregates across related `Posting` match the filter criteria. */
  aggregates?: InputMaybe<PostingAggregatesFilter>;
  /** Every related `Posting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PostingFilter>;
  /** No related `Posting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PostingFilter>;
  /** Some related `Posting` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PostingFilter>;
};

/** A filter to be used against many `PostingReceipt` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyPostingReceiptFilter = {
  /** Aggregates across related `PostingReceipt` match the filter criteria. */
  aggregates?: InputMaybe<PostingReceiptAggregatesFilter>;
  /** Every related `PostingReceipt` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<PostingReceiptFilter>;
  /** No related `PostingReceipt` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<PostingReceiptFilter>;
  /** Some related `PostingReceipt` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<PostingReceiptFilter>;
};

/** A filter to be used against many `RawUsageDatum` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyRawUsageDatumFilter = {
  /** Aggregates across related `RawUsageDatum` match the filter criteria. */
  aggregates?: InputMaybe<RawUsageDatumAggregatesFilter>;
  /** Every related `RawUsageDatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<RawUsageDatumFilter>;
  /** No related `RawUsageDatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<RawUsageDatumFilter>;
  /** Some related `RawUsageDatum` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<RawUsageDatumFilter>;
};

/** A filter to be used against many `Trial` object types. All fields are combined with a logical ‘and.’ */
export type UserToManyTrialFilter = {
  /** Aggregates across related `Trial` match the filter criteria. */
  aggregates?: InputMaybe<TrialAggregatesFilter>;
  /** Every related `Trial` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<TrialFilter>;
  /** No related `Trial` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<TrialFilter>;
  /** Some related `Trial` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<TrialFilter>;
};

/** A connection to a list of `User` values. */
export type UsersConnection = {
  __typename?: 'UsersConnection';
  /** Aggregates across the matching connection (ignoring before/after/first/last/offset) */
  aggregates?: Maybe<UserAggregates>;
  /** A list of edges which contains the `User` and cursor to aid in pagination. */
  edges: Array<UsersEdge>;
  /** Grouped aggregates across the matching connection (ignoring before/after/first/last/offset) */
  groupedAggregates?: Maybe<Array<UserAggregates>>;
  /** A list of `User` objects. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `User` you could get from the connection. */
  totalCount: Scalars['Int'];
};


/** A connection to a list of `User` values. */
export type UsersConnectionGroupedAggregatesArgs = {
  groupBy: Array<UsersGroupBy>;
  having?: InputMaybe<UsersHavingInput>;
};

/** A `User` edge in the connection. */
export type UsersEdge = {
  __typename?: 'UsersEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']>;
  /** The `User` at the end of the edge. */
  node: User;
};

/** Grouping methods for `User` for usage during aggregation. */
export type UsersGroupBy =
  | 'ABOUT_ME'
  | 'ABOUT_ME_FORMAT'
  | 'CREATED_AT'
  | 'CREATED_AT_TRUNCATED_TO_DAY'
  | 'CREATED_AT_TRUNCATED_TO_HOUR'
  | 'EXTERNAL_ROLES'
  | 'GRAVATAR_HASH'
  | 'IS_TENANT_ADMIN'
  | 'TENANT_ID'
  | 'UPDATED_AT'
  | 'UPDATED_AT_TRUNCATED_TO_DAY'
  | 'UPDATED_AT_TRUNCATED_TO_HOUR'
  | 'USERNAME';

export type UsersHavingAverageInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UsersHavingDistinctCountInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Conditions for `User` aggregates. */
export type UsersHavingInput = {
  AND?: InputMaybe<Array<UsersHavingInput>>;
  OR?: InputMaybe<Array<UsersHavingInput>>;
  average?: InputMaybe<UsersHavingAverageInput>;
  distinctCount?: InputMaybe<UsersHavingDistinctCountInput>;
  max?: InputMaybe<UsersHavingMaxInput>;
  min?: InputMaybe<UsersHavingMinInput>;
  stddevPopulation?: InputMaybe<UsersHavingStddevPopulationInput>;
  stddevSample?: InputMaybe<UsersHavingStddevSampleInput>;
  sum?: InputMaybe<UsersHavingSumInput>;
  variancePopulation?: InputMaybe<UsersHavingVariancePopulationInput>;
  varianceSample?: InputMaybe<UsersHavingVarianceSampleInput>;
};

export type UsersHavingMaxInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UsersHavingMinInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UsersHavingStddevPopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UsersHavingStddevSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UsersHavingSumInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UsersHavingVariancePopulationInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

export type UsersHavingVarianceSampleInput = {
  createdAt?: InputMaybe<HavingDatetimeFilter>;
  updatedAt?: InputMaybe<HavingDatetimeFilter>;
};

/** Methods to use when ordering `User`. */
export type UsersOrderBy =
  | 'ABOUT_ME_ASC'
  | 'ABOUT_ME_DESC'
  | 'ABOUT_ME_FORMAT_ASC'
  | 'ABOUT_ME_FORMAT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_AVERAGE_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_AVERAGE_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_AVERAGE_ABSTRACT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_AVERAGE_ABSTRACT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_AVERAGE_CREATED_AT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_AVERAGE_CREATED_AT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_AVERAGE_CREATOR_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_AVERAGE_CREATOR_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_AVERAGE_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_AVERAGE_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_AVERAGE_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_AVERAGE_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_AVERAGE_LANGUAGE_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_AVERAGE_LANGUAGE_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_AVERAGE_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_AVERAGE_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_AVERAGE_TENANT_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_AVERAGE_TENANT_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_AVERAGE_TITLE_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_AVERAGE_TITLE_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_AVERAGE_UPDATED_AT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_AVERAGE_UPDATED_AT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_COUNT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_COUNT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_DISTINCT_COUNT_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_DISTINCT_COUNT_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_DISTINCT_COUNT_ABSTRACT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_DISTINCT_COUNT_ABSTRACT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_DISTINCT_COUNT_CREATOR_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_DISTINCT_COUNT_CREATOR_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_DISTINCT_COUNT_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_DISTINCT_COUNT_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_DISTINCT_COUNT_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_DISTINCT_COUNT_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_DISTINCT_COUNT_LANGUAGE_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_DISTINCT_COUNT_LANGUAGE_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_DISTINCT_COUNT_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_DISTINCT_COUNT_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_DISTINCT_COUNT_TENANT_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_DISTINCT_COUNT_TENANT_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_DISTINCT_COUNT_TITLE_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_DISTINCT_COUNT_TITLE_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MAX_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MAX_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MAX_ABSTRACT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MAX_ABSTRACT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MAX_CREATED_AT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MAX_CREATED_AT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MAX_CREATOR_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MAX_CREATOR_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MAX_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MAX_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MAX_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MAX_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MAX_LANGUAGE_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MAX_LANGUAGE_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MAX_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MAX_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MAX_TENANT_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MAX_TENANT_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MAX_TITLE_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MAX_TITLE_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MAX_UPDATED_AT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MAX_UPDATED_AT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MIN_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MIN_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MIN_ABSTRACT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MIN_ABSTRACT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MIN_CREATED_AT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MIN_CREATED_AT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MIN_CREATOR_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MIN_CREATOR_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MIN_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MIN_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MIN_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MIN_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MIN_LANGUAGE_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MIN_LANGUAGE_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MIN_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MIN_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MIN_TENANT_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MIN_TENANT_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MIN_TITLE_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MIN_TITLE_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MIN_UPDATED_AT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_MIN_UPDATED_AT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_POPULATION_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_POPULATION_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_POPULATION_ABSTRACT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_POPULATION_ABSTRACT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_POPULATION_CREATOR_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_POPULATION_CREATOR_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_POPULATION_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_POPULATION_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_POPULATION_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_POPULATION_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_POPULATION_LANGUAGE_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_POPULATION_LANGUAGE_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_POPULATION_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_POPULATION_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_POPULATION_TENANT_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_POPULATION_TENANT_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_POPULATION_TITLE_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_POPULATION_TITLE_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_SAMPLE_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_SAMPLE_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_SAMPLE_ABSTRACT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_SAMPLE_ABSTRACT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_SAMPLE_CREATOR_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_SAMPLE_CREATOR_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_SAMPLE_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_SAMPLE_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_SAMPLE_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_SAMPLE_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_SAMPLE_LANGUAGE_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_SAMPLE_LANGUAGE_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_SAMPLE_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_SAMPLE_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_SAMPLE_TENANT_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_SAMPLE_TENANT_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_SAMPLE_TITLE_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_SAMPLE_TITLE_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_SUM_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_SUM_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_SUM_ABSTRACT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_SUM_ABSTRACT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_SUM_CREATED_AT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_SUM_CREATED_AT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_SUM_CREATOR_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_SUM_CREATOR_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_SUM_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_SUM_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_SUM_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_SUM_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_SUM_LANGUAGE_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_SUM_LANGUAGE_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_SUM_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_SUM_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_SUM_TENANT_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_SUM_TENANT_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_SUM_TITLE_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_SUM_TITLE_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_SUM_UPDATED_AT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_SUM_UPDATED_AT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_POPULATION_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_POPULATION_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_POPULATION_ABSTRACT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_POPULATION_ABSTRACT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_POPULATION_CREATOR_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_POPULATION_CREATOR_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_POPULATION_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_POPULATION_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_POPULATION_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_POPULATION_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_POPULATION_LANGUAGE_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_POPULATION_LANGUAGE_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_POPULATION_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_POPULATION_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_POPULATION_TENANT_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_POPULATION_TENANT_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_POPULATION_TITLE_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_POPULATION_TITLE_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_SAMPLE_ABOUT_COMMENTABLE_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_SAMPLE_ABOUT_COMMENTABLE_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_SAMPLE_ABSTRACT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_SAMPLE_ABSTRACT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_SAMPLE_CREATOR_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_SAMPLE_CREATOR_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_SAMPLE_IS_PUBLIC_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_SAMPLE_IS_PUBLIC_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_SAMPLE_LANGUAGE_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_SAMPLE_LANGUAGE_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_SAMPLE_PRIVATE_TO_GROUP_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_SAMPLE_PRIVATE_TO_GROUP_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_SAMPLE_TENANT_ID_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_SAMPLE_TENANT_ID_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_SAMPLE_TITLE_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_SAMPLE_TITLE_DESC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'CONVERSATIONS_BY_CREATOR_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'CREATED_AT_ASC'
  | 'CREATED_AT_DESC'
  | 'CREDENTIALS_ID_ASC'
  | 'CREDENTIALS_ID_DESC'
  | 'EMAIL_ADDRESS_ID_ASC'
  | 'EMAIL_ADDRESS_ID_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_ANGRY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_ANGRY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_ANXIOUS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_ANXIOUS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_BURDEN_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_BURDEN_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_CREATED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_CREATED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_DELETED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_DELETED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_GUILTY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_GUILTY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_HAPPY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_HAPPY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_ID_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_ID_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_LONELY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_LONELY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_NOT_TRIED_TO_ALTER_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_NOT_TRIED_TO_ALTER_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_PLANNED_HOW_TO_PROCEED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_PLANNED_HOW_TO_PROCEED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_RELAXED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_RELAXED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_RUMINATION_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_RUMINATION_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_SAD_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_SAD_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_SATISFIED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_SATISFIED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_STARTED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_STARTED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_SUBJECT_ID_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_SUBJECT_ID_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_TESTY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_TESTY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_THOUGHT_A_LOT_ABOUT_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_THOUGHT_A_LOT_ABOUT_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_TRIED_TO_ACCEPT_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_TRIED_TO_ACCEPT_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_TRIED_TO_CALM_MYSELF_DOWN_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_TRIED_TO_CALM_MYSELF_DOWN_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_TRIED_TO_CHANGE_MY_PERSPECTIVE_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_TRIED_TO_CHANGE_MY_PERSPECTIVE_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_TRIED_TO_DISTRACT_MYSELF_FROM_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_TRIED_TO_DISTRACT_MYSELF_FROM_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_TRIED_TO_HIDE_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_TRIED_TO_HIDE_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_UPDATED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_UPDATED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_AVERAGE_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_COUNT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_COUNT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_ANGRY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_ANGRY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_ANXIOUS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_ANXIOUS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_BURDEN_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_BURDEN_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_DELETED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_DELETED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_GUILTY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_GUILTY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_HAPPY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_HAPPY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_ID_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_ID_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_LONELY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_LONELY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_NOT_TRIED_TO_ALTER_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_NOT_TRIED_TO_ALTER_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_PLANNED_HOW_TO_PROCEED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_PLANNED_HOW_TO_PROCEED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_RELAXED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_RELAXED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_RUMINATION_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_RUMINATION_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_SAD_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_SAD_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_SATISFIED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_SATISFIED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_STARTED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_STARTED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_SUBJECT_ID_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_SUBJECT_ID_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_TESTY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_TESTY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_THOUGHT_A_LOT_ABOUT_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_THOUGHT_A_LOT_ABOUT_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_ACCEPT_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_ACCEPT_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_CALM_MYSELF_DOWN_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_CALM_MYSELF_DOWN_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_CHANGE_MY_PERSPECTIVE_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_CHANGE_MY_PERSPECTIVE_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_DISTRACT_MYSELF_FROM_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_DISTRACT_MYSELF_FROM_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_HIDE_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_HIDE_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_DISTINCT_COUNT_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_ANGRY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_ANGRY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_ANXIOUS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_ANXIOUS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_BURDEN_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_BURDEN_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_CREATED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_CREATED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_DELETED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_DELETED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_GUILTY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_GUILTY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_HAPPY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_HAPPY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_ID_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_ID_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_LONELY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_LONELY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_NOT_TRIED_TO_ALTER_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_NOT_TRIED_TO_ALTER_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_PLANNED_HOW_TO_PROCEED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_PLANNED_HOW_TO_PROCEED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_RELAXED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_RELAXED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_RUMINATION_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_RUMINATION_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_SAD_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_SAD_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_SATISFIED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_SATISFIED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_STARTED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_STARTED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_SUBJECT_ID_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_SUBJECT_ID_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_TESTY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_TESTY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_THOUGHT_A_LOT_ABOUT_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_THOUGHT_A_LOT_ABOUT_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_TRIED_TO_ACCEPT_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_TRIED_TO_ACCEPT_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_TRIED_TO_CALM_MYSELF_DOWN_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_TRIED_TO_CALM_MYSELF_DOWN_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_TRIED_TO_CHANGE_MY_PERSPECTIVE_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_TRIED_TO_CHANGE_MY_PERSPECTIVE_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_TRIED_TO_DISTRACT_MYSELF_FROM_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_TRIED_TO_DISTRACT_MYSELF_FROM_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_TRIED_TO_HIDE_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_TRIED_TO_HIDE_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_UPDATED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_UPDATED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MAX_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_ANGRY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_ANGRY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_ANXIOUS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_ANXIOUS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_BURDEN_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_BURDEN_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_CREATED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_CREATED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_DELETED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_DELETED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_GUILTY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_GUILTY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_HAPPY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_HAPPY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_ID_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_ID_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_LONELY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_LONELY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_NOT_TRIED_TO_ALTER_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_NOT_TRIED_TO_ALTER_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_PLANNED_HOW_TO_PROCEED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_PLANNED_HOW_TO_PROCEED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_RELAXED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_RELAXED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_RUMINATION_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_RUMINATION_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_SAD_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_SAD_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_SATISFIED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_SATISFIED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_STARTED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_STARTED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_SUBJECT_ID_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_SUBJECT_ID_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_TESTY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_TESTY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_THOUGHT_A_LOT_ABOUT_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_THOUGHT_A_LOT_ABOUT_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_TRIED_TO_ACCEPT_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_TRIED_TO_ACCEPT_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_TRIED_TO_CALM_MYSELF_DOWN_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_TRIED_TO_CALM_MYSELF_DOWN_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_TRIED_TO_CHANGE_MY_PERSPECTIVE_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_TRIED_TO_CHANGE_MY_PERSPECTIVE_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_TRIED_TO_DISTRACT_MYSELF_FROM_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_TRIED_TO_DISTRACT_MYSELF_FROM_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_TRIED_TO_HIDE_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_TRIED_TO_HIDE_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_UPDATED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_UPDATED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_MIN_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_ANGRY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_ANGRY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_ANXIOUS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_ANXIOUS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_BURDEN_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_BURDEN_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_DELETED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_DELETED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_GUILTY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_GUILTY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_HAPPY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_HAPPY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_ID_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_ID_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_LONELY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_LONELY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_NOT_TRIED_TO_ALTER_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_NOT_TRIED_TO_ALTER_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_PLANNED_HOW_TO_PROCEED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_PLANNED_HOW_TO_PROCEED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_RELAXED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_RELAXED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_RUMINATION_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_RUMINATION_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_SAD_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_SAD_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_SATISFIED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_SATISFIED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_STARTED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_STARTED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_SUBJECT_ID_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_SUBJECT_ID_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_TESTY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_TESTY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_THOUGHT_A_LOT_ABOUT_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_THOUGHT_A_LOT_ABOUT_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_ACCEPT_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_ACCEPT_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_CALM_MYSELF_DOWN_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_CALM_MYSELF_DOWN_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_CHANGE_MY_PERSPECTIVE_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_CHANGE_MY_PERSPECTIVE_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_DISTRACT_MYSELF_FROM_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_DISTRACT_MYSELF_FROM_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_HIDE_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_HIDE_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_POPULATION_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_ANGRY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_ANGRY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_ANXIOUS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_ANXIOUS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_BURDEN_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_BURDEN_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_DELETED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_DELETED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_GUILTY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_GUILTY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_HAPPY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_HAPPY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_LONELY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_LONELY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_NOT_TRIED_TO_ALTER_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_NOT_TRIED_TO_ALTER_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_PLANNED_HOW_TO_PROCEED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_PLANNED_HOW_TO_PROCEED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_RELAXED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_RELAXED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_RUMINATION_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_RUMINATION_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_SAD_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_SAD_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_SATISFIED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_SATISFIED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_STARTED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_STARTED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_SUBJECT_ID_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_SUBJECT_ID_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_TESTY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_TESTY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_THOUGHT_A_LOT_ABOUT_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_THOUGHT_A_LOT_ABOUT_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_ACCEPT_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_ACCEPT_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_CALM_MYSELF_DOWN_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_CALM_MYSELF_DOWN_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_CHANGE_MY_PERSPECTIVE_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_CHANGE_MY_PERSPECTIVE_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_DISTRACT_MYSELF_FROM_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_DISTRACT_MYSELF_FROM_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_HIDE_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_HIDE_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_STDDEV_SAMPLE_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_ANGRY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_ANGRY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_ANXIOUS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_ANXIOUS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_BURDEN_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_BURDEN_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_CREATED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_CREATED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_DELETED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_DELETED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_GUILTY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_GUILTY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_HAPPY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_HAPPY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_ID_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_ID_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_LONELY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_LONELY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_NOT_TRIED_TO_ALTER_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_NOT_TRIED_TO_ALTER_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_PLANNED_HOW_TO_PROCEED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_PLANNED_HOW_TO_PROCEED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_RELAXED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_RELAXED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_RUMINATION_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_RUMINATION_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_SAD_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_SAD_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_SATISFIED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_SATISFIED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_STARTED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_STARTED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_SUBJECT_ID_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_SUBJECT_ID_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_TESTY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_TESTY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_THOUGHT_A_LOT_ABOUT_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_THOUGHT_A_LOT_ABOUT_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_TRIED_TO_ACCEPT_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_TRIED_TO_ACCEPT_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_TRIED_TO_CALM_MYSELF_DOWN_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_TRIED_TO_CALM_MYSELF_DOWN_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_TRIED_TO_CHANGE_MY_PERSPECTIVE_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_TRIED_TO_CHANGE_MY_PERSPECTIVE_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_TRIED_TO_DISTRACT_MYSELF_FROM_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_TRIED_TO_DISTRACT_MYSELF_FROM_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_TRIED_TO_HIDE_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_TRIED_TO_HIDE_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_UPDATED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_UPDATED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_SUM_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_ANGRY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_ANGRY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_ANXIOUS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_ANXIOUS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_BURDEN_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_BURDEN_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_DELETED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_DELETED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_GUILTY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_GUILTY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_HAPPY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_HAPPY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_LONELY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_LONELY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_NOT_TRIED_TO_ALTER_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_NOT_TRIED_TO_ALTER_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_PLANNED_HOW_TO_PROCEED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_PLANNED_HOW_TO_PROCEED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_RELAXED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_RELAXED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_RUMINATION_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_RUMINATION_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_SAD_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_SAD_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_SATISFIED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_SATISFIED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_STARTED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_STARTED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_SUBJECT_ID_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_SUBJECT_ID_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_TESTY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_TESTY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_THOUGHT_A_LOT_ABOUT_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_THOUGHT_A_LOT_ABOUT_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_ACCEPT_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_ACCEPT_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_CALM_MYSELF_DOWN_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_CALM_MYSELF_DOWN_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_CHANGE_MY_PERSPECTIVE_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_CHANGE_MY_PERSPECTIVE_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_DISTRACT_MYSELF_FROM_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_DISTRACT_MYSELF_FROM_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_HIDE_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_HIDE_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_POPULATION_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_ANGRY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_ANGRY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_ANXIOUS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_ANXIOUS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_BURDEN_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_BURDEN_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_DELETED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_DELETED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_GUILTY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_GUILTY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_HAPPY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_HAPPY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_LONELY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_LONELY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_LOOKED_FOR_ADVICE_AND_COMFORT_FROM_OTHERS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_NOT_TRIED_TO_ALTER_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_NOT_TRIED_TO_ALTER_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_PLANNED_HOW_TO_PROCEED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_PLANNED_HOW_TO_PROCEED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_RELAXED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_RELAXED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_RUMINATION_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_RUMINATION_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_SAD_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_SAD_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_SATISFIED_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_SATISFIED_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_STARTED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_STARTED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_SUBJECT_ID_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_SUBJECT_ID_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_TESTY_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_TESTY_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_THOUGHT_A_LOT_ABOUT_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_THOUGHT_A_LOT_ABOUT_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_ACCEPT_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_ACCEPT_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_CALM_MYSELF_DOWN_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_CALM_MYSELF_DOWN_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_CHANGE_MY_PERSPECTIVE_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_CHANGE_MY_PERSPECTIVE_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_DISTRACT_MYSELF_FROM_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_DISTRACT_MYSELF_FROM_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_HIDE_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_HIDE_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_REPRESS_MY_THOUGHTS_AND_FEELINGS_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES2_SBY_SUBJECT_ID_VARIANCE_SAMPLE_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_ANGRY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_ANGRY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_ANXIOUS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_ANXIOUS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_COPING_HELPED_IN_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_COPING_HELPED_IN_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_COULD_THINK_OF_NOTHING_ELSE_THAN_THE_SITATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_COULD_THINK_OF_NOTHING_ELSE_THAN_THE_SITATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_CREATED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_CREATED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_DELETED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_DELETED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_GUILTY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_GUILTY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_HAD_A_STRESSFUL_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_HAD_A_STRESSFUL_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_HAPPY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_HAPPY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_ID_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_ID_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_LONELY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_LONELY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_RELAXED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_RELAXED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_SAD_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_SAD_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_SATISFIED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_SATISFIED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_STARTED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_STARTED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_SUBJECT_ID_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_SUBJECT_ID_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TESTY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TESTY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TRIED_NOT_TO_THINK_OF_THE_SITATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TRIED_NOT_TO_THINK_OF_THE_SITATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TRIED_SOMETHING_ELSE_TO_COPE_WITH_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TRIED_SOMETHING_ELSE_TO_COPE_WITH_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TRIED_TO_ACCEPT_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TRIED_TO_ACCEPT_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TRIED_TO_ALTER_FEELINGS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TRIED_TO_ALTER_FEELINGS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TRIED_TO_CALM_MYSELF_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TRIED_TO_CALM_MYSELF_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TRIED_TO_CHANGE_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TRIED_TO_CHANGE_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TRIED_TO_FIND_A_SOLUTION_FOR_THE_PROBLEM_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TRIED_TO_FIND_A_SOLUTION_FOR_THE_PROBLEM_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TRIED_TO_FIND_THE_CAUSE_OF_THE_PROBLEM_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TRIED_TO_FIND_THE_CAUSE_OF_THE_PROBLEM_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TRIED_TO_THINK_DIFFERENTLY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_TRIED_TO_THINK_DIFFERENTLY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_UPDATED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_UPDATED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_AVERAGE_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_COUNT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_COUNT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_ANGRY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_ANGRY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_ANXIOUS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_ANXIOUS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_COPING_HELPED_IN_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_COPING_HELPED_IN_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_COULD_THINK_OF_NOTHING_ELSE_THAN_THE_SITATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_COULD_THINK_OF_NOTHING_ELSE_THAN_THE_SITATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_DELETED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_DELETED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_GUILTY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_GUILTY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_HAD_A_STRESSFUL_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_HAD_A_STRESSFUL_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_HAPPY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_HAPPY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_ID_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_ID_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_LONELY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_LONELY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_RELAXED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_RELAXED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_SAD_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_SAD_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_SATISFIED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_SATISFIED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_STARTED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_STARTED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_SUBJECT_ID_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_SUBJECT_ID_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TESTY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TESTY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TRIED_NOT_TO_THINK_OF_THE_SITATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TRIED_NOT_TO_THINK_OF_THE_SITATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TRIED_SOMETHING_ELSE_TO_COPE_WITH_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TRIED_SOMETHING_ELSE_TO_COPE_WITH_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_ACCEPT_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_ACCEPT_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_ALTER_FEELINGS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_ALTER_FEELINGS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_CALM_MYSELF_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_CALM_MYSELF_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_CHANGE_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_CHANGE_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_FIND_A_SOLUTION_FOR_THE_PROBLEM_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_FIND_A_SOLUTION_FOR_THE_PROBLEM_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_FIND_THE_CAUSE_OF_THE_PROBLEM_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_FIND_THE_CAUSE_OF_THE_PROBLEM_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_THINK_DIFFERENTLY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_TRIED_TO_THINK_DIFFERENTLY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_DISTINCT_COUNT_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_ANGRY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_ANGRY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_ANXIOUS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_ANXIOUS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_COPING_HELPED_IN_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_COPING_HELPED_IN_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_COULD_THINK_OF_NOTHING_ELSE_THAN_THE_SITATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_COULD_THINK_OF_NOTHING_ELSE_THAN_THE_SITATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_CREATED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_CREATED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_DELETED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_DELETED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_GUILTY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_GUILTY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_HAD_A_STRESSFUL_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_HAD_A_STRESSFUL_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_HAPPY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_HAPPY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_ID_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_ID_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_LONELY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_LONELY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_RELAXED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_RELAXED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_SAD_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_SAD_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_SATISFIED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_SATISFIED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_STARTED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_STARTED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_SUBJECT_ID_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_SUBJECT_ID_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TESTY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TESTY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TRIED_NOT_TO_THINK_OF_THE_SITATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TRIED_NOT_TO_THINK_OF_THE_SITATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TRIED_SOMETHING_ELSE_TO_COPE_WITH_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TRIED_SOMETHING_ELSE_TO_COPE_WITH_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TRIED_TO_ACCEPT_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TRIED_TO_ACCEPT_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TRIED_TO_ALTER_FEELINGS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TRIED_TO_ALTER_FEELINGS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TRIED_TO_CALM_MYSELF_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TRIED_TO_CALM_MYSELF_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TRIED_TO_CHANGE_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TRIED_TO_CHANGE_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TRIED_TO_FIND_A_SOLUTION_FOR_THE_PROBLEM_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TRIED_TO_FIND_A_SOLUTION_FOR_THE_PROBLEM_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TRIED_TO_FIND_THE_CAUSE_OF_THE_PROBLEM_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TRIED_TO_FIND_THE_CAUSE_OF_THE_PROBLEM_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TRIED_TO_THINK_DIFFERENTLY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_TRIED_TO_THINK_DIFFERENTLY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_UPDATED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_UPDATED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MAX_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_ANGRY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_ANGRY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_ANXIOUS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_ANXIOUS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_COPING_HELPED_IN_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_COPING_HELPED_IN_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_COULD_THINK_OF_NOTHING_ELSE_THAN_THE_SITATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_COULD_THINK_OF_NOTHING_ELSE_THAN_THE_SITATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_CREATED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_CREATED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_DELETED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_DELETED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_GUILTY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_GUILTY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_HAD_A_STRESSFUL_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_HAD_A_STRESSFUL_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_HAPPY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_HAPPY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_ID_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_ID_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_LONELY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_LONELY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_RELAXED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_RELAXED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_SAD_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_SAD_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_SATISFIED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_SATISFIED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_STARTED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_STARTED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_SUBJECT_ID_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_SUBJECT_ID_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TESTY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TESTY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TRIED_NOT_TO_THINK_OF_THE_SITATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TRIED_NOT_TO_THINK_OF_THE_SITATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TRIED_SOMETHING_ELSE_TO_COPE_WITH_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TRIED_SOMETHING_ELSE_TO_COPE_WITH_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TRIED_TO_ACCEPT_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TRIED_TO_ACCEPT_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TRIED_TO_ALTER_FEELINGS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TRIED_TO_ALTER_FEELINGS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TRIED_TO_CALM_MYSELF_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TRIED_TO_CALM_MYSELF_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TRIED_TO_CHANGE_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TRIED_TO_CHANGE_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TRIED_TO_FIND_A_SOLUTION_FOR_THE_PROBLEM_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TRIED_TO_FIND_A_SOLUTION_FOR_THE_PROBLEM_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TRIED_TO_FIND_THE_CAUSE_OF_THE_PROBLEM_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TRIED_TO_FIND_THE_CAUSE_OF_THE_PROBLEM_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TRIED_TO_THINK_DIFFERENTLY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_TRIED_TO_THINK_DIFFERENTLY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_UPDATED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_UPDATED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_MIN_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_ANGRY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_ANGRY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_ANXIOUS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_ANXIOUS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_COPING_HELPED_IN_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_COPING_HELPED_IN_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_COULD_THINK_OF_NOTHING_ELSE_THAN_THE_SITATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_COULD_THINK_OF_NOTHING_ELSE_THAN_THE_SITATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_DELETED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_DELETED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_GUILTY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_GUILTY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_HAD_A_STRESSFUL_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_HAD_A_STRESSFUL_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_HAPPY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_HAPPY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_ID_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_ID_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_LONELY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_LONELY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_RELAXED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_RELAXED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_SAD_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_SAD_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_SATISFIED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_SATISFIED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_STARTED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_STARTED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_SUBJECT_ID_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_SUBJECT_ID_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TESTY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TESTY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TRIED_NOT_TO_THINK_OF_THE_SITATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TRIED_NOT_TO_THINK_OF_THE_SITATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TRIED_SOMETHING_ELSE_TO_COPE_WITH_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TRIED_SOMETHING_ELSE_TO_COPE_WITH_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_ACCEPT_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_ACCEPT_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_ALTER_FEELINGS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_ALTER_FEELINGS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_CALM_MYSELF_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_CALM_MYSELF_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_CHANGE_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_CHANGE_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_FIND_A_SOLUTION_FOR_THE_PROBLEM_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_FIND_A_SOLUTION_FOR_THE_PROBLEM_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_FIND_THE_CAUSE_OF_THE_PROBLEM_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_FIND_THE_CAUSE_OF_THE_PROBLEM_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_THINK_DIFFERENTLY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_TRIED_TO_THINK_DIFFERENTLY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_POPULATION_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_ANGRY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_ANGRY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_ANXIOUS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_ANXIOUS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_COPING_HELPED_IN_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_COPING_HELPED_IN_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_COULD_THINK_OF_NOTHING_ELSE_THAN_THE_SITATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_COULD_THINK_OF_NOTHING_ELSE_THAN_THE_SITATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_DELETED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_DELETED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_GUILTY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_GUILTY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_HAD_A_STRESSFUL_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_HAD_A_STRESSFUL_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_HAPPY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_HAPPY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_LONELY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_LONELY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_RELAXED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_RELAXED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_SAD_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_SAD_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_SATISFIED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_SATISFIED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_STARTED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_STARTED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_SUBJECT_ID_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_SUBJECT_ID_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TESTY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TESTY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_NOT_TO_THINK_OF_THE_SITATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_NOT_TO_THINK_OF_THE_SITATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_SOMETHING_ELSE_TO_COPE_WITH_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_SOMETHING_ELSE_TO_COPE_WITH_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_ACCEPT_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_ACCEPT_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_ALTER_FEELINGS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_ALTER_FEELINGS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_CALM_MYSELF_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_CALM_MYSELF_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_CHANGE_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_CHANGE_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_FIND_A_SOLUTION_FOR_THE_PROBLEM_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_FIND_A_SOLUTION_FOR_THE_PROBLEM_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_FIND_THE_CAUSE_OF_THE_PROBLEM_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_FIND_THE_CAUSE_OF_THE_PROBLEM_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_THINK_DIFFERENTLY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_TRIED_TO_THINK_DIFFERENTLY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_STDDEV_SAMPLE_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_ANGRY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_ANGRY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_ANXIOUS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_ANXIOUS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_COPING_HELPED_IN_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_COPING_HELPED_IN_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_COULD_THINK_OF_NOTHING_ELSE_THAN_THE_SITATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_COULD_THINK_OF_NOTHING_ELSE_THAN_THE_SITATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_CREATED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_CREATED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_DELETED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_DELETED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_GUILTY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_GUILTY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_HAD_A_STRESSFUL_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_HAD_A_STRESSFUL_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_HAPPY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_HAPPY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_ID_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_ID_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_LONELY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_LONELY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_RELAXED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_RELAXED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_SAD_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_SAD_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_SATISFIED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_SATISFIED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_STARTED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_STARTED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_SUBJECT_ID_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_SUBJECT_ID_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TESTY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TESTY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TRIED_NOT_TO_THINK_OF_THE_SITATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TRIED_NOT_TO_THINK_OF_THE_SITATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TRIED_SOMETHING_ELSE_TO_COPE_WITH_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TRIED_SOMETHING_ELSE_TO_COPE_WITH_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TRIED_TO_ACCEPT_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TRIED_TO_ACCEPT_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TRIED_TO_ALTER_FEELINGS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TRIED_TO_ALTER_FEELINGS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TRIED_TO_CALM_MYSELF_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TRIED_TO_CALM_MYSELF_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TRIED_TO_CHANGE_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TRIED_TO_CHANGE_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TRIED_TO_FIND_A_SOLUTION_FOR_THE_PROBLEM_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TRIED_TO_FIND_A_SOLUTION_FOR_THE_PROBLEM_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TRIED_TO_FIND_THE_CAUSE_OF_THE_PROBLEM_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TRIED_TO_FIND_THE_CAUSE_OF_THE_PROBLEM_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TRIED_TO_THINK_DIFFERENTLY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_TRIED_TO_THINK_DIFFERENTLY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_UPDATED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_UPDATED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_SUM_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_ANGRY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_ANGRY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_ANXIOUS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_ANXIOUS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_COPING_HELPED_IN_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_COPING_HELPED_IN_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_COULD_THINK_OF_NOTHING_ELSE_THAN_THE_SITATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_COULD_THINK_OF_NOTHING_ELSE_THAN_THE_SITATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_DELETED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_DELETED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_GUILTY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_GUILTY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_HAD_A_STRESSFUL_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_HAD_A_STRESSFUL_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_HAPPY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_HAPPY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_LONELY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_LONELY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_RELAXED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_RELAXED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_SAD_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_SAD_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_SATISFIED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_SATISFIED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_STARTED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_STARTED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_SUBJECT_ID_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_SUBJECT_ID_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TESTY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TESTY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_NOT_TO_THINK_OF_THE_SITATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_NOT_TO_THINK_OF_THE_SITATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_SOMETHING_ELSE_TO_COPE_WITH_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_SOMETHING_ELSE_TO_COPE_WITH_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_ACCEPT_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_ACCEPT_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_ALTER_FEELINGS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_ALTER_FEELINGS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_CALM_MYSELF_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_CALM_MYSELF_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_CHANGE_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_CHANGE_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_FIND_A_SOLUTION_FOR_THE_PROBLEM_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_FIND_A_SOLUTION_FOR_THE_PROBLEM_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_FIND_THE_CAUSE_OF_THE_PROBLEM_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_FIND_THE_CAUSE_OF_THE_PROBLEM_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_THINK_DIFFERENTLY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_TRIED_TO_THINK_DIFFERENTLY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_POPULATION_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_ANGRY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_ANGRY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_ANXIOUS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_ANXIOUS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_ANXIOUS_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_ANXIOUS_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_AVOIDED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_AVOIDED_SOCIAL_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_COMFORTABLE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_COMFORTABLE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_COMPLETED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_COMPLETED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_COPING_HELPED_IN_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_COPING_HELPED_IN_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_COULD_THINK_OF_NOTHING_ELSE_THAN_THE_SITATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_COULD_THINK_OF_NOTHING_ELSE_THAN_THE_SITATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_DELETED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_DELETED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_GUILTY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_GUILTY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_HAD_ANY_CONTACT_WITH_OTHERS_SINCE_THE_LAST_SURVEY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_HAD_A_STRESSFUL_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_HAD_A_STRESSFUL_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_HAPPY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_HAPPY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_LACK_OF_SOCIAL_CONTACT_BOTHERS_ME_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_LONELY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_LONELY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_NO_SOCIAL_CONTACT_DUE_TO_OUTER_CONDITIONS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_RELAXED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_RELAXED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_SAD_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_SAD_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_SATISFIED_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_SATISFIED_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_SCHEDULED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_SCHEDULED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_STARTED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_STARTED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_SUBJECT_ID_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_SUBJECT_ID_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TENSE_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TENSE_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TESTY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TESTY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TESTY_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TESTY_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_NOT_TO_THINK_OF_THE_SITATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_NOT_TO_THINK_OF_THE_SITATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_SOMETHING_ELSE_TO_COPE_WITH_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_SOMETHING_ELSE_TO_COPE_WITH_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_ACCEPT_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_ACCEPT_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_ALTER_FEELINGS_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_ALTER_FEELINGS_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_CALM_MYSELF_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_CALM_MYSELF_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_CHANGE_THE_SITUATION_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_CHANGE_THE_SITUATION_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_FIND_A_SOLUTION_FOR_THE_PROBLEM_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_FIND_A_SOLUTION_FOR_THE_PROBLEM_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_FIND_THE_CAUSE_OF_THE_PROBLEM_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_FIND_THE_CAUSE_OF_THE_PROBLEM_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_THINK_DIFFERENTLY_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_TRIED_TO_THINK_DIFFERENTLY_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_UNCONFIDENT_DURING_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_UNCONFIDENT_DURING_CONTACT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_WOULD_HAVE_LIKED_SOCIAL_CONTACT_ASC'
  | 'EMA_ENTRIES_BY_SUBJECT_ID_VARIANCE_SAMPLE_WOULD_HAVE_LIKED_SOCIAL_CONTACT_DESC'
  | 'EXTERNAL_ROLES_ASC'
  | 'EXTERNAL_ROLES_DESC'
  | 'GRAVATAR_HASH_ASC'
  | 'GRAVATAR_HASH_DESC'
  | 'GROUPS_BY_CREATOR_ID_AVERAGE_CAN_JOIN_ASC'
  | 'GROUPS_BY_CREATOR_ID_AVERAGE_CAN_JOIN_DESC'
  | 'GROUPS_BY_CREATOR_ID_AVERAGE_CAN_MANAGE_ASC'
  | 'GROUPS_BY_CREATOR_ID_AVERAGE_CAN_MANAGE_DESC'
  | 'GROUPS_BY_CREATOR_ID_AVERAGE_CREATED_AT_ASC'
  | 'GROUPS_BY_CREATOR_ID_AVERAGE_CREATED_AT_DESC'
  | 'GROUPS_BY_CREATOR_ID_AVERAGE_CREATOR_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_AVERAGE_CREATOR_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_AVERAGE_EXTERNAL_NAMES_ASC'
  | 'GROUPS_BY_CREATOR_ID_AVERAGE_EXTERNAL_NAMES_DESC'
  | 'GROUPS_BY_CREATOR_ID_AVERAGE_FLAGS_ASC'
  | 'GROUPS_BY_CREATOR_ID_AVERAGE_FLAGS_DESC'
  | 'GROUPS_BY_CREATOR_ID_AVERAGE_HOME_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_AVERAGE_HOME_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_AVERAGE_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_AVERAGE_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_AVERAGE_NAME_ASC'
  | 'GROUPS_BY_CREATOR_ID_AVERAGE_NAME_DESC'
  | 'GROUPS_BY_CREATOR_ID_AVERAGE_TENANT_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_AVERAGE_TENANT_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_AVERAGE_UPDATED_AT_ASC'
  | 'GROUPS_BY_CREATOR_ID_AVERAGE_UPDATED_AT_DESC'
  | 'GROUPS_BY_CREATOR_ID_COUNT_ASC'
  | 'GROUPS_BY_CREATOR_ID_COUNT_DESC'
  | 'GROUPS_BY_CREATOR_ID_DISTINCT_COUNT_CAN_JOIN_ASC'
  | 'GROUPS_BY_CREATOR_ID_DISTINCT_COUNT_CAN_JOIN_DESC'
  | 'GROUPS_BY_CREATOR_ID_DISTINCT_COUNT_CAN_MANAGE_ASC'
  | 'GROUPS_BY_CREATOR_ID_DISTINCT_COUNT_CAN_MANAGE_DESC'
  | 'GROUPS_BY_CREATOR_ID_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'GROUPS_BY_CREATOR_ID_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'GROUPS_BY_CREATOR_ID_DISTINCT_COUNT_CREATOR_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_DISTINCT_COUNT_CREATOR_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_DISTINCT_COUNT_EXTERNAL_NAMES_ASC'
  | 'GROUPS_BY_CREATOR_ID_DISTINCT_COUNT_EXTERNAL_NAMES_DESC'
  | 'GROUPS_BY_CREATOR_ID_DISTINCT_COUNT_FLAGS_ASC'
  | 'GROUPS_BY_CREATOR_ID_DISTINCT_COUNT_FLAGS_DESC'
  | 'GROUPS_BY_CREATOR_ID_DISTINCT_COUNT_HOME_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_DISTINCT_COUNT_HOME_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_DISTINCT_COUNT_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_DISTINCT_COUNT_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_DISTINCT_COUNT_NAME_ASC'
  | 'GROUPS_BY_CREATOR_ID_DISTINCT_COUNT_NAME_DESC'
  | 'GROUPS_BY_CREATOR_ID_DISTINCT_COUNT_TENANT_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_DISTINCT_COUNT_TENANT_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'GROUPS_BY_CREATOR_ID_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'GROUPS_BY_CREATOR_ID_MAX_CAN_JOIN_ASC'
  | 'GROUPS_BY_CREATOR_ID_MAX_CAN_JOIN_DESC'
  | 'GROUPS_BY_CREATOR_ID_MAX_CAN_MANAGE_ASC'
  | 'GROUPS_BY_CREATOR_ID_MAX_CAN_MANAGE_DESC'
  | 'GROUPS_BY_CREATOR_ID_MAX_CREATED_AT_ASC'
  | 'GROUPS_BY_CREATOR_ID_MAX_CREATED_AT_DESC'
  | 'GROUPS_BY_CREATOR_ID_MAX_CREATOR_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_MAX_CREATOR_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_MAX_EXTERNAL_NAMES_ASC'
  | 'GROUPS_BY_CREATOR_ID_MAX_EXTERNAL_NAMES_DESC'
  | 'GROUPS_BY_CREATOR_ID_MAX_FLAGS_ASC'
  | 'GROUPS_BY_CREATOR_ID_MAX_FLAGS_DESC'
  | 'GROUPS_BY_CREATOR_ID_MAX_HOME_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_MAX_HOME_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_MAX_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_MAX_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_MAX_NAME_ASC'
  | 'GROUPS_BY_CREATOR_ID_MAX_NAME_DESC'
  | 'GROUPS_BY_CREATOR_ID_MAX_TENANT_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_MAX_TENANT_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_MAX_UPDATED_AT_ASC'
  | 'GROUPS_BY_CREATOR_ID_MAX_UPDATED_AT_DESC'
  | 'GROUPS_BY_CREATOR_ID_MIN_CAN_JOIN_ASC'
  | 'GROUPS_BY_CREATOR_ID_MIN_CAN_JOIN_DESC'
  | 'GROUPS_BY_CREATOR_ID_MIN_CAN_MANAGE_ASC'
  | 'GROUPS_BY_CREATOR_ID_MIN_CAN_MANAGE_DESC'
  | 'GROUPS_BY_CREATOR_ID_MIN_CREATED_AT_ASC'
  | 'GROUPS_BY_CREATOR_ID_MIN_CREATED_AT_DESC'
  | 'GROUPS_BY_CREATOR_ID_MIN_CREATOR_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_MIN_CREATOR_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_MIN_EXTERNAL_NAMES_ASC'
  | 'GROUPS_BY_CREATOR_ID_MIN_EXTERNAL_NAMES_DESC'
  | 'GROUPS_BY_CREATOR_ID_MIN_FLAGS_ASC'
  | 'GROUPS_BY_CREATOR_ID_MIN_FLAGS_DESC'
  | 'GROUPS_BY_CREATOR_ID_MIN_HOME_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_MIN_HOME_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_MIN_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_MIN_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_MIN_NAME_ASC'
  | 'GROUPS_BY_CREATOR_ID_MIN_NAME_DESC'
  | 'GROUPS_BY_CREATOR_ID_MIN_TENANT_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_MIN_TENANT_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_MIN_UPDATED_AT_ASC'
  | 'GROUPS_BY_CREATOR_ID_MIN_UPDATED_AT_DESC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_POPULATION_CAN_JOIN_ASC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_POPULATION_CAN_JOIN_DESC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_POPULATION_CAN_MANAGE_ASC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_POPULATION_CAN_MANAGE_DESC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_POPULATION_CREATOR_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_POPULATION_CREATOR_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_POPULATION_EXTERNAL_NAMES_ASC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_POPULATION_EXTERNAL_NAMES_DESC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_POPULATION_FLAGS_ASC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_POPULATION_FLAGS_DESC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_POPULATION_HOME_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_POPULATION_HOME_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_POPULATION_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_POPULATION_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_POPULATION_NAME_ASC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_POPULATION_NAME_DESC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_POPULATION_TENANT_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_POPULATION_TENANT_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_SAMPLE_CAN_JOIN_ASC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_SAMPLE_CAN_JOIN_DESC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_SAMPLE_CAN_MANAGE_ASC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_SAMPLE_CAN_MANAGE_DESC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_SAMPLE_CREATOR_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_SAMPLE_CREATOR_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_SAMPLE_EXTERNAL_NAMES_ASC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_SAMPLE_EXTERNAL_NAMES_DESC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_SAMPLE_FLAGS_ASC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_SAMPLE_FLAGS_DESC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_SAMPLE_HOME_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_SAMPLE_HOME_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_SAMPLE_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_SAMPLE_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_SAMPLE_NAME_ASC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_SAMPLE_NAME_DESC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_SAMPLE_TENANT_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_SAMPLE_TENANT_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'GROUPS_BY_CREATOR_ID_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'GROUPS_BY_CREATOR_ID_SUM_CAN_JOIN_ASC'
  | 'GROUPS_BY_CREATOR_ID_SUM_CAN_JOIN_DESC'
  | 'GROUPS_BY_CREATOR_ID_SUM_CAN_MANAGE_ASC'
  | 'GROUPS_BY_CREATOR_ID_SUM_CAN_MANAGE_DESC'
  | 'GROUPS_BY_CREATOR_ID_SUM_CREATED_AT_ASC'
  | 'GROUPS_BY_CREATOR_ID_SUM_CREATED_AT_DESC'
  | 'GROUPS_BY_CREATOR_ID_SUM_CREATOR_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_SUM_CREATOR_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_SUM_EXTERNAL_NAMES_ASC'
  | 'GROUPS_BY_CREATOR_ID_SUM_EXTERNAL_NAMES_DESC'
  | 'GROUPS_BY_CREATOR_ID_SUM_FLAGS_ASC'
  | 'GROUPS_BY_CREATOR_ID_SUM_FLAGS_DESC'
  | 'GROUPS_BY_CREATOR_ID_SUM_HOME_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_SUM_HOME_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_SUM_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_SUM_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_SUM_NAME_ASC'
  | 'GROUPS_BY_CREATOR_ID_SUM_NAME_DESC'
  | 'GROUPS_BY_CREATOR_ID_SUM_TENANT_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_SUM_TENANT_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_SUM_UPDATED_AT_ASC'
  | 'GROUPS_BY_CREATOR_ID_SUM_UPDATED_AT_DESC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_POPULATION_CAN_JOIN_ASC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_POPULATION_CAN_JOIN_DESC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_POPULATION_CAN_MANAGE_ASC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_POPULATION_CAN_MANAGE_DESC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_POPULATION_CREATOR_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_POPULATION_CREATOR_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_POPULATION_EXTERNAL_NAMES_ASC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_POPULATION_EXTERNAL_NAMES_DESC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_POPULATION_FLAGS_ASC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_POPULATION_FLAGS_DESC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_POPULATION_HOME_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_POPULATION_HOME_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_POPULATION_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_POPULATION_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_POPULATION_NAME_ASC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_POPULATION_NAME_DESC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_POPULATION_TENANT_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_POPULATION_TENANT_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_SAMPLE_CAN_JOIN_ASC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_SAMPLE_CAN_JOIN_DESC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_SAMPLE_CAN_MANAGE_ASC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_SAMPLE_CAN_MANAGE_DESC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_SAMPLE_CREATOR_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_SAMPLE_CREATOR_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_SAMPLE_EXTERNAL_NAMES_ASC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_SAMPLE_EXTERNAL_NAMES_DESC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_SAMPLE_FLAGS_ASC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_SAMPLE_FLAGS_DESC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_SAMPLE_HOME_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_SAMPLE_HOME_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_SAMPLE_NAME_ASC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_SAMPLE_NAME_DESC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_SAMPLE_TENANT_ID_ASC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_SAMPLE_TENANT_ID_DESC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'GROUPS_BY_CREATOR_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'ID_ASC'
  | 'ID_DESC'
  | 'IS_TENANT_ADMIN_ASC'
  | 'IS_TENANT_ADMIN_DESC'
  | 'MEMBERSHIPS_AVERAGE_CREATED_AT_ASC'
  | 'MEMBERSHIPS_AVERAGE_CREATED_AT_DESC'
  | 'MEMBERSHIPS_AVERAGE_FLAGS_ASC'
  | 'MEMBERSHIPS_AVERAGE_FLAGS_DESC'
  | 'MEMBERSHIPS_AVERAGE_GROUP_ID_ASC'
  | 'MEMBERSHIPS_AVERAGE_GROUP_ID_DESC'
  | 'MEMBERSHIPS_AVERAGE_ID_ASC'
  | 'MEMBERSHIPS_AVERAGE_ID_DESC'
  | 'MEMBERSHIPS_AVERAGE_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_AVERAGE_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_AVERAGE_ROLE_ASC'
  | 'MEMBERSHIPS_AVERAGE_ROLE_DESC'
  | 'MEMBERSHIPS_AVERAGE_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_AVERAGE_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_AVERAGE_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_AVERAGE_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_AVERAGE_USER_ID_ASC'
  | 'MEMBERSHIPS_AVERAGE_USER_ID_DESC'
  | 'MEMBERSHIPS_COUNT_ASC'
  | 'MEMBERSHIPS_COUNT_DESC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_FLAGS_ASC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_FLAGS_DESC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_GROUP_ID_ASC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_GROUP_ID_DESC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_ID_ASC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_ID_DESC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_ROLE_ASC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_ROLE_DESC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_USER_ID_ASC'
  | 'MEMBERSHIPS_DISTINCT_COUNT_USER_ID_DESC'
  | 'MEMBERSHIPS_MAX_CREATED_AT_ASC'
  | 'MEMBERSHIPS_MAX_CREATED_AT_DESC'
  | 'MEMBERSHIPS_MAX_FLAGS_ASC'
  | 'MEMBERSHIPS_MAX_FLAGS_DESC'
  | 'MEMBERSHIPS_MAX_GROUP_ID_ASC'
  | 'MEMBERSHIPS_MAX_GROUP_ID_DESC'
  | 'MEMBERSHIPS_MAX_ID_ASC'
  | 'MEMBERSHIPS_MAX_ID_DESC'
  | 'MEMBERSHIPS_MAX_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_MAX_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_MAX_ROLE_ASC'
  | 'MEMBERSHIPS_MAX_ROLE_DESC'
  | 'MEMBERSHIPS_MAX_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_MAX_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_MAX_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_MAX_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_MAX_USER_ID_ASC'
  | 'MEMBERSHIPS_MAX_USER_ID_DESC'
  | 'MEMBERSHIPS_MIN_CREATED_AT_ASC'
  | 'MEMBERSHIPS_MIN_CREATED_AT_DESC'
  | 'MEMBERSHIPS_MIN_FLAGS_ASC'
  | 'MEMBERSHIPS_MIN_FLAGS_DESC'
  | 'MEMBERSHIPS_MIN_GROUP_ID_ASC'
  | 'MEMBERSHIPS_MIN_GROUP_ID_DESC'
  | 'MEMBERSHIPS_MIN_ID_ASC'
  | 'MEMBERSHIPS_MIN_ID_DESC'
  | 'MEMBERSHIPS_MIN_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_MIN_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_MIN_ROLE_ASC'
  | 'MEMBERSHIPS_MIN_ROLE_DESC'
  | 'MEMBERSHIPS_MIN_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_MIN_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_MIN_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_MIN_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_MIN_USER_ID_ASC'
  | 'MEMBERSHIPS_MIN_USER_ID_DESC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_FLAGS_ASC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_FLAGS_DESC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_GROUP_ID_ASC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_GROUP_ID_DESC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_ID_ASC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_ID_DESC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_ROLE_ASC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_ROLE_DESC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_USER_ID_ASC'
  | 'MEMBERSHIPS_STDDEV_POPULATION_USER_ID_DESC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_FLAGS_ASC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_FLAGS_DESC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_GROUP_ID_ASC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_GROUP_ID_DESC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_ID_ASC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_ID_DESC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_ROLE_ASC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_ROLE_DESC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_USER_ID_ASC'
  | 'MEMBERSHIPS_STDDEV_SAMPLE_USER_ID_DESC'
  | 'MEMBERSHIPS_SUM_CREATED_AT_ASC'
  | 'MEMBERSHIPS_SUM_CREATED_AT_DESC'
  | 'MEMBERSHIPS_SUM_FLAGS_ASC'
  | 'MEMBERSHIPS_SUM_FLAGS_DESC'
  | 'MEMBERSHIPS_SUM_GROUP_ID_ASC'
  | 'MEMBERSHIPS_SUM_GROUP_ID_DESC'
  | 'MEMBERSHIPS_SUM_ID_ASC'
  | 'MEMBERSHIPS_SUM_ID_DESC'
  | 'MEMBERSHIPS_SUM_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_SUM_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_SUM_ROLE_ASC'
  | 'MEMBERSHIPS_SUM_ROLE_DESC'
  | 'MEMBERSHIPS_SUM_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_SUM_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_SUM_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_SUM_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_SUM_USER_ID_ASC'
  | 'MEMBERSHIPS_SUM_USER_ID_DESC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_FLAGS_ASC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_FLAGS_DESC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_GROUP_ID_ASC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_GROUP_ID_DESC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_ID_ASC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_ID_DESC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_ROLE_ASC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_ROLE_DESC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_USER_ID_ASC'
  | 'MEMBERSHIPS_VARIANCE_POPULATION_USER_ID_DESC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_FLAGS_ASC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_FLAGS_DESC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_GROUP_ID_ASC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_GROUP_ID_DESC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_ID_ASC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_ID_DESC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_IS_MANAGED_EXTERNALLY_ASC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_IS_MANAGED_EXTERNALLY_DESC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_ROLE_ASC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_ROLE_DESC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_SUBGROUP_ID_ASC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_SUBGROUP_ID_DESC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_USER_ID_ASC'
  | 'MEMBERSHIPS_VARIANCE_SAMPLE_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_AVERAGE_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_COUNT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_COUNT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_DISTINCT_COUNT_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MAX_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_MIN_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_POPULATION_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_STDDEV_SAMPLE_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_SUM_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_POPULATION_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITED_USER_ID_VARIANCE_SAMPLE_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_AVERAGE_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_COUNT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_COUNT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_DISTINCT_COUNT_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MAX_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_MIN_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_POPULATION_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_STDDEV_SAMPLE_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_SUM_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_POPULATION_VALID_UNTIL_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_ACCEPTED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_ACCEPTED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_ALSO_APPLIES_IN_SUBGROUPS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_ALSO_APPLIES_IN_SUBGROUPS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_DIRECTED_TO_MEMBERS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_DIRECTED_TO_MEMBERS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_INVITED_AS_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_INVITED_AS_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_INVITED_AT_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_INVITED_AT_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_INVITED_GROUP_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_INVITED_GROUP_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_INVITED_USER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_INVITED_USER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_INVITER_ID_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_INVITER_ID_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_MAXIMUM_USES_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_MAXIMUM_USES_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_NOTE_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_NOTE_DESC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_VALID_UNTIL_ASC'
  | 'MEMBERSHIP_INVITATIONS_BY_INVITER_ID_VARIANCE_SAMPLE_VALID_UNTIL_DESC'
  | 'NATURAL'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_BODY_ASC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_BODY_DESC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_CONVERSATION_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_CONVERSATION_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_CREATED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_CREATED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_HASHTAGS_ASC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_HASHTAGS_DESC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_LANGUAGE_ASC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_LANGUAGE_DESC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_SENDER_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_SENDER_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_SUBJECT_ASC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_SUBJECT_DESC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_SUBMITTED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_SUBMITTED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_UPDATED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_AVERAGE_UPDATED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_COUNT_ASC'
  | 'POSTINGS_BY_SENDER_ID_COUNT_DESC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_BODY_ASC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_BODY_DESC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_CONVERSATION_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_CONVERSATION_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_HASHTAGS_ASC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_HASHTAGS_DESC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_LANGUAGE_ASC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_LANGUAGE_DESC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_SENDER_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_SENDER_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_SUBJECT_ASC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_SUBJECT_DESC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_SUBMITTED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_SUBMITTED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_MAX_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_MAX_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_MAX_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_MAX_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_MAX_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_BY_SENDER_ID_MAX_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_BY_SENDER_ID_MAX_BODY_ASC'
  | 'POSTINGS_BY_SENDER_ID_MAX_BODY_DESC'
  | 'POSTINGS_BY_SENDER_ID_MAX_CONVERSATION_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_MAX_CONVERSATION_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_MAX_CREATED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_MAX_CREATED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_MAX_HASHTAGS_ASC'
  | 'POSTINGS_BY_SENDER_ID_MAX_HASHTAGS_DESC'
  | 'POSTINGS_BY_SENDER_ID_MAX_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_MAX_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_MAX_LANGUAGE_ASC'
  | 'POSTINGS_BY_SENDER_ID_MAX_LANGUAGE_DESC'
  | 'POSTINGS_BY_SENDER_ID_MAX_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_BY_SENDER_ID_MAX_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_BY_SENDER_ID_MAX_SENDER_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_MAX_SENDER_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_MAX_SUBJECT_ASC'
  | 'POSTINGS_BY_SENDER_ID_MAX_SUBJECT_DESC'
  | 'POSTINGS_BY_SENDER_ID_MAX_SUBMITTED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_MAX_SUBMITTED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_MAX_UPDATED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_MAX_UPDATED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_MIN_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_MIN_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_MIN_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_MIN_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_MIN_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_BY_SENDER_ID_MIN_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_BY_SENDER_ID_MIN_BODY_ASC'
  | 'POSTINGS_BY_SENDER_ID_MIN_BODY_DESC'
  | 'POSTINGS_BY_SENDER_ID_MIN_CONVERSATION_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_MIN_CONVERSATION_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_MIN_CREATED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_MIN_CREATED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_MIN_HASHTAGS_ASC'
  | 'POSTINGS_BY_SENDER_ID_MIN_HASHTAGS_DESC'
  | 'POSTINGS_BY_SENDER_ID_MIN_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_MIN_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_MIN_LANGUAGE_ASC'
  | 'POSTINGS_BY_SENDER_ID_MIN_LANGUAGE_DESC'
  | 'POSTINGS_BY_SENDER_ID_MIN_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_BY_SENDER_ID_MIN_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_BY_SENDER_ID_MIN_SENDER_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_MIN_SENDER_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_MIN_SUBJECT_ASC'
  | 'POSTINGS_BY_SENDER_ID_MIN_SUBJECT_DESC'
  | 'POSTINGS_BY_SENDER_ID_MIN_SUBMITTED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_MIN_SUBMITTED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_MIN_UPDATED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_MIN_UPDATED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_BODY_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_BODY_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_CONVERSATION_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_CONVERSATION_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_HASHTAGS_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_HASHTAGS_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_LANGUAGE_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_LANGUAGE_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_SENDER_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_SENDER_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_SUBJECT_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_SUBJECT_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_SUBMITTED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_SUBMITTED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_BODY_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_BODY_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_CONVERSATION_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_CONVERSATION_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_HASHTAGS_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_HASHTAGS_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_LANGUAGE_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_LANGUAGE_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_SENDER_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_SENDER_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_SUBJECT_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_SUBJECT_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_SUBMITTED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_SUBMITTED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_SUM_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_SUM_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_SUM_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_SUM_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_SUM_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_BY_SENDER_ID_SUM_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_BY_SENDER_ID_SUM_BODY_ASC'
  | 'POSTINGS_BY_SENDER_ID_SUM_BODY_DESC'
  | 'POSTINGS_BY_SENDER_ID_SUM_CONVERSATION_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_SUM_CONVERSATION_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_SUM_CREATED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_SUM_CREATED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_SUM_HASHTAGS_ASC'
  | 'POSTINGS_BY_SENDER_ID_SUM_HASHTAGS_DESC'
  | 'POSTINGS_BY_SENDER_ID_SUM_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_SUM_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_SUM_LANGUAGE_ASC'
  | 'POSTINGS_BY_SENDER_ID_SUM_LANGUAGE_DESC'
  | 'POSTINGS_BY_SENDER_ID_SUM_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_BY_SENDER_ID_SUM_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_BY_SENDER_ID_SUM_SENDER_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_SUM_SENDER_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_SUM_SUBJECT_ASC'
  | 'POSTINGS_BY_SENDER_ID_SUM_SUBJECT_DESC'
  | 'POSTINGS_BY_SENDER_ID_SUM_SUBMITTED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_SUM_SUBMITTED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_SUM_UPDATED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_SUM_UPDATED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_BODY_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_BODY_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_CONVERSATION_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_CONVERSATION_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_HASHTAGS_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_HASHTAGS_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_LANGUAGE_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_LANGUAGE_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_SENDER_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_SENDER_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_SUBJECT_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_SUBJECT_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_SUBMITTED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_SUBMITTED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_ABOUT_COMMENTABLE_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_ABOUT_COMMENTABLE_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_ANSWERED_POSTING_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_ANSWERED_POSTING_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_ANSWERED_POSTING_WAS_DELETED_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_ANSWERED_POSTING_WAS_DELETED_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_BODY_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_BODY_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_CONVERSATION_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_CONVERSATION_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_HASHTAGS_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_HASHTAGS_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_LANGUAGE_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_LANGUAGE_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_MENTIONED_USERNAMES_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_MENTIONED_USERNAMES_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_SENDER_ID_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_SENDER_ID_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_SUBJECT_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_SUBJECT_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_SUBMITTED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_SUBMITTED_AT_DESC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'POSTINGS_BY_SENDER_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'POSTING_RECEIPTS_AVERAGE_MANUALLY_CONFIRMED_AT_ASC'
  | 'POSTING_RECEIPTS_AVERAGE_MANUALLY_CONFIRMED_AT_DESC'
  | 'POSTING_RECEIPTS_AVERAGE_POSTING_ID_ASC'
  | 'POSTING_RECEIPTS_AVERAGE_POSTING_ID_DESC'
  | 'POSTING_RECEIPTS_AVERAGE_RECEIVED_AT_ASC'
  | 'POSTING_RECEIPTS_AVERAGE_RECEIVED_AT_DESC'
  | 'POSTING_RECEIPTS_AVERAGE_USER_ID_ASC'
  | 'POSTING_RECEIPTS_AVERAGE_USER_ID_DESC'
  | 'POSTING_RECEIPTS_AVERAGE_VIEWED_AT_ASC'
  | 'POSTING_RECEIPTS_AVERAGE_VIEWED_AT_DESC'
  | 'POSTING_RECEIPTS_COUNT_ASC'
  | 'POSTING_RECEIPTS_COUNT_DESC'
  | 'POSTING_RECEIPTS_DISTINCT_COUNT_MANUALLY_CONFIRMED_AT_ASC'
  | 'POSTING_RECEIPTS_DISTINCT_COUNT_MANUALLY_CONFIRMED_AT_DESC'
  | 'POSTING_RECEIPTS_DISTINCT_COUNT_POSTING_ID_ASC'
  | 'POSTING_RECEIPTS_DISTINCT_COUNT_POSTING_ID_DESC'
  | 'POSTING_RECEIPTS_DISTINCT_COUNT_RECEIVED_AT_ASC'
  | 'POSTING_RECEIPTS_DISTINCT_COUNT_RECEIVED_AT_DESC'
  | 'POSTING_RECEIPTS_DISTINCT_COUNT_USER_ID_ASC'
  | 'POSTING_RECEIPTS_DISTINCT_COUNT_USER_ID_DESC'
  | 'POSTING_RECEIPTS_DISTINCT_COUNT_VIEWED_AT_ASC'
  | 'POSTING_RECEIPTS_DISTINCT_COUNT_VIEWED_AT_DESC'
  | 'POSTING_RECEIPTS_MAX_MANUALLY_CONFIRMED_AT_ASC'
  | 'POSTING_RECEIPTS_MAX_MANUALLY_CONFIRMED_AT_DESC'
  | 'POSTING_RECEIPTS_MAX_POSTING_ID_ASC'
  | 'POSTING_RECEIPTS_MAX_POSTING_ID_DESC'
  | 'POSTING_RECEIPTS_MAX_RECEIVED_AT_ASC'
  | 'POSTING_RECEIPTS_MAX_RECEIVED_AT_DESC'
  | 'POSTING_RECEIPTS_MAX_USER_ID_ASC'
  | 'POSTING_RECEIPTS_MAX_USER_ID_DESC'
  | 'POSTING_RECEIPTS_MAX_VIEWED_AT_ASC'
  | 'POSTING_RECEIPTS_MAX_VIEWED_AT_DESC'
  | 'POSTING_RECEIPTS_MIN_MANUALLY_CONFIRMED_AT_ASC'
  | 'POSTING_RECEIPTS_MIN_MANUALLY_CONFIRMED_AT_DESC'
  | 'POSTING_RECEIPTS_MIN_POSTING_ID_ASC'
  | 'POSTING_RECEIPTS_MIN_POSTING_ID_DESC'
  | 'POSTING_RECEIPTS_MIN_RECEIVED_AT_ASC'
  | 'POSTING_RECEIPTS_MIN_RECEIVED_AT_DESC'
  | 'POSTING_RECEIPTS_MIN_USER_ID_ASC'
  | 'POSTING_RECEIPTS_MIN_USER_ID_DESC'
  | 'POSTING_RECEIPTS_MIN_VIEWED_AT_ASC'
  | 'POSTING_RECEIPTS_MIN_VIEWED_AT_DESC'
  | 'POSTING_RECEIPTS_STDDEV_POPULATION_MANUALLY_CONFIRMED_AT_ASC'
  | 'POSTING_RECEIPTS_STDDEV_POPULATION_MANUALLY_CONFIRMED_AT_DESC'
  | 'POSTING_RECEIPTS_STDDEV_POPULATION_POSTING_ID_ASC'
  | 'POSTING_RECEIPTS_STDDEV_POPULATION_POSTING_ID_DESC'
  | 'POSTING_RECEIPTS_STDDEV_POPULATION_RECEIVED_AT_ASC'
  | 'POSTING_RECEIPTS_STDDEV_POPULATION_RECEIVED_AT_DESC'
  | 'POSTING_RECEIPTS_STDDEV_POPULATION_USER_ID_ASC'
  | 'POSTING_RECEIPTS_STDDEV_POPULATION_USER_ID_DESC'
  | 'POSTING_RECEIPTS_STDDEV_POPULATION_VIEWED_AT_ASC'
  | 'POSTING_RECEIPTS_STDDEV_POPULATION_VIEWED_AT_DESC'
  | 'POSTING_RECEIPTS_STDDEV_SAMPLE_MANUALLY_CONFIRMED_AT_ASC'
  | 'POSTING_RECEIPTS_STDDEV_SAMPLE_MANUALLY_CONFIRMED_AT_DESC'
  | 'POSTING_RECEIPTS_STDDEV_SAMPLE_POSTING_ID_ASC'
  | 'POSTING_RECEIPTS_STDDEV_SAMPLE_POSTING_ID_DESC'
  | 'POSTING_RECEIPTS_STDDEV_SAMPLE_RECEIVED_AT_ASC'
  | 'POSTING_RECEIPTS_STDDEV_SAMPLE_RECEIVED_AT_DESC'
  | 'POSTING_RECEIPTS_STDDEV_SAMPLE_USER_ID_ASC'
  | 'POSTING_RECEIPTS_STDDEV_SAMPLE_USER_ID_DESC'
  | 'POSTING_RECEIPTS_STDDEV_SAMPLE_VIEWED_AT_ASC'
  | 'POSTING_RECEIPTS_STDDEV_SAMPLE_VIEWED_AT_DESC'
  | 'POSTING_RECEIPTS_SUM_MANUALLY_CONFIRMED_AT_ASC'
  | 'POSTING_RECEIPTS_SUM_MANUALLY_CONFIRMED_AT_DESC'
  | 'POSTING_RECEIPTS_SUM_POSTING_ID_ASC'
  | 'POSTING_RECEIPTS_SUM_POSTING_ID_DESC'
  | 'POSTING_RECEIPTS_SUM_RECEIVED_AT_ASC'
  | 'POSTING_RECEIPTS_SUM_RECEIVED_AT_DESC'
  | 'POSTING_RECEIPTS_SUM_USER_ID_ASC'
  | 'POSTING_RECEIPTS_SUM_USER_ID_DESC'
  | 'POSTING_RECEIPTS_SUM_VIEWED_AT_ASC'
  | 'POSTING_RECEIPTS_SUM_VIEWED_AT_DESC'
  | 'POSTING_RECEIPTS_VARIANCE_POPULATION_MANUALLY_CONFIRMED_AT_ASC'
  | 'POSTING_RECEIPTS_VARIANCE_POPULATION_MANUALLY_CONFIRMED_AT_DESC'
  | 'POSTING_RECEIPTS_VARIANCE_POPULATION_POSTING_ID_ASC'
  | 'POSTING_RECEIPTS_VARIANCE_POPULATION_POSTING_ID_DESC'
  | 'POSTING_RECEIPTS_VARIANCE_POPULATION_RECEIVED_AT_ASC'
  | 'POSTING_RECEIPTS_VARIANCE_POPULATION_RECEIVED_AT_DESC'
  | 'POSTING_RECEIPTS_VARIANCE_POPULATION_USER_ID_ASC'
  | 'POSTING_RECEIPTS_VARIANCE_POPULATION_USER_ID_DESC'
  | 'POSTING_RECEIPTS_VARIANCE_POPULATION_VIEWED_AT_ASC'
  | 'POSTING_RECEIPTS_VARIANCE_POPULATION_VIEWED_AT_DESC'
  | 'POSTING_RECEIPTS_VARIANCE_SAMPLE_MANUALLY_CONFIRMED_AT_ASC'
  | 'POSTING_RECEIPTS_VARIANCE_SAMPLE_MANUALLY_CONFIRMED_AT_DESC'
  | 'POSTING_RECEIPTS_VARIANCE_SAMPLE_POSTING_ID_ASC'
  | 'POSTING_RECEIPTS_VARIANCE_SAMPLE_POSTING_ID_DESC'
  | 'POSTING_RECEIPTS_VARIANCE_SAMPLE_RECEIVED_AT_ASC'
  | 'POSTING_RECEIPTS_VARIANCE_SAMPLE_RECEIVED_AT_DESC'
  | 'POSTING_RECEIPTS_VARIANCE_SAMPLE_USER_ID_ASC'
  | 'POSTING_RECEIPTS_VARIANCE_SAMPLE_USER_ID_DESC'
  | 'POSTING_RECEIPTS_VARIANCE_SAMPLE_VIEWED_AT_ASC'
  | 'POSTING_RECEIPTS_VARIANCE_SAMPLE_VIEWED_AT_DESC'
  | 'PRIMARY_KEY_ASC'
  | 'PRIMARY_KEY_DESC'
  | 'RAW_USAGE_DATA_AVERAGE_CLIENT_HASH_ASC'
  | 'RAW_USAGE_DATA_AVERAGE_CLIENT_HASH_DESC'
  | 'RAW_USAGE_DATA_AVERAGE_ID_ASC'
  | 'RAW_USAGE_DATA_AVERAGE_ID_DESC'
  | 'RAW_USAGE_DATA_AVERAGE_PAYLOAD_ASC'
  | 'RAW_USAGE_DATA_AVERAGE_PAYLOAD_DESC'
  | 'RAW_USAGE_DATA_AVERAGE_REMOTE_ADDRESS_ASC'
  | 'RAW_USAGE_DATA_AVERAGE_REMOTE_ADDRESS_DESC'
  | 'RAW_USAGE_DATA_AVERAGE_TRACKED_AT_ASC'
  | 'RAW_USAGE_DATA_AVERAGE_TRACKED_AT_DESC'
  | 'RAW_USAGE_DATA_AVERAGE_TRIAL_ID_ASC'
  | 'RAW_USAGE_DATA_AVERAGE_TRIAL_ID_DESC'
  | 'RAW_USAGE_DATA_AVERAGE_TYPE_ASC'
  | 'RAW_USAGE_DATA_AVERAGE_TYPE_DESC'
  | 'RAW_USAGE_DATA_AVERAGE_USER_AGENT_ASC'
  | 'RAW_USAGE_DATA_AVERAGE_USER_AGENT_DESC'
  | 'RAW_USAGE_DATA_AVERAGE_USER_ID_ASC'
  | 'RAW_USAGE_DATA_AVERAGE_USER_ID_DESC'
  | 'RAW_USAGE_DATA_COUNT_ASC'
  | 'RAW_USAGE_DATA_COUNT_DESC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_CLIENT_HASH_ASC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_CLIENT_HASH_DESC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_ID_ASC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_ID_DESC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_PAYLOAD_ASC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_PAYLOAD_DESC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_REMOTE_ADDRESS_ASC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_REMOTE_ADDRESS_DESC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_TRACKED_AT_ASC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_TRACKED_AT_DESC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_TRIAL_ID_ASC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_TRIAL_ID_DESC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_TYPE_ASC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_TYPE_DESC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_USER_AGENT_ASC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_USER_AGENT_DESC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_USER_ID_ASC'
  | 'RAW_USAGE_DATA_DISTINCT_COUNT_USER_ID_DESC'
  | 'RAW_USAGE_DATA_MAX_CLIENT_HASH_ASC'
  | 'RAW_USAGE_DATA_MAX_CLIENT_HASH_DESC'
  | 'RAW_USAGE_DATA_MAX_ID_ASC'
  | 'RAW_USAGE_DATA_MAX_ID_DESC'
  | 'RAW_USAGE_DATA_MAX_PAYLOAD_ASC'
  | 'RAW_USAGE_DATA_MAX_PAYLOAD_DESC'
  | 'RAW_USAGE_DATA_MAX_REMOTE_ADDRESS_ASC'
  | 'RAW_USAGE_DATA_MAX_REMOTE_ADDRESS_DESC'
  | 'RAW_USAGE_DATA_MAX_TRACKED_AT_ASC'
  | 'RAW_USAGE_DATA_MAX_TRACKED_AT_DESC'
  | 'RAW_USAGE_DATA_MAX_TRIAL_ID_ASC'
  | 'RAW_USAGE_DATA_MAX_TRIAL_ID_DESC'
  | 'RAW_USAGE_DATA_MAX_TYPE_ASC'
  | 'RAW_USAGE_DATA_MAX_TYPE_DESC'
  | 'RAW_USAGE_DATA_MAX_USER_AGENT_ASC'
  | 'RAW_USAGE_DATA_MAX_USER_AGENT_DESC'
  | 'RAW_USAGE_DATA_MAX_USER_ID_ASC'
  | 'RAW_USAGE_DATA_MAX_USER_ID_DESC'
  | 'RAW_USAGE_DATA_MIN_CLIENT_HASH_ASC'
  | 'RAW_USAGE_DATA_MIN_CLIENT_HASH_DESC'
  | 'RAW_USAGE_DATA_MIN_ID_ASC'
  | 'RAW_USAGE_DATA_MIN_ID_DESC'
  | 'RAW_USAGE_DATA_MIN_PAYLOAD_ASC'
  | 'RAW_USAGE_DATA_MIN_PAYLOAD_DESC'
  | 'RAW_USAGE_DATA_MIN_REMOTE_ADDRESS_ASC'
  | 'RAW_USAGE_DATA_MIN_REMOTE_ADDRESS_DESC'
  | 'RAW_USAGE_DATA_MIN_TRACKED_AT_ASC'
  | 'RAW_USAGE_DATA_MIN_TRACKED_AT_DESC'
  | 'RAW_USAGE_DATA_MIN_TRIAL_ID_ASC'
  | 'RAW_USAGE_DATA_MIN_TRIAL_ID_DESC'
  | 'RAW_USAGE_DATA_MIN_TYPE_ASC'
  | 'RAW_USAGE_DATA_MIN_TYPE_DESC'
  | 'RAW_USAGE_DATA_MIN_USER_AGENT_ASC'
  | 'RAW_USAGE_DATA_MIN_USER_AGENT_DESC'
  | 'RAW_USAGE_DATA_MIN_USER_ID_ASC'
  | 'RAW_USAGE_DATA_MIN_USER_ID_DESC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_CLIENT_HASH_ASC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_CLIENT_HASH_DESC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_ID_ASC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_ID_DESC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_PAYLOAD_ASC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_PAYLOAD_DESC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_REMOTE_ADDRESS_ASC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_REMOTE_ADDRESS_DESC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_TRACKED_AT_ASC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_TRACKED_AT_DESC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_TRIAL_ID_ASC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_TRIAL_ID_DESC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_TYPE_ASC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_TYPE_DESC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_USER_AGENT_ASC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_USER_AGENT_DESC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_USER_ID_ASC'
  | 'RAW_USAGE_DATA_STDDEV_POPULATION_USER_ID_DESC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_CLIENT_HASH_ASC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_CLIENT_HASH_DESC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_ID_ASC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_ID_DESC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_PAYLOAD_ASC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_PAYLOAD_DESC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_REMOTE_ADDRESS_ASC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_REMOTE_ADDRESS_DESC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_TRACKED_AT_ASC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_TRACKED_AT_DESC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_TRIAL_ID_ASC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_TRIAL_ID_DESC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_TYPE_ASC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_TYPE_DESC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_USER_AGENT_ASC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_USER_AGENT_DESC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_USER_ID_ASC'
  | 'RAW_USAGE_DATA_STDDEV_SAMPLE_USER_ID_DESC'
  | 'RAW_USAGE_DATA_SUM_CLIENT_HASH_ASC'
  | 'RAW_USAGE_DATA_SUM_CLIENT_HASH_DESC'
  | 'RAW_USAGE_DATA_SUM_ID_ASC'
  | 'RAW_USAGE_DATA_SUM_ID_DESC'
  | 'RAW_USAGE_DATA_SUM_PAYLOAD_ASC'
  | 'RAW_USAGE_DATA_SUM_PAYLOAD_DESC'
  | 'RAW_USAGE_DATA_SUM_REMOTE_ADDRESS_ASC'
  | 'RAW_USAGE_DATA_SUM_REMOTE_ADDRESS_DESC'
  | 'RAW_USAGE_DATA_SUM_TRACKED_AT_ASC'
  | 'RAW_USAGE_DATA_SUM_TRACKED_AT_DESC'
  | 'RAW_USAGE_DATA_SUM_TRIAL_ID_ASC'
  | 'RAW_USAGE_DATA_SUM_TRIAL_ID_DESC'
  | 'RAW_USAGE_DATA_SUM_TYPE_ASC'
  | 'RAW_USAGE_DATA_SUM_TYPE_DESC'
  | 'RAW_USAGE_DATA_SUM_USER_AGENT_ASC'
  | 'RAW_USAGE_DATA_SUM_USER_AGENT_DESC'
  | 'RAW_USAGE_DATA_SUM_USER_ID_ASC'
  | 'RAW_USAGE_DATA_SUM_USER_ID_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_CLIENT_HASH_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_CLIENT_HASH_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_ID_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_ID_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_PAYLOAD_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_PAYLOAD_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_REMOTE_ADDRESS_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_REMOTE_ADDRESS_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_TRACKED_AT_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_TRACKED_AT_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_TRIAL_ID_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_TRIAL_ID_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_TYPE_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_TYPE_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_USER_AGENT_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_USER_AGENT_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_USER_ID_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_POPULATION_USER_ID_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_CLIENT_HASH_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_CLIENT_HASH_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_ID_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_ID_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_PAYLOAD_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_PAYLOAD_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_REMOTE_ADDRESS_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_REMOTE_ADDRESS_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_TRACKED_AT_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_TRACKED_AT_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_TRIAL_ID_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_TRIAL_ID_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_TYPE_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_TYPE_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_USER_AGENT_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_USER_AGENT_DESC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_USER_ID_ASC'
  | 'RAW_USAGE_DATA_VARIANCE_SAMPLE_USER_ID_DESC'
  | 'TENANT_ID_ASC'
  | 'TENANT_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_AVATAR_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_AVATAR_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_CREATED_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_CREATED_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_MESSAGES_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_MESSAGES_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_NAME_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_NAME_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_STAFF_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_STAFF_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_SUBJECT_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_SUBJECT_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_TENANT_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_TENANT_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_UPDATED_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_AVERAGE_UPDATED_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_COUNT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_COUNT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_AVATAR_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_AVATAR_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_MESSAGES_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_MESSAGES_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_NAME_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_NAME_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_STAFF_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_STAFF_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_SUBJECT_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_SUBJECT_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_TENANT_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_TENANT_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_AVATAR_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_AVATAR_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_CREATED_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_CREATED_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_MESSAGES_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_MESSAGES_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_NAME_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_NAME_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_STAFF_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_STAFF_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_SUBJECT_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_SUBJECT_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_TENANT_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_TENANT_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_UPDATED_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MAX_UPDATED_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_AVATAR_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_AVATAR_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_CREATED_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_CREATED_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_MESSAGES_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_MESSAGES_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_NAME_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_NAME_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_STAFF_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_STAFF_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_SUBJECT_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_SUBJECT_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_TENANT_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_TENANT_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_UPDATED_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_MIN_UPDATED_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_AVATAR_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_AVATAR_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_MESSAGES_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_MESSAGES_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_NAME_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_NAME_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_STAFF_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_STAFF_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_SUBJECT_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_SUBJECT_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_TENANT_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_TENANT_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_AVATAR_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_AVATAR_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_MESSAGES_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_MESSAGES_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_NAME_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_NAME_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_STAFF_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_STAFF_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_SUBJECT_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_SUBJECT_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_TENANT_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_TENANT_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_AVATAR_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_AVATAR_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_CREATED_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_CREATED_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_MESSAGES_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_MESSAGES_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_NAME_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_NAME_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_STAFF_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_STAFF_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_SUBJECT_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_SUBJECT_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_TENANT_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_TENANT_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_UPDATED_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_SUM_UPDATED_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_AVATAR_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_AVATAR_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_MESSAGES_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_MESSAGES_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_NAME_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_NAME_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_STAFF_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_STAFF_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_SUBJECT_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_SUBJECT_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_TENANT_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_TENANT_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_AVATAR_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_AVATAR_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_MESSAGES_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_MESSAGES_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_NAME_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_NAME_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_STAFF_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_STAFF_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_SUBJECT_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_SUBJECT_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_TENANT_ID_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_TENANT_ID_DESC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'TRIALS_BY_CREATED_BY_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_AVATAR_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_AVATAR_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_CREATED_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_CREATED_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_MESSAGES_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_MESSAGES_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_NAME_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_NAME_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_STAFF_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_STAFF_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_SUBJECT_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_SUBJECT_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_TENANT_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_TENANT_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_UPDATED_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_AVERAGE_UPDATED_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_COUNT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_COUNT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_AVATAR_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_AVATAR_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_CREATED_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_CREATED_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_MESSAGES_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_MESSAGES_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_NAME_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_NAME_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_STAFF_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_STAFF_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_SUBJECT_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_SUBJECT_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_TENANT_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_TENANT_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_UPDATED_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_DISTINCT_COUNT_UPDATED_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_AVATAR_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_AVATAR_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_CREATED_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_CREATED_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_MESSAGES_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_MESSAGES_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_NAME_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_NAME_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_STAFF_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_STAFF_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_SUBJECT_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_SUBJECT_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_TENANT_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_TENANT_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_UPDATED_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MAX_UPDATED_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_AVATAR_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_AVATAR_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_CREATED_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_CREATED_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_MESSAGES_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_MESSAGES_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_NAME_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_NAME_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_STAFF_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_STAFF_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_SUBJECT_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_SUBJECT_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_TENANT_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_TENANT_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_UPDATED_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_MIN_UPDATED_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_AVATAR_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_AVATAR_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_CREATED_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_CREATED_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_MESSAGES_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_MESSAGES_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_NAME_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_NAME_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_STAFF_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_STAFF_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_SUBJECT_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_SUBJECT_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_TENANT_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_TENANT_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_UPDATED_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_POPULATION_UPDATED_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_AVATAR_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_AVATAR_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_CREATED_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_CREATED_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_MESSAGES_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_MESSAGES_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_NAME_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_NAME_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_STAFF_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_STAFF_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_SUBJECT_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_SUBJECT_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_TENANT_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_TENANT_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_UPDATED_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_STDDEV_SAMPLE_UPDATED_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_AVATAR_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_AVATAR_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_CREATED_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_CREATED_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_MESSAGES_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_MESSAGES_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_NAME_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_NAME_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_STAFF_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_STAFF_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_SUBJECT_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_SUBJECT_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_TENANT_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_TENANT_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_UPDATED_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_SUM_UPDATED_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_AVATAR_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_AVATAR_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_CREATED_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_CREATED_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_MESSAGES_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_MESSAGES_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_NAME_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_NAME_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_STAFF_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_STAFF_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_SUBJECT_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_SUBJECT_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_TENANT_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_TENANT_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_UPDATED_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_POPULATION_UPDATED_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_AVATAR_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_AVATAR_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_CANNOT_USE_THE_INTERVENTION_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_CANNOT_USE_THE_INTERVENTION_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_CAN_ACCESS_ER_SINCE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_CAN_ACCESS_ER_SINCE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_CAN_ACCESS_SIP_SINCE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_CAN_ACCESS_SIP_SINCE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_CAN_BE_INCLUDED_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_CAN_BE_INCLUDED_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_CREATED_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_CREATED_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_CREATED_BY_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_CREATED_BY_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_EMERGENCY_PHONE_NUMBERS_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_EMERGENCY_PHONE_NUMBERS_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_HAS_ACCESS_TO_A_SMARTPHONE_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_HAS_ADEQUATE_KNOWLEDGE_OF_GERMAN_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_HAS_AGE_BETWEEN_18_AND_25_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_HAS_CURRENT_SUICIDAL_IDEATION_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_HAS_FACED_ADVERSE_CHILDHOOD_EXPERIENCES_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_HAS_GIVEN_INFORMED_CONSENT_AT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_HUMAN_READABLE_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_HUMAN_READABLE_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_INTERNAL_MESSAGES_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_INTERNAL_MESSAGES_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_MEETS_ALL_INCLUSION_CRITERIA_EXCEPT_INFORMED_CONSENT_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_MEETS_ANY_EXCLUSION_CRITERIA_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_MESSAGES_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_MESSAGES_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_NAME_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_NAME_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_STAFF_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_STAFF_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_SUBJECTS_NICKNAME_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_SUBJECTS_NICKNAME_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_SUBJECT_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_SUBJECT_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_TENANT_ID_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_TENANT_ID_DESC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_UPDATED_AT_ASC'
  | 'TRIALS_BY_SUBJECT_ID_VARIANCE_SAMPLE_UPDATED_AT_DESC'
  | 'UPDATED_AT_ASC'
  | 'UPDATED_AT_DESC'
  | 'USERNAME_ASC'
  | 'USERNAME_DESC';

/** All input for the create mn`PostingReceipt` mutation. */
export type MnCreatePostingReceiptInput = {
  /** An arbitrary string value with no semantic meaning. Will be included in the payload verbatim. May be used to track mutations by the client. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `PostingReceipt` to be created by this mutation. */
  mnPostingReceipt?: InputMaybe<Array<PostingReceiptInput>>;
};

/** The output of our many create `PostingReceipt` mutation. */
export type MnCreatePostingReceiptPayload = {
  __typename?: 'mnCreatePostingReceiptPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Posting` that is related to this `PostingReceipt`. */
  posting?: Maybe<Posting>;
  /** The `PostingReceipt` that was created by this mutation. */
  postingReceipt?: Maybe<PostingReceipt>;
  /** An edge for our `PostingReceipt`. May be used by Relay 1. */
  postingReceiptEdge?: Maybe<PostingReceiptsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PostingReceipt`. */
  user?: Maybe<User>;
};


/** The output of our many create `PostingReceipt` mutation. */
export type MnCreatePostingReceiptPayloadPostingReceiptEdgeArgs = {
  orderBy?: InputMaybe<Array<PostingReceiptsOrderBy>>;
};

/** All input for the delete `mnDeletePostingReceipt` mutation. */
export type MnDeletePostingReceiptInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `PostingReceipt` to be deleted. You must provide the PK values! */
  mnPatch?: InputMaybe<Array<PostingReceiptPatch>>;
};

/** The output of our delete mn `PostingReceipt` mutation. */
export type MnDeletePostingReceiptPayload = {
  __typename?: 'mnDeletePostingReceiptPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input, unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedPostingReceiptNodeId?: Maybe<Scalars['ID']>;
  /** Reads a single `Posting` that is related to this `PostingReceipt`. */
  posting?: Maybe<Posting>;
  /** The `PostingReceipt` that was deleted by this mutation. */
  postingReceipt?: Maybe<PostingReceipt>;
  /** An edge for our `PostingReceipt`. May be used by Relay 1. */
  postingReceiptEdge?: Maybe<PostingReceiptsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PostingReceipt`. */
  user?: Maybe<User>;
};


/** The output of our delete mn `PostingReceipt` mutation. */
export type MnDeletePostingReceiptPayloadPostingReceiptEdgeArgs = {
  orderBy?: InputMaybe<Array<PostingReceiptsOrderBy>>;
};

/** All input for the update `mnUpdatePostingReceipt` mutation. */
export type MnUpdatePostingReceiptInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The one or many `PostingReceipt` to be updated. */
  mnPatch?: InputMaybe<Array<PostingReceiptPatch>>;
};

/** The output of our update mn `PostingReceipt` mutation. */
export type MnUpdatePostingReceiptPayload = {
  __typename?: 'mnUpdatePostingReceiptPayload';
  /** The exact same `clientMutationId` that was provided in the mutation input,                 unchanged and unused. May be used by a client to track mutations. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Reads a single `Posting` that is related to this `PostingReceipt`. */
  posting?: Maybe<Posting>;
  /** The `PostingReceipt` that was updated by this mutation. */
  postingReceipt?: Maybe<PostingReceipt>;
  /** An edge for our `PostingReceipt`. May be used by Relay 1. */
  postingReceiptEdge?: Maybe<PostingReceiptsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `User` that is related to this `PostingReceipt`. */
  user?: Maybe<User>;
};


/** The output of our update mn `PostingReceipt` mutation. */
export type MnUpdatePostingReceiptPayloadPostingReceiptEdgeArgs = {
  orderBy?: InputMaybe<Array<PostingReceiptsOrderBy>>;
};

export type RegisterAfterKeycloakSignInMutationVariables = Exact<{ [key: string]: never; }>;


export type RegisterAfterKeycloakSignInMutation = { __typename?: 'Mutation', signUpWithAccessToken?: { __typename?: 'SignUpWithAccessTokenPayload', result?: { __typename?: 'SignUpWithAccessTokenRecord', user?: { __typename?: 'User', id: string, username: string } | null | undefined, tenant?: { __typename?: 'Tenant', name: string, keycloakRealmUrl?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type FetchNamedExerciseQueryVariables = Exact<{
  name: Scalars['String'];
  trialId: Scalars['UUID'];
}>;


export type FetchNamedExerciseQuery = { __typename?: 'Query', genericEmiExercises?: { __typename?: 'GenericEmiExercisesConnection', nodes: Array<{ __typename?: 'GenericEmiExercise', id: string, type: string, body: any }> } | null | undefined };

export type SelectPageHitsQueryVariables = Exact<{
  trialId: Scalars['UUID'];
}>;


export type SelectPageHitsQuery = { __typename?: 'Query', pageHits?: { __typename?: 'PageHitsConnection', nodes: Array<{ __typename?: 'PageHit', route?: string | null | undefined, path?: string | null | undefined, queryParameters?: any | null | undefined, nthVisit?: any | null | undefined, trackedAt?: string | null | undefined, duration?: { __typename?: 'Interval', minutes?: number | null | undefined, seconds?: number | null | undefined } | null | undefined }> } | null | undefined };

export type CreateGenericExerciseMutationVariables = Exact<{
  input: GenericEmiExerciseInput;
}>;


export type CreateGenericExerciseMutation = { __typename?: 'Mutation', createGenericEmiExercise?: { __typename?: 'CreateGenericEmiExercisePayload', genericEmiExercise?: { __typename?: 'GenericEmiExercise', body: any, createdAt: string, id: string, name?: string | null | undefined, type: string, updatedAt: string, trial?: { __typename?: 'Trial', id: string, subject?: { __typename?: 'User', id: string, username: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type DeleteExerciseMutationVariables = Exact<{
  byId: Scalars['UUID'];
}>;


export type DeleteExerciseMutation = { __typename?: 'Mutation', deleteGenericEmiExercise?: { __typename?: 'DeleteGenericEmiExercisePayload', deletedGenericEmiExerciseNodeId?: string | null | undefined, genericEmiExercise?: { __typename?: 'GenericEmiExercise', body: any, createdAt: string, id: string, name?: string | null | undefined, type: string, updatedAt: string, trial?: { __typename?: 'Trial', id: string, subject?: { __typename?: 'User', id: string, username: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type DeleteExerciseOfTrialByNameMutationVariables = Exact<{
  trialId: Scalars['UUID'];
  name: Scalars['String'];
}>;


export type DeleteExerciseOfTrialByNameMutation = { __typename?: 'Mutation', deleteGenericEmiExerciseByTrialIdAndName?: { __typename?: 'DeleteGenericEmiExercisePayload', deletedGenericEmiExerciseNodeId?: string | null | undefined, genericEmiExercise?: { __typename?: 'GenericEmiExercise', body: any, createdAt: string, id: string, name?: string | null | undefined, type: string, updatedAt: string, trial?: { __typename?: 'Trial', id: string, subject?: { __typename?: 'User', id: string, username: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type FilterGenericExercisesQueryVariables = Exact<{
  condition?: InputMaybe<GenericEmiExerciseCondition>;
  filter?: InputMaybe<GenericEmiExerciseFilter>;
  orderBy?: InputMaybe<Array<GenericEmiExercisesOrderBy> | GenericEmiExercisesOrderBy>;
  first?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type FilterGenericExercisesQuery = { __typename?: 'Query', genericEmiExercises?: { __typename?: 'GenericEmiExercisesConnection', totalCount: number, nodes: Array<{ __typename?: 'GenericEmiExercise', body: any, createdAt: string, id: string, name?: string | null | undefined, type: string, updatedAt: string, trial?: { __typename?: 'Trial', id: string, subject?: { __typename?: 'User', id: string, username: string } | null | undefined } | null | undefined }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean } } | null | undefined };

export type ExerciseFragment = { __typename?: 'GenericEmiExercise', body: any, createdAt: string, id: string, name?: string | null | undefined, type: string, updatedAt: string, trial?: { __typename?: 'Trial', id: string, subject?: { __typename?: 'User', id: string, username: string } | null | undefined } | null | undefined };

export type GetGenericExerciseQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetGenericExerciseQuery = { __typename?: 'Query', genericEmiExercise?: { __typename?: 'GenericEmiExercise', body: any, createdAt: string, id: string, name?: string | null | undefined, type: string, updatedAt: string, trial?: { __typename?: 'Trial', id: string, subject?: { __typename?: 'User', id: string, username: string } | null | undefined } | null | undefined } | null | undefined };

export type GetExerciseOfTrialByNameQueryVariables = Exact<{
  trialId: Scalars['UUID'];
  name: Scalars['String'];
}>;


export type GetExerciseOfTrialByNameQuery = { __typename?: 'Query', genericEmiExerciseByTrialIdAndName?: { __typename?: 'GenericEmiExercise', body: any, createdAt: string, id: string, name?: string | null | undefined, type: string, updatedAt: string, trial?: { __typename?: 'Trial', id: string, subject?: { __typename?: 'User', id: string, username: string } | null | undefined } | null | undefined } | null | undefined };

export type UpdateGenericExerciseMutationVariables = Exact<{
  byId: Scalars['UUID'];
  patch: GenericEmiExercisePatch;
}>;


export type UpdateGenericExerciseMutation = { __typename?: 'Mutation', updateGenericEmiExercise?: { __typename?: 'UpdateGenericEmiExercisePayload', genericEmiExercise?: { __typename?: 'GenericEmiExercise', body: any, createdAt: string, id: string, name?: string | null | undefined, type: string, updatedAt: string, trial?: { __typename?: 'Trial', id: string, subject?: { __typename?: 'User', id: string, username: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type UpsertGenericExerciseOfTrialByNameMutationVariables = Exact<{
  trialId: Scalars['UUID'];
  name: Scalars['String'];
  input: GenericEmiExerciseInput;
}>;


export type UpsertGenericExerciseOfTrialByNameMutation = { __typename?: 'Mutation', upsertGenericEmiExercise?: { __typename?: 'UpsertGenericEmiExercisePayload', genericEmiExercise?: { __typename?: 'GenericEmiExercise', body: any, createdAt: string, id: string, name?: string | null | undefined, type: string, updatedAt: string, trial?: { __typename?: 'Trial', id: string, subject?: { __typename?: 'User', id: string, username: string } | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type CreateEventMutationVariables = Exact<{
  type: Scalars['String'];
  payload?: InputMaybe<Scalars['JSON']>;
}>;


export type CreateEventMutation = { __typename?: 'Mutation', createRawUsageDatum?: { __typename?: 'CreateRawUsageDatumPayload', clientMutationId?: string | null | undefined, rawUsageDatum?: { __typename?: 'RawUsageDatum', id: string, trackedAt: string } | null | undefined } | null | undefined };

export type SetAvatarMutationVariables = Exact<{
  avatar?: InputMaybe<AvatarIcon>;
}>;


export type SetAvatarMutation = { __typename?: 'Mutation', setAvatar?: { __typename?: 'SetAvatarPayload', trial?: { __typename?: 'Trial', id: string } | null | undefined } | null | undefined };

export type SetNicknameMutationVariables = Exact<{
  nickname?: InputMaybe<Scalars['String']>;
}>;


export type SetNicknameMutation = { __typename?: 'Mutation', setNickname?: { __typename?: 'SetNicknamePayload', trial?: { __typename?: 'Trial', id: string } | null | undefined } | null | undefined };

export type SetEmergencyPhoneNumbersMutationVariables = Exact<{
  phoneNumbers: Array<EmergencyContactInput> | EmergencyContactInput;
}>;


export type SetEmergencyPhoneNumbersMutation = { __typename?: 'Mutation', setEmergencyPhoneNumbers?: { __typename?: 'SetEmergencyPhoneNumbersPayload', trial?: { __typename?: 'Trial', id: string } | null | undefined } | null | undefined };

export type MyTrialQueryVariables = Exact<{ [key: string]: never; }>;


export type MyTrialQuery = { __typename?: 'Query', myCurrentTrial?: { __typename?: 'Trial', id: string, humanReadableId: any, canAccessErSince?: string | null | undefined, canAccessSipSince?: string | null | undefined, subjectsNickname?: string | null | undefined, lastResumableRoute?: any | null | undefined, avatar?: AvatarIcon | null | undefined, emergencyPhoneNumbers: Array<{ __typename?: 'EmergencyContact', name?: string | null | undefined, phoneNumber?: string | null | undefined } | null | undefined>, staff?: { __typename?: 'Group', id: string, memberships: { __typename?: 'MembershipsConnection', totalCount: number, nodes: Array<{ __typename?: 'Membership', user?: { __typename?: 'User', id: string, username: string } | null | undefined }> } } | null | undefined, messages?: { __typename?: 'Conversation', id: string, unreadPostings: { __typename?: 'PostingsConnection', totalCount: number }, postings: { __typename?: 'PostingsConnection', totalCount: number, nodes: Array<{ __typename?: 'Posting', id: string, createdAt: string, body: string, sender?: { __typename?: 'User', id: string, username: string } | null | undefined }> } } | null | undefined } | null | undefined };

export type ShortProfileFragment = { __typename?: 'User', id: string, username: string };

export type ShortPostingFragment = { __typename?: 'Posting', id: string, createdAt: string, updatedAt: string, body: string, sender?: { __typename?: 'User', id: string, username: string } | null | undefined };

export type ShortMembershipFragment = { __typename?: 'Membership', id: string, role: GroupRole, user?: { __typename?: 'User', id: string, username: string } | null | undefined, subgroup?: { __typename?: 'Group', id: string, name?: string | null | undefined } | null | undefined };

export type TrialListDetailFragment = { __typename?: 'Trial', id: string, name?: string | null | undefined, humanReadableId: any, subjectsNickname?: string | null | undefined, createdAt: string, subject?: { __typename?: 'User', id: string, username: string } | null | undefined, createdBy?: { __typename?: 'User', id: string, username: string } | null | undefined, staff?: { __typename?: 'Group', memberships: { __typename?: 'MembershipsConnection', totalCount: number, nodes: Array<{ __typename?: 'Membership', id: string, role: GroupRole, user?: { __typename?: 'User', id: string, username: string } | null | undefined, subgroup?: { __typename?: 'Group', id: string, name?: string | null | undefined } | null | undefined }> } } | null | undefined, messages?: { __typename?: 'Conversation', id: string, unreadPostings: { __typename?: 'PostingsConnection', totalCount: number, nodes: Array<{ __typename?: 'Posting', id: string, createdAt: string, updatedAt: string, body: string, sender?: { __typename?: 'User', id: string, username: string } | null | undefined }> } } | null | undefined };

export type TrialDetailFragment = { __typename?: 'Trial', id: string, name?: string | null | undefined, humanReadableId: any, subjectsNickname?: string | null | undefined, createdAt: string, subject?: { __typename?: 'User', id: string, username: string } | null | undefined, createdBy?: { __typename?: 'User', id: string, username: string } | null | undefined, staff?: { __typename?: 'Group', myMembershipExists?: boolean | null | undefined, memberships: { __typename?: 'MembershipsConnection', totalCount: number, nodes: Array<{ __typename?: 'Membership', id: string, role: GroupRole, user?: { __typename?: 'User', id: string, username: string } | null | undefined, subgroup?: { __typename?: 'Group', id: string, name?: string | null | undefined } | null | undefined }> } } | null | undefined, messages?: { __typename?: 'Conversation', id: string, postings: { __typename?: 'PostingsConnection', totalCount: number, nodes: Array<{ __typename?: 'Posting', id: string, createdAt: string, updatedAt: string, body: string, sender?: { __typename?: 'User', id: string, username: string } | null | undefined }> }, unreadPostings: { __typename?: 'PostingsConnection', totalCount: number, nodes: Array<{ __typename?: 'Posting', id: string, createdAt: string, updatedAt: string, body: string, sender?: { __typename?: 'User', id: string, username: string } | null | undefined }> } } | null | undefined, internalMessages?: { __typename?: 'Conversation', id: string, postings: { __typename?: 'PostingsConnection', totalCount: number, nodes: Array<{ __typename?: 'Posting', id: string, createdAt: string, updatedAt: string, body: string, sender?: { __typename?: 'User', id: string, username: string } | null | undefined }> } } | null | undefined };

export type CreateTrialMutationVariables = Exact<{
  withSubjectId: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
}>;


export type CreateTrialMutation = { __typename?: 'Mutation', createTrial?: { __typename?: 'CreateTrialPayload', trial?: { __typename?: 'Trial', id: string, name?: string | null | undefined, humanReadableId: any, subjectsNickname?: string | null | undefined, createdAt: string, subject?: { __typename?: 'User', id: string, username: string } | null | undefined, createdBy?: { __typename?: 'User', id: string, username: string } | null | undefined, staff?: { __typename?: 'Group', memberships: { __typename?: 'MembershipsConnection', totalCount: number, nodes: Array<{ __typename?: 'Membership', id: string, role: GroupRole, user?: { __typename?: 'User', id: string, username: string } | null | undefined, subgroup?: { __typename?: 'Group', id: string, name?: string | null | undefined } | null | undefined }> } } | null | undefined, messages?: { __typename?: 'Conversation', id: string, unreadPostings: { __typename?: 'PostingsConnection', totalCount: number, nodes: Array<{ __typename?: 'Posting', id: string, createdAt: string, updatedAt: string, body: string, sender?: { __typename?: 'User', id: string, username: string } | null | undefined }> } } | null | undefined } | null | undefined } | null | undefined };

export type ListTrialsQueryVariables = Exact<{
  filter?: InputMaybe<TrialFilter>;
}>;


export type ListTrialsQuery = { __typename?: 'Query', trials?: { __typename?: 'TrialsConnection', nodes: Array<{ __typename?: 'Trial', id: string, name?: string | null | undefined, humanReadableId: any, subjectsNickname?: string | null | undefined, createdAt: string, subject?: { __typename?: 'User', id: string, username: string } | null | undefined, createdBy?: { __typename?: 'User', id: string, username: string } | null | undefined, staff?: { __typename?: 'Group', memberships: { __typename?: 'MembershipsConnection', totalCount: number, nodes: Array<{ __typename?: 'Membership', id: string, role: GroupRole, user?: { __typename?: 'User', id: string, username: string } | null | undefined, subgroup?: { __typename?: 'Group', id: string, name?: string | null | undefined } | null | undefined }> } } | null | undefined, messages?: { __typename?: 'Conversation', id: string, unreadPostings: { __typename?: 'PostingsConnection', totalCount: number, nodes: Array<{ __typename?: 'Posting', id: string, createdAt: string, updatedAt: string, body: string, sender?: { __typename?: 'User', id: string, username: string } | null | undefined }> } } | null | undefined }> } | null | undefined };

export type GetTrialDetailsQueryVariables = Exact<{
  byId: Scalars['UUID'];
}>;


export type GetTrialDetailsQuery = { __typename?: 'Query', trial?: { __typename?: 'Trial', id: string, name?: string | null | undefined, humanReadableId: any, subjectsNickname?: string | null | undefined, createdAt: string, subject?: { __typename?: 'User', id: string, username: string } | null | undefined, createdBy?: { __typename?: 'User', id: string, username: string } | null | undefined, staff?: { __typename?: 'Group', myMembershipExists?: boolean | null | undefined, memberships: { __typename?: 'MembershipsConnection', totalCount: number, nodes: Array<{ __typename?: 'Membership', id: string, role: GroupRole, user?: { __typename?: 'User', id: string, username: string } | null | undefined, subgroup?: { __typename?: 'Group', id: string, name?: string | null | undefined } | null | undefined }> } } | null | undefined, messages?: { __typename?: 'Conversation', id: string, postings: { __typename?: 'PostingsConnection', totalCount: number, nodes: Array<{ __typename?: 'Posting', id: string, createdAt: string, updatedAt: string, body: string, sender?: { __typename?: 'User', id: string, username: string } | null | undefined }> }, unreadPostings: { __typename?: 'PostingsConnection', totalCount: number, nodes: Array<{ __typename?: 'Posting', id: string, createdAt: string, updatedAt: string, body: string, sender?: { __typename?: 'User', id: string, username: string } | null | undefined }> } } | null | undefined, internalMessages?: { __typename?: 'Conversation', id: string, postings: { __typename?: 'PostingsConnection', totalCount: number, nodes: Array<{ __typename?: 'Posting', id: string, createdAt: string, updatedAt: string, body: string, sender?: { __typename?: 'User', id: string, username: string } | null | undefined }> } } | null | undefined } | null | undefined };

export type ListAvailableUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type ListAvailableUsersQuery = { __typename?: 'Query', users?: { __typename?: 'UsersConnection', nodes: Array<{ __typename?: 'User', id: string, username: string }> } | null | undefined };

export type SendPostingMutationVariables = Exact<{
  inConversation: Scalars['UUID'];
  body: Scalars['String'];
}>;


export type SendPostingMutation = { __typename?: 'Mutation', createPosting?: { __typename?: 'CreatePostingPayload', posting?: { __typename?: 'Posting', id: string, createdAt: string, updatedAt: string, body: string, sender?: { __typename?: 'User', id: string, username: string } | null | undefined } | null | undefined } | null | undefined };

export type AddReadReceiptsMutationVariables = Exact<{
  postingIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type AddReadReceiptsMutation = { __typename?: 'Mutation', markPostingsAsReceived?: { __typename?: 'MarkPostingsAsReceivedPayload', postingReceipts?: Array<{ __typename?: 'PostingReceipt', postingId: string, receivedAt: string, posting?: { __typename?: 'Posting', conversation?: { __typename?: 'Conversation', trialsByMessagesId: { __typename?: 'TrialsConnection', nodes: Array<{ __typename?: 'Trial', id: string }> } } | null | undefined } | null | undefined }> | null | undefined } | null | undefined };

export type ShortEmaEntryFragment = { __typename?: 'EmaEntries3', id: string, scheduledAt: string, startedAt?: string | null | undefined, completedAt?: string | null | undefined };

export type FullEmaEntryFragment = { __typename?: 'EmaEntries3', relaxed?: number | null | undefined, lonely?: number | null | undefined, anxious?: number | null | undefined, sad?: number | null | undefined, guilty?: number | null | undefined, testy?: number | null | undefined, satisfied?: number | null | undefined, happy?: number | null | undefined, angry?: number | null | undefined, energetic?: number | null | undefined, helpless?: number | null | undefined, burdens?: Array<string | null | undefined> | null | undefined, strain?: number | null | undefined, strength?: number | null | undefined, triedToThinkDifferently?: number | null | undefined, triedToRepressMyThoughtsAndFeelings?: number | null | undefined, plannedHowToProceed?: number | null | undefined, lookedForAdviceAndComfortFromOthers?: number | null | undefined, triedToCalmMyselfDown?: number | null | undefined, noBurdenForExternalReasons?: number | null | undefined, couldResolveBurdensInAdvance?: number | null | undefined, expectBurdenInTheNearFuture?: number | null | undefined, expectedBurdenThatDidNotOccur?: number | null | undefined, typicalThatNoBurdenHaveOccured?: number | null | undefined, hadAnyContactWithOthersSinceTheLastSurvey?: boolean | null | undefined, tenseDuringContact?: number | null | undefined, comfortableDuringContact?: number | null | undefined, anxiousDuringContact?: number | null | undefined, testyDuringContact?: number | null | undefined, unconfidentDuringContact?: number | null | undefined, happyDuringContact?: number | null | undefined, wouldHaveLikedSocialContact?: number | null | undefined, avoidedSocialContact?: number | null | undefined, lackOfSocialContactBothersMe?: number | null | undefined, lackOfSocialContactForExternalReasons?: number | null | undefined, atThatMomentIFeltMoreComfortableAlone?: number | null | undefined, enthusiastic?: number | null | undefined, stressed?: number | null | undefined, determined?: number | null | undefined, understoodDuringContact?: number | null | undefined, inspiredDuringContact?: number | null | undefined, smsReceivedAt?: any | null | undefined, socialDistress?: number | null | undefined, id: string, scheduledAt: string, startedAt?: string | null | undefined, completedAt?: string | null | undefined };

export type GetEmaEntryQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type GetEmaEntryQuery = { __typename?: 'Query', emaEntries3?: { __typename?: 'EmaEntries3', relaxed?: number | null | undefined, lonely?: number | null | undefined, anxious?: number | null | undefined, sad?: number | null | undefined, guilty?: number | null | undefined, testy?: number | null | undefined, satisfied?: number | null | undefined, happy?: number | null | undefined, angry?: number | null | undefined, energetic?: number | null | undefined, helpless?: number | null | undefined, burdens?: Array<string | null | undefined> | null | undefined, strain?: number | null | undefined, strength?: number | null | undefined, triedToThinkDifferently?: number | null | undefined, triedToRepressMyThoughtsAndFeelings?: number | null | undefined, plannedHowToProceed?: number | null | undefined, lookedForAdviceAndComfortFromOthers?: number | null | undefined, triedToCalmMyselfDown?: number | null | undefined, noBurdenForExternalReasons?: number | null | undefined, couldResolveBurdensInAdvance?: number | null | undefined, expectBurdenInTheNearFuture?: number | null | undefined, expectedBurdenThatDidNotOccur?: number | null | undefined, typicalThatNoBurdenHaveOccured?: number | null | undefined, hadAnyContactWithOthersSinceTheLastSurvey?: boolean | null | undefined, tenseDuringContact?: number | null | undefined, comfortableDuringContact?: number | null | undefined, anxiousDuringContact?: number | null | undefined, testyDuringContact?: number | null | undefined, unconfidentDuringContact?: number | null | undefined, happyDuringContact?: number | null | undefined, wouldHaveLikedSocialContact?: number | null | undefined, avoidedSocialContact?: number | null | undefined, lackOfSocialContactBothersMe?: number | null | undefined, lackOfSocialContactForExternalReasons?: number | null | undefined, atThatMomentIFeltMoreComfortableAlone?: number | null | undefined, enthusiastic?: number | null | undefined, stressed?: number | null | undefined, determined?: number | null | undefined, understoodDuringContact?: number | null | undefined, inspiredDuringContact?: number | null | undefined, smsReceivedAt?: any | null | undefined, socialDistress?: number | null | undefined, id: string, scheduledAt: string, startedAt?: string | null | undefined, completedAt?: string | null | undefined } | null | undefined };

export type PatchEmaEntryMutationVariables = Exact<{
  id: Scalars['UUID'];
  patch: EmaEntries3Patch;
}>;


export type PatchEmaEntryMutation = { __typename?: 'Mutation', updateEmaEntries3?: { __typename?: 'UpdateEmaEntries3Payload', emaEntries3?: { __typename?: 'EmaEntries3', relaxed?: number | null | undefined, lonely?: number | null | undefined, anxious?: number | null | undefined, sad?: number | null | undefined, guilty?: number | null | undefined, testy?: number | null | undefined, satisfied?: number | null | undefined, happy?: number | null | undefined, angry?: number | null | undefined, energetic?: number | null | undefined, helpless?: number | null | undefined, burdens?: Array<string | null | undefined> | null | undefined, strain?: number | null | undefined, strength?: number | null | undefined, triedToThinkDifferently?: number | null | undefined, triedToRepressMyThoughtsAndFeelings?: number | null | undefined, plannedHowToProceed?: number | null | undefined, lookedForAdviceAndComfortFromOthers?: number | null | undefined, triedToCalmMyselfDown?: number | null | undefined, noBurdenForExternalReasons?: number | null | undefined, couldResolveBurdensInAdvance?: number | null | undefined, expectBurdenInTheNearFuture?: number | null | undefined, expectedBurdenThatDidNotOccur?: number | null | undefined, typicalThatNoBurdenHaveOccured?: number | null | undefined, hadAnyContactWithOthersSinceTheLastSurvey?: boolean | null | undefined, tenseDuringContact?: number | null | undefined, comfortableDuringContact?: number | null | undefined, anxiousDuringContact?: number | null | undefined, testyDuringContact?: number | null | undefined, unconfidentDuringContact?: number | null | undefined, happyDuringContact?: number | null | undefined, wouldHaveLikedSocialContact?: number | null | undefined, avoidedSocialContact?: number | null | undefined, lackOfSocialContactBothersMe?: number | null | undefined, lackOfSocialContactForExternalReasons?: number | null | undefined, atThatMomentIFeltMoreComfortableAlone?: number | null | undefined, enthusiastic?: number | null | undefined, stressed?: number | null | undefined, determined?: number | null | undefined, understoodDuringContact?: number | null | undefined, inspiredDuringContact?: number | null | undefined, smsReceivedAt?: any | null | undefined, socialDistress?: number | null | undefined, id: string, scheduledAt: string, startedAt?: string | null | undefined, completedAt?: string | null | undefined } | null | undefined } | null | undefined };

export type FetchEmaEntriesQueryVariables = Exact<{
  filter?: InputMaybe<EmaEntries3Filter>;
  orderBy?: InputMaybe<Array<EmaEntries3sOrderBy> | EmaEntries3sOrderBy>;
}>;


export type FetchEmaEntriesQuery = { __typename?: 'Query', emaEntries3s?: { __typename?: 'EmaEntries3sConnection', nodes: Array<{ __typename?: 'EmaEntries3', id: string, scheduledAt: string, startedAt?: string | null | undefined, completedAt?: string | null | undefined }> } | null | undefined };

export type FetchCompletionStateBetweenQueryVariables = Exact<{
  start: Scalars['Datetime'];
  end: Scalars['Datetime'];
  trial: Scalars['UUID'];
}>;


export type FetchCompletionStateBetweenQuery = { __typename?: 'Query', emaEntries3s?: { __typename?: 'EmaEntries3sConnection', nodes: Array<{ __typename?: 'EmaEntries3', id: string, completedAt?: string | null | undefined }> } | null | undefined };

export type FetchChartStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchChartStatsQuery = { __typename?: 'Query', emaEntries3s?: { __typename?: 'EmaEntries3sConnection', nodes: Array<{ __typename?: 'EmaEntries3', id: string, strain?: number | null | undefined, tenseDuringContact?: number | null | undefined, relaxed?: number | null | undefined, enthusiastic?: number | null | undefined, happy?: number | null | undefined, satisfied?: number | null | undefined, energetic?: number | null | undefined, determined?: number | null | undefined, socialDistress?: number | null | undefined }> } | null | undefined };

export type GenerateEmaSamplingPlanMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateEmaSamplingPlanMutation = { __typename?: 'Mutation', generateSamplingPlan3?: { __typename?: 'GenerateSamplingPlan3Payload', emaEntries3S?: Array<{ __typename?: 'EmaEntries3', id: string, scheduledAt: string, startedAt?: string | null | undefined, completedAt?: string | null | undefined }> | null | undefined } | null | undefined };

export type ListFavoritesQueryVariables = Exact<{
  filter?: InputMaybe<FavoritePageFilter>;
  orderBy?: InputMaybe<Array<FavoritePagesOrderBy> | FavoritePagesOrderBy>;
}>;


export type ListFavoritesQuery = { __typename?: 'Query', favoritePages?: { __typename?: 'FavoritePagesConnection', nodes: Array<{ __typename?: 'FavoritePage', trialId: string, route: string, addedAt: string }> } | null | undefined };

export type GetFavoriteQueryVariables = Exact<{
  route: Scalars['String'];
}>;


export type GetFavoriteQuery = { __typename?: 'Query', favoritePages?: { __typename?: 'FavoritePagesConnection', totalCount: number, nodes: Array<{ __typename?: 'FavoritePage', nodeId: string, route: string, trialId: string, addedAt: string }> } | null | undefined };

export type ToggleFavoriteMutationVariables = Exact<{
  route: Scalars['String'];
}>;


export type ToggleFavoriteMutation = { __typename?: 'Mutation', toggleFavoriteOfRoute?: { __typename?: 'ToggleFavoriteOfRoutePayload', entry?: { __typename?: 'FavoritePage', trialId: string, route: string, addedAt: string, nodeId: string } | null | undefined } | null | undefined };

export const Exercise = gql`
    fragment Exercise on GenericEmiExercise {
  body
  createdAt
  id
  name
  trial {
    id
    subject {
      id
      username
    }
  }
  type
  updatedAt
}
    `;
export const ShortProfile = gql`
    fragment ShortProfile on User {
  id
  username
}
    `;
export const ShortMembership = gql`
    fragment ShortMembership on Membership {
  id
  role
  user {
    ...ShortProfile
  }
  subgroup {
    id
    name
  }
}
    ${ShortProfile}`;
export const ShortPosting = gql`
    fragment ShortPosting on Posting {
  id
  sender {
    ...ShortProfile
  }
  createdAt
  updatedAt
  body
}
    ${ShortProfile}`;
export const TrialListDetail = gql`
    fragment TrialListDetail on Trial {
  id
  name
  humanReadableId
  subjectsNickname
  subject {
    ...ShortProfile
  }
  createdAt
  createdBy {
    ...ShortProfile
  }
  staff {
    memberships {
      totalCount
      nodes {
        ...ShortMembership
      }
    }
  }
  messages {
    id
    unreadPostings(orderBy: [CREATED_AT_DESC], first: 1) {
      totalCount
      nodes {
        ...ShortPosting
      }
    }
  }
}
    ${ShortProfile}
${ShortMembership}
${ShortPosting}`;
export const TrialDetail = gql`
    fragment TrialDetail on Trial {
  ...TrialListDetail
  subject {
    ...ShortProfile
  }
  createdBy {
    ...ShortProfile
  }
  staff {
    myMembershipExists
    memberships {
      totalCount
      nodes {
        id
        role
        user {
          ...ShortProfile
        }
        subgroup {
          id
          name
        }
      }
    }
  }
  messages {
    id
    postings(orderBy: [CREATED_AT_DESC]) {
      totalCount
      nodes {
        ...ShortPosting
      }
    }
  }
  internalMessages {
    id
    postings(orderBy: [CREATED_AT_DESC]) {
      totalCount
      nodes {
        ...ShortPosting
      }
    }
  }
}
    ${TrialListDetail}
${ShortProfile}
${ShortPosting}`;
export const ShortEmaEntry = gql`
    fragment ShortEmaEntry on EmaEntries3 {
  id
  scheduledAt
  startedAt
  completedAt
}
    `;
export const FullEmaEntry = gql`
    fragment FullEmaEntry on EmaEntries3 {
  ...ShortEmaEntry
  relaxed
  lonely
  anxious
  sad
  guilty
  testy
  satisfied
  happy
  angry
  energetic
  helpless
  burdens
  strain
  strength
  triedToThinkDifferently
  triedToRepressMyThoughtsAndFeelings
  plannedHowToProceed
  lookedForAdviceAndComfortFromOthers
  triedToCalmMyselfDown
  noBurdenForExternalReasons
  couldResolveBurdensInAdvance
  expectBurdenInTheNearFuture
  expectedBurdenThatDidNotOccur
  typicalThatNoBurdenHaveOccured
  hadAnyContactWithOthersSinceTheLastSurvey
  tenseDuringContact
  comfortableDuringContact
  anxiousDuringContact
  testyDuringContact
  unconfidentDuringContact
  happyDuringContact
  wouldHaveLikedSocialContact
  avoidedSocialContact
  lackOfSocialContactBothersMe
  lackOfSocialContactForExternalReasons
  atThatMomentIFeltMoreComfortableAlone
  enthusiastic
  stressed
  determined
  understoodDuringContact
  inspiredDuringContact
  smsReceivedAt
  socialDistress
}
    ${ShortEmaEntry}`;
export const RegisterAfterKeycloakSignIn = gql`
    mutation RegisterAfterKeycloakSignIn {
  signUpWithAccessToken(input: {}) {
    result {
      user {
        id
        username
      }
      tenant {
        name
        keycloakRealmUrl
      }
    }
  }
}
    `;
export const FetchNamedExercise = gql`
    query FetchNamedExercise($name: String!, $trialId: UUID!) {
  genericEmiExercises(condition: {name: $name, trialId: $trialId}) {
    nodes {
      id
      type
      body
    }
  }
}
    `;
export const SelectPageHits = gql`
    query SelectPageHits($trialId: UUID!) {
  pageHits(condition: {trialId: $trialId}, orderBy: [TRACKED_AT_DESC]) {
    nodes {
      route
      path
      queryParameters
      duration {
        minutes
        seconds
      }
      nthVisit
      trackedAt
    }
  }
}
    `;
export const CreateGenericExercise = gql`
    mutation CreateGenericExercise($input: GenericEmiExerciseInput!) {
  createGenericEmiExercise(input: {genericEmiExercise: $input}) {
    genericEmiExercise {
      ...Exercise
    }
  }
}
    ${Exercise}`;
export const DeleteExercise = gql`
    mutation DeleteExercise($byId: UUID!) {
  deleteGenericEmiExercise(input: {id: $byId}) {
    deletedGenericEmiExerciseNodeId
    genericEmiExercise {
      ...Exercise
    }
  }
}
    ${Exercise}`;
export const DeleteExerciseOfTrialByName = gql`
    mutation DeleteExerciseOfTrialByName($trialId: UUID!, $name: String!) {
  deleteGenericEmiExerciseByTrialIdAndName(
    input: {trialId: $trialId, name: $name}
  ) {
    deletedGenericEmiExerciseNodeId
    genericEmiExercise {
      ...Exercise
    }
  }
}
    ${Exercise}`;
export const FilterGenericExercises = gql`
    query FilterGenericExercises($condition: GenericEmiExerciseCondition, $filter: GenericEmiExerciseFilter, $orderBy: [GenericEmiExercisesOrderBy!], $first: Int, $offset: Int) {
  genericEmiExercises(
    condition: $condition
    filter: $filter
    orderBy: $orderBy
    first: $first
    offset: $offset
  ) {
    nodes {
      ...Exercise
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    ${Exercise}`;
export const GetGenericExercise = gql`
    query GetGenericExercise($id: UUID!) {
  genericEmiExercise(id: $id) {
    ...Exercise
  }
}
    ${Exercise}`;
export const GetExerciseOfTrialByName = gql`
    query GetExerciseOfTrialByName($trialId: UUID!, $name: String!) {
  genericEmiExerciseByTrialIdAndName(trialId: $trialId, name: $name) {
    ...Exercise
  }
}
    ${Exercise}`;
export const UpdateGenericExercise = gql`
    mutation UpdateGenericExercise($byId: UUID!, $patch: GenericEmiExercisePatch!) {
  updateGenericEmiExercise(input: {id: $byId, patch: $patch}) {
    genericEmiExercise {
      ...Exercise
    }
  }
}
    ${Exercise}`;
export const UpsertGenericExerciseOfTrialByName = gql`
    mutation UpsertGenericExerciseOfTrialByName($trialId: UUID!, $name: String!, $input: GenericEmiExerciseInput!) {
  upsertGenericEmiExercise(
    where: {trialId: $trialId, name: $name}
    input: {genericEmiExercise: $input}
  ) {
    genericEmiExercise {
      ...Exercise
    }
  }
}
    ${Exercise}`;
export const CreateEvent = gql`
    mutation CreateEvent($type: String!, $payload: JSON) {
  createRawUsageDatum(input: {rawUsageDatum: {type: $type, payload: $payload}}) {
    clientMutationId
    rawUsageDatum {
      id
      trackedAt
    }
  }
}
    `;
export const SetAvatar = gql`
    mutation SetAvatar($avatar: AvatarIcon) {
  setAvatar(input: {avatar: $avatar}) {
    trial {
      id
    }
  }
}
    `;
export const SetNickname = gql`
    mutation SetNickname($nickname: String) {
  setNickname(input: {nickname: $nickname}) {
    trial {
      id
    }
  }
}
    `;
export const SetEmergencyPhoneNumbers = gql`
    mutation SetEmergencyPhoneNumbers($phoneNumbers: [EmergencyContactInput!]!) {
  setEmergencyPhoneNumbers(input: {phoneNumbers: $phoneNumbers}) {
    trial {
      id
    }
  }
}
    `;
export const MyTrial = gql`
    query MyTrial {
  myCurrentTrial {
    id
    humanReadableId
    canAccessErSince
    canAccessSipSince
    subjectsNickname
    lastResumableRoute
    emergencyPhoneNumbers {
      name
      phoneNumber
    }
    avatar
    staff {
      id
      memberships {
        totalCount
        nodes {
          user {
            id
            username
          }
        }
      }
    }
    messages {
      id
      unreadPostings {
        totalCount
      }
      postings(orderBy: [CREATED_AT_ASC]) {
        totalCount
        nodes {
          id
          createdAt
          body
          sender {
            id
            username
          }
        }
      }
    }
  }
}
    `;
export const CreateTrial = gql`
    mutation CreateTrial($withSubjectId: UUID!, $name: String) {
  createTrial(input: {trial: {subjectId: $withSubjectId, name: $name}}) {
    trial {
      ...TrialListDetail
    }
  }
}
    ${TrialListDetail}`;
export const ListTrials = gql`
    query ListTrials($filter: TrialFilter) {
  trials(orderBy: [CREATED_AT_DESC], filter: $filter) {
    nodes {
      ...TrialListDetail
    }
  }
}
    ${TrialListDetail}`;
export const GetTrialDetails = gql`
    query GetTrialDetails($byId: UUID!) {
  trial(id: $byId) {
    ...TrialDetail
  }
}
    ${TrialDetail}`;
export const ListAvailableUsers = gql`
    query ListAvailableUsers {
  users(orderBy: [USERNAME_ASC]) {
    nodes {
      id
      username
    }
  }
}
    `;
export const SendPosting = gql`
    mutation SendPosting($inConversation: UUID!, $body: String!) {
  createPosting(input: {posting: {body: $body, conversationId: $inConversation}}) {
    posting {
      ...ShortPosting
    }
  }
}
    ${ShortPosting}`;
export const AddReadReceipts = gql`
    mutation AddReadReceipts($postingIds: [UUID!]!) {
  markPostingsAsReceived(input: {postingIds: $postingIds}) {
    postingReceipts {
      postingId
      receivedAt
      posting {
        conversation {
          trialsByMessagesId {
            nodes {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export const GetEmaEntry = gql`
    query GetEmaEntry($id: UUID!) {
  emaEntries3(id: $id) {
    ...FullEmaEntry
  }
}
    ${FullEmaEntry}`;
export const PatchEmaEntry = gql`
    mutation PatchEmaEntry($id: UUID!, $patch: EmaEntries3Patch!) {
  updateEmaEntries3(input: {id: $id, patch: $patch}) {
    emaEntries3 {
      ...FullEmaEntry
    }
  }
}
    ${FullEmaEntry}`;
export const FetchEmaEntries = gql`
    query FetchEmaEntries($filter: EmaEntries3Filter, $orderBy: [EmaEntries3sOrderBy!]) {
  emaEntries3s(filter: $filter, orderBy: $orderBy) {
    nodes {
      ...ShortEmaEntry
    }
  }
}
    ${ShortEmaEntry}`;
export const FetchCompletionStateBetween = gql`
    query FetchCompletionStateBetween($start: Datetime!, $end: Datetime!, $trial: UUID!) {
  emaEntries3s(
    filter: {scheduledAt: {greaterThanOrEqualTo: $start, lessThanOrEqualTo: $end}}
    condition: {trialId: $trial}
    orderBy: SCHEDULED_AT_ASC
  ) {
    nodes {
      id
      completedAt
    }
  }
}
    `;
export const FetchChartStats = gql`
    query FetchChartStats {
  emaEntries3s(last: 42, orderBy: SCHEDULED_AT_ASC) {
    nodes {
      id
      strain
      tenseDuringContact
      relaxed
      enthusiastic
      happy
      satisfied
      energetic
      determined
      socialDistress
    }
  }
}
    `;
export const GenerateEmaSamplingPlan = gql`
    mutation GenerateEmaSamplingPlan {
  generateSamplingPlan3(input: {}) {
    emaEntries3S {
      ...ShortEmaEntry
    }
  }
}
    ${ShortEmaEntry}`;
export const ListFavorites = gql`
    query ListFavorites($filter: FavoritePageFilter, $orderBy: [FavoritePagesOrderBy!] = [ADDED_AT_DESC]) {
  favoritePages(orderBy: $orderBy, filter: $filter) {
    nodes {
      trialId
      route
      addedAt
    }
  }
}
    `;
export const GetFavorite = gql`
    query GetFavorite($route: String!) {
  favoritePages(condition: {route: $route}) {
    totalCount
    nodes {
      nodeId
      route
      trialId
      addedAt
    }
  }
}
    `;
export const ToggleFavorite = gql`
    mutation ToggleFavorite($route: String!) {
  toggleFavoriteOfRoute(input: {route: $route}) {
    entry {
      trialId
      route
      addedAt
      nodeId
    }
  }
}
    `;
export const ExerciseFragmentDoc = gql`
    fragment Exercise on GenericEmiExercise {
  body
  createdAt
  id
  name
  trial {
    id
    subject {
      id
      username
    }
  }
  type
  updatedAt
}
    `;
export const ShortProfileFragmentDoc = gql`
    fragment ShortProfile on User {
  id
  username
}
    `;
export const ShortMembershipFragmentDoc = gql`
    fragment ShortMembership on Membership {
  id
  role
  user {
    ...ShortProfile
  }
  subgroup {
    id
    name
  }
}
    ${ShortProfileFragmentDoc}`;
export const ShortPostingFragmentDoc = gql`
    fragment ShortPosting on Posting {
  id
  sender {
    ...ShortProfile
  }
  createdAt
  updatedAt
  body
}
    ${ShortProfileFragmentDoc}`;
export const TrialListDetailFragmentDoc = gql`
    fragment TrialListDetail on Trial {
  id
  name
  humanReadableId
  subjectsNickname
  subject {
    ...ShortProfile
  }
  createdAt
  createdBy {
    ...ShortProfile
  }
  staff {
    memberships {
      totalCount
      nodes {
        ...ShortMembership
      }
    }
  }
  messages {
    id
    unreadPostings(orderBy: [CREATED_AT_DESC], first: 1) {
      totalCount
      nodes {
        ...ShortPosting
      }
    }
  }
}
    ${ShortProfileFragmentDoc}
${ShortMembershipFragmentDoc}
${ShortPostingFragmentDoc}`;
export const TrialDetailFragmentDoc = gql`
    fragment TrialDetail on Trial {
  ...TrialListDetail
  subject {
    ...ShortProfile
  }
  createdBy {
    ...ShortProfile
  }
  staff {
    myMembershipExists
    memberships {
      totalCount
      nodes {
        id
        role
        user {
          ...ShortProfile
        }
        subgroup {
          id
          name
        }
      }
    }
  }
  messages {
    id
    postings(orderBy: [CREATED_AT_DESC]) {
      totalCount
      nodes {
        ...ShortPosting
      }
    }
  }
  internalMessages {
    id
    postings(orderBy: [CREATED_AT_DESC]) {
      totalCount
      nodes {
        ...ShortPosting
      }
    }
  }
}
    ${TrialListDetailFragmentDoc}
${ShortProfileFragmentDoc}
${ShortPostingFragmentDoc}`;
export const ShortEmaEntryFragmentDoc = gql`
    fragment ShortEmaEntry on EmaEntries3 {
  id
  scheduledAt
  startedAt
  completedAt
}
    `;
export const FullEmaEntryFragmentDoc = gql`
    fragment FullEmaEntry on EmaEntries3 {
  ...ShortEmaEntry
  relaxed
  lonely
  anxious
  sad
  guilty
  testy
  satisfied
  happy
  angry
  energetic
  helpless
  burdens
  strain
  strength
  triedToThinkDifferently
  triedToRepressMyThoughtsAndFeelings
  plannedHowToProceed
  lookedForAdviceAndComfortFromOthers
  triedToCalmMyselfDown
  noBurdenForExternalReasons
  couldResolveBurdensInAdvance
  expectBurdenInTheNearFuture
  expectedBurdenThatDidNotOccur
  typicalThatNoBurdenHaveOccured
  hadAnyContactWithOthersSinceTheLastSurvey
  tenseDuringContact
  comfortableDuringContact
  anxiousDuringContact
  testyDuringContact
  unconfidentDuringContact
  happyDuringContact
  wouldHaveLikedSocialContact
  avoidedSocialContact
  lackOfSocialContactBothersMe
  lackOfSocialContactForExternalReasons
  atThatMomentIFeltMoreComfortableAlone
  enthusiastic
  stressed
  determined
  understoodDuringContact
  inspiredDuringContact
  smsReceivedAt
  socialDistress
}
    ${ShortEmaEntryFragmentDoc}`;
export const RegisterAfterKeycloakSignInDocument = gql`
    mutation RegisterAfterKeycloakSignIn {
  signUpWithAccessToken(input: {}) {
    result {
      user {
        id
        username
      }
      tenant {
        name
        keycloakRealmUrl
      }
    }
  }
}
    `;

export function useRegisterAfterKeycloakSignInMutation() {
  return Urql.useMutation<RegisterAfterKeycloakSignInMutation, RegisterAfterKeycloakSignInMutationVariables>(RegisterAfterKeycloakSignInDocument);
};
export const FetchNamedExerciseDocument = gql`
    query FetchNamedExercise($name: String!, $trialId: UUID!) {
  genericEmiExercises(condition: {name: $name, trialId: $trialId}) {
    nodes {
      id
      type
      body
    }
  }
}
    `;

export function useFetchNamedExerciseQuery(options: Omit<Urql.UseQueryArgs<never, FetchNamedExerciseQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<FetchNamedExerciseQuery>({ query: FetchNamedExerciseDocument, ...options });
};
export const SelectPageHitsDocument = gql`
    query SelectPageHits($trialId: UUID!) {
  pageHits(condition: {trialId: $trialId}, orderBy: [TRACKED_AT_DESC]) {
    nodes {
      route
      path
      queryParameters
      duration {
        minutes
        seconds
      }
      nthVisit
      trackedAt
    }
  }
}
    `;

export function useSelectPageHitsQuery(options: Omit<Urql.UseQueryArgs<never, SelectPageHitsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<SelectPageHitsQuery>({ query: SelectPageHitsDocument, ...options });
};
export const CreateGenericExerciseDocument = gql`
    mutation CreateGenericExercise($input: GenericEmiExerciseInput!) {
  createGenericEmiExercise(input: {genericEmiExercise: $input}) {
    genericEmiExercise {
      ...Exercise
    }
  }
}
    ${ExerciseFragmentDoc}`;

export function useCreateGenericExerciseMutation() {
  return Urql.useMutation<CreateGenericExerciseMutation, CreateGenericExerciseMutationVariables>(CreateGenericExerciseDocument);
};
export const DeleteExerciseDocument = gql`
    mutation DeleteExercise($byId: UUID!) {
  deleteGenericEmiExercise(input: {id: $byId}) {
    deletedGenericEmiExerciseNodeId
    genericEmiExercise {
      ...Exercise
    }
  }
}
    ${ExerciseFragmentDoc}`;

export function useDeleteExerciseMutation() {
  return Urql.useMutation<DeleteExerciseMutation, DeleteExerciseMutationVariables>(DeleteExerciseDocument);
};
export const DeleteExerciseOfTrialByNameDocument = gql`
    mutation DeleteExerciseOfTrialByName($trialId: UUID!, $name: String!) {
  deleteGenericEmiExerciseByTrialIdAndName(
    input: {trialId: $trialId, name: $name}
  ) {
    deletedGenericEmiExerciseNodeId
    genericEmiExercise {
      ...Exercise
    }
  }
}
    ${ExerciseFragmentDoc}`;

export function useDeleteExerciseOfTrialByNameMutation() {
  return Urql.useMutation<DeleteExerciseOfTrialByNameMutation, DeleteExerciseOfTrialByNameMutationVariables>(DeleteExerciseOfTrialByNameDocument);
};
export const FilterGenericExercisesDocument = gql`
    query FilterGenericExercises($condition: GenericEmiExerciseCondition, $filter: GenericEmiExerciseFilter, $orderBy: [GenericEmiExercisesOrderBy!], $first: Int, $offset: Int) {
  genericEmiExercises(
    condition: $condition
    filter: $filter
    orderBy: $orderBy
    first: $first
    offset: $offset
  ) {
    nodes {
      ...Exercise
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
    }
    totalCount
  }
}
    ${ExerciseFragmentDoc}`;

export function useFilterGenericExercisesQuery(options: Omit<Urql.UseQueryArgs<never, FilterGenericExercisesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<FilterGenericExercisesQuery>({ query: FilterGenericExercisesDocument, ...options });
};
export const GetGenericExerciseDocument = gql`
    query GetGenericExercise($id: UUID!) {
  genericEmiExercise(id: $id) {
    ...Exercise
  }
}
    ${ExerciseFragmentDoc}`;

export function useGetGenericExerciseQuery(options: Omit<Urql.UseQueryArgs<never, GetGenericExerciseQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetGenericExerciseQuery>({ query: GetGenericExerciseDocument, ...options });
};
export const GetExerciseOfTrialByNameDocument = gql`
    query GetExerciseOfTrialByName($trialId: UUID!, $name: String!) {
  genericEmiExerciseByTrialIdAndName(trialId: $trialId, name: $name) {
    ...Exercise
  }
}
    ${ExerciseFragmentDoc}`;

export function useGetExerciseOfTrialByNameQuery(options: Omit<Urql.UseQueryArgs<never, GetExerciseOfTrialByNameQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetExerciseOfTrialByNameQuery>({ query: GetExerciseOfTrialByNameDocument, ...options });
};
export const UpdateGenericExerciseDocument = gql`
    mutation UpdateGenericExercise($byId: UUID!, $patch: GenericEmiExercisePatch!) {
  updateGenericEmiExercise(input: {id: $byId, patch: $patch}) {
    genericEmiExercise {
      ...Exercise
    }
  }
}
    ${ExerciseFragmentDoc}`;

export function useUpdateGenericExerciseMutation() {
  return Urql.useMutation<UpdateGenericExerciseMutation, UpdateGenericExerciseMutationVariables>(UpdateGenericExerciseDocument);
};
export const UpsertGenericExerciseOfTrialByNameDocument = gql`
    mutation UpsertGenericExerciseOfTrialByName($trialId: UUID!, $name: String!, $input: GenericEmiExerciseInput!) {
  upsertGenericEmiExercise(
    where: {trialId: $trialId, name: $name}
    input: {genericEmiExercise: $input}
  ) {
    genericEmiExercise {
      ...Exercise
    }
  }
}
    ${ExerciseFragmentDoc}`;

export function useUpsertGenericExerciseOfTrialByNameMutation() {
  return Urql.useMutation<UpsertGenericExerciseOfTrialByNameMutation, UpsertGenericExerciseOfTrialByNameMutationVariables>(UpsertGenericExerciseOfTrialByNameDocument);
};
export const CreateEventDocument = gql`
    mutation CreateEvent($type: String!, $payload: JSON) {
  createRawUsageDatum(input: {rawUsageDatum: {type: $type, payload: $payload}}) {
    clientMutationId
    rawUsageDatum {
      id
      trackedAt
    }
  }
}
    `;

export function useCreateEventMutation() {
  return Urql.useMutation<CreateEventMutation, CreateEventMutationVariables>(CreateEventDocument);
};
export const SetAvatarDocument = gql`
    mutation SetAvatar($avatar: AvatarIcon) {
  setAvatar(input: {avatar: $avatar}) {
    trial {
      id
    }
  }
}
    `;

export function useSetAvatarMutation() {
  return Urql.useMutation<SetAvatarMutation, SetAvatarMutationVariables>(SetAvatarDocument);
};
export const SetNicknameDocument = gql`
    mutation SetNickname($nickname: String) {
  setNickname(input: {nickname: $nickname}) {
    trial {
      id
    }
  }
}
    `;

export function useSetNicknameMutation() {
  return Urql.useMutation<SetNicknameMutation, SetNicknameMutationVariables>(SetNicknameDocument);
};
export const SetEmergencyPhoneNumbersDocument = gql`
    mutation SetEmergencyPhoneNumbers($phoneNumbers: [EmergencyContactInput!]!) {
  setEmergencyPhoneNumbers(input: {phoneNumbers: $phoneNumbers}) {
    trial {
      id
    }
  }
}
    `;

export function useSetEmergencyPhoneNumbersMutation() {
  return Urql.useMutation<SetEmergencyPhoneNumbersMutation, SetEmergencyPhoneNumbersMutationVariables>(SetEmergencyPhoneNumbersDocument);
};
export const MyTrialDocument = gql`
    query MyTrial {
  myCurrentTrial {
    id
    humanReadableId
    canAccessErSince
    canAccessSipSince
    subjectsNickname
    lastResumableRoute
    emergencyPhoneNumbers {
      name
      phoneNumber
    }
    avatar
    staff {
      id
      memberships {
        totalCount
        nodes {
          user {
            id
            username
          }
        }
      }
    }
    messages {
      id
      unreadPostings {
        totalCount
      }
      postings(orderBy: [CREATED_AT_ASC]) {
        totalCount
        nodes {
          id
          createdAt
          body
          sender {
            id
            username
          }
        }
      }
    }
  }
}
    `;

export function useMyTrialQuery(options: Omit<Urql.UseQueryArgs<never, MyTrialQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<MyTrialQuery>({ query: MyTrialDocument, ...options });
};
export const CreateTrialDocument = gql`
    mutation CreateTrial($withSubjectId: UUID!, $name: String) {
  createTrial(input: {trial: {subjectId: $withSubjectId, name: $name}}) {
    trial {
      ...TrialListDetail
    }
  }
}
    ${TrialListDetailFragmentDoc}`;

export function useCreateTrialMutation() {
  return Urql.useMutation<CreateTrialMutation, CreateTrialMutationVariables>(CreateTrialDocument);
};
export const ListTrialsDocument = gql`
    query ListTrials($filter: TrialFilter) {
  trials(orderBy: [CREATED_AT_DESC], filter: $filter) {
    nodes {
      ...TrialListDetail
    }
  }
}
    ${TrialListDetailFragmentDoc}`;

export function useListTrialsQuery(options: Omit<Urql.UseQueryArgs<never, ListTrialsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ListTrialsQuery>({ query: ListTrialsDocument, ...options });
};
export const GetTrialDetailsDocument = gql`
    query GetTrialDetails($byId: UUID!) {
  trial(id: $byId) {
    ...TrialDetail
  }
}
    ${TrialDetailFragmentDoc}`;

export function useGetTrialDetailsQuery(options: Omit<Urql.UseQueryArgs<never, GetTrialDetailsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetTrialDetailsQuery>({ query: GetTrialDetailsDocument, ...options });
};
export const ListAvailableUsersDocument = gql`
    query ListAvailableUsers {
  users(orderBy: [USERNAME_ASC]) {
    nodes {
      id
      username
    }
  }
}
    `;

export function useListAvailableUsersQuery(options: Omit<Urql.UseQueryArgs<never, ListAvailableUsersQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ListAvailableUsersQuery>({ query: ListAvailableUsersDocument, ...options });
};
export const SendPostingDocument = gql`
    mutation SendPosting($inConversation: UUID!, $body: String!) {
  createPosting(input: {posting: {body: $body, conversationId: $inConversation}}) {
    posting {
      ...ShortPosting
    }
  }
}
    ${ShortPostingFragmentDoc}`;

export function useSendPostingMutation() {
  return Urql.useMutation<SendPostingMutation, SendPostingMutationVariables>(SendPostingDocument);
};
export const AddReadReceiptsDocument = gql`
    mutation AddReadReceipts($postingIds: [UUID!]!) {
  markPostingsAsReceived(input: {postingIds: $postingIds}) {
    postingReceipts {
      postingId
      receivedAt
      posting {
        conversation {
          trialsByMessagesId {
            nodes {
              id
            }
          }
        }
      }
    }
  }
}
    `;

export function useAddReadReceiptsMutation() {
  return Urql.useMutation<AddReadReceiptsMutation, AddReadReceiptsMutationVariables>(AddReadReceiptsDocument);
};
export const GetEmaEntryDocument = gql`
    query GetEmaEntry($id: UUID!) {
  emaEntries3(id: $id) {
    ...FullEmaEntry
  }
}
    ${FullEmaEntryFragmentDoc}`;

export function useGetEmaEntryQuery(options: Omit<Urql.UseQueryArgs<never, GetEmaEntryQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetEmaEntryQuery>({ query: GetEmaEntryDocument, ...options });
};
export const PatchEmaEntryDocument = gql`
    mutation PatchEmaEntry($id: UUID!, $patch: EmaEntries3Patch!) {
  updateEmaEntries3(input: {id: $id, patch: $patch}) {
    emaEntries3 {
      ...FullEmaEntry
    }
  }
}
    ${FullEmaEntryFragmentDoc}`;

export function usePatchEmaEntryMutation() {
  return Urql.useMutation<PatchEmaEntryMutation, PatchEmaEntryMutationVariables>(PatchEmaEntryDocument);
};
export const FetchEmaEntriesDocument = gql`
    query FetchEmaEntries($filter: EmaEntries3Filter, $orderBy: [EmaEntries3sOrderBy!]) {
  emaEntries3s(filter: $filter, orderBy: $orderBy) {
    nodes {
      ...ShortEmaEntry
    }
  }
}
    ${ShortEmaEntryFragmentDoc}`;

export function useFetchEmaEntriesQuery(options: Omit<Urql.UseQueryArgs<never, FetchEmaEntriesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<FetchEmaEntriesQuery>({ query: FetchEmaEntriesDocument, ...options });
};
export const FetchCompletionStateBetweenDocument = gql`
    query FetchCompletionStateBetween($start: Datetime!, $end: Datetime!, $trial: UUID!) {
  emaEntries3s(
    filter: {scheduledAt: {greaterThanOrEqualTo: $start, lessThanOrEqualTo: $end}}
    condition: {trialId: $trial}
    orderBy: SCHEDULED_AT_ASC
  ) {
    nodes {
      id
      completedAt
    }
  }
}
    `;

export function useFetchCompletionStateBetweenQuery(options: Omit<Urql.UseQueryArgs<never, FetchCompletionStateBetweenQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<FetchCompletionStateBetweenQuery>({ query: FetchCompletionStateBetweenDocument, ...options });
};
export const FetchChartStatsDocument = gql`
    query FetchChartStats {
  emaEntries3s(last: 42, orderBy: SCHEDULED_AT_ASC) {
    nodes {
      id
      strain
      tenseDuringContact
      relaxed
      enthusiastic
      happy
      satisfied
      energetic
      determined
      socialDistress
    }
  }
}
    `;

export function useFetchChartStatsQuery(options: Omit<Urql.UseQueryArgs<never, FetchChartStatsQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<FetchChartStatsQuery>({ query: FetchChartStatsDocument, ...options });
};
export const GenerateEmaSamplingPlanDocument = gql`
    mutation GenerateEmaSamplingPlan {
  generateSamplingPlan3(input: {}) {
    emaEntries3S {
      ...ShortEmaEntry
    }
  }
}
    ${ShortEmaEntryFragmentDoc}`;

export function useGenerateEmaSamplingPlanMutation() {
  return Urql.useMutation<GenerateEmaSamplingPlanMutation, GenerateEmaSamplingPlanMutationVariables>(GenerateEmaSamplingPlanDocument);
};
export const ListFavoritesDocument = gql`
    query ListFavorites($filter: FavoritePageFilter, $orderBy: [FavoritePagesOrderBy!] = [ADDED_AT_DESC]) {
  favoritePages(orderBy: $orderBy, filter: $filter) {
    nodes {
      trialId
      route
      addedAt
    }
  }
}
    `;

export function useListFavoritesQuery(options: Omit<Urql.UseQueryArgs<never, ListFavoritesQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<ListFavoritesQuery>({ query: ListFavoritesDocument, ...options });
};
export const GetFavoriteDocument = gql`
    query GetFavorite($route: String!) {
  favoritePages(condition: {route: $route}) {
    totalCount
    nodes {
      nodeId
      route
      trialId
      addedAt
    }
  }
}
    `;

export function useGetFavoriteQuery(options: Omit<Urql.UseQueryArgs<never, GetFavoriteQueryVariables>, 'query'> = {}) {
  return Urql.useQuery<GetFavoriteQuery>({ query: GetFavoriteDocument, ...options });
};
export const ToggleFavoriteDocument = gql`
    mutation ToggleFavorite($route: String!) {
  toggleFavoriteOfRoute(input: {route: $route}) {
    entry {
      trialId
      route
      addedAt
      nodeId
    }
  }
}
    `;

export function useToggleFavoriteMutation() {
  return Urql.useMutation<ToggleFavoriteMutation, ToggleFavoriteMutationVariables>(ToggleFavoriteDocument);
};